/* esm.sh - @bitauth/libauth@3.0.0 */
var R=(e,A,a=!1)=>{let r=`${e}${A===void 0?"":` ${A}`}`;if(a)throw new Error(r);return r},Mr=(e,A="Received an unknown value; this should have been caught by TypeScript - are your types correct?")=>R(A,String(e),!0),Ra=(e,A="Expected a successful result, but encountered an error: ")=>{if(typeof e=="string")throw new Error(`${A}${e}`);return e};var Fa;(function(e){e.tooLong="Base converter creation error: an alphabet may be no longer than 254 characters.",e.ambiguousCharacter="Base converter creation error: a character code may only appear once in a single alphabet."})(Fa||(Fa={}));var Gr;(function(e){e.unknownCharacter="Base conversion error: encountered an unknown character for this alphabet."})(Gr||(Gr={}));var PI=e=>{if(e.length>=255)return R(Fa.tooLong,`Alphabet length: ${e.length}`);let r=new Uint8Array(256).fill(255);for(let s=0;s<e.length;s++){let g=e.charCodeAt(s);if(r[g]!==255)return R(Fa.ambiguousCharacter,`Ambiguous character: ${r[g]}`);r[g]=s}let n=e.length,i=e.charAt(0),t=Math.log(n)/Math.log(256),o=Math.log(256)/Math.log(n);return{decode:s=>{if(s.length===0)return Uint8Array.of();let g=s.split("").findIndex(N=>N!==i);if(g===-1)return new Uint8Array(s.length);let l=Math.floor((s.length-g)*t+1),I=new Uint8Array(l),E=g,u=0;for(;s[E]!==void 0;){let N=r[s.charCodeAt(E)];if(N===255)return R(Gr.unknownCharacter,`Unknown character: "${s[E]}".`);let c=0;for(let B=l-1;(N!==0||c<u)&&B!==-1;B--,c++)N+=Math.floor(n*I[B]),I[B]=Math.floor(N%256),N=Math.floor(N/256);u=c,E++}let k=I.findIndex(N=>N!==0),U=new Uint8Array(g+(l-k));return U.set(I.slice(k),g),U},encode:s=>{if(s.length===0)return"";let g=s.findIndex(N=>N!==0);if(g===-1)return i.repeat(s.length);let l=Math.floor((s.length-g)*o+1),I=new Uint8Array(l),E=g,u=0;for(;E!==s.length;){let N=s[E],c=0;for(let B=l-1;(N!==0||c<u)&&B!==-1;B--,c++)N+=Math.floor(256*I[B]),I[B]=Math.floor(N%n),N=Math.floor(N/n);u=c,E++}let k=I.findIndex(N=>N!==0),U=i.repeat(g);return I.slice(k).reduce((N,c)=>N+e.charAt(c),U)}}},SI="123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz",ho=PI(SI),Ka=ho.decode,Ma=ho.encode;var At="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";var bI=new RegExp(`[^${At}=]`,"u"),yh=e=>e.length%4===0&&!bI.test(e),dA=e=>{let A=new Uint8Array(123);for(let s=0;s<At.length;s++)A[At.charCodeAt(s)]=s;let a=e.length*.75,r=e.length,n=e[e.length-1]==="="?e[e.length-2]==="="?a-2:a-1:a,i=new ArrayBuffer(n),t=new Uint8Array(i),o=0;for(let s=0;s<r;s+=4){let g=A[e.charCodeAt(s)],l=A[e.charCodeAt(s+1)],I=A[e.charCodeAt(s+2)],E=A[e.charCodeAt(s+3)];t[o++]=g<<2|l>>4,t[o++]=(l&15)<<4|I>>2,t[o++]=(I&3)<<6|E&63}return t},fh=e=>{let A="";for(let r=0;r<e.length;r+=3)A+=At[e[r]>>2],A+=At[(e[r]&3)<<4|e[r+1]>>4],A+=At[(e[r+1]&15)<<2|e[r+2]>>6],A+=At[e[r+2]&63];return e.length%3===2?`${A.substring(0,A.length-1)}=`:e.length%3===1?`${A.substring(0,A.length-2)}==`:A};var qr=(e,A=0)=>Array.from({length:e},(a,r)=>A+r),ca=(e,A)=>qr(Math.ceil(e.length/A)).map(a=>a*A).map(a=>e.slice(a,a+A));var ze=e=>Uint8Array.from(ca(e,2).map(A=>parseInt(A,16))),Ph=e=>e.length%2===0&&!/[^a-fA-F0-9]/u.test(e),$=e=>e.reduce((A,a)=>A+a.toString(16).padStart(2,"0"),""),Sh=e=>$(ze(e).reverse()),ee=e=>{let A=e.reduce((r,n)=>r+n.length,0),a=new Uint8Array(A);return e.reduce((r,n)=>(a.set(n,r),r+n.length),0),a},tt=(e,A)=>{if(e.length!==A.length)return!1;for(let a=0;a<e.length;a++)if(e[a]!==A[a])return!1;return!0};var Hr=8,Eo=2,Ga=e=>Uint8Array.from(ca(e,Hr).map(A=>parseInt(A,Eo))),Jr=e=>e.reduce((A,a)=>A+a.toString(Eo).padStart(Hr,"0"),""),Nh=e=>e.length%Hr===0&&!/[^01]/u.test(e);var kI=2,Bo=(e,A=kI)=>JSON.stringify(e,(a,r)=>{let i=typeof r=="object"&&r!==null?r.constructor.name:typeof r;switch(i){case"Uint8Array":return`<Uint8Array: 0x${$(r)}>`;case"bigint":return`<bigint: ${r.toString()}n>`;case"function":case"symbol":return`<${i}: ${r.toString()}>`;default:return r}},A),Lr=e=>Array.isArray(e)?e.map(Lr):typeof e!="object"||e===null||e.constructor.name!=="Object"?e:Object.keys(e).sort((a,r)=>a.localeCompare(r,"en")).reduce((a,r)=>({...a,[r]:Lr(e[r])}),{}),NI=/"<Uint8Array: 0x(?<hex>[0-9a-f]*)>"/gu,UI=/"<bigint: (?<bigint>[0-9]*)n>"/gu,vh=(e,A=!0)=>Bo(A?Lr(e):e).replace(NI,"hexToBin('$1')").replace(UI,"$1n");var po=e=>{let a=[],r=e;for(;r>=256;)a.push(r%256),r=Math.floor(r/256);return r>0&&a.push(r),Uint8Array.from(a)},qa=(e,A)=>{let a=new Uint8Array(A);return e.length>A?a.fill(255):a.set(e),a},Th=e=>qa(po(e),2),Yh=e=>qa(po(e),4),mt=e=>{let a=new Uint8Array(2);return new DataView(a.buffer,a.byteOffset,a.byteLength).setUint16(0,e,!0),a},xh=e=>{let a=new Uint8Array(2);return new DataView(a.buffer,a.byteOffset,a.byteLength).setInt16(0,e,!0),a},Oh=e=>{let a=new Uint8Array(4);return new DataView(a.buffer,a.byteOffset,a.byteLength).setInt32(0,e,!0),a},Rh=e=>new DataView(e.buffer,e.byteOffset,e.byteLength).getInt16(0,!0),Fh=e=>new DataView(e.buffer,e.byteOffset,e.byteLength).getInt32(0,!0),Kh=e=>{let a=new Uint8Array(2);return new DataView(a.buffer,a.byteOffset,a.byteLength).setUint16(0,e,!1),a},de=e=>{let a=new Uint8Array(4);return new DataView(a.buffer,a.byteOffset,a.byteLength).setUint32(0,e,!0),a},vA=e=>{let a=new Uint8Array(4);return new DataView(a.buffer,a.byteOffset,a.byteLength).setUint32(0,e,!1),a},Vr=e=>{let a=BigInt(256),r=[],n=e;for(;n>=a;)r.push(Number(n%a)),n/=a;return n>0n&&r.push(Number(n)),Uint8Array.from(r.length>0?r:[0])},_I=e=>qa(Vr(e),8),mo=e=>{let a=BigInt.asUintN(64,e);return _I(a)},Mh=e=>{let r=new Uint8Array(4);for(let n=0;n<4;n++)r[n]=e,e>>>=8;return r},Gh=(e,A=e.length)=>{if(e.length!==A)throw new TypeError(`Bin length must be ${A}.`);return new Uint8Array(e.buffer,e.byteOffset,e.length).reduce((n,i,t)=>n+i*2**(8*t),0)},qh=e=>new DataView(e.buffer,e.byteOffset,e.byteLength).getUint16(0,!0),Ha=e=>new DataView(e.buffer,e.byteOffset,e.byteLength).getUint32(0,!0),vI=(e,A=e.length)=>{let r=BigInt(8);if(e.length!==A)throw new TypeError(`Bin length must be ${A}.`);return new Uint8Array(e.buffer,e.byteOffset,e.length).reduce((n,i)=>n<<r|BigInt(i),0n)},Hh=e=>Vr(e).reverse(),zr=e=>vI(e,32),Ja=e=>qa(Vr(e),32).reverse(),Qo=(e,A=e.length)=>{if(e.length!==A)throw new TypeError(`Bin length must be ${A}.`);return new Uint8Array(e.buffer,e.byteOffset,e.length).reduceRight((r,n)=>r<<BigInt(8)|BigInt(n),0n)},jr=e=>{let a=e.length>8?e.slice(0,8):e;return Qo(a,8)},yo=jr,Qt=mo,DI=e=>{switch(e){case 253:return 3;case 254:return 5;case 255:return 9;default:return 1}},pt;(function(e){e.noPrefix="Error reading CompactUint: requires at least one byte.",e.insufficientBytes="Error reading CompactUint: insufficient bytes.",e.nonMinimal="Error reading CompactUint: CompactUint is not minimally encoded.",e.excessiveBytes="Error decoding CompactUint: unexpected bytes after CompactUint."})(pt||(pt={}));var wI=e=>{let{bin:A,index:a}=e,r=A[a];if(r===void 0)return R(pt.noPrefix);let n=DI(r);if(A.length-a<n)return R(pt.insufficientBytes,`CompactUint prefix ${r} requires at least ${n} bytes. Remaining bytes: ${A.length-a}`);let t=n!==1?A.subarray(a+1,a+n):A.subarray(a,a+n);return{position:{bin:A,index:a+n},result:Qo(t)}},IA=e=>e<=BigInt(252)?Uint8Array.of(Number(e)):e<=BigInt(65535)?Uint8Array.from([253,...mt(Number(e))]):e<=BigInt(4294967295)?Uint8Array.from([254,...de(Number(e))]):Uint8Array.from([255,...mo(e)]),it=e=>{let A=wI(e);if(typeof A=="string")return A;let a=A.position.index-e.index,r=IA(A.result);return a!==r.length?R(pt.nonMinimal,`Value: ${A.result.toString()}, encoded length: ${a}, canonical length: ${r.length}`):A},Jh=e=>{let A=it({bin:e,index:0});return typeof A=="string"?A:A.position.index!==e.length?R(pt.excessiveBytes,`CompactUint ends at index ${A.position.index}, but input includes ${e.length} bytes.`):A.result},Lh=e=>Uint32Array.from(Int32Array.of(e))[0],fo=e=>Int32Array.from(Uint32Array.of(e))[0];var at=(e,A)=>{let a=e,r=[];for(let n of A){let i=n(a);if(typeof i=="string")return i;r.push(i.result),a=i.position}return{position:a,result:r}},La;(function(e){e.itemCount="Error reading item count.",e.item="Error reading item."})(La||(La={}));var Va=(e,A)=>{let a=it(e);if(typeof a=="string")return R(La.itemCount,a);let r=a.position,n=[];for(let i=Number(a.result);i>0;i--){let t=A(r);if(typeof t=="string")return R(La.item,t);n.push(t.result),r=t.position}return{position:r,result:n}};var ua=1e3,Wr=5e8,Co=4294967295,TI=new Date(Wr*ua),YI=new Date(Co*ua),la;(function(e){e.dateOutOfRange="The provided Date is outside of the range that can be encoded in locktime.",e.locktimeOutOfRange="The provided locktime is outside of the range that can be encoded as a Date (greater than or equal to 500000000 and less than or equal to 4294967295).",e.incorrectLength="The provided locktime is not the correct length (4 bytes)."})(la||(la={}));var xI=e=>e<TI||e>YI?la.dateOutOfRange:Math.round(e.getTime()/ua),Xh=e=>e<Wr||e>Co?la.locktimeOutOfRange:new Date(e*ua),$h=e=>{let A=xI(e);return typeof A=="string"?A:de(A)},OI=4,ed=e=>{if(e.length!==OI)return la.incorrectLength;let A=Ha(e);return A>=Wr?new Date(A*ua):A};var RI=new TextEncoder,DA=e=>RI.encode(e),FI=new TextDecoder,td=e=>FI.decode(e),za=e=>e.normalize("NFKC"),KI=e=>[...new Intl.Segmenter("en",{granularity:"grapheme"}).segment(e)].map(A=>A.segment),id=e=>KI(e).length;var VA=async(e,A,a,r,n,i)=>{let t=(await WebAssembly.instantiate(e,{[A]:{__wbindgen_throw:(S,P)=>{throw new Error(Array.from(I().subarray(S,S+P)).map(h=>String.fromCharCode(h)).join(""))}}})).instance.exports,o,s,g,l=()=>(g===void 0&&(g=t.__wbindgen_global_argument_ptr()),g);function I(){return(o===void 0||o.buffer!==t.memory.buffer)&&(o=new Uint8Array(t.memory.buffer)),o}let E=()=>((s===void 0||s.buffer!==t.memory.buffer)&&(s=new Uint32Array(t.memory.buffer)),s),u=S=>{let P=t.__wbindgen_malloc(S.length);return I().set(S,P),[P,S.length]},k=(S,P)=>I().subarray(S,S+P);return{final:S=>{let[P,h]=u(S),y=l();try{t[i](y,P,h);let p=E(),C=p[y/4],b=p[y/4+1],Y=k(C,b).slice();return t.__wbindgen_free(C,b),Y}finally{S.set(I().subarray(P/1,P/1+h)),t.__wbindgen_free(P,h)}},hash:S=>{let[P,h]=u(S),y=l();try{t[a](y,P,h);let p=E(),C=p[y/4],b=p[y/4+1],Y=k(C,b).slice();return t.__wbindgen_free(C,b),Y}finally{t.__wbindgen_free(P,h)}},init:()=>{let S=l();t[r](S);let P=E(),h=P[S/4],y=P[S/4+1],p=k(h,y).slice();return t.__wbindgen_free(h,y),p},update:(S,P)=>{let[h,y]=u(S),[p,C]=u(P),b=l();try{t[n](b,h,y,p,C);let Y=E(),_=Y[b/4],x=Y[b/4+1],H=k(_,x).slice();return t.__wbindgen_free(_,x),H}finally{S.set(I().subarray(h/1,h/1+y)),t.__wbindgen_free(h,y),t.__wbindgen_free(p,C)}}}};var Po="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";var ha;(function(e){e[e.NONE=1]="NONE",e[e.VERIFY=257]="VERIFY",e[e.SIGN=513]="SIGN",e[e.BOTH=769]="BOTH"})(ha||(ha={}));var yt;(function(e){e[e.COMPRESSED=258]="COMPRESSED",e[e.UNCOMPRESSED=2]="UNCOMPRESSED"})(yt||(yt={}));var So="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";var MI=(e,A,a)=>({contextCreate:r=>e.exports._secp256k1_context_create(r),contextRandomize:(r,n)=>e.exports._secp256k1_context_randomize(r,n),free:r=>e.exports._free(r),heapU32:a,heapU8:A,instance:e,malloc:r=>e.exports._malloc(r),mallocSizeT:r=>{let n=e.exports._malloc(4),i=n>>2;return a.set([r],i),n},mallocUint8Array:r=>{let n=e.exports._malloc(r.length);return A.set(r,n),n},privkeyTweakAdd:(r,n,i)=>e.exports._secp256k1_ec_privkey_tweak_add(r,n,i),privkeyTweakMul:(r,n,i)=>e.exports._secp256k1_ec_privkey_tweak_mul(r,n,i),pubkeyCreate:(r,n,i)=>e.exports._secp256k1_ec_pubkey_create(r,n,i),pubkeyParse:(r,n,i,t)=>e.exports._secp256k1_ec_pubkey_parse(r,n,i,t),pubkeySerialize:(r,n,i,t,o)=>e.exports._secp256k1_ec_pubkey_serialize(r,n,i,t,o),pubkeyTweakAdd:(r,n,i)=>e.exports._secp256k1_ec_pubkey_tweak_add(r,n,i),pubkeyTweakMul:(r,n,i)=>e.exports._secp256k1_ec_pubkey_tweak_mul(r,n,i),readHeapU8:(r,n)=>new Uint8Array(A.buffer,r,n),readSizeT:r=>{let n=r>>2;return a[n]},recover:(r,n,i,t)=>e.exports._secp256k1_ecdsa_recover(r,n,i,t),recoverableSignatureParse:(r,n,i,t)=>e.exports._secp256k1_ecdsa_recoverable_signature_parse_compact(r,n,i,t),recoverableSignatureSerialize:(r,n,i,t)=>e.exports._secp256k1_ecdsa_recoverable_signature_serialize_compact(r,n,i,t),schnorrSign:(r,n,i,t)=>e.exports._secp256k1_schnorr_sign(r,n,i,t),schnorrVerify:(r,n,i,t)=>e.exports._secp256k1_schnorr_verify(r,n,i,t),seckeyVerify:(r,n)=>e.exports._secp256k1_ec_seckey_verify(r,n),sign:(r,n,i,t)=>e.exports._secp256k1_ecdsa_sign(r,n,i,t),signRecoverable:(r,n,i,t)=>e.exports._secp256k1_ecdsa_sign_recoverable(r,n,i,t),signatureMalleate:(r,n,i)=>e.exports._secp256k1_ecdsa_signature_malleate(r,n,i),signatureNormalize:(r,n,i)=>e.exports._secp256k1_ecdsa_signature_normalize(r,n,i),signatureParseCompact:(r,n,i)=>e.exports._secp256k1_ecdsa_signature_parse_compact(r,n,i),signatureParseDER:(r,n,i,t)=>e.exports._secp256k1_ecdsa_signature_parse_der(r,n,i,t),signatureSerializeCompact:(r,n,i)=>e.exports._secp256k1_ecdsa_signature_serialize_compact(r,n,i),signatureSerializeDER:(r,n,i,t)=>e.exports._secp256k1_ecdsa_signature_serialize_der(r,n,i,t),verify:(r,n,i,t)=>e.exports._secp256k1_ecdsa_verify(r,n,i,t)}),GI=e=>{let r=new Int16Array(e),n=new Int32Array(e),i=new Uint8Array(e);return n[0]=1668509029,r[1]=25459,!(i[2]!==115||i[3]!==99)},bo=(e,A)=>Math.ceil(A/e)*e,Zr=async e=>{let t=new WebAssembly.Memory({initial:256,maximum:256});if(!GI(t.buffer))throw new Error("Runtime error: expected the system to be little-endian.");let o=1024,s=o+67696+16,g=s,I=s+4+15&-16,E=bo(16,I),k=E+5242880,U=bo(16,k),N=new Uint8Array(t.buffer),c=new Int32Array(t.buffer),B=new Uint32Array(t.buffer);c[g>>2]=U;let S=6,P=6,h,p={env:{...{DYNAMICTOP_PTR:g,STACKTOP:E,___setErrNo:C=>(h!==void 0&&(c[h()>>2]=C),C),_abort:(C="Secp256k1 Error")=>{throw new Error(C)},_emscripten_memcpy_big:(C,b,Y)=>(N.set(N.subarray(b,b+Y),C),C),abort:(C="Secp256k1 Error")=>{throw new Error(C)},abortOnCannotGrowMemory:()=>{throw new Error("Secp256k1 Error: abortOnCannotGrowMemory was called.")},enlargeMemory:()=>{throw new Error("Secp256k1 Error: enlargeMemory was called.")},getTotalMemory:()=>16777216},memory:t,memoryBase:o,table:new WebAssembly.Table({element:"anyfunc",initial:S,maximum:P}),tableBase:0},global:{Infinity:1/0,NaN:NaN}};return WebAssembly.instantiate(e,p).then(C=>(h=C.instance.exports.___errno_location,MI(C.instance,N,B)))},qI=()=>dA(So).buffer,ko=async()=>Zr(qI());var No="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";var Uo="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";var _o="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";var HI=async e=>{let A=await VA(e,"./ripemd160","ripemd160","ripemd160_init","ripemd160_update","ripemd160_final");return{final:A.final,hash:A.hash,init:A.init,update:A.update}},JI=()=>dA(Po).buffer,vo=async()=>HI(JI());var Ge;(function(e){e.unparsableSignature="Failed to parse signature.",e.unparsablePublicKey="Failed to parse public key.",e.derivePublicKeyFromInvalidPrivateKey="Cannot derive public key from invalid private key.",e.signWithInvalidPrivateKey="Failed to sign message hash. The private key is not valid.",e.recoverPublicKeyWithUnparsableSignature="Failed to recover public key. Could not parse signature.",e.recoverPublicKeyInvalidMaterial="Failed to recover public key. The compact signature, recovery, or message hash is invalid.",e.addTweakPrivateKey="Private key is invalid or adding failed.",e.mulTweakPrivateKey="Private key is invalid or multiplying failed.",e.addTweakPublicKey="Failed to tweak public key (by addition).",e.mulTweakPublicKey="Failed to tweak public key (by multiplication)."})(Ge||(Ge={}));var Do=(e,A)=>{let a=e.contextCreate(ha.BOTH),r=e.malloc(72),n=e.malloc(65),i=e.malloc(32),t=e.malloc(64),o=e.malloc(64),s=e.malloc(64),g=e.malloc(32),l=e.malloc(65),I=e.malloc(4),E=I>>2,u=()=>e.heapU32[E],k=e.malloc(4),U=k>>2,N=(J,j)=>{let he=new Uint8Array(j);return he.set(J),he},c=J=>{let j=N(J,65);return e.heapU8.set(j,n),e.pubkeyParse(a,t,n,J.length)===1},B=J=>{e.heapU32.set([J],U)},S=()=>e.heapU32[U],P=(J,j)=>(B(J),e.pubkeySerialize(a,n,k,t,j),e.readHeapU8(n,S()).slice()),h=J=>J?P(33,yt.COMPRESSED):P(65,yt.UNCOMPRESSED),y=J=>j=>c(j)?h(J):Ge.unparsablePublicKey,p=(J,j)=>{let he=N(J,72);return e.heapU8.set(he,r),j?e.signatureParseDER(a,o,r,J.length)===1:e.signatureParseCompact(a,o,r)===1},C=()=>(e.signatureSerializeCompact(a,r,o),e.readHeapU8(r,64).slice()),b=()=>(B(72),e.signatureSerializeDER(a,r,k,o),e.readHeapU8(r,S()).slice()),Y=J=>j=>p(j,J)?J?C():b():Ge.unparsableSignature,_=J=>{let j=N(J,32);e.heapU8.set(j,g)},x=(J,j)=>{e.heapU8.fill(0,J,J+j)},H=()=>{x(g,32)},F=(J,j)=>{_(J);let he=j();return H(),he},O=J=>j=>F(j,()=>e.pubkeyCreate(a,t,g)!==1)?Ge.derivePublicKeyFromInvalidPrivateKey:h(J),D=J=>{let j=N(J,32);e.heapU8.set(j,i)},G=()=>{e.signatureNormalize(a,o,o)},K=(J,j)=>he=>p(he,J)?(j?G():e.signatureMalleate(a,o,o),J?b():C()):Ge.unparsableSignature,V=(J,j,he)=>{let Bt=p(J,j);return he&&G(),Bt},L=J=>(j,he)=>(D(he),F(j,()=>e.sign(a,o,i,g)!==1?Ge.signWithInvalidPrivateKey:J?(B(72),e.signatureSerializeDER(a,r,k,o),e.readHeapU8(r,S()).slice()):(e.signatureSerializeCompact(a,r,o),e.readHeapU8(r,64).slice()))),Pe=()=>(J,j)=>(D(j),F(J,()=>e.schnorrSign(a,s,i,g)!==1?Ge.signWithInvalidPrivateKey:e.readHeapU8(s,64).slice())),Fe=J=>(D(J),e.verify(a,o,i,t)===1),Ne=(J,j)=>(he,Bt,Kr)=>c(Bt)&&V(he,J,j)&&Fe(Kr),JA=(J,j)=>{D(J);let he=N(j,64);return e.heapU8.set(he,s),e.schnorrVerify(a,s,i,t)===1},ne=()=>(J,j,he)=>c(j)?JA(he,J):!1,Ke=(J,j)=>(D(j),F(J,()=>e.signRecoverable(a,l,i,g)!==1?Ge.signWithInvalidPrivateKey:(e.recoverableSignatureSerialize(a,r,I,l),{recoveryId:u(),signature:e.readHeapU8(r,64).slice()}))),eA=J=>(j,he,Bt)=>{D(Bt);let Kr=N(j,72);return e.heapU8.set(Kr,r),e.recoverableSignatureParse(a,l,r,he)!==1?Ge.recoverPublicKeyWithUnparsableSignature:e.recover(a,t,l,i)!==1?Ge.recoverPublicKeyInvalidMaterial:h(J)},Se=(J,j)=>(D(j),F(J,()=>e.privkeyTweakAdd(a,g,i)!==1?Ge.addTweakPrivateKey:e.readHeapU8(g,32).slice())),Je=(J,j)=>(D(j),F(J,()=>e.privkeyTweakMul(a,g,i)!==1?Ge.mulTweakPrivateKey:e.readHeapU8(g,32).slice())),LA=J=>(j,he)=>c(j)?(D(he),e.pubkeyTweakAdd(a,t,i)!==1?Ge.addTweakPublicKey:h(J)):Ge.unparsablePublicKey,uo=J=>(j,he)=>c(j)?(D(he),e.pubkeyTweakMul(a,t,i)!==1?Ge.mulTweakPublicKey:h(J)):Ge.unparsablePublicKey;if(A!==void 0){let J=i,j=N(A,32);e.heapU8.set(j,J),e.contextRandomize(a,J),x(J,32)}return{addTweakPrivateKey:Se,addTweakPublicKeyCompressed:LA(!0),addTweakPublicKeyUncompressed:LA(!1),compressPublicKey:y(!0),derivePublicKeyCompressed:O(!0),derivePublicKeyUncompressed:O(!1),malleateSignatureCompact:K(!1,!1),malleateSignatureDER:K(!0,!1),mulTweakPrivateKey:Je,mulTweakPublicKeyCompressed:uo(!0),mulTweakPublicKeyUncompressed:uo(!1),normalizeSignatureCompact:K(!1,!0),normalizeSignatureDER:K(!0,!0),recoverPublicKeyCompressed:eA(!0),recoverPublicKeyUncompressed:eA(!1),signMessageHashCompact:L(!1),signMessageHashDER:L(!0),signMessageHashRecoverableCompact:Ke,signMessageHashSchnorr:Pe(),signatureCompactToDER:Y(!1),signatureDERToCompact:Y(!0),uncompressPublicKey:y(!1),validatePrivateKey:J=>F(J,()=>e.seckeyVerify(a,g)===1),validatePublicKey:c,verifySignatureCompact:Ne(!1,!0),verifySignatureCompactLowS:Ne(!1,!1),verifySignatureDER:Ne(!0,!0),verifySignatureDERLowS:Ne(!0,!1),verifySignatureSchnorr:ne()}},Md=async(e,A)=>Do(await Zr(e),A),wo=async e=>Do(await ko(),e);var LI=async e=>{let A=await VA(e,"./sha1","sha1","sha1_init","sha1_update","sha1_final");return{final:A.final,hash:A.hash,init:A.init,update:A.update}},VI=()=>dA(No).buffer,To=async()=>LI(VI());var zI=async e=>{let A=await VA(e,"./sha256","sha256","sha256_init","sha256_update","sha256_final");return{final:A.final,hash:A.hash,init:A.init,update:A.update}},jI=()=>dA(Uo).buffer,Yo=async()=>zI(jI());var WI=async e=>{let A=await VA(e,"./sha512","sha512","sha512_init","sha512_update","sha512_final");return{final:A.final,hash:A.hash,init:A.init,update:A.update}},ZI=()=>dA(_o).buffer,xo=async()=>WI(ZI());var[fA,q,je,Ee,Ae]=await Promise.all([To(),Yo(),xo(),vo(),wo()]);var tE=(e,A={ripemd160:Ee,sha256:q})=>A.ripemd160.hash(A.sha256.hash(e)),pe=(e,A=q)=>A.hash(A.hash(e));var Oo=(e,A)=>(a,r)=>{let n=new Uint8Array(A).fill(0);n.set(a.length>A?e(a):a,0);let o=new Uint8Array(A).fill(54).map((u,k)=>u^n[k]),s=ee([o,r]),g=e(s),E=new Uint8Array(A).fill(92).map((u,k)=>u^n[k]);return e(ee([E,g]))},XI=64,Ro=(e,A,a=q)=>Oo(a.hash,XI)(e,A),$I=128,rt=(e,A,a=je)=>Oo(a.hash,$I)(e,A);var da;(function(e){e.invalidIterations="Invalid PBKDF2 parameters: iterations must be a positive integer.",e.invalidDerivedKeyLength="Invalid PBKDF2 parameters: derived key length must be a positive integer.",e.invalidHmacLength="Invalid HMAC length: HMAC length must be a positive integer."})(da||(da={}));var Fo=(e,A)=>a=>{let{password:r,salt:n,iterations:i,derivedKeyLength:t}=a;if(!Number.isInteger(i)||i<=0)return R(da.invalidIterations,`Iterations parameter: ${i}.`);if(!Number.isInteger(t)||t<=0)return R(da.invalidDerivedKeyLength,`Derived key length: ${t}.`);if(!Number.isInteger(A)||A<=0)return R(da.invalidHmacLength,`HMAC length: ${A}.`);let o=4,s=new Uint8Array(t),g=new Uint8Array(n.length+o);g.set(n,0);let l=0,I=Math.ceil(t/A);for(let E=1;E<=I;E++){let u=vA(E);g.set(u,n.length);let k=e(r,g),U=k;for(let c=1;c<i;c++){U=e(r,U);for(let B=0;B<A;B++)k[B]^=U[B]}let N=k.subarray(0,t);s.set(N,l),l+=A}return s},ec=32,gE=(e,A=Ro)=>Fo(A,ec)(e),Ac=64,Xr=(e,A=rt)=>Fo(A,Ac)(e);var le;(function(e){e[e.p2pkh=0]="p2pkh",e[e.p2sh20=5]="p2sh20",e[e.wif=128]="wif",e[e.p2pkhTestnet=111]="p2pkhTestnet",e[e.p2sh20Testnet=196]="p2sh20Testnet",e[e.wifTestnet=239]="wifTestnet",e[e.p2pkhCopayBCH=28]="p2pkhCopayBCH",e[e.p2sh20CopayBCH=40]="p2sh20CopayBCH"})(le||(le={}));var ft=(e,A,a=q)=>{let n=Uint8Array.from([e,...A]),i=pe(n,a).slice(0,4),t=ee([n,i]);return Ma(t)},PE=(e,A,a=q)=>ft({p2pkh:le.p2pkh,p2pkhCopayBCH:le.p2pkhCopayBCH,p2pkhTestnet:le.p2pkhTestnet,p2sh20:le.p2sh20,p2sh20CopayBCH:le.p2sh20CopayBCH,p2sh20Testnet:le.p2sh20Testnet}[e],A,a),nt;(function(e){e.unknownCharacter="Base58Address error: address may only contain valid base58 characters.",e.tooShort="Base58Address error: address is too short to be valid.",e.invalidChecksum="Base58Address error: address has an invalid checksum.",e.unknownAddressVersion="Base58Address error: address uses an unknown address version.",e.incorrectLength="Base58Address error: the encoded payload is not the correct length (20 bytes)."})(nt||(nt={}));var $r=(e,A=q)=>{let r=Ka(e);if(typeof r=="string")return R(nt.unknownCharacter,r);if(r.length<5)return nt.tooShort;let i=r.slice(0,-4),t=r.slice(-4),o=A.hash(A.hash(i)).slice(0,4);return t.every((s,g)=>s===o[g])?{payload:i.slice(1),version:i[0]}:nt.invalidChecksum},Ko=(e,A=q)=>{let a=$r(e,A);return typeof a=="string"?a:[le.p2pkh,le.p2sh20,le.p2pkhTestnet,le.p2sh20Testnet,le.p2pkhCopayBCH,le.p2sh20CopayBCH].includes(a.version)?a.payload.length!==20?nt.incorrectLength:a:nt.unknownAddressVersion};var An="qpzry9x8gf2tvdw0s3jn54khce6mua7l",tc={q:0,p:1,z:2,r:3,y:4,9:5,x:6,8:7,g:8,f:9,2:10,t:11,v:12,d:13,w:14,0:15,s:16,3:17,j:18,n:19,5:20,4:21,k:22,h:23,c:24,e:25,6:26,m:27,u:28,a:29,7:30,l:31},Ea;(function(e){e.integerOutOfRange="An integer provided in the source array is out of the range of the specified source word length.",e.hasDisallowedPadding="Encountered padding when padding was disallowed.",e.requiresDisallowedPadding="Encoding requires padding while padding is disallowed."})(Ea||(Ea={}));var ot=({bin:e,sourceWordLength:A,resultWordLength:a,allowPadding:r=!0})=>{let n=0,i=0,t=[],o=(1<<a)-1;for(let s=0;s<e.length;++s){let g=e[s];if(g<0||g>>A!==0)return Ea.integerOutOfRange;for(n=n<<A|g,i+=A;i>=a;)i-=a,t.push(n>>i&o)}if(r)i>0&&t.push(n<<a-i&o);else{if(i>=A)return Ea.hasDisallowedPadding;if((n<<a-i&o)>0)return Ea.requiresDisallowedPadding}return t},Ct=e=>{let A="";for(let a=0;a<e.length;a++)A+=An[e[a]];return A},ja=e=>{let A=[];for(let a=0;a<e.length;a++)A.push(tc[e[a]]);return A},ic=new RegExp(`[^${An}]`,"u"),Mo=5,Go=8,Wa=e=>!ic.test(e),tn=e=>[...new Set([...e].filter(A=>!An.includes(A)))],en;(function(e){e.notBech32CharacterSet="Bech32 decoding error: input contains characters outside of the Bech32 character set."})(en||(en={}));var bE=e=>{let A=Wa(e)?ot({allowPadding:!1,bin:ja(e),resultWordLength:Go,sourceWordLength:Mo}):en.notBech32CharacterSet;return typeof A=="string"?A:Uint8Array.from(A)},kE=e=>Ct(ot({bin:e,resultWordLength:Mo,sourceWordLength:Go}));var Ba;(function(e){e.mainnet="bitcoincash",e.testnet="bchtest",e.regtest="bchreg"})(Ba||(Ba={}));var qo;(function(e){e[e.p2pkh=0]="p2pkh",e[e.p2sh20=8]="p2sh20",e[e.p2sh32=11]="p2sh32",e[e.p2pkhWithTokens=16]="p2pkhWithTokens",e[e.p2sh20WithTokens=24]="p2sh20WithTokens",e[e.p2sh32WithTokens=27]="p2sh32WithTokens"})(qo||(qo={}));var Ue;(function(e){e.p2pkh="p2pkh",e.p2sh="p2sh",e.p2pkhWithTokens="p2pkhWithTokens",e.p2shWithTokens="p2shWithTokens"})(Ue||(Ue={}));var CA;(function(e){e[e.p2pkh=0]="p2pkh",e[e.p2sh=1]="p2sh",e[e.p2pkhWithTokens=2]="p2pkhWithTokens",e[e.p2shWithTokens=3]="p2shWithTokens"})(CA||(CA={}));var ac={[Ue.p2pkh]:CA.p2pkh,[Ue.p2sh]:CA.p2sh,[Ue.p2pkhWithTokens]:CA.p2pkhWithTokens,[Ue.p2shWithTokens]:CA.p2shWithTokens},rc={[CA.p2pkh]:Ue.p2pkh,[CA.p2sh]:Ue.p2sh,[CA.p2pkhWithTokens]:Ue.p2pkhWithTokens,[CA.p2shWithTokens]:Ue.p2shWithTokens},nc={0:20,1:24,2:28,3:32,4:40,5:48,6:56,7:64},Jo={20:0,24:1,28:2,32:3,40:4,48:5,56:6,64:7},oc=(e,A)=>e<<3|Jo[A],Za;(function(e){e.reservedBitSet="Reserved bit is set."})(Za||(Za={}));var sc=e=>(e&128)!==0?Za.reservedBitSet:{length:nc[e&7],typeBits:e>>>3&15},on=e=>{let A=[];for(let a=0;a<e.length;a++)A.push(e.charCodeAt(a)&31);return A},Ho=[152,121,243,174,30],gc=[4072443489,3077413346,1046459332,783016616,1329849456],Xa=e=>{let A=0,a=1,r=0;for(let n=0;n<e.length;n++){r=A>>>3,A&=7,A<<=5,A|=a>>>27,a&=134217727,a<<=5,a^=e[n];for(let i=0;i<Ho.length;++i)r&1<<i&&(A^=Ho[i],a^=gc[i])}return a^=1,a<0&&(a^=1<<31,a+=(1<<30)*2),A*(1<<30)*4+a},Ic=e=>{let A=[];for(let a=0;a<8;++a)A.push(e&31),e/=32;return A.reverse()},rn;(function(e){e.excessiveVersion="CashAddress format encoding error: version must be 255 or less."})(rn||(rn={}));var Pt;(function(e){e.noTypeBitsValueStandardizedForP2pk="CashAddress encoding error: no CashAddress type bit has been standardized for P2PK locking bytecode.",e.unsupportedPayloadLength="CashAddress encoding error: a payload of this length can not be encoded as a valid CashAddress.",e.unknownLockingBytecodeType="CashAddress encoding error: unknown locking bytecode type."})(Pt||(Pt={}));var cc=({payload:e,prefix:A,throwErrors:a=!0,version:r})=>{let n=[0,0,0,0,0,0,0,0];if(r>255)return R(rn.excessiveVersion,`Version: ${r}.`,a);let i=ot({bin:Uint8Array.from([r,...e]),resultWordLength:5,sourceWordLength:8}),t=[...on(A),0,...i,...n],o=Xa(t),s=[...i,...Ic(o)];return{address:`${A}:${Ct(s)}`}},lc=e=>Jo[e]!==void 0,uc=({payload:e,prefix:A,throwErrors:a=!0,typeBits:r})=>{let{length:n}=e;return lc(n)?cc({payload:e,prefix:A,throwErrors:a,version:oc(r,n)}):R(Pt.unsupportedPayloadLength,`Payload length: ${n}.`,a)},pa=({payload:e,prefix:A="bitcoincash",throwErrors:a=!0,type:r})=>uc({payload:e,prefix:A,throwErrors:a,typeBits:ac[r]}),rA;(function(e){e.improperPadding="CashAddress decoding error: the payload is improperly padded.",e.invalidCharacters="CashAddress decoding error: the payload contains unexpected characters.",e.invalidChecksum="CashAddress decoding error: invalid checksum - please review the address for errors.",e.invalidFormat='CashAddress decoding error: CashAddresses should be of the form "prefix:payload".',e.mismatchedPayloadLength="CashAddress decoding error: mismatched payload length for specified address version.",e.reservedBit="CashAddress decoding error: unknown CashAddress version, reserved bit set.",e.unknownAddressType="CashAddress decoding error: unknown CashAddress type."})(rA||(rA={}));var Lo=e=>{let A=e.toLowerCase().split(":");if(A.length!==2||A[0]===""||A[1]==="")return R(rA.invalidFormat,`Provided address: "${e}".`);let[a,r]=A;if(!Wa(r))return R(rA.invalidCharacters,`Invalid characters: ${tn(r).join(", ")}.`);let n=ja(r),i=[...on(a),0,...n];if(Xa(i)!==0)return rA.invalidChecksum;let o=ot({allowPadding:!1,bin:n.slice(0,-8),resultWordLength:8,sourceWordLength:5});if(typeof o=="string")return R(rA.improperPadding,o);let[s,...g]=o;return{payload:Uint8Array.from(g),prefix:a,version:s}},hc=e=>{let A=Lo(e);if(typeof A=="string")return A;let a=sc(A.version);return a===Za.reservedBitSet?R(rA.reservedBit):A.payload.length!==a.length?R(rA.mismatchedPayloadLength,`Version byte indicated a byte length of ${a.length}, but the payload is ${A.payload.length} bytes.`):{payload:A.payload,prefix:A.prefix,typeBits:a.typeBits}},Vo=e=>{let A=hc(e);if(typeof A=="string")return A;let a=rc[A.typeBits];return a===void 0?R(rA.unknownAddressType,`Type bit value: ${A.typeBits}.`):{payload:A.payload,prefix:A.prefix,type:a}},vE=(e,A=[Ba.mainnet,Ba.testnet,Ba.regtest])=>{for(let a of A){let r=Lo(`${a}:${e}`);if(r!==rA.invalidChecksum)return r}return rA.invalidChecksum},an=e=>{let A=e.indexOf(0),a=e.slice(0,A).map(n=>String.fromCharCode(96+n)).join(""),r=Ct(e.slice(A+1));return`${a}:${r}`},nn;(function(e){e.tooManyErrors="CashAddress format correction error: this address cannot be corrected as it contains more than 2 errors."})(nn||(nn={}));var DE=e=>{let A=e.toLowerCase().split(":");if(A.length!==2||A[0]===""||A[1]==="")return rA.invalidFormat;let[a,r]=A;if(!Wa(r))return R(rA.invalidCharacters,`Invalid characters: ${tn(r).join(", ")}.`);let n=ja(r),i=[...on(a),0,...n],t=Xa(i);if(t===0)return{address:an(i),corrections:[]};let o={};for(let s=0;s<i.length;s++)for(let g=1;g<32;g++){i[s]^=g;let l=Xa(i);if(l===0)return{address:an(i),corrections:[s]};let I=(BigInt(l)^BigInt(t)).toString();o[I]=s*32+g,i[s]^=g}for(let[s,g]of Object.entries(o)){let l=(BigInt(s)^BigInt(t)).toString(),I=o[l];if(I!==void 0){let E=Math.trunc(g/32),u=Math.trunc(I/32);return i[E]^=g%32,i[u]^=I%32,{address:an(i),corrections:[E,u].sort((k,U)=>k-U)}}}return nn.tooManyErrors};var _e;(function(e){e.p2pk="P2PK",e.p2pkh="P2PKH",e.p2sh20="P2SH20",e.p2sh32="P2SH32"})(_e||(_e={}));var zo=e=>e.length===67&&e[0]===65&&e[66]===172,jo=e=>e.length===35&&e[0]===33&&e[34]===172,gn=e=>jo(e)||zo(e),$a=e=>e.length===25&&e[0]===118&&e[1]===169&&e[2]===20&&e[23]===136&&e[24]===172,PA=e=>e.length===23&&e[0]===169&&e[1]===20&&e[22]===135,ma=e=>e.length===35&&e[0]===170&&e[1]===32&&e[34]===135,Wo=e=>$a(e)?{payload:e.slice(3,23),type:_e.p2pkh}:PA(e)?{payload:e.slice(2,22),type:_e.p2sh20}:ma(e)?{payload:e.slice(2,34),type:_e.p2sh32}:zo(e)?{payload:e.slice(1,66),type:_e.p2pk}:jo(e)?{payload:e.slice(1,34),type:_e.p2pk}:{payload:e.slice(),type:"unknown"},dc=e=>Uint8Array.from([118,169,20,...e,136,172]),Ec=e=>Uint8Array.from([169,20,...e,135]),Bc=e=>Uint8Array.from([170,32,...e,135]),pc=e=>e.length===33?Uint8Array.from([33,...e,172]):Uint8Array.from([65,...e,172]),sn=({payload:e,type:A})=>A===_e.p2pkh?dc(e):A===_e.p2sh20?Ec(e):A===_e.p2sh32?Bc(e):A===_e.p2pk?pc(e):Mr(A,"Unrecognized addressContents type:"),Qa=({prefix:e="bitcoincash",bytecode:A,tokenSupport:a=!1})=>{let{payload:r,type:n}=Wo(A);return n===_e.p2pkh?a?pa({payload:r,prefix:e,throwErrors:!1,type:Ue.p2pkhWithTokens}):pa({payload:r,prefix:e,throwErrors:!1,type:Ue.p2pkh}):n===_e.p2sh20||n===_e.p2sh32?a?pa({payload:r,prefix:e,throwErrors:!1,type:Ue.p2shWithTokens}):pa({payload:r,prefix:e,throwErrors:!1,type:Ue.p2sh}):n==="P2PK"?Pt.noTypeBitsValueStandardizedForP2pk:Pt.unknownLockingBytecodeType},RE=e=>{let A=Vo(e);return typeof A=="string"?A:A.type===Ue.p2pkh||A.type===Ue.p2pkhWithTokens?{bytecode:sn({payload:A.payload,type:_e.p2pkh}),prefix:A.prefix,tokenSupport:A.type===Ue.p2pkhWithTokens}:A.type===Ue.p2sh||A.type===Ue.p2shWithTokens?{bytecode:sn({payload:A.payload,type:A.payload.length===32?_e.p2sh32:_e.p2sh20}),prefix:A.prefix,tokenSupport:A.type===Ue.p2shWithTokens}:Mr(A.type)},FE=(e,A="mainnet",a=q)=>{let r=Wo(e);return r.type===_e.p2pkh?ft({copayBCH:le.p2pkhCopayBCH,mainnet:le.p2pkh,testnet:le.p2pkhTestnet}[A],r.payload,a):r.type===_e.p2sh20?ft({copayBCH:le.p2sh20CopayBCH,mainnet:le.p2sh20,testnet:le.p2sh20Testnet}[A],r.payload,a):r},KE=(e,A=q)=>{let a=Ko(e,A);return typeof a=="string"?a:{bytecode:sn({payload:a.payload,type:[le.p2pkh,le.p2pkhCopayBCH,le.p2pkhTestnet].includes(a.version)?_e.p2pkh:_e.p2sh20}),version:a.version}};var In;(function(e){e.insufficientLength="Error reading bytes: insufficient length."})(In||(In={}));var Zo=e=>A=>{let a={bin:A.bin,index:A.index+e},r=A.bin.slice(A.index,a.index);return r.length!==e?R(In.insufficientLength,`Bytes requested: ${e}; remaining bytes: ${r.length}`):{position:a,result:r}},cn;(function(e){e.insufficientBytes="Error reading Uint32LE: requires 4 bytes."})(cn||(cn={}));var st=e=>{let A={bin:e.bin,index:e.index+4},a=e.bin.subarray(e.index,A.index);if(a.length!==4)return R(cn.insufficientBytes,`Remaining bytes: ${a.length}`);let r=Ha(a);return{position:A,result:r}},ln;(function(e){e.insufficientBytes="Error reading Uint64LE: requires 8 bytes."})(ln||(ln={}));var un=e=>{let A={bin:e.bin,index:e.index+8},a=e.bin.subarray(e.index,A.index);if(a.length!==8)return R(ln.insufficientBytes,`Remaining bytes: ${a.length}`);let r=jr(a);return{position:A,result:r}},er;(function(e){e.invalidCompactUint="Error reading CompactUint-prefixed bin: invalid CompactUint.",e.insufficientBytes="Error reading CompactUint-prefixed bin: insufficient bytes."})(er||(er={}));var ya=e=>{let A=it(e);if(typeof A=="string")return R(er.invalidCompactUint,A);let{result:a,position:r}=A,n=Number(a),i={bin:e.bin,index:r.index+n},t=e.bin.slice(r.index,i.index);return t.length!==n?R(er.insufficientBytes,`Required bytes: ${n}, remaining bytes: ${t.length}`):{position:i,result:t}},Xo=e=>{let A={bin:e.bin,index:e.bin.length},a=e.bin.subarray(e.index,A.index);return{position:A,result:a}};var SA;(function(e){e.none="none",e.mutable="mutable",e.minting="minting"})(SA||(SA={}));var jE=Uint8Array.from([255,255,255,255,255,255,255,255]);var mc=e=>ee([e.outpointTransactionHash.slice().reverse(),de(e.outpointIndex),IA(BigInt(e.unlockingBytecode.length)),e.unlockingBytecode,de(e.sequenceNumber)]),nA;(function(e){e.transaction="Error reading transaction.",e.endsWithUnexpectedBytes="Error decoding transaction: the provided input includes unexpected bytes after the encoded transaction.",e.input="Error reading transaction input.",e.inputs="Error reading transaction inputs.",e.output="Error reading transaction output.",e.outputs="Error reading transaction outputs.",e.outputsEndWithUnexpectedBytes="Error decoding transaction outputs: the provided serialization includes unexpected bytes after the encoded transaction outputs.",e.lockingBytecodeLength="Error reading locking bytecode length."})(nA||(nA={}));var Qc=e=>{let A=at(e,[Zo(32),st,ya,st]);if(typeof A=="string")return R(nA.input,A);let{position:a,result:[r,n,i,t]}=A;return{position:a,result:{outpointIndex:n,outpointTransactionHash:r.reverse(),sequenceNumber:t,unlockingBytecode:i}}},yc=e=>ee([IA(BigInt(e.length)),...e.map(mc)]),es=e=>{let A=Va(e,Qc);return typeof A=="string"?R(nA.inputs,A):A},fc=9223372036854775807n,Cc=[SA.none,SA.mutable,SA.minting],Pc={[SA.none]:0,[SA.mutable]:1,[SA.minting]:2},AA;(function(e){e.invalidPrefix="Error reading token prefix.",e.insufficientLength="Invalid token prefix: insufficient length.",e.reservedBit="Invalid token prefix: reserved bit is set.",e.invalidCapability="Invalid token prefix: capability must be none (0), mutable (1), or minting (2).",e.commitmentWithoutNft="Invalid token prefix: commitment requires an NFT.",e.capabilityWithoutNft="Invalid token prefix: capability requires an NFT.",e.commitmentLengthZero="Invalid token prefix: if encoded, commitment length must be greater than 0.",e.invalidCommitment="Invalid token prefix: invalid non-fungible token commitment.",e.invalidAmountEncoding="Invalid token prefix: invalid fungible token amount encoding.",e.zeroAmount="Invalid token prefix: if encoded, fungible token amount must be greater than 0.",e.excessiveAmount="Invalid token prefix: exceeds maximum fungible token amount of 9223372036854775807.",e.noTokens="Invalid token prefix: must encode at least one token."})(AA||(AA={}));var $o=e=>{let A=it(e);return typeof A=="string"?R(AA.invalidAmountEncoding,A):A.result>fc?R(AA.excessiveAmount,`Encoded amount: ${A.result}`):A.result===0n?R(AA.zeroAmount):A},Sc=e=>{let{bin:A,index:a}=e;if(A[a]!==239)return{position:e,result:{}};if(A.length<a+34)return R(AA.insufficientLength,`The minimum possible length is 34. Missing bytes: ${34-(A.length-a)}`);let r=A.slice(a+1,a+33).reverse(),n=A[a+33],i=n&240;if((i&128)!==0)return R(AA.reservedBit,`Bitfield: 0b${n.toString(2)}`);let t=n&15;if(t>2)return R(AA.invalidCapability,`Capability value: ${t}`);let o=Cc[t],s=(i&32)!==0,g=(i&64)!==0;if(g&&!s)return R(AA.commitmentWithoutNft,`Bitfield: 0b${n.toString(2)}`);let l=(i&16)!==0,I={bin:A,index:a+33+1};if(s){let u=g?ya(I):{position:I,result:Uint8Array.of()};if(typeof u=="string")return R(AA.invalidCommitment,u);if(g&&u.result.length===0)return R(AA.commitmentLengthZero);let k=l?$o(u.position):{position:u.position,result:0n};return typeof k=="string"?k:{position:k.position,result:{token:{amount:k.result,category:r,nft:{capability:o,commitment:u.result}}}}}if(o!==SA.none)return R(AA.capabilityWithoutNft,`Bitfield: 0b${n.toString(2)}`);if(!l)return R(AA.noTokens,`Bitfield: 0b${n.toString(2)}`);let E=$o(I);return typeof E=="string"?E:{position:E.position,result:{token:{amount:E.result,category:r}}}},bc=e=>{let A=ya(e);if(typeof A=="string")return R(nA.lockingBytecodeLength,A);let{result:a,position:r}=A,n=at({bin:a,index:0},[Sc,Xo]);if(typeof n=="string")return R(AA.invalidPrefix,n);let{result:[{token:i},t]}=n;return{position:r,result:{lockingBytecode:t,...i===void 0?{}:{token:i}}}},kc=e=>{let A=at(e,[un,bc]);if(typeof A=="string")return R(nA.output,A);let{position:a,result:[r,{lockingBytecode:n,token:i}]}=A;return{position:a,result:{lockingBytecode:n,...i===void 0?{}:{token:i},valueSatoshis:r}}},fa=e=>{if(e===void 0||e.nft===void 0&&e.amount<1n)return Uint8Array.of();let A=e.nft===void 0?0:32,a=e.nft===void 0?0:Pc[e.nft.capability],r=e.nft!==void 0&&e.nft.commitment.length>0?64:0,n=e.amount>0n?16:0,i=A|r|n|a;return ee([Uint8Array.of(239),e.category.slice().reverse(),Uint8Array.of(i),...r===0?[]:[IA(BigInt(e.nft.commitment.length)),e.nft.commitment],...n===0?[]:[IA(e.amount)]])},St=e=>{let A=ee([fa(e.token),e.lockingBytecode]);return ee([Qt(e.valueSatoshis),IA(BigInt(A.length)),A])},As=e=>{let A=Va(e,kc);return typeof A=="string"?R(nA.outputs,A):A},AB=e=>{let A=As({bin:e,index:0});return typeof A=="string"?A:A.position.index!==e.length?R(nA.outputsEndWithUnexpectedBytes,`Last encoded transaction output ends at index ${A.position.index-1}, leaving ${e.length-A.position.index} remaining byte(s).`):A.result},hn=e=>ee([IA(BigInt(e.length)),...e.map(St)]),ts=e=>{let A=at(e,[st,es,As,st]);if(typeof A=="string")return R(nA.transaction,A);let{position:a,result:[r,n,i,t]}=A;return{position:a,result:{inputs:n,locktime:t,outputs:i,version:r}}},tB=ts,Nc=e=>{let A=at(e,[un,ya]);if(typeof A=="string")return R(nA.output,A);let{position:a,result:[r,n]}=A;return{position:a,result:{lockingBytecode:n,valueSatoshis:r}}},Uc=e=>{let A=Va(e,Nc);return typeof A=="string"?R(nA.outputs,A):A},iB=e=>{let A=at(e,[st,es,Uc,st]);if(typeof A=="string")return R(nA.transaction,A);let{position:a,result:[r,n,i,t]}=A;return{position:a,result:{inputs:n,locktime:t,outputs:i,version:r}}},is=e=>{let A=ts({bin:e,index:0});return typeof A=="string"?A:A.position.index!==e.length?R(nA.endsWithUnexpectedBytes,`Encoded transaction ends at index ${A.position.index-1}, leaving ${e.length-A.position.index} remaining bytes.`):A.result},_c=is,aB=_c,vc=e=>{let A=is(e);if(typeof A=="string")throw new Error(A);return A},Dc=vc,rB=Dc,dn=e=>ee([de(e.version),yc(e.inputs),hn(e.outputs),de(e.locktime)]),gt=dn,as=gt,wc=e=>e.map(A=>({outpointIndex:A.outpointIndex,outpointTransactionHash:A.outpointTransactionHash.slice(),sequenceNumber:A.sequenceNumber,unlockingBytecode:A.unlockingBytecode.slice()})),En=e=>e.map(A=>({lockingBytecode:A.lockingBytecode.slice(),...A.token===void 0?{}:{token:{amount:A.token.amount,category:A.token.category.slice(),...A.token.nft===void 0?{}:{nft:{capability:A.token.nft.capability,commitment:A.token.nft.commitment.slice()}}}},valueSatoshis:A.valueSatoshis})),rs=e=>({inputs:wc(e.inputs),locktime:e.locktime,outputs:En(e.outputs),version:e.version}),Bn=(e,A=q)=>pe(e,A),Tc=(e,A=q)=>Bn(e,A).reverse(),nB=e=>$(Tc(e)),Ca=e=>ee(e.map(A=>ee([A.outpointTransactionHash.slice().reverse(),de(A.outpointIndex)]))),bt=e=>ee(e.map(St)),Pa=e=>ee(e.map(A=>de(A.sequenceNumber)));var ns;(function(e){e.OP_0="Push the VM Number 0 onto the stack.",e.OP_PUSHBYTES_1="Push the next byte onto the stack.",e.OP_PUSHBYTES_2="Push the next 2 bytes onto the stack.",e.OP_PUSHBYTES_3="Push the next 3 bytes onto the stack.",e.OP_PUSHBYTES_4="Push the next 4 bytes onto the stack.",e.OP_PUSHBYTES_5="Push the next 5 bytes onto the stack.",e.OP_PUSHBYTES_6="Push the next 6 bytes onto the stack.",e.OP_PUSHBYTES_7="Push the next 7 bytes onto the stack.",e.OP_PUSHBYTES_8="Push the next 8 bytes onto the stack.",e.OP_PUSHBYTES_9="Push the next 9 bytes onto the stack.",e.OP_PUSHBYTES_10="Push the next 10 bytes onto the stack.",e.OP_PUSHBYTES_11="Push the next 11 bytes onto the stack.",e.OP_PUSHBYTES_12="Push the next 12 bytes onto the stack.",e.OP_PUSHBYTES_13="Push the next 13 bytes onto the stack.",e.OP_PUSHBYTES_14="Push the next 14 bytes onto the stack.",e.OP_PUSHBYTES_15="Push the next 15 bytes onto the stack.",e.OP_PUSHBYTES_16="Push the next 16 bytes onto the stack.",e.OP_PUSHBYTES_17="Push the next 17 bytes onto the stack.",e.OP_PUSHBYTES_18="Push the next 18 bytes onto the stack.",e.OP_PUSHBYTES_19="Push the next 19 bytes onto the stack.",e.OP_PUSHBYTES_20="Push the next 20 bytes onto the stack.",e.OP_PUSHBYTES_21="Push the next 21 bytes onto the stack.",e.OP_PUSHBYTES_22="Push the next 22 bytes onto the stack.",e.OP_PUSHBYTES_23="Push the next 23 bytes onto the stack.",e.OP_PUSHBYTES_24="Push the next 24 bytes onto the stack.",e.OP_PUSHBYTES_25="Push the next 25 bytes onto the stack.",e.OP_PUSHBYTES_26="Push the next 26 bytes onto the stack.",e.OP_PUSHBYTES_27="Push the next 27 bytes onto the stack.",e.OP_PUSHBYTES_28="Push the next 28 bytes onto the stack.",e.OP_PUSHBYTES_29="Push the next 29 bytes onto the stack.",e.OP_PUSHBYTES_30="Push the next 30 bytes onto the stack.",e.OP_PUSHBYTES_31="Push the next 31 bytes onto the stack.",e.OP_PUSHBYTES_32="Push the next 32 bytes onto the stack.",e.OP_PUSHBYTES_33="Push the next 33 bytes onto the stack.",e.OP_PUSHBYTES_34="Push the next 34 bytes onto the stack.",e.OP_PUSHBYTES_35="Push the next 35 bytes onto the stack.",e.OP_PUSHBYTES_36="Push the next 36 bytes onto the stack.",e.OP_PUSHBYTES_37="Push the next 37 bytes onto the stack.",e.OP_PUSHBYTES_38="Push the next 38 bytes onto the stack.",e.OP_PUSHBYTES_39="Push the next 39 bytes onto the stack.",e.OP_PUSHBYTES_40="Push the next 40 bytes onto the stack.",e.OP_PUSHBYTES_41="Push the next 41 bytes onto the stack.",e.OP_PUSHBYTES_42="Push the next 42 bytes onto the stack.",e.OP_PUSHBYTES_43="Push the next 43 bytes onto the stack.",e.OP_PUSHBYTES_44="Push the next 44 bytes onto the stack.",e.OP_PUSHBYTES_45="Push the next 45 bytes onto the stack.",e.OP_PUSHBYTES_46="Push the next 46 bytes onto the stack.",e.OP_PUSHBYTES_47="Push the next 47 bytes onto the stack.",e.OP_PUSHBYTES_48="Push the next 48 bytes onto the stack.",e.OP_PUSHBYTES_49="Push the next 49 bytes onto the stack.",e.OP_PUSHBYTES_50="Push the next 50 bytes onto the stack.",e.OP_PUSHBYTES_51="Push the next 51 bytes onto the stack.",e.OP_PUSHBYTES_52="Push the next 52 bytes onto the stack.",e.OP_PUSHBYTES_53="Push the next 53 bytes onto the stack.",e.OP_PUSHBYTES_54="Push the next 54 bytes onto the stack.",e.OP_PUSHBYTES_55="Push the next 55 bytes onto the stack.",e.OP_PUSHBYTES_56="Push the next 56 bytes onto the stack.",e.OP_PUSHBYTES_57="Push the next 57 bytes onto the stack.",e.OP_PUSHBYTES_58="Push the next 58 bytes onto the stack.",e.OP_PUSHBYTES_59="Push the next 59 bytes onto the stack.",e.OP_PUSHBYTES_60="Push the next 60 bytes onto the stack.",e.OP_PUSHBYTES_61="Push the next 61 bytes onto the stack.",e.OP_PUSHBYTES_62="Push the next 62 bytes onto the stack.",e.OP_PUSHBYTES_63="Push the next 63 bytes onto the stack.",e.OP_PUSHBYTES_64="Push the next 64 bytes onto the stack.",e.OP_PUSHBYTES_65="Push the next 65 bytes onto the stack.",e.OP_PUSHBYTES_66="Push the next 66 bytes onto the stack.",e.OP_PUSHBYTES_67="Push the next 67 bytes onto the stack.",e.OP_PUSHBYTES_68="Push the next 68 bytes onto the stack.",e.OP_PUSHBYTES_69="Push the next 69 bytes onto the stack.",e.OP_PUSHBYTES_70="Push the next 70 bytes onto the stack.",e.OP_PUSHBYTES_71="Push the next 71 bytes onto the stack.",e.OP_PUSHBYTES_72="Push the next 72 bytes onto the stack.",e.OP_PUSHBYTES_73="Push the next 73 bytes onto the stack.",e.OP_PUSHBYTES_74="Push the next 74 bytes onto the stack.",e.OP_PUSHBYTES_75="Push the next 75 bytes onto the stack.",e.OP_PUSHDATA_1="Read the next Uint8 and push that number of bytes onto the stack.",e.OP_PUSHDATA_2="Read the next little-endian Uint16 and push that number of bytes onto the stack.",e.OP_PUSHDATA_4="Read the next little-endian Uint32 and push that number of bytes onto the stack.",e.OP_1NEGATE="Push the VM Number -1 onto the stack.",e.OP_RESERVED="Error unless found in an unexecuted conditional branch. Note: OP_RESERVED does not count toward the opcode limit.",e.OP_1="Push a 1 (VM Number) onto the stack.",e.OP_2="Push a 2 (VM Number) onto the stack.",e.OP_3="Push a 3 (VM Number) onto the stack.",e.OP_4="Push a 4 (VM Number) onto the stack.",e.OP_5="Push a 5 (VM Number) onto the stack.",e.OP_6="Push a 6 (VM Number) onto the stack.",e.OP_7="Push a 7 (VM Number) onto the stack.",e.OP_8="Push a 8 (VM Number) onto the stack.",e.OP_9="Push a 9 (VM Number) onto the stack.",e.OP_10="Push a 10 (VM Number) onto the stack.",e.OP_11="Push a 11 (VM Number) onto the stack.",e.OP_12="Push a 12 (VM Number) onto the stack.",e.OP_13="Push a 13 (VM Number) onto the stack.",e.OP_14="Push a 14 (VM Number) onto the stack.",e.OP_15="Push a 15 (VM Number) onto the stack.",e.OP_16="Push a 16 (VM Number) onto the stack.",e.OP_NOP="No operation. Note: OP_NOP counts toward the opcode limit.",e.OP_VER="Error unless found in an unexecuted conditional branch. Note: OP_VER counts toward the opcode limit. (Historically, this pushed a protocol version number to the stack.)",e.OP_IF='Pop the top item from the stack. If it is not "truthy", skip evaluation until a matching OP_ELSE or OP_ENDIF.',e.OP_NOTIF='Pop the top item from the stack. If it is "truthy", skip evaluation until a matching OP_ELSE or OP_ENDIF.',e.OP_VERIF="Error, even when found in an unexecuted conditional branch. (Historically, this was a combination of OP_VER and OP_IF.)",e.OP_VERNOTIF="Error, even when found in an unexecuted conditional branch. (Historically, this was a combination of OP_VER and OP_NOTIF.)",e.OP_ELSE="Invert conditional evaluation within the current OP_IF ... OP_ENDIF block. (If evaluation is enabled, disable it, if it is disabled, enable it.)",e.OP_ENDIF="End the current OP_IF/OP_NOTIF ... OP_ENDIF block.",e.OP_VERIFY=`Pop the top item from the stack and error if it isn't "truthy".`,e.OP_RETURN="Error when executed.",e.OP_TOALTSTACK="Pop the top item from the stack and push it onto the alternate stack.",e.OP_FROMALTSTACK="Pop the top item from the alternate stack and push it onto the stack.",e.OP_2DROP="Pop the top 2 items from the stack and discard them.",e.OP_2DUP="Duplicate the top 2 items on the stack. (E.g. [a, b] -> [a, b, a, b])",e.OP_3DUP="Duplicate the top 3 items on the stack. (E.g. [a, b, c] -> [a, b, c, a, b, c])",e.OP_2OVER="Duplicate the 2 items beginning at a depth of 2 on the stack. (E.g. [a, b, c, d] -> [a, b, c, d, a, b])",e.OP_2ROT="Rotate the top 6 items on the stack, bringing the fifth and sixth items to the top. (E.g. [a, b, c, d, e, f] -> [c, d, e, f, a, b])",e.OP_2SWAP="Swap the positions of the top two pairs of items on the stack. (E.g. [a, b, c, d] -> [c, d, a, b])",e.OP_IFDUP='If the top item on the stack is "truthy", duplicate it.',e.OP_DEPTH="Push the current number of stack items as a VM Number.",e.OP_DROP="Pop the top item from the stack and discard it. (E.g. [a] -> [])",e.OP_DUP="Duplicate the top item on the stack. (E.g. [a] -> [a, a])",e.OP_NIP="Remove the second-to-top item from the stack. (E.g. [a, b] -> [b])",e.OP_OVER="Duplicate the second-to-top item on the stack. (E.g. [a, b] -> [a, b, a])",e.OP_PICK="Pop the top item from the stack as a VM Number. Duplicate the item at that depth (zero-indexed), placing it on top of the stack. (E.g. [a, b, c, 2] -> [a, b, c, a])",e.OP_ROLL="Pop the top item from the stack as a VM Number. Move the item at that depth (zero-indexed) to the top of the stack. (E.g. [a, b, c, 2] -> [b, c, a])",e.OP_ROT="Rotate the top 3 items on the stack, bringing the third item to the top. (E.g. [a, b, c] -> [b, c, a])",e.OP_SWAP="Swap the top two items on the stack. (E.g. [a, b] -> [b, a])",e.OP_TUCK="Duplicate the item at the top of the stack, inserting it below the second-to-top item. (E.g. [a, b] -> [b, a, b])",e.OP_CAT="Pop the top 2 items from the stack and concatenate them, pushing the result.",e.OP_SPLIT="Pop the top item from the stack as an index (VM Number) and the next item as a byte array. Split the byte array into two stack items at the index (zero-based), pushing the results.",e.OP_NUM2BIN="Pop the top item from the stack as an item length (VM Number) and the next item as a VM Number (without encoding restrictions). Re-encode the number using a byte array of the provided length, filling any unused bytes with zeros, then push the result. (If the requested length is too short to encode the number, error.)",e.OP_BIN2NUM="Pop the top item from the stack as a VM Number without encoding restrictions. Minimally-encode the number and push the result. (If the number can't be encoded in 4 bytes or less, error.)",e.OP_SIZE="Push the byte-length of the top stack item as a VM Number.",e.OP_INVERT="Error, even when found in an unexecuted conditional branch. (Historically, this flipped all the bits in a stack item.)",e.OP_AND="Pop the top 2 items from the stack and perform a bitwise AND on each byte, pushing the result. If the length of the items are not equal, error.",e.OP_OR="Pop the top 2 items from the stack and perform a bitwise OR on each byte, pushing the result. If the length of the items are not equal, error.",e.OP_XOR="Pop the top 2 items from the stack and perform a bitwise XOR on each byte, pushing the result. If the length of the items are not equal, error.",e.OP_EQUAL="Pop the top two items from the stack and compare them byte-by-byte. If they are the same, push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_EQUALVERIFY="Pop the top two items from the stack and compare them byte-by-byte. If the values are different, error. (This operation is a combination of OP_EQUAL followed by OP_VERIFY.)",e.OP_RESERVED1="Error unless found in an unexecuted conditional branch. Note: OP_RESERVED1 counts toward the opcode limit.",e.OP_RESERVED2="Error unless found in an unexecuted conditional branch. Note: OP_RESERVED2 counts toward the opcode limit.",e.OP_1ADD="Pop the top item from the stack as a VM Number, add 1, then push the result.",e.OP_1SUB="Pop the top item from the stack as a VM Number, subtract 1, then push the result.",e.OP_2MUL="Error, even when found in an unexecuted conditional branch. (Historically, this multiplied a VM Number by 2.)",e.OP_2DIV="Error, even when found in an unexecuted conditional branch. (Historically, this divided a VM Number by 2.)",e.OP_NEGATE="Pop the top item from the stack as a VM Number, negate it, then push the result.",e.OP_ABS="Pop the top item from the stack as a VM Number, take its absolute value, then push the result.",e.OP_NOT="Pop the top item from the stack as a VM Number. If its value is 0, push a 1 (VM Number), otherwise, push a 0 (VM Number).",e.OP_0NOTEQUAL="Pop the top item from the stack as a VM Number. If its value is not 0, push a 1 (VM Number), otherwise, push a 0 (VM Number).",e.OP_ADD="Pop the top two items from the stack as VM Numbers. Add them, then push the result.",e.OP_SUB="Pop the top two items from the stack as VM Numbers. Subtract the top item from the second item, then push the result.",e.OP_MUL="Pop the top two items from the stack as VM Numbers. Multiply them, then push the result.",e.OP_DIV="Pop the top item from the stack as a denominator (VM Number) and the next as a numerator (VM Number). Divide and push the result to the stack.",e.OP_MOD="Pop the top item from the stack as a denominator (VM Number) and the next as a numerator (VM Number). Divide and push the remainder to the stack.",e.OP_LSHIFT="Error, even when found in an unexecuted conditional branch. (Historically, this performed a sign-preserving, left bit shift.)",e.OP_RSHIFT="Error, even when found in an unexecuted conditional branch. (Historically, this performed a sign-preserving, right bit shift.)",e.OP_BOOLAND="Pop the top two items from the stack as VM Numbers. If neither value is a 0 (VM Number), push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_BOOLOR="Pop the top two items from the stack as VM Numbers. If either value is a 1 (VM Number), push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_NUMEQUAL="Pop the top two items from the stack as VM Numbers. If the values are equal, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_NUMEQUALVERIFY="Pop the top two items from the stack as VM Numbers. If the values are different, error. (This operation is a combination of OP_NUMEQUAL followed by OP_VERIFY.)",e.OP_NUMNOTEQUAL="Pop the top two items from the stack as VM Numbers. If the values are not equal, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_LESSTHAN="Pop the top two items from the stack as VM Numbers. If the second item is less than top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_GREATERTHAN="Pop the top two items from the stack as VM Numbers. If the second item is greater than top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_LESSTHANOREQUAL="Pop the top two items from the stack as VM Numbers. If the second item is less than or equal to the top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_GREATERTHANOREQUAL="Pop the top two items from the stack as VM Numbers. If the second item is greater than or equal to the top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_MIN="Pop the top two items from the stack as VM Numbers. Push the smaller of the two numbers.",e.OP_MAX="Pop the top two items from the stack as VM Numbers. Push the larger of the two numbers.",e.OP_WITHIN="Pop the top three items from the stack as VM Numbers. If the top number is within the range defined by the following two numbers (left-inclusive), push a 1 (VM Number). Otherwise, push a 0 (VM Number). (E.g. for [a, b, c]: if (b <= a), and (a < c), [1]. Else [0].)",e.OP_RIPEMD160="Pop the top item from the stack and pass it through ripemd160, pushing the result onto the stack.",e.OP_SHA1="Pop the top item from the stack and pass it through sha1, pushing the result onto the stack.",e.OP_SHA256="Pop the top item from the stack and pass it through sha256, pushing the result onto the stack.",e.OP_HASH160="Pop the top item from the stack and pass it through sha256, then ripemd160, pushing the result onto the stack.",e.OP_HASH256="Pop the top item from the stack and pass it through sha256 twice, pushing the result onto the stack.",e.OP_CODESEPARATOR="Update the value of lastCodeSeparator to the instruction pointer's current value. (This reduces the coverage of signing serializations used in signature verification operations.)",e.OP_CHECKSIG="Pop the top two items from the stack. Treat the top as a signature and the second as a public key. If the signature is valid, push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_CHECKSIGVERIFY="Pop the top two items from the stack. Treat the top as a signature and the second as a public key. If the signature is not valid, error. (This operation is a combination of OP_CHECKSIG followed by OP_VERIFY.)",e.OP_CHECKMULTISIG="Pop items from the stack: first pop the VM Number of public keys, then pop each of those public keys. Next, pop the VM Number of required signatures, then pop each of those signatures. Finally, pop a final VM Number that must be 0 due to a protocol bug. Checking each signature against each public key in order, if all signatures are valid \u2013 and the required number of signatures have been provided \u2013 push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_CHECKMULTISIGVERIFY="Pop items from the stack: first pop the VM Number of public keys, then pop each of those public keys. Next, pop the VM Number of required signatures, then pop each of those signatures. Finally, (due to a protocol bug) pop an unused final VM Number that must be 0. Checking each signature against each public key in order, if any signatures are invalid \u2013 or the required number of signatures have not been provided \u2013 error. (This operation is a combination of OP_CHECKMULTISIG followed by OP_VERIFY.)",e.OP_NOP1="No operation (reserved for future expansion). Note: OP_NOP1 counts toward the opcode limit.",e.OP_CHECKLOCKTIMEVERIFY="Verify the transaction occurs after an absolute block time or height: read the top item on the stack as a VM Number (without removing it), and compare it to the transaction's locktime. If the required locktime has not passed, or if locktime has been disabled for this input by a maximized sequence number, error.",e.OP_CHECKSEQUENCEVERIFY=`Verify the transaction occurs after the output being spent has "aged" by a relative block time or block height since it was created: read the top item on the stack as a VM Number (without removing it), and compare it to the age encoded in the input's sequence number. If the required relative locktime has not passed, or if relative locktime has been disabled by the sequence number or the transaction version, error.`,e.OP_NOP4="No operation (reserved for future expansion). Note: OP_NOP4 counts toward the opcode limit.",e.OP_NOP6="No operation (reserved for future expansion). Note: OP_NOP6 counts toward the opcode limit.",e.OP_NOP5="No operation (reserved for future expansion). Note: OP_NOP5 counts toward the opcode limit.",e.OP_NOP7="No operation (reserved for future expansion). Note: OP_NOP7 counts toward the opcode limit.",e.OP_NOP8="No operation (reserved for future expansion). Note: OP_NOP8 counts toward the opcode limit.",e.OP_NOP9="No operation (reserved for future expansion). Note: OP_NOP9 counts toward the opcode limit.",e.OP_NOP10="No operation (reserved for future expansion). Note: OP_NOP10 counts toward the opcode limit.",e.OP_CHECKDATASIG="Pop the top 3 items from the stack. Treat the top as a public key, the second as a message, and the third as a signature. If the signature is valid, push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_CHECKDATASIGVERIFY="Pop the top 3 items from the stack. Treat the top as a public key, the second as a message, and the third as a signature. If the signature is not valid, error. (This operation is a combination of OP_CHECKDATASIG followed by OP_VERIFY.)",e.OP_REVERSEBYTES="Pop the top item from the stack and reverse it, pushing the result."})(ns||(ns={}));var De;(function(e){e[e.allOutputs=1]="allOutputs",e[e.noOutputs=2]="noOutputs",e[e.correspondingOutput=3]="correspondingOutput",e[e.utxos=32]="utxos",e[e.forkId=64]="forkId",e[e.singleInput=128]="singleInput"})(De||(De={}));var pn;(function(e){e[e.allOutputs=65]="allOutputs",e[e.allOutputsAllUtxos=97]="allOutputsAllUtxos",e[e.allOutputsSingleInput=193]="allOutputsSingleInput",e[e.correspondingOutput=67]="correspondingOutput",e[e.correspondingOutputAllUtxos=99]="correspondingOutputAllUtxos",e[e.correspondingOutputSingleInput=195]="correspondingOutputSingleInput",e[e.noOutputs=66]="noOutputs",e[e.noOutputsAllUtxos=98]="noOutputsAllUtxos",e[e.noOutputsSingleInput=194]="noOutputsSingleInput"})(pn||(pn={}));var ve=pn,os=(e,A)=>(e[0]&A)!==0,ss=(e,A)=>(e[0]&31)===A,gs=e=>os(e,De.singleInput),mn=e=>ss(e,De.correspondingOutput),Is=e=>ss(e,De.noOutputs),Yc=e=>os(e,De.utxos),Ar=()=>new Uint8Array(32).fill(0),xc=({signingSerializationType:e,transactionOutpoints:A},a=q)=>gs(e)?Ar():pe(A,a),Oc=({signingSerializationType:e,transactionUtxos:A},a=q)=>Yc(e)?pe(A,a):Uint8Array.of(),Rc=({signingSerializationType:e,transactionSequenceNumbers:A},a=q)=>!gs(e)&&!mn(e)&&!Is(e)?pe(A,a):Ar(),Fc=({correspondingOutput:e,signingSerializationType:A,transactionOutputs:a},r=q)=>!mn(A)&&!Is(A)?pe(a,r):mn(A)?e===void 0?Ar():pe(e,r):Ar(),Kc=({correspondingOutput:e,coveredBytecode:A,forkId:a=new Uint8Array([0,0,0]),locktime:r,outpointIndex:n,outpointTransactionHash:i,outputTokenPrefix:t,outputValue:o,sequenceNumber:s,signingSerializationType:g,transactionOutpoints:l,transactionOutputs:I,transactionSequenceNumbers:E,transactionUtxos:u,version:k},U=q)=>ee([de(k),xc({signingSerializationType:g,transactionOutpoints:l},U),Oc({signingSerializationType:g,transactionUtxos:u},U),Rc({signingSerializationType:g,transactionSequenceNumbers:E},U),i.slice().reverse(),de(n),t,IA(BigInt(A.length)),A,o,de(s),Fc({correspondingOutput:e,signingSerializationType:g,transactionOutputs:I},U),de(r),g,a]),tr=e=>({correspondingOutput:e.inputIndex<e.transaction.outputs.length?St(e.transaction.outputs[e.inputIndex]):void 0,locktime:e.transaction.locktime,outpointIndex:e.transaction.inputs[e.inputIndex].outpointIndex,outpointTransactionHash:e.transaction.inputs[e.inputIndex].outpointTransactionHash,outputTokenPrefix:fa(e.sourceOutputs[e.inputIndex].token),outputValue:Qt(e.sourceOutputs[e.inputIndex].valueSatoshis),sequenceNumber:e.transaction.inputs[e.inputIndex].sequenceNumber,transactionOutpoints:Ca(e.transaction.inputs),transactionOutputs:bt(e.transaction.outputs),transactionSequenceNumbers:Pa(e.transaction.inputs),transactionUtxos:bt(e.sourceOutputs),version:e.transaction.version}),cA=(e,{coveredBytecode:A,signingSerializationType:a},r=q)=>Kc({...tr(e),coveredBytecode:A,signingSerializationType:a},r),EB=e=>(((e>>8^57005|16711680)<<8|e&255)&De.forkId)===0;var ae;(function(e){e[e.maximumBytecodeLength=1e4]="maximumBytecodeLength",e[e.maximumDataCarrierBytes=223]="maximumDataCarrierBytes",e[e.maximumOperationCount=201]="maximumOperationCount",e[e.maximumStackDepth=1e3]="maximumStackDepth",e[e.maximumStackItemLength=520]="maximumStackItemLength",e[e.maximumStandardVersion=2]="maximumStandardVersion",e[e.maximumStandardUnlockingBytecodeLength=1650]="maximumStandardUnlockingBytecodeLength",e[e.minimumTransactionSize=100]="minimumTransactionSize",e[e.maximumStandardTransactionSize=1e5]="maximumStandardTransactionSize",e[e.maximumTransactionSize=1e6]="maximumTransactionSize",e[e.maximumVmNumberLength=8]="maximumVmNumberLength",e.minVmNumber="-9223372036854775807",e.maxVmNumber="9223372036854775807",e[e.schnorrSignatureLength=64]="schnorrSignatureLength"})(ae||(ae={}));var Mc=[ve.allOutputs,ve.allOutputsSingleInput,ve.correspondingOutput,ve.correspondingOutputSingleInput,ve.noOutputs,ve.noOutputsSingleInput],Sa=Mc,re=ae;var v;(function(e){e.calledReserved="Program called an unassigned, reserved operation.",e.calledReturn="Program called an OP_RETURN operation.",e.calledUpgradableNop="Program called a disallowed upgradable non-operation (OP_NOP1-OP_NOP10).",e.checkSequenceUnavailable="Program called an OP_CHECKSEQUENCEVERIFY operation, but OP_CHECKSEQUENCEVERIFY requires transaction version 2 or higher.",e.disabledOpcode="Program contains a disabled opcode.",e.divisionByZero="Program attempted to divide a number by zero.",e.emptyAlternateStack="Tried to read from an empty alternate stack.",e.emptyStack="Tried to read from an empty stack.",e.exceededMaximumBytecodeLengthLocking="The provided locking bytecode exceeds the maximum bytecode length (10,000 bytes).",e.exceededMaximumBytecodeLengthUnlocking="The provided unlocking bytecode exceeds the maximum bytecode length (10,000 bytes).",e.exceededMaximumVmNumberLength="Program attempted an OP_BIN2NUM operation on a byte sequence that cannot be encoded within the maximum VM Number length.",e.exceededMaximumStackDepth="Program exceeded the maximum stack depth (1,000 items).",e.exceededMaximumStackItemLength="Program attempted to push a stack item that exceeded the maximum stack item length (520 bytes).",e.exceededMaximumOperationCount="Program exceeded the maximum operation count (201 operations).",e.exceedsMaximumMultisigPublicKeyCount="Program called an OP_CHECKMULTISIG that exceeds the maximum public key count (20 public keys).",e.failedVerify="Program failed an OP_VERIFY operation.",e.invalidStackIndex="Tried to read from an invalid stack index.",e.incompatibleLocktimeType="Program called an OP_CHECKLOCKTIMEVERIFY operation with an incompatible locktime type. The transaction locktime and required locktime must both refer to either a block height or a block time.",e.incompatibleSequenceType="Program called an OP_CHECKSEQUENCEVERIFY operation with an incompatible sequence type flag. The input sequence number and required sequence number must both use the same sequence locktime type.",e.insufficientLength="Program called an OP_NUM2BIN operation with an insufficient byte length to re-encode the provided number.",e.insufficientPublicKeys="Program called an OP_CHECKMULTISIG operation that requires signatures from more public keys than are provided.",e.invalidNaturalNumber="Invalid input: the key/signature count inputs for OP_CHECKMULTISIG require a natural number (n > 0).",e.invalidProtocolBugValue='The OP_CHECKMULTISIG protocol bug value must be a VM Number 0 (to comply with the "NULLDUMMY" rule).',e.invalidPublicKeyEncoding="Encountered an improperly encoded public key.",e.invalidVmNumber="Invalid input: this operation requires a valid VM Number.",e.invalidSignatureEncoding="Encountered an improperly encoded signature.",e.invalidSplitIndex="Program called an OP_SPLIT operation with an invalid index.",e.invalidTransactionInputIndex="Program attempted to read from an invalid transaction input index.",e.invalidTransactionOutputIndex="Program attempted to read from an invalid transaction output index.",e.invalidTransactionUtxoIndex="Program attempted to read from an invalid transaction UTXO index.",e.locktimeDisabled="Program called an OP_CHECKLOCKTIMEVERIFY operation, but locktime is disabled for this transaction.",e.mismatchedBitwiseOperandLength="Program attempted a bitwise operation on operands of different lengths.",e.malformedLockingBytecode="The provided locking bytecode is malformed.",e.malformedP2shBytecode="Redeem bytecode was malformed prior to P2SH evaluation.",e.malformedPush="Program must be long enough to push the requested number of bytes.",e.malformedUnlockingBytecode="The provided unlocking bytecode is malformed.",e.negativeLocktime="Program called an OP_CHECKLOCKTIMEVERIFY or OP_CHECKSEQUENCEVERIFY operation with a negative locktime.",e.nonEmptyControlStack="The active bytecode completed with a non-empty control stack (missing `OP_ENDIF`).",e.nonMinimalPush="Push operations must use the smallest possible encoding.",e.nonNullSignatureFailure='Program failed a signature verification with a non-null signature (violating the "NULLFAIL" rule).',e.overflowsVmNumberRange="Program attempted an arithmetic operation which exceeds the range of VM Numbers.",e.requiresCleanStack="Program completed with an unexpected number of items on the stack (must be exactly 1).",e.requiresPushOnly="Unlocking bytecode may contain only push operations.",e.schnorrSizedSignatureInCheckMultiSig="Program used a schnorr-sized signature (65 bytes) in an OP_CHECKMULTISIG operation.",e.unexpectedElse="Encountered an OP_ELSE outside of an OP_IF ... OP_ENDIF block.",e.unexpectedEndIf="Encountered an OP_ENDIF that is not following a matching OP_IF.",e.unknownOpcode="Called an unknown opcode.",e.unmatchedSequenceDisable="Program called an OP_CHECKSEQUENCEVERIFY operation requiring the disable flag, but the input's sequence number is missing the disable flag.",e.unsatisfiedLocktime="Program called an OP_CHECKLOCKTIMEVERIFY operation that requires a locktime greater than the transaction's locktime.",e.unsatisfiedSequenceNumber="Program called an OP_CHECKSEQUENCEVERIFY operation that requires a sequence number greater than the input's sequence number.",e.unsuccessfulEvaluation="Unsuccessful evaluation: completed with a non-truthy value on top of the stack."})(v||(v={}));var w=(e,A,a)=>({...e,error:e.error??R(A,a)});var Q;(function(e){e[e.OP_0=0]="OP_0",e[e.OP_PUSHBYTES_1=1]="OP_PUSHBYTES_1",e[e.OP_PUSHBYTES_2=2]="OP_PUSHBYTES_2",e[e.OP_PUSHBYTES_3=3]="OP_PUSHBYTES_3",e[e.OP_PUSHBYTES_4=4]="OP_PUSHBYTES_4",e[e.OP_PUSHBYTES_5=5]="OP_PUSHBYTES_5",e[e.OP_PUSHBYTES_6=6]="OP_PUSHBYTES_6",e[e.OP_PUSHBYTES_7=7]="OP_PUSHBYTES_7",e[e.OP_PUSHBYTES_8=8]="OP_PUSHBYTES_8",e[e.OP_PUSHBYTES_9=9]="OP_PUSHBYTES_9",e[e.OP_PUSHBYTES_10=10]="OP_PUSHBYTES_10",e[e.OP_PUSHBYTES_11=11]="OP_PUSHBYTES_11",e[e.OP_PUSHBYTES_12=12]="OP_PUSHBYTES_12",e[e.OP_PUSHBYTES_13=13]="OP_PUSHBYTES_13",e[e.OP_PUSHBYTES_14=14]="OP_PUSHBYTES_14",e[e.OP_PUSHBYTES_15=15]="OP_PUSHBYTES_15",e[e.OP_PUSHBYTES_16=16]="OP_PUSHBYTES_16",e[e.OP_PUSHBYTES_17=17]="OP_PUSHBYTES_17",e[e.OP_PUSHBYTES_18=18]="OP_PUSHBYTES_18",e[e.OP_PUSHBYTES_19=19]="OP_PUSHBYTES_19",e[e.OP_PUSHBYTES_20=20]="OP_PUSHBYTES_20",e[e.OP_PUSHBYTES_21=21]="OP_PUSHBYTES_21",e[e.OP_PUSHBYTES_22=22]="OP_PUSHBYTES_22",e[e.OP_PUSHBYTES_23=23]="OP_PUSHBYTES_23",e[e.OP_PUSHBYTES_24=24]="OP_PUSHBYTES_24",e[e.OP_PUSHBYTES_25=25]="OP_PUSHBYTES_25",e[e.OP_PUSHBYTES_26=26]="OP_PUSHBYTES_26",e[e.OP_PUSHBYTES_27=27]="OP_PUSHBYTES_27",e[e.OP_PUSHBYTES_28=28]="OP_PUSHBYTES_28",e[e.OP_PUSHBYTES_29=29]="OP_PUSHBYTES_29",e[e.OP_PUSHBYTES_30=30]="OP_PUSHBYTES_30",e[e.OP_PUSHBYTES_31=31]="OP_PUSHBYTES_31",e[e.OP_PUSHBYTES_32=32]="OP_PUSHBYTES_32",e[e.OP_PUSHBYTES_33=33]="OP_PUSHBYTES_33",e[e.OP_PUSHBYTES_34=34]="OP_PUSHBYTES_34",e[e.OP_PUSHBYTES_35=35]="OP_PUSHBYTES_35",e[e.OP_PUSHBYTES_36=36]="OP_PUSHBYTES_36",e[e.OP_PUSHBYTES_37=37]="OP_PUSHBYTES_37",e[e.OP_PUSHBYTES_38=38]="OP_PUSHBYTES_38",e[e.OP_PUSHBYTES_39=39]="OP_PUSHBYTES_39",e[e.OP_PUSHBYTES_40=40]="OP_PUSHBYTES_40",e[e.OP_PUSHBYTES_41=41]="OP_PUSHBYTES_41",e[e.OP_PUSHBYTES_42=42]="OP_PUSHBYTES_42",e[e.OP_PUSHBYTES_43=43]="OP_PUSHBYTES_43",e[e.OP_PUSHBYTES_44=44]="OP_PUSHBYTES_44",e[e.OP_PUSHBYTES_45=45]="OP_PUSHBYTES_45",e[e.OP_PUSHBYTES_46=46]="OP_PUSHBYTES_46",e[e.OP_PUSHBYTES_47=47]="OP_PUSHBYTES_47",e[e.OP_PUSHBYTES_48=48]="OP_PUSHBYTES_48",e[e.OP_PUSHBYTES_49=49]="OP_PUSHBYTES_49",e[e.OP_PUSHBYTES_50=50]="OP_PUSHBYTES_50",e[e.OP_PUSHBYTES_51=51]="OP_PUSHBYTES_51",e[e.OP_PUSHBYTES_52=52]="OP_PUSHBYTES_52",e[e.OP_PUSHBYTES_53=53]="OP_PUSHBYTES_53",e[e.OP_PUSHBYTES_54=54]="OP_PUSHBYTES_54",e[e.OP_PUSHBYTES_55=55]="OP_PUSHBYTES_55",e[e.OP_PUSHBYTES_56=56]="OP_PUSHBYTES_56",e[e.OP_PUSHBYTES_57=57]="OP_PUSHBYTES_57",e[e.OP_PUSHBYTES_58=58]="OP_PUSHBYTES_58",e[e.OP_PUSHBYTES_59=59]="OP_PUSHBYTES_59",e[e.OP_PUSHBYTES_60=60]="OP_PUSHBYTES_60",e[e.OP_PUSHBYTES_61=61]="OP_PUSHBYTES_61",e[e.OP_PUSHBYTES_62=62]="OP_PUSHBYTES_62",e[e.OP_PUSHBYTES_63=63]="OP_PUSHBYTES_63",e[e.OP_PUSHBYTES_64=64]="OP_PUSHBYTES_64",e[e.OP_PUSHBYTES_65=65]="OP_PUSHBYTES_65",e[e.OP_PUSHBYTES_66=66]="OP_PUSHBYTES_66",e[e.OP_PUSHBYTES_67=67]="OP_PUSHBYTES_67",e[e.OP_PUSHBYTES_68=68]="OP_PUSHBYTES_68",e[e.OP_PUSHBYTES_69=69]="OP_PUSHBYTES_69",e[e.OP_PUSHBYTES_70=70]="OP_PUSHBYTES_70",e[e.OP_PUSHBYTES_71=71]="OP_PUSHBYTES_71",e[e.OP_PUSHBYTES_72=72]="OP_PUSHBYTES_72",e[e.OP_PUSHBYTES_73=73]="OP_PUSHBYTES_73",e[e.OP_PUSHBYTES_74=74]="OP_PUSHBYTES_74",e[e.OP_PUSHBYTES_75=75]="OP_PUSHBYTES_75",e[e.OP_PUSHDATA_1=76]="OP_PUSHDATA_1",e[e.OP_PUSHDATA_2=77]="OP_PUSHDATA_2",e[e.OP_PUSHDATA_4=78]="OP_PUSHDATA_4",e[e.OP_1NEGATE=79]="OP_1NEGATE",e[e.OP_RESERVED=80]="OP_RESERVED",e[e.OP_1=81]="OP_1",e[e.OP_2=82]="OP_2",e[e.OP_3=83]="OP_3",e[e.OP_4=84]="OP_4",e[e.OP_5=85]="OP_5",e[e.OP_6=86]="OP_6",e[e.OP_7=87]="OP_7",e[e.OP_8=88]="OP_8",e[e.OP_9=89]="OP_9",e[e.OP_10=90]="OP_10",e[e.OP_11=91]="OP_11",e[e.OP_12=92]="OP_12",e[e.OP_13=93]="OP_13",e[e.OP_14=94]="OP_14",e[e.OP_15=95]="OP_15",e[e.OP_16=96]="OP_16",e[e.OP_NOP=97]="OP_NOP",e[e.OP_VER=98]="OP_VER",e[e.OP_IF=99]="OP_IF",e[e.OP_NOTIF=100]="OP_NOTIF",e[e.OP_VERIF=101]="OP_VERIF",e[e.OP_VERNOTIF=102]="OP_VERNOTIF",e[e.OP_ELSE=103]="OP_ELSE",e[e.OP_ENDIF=104]="OP_ENDIF",e[e.OP_VERIFY=105]="OP_VERIFY",e[e.OP_RETURN=106]="OP_RETURN",e[e.OP_TOALTSTACK=107]="OP_TOALTSTACK",e[e.OP_FROMALTSTACK=108]="OP_FROMALTSTACK",e[e.OP_2DROP=109]="OP_2DROP",e[e.OP_2DUP=110]="OP_2DUP",e[e.OP_3DUP=111]="OP_3DUP",e[e.OP_2OVER=112]="OP_2OVER",e[e.OP_2ROT=113]="OP_2ROT",e[e.OP_2SWAP=114]="OP_2SWAP",e[e.OP_IFDUP=115]="OP_IFDUP",e[e.OP_DEPTH=116]="OP_DEPTH",e[e.OP_DROP=117]="OP_DROP",e[e.OP_DUP=118]="OP_DUP",e[e.OP_NIP=119]="OP_NIP",e[e.OP_OVER=120]="OP_OVER",e[e.OP_PICK=121]="OP_PICK",e[e.OP_ROLL=122]="OP_ROLL",e[e.OP_ROT=123]="OP_ROT",e[e.OP_SWAP=124]="OP_SWAP",e[e.OP_TUCK=125]="OP_TUCK",e[e.OP_CAT=126]="OP_CAT",e[e.OP_SPLIT=127]="OP_SPLIT",e[e.OP_NUM2BIN=128]="OP_NUM2BIN",e[e.OP_BIN2NUM=129]="OP_BIN2NUM",e[e.OP_SIZE=130]="OP_SIZE",e[e.OP_INVERT=131]="OP_INVERT",e[e.OP_AND=132]="OP_AND",e[e.OP_OR=133]="OP_OR",e[e.OP_XOR=134]="OP_XOR",e[e.OP_EQUAL=135]="OP_EQUAL",e[e.OP_EQUALVERIFY=136]="OP_EQUALVERIFY",e[e.OP_RESERVED1=137]="OP_RESERVED1",e[e.OP_RESERVED2=138]="OP_RESERVED2",e[e.OP_1ADD=139]="OP_1ADD",e[e.OP_1SUB=140]="OP_1SUB",e[e.OP_2MUL=141]="OP_2MUL",e[e.OP_2DIV=142]="OP_2DIV",e[e.OP_NEGATE=143]="OP_NEGATE",e[e.OP_ABS=144]="OP_ABS",e[e.OP_NOT=145]="OP_NOT",e[e.OP_0NOTEQUAL=146]="OP_0NOTEQUAL",e[e.OP_ADD=147]="OP_ADD",e[e.OP_SUB=148]="OP_SUB",e[e.OP_MUL=149]="OP_MUL",e[e.OP_DIV=150]="OP_DIV",e[e.OP_MOD=151]="OP_MOD",e[e.OP_LSHIFT=152]="OP_LSHIFT",e[e.OP_RSHIFT=153]="OP_RSHIFT",e[e.OP_BOOLAND=154]="OP_BOOLAND",e[e.OP_BOOLOR=155]="OP_BOOLOR",e[e.OP_NUMEQUAL=156]="OP_NUMEQUAL",e[e.OP_NUMEQUALVERIFY=157]="OP_NUMEQUALVERIFY",e[e.OP_NUMNOTEQUAL=158]="OP_NUMNOTEQUAL",e[e.OP_LESSTHAN=159]="OP_LESSTHAN",e[e.OP_GREATERTHAN=160]="OP_GREATERTHAN",e[e.OP_LESSTHANOREQUAL=161]="OP_LESSTHANOREQUAL",e[e.OP_GREATERTHANOREQUAL=162]="OP_GREATERTHANOREQUAL",e[e.OP_MIN=163]="OP_MIN",e[e.OP_MAX=164]="OP_MAX",e[e.OP_WITHIN=165]="OP_WITHIN",e[e.OP_RIPEMD160=166]="OP_RIPEMD160",e[e.OP_SHA1=167]="OP_SHA1",e[e.OP_SHA256=168]="OP_SHA256",e[e.OP_HASH160=169]="OP_HASH160",e[e.OP_HASH256=170]="OP_HASH256",e[e.OP_CODESEPARATOR=171]="OP_CODESEPARATOR",e[e.OP_CHECKSIG=172]="OP_CHECKSIG",e[e.OP_CHECKSIGVERIFY=173]="OP_CHECKSIGVERIFY",e[e.OP_CHECKMULTISIG=174]="OP_CHECKMULTISIG",e[e.OP_CHECKMULTISIGVERIFY=175]="OP_CHECKMULTISIGVERIFY",e[e.OP_NOP1=176]="OP_NOP1",e[e.OP_CHECKLOCKTIMEVERIFY=177]="OP_CHECKLOCKTIMEVERIFY",e[e.OP_CHECKSEQUENCEVERIFY=178]="OP_CHECKSEQUENCEVERIFY",e[e.OP_NOP4=179]="OP_NOP4",e[e.OP_NOP5=180]="OP_NOP5",e[e.OP_NOP6=181]="OP_NOP6",e[e.OP_NOP7=182]="OP_NOP7",e[e.OP_NOP8=183]="OP_NOP8",e[e.OP_NOP9=184]="OP_NOP9",e[e.OP_NOP10=185]="OP_NOP10",e[e.OP_CHECKDATASIG=186]="OP_CHECKDATASIG",e[e.OP_CHECKDATASIGVERIFY=187]="OP_CHECKDATASIGVERIFY",e[e.OP_REVERSEBYTES=188]="OP_REVERSEBYTES",e[e.OP_UNKNOWN189=189]="OP_UNKNOWN189",e[e.OP_UNKNOWN190=190]="OP_UNKNOWN190",e[e.OP_UNKNOWN191=191]="OP_UNKNOWN191",e[e.OP_INPUTINDEX=192]="OP_INPUTINDEX",e[e.OP_ACTIVEBYTECODE=193]="OP_ACTIVEBYTECODE",e[e.OP_TXVERSION=194]="OP_TXVERSION",e[e.OP_TXINPUTCOUNT=195]="OP_TXINPUTCOUNT",e[e.OP_TXOUTPUTCOUNT=196]="OP_TXOUTPUTCOUNT",e[e.OP_TXLOCKTIME=197]="OP_TXLOCKTIME",e[e.OP_UTXOVALUE=198]="OP_UTXOVALUE",e[e.OP_UTXOBYTECODE=199]="OP_UTXOBYTECODE",e[e.OP_OUTPOINTTXHASH=200]="OP_OUTPOINTTXHASH",e[e.OP_OUTPOINTINDEX=201]="OP_OUTPOINTINDEX",e[e.OP_INPUTBYTECODE=202]="OP_INPUTBYTECODE",e[e.OP_INPUTSEQUENCENUMBER=203]="OP_INPUTSEQUENCENUMBER",e[e.OP_OUTPUTVALUE=204]="OP_OUTPUTVALUE",e[e.OP_OUTPUTBYTECODE=205]="OP_OUTPUTBYTECODE",e[e.OP_UTXOTOKENCATEGORY=206]="OP_UTXOTOKENCATEGORY",e[e.OP_UTXOTOKENCOMMITMENT=207]="OP_UTXOTOKENCOMMITMENT",e[e.OP_UTXOTOKENAMOUNT=208]="OP_UTXOTOKENAMOUNT",e[e.OP_OUTPUTTOKENCATEGORY=209]="OP_OUTPUTTOKENCATEGORY",e[e.OP_OUTPUTTOKENCOMMITMENT=210]="OP_OUTPUTTOKENCOMMITMENT",e[e.OP_OUTPUTTOKENAMOUNT=211]="OP_OUTPUTTOKENAMOUNT",e[e.OP_UNKNOWN212=212]="OP_UNKNOWN212",e[e.OP_UNKNOWN213=213]="OP_UNKNOWN213",e[e.OP_UNKNOWN214=214]="OP_UNKNOWN214",e[e.OP_UNKNOWN215=215]="OP_UNKNOWN215",e[e.OP_UNKNOWN216=216]="OP_UNKNOWN216",e[e.OP_UNKNOWN217=217]="OP_UNKNOWN217",e[e.OP_UNKNOWN218=218]="OP_UNKNOWN218",e[e.OP_UNKNOWN219=219]="OP_UNKNOWN219",e[e.OP_UNKNOWN220=220]="OP_UNKNOWN220",e[e.OP_UNKNOWN221=221]="OP_UNKNOWN221",e[e.OP_UNKNOWN222=222]="OP_UNKNOWN222",e[e.OP_UNKNOWN223=223]="OP_UNKNOWN223",e[e.OP_UNKNOWN224=224]="OP_UNKNOWN224",e[e.OP_UNKNOWN225=225]="OP_UNKNOWN225",e[e.OP_UNKNOWN226=226]="OP_UNKNOWN226",e[e.OP_UNKNOWN227=227]="OP_UNKNOWN227",e[e.OP_UNKNOWN228=228]="OP_UNKNOWN228",e[e.OP_UNKNOWN229=229]="OP_UNKNOWN229",e[e.OP_UNKNOWN230=230]="OP_UNKNOWN230",e[e.OP_UNKNOWN231=231]="OP_UNKNOWN231",e[e.OP_UNKNOWN232=232]="OP_UNKNOWN232",e[e.OP_UNKNOWN233=233]="OP_UNKNOWN233",e[e.OP_UNKNOWN234=234]="OP_UNKNOWN234",e[e.OP_UNKNOWN235=235]="OP_UNKNOWN235",e[e.OP_UNKNOWN236=236]="OP_UNKNOWN236",e[e.OP_UNKNOWN237=237]="OP_UNKNOWN237",e[e.OP_UNKNOWN238=238]="OP_UNKNOWN238",e[e.OP_UNKNOWN239=239]="OP_UNKNOWN239",e[e.OP_UNKNOWN240=240]="OP_UNKNOWN240",e[e.OP_UNKNOWN241=241]="OP_UNKNOWN241",e[e.OP_UNKNOWN242=242]="OP_UNKNOWN242",e[e.OP_UNKNOWN243=243]="OP_UNKNOWN243",e[e.OP_UNKNOWN244=244]="OP_UNKNOWN244",e[e.OP_UNKNOWN245=245]="OP_UNKNOWN245",e[e.OP_UNKNOWN246=246]="OP_UNKNOWN246",e[e.OP_UNKNOWN247=247]="OP_UNKNOWN247",e[e.OP_UNKNOWN248=248]="OP_UNKNOWN248",e[e.OP_UNKNOWN249=249]="OP_UNKNOWN249",e[e.OP_UNKNOWN250=250]="OP_UNKNOWN250",e[e.OP_UNKNOWN251=251]="OP_UNKNOWN251",e[e.OP_UNKNOWN252=252]="OP_UNKNOWN252",e[e.OP_UNKNOWN253=253]="OP_UNKNOWN253",e[e.OP_UNKNOWN254=254]="OP_UNKNOWN254",e[e.OP_UNKNOWN255=255]="OP_UNKNOWN255"})(Q||(Q={}));var f=Q,cs=f;var kt;(function(e){e[e.OP_0=0]="OP_0",e[e.OP_PUSHBYTES_1=1]="OP_PUSHBYTES_1",e[e.OP_PUSHBYTES_2=2]="OP_PUSHBYTES_2",e[e.OP_PUSHBYTES_3=3]="OP_PUSHBYTES_3",e[e.OP_PUSHBYTES_4=4]="OP_PUSHBYTES_4",e[e.OP_PUSHBYTES_5=5]="OP_PUSHBYTES_5",e[e.OP_PUSHBYTES_6=6]="OP_PUSHBYTES_6",e[e.OP_PUSHBYTES_7=7]="OP_PUSHBYTES_7",e[e.OP_PUSHBYTES_8=8]="OP_PUSHBYTES_8",e[e.OP_PUSHBYTES_9=9]="OP_PUSHBYTES_9",e[e.OP_PUSHBYTES_10=10]="OP_PUSHBYTES_10",e[e.OP_PUSHBYTES_11=11]="OP_PUSHBYTES_11",e[e.OP_PUSHBYTES_12=12]="OP_PUSHBYTES_12",e[e.OP_PUSHBYTES_13=13]="OP_PUSHBYTES_13",e[e.OP_PUSHBYTES_14=14]="OP_PUSHBYTES_14",e[e.OP_PUSHBYTES_15=15]="OP_PUSHBYTES_15",e[e.OP_PUSHBYTES_16=16]="OP_PUSHBYTES_16",e[e.OP_PUSHBYTES_17=17]="OP_PUSHBYTES_17",e[e.OP_PUSHBYTES_18=18]="OP_PUSHBYTES_18",e[e.OP_PUSHBYTES_19=19]="OP_PUSHBYTES_19",e[e.OP_PUSHBYTES_20=20]="OP_PUSHBYTES_20",e[e.OP_PUSHBYTES_21=21]="OP_PUSHBYTES_21",e[e.OP_PUSHBYTES_22=22]="OP_PUSHBYTES_22",e[e.OP_PUSHBYTES_23=23]="OP_PUSHBYTES_23",e[e.OP_PUSHBYTES_24=24]="OP_PUSHBYTES_24",e[e.OP_PUSHBYTES_25=25]="OP_PUSHBYTES_25",e[e.OP_PUSHBYTES_26=26]="OP_PUSHBYTES_26",e[e.OP_PUSHBYTES_27=27]="OP_PUSHBYTES_27",e[e.OP_PUSHBYTES_28=28]="OP_PUSHBYTES_28",e[e.OP_PUSHBYTES_29=29]="OP_PUSHBYTES_29",e[e.OP_PUSHBYTES_30=30]="OP_PUSHBYTES_30",e[e.OP_PUSHBYTES_31=31]="OP_PUSHBYTES_31",e[e.OP_PUSHBYTES_32=32]="OP_PUSHBYTES_32",e[e.OP_PUSHBYTES_33=33]="OP_PUSHBYTES_33",e[e.OP_PUSHBYTES_34=34]="OP_PUSHBYTES_34",e[e.OP_PUSHBYTES_35=35]="OP_PUSHBYTES_35",e[e.OP_PUSHBYTES_36=36]="OP_PUSHBYTES_36",e[e.OP_PUSHBYTES_37=37]="OP_PUSHBYTES_37",e[e.OP_PUSHBYTES_38=38]="OP_PUSHBYTES_38",e[e.OP_PUSHBYTES_39=39]="OP_PUSHBYTES_39",e[e.OP_PUSHBYTES_40=40]="OP_PUSHBYTES_40",e[e.OP_PUSHBYTES_41=41]="OP_PUSHBYTES_41",e[e.OP_PUSHBYTES_42=42]="OP_PUSHBYTES_42",e[e.OP_PUSHBYTES_43=43]="OP_PUSHBYTES_43",e[e.OP_PUSHBYTES_44=44]="OP_PUSHBYTES_44",e[e.OP_PUSHBYTES_45=45]="OP_PUSHBYTES_45",e[e.OP_PUSHBYTES_46=46]="OP_PUSHBYTES_46",e[e.OP_PUSHBYTES_47=47]="OP_PUSHBYTES_47",e[e.OP_PUSHBYTES_48=48]="OP_PUSHBYTES_48",e[e.OP_PUSHBYTES_49=49]="OP_PUSHBYTES_49",e[e.OP_PUSHBYTES_50=50]="OP_PUSHBYTES_50",e[e.OP_PUSHBYTES_51=51]="OP_PUSHBYTES_51",e[e.OP_PUSHBYTES_52=52]="OP_PUSHBYTES_52",e[e.OP_PUSHBYTES_53=53]="OP_PUSHBYTES_53",e[e.OP_PUSHBYTES_54=54]="OP_PUSHBYTES_54",e[e.OP_PUSHBYTES_55=55]="OP_PUSHBYTES_55",e[e.OP_PUSHBYTES_56=56]="OP_PUSHBYTES_56",e[e.OP_PUSHBYTES_57=57]="OP_PUSHBYTES_57",e[e.OP_PUSHBYTES_58=58]="OP_PUSHBYTES_58",e[e.OP_PUSHBYTES_59=59]="OP_PUSHBYTES_59",e[e.OP_PUSHBYTES_60=60]="OP_PUSHBYTES_60",e[e.OP_PUSHBYTES_61=61]="OP_PUSHBYTES_61",e[e.OP_PUSHBYTES_62=62]="OP_PUSHBYTES_62",e[e.OP_PUSHBYTES_63=63]="OP_PUSHBYTES_63",e[e.OP_PUSHBYTES_64=64]="OP_PUSHBYTES_64",e[e.OP_PUSHBYTES_65=65]="OP_PUSHBYTES_65",e[e.OP_PUSHBYTES_66=66]="OP_PUSHBYTES_66",e[e.OP_PUSHBYTES_67=67]="OP_PUSHBYTES_67",e[e.OP_PUSHBYTES_68=68]="OP_PUSHBYTES_68",e[e.OP_PUSHBYTES_69=69]="OP_PUSHBYTES_69",e[e.OP_PUSHBYTES_70=70]="OP_PUSHBYTES_70",e[e.OP_PUSHBYTES_71=71]="OP_PUSHBYTES_71",e[e.OP_PUSHBYTES_72=72]="OP_PUSHBYTES_72",e[e.OP_PUSHBYTES_73=73]="OP_PUSHBYTES_73",e[e.OP_PUSHBYTES_74=74]="OP_PUSHBYTES_74",e[e.OP_PUSHBYTES_75=75]="OP_PUSHBYTES_75",e[e.OP_PUSHDATA_1=76]="OP_PUSHDATA_1",e[e.OP_PUSHDATA_2=77]="OP_PUSHDATA_2",e[e.OP_PUSHDATA_4=78]="OP_PUSHDATA_4",e[e.OP_1NEGATE=79]="OP_1NEGATE",e[e.OP_RESERVED=80]="OP_RESERVED",e[e.OP_1=81]="OP_1",e[e.OP_2=82]="OP_2",e[e.OP_3=83]="OP_3",e[e.OP_4=84]="OP_4",e[e.OP_5=85]="OP_5",e[e.OP_6=86]="OP_6",e[e.OP_7=87]="OP_7",e[e.OP_8=88]="OP_8",e[e.OP_9=89]="OP_9",e[e.OP_10=90]="OP_10",e[e.OP_11=91]="OP_11",e[e.OP_12=92]="OP_12",e[e.OP_13=93]="OP_13",e[e.OP_14=94]="OP_14",e[e.OP_15=95]="OP_15",e[e.OP_16=96]="OP_16",e[e.OP_NOP=97]="OP_NOP",e[e.OP_VER=98]="OP_VER",e[e.OP_IF=99]="OP_IF",e[e.OP_NOTIF=100]="OP_NOTIF",e[e.OP_VERIF=101]="OP_VERIF",e[e.OP_VERNOTIF=102]="OP_VERNOTIF",e[e.OP_ELSE=103]="OP_ELSE",e[e.OP_ENDIF=104]="OP_ENDIF",e[e.OP_VERIFY=105]="OP_VERIFY",e[e.OP_RETURN=106]="OP_RETURN",e[e.OP_TOALTSTACK=107]="OP_TOALTSTACK",e[e.OP_FROMALTSTACK=108]="OP_FROMALTSTACK",e[e.OP_2DROP=109]="OP_2DROP",e[e.OP_2DUP=110]="OP_2DUP",e[e.OP_3DUP=111]="OP_3DUP",e[e.OP_2OVER=112]="OP_2OVER",e[e.OP_2ROT=113]="OP_2ROT",e[e.OP_2SWAP=114]="OP_2SWAP",e[e.OP_IFDUP=115]="OP_IFDUP",e[e.OP_DEPTH=116]="OP_DEPTH",e[e.OP_DROP=117]="OP_DROP",e[e.OP_DUP=118]="OP_DUP",e[e.OP_NIP=119]="OP_NIP",e[e.OP_OVER=120]="OP_OVER",e[e.OP_PICK=121]="OP_PICK",e[e.OP_ROLL=122]="OP_ROLL",e[e.OP_ROT=123]="OP_ROT",e[e.OP_SWAP=124]="OP_SWAP",e[e.OP_TUCK=125]="OP_TUCK",e[e.OP_CAT=126]="OP_CAT",e[e.OP_SUBSTR=127]="OP_SUBSTR",e[e.OP_LEFT=128]="OP_LEFT",e[e.OP_RIGHT=129]="OP_RIGHT",e[e.OP_SIZE=130]="OP_SIZE",e[e.OP_INVERT=131]="OP_INVERT",e[e.OP_AND=132]="OP_AND",e[e.OP_OR=133]="OP_OR",e[e.OP_XOR=134]="OP_XOR",e[e.OP_EQUAL=135]="OP_EQUAL",e[e.OP_EQUALVERIFY=136]="OP_EQUALVERIFY",e[e.OP_RESERVED1=137]="OP_RESERVED1",e[e.OP_RESERVED2=138]="OP_RESERVED2",e[e.OP_1ADD=139]="OP_1ADD",e[e.OP_1SUB=140]="OP_1SUB",e[e.OP_2MUL=141]="OP_2MUL",e[e.OP_2DIV=142]="OP_2DIV",e[e.OP_NEGATE=143]="OP_NEGATE",e[e.OP_ABS=144]="OP_ABS",e[e.OP_NOT=145]="OP_NOT",e[e.OP_0NOTEQUAL=146]="OP_0NOTEQUAL",e[e.OP_ADD=147]="OP_ADD",e[e.OP_SUB=148]="OP_SUB",e[e.OP_MUL=149]="OP_MUL",e[e.OP_DIV=150]="OP_DIV",e[e.OP_MOD=151]="OP_MOD",e[e.OP_LSHIFT=152]="OP_LSHIFT",e[e.OP_RSHIFT=153]="OP_RSHIFT",e[e.OP_BOOLAND=154]="OP_BOOLAND",e[e.OP_BOOLOR=155]="OP_BOOLOR",e[e.OP_NUMEQUAL=156]="OP_NUMEQUAL",e[e.OP_NUMEQUALVERIFY=157]="OP_NUMEQUALVERIFY",e[e.OP_NUMNOTEQUAL=158]="OP_NUMNOTEQUAL",e[e.OP_LESSTHAN=159]="OP_LESSTHAN",e[e.OP_GREATERTHAN=160]="OP_GREATERTHAN",e[e.OP_LESSTHANOREQUAL=161]="OP_LESSTHANOREQUAL",e[e.OP_GREATERTHANOREQUAL=162]="OP_GREATERTHANOREQUAL",e[e.OP_MIN=163]="OP_MIN",e[e.OP_MAX=164]="OP_MAX",e[e.OP_WITHIN=165]="OP_WITHIN",e[e.OP_RIPEMD160=166]="OP_RIPEMD160",e[e.OP_SHA1=167]="OP_SHA1",e[e.OP_SHA256=168]="OP_SHA256",e[e.OP_HASH160=169]="OP_HASH160",e[e.OP_HASH256=170]="OP_HASH256",e[e.OP_CODESEPARATOR=171]="OP_CODESEPARATOR",e[e.OP_CHECKSIG=172]="OP_CHECKSIG",e[e.OP_CHECKSIGVERIFY=173]="OP_CHECKSIGVERIFY",e[e.OP_CHECKMULTISIG=174]="OP_CHECKMULTISIG",e[e.OP_CHECKMULTISIGVERIFY=175]="OP_CHECKMULTISIGVERIFY",e[e.OP_NOP1=176]="OP_NOP1",e[e.OP_CHECKLOCKTIMEVERIFY=177]="OP_CHECKLOCKTIMEVERIFY",e[e.OP_CHECKSEQUENCEVERIFY=178]="OP_CHECKSEQUENCEVERIFY",e[e.OP_NOP4=179]="OP_NOP4",e[e.OP_NOP5=180]="OP_NOP5",e[e.OP_NOP6=181]="OP_NOP6",e[e.OP_NOP7=182]="OP_NOP7",e[e.OP_NOP8=183]="OP_NOP8",e[e.OP_NOP9=184]="OP_NOP9",e[e.OP_NOP10=185]="OP_NOP10",e[e.OP_UNKNOWN186=186]="OP_UNKNOWN186",e[e.OP_UNKNOWN187=187]="OP_UNKNOWN187",e[e.OP_UNKNOWN188=188]="OP_UNKNOWN188",e[e.OP_UNKNOWN189=189]="OP_UNKNOWN189",e[e.OP_UNKNOWN190=190]="OP_UNKNOWN190",e[e.OP_UNKNOWN191=191]="OP_UNKNOWN191",e[e.OP_UNKNOWN192=192]="OP_UNKNOWN192",e[e.OP_UNKNOWN193=193]="OP_UNKNOWN193",e[e.OP_UNKNOWN194=194]="OP_UNKNOWN194",e[e.OP_UNKNOWN195=195]="OP_UNKNOWN195",e[e.OP_UNKNOWN196=196]="OP_UNKNOWN196",e[e.OP_UNKNOWN197=197]="OP_UNKNOWN197",e[e.OP_UNKNOWN198=198]="OP_UNKNOWN198",e[e.OP_UNKNOWN199=199]="OP_UNKNOWN199",e[e.OP_UNKNOWN200=200]="OP_UNKNOWN200",e[e.OP_UNKNOWN201=201]="OP_UNKNOWN201",e[e.OP_UNKNOWN202=202]="OP_UNKNOWN202",e[e.OP_UNKNOWN203=203]="OP_UNKNOWN203",e[e.OP_UNKNOWN204=204]="OP_UNKNOWN204",e[e.OP_UNKNOWN205=205]="OP_UNKNOWN205",e[e.OP_UNKNOWN206=206]="OP_UNKNOWN206",e[e.OP_UNKNOWN207=207]="OP_UNKNOWN207",e[e.OP_UNKNOWN208=208]="OP_UNKNOWN208",e[e.OP_UNKNOWN209=209]="OP_UNKNOWN209",e[e.OP_UNKNOWN210=210]="OP_UNKNOWN210",e[e.OP_UNKNOWN211=211]="OP_UNKNOWN211",e[e.OP_UNKNOWN212=212]="OP_UNKNOWN212",e[e.OP_UNKNOWN213=213]="OP_UNKNOWN213",e[e.OP_UNKNOWN214=214]="OP_UNKNOWN214",e[e.OP_UNKNOWN215=215]="OP_UNKNOWN215",e[e.OP_UNKNOWN216=216]="OP_UNKNOWN216",e[e.OP_UNKNOWN217=217]="OP_UNKNOWN217",e[e.OP_UNKNOWN218=218]="OP_UNKNOWN218",e[e.OP_UNKNOWN219=219]="OP_UNKNOWN219",e[e.OP_UNKNOWN220=220]="OP_UNKNOWN220",e[e.OP_UNKNOWN221=221]="OP_UNKNOWN221",e[e.OP_UNKNOWN222=222]="OP_UNKNOWN222",e[e.OP_UNKNOWN223=223]="OP_UNKNOWN223",e[e.OP_UNKNOWN224=224]="OP_UNKNOWN224",e[e.OP_UNKNOWN225=225]="OP_UNKNOWN225",e[e.OP_UNKNOWN226=226]="OP_UNKNOWN226",e[e.OP_UNKNOWN227=227]="OP_UNKNOWN227",e[e.OP_UNKNOWN228=228]="OP_UNKNOWN228",e[e.OP_UNKNOWN229=229]="OP_UNKNOWN229",e[e.OP_UNKNOWN230=230]="OP_UNKNOWN230",e[e.OP_UNKNOWN231=231]="OP_UNKNOWN231",e[e.OP_UNKNOWN232=232]="OP_UNKNOWN232",e[e.OP_UNKNOWN233=233]="OP_UNKNOWN233",e[e.OP_UNKNOWN234=234]="OP_UNKNOWN234",e[e.OP_UNKNOWN235=235]="OP_UNKNOWN235",e[e.OP_UNKNOWN236=236]="OP_UNKNOWN236",e[e.OP_UNKNOWN237=237]="OP_UNKNOWN237",e[e.OP_UNKNOWN238=238]="OP_UNKNOWN238",e[e.OP_UNKNOWN239=239]="OP_UNKNOWN239",e[e.OP_UNKNOWN240=240]="OP_UNKNOWN240",e[e.OP_UNKNOWN241=241]="OP_UNKNOWN241",e[e.OP_UNKNOWN242=242]="OP_UNKNOWN242",e[e.OP_UNKNOWN243=243]="OP_UNKNOWN243",e[e.OP_UNKNOWN244=244]="OP_UNKNOWN244",e[e.OP_UNKNOWN245=245]="OP_UNKNOWN245",e[e.OP_UNKNOWN246=246]="OP_UNKNOWN246",e[e.OP_UNKNOWN247=247]="OP_UNKNOWN247",e[e.OP_UNKNOWN248=248]="OP_UNKNOWN248",e[e.OP_UNKNOWN249=249]="OP_UNKNOWN249",e[e.OP_SMALLINTEGER=250]="OP_SMALLINTEGER",e[e.OP_PUBKEYS=251]="OP_PUBKEYS",e[e.OP_UNKNOWN252=252]="OP_UNKNOWN252",e[e.OP_PUBKEYHASH=253]="OP_PUBKEYHASH",e[e.OP_PUBKEY=254]="OP_PUBKEY",e[e.OP_INVALIDOPCODE=255]="OP_INVALIDOPCODE"})(kt||(kt={}));var Ut=e=>"malformed"in e,tA=e=>e.length>0&&Ut(e[e.length-1]),ds=e=>e.every(A=>"data"in A),yn=1,fn=2,Gc=4,qc=(e,A)=>{let a=new DataView(e.bin.buffer,e.index,A),r=!0;return A===yn?a.getUint8(0):A===fn?a.getUint16(0,r):a.getUint32(0,r)},Es=e=>({76:yn,77:fn,78:Gc})[e]??0,Hc=e=>{let{bin:A,index:a}=e,r=A[a];if(r>78)return{instruction:{opcode:r},position:{bin:A,index:a+1}};let n=Es(r);if(n!==0&&a+n>=A.length){let s=a+1,g=s+n;return{instruction:{expectedLengthBytes:n,length:A.slice(s,g),malformed:!0,opcode:r},position:{bin:A,index:g}}}let i=n===0?r:qc({bin:A,index:a+1},n),t=a+1+n,o=t+i;return{instruction:{data:A.slice(t,o),...o>A.length?{expectedDataBytes:o-t,malformed:!0}:void 0,opcode:r},position:{bin:A,index:o}}},ir=e=>({..."data"in e?{data:e.data}:{},opcode:e.opcode}),we=e=>{let A=[],a=0;for(;a<e.length;){let{instruction:r,position:n}=Hc({bin:e,index:a});a=n.index,A.push(r)}return A},Jc=e=>e!==0,Qn=e=>e.length>0?`0x${$(e)}`:"",ls=e=>`[missing ${e} byte${e===1?"":"s"}]`,Bs=e=>"length"in e,ar=e=>e>=76,Lc=(e,A)=>`${e[A.opcode]??"OP_UNKNOWN"} ${Bs(A)?`${Qn(A.length)}${ls(A.expectedLengthBytes-A.length.length)}`:`${ar(A.opcode)?`${A.expectedDataBytes} `:""}${Qn(A.data)}${ls(A.expectedDataBytes-A.data.length)}`}`,Vc=(e,A)=>`${e[A.opcode]??"OP_UNKNOWN"}${"data"in A&&Jc(A.opcode)?` ${ar(A.opcode)?`${A.data.length} `:""}${Qn(A.data)}`:""}`,zc=(e,A)=>Ut(A)?Lc(e,A):Vc(e,A),Cn=(e,A)=>A.map(a=>zc(e,a)).join(" "),UB=(e,A)=>Cn(e,we(A)),_B=e=>Cn(f,we(e)),vB=e=>Cn(kt,we(e)),zA=e=>Object.entries(e).filter(A=>typeof A[1]=="number").reduce((A,a)=>({...A,[a[0]]:Uint8Array.of(a[1])}),{}),jc=e=>{let{opcode:A}=e,a=Es(A);return a===yn?Uint8Array.of(e.data.length):a===fn?mt(e.data.length):de(e.data.length)},ps=e=>Uint8Array.from([e.opcode,..."data"in e?[...ar(e.opcode)?jc(e):[],...e.data]:[]]),rr=e=>{let{opcode:A}=e;return Bs(e)?Uint8Array.from([A,...e.length]):ar(A)?Uint8Array.from([A,...A===76?Uint8Array.of(e.expectedDataBytes):A===77?mt(e.expectedDataBytes):de(e.expectedDataBytes),...e.data]):Uint8Array.from([A,...e.data])},Wc=e=>Ut(e)?rr(e):ps(e),iA=e=>ee(e.map(ps)),DB=e=>ee(e.map(Wc)),Nt;(function(e){e.outOfRange="Failed to decode VM Number: overflows VM Number range.",e.requiresMinimal="Failed to decode VM Number: the number is not minimally-encoded."})(Nt||(Nt={}));var nr=e=>e===Nt.outOfRange||e===Nt.requiresMinimal,us=8,_t=(e,{maximumVmNumberByteLength:A=us,requireMinimalEncoding:a=!0}={maximumVmNumberByteLength:us,requireMinimalEncoding:!0})=>{if(e.length===0)return 0n;if(e.length>A)return Nt.outOfRange;let r=e[e.length-1],n=e[e.length-1-1];if(a&&(r&127)===0&&(e.length<=1||(n&128)===0))return Nt.requiresMinimal;let o=8,s=128,g=0n;for(let I=0;I<e.length;I++)g|=BigInt(e[I])<<BigInt(I*o);return(e[e.length-1]&s)!==0?-(g&~(BigInt(s)<<BigInt(o*(e.length-1)))):g},W=e=>{if(e===0n)return new Uint8Array;let A=[],a=e<0,r=255,n=8,i=a?-e:e;for(;i>0;)A.push(Number(i&BigInt(r))),i>>=BigInt(n);let t=128;return(A[A.length-1]&t)>0?A.push(a?t:0):a&&(A[A.length-1]|=t),new Uint8Array(A)},We=e=>{for(let a=0;a<e.length;a++)if(e[a]!==0)return!(a===e.length-1&&e[a]===128);return!1},oe=e=>W(e?1n:0n),Zc=e=>e<=96,bA=e=>we(e).every(a=>Zc(a.opcode)),wB=e=>{let A=we(e);return!tA(A)&&ds(A)},wA=e=>e.length>=1&&e[0]===106&&bA(e.slice(1)),Xc=(e,A)=>{if(e<1n)return 0n;let a=e*A/BigInt(1e3);return a===0n?1n:a},$c=(e,A=BigInt(1e3))=>{let a=e+148;return BigInt(3)*Xc(BigInt(a),A)},Pn=(e,A=BigInt(1e3))=>{if(wA(e.lockingBytecode))return 0n;let a=St(e).length;return $c(a,A)},ms=(e,A=BigInt(1e3))=>e.valueSatoshis<Pn(e,A),el=e=>e.length===65&&e[0]===4,Al=e=>e.length===33&&(e[0]===2||e[0]===3),lA=e=>Al(e)||el(e),hs=e=>e===0?0:e===79?-1:!Number.isInteger(e)||e<81||e>96?!1:e-80,tl=e=>{let A=we(e);if(tA(A))return!1;let a=A.length-1;if(A.length<4||A[a].opcode!==174)return!1;let r=hs(A[0].opcode),n=hs(A[a-1].opcode);if(n===!1||r===!1)return!1;let i=A.slice(1,-2);if(!ds(i))return!1;let t=i.map(o=>o.data);return t.some(o=>!lA(o))?!1:{m:r,n,publicKeys:t}},Qs=e=>{let A=tl(e);if(A===!1)return!1;let{m:a,n:r}=A;return!(r<1||r>3||a<1||a>r)},vt=e=>$a(e)||PA(e)||gn(e)||wA(e)||Qs(e),Sn=e=>$a(e)||PA(e)||ma(e)||gn(e)||wA(e)||Qs(e),Dt=e=>{let A=e.length>=4&&e.length<=42,a=e[0]===0||e[0]>=81&&e[0]<=96,r=e[1]+2===e.length;return A&&a&&r};var Tt=e=>A=>{let a=e(A);return a.operationCount+=1,a},d=e=>A=>A.controlStack.every(a=>a)?e(A):A,Yt=(e,A)=>Object.keys(A).reduce((a,r)=>({...a,[r]:e.reduce((n,i)=>i(n),A[Number(r)])}),{}),te=(e,A)=>{let a=e.stack.pop();return a===void 0?w(e,v.emptyStack):A(e,[a])},be=(e,A)=>te(e,(a,[r])=>te(a,(n,[i])=>A(n,[i,r]))),It=(e,A)=>te(e,(a,[r])=>be(a,(n,[i,t])=>A(n,[i,t,r]))),or=(e,A)=>be(e,(a,[r,n])=>be(a,(i,[t,o])=>A(i,[t,o,r,n]))),ys=(e,A)=>or(e,(a,[r,n,i,t])=>be(a,(o,[s,g])=>A(o,[s,g,r,n,i,t]))),wt=8,X=(e,A,{maximumVmNumberByteLength:a=wt,requireMinimalEncoding:r=!0}={maximumVmNumberByteLength:wt,requireMinimalEncoding:!0})=>te(e,(n,[i])=>{let t=_t(i,{maximumVmNumberByteLength:a,requireMinimalEncoding:r});return nr(t)?w(e,v.invalidVmNumber):A(n,[t])}),ge=(e,A,{maximumVmNumberByteLength:a=wt,requireMinimalEncoding:r=!0}={maximumVmNumberByteLength:wt,requireMinimalEncoding:!0})=>X(e,(n,[i])=>X(n,(t,[o])=>A(t,[o,i]),{maximumVmNumberByteLength:a,requireMinimalEncoding:r}),{maximumVmNumberByteLength:a,requireMinimalEncoding:r}),sr=(e,A,{maximumVmNumberByteLength:a=wt,requireMinimalEncoding:r=!0}={maximumVmNumberByteLength:wt,requireMinimalEncoding:!0})=>ge(e,(n,[i,t])=>X(n,(o,[s])=>A(o,[s,i,t]),{maximumVmNumberByteLength:a,requireMinimalEncoding:r}),{maximumVmNumberByteLength:a,requireMinimalEncoding:r}),M=(e,...A)=>(e.stack.push(...A),e),EA=(e,A,a=ae.maximumStackItemLength)=>A.length>a?w(e,`${v.exceededMaximumStackItemLength} Item length: ${A.length} bytes.`):(e.stack.push(A),e),ba=(e,A)=>M(e,W(A)),Le=(e,A,{minVmNumber:a=BigInt(ae.minVmNumber),maxVmNumber:r=BigInt(ae.maxVmNumber)}={})=>A>r||A<a?w(e,v.overflowsVmNumberRange):ba(e,A),qe=(e,A)=>a=>A(e(a));var me=e=>te(e,(A,[a])=>We(a)?A:w(A,v.failedVerify)),Ye=e=>w(e,v.calledReserved),xt=e=>w(e,v.calledReturn),gr=e=>e.controlStack.every(A=>A)?te(e,(A,[a])=>(A.controlStack.push(We(a)),e)):(e.controlStack.push(!1),e),Ir=e=>e.controlStack.every(A=>A)?te(e,(A,[a])=>(A.controlStack.push(!We(a)),e)):(e.controlStack.push(!1),e),cr=e=>e.controlStack.pop()===void 0?w(e,v.unexpectedEndIf):e,lr=e=>{let A=e.controlStack[e.controlStack.length-1];return A===void 0?w(e,v.unexpectedElse):(e.controlStack[e.controlStack.length-1]=!A,e)};var Ot=e=>X(e,(A,[a])=>Le(A,a+1n)),Rt=e=>X(e,(A,[a])=>M(A,W(a-1n))),Ft=e=>X(e,(A,[a])=>M(A,W(-a))),Kt=e=>X(e,(A,[a])=>M(A,W(a<0?-a:a))),Mt=e=>X(e,(A,[a])=>M(A,a===0n?W(1n):W(0n))),Gt=e=>X(e,(A,[a])=>M(A,a===0n?W(0n):W(1n))),qt=e=>ge(e,(A,[a,r])=>Le(A,a+r)),Ht=e=>ge(e,(A,[a,r])=>M(A,W(a-r))),Jt=e=>ge(e,(A,[a,r])=>M(A,oe(a!==0n&&r!==0n))),Lt=e=>ge(e,(A,[a,r])=>M(A,oe(a!==0n||r!==0n))),ct=e=>ge(e,(A,[a,r])=>M(A,oe(a===r))),Vt=qe(ct,me),zt=e=>ge(e,(A,[a,r])=>M(A,oe(a!==r))),jt=e=>ge(e,(A,[a,r])=>M(A,oe(a<r))),Wt=e=>ge(e,(A,[a,r])=>M(A,oe(a<=r))),Zt=e=>ge(e,(A,[a,r])=>M(A,oe(a>r))),Xt=e=>ge(e,(A,[a,r])=>M(A,oe(a>=r))),$t=e=>ge(e,(A,[a,r])=>M(A,W(a<r?a:r))),ei=e=>ge(e,(A,[a,r])=>M(A,W(a>r?a:r))),Ai=e=>sr(e,(A,[a,r,n])=>M(A,oe(r<=a&&a<n))),ti=e=>ge(e,(A,[a,r])=>Le(A,a*r)),ii=e=>ge(e,(A,[a,r])=>r===0n?w(A,v.divisionByZero):M(A,W(a/r))),ai=e=>ge(e,(A,[a,r])=>r===0n?w(A,v.divisionByZero):M(A,W(a%r)));var lt=e=>be(e,(A,[a,r])=>M(A,oe(tt(a,r)))),ri=qe(lt,me),bn=e=>A=>be(A,(a,[r,n])=>r.length===n.length?M(a,e(r,n)):w(a,v.mismatchedBitwiseOperandLength)),ni=bn((e,A)=>e.map((a,r)=>a&A[r])),oi=bn((e,A)=>e.map((a,r)=>a|A[r])),si=bn((e,A)=>e.map((a,r)=>a^A[r]));var xe=d(e=>w(e,v.unknownOpcode)),rp=e=>A=>{let a=e(A);return a.stack.length+a.alternateStack.length>ae.maximumStackDepth?w(a,v.exceededMaximumStackDepth):a.operationCount>ae.maximumOperationCount?w(a,v.exceededMaximumOperationCount):a},BA=e=>e.map(A=>A.slice()),jA=({program:e,instructions:A,stack:a})=>({alternateStack:[],controlStack:[],instructions:A,ip:0,lastCodeSeparator:-1,operationCount:0,program:e,signatureOperationsCount:0,signedMessages:[],stack:a}),kn=e=>({inputIndex:e.inputIndex,sourceOutputs:En(e.sourceOutputs),transaction:rs(e.transaction)}),il=e=>({...e.error===void 0?{}:{error:e.error},alternateStack:BA(e.alternateStack),controlStack:e.controlStack.slice(),instructions:e.instructions.map(ir),ip:e.ip,lastCodeSeparator:e.lastCodeSeparator,operationCount:e.operationCount,program:kn(e.program),signatureOperationsCount:e.signatureOperationsCount,signedMessages:e.signedMessages.map(A=>({digest:A.digest.slice(),..."serialization"in A?{serialization:A.serialization.slice()}:{message:A.message.slice()}})),stack:BA(e.stack)}),ka=il,np=ka,al=32,op=({sourceOutputs:e,inputs:A,locktime:a,version:r,outputs:n}={})=>({inputIndex:0,sourceOutputs:e||[{lockingBytecode:Uint8Array.from([]),valueSatoshis:0xffffffffffffffffn}],transaction:{inputs:A||[{outpointIndex:0,outpointTransactionHash:new Uint8Array(al).fill(1),sequenceNumber:0,unlockingBytecode:void 0}],locktime:a??0,outputs:n??[{lockingBytecode:Uint8Array.from([]),valueSatoshis:0xffffffffffffffffn}],version:r??0}});var Cs=e=>(e&128)!==0,rl=(e,A,a)=>e>1&&A===0&&!Cs(a),fs=(e,A,a,r)=>e[A]===2&&a!==0&&!Cs(e[r])&&!rl(a,e[r],e[r+1]),Nn=e=>{let A=e.length>8&&e.length<72,a=e[0]===48,r=e[1]===e.length-2,n=e[3];if(n===void 0)return!1;let i=n<=e.length-7,t=fs(e,2,n,4),o=4+n,s=o+1,g=e[s];if(g===void 0)return!1;let l=s+1,I=l+g===e.length,E=fs(e,o,g,l);return A&&a&&r&&i&&t&&I&&E},TA=(e,A)=>e.length===0||A.includes(e[e.length-1])&&(e.length===ae.schnorrSignatureLength+1||Nn(e.slice(0,e.length-1))),YA=e=>({signature:e.slice(0,-1),signingSerializationType:e.slice(-1)});var gi=({ripemd160:e}={ripemd160:Ee})=>A=>te(A,(a,[r])=>M(a,e.hash(r))),Ii=({sha1:e}={sha1:fA})=>A=>te(A,(a,[r])=>M(a,e.hash(r))),ci=({sha256:e}={sha256:q})=>A=>te(A,(a,[r])=>M(a,e.hash(r))),li=({ripemd160:e,sha256:A}={ripemd160:Ee,sha256:q})=>a=>te(a,(r,[n])=>M(r,e.hash(A.hash(n)))),ui=({sha256:e}={sha256:q})=>A=>te(A,(a,[r])=>M(a,pe(r,e))),hi=e=>(e.lastCodeSeparator=e.ip,e),Un=({secp256k1:e,sha256:A}={secp256k1:Ae,sha256:q})=>a=>be(a,(r,[n,i])=>{if(!lA(i))return w(r,v.invalidPublicKeyEncoding);if(!TA(n,Sa))return w(r,v.invalidSignatureEncoding,`Transaction signature (including signing serialization): ${$(n)}`);let t=iA(r.instructions).subarray(r.lastCodeSeparator+1),{signingSerializationType:o,signature:s}=YA(n),g=cA(r.program,{coveredBytecode:t,signingSerializationType:o},A),l=pe(g,A);r.signedMessages.push({digest:l,serialization:g});let E=s.length===ae.schnorrSignatureLength?e.verifySignatureSchnorr(s,i,l):e.verifySignatureDERLowS(s,i,l);return!E&&s.length!==0?w(r,v.nonNullSignatureFailure):M(r,oe(E))}),_n=({secp256k1:e,sha256:A}={secp256k1:Ae,sha256:q})=>a=>X(a,(r,n)=>{let i=Number(n);if(i<0)return w(r,v.invalidNaturalNumber);if(i>20)return w(r,v.exceedsMaximumMultisigPublicKeyCount);let t=i>0?r.stack.splice(-i):[];return r.operationCount+=i,r.operationCount>ae.maximumOperationCount?w(r,v.exceededMaximumOperationCount):X(r,(o,s)=>{let g=Number(s);if(g<0)return w(o,v.invalidNaturalNumber);if(g>i)return w(o,v.insufficientPublicKeys);let l=g>0?o.stack.splice(-g):[];return te(o,(I,[E])=>{if(E.length!==0)return w(I,v.invalidProtocolBugValue);let u=iA(I.instructions).subarray(I.lastCodeSeparator+1),k=0,U=l.length,N=t.length;for(;U>0&&N>0&&k+N>=U&&k!==g;){let B=t[N-1],S=l[U-1];if(!lA(B))return w(I,v.invalidPublicKeyEncoding);if(!TA(S,Sa))return w(I,v.invalidSignatureEncoding,`Transaction signature (including signing serialization type): ${$(S)}`);let{signingSerializationType:P,signature:h}=YA(S),y=cA(r.program,{coveredBytecode:u,signingSerializationType:P},A),p=pe(y,A);if(I.signedMessages.push({digest:p,serialization:y}),h.length===ae.schnorrSignatureLength)return w(I,v.schnorrSizedSignatureInCheckMultiSig);e.verifySignatureDERLowS(h,B,p)&&(k+=1,U-=1),N-=1}let c=k===g;return!c&&!l.every(B=>B.length===0)?w(I,v.nonNullSignatureFailure):M(I,oe(c))})})}),Ps=({secp256k1:e,sha256:A}={secp256k1:Ae,sha256:q})=>qe(Un({secp256k1:e,sha256:A}),me),Ss=({secp256k1:e,sha256:A})=>qe(_n({secp256k1:e,sha256:A}),me),vn=e=>e.length===0||e.length===ae.schnorrSignatureLength||Nn(e),ut=({secp256k1:e,sha256:A})=>a=>It(a,(r,[n,i,t])=>{if(!vn(n))return w(r,v.invalidSignatureEncoding,`Data signature: ${$(n)}`);if(!lA(t))return w(r,v.invalidPublicKeyEncoding);let o=A.hash(i);r.signedMessages.push({digest:o,message:i});let g=n.length===ae.schnorrSignatureLength?e.verifySignatureSchnorr(n,t,o):e.verifySignatureDERLowS(n,t,o);return!g&&n.length!==0?w(r,v.nonNullSignatureFailure):M(r,oe(g))}),di=({secp256k1:e,sha256:A}={secp256k1:Ae,sha256:q})=>qe(ut({secp256k1:e,sha256:A}),me),Ei=e=>te(e,(A,[a])=>M(A,a.slice().reverse()));var Bi=e=>be(e,(A,[a,r])=>EA(A,ee([a,r]))),pi=e=>X(e,(A,a)=>{let r=Number(a);return te(A,(n,[i])=>r<0||r>i.length?w(n,v.invalidSplitIndex):M(n,i.slice(0,r),i.slice(r)))}),Dn=(e,A)=>{let a=0;e.length>0&&(a=e[e.length-1]&128,e[e.length-1]&=127);let r=Array.from(e);for(;r.length<A-1;)r.push(0);return r.push(a),Uint8Array.from(r)},mi=e=>X(e,(A,a)=>{let r=Number(a);return r>ae.maximumStackItemLength?w(A,`${v.exceededMaximumStackItemLength} Item length: ${r} bytes.`):X(A,(n,[i])=>{let t=W(i);return t.length>r?w(n,v.insufficientLength):t.length===r?M(n,t):M(n,Dn(t,r))},{maximumVmNumberByteLength:ae.maximumStackItemLength,requireMinimalEncoding:!1})}),Qi=e=>X(e,(A,[a])=>{let r=W(a);return r.length>ae.maximumVmNumberLength?w(A,v.exceededMaximumVmNumberLength):M(A,r)},{maximumVmNumberByteLength:ae.maximumStackItemLength,requireMinimalEncoding:!1});var yi=e=>Le(e,BigInt(e.program.inputIndex)),fi=e=>EA(e,iA(e.instructions.slice(e.lastCodeSeparator+1))),Ci=e=>Le(e,BigInt(fo(e.program.transaction.version))),Pi=e=>Le(e,BigInt(e.program.transaction.inputs.length)),Si=e=>Le(e,BigInt(e.program.transaction.outputs.length)),bi=e=>Le(e,BigInt(e.program.transaction.locktime)),ki=(e,A)=>X(e,(a,[r])=>{let n=a.program.sourceOutputs[Number(r)];return n===void 0?w(a,v.invalidTransactionUtxoIndex):A(e,[n])}),Ni=e=>ki(e,(A,[a])=>Le(A,a.valueSatoshis)),Ui=e=>ki(e,(A,[a])=>EA(A,a.lockingBytecode.slice())),ur=(e,A)=>X(e,(a,[r])=>{let n=a.program.transaction.inputs[Number(r)];return n===void 0?w(a,v.invalidTransactionInputIndex):A(e,[n])}),_i=e=>ur(e,(A,[a])=>EA(A,a.outpointTransactionHash.slice().reverse())),vi=e=>ur(e,(A,[a])=>Le(A,BigInt(a.outpointIndex))),Di=e=>ur(e,(A,[a])=>EA(A,a.unlockingBytecode.slice())),wi=e=>ur(e,(A,[a])=>Le(A,BigInt(a.sequenceNumber))),Ti=(e,A)=>X(e,(a,[r])=>{let n=a.program.transaction.outputs[Number(r)];return n===void 0?w(a,v.invalidTransactionOutputIndex):A(e,[n])}),Yi=e=>Ti(e,(A,[a])=>Le(A,a.valueSatoshis)),xi=e=>Ti(e,(A,[a])=>EA(A,a.lockingBytecode.slice()));var Ie=e=>e,ue=e=>w(e,v.calledUpgradableNop),Te=e=>w(e,v.unknownOpcode);var Na=e=>e.length<=75?e.length===0?Uint8Array.of(0):e.length===1?e[0]!==0&&e[0]<=16?Uint8Array.of(e[0]+80):e[0]===129?Uint8Array.of(79):Uint8Array.from([1,...e]):Uint8Array.from([e.length,...e]):e.length<=255?Uint8Array.from([76,e.length,...e]):e.length<=65535?Uint8Array.from([77,...mt(e.length),...e]):Uint8Array.from([78,...de(e.length),...e]),wn=(e,A)=>A.length===0?e===0:A.length===1?A[0]>=1&&A[0]<=16?e===A[0]+80:A[0]===129?e===79:!0:A.length<=75?e===A.length:A.length<=255?e===76:A.length<=65535?e===77:A.length<=4294967295?e===78:!1,nl=e=>e.controlStack.every(A=>A),hr=(e=ae.maximumStackItemLength)=>A=>{let a=A.instructions[A.ip];return a.data.length>e?w(A,`${v.exceededMaximumStackItemLength} Item length: ${a.data.length} bytes.`):nl(A)?wn(a.opcode,a.data)?M(A,a.data):w(A,v.nonMinimalPush):A},z=e=>{let A=W(BigInt(e));return a=>M(a,A)};var Oi=e=>te(e,(A,[a])=>(A.alternateStack.push(a),A)),Ri=e=>{let A=e.alternateStack.pop();return A===void 0?w(e,v.emptyAlternateStack):M(e,A)},Fi=e=>be(e,A=>A),Ki=e=>be(e,(A,[a,r])=>M(A,a,r,a.slice(),r.slice())),Mi=e=>It(e,(A,[a,r,n])=>M(A,a,r,n,a.slice(),r.slice(),n.slice())),Gi=e=>or(e,(A,[a,r,n,i])=>M(A,a,r,n,i,a.slice(),r.slice())),qi=e=>ys(e,(A,[a,r,n,i,t,o])=>M(A,n,i,t,o,a,r)),Hi=e=>or(e,(A,[a,r,n,i])=>M(A,n,i,a,r)),Ji=e=>te(e,(A,[a])=>M(A,...We(a)?[a,a.slice()]:[a])),Li=e=>M(e,W(BigInt(e.stack.length))),Vi=e=>te(e,A=>A),zi=e=>te(e,(A,[a])=>M(A,a,a.slice())),ji=e=>be(e,(A,[,a])=>M(A,a)),Wi=e=>be(e,(A,[a,r])=>M(A,a,r,a.slice())),Zi=e=>X(e,(A,a)=>{let r=A.stack[A.stack.length-1-Number(a)];return r===void 0?w(e,v.invalidStackIndex):M(A,r.slice())}),Xi=e=>X(e,(A,a)=>{let r=A.stack.length-1-Number(a);return r<0||r>A.stack.length-1?w(e,v.invalidStackIndex):M(A,A.stack.splice(r,1)[0])}),$i=e=>It(e,(A,[a,r,n])=>M(A,r,n,a)),ea=e=>be(e,(A,[a,r])=>M(A,r,a)),Aa=e=>be(e,(A,[a,r])=>M(A,r.slice(),a,r)),ta=e=>te(e,(A,[a])=>M(A,a,W(BigInt(a.length))));var bs=(e,A)=>{let a=e.stack[e.stack.length-1];if(a===void 0)return w(e,v.emptyStack);let r=_t(a,{maximumVmNumberByteLength:5,requireMinimalEncoding:!0});if(nr(r))return w(e,v.invalidVmNumber);let n=Number(r);return n<0?w(e,v.negativeLocktime):A(e,n)},ol=(e,A)=>e<5e8&&A<5e8||e>=5e8&&A>=5e8,xA=e=>bs(e,(A,a)=>{if(!ol(A.program.transaction.locktime,a))return w(A,v.incompatibleLocktimeType);if(a>A.program.transaction.locktime)return w(A,v.unsatisfiedLocktime);let{sequenceNumber:r}=A.program.transaction.inputs[A.program.inputIndex];return r===4294967295?w(A,v.locktimeDisabled):A}),dr=(e,A)=>(e&A)!==0,OA=e=>bs(e,(A,a)=>{let{sequenceNumber:r}=A.program.transaction.inputs[A.program.inputIndex];return dr(a,2147483648)?A:A.program.transaction.version<2?w(A,v.checkSequenceUnavailable):dr(r,2147483648)?w(A,v.unmatchedSequenceDisable):dr(a,4194304)!==dr(r,4194304)?w(A,v.incompatibleSequenceType):(a&65535)>(r&65535)?w(A,v.unsatisfiedSequenceNumber):A});var Be;(function(e){e[e.maximumBytecodeLength=1e4]="maximumBytecodeLength",e[e.maximumDataCarrierBytes=223]="maximumDataCarrierBytes",e[e.maximumOperationCount=201]="maximumOperationCount",e[e.maximumStackDepth=1e3]="maximumStackDepth",e[e.maximumStackItemLength=520]="maximumStackItemLength",e[e.maximumStandardVersion=2]="maximumStandardVersion",e[e.maximumStandardUnlockingBytecodeLength=1650]="maximumStandardUnlockingBytecodeLength",e[e.minimumTransactionSize=65]="minimumTransactionSize",e[e.maximumStandardTransactionSize=1e5]="maximumStandardTransactionSize",e[e.maximumTransactionSize=1e6]="maximumTransactionSize",e[e.maximumVmNumberLength=8]="maximumVmNumberLength",e.minVmNumber="-9223372036854775807",e.maxVmNumber="9223372036854775807",e[e.schnorrSignatureLength=64]="schnorrSignatureLength",e[e.maximumCommitmentLength=40]="maximumCommitmentLength"})(Be||(Be={}));var ia=[...Sa,ve.allOutputsAllUtxos,ve.correspondingOutputAllUtxos,ve.noOutputsAllUtxos];var Tn=({secp256k1:e,sha256:A}={secp256k1:Ae,sha256:q})=>a=>be(a,(r,[n,i])=>{if(!lA(i))return w(r,v.invalidPublicKeyEncoding);if(!TA(n,ia))return w(r,v.invalidSignatureEncoding,`Transaction signature (including signing serialization): ${$(n)}`);let t=iA(r.instructions).subarray(r.lastCodeSeparator+1),{signingSerializationType:o,signature:s}=YA(n),g=cA(r.program,{coveredBytecode:t,signingSerializationType:o},A),l=pe(g,A);r.signedMessages.push({digest:l,serialization:g});let E=s.length===ae.schnorrSignatureLength?e.verifySignatureSchnorr(s,i,l):e.verifySignatureDERLowS(s,i,l);return!E&&s.length!==0?w(r,v.nonNullSignatureFailure):M(r,oe(E))}),Yn=({secp256k1:e,sha256:A}={secp256k1:Ae,sha256:q})=>a=>X(a,(r,n)=>{let i=Number(n);if(i<0)return w(r,v.invalidNaturalNumber);if(i>20)return w(r,v.exceedsMaximumMultisigPublicKeyCount);let t=i>0?r.stack.splice(-i):[];return r.operationCount+=i,r.operationCount>ae.maximumOperationCount?w(r,v.exceededMaximumOperationCount):X(r,(o,s)=>{let g=Number(s);if(g<0)return w(o,v.invalidNaturalNumber);if(g>i)return w(o,v.insufficientPublicKeys);let l=g>0?o.stack.splice(-g):[];return te(o,(I,[E])=>{if(E.length!==0)return w(I,v.invalidProtocolBugValue);let u=iA(I.instructions).subarray(I.lastCodeSeparator+1),k=0,U=l.length,N=t.length;for(;U>0&&N>0&&k+N>=U&&k!==g;){let B=t[N-1],S=l[U-1];if(!lA(B))return w(I,v.invalidPublicKeyEncoding);if(!TA(S,ia))return w(I,v.invalidSignatureEncoding,`Transaction signature (including signing serialization type): ${$(S)}`);let{signingSerializationType:P,signature:h}=YA(S),y=cA(r.program,{coveredBytecode:u,signingSerializationType:P},A),p=pe(y,A);if(I.signedMessages.push({digest:p,serialization:y}),h.length===ae.schnorrSignatureLength)return w(I,v.schnorrSizedSignatureInCheckMultiSig);e.verifySignatureDERLowS(h,B,p)&&(k+=1,U-=1),N-=1}let c=k===g;return!c&&!l.every(B=>B.length===0)?w(I,v.nonNullSignatureFailure):M(I,oe(c))})})}),ks=({secp256k1:e,sha256:A}={secp256k1:Ae,sha256:q})=>qe(Tn({secp256k1:e,sha256:A}),me),Ns=({secp256k1:e,sha256:A})=>qe(Yn({secp256k1:e,sha256:A}),me);var xn;(function(e){e.OP_0="Push the VM Number 0 onto the stack.",e.OP_PUSHBYTES_1="Push the next byte onto the stack.",e.OP_PUSHBYTES_2="Push the next 2 bytes onto the stack.",e.OP_PUSHBYTES_3="Push the next 3 bytes onto the stack.",e.OP_PUSHBYTES_4="Push the next 4 bytes onto the stack.",e.OP_PUSHBYTES_5="Push the next 5 bytes onto the stack.",e.OP_PUSHBYTES_6="Push the next 6 bytes onto the stack.",e.OP_PUSHBYTES_7="Push the next 7 bytes onto the stack.",e.OP_PUSHBYTES_8="Push the next 8 bytes onto the stack.",e.OP_PUSHBYTES_9="Push the next 9 bytes onto the stack.",e.OP_PUSHBYTES_10="Push the next 10 bytes onto the stack.",e.OP_PUSHBYTES_11="Push the next 11 bytes onto the stack.",e.OP_PUSHBYTES_12="Push the next 12 bytes onto the stack.",e.OP_PUSHBYTES_13="Push the next 13 bytes onto the stack.",e.OP_PUSHBYTES_14="Push the next 14 bytes onto the stack.",e.OP_PUSHBYTES_15="Push the next 15 bytes onto the stack.",e.OP_PUSHBYTES_16="Push the next 16 bytes onto the stack.",e.OP_PUSHBYTES_17="Push the next 17 bytes onto the stack.",e.OP_PUSHBYTES_18="Push the next 18 bytes onto the stack.",e.OP_PUSHBYTES_19="Push the next 19 bytes onto the stack.",e.OP_PUSHBYTES_20="Push the next 20 bytes onto the stack.",e.OP_PUSHBYTES_21="Push the next 21 bytes onto the stack.",e.OP_PUSHBYTES_22="Push the next 22 bytes onto the stack.",e.OP_PUSHBYTES_23="Push the next 23 bytes onto the stack.",e.OP_PUSHBYTES_24="Push the next 24 bytes onto the stack.",e.OP_PUSHBYTES_25="Push the next 25 bytes onto the stack.",e.OP_PUSHBYTES_26="Push the next 26 bytes onto the stack.",e.OP_PUSHBYTES_27="Push the next 27 bytes onto the stack.",e.OP_PUSHBYTES_28="Push the next 28 bytes onto the stack.",e.OP_PUSHBYTES_29="Push the next 29 bytes onto the stack.",e.OP_PUSHBYTES_30="Push the next 30 bytes onto the stack.",e.OP_PUSHBYTES_31="Push the next 31 bytes onto the stack.",e.OP_PUSHBYTES_32="Push the next 32 bytes onto the stack.",e.OP_PUSHBYTES_33="Push the next 33 bytes onto the stack.",e.OP_PUSHBYTES_34="Push the next 34 bytes onto the stack.",e.OP_PUSHBYTES_35="Push the next 35 bytes onto the stack.",e.OP_PUSHBYTES_36="Push the next 36 bytes onto the stack.",e.OP_PUSHBYTES_37="Push the next 37 bytes onto the stack.",e.OP_PUSHBYTES_38="Push the next 38 bytes onto the stack.",e.OP_PUSHBYTES_39="Push the next 39 bytes onto the stack.",e.OP_PUSHBYTES_40="Push the next 40 bytes onto the stack.",e.OP_PUSHBYTES_41="Push the next 41 bytes onto the stack.",e.OP_PUSHBYTES_42="Push the next 42 bytes onto the stack.",e.OP_PUSHBYTES_43="Push the next 43 bytes onto the stack.",e.OP_PUSHBYTES_44="Push the next 44 bytes onto the stack.",e.OP_PUSHBYTES_45="Push the next 45 bytes onto the stack.",e.OP_PUSHBYTES_46="Push the next 46 bytes onto the stack.",e.OP_PUSHBYTES_47="Push the next 47 bytes onto the stack.",e.OP_PUSHBYTES_48="Push the next 48 bytes onto the stack.",e.OP_PUSHBYTES_49="Push the next 49 bytes onto the stack.",e.OP_PUSHBYTES_50="Push the next 50 bytes onto the stack.",e.OP_PUSHBYTES_51="Push the next 51 bytes onto the stack.",e.OP_PUSHBYTES_52="Push the next 52 bytes onto the stack.",e.OP_PUSHBYTES_53="Push the next 53 bytes onto the stack.",e.OP_PUSHBYTES_54="Push the next 54 bytes onto the stack.",e.OP_PUSHBYTES_55="Push the next 55 bytes onto the stack.",e.OP_PUSHBYTES_56="Push the next 56 bytes onto the stack.",e.OP_PUSHBYTES_57="Push the next 57 bytes onto the stack.",e.OP_PUSHBYTES_58="Push the next 58 bytes onto the stack.",e.OP_PUSHBYTES_59="Push the next 59 bytes onto the stack.",e.OP_PUSHBYTES_60="Push the next 60 bytes onto the stack.",e.OP_PUSHBYTES_61="Push the next 61 bytes onto the stack.",e.OP_PUSHBYTES_62="Push the next 62 bytes onto the stack.",e.OP_PUSHBYTES_63="Push the next 63 bytes onto the stack.",e.OP_PUSHBYTES_64="Push the next 64 bytes onto the stack.",e.OP_PUSHBYTES_65="Push the next 65 bytes onto the stack.",e.OP_PUSHBYTES_66="Push the next 66 bytes onto the stack.",e.OP_PUSHBYTES_67="Push the next 67 bytes onto the stack.",e.OP_PUSHBYTES_68="Push the next 68 bytes onto the stack.",e.OP_PUSHBYTES_69="Push the next 69 bytes onto the stack.",e.OP_PUSHBYTES_70="Push the next 70 bytes onto the stack.",e.OP_PUSHBYTES_71="Push the next 71 bytes onto the stack.",e.OP_PUSHBYTES_72="Push the next 72 bytes onto the stack.",e.OP_PUSHBYTES_73="Push the next 73 bytes onto the stack.",e.OP_PUSHBYTES_74="Push the next 74 bytes onto the stack.",e.OP_PUSHBYTES_75="Push the next 75 bytes onto the stack.",e.OP_PUSHDATA_1="Read the next Uint8 and push that number of bytes onto the stack.",e.OP_PUSHDATA_2="Read the next little-endian Uint16 and push that number of bytes onto the stack.",e.OP_PUSHDATA_4="Read the next little-endian Uint32 and push that number of bytes onto the stack.",e.OP_1NEGATE="Push the VM Number -1 onto the stack.",e.OP_RESERVED="Error unless found in an unexecuted conditional branch. Note: OP_RESERVED does not count toward the opcode limit.",e.OP_1="Push a 1 (VM Number) onto the stack.",e.OP_2="Push a 2 (VM Number) onto the stack.",e.OP_3="Push a 3 (VM Number) onto the stack.",e.OP_4="Push a 4 (VM Number) onto the stack.",e.OP_5="Push a 5 (VM Number) onto the stack.",e.OP_6="Push a 6 (VM Number) onto the stack.",e.OP_7="Push a 7 (VM Number) onto the stack.",e.OP_8="Push a 8 (VM Number) onto the stack.",e.OP_9="Push a 9 (VM Number) onto the stack.",e.OP_10="Push a 10 (VM Number) onto the stack.",e.OP_11="Push a 11 (VM Number) onto the stack.",e.OP_12="Push a 12 (VM Number) onto the stack.",e.OP_13="Push a 13 (VM Number) onto the stack.",e.OP_14="Push a 14 (VM Number) onto the stack.",e.OP_15="Push a 15 (VM Number) onto the stack.",e.OP_16="Push a 16 (VM Number) onto the stack.",e.OP_NOP="No operation. Note: OP_NOP counts toward the opcode limit.",e.OP_VER="Error unless found in an unexecuted conditional branch. Note: OP_VER counts toward the opcode limit. (Historically, this pushed a protocol version number to the stack.)",e.OP_IF='Pop the top item from the stack. If it is not "truthy", skip evaluation until a matching OP_ELSE or OP_ENDIF.',e.OP_NOTIF='Pop the top item from the stack. If it is "truthy", skip evaluation until a matching OP_ELSE or OP_ENDIF.',e.OP_VERIF="Error, even when found in an unexecuted conditional branch. (Historically, this was a combination of OP_VER and OP_IF.)",e.OP_VERNOTIF="Error, even when found in an unexecuted conditional branch. (Historically, this was a combination of OP_VER and OP_NOTIF.)",e.OP_ELSE="Invert conditional evaluation within the current OP_IF ... OP_ENDIF block. (If evaluation is enabled, disable it, if it is disabled, enable it.)",e.OP_ENDIF="End the current OP_IF/OP_NOTIF ... OP_ENDIF block.",e.OP_VERIFY=`Pop the top item from the stack and error if it isn't "truthy".`,e.OP_RETURN="Error when executed.",e.OP_TOALTSTACK="Pop the top item from the stack and push it onto the alternate stack.",e.OP_FROMALTSTACK="Pop the top item from the alternate stack and push it onto the stack.",e.OP_2DROP="Pop the top 2 items from the stack and discard them.",e.OP_2DUP="Duplicate the top 2 items on the stack. (E.g. [a, b] -> [a, b, a, b])",e.OP_3DUP="Duplicate the top 3 items on the stack. (E.g. [a, b, c] -> [a, b, c, a, b, c])",e.OP_2OVER="Duplicate the 2 items beginning at a depth of 2 on the stack. (E.g. [a, b, c, d] -> [a, b, c, d, a, b])",e.OP_2ROT="Rotate the top 6 items on the stack, bringing the fifth and sixth items to the top. (E.g. [a, b, c, d, e, f] -> [c, d, e, f, a, b])",e.OP_2SWAP="Swap the positions of the top two pairs of items on the stack. (E.g. [a, b, c, d] -> [c, d, a, b])",e.OP_IFDUP='If the top item on the stack is "truthy", duplicate it.',e.OP_DEPTH="Push the current number of stack items as a VM Number.",e.OP_DROP="Pop the top item from the stack and discard it. (E.g. [a] -> [])",e.OP_DUP="Duplicate the top item on the stack. (E.g. [a] -> [a, a])",e.OP_NIP="Remove the second-to-top item from the stack. (E.g. [a, b] -> [b])",e.OP_OVER="Duplicate the second-to-top item on the stack. (E.g. [a, b] -> [a, b, a])",e.OP_PICK="Pop the top item from the stack as a VM Number. Duplicate the item at that depth (zero-indexed), placing it on top of the stack. (E.g. [a, b, c, 2] -> [a, b, c, a])",e.OP_ROLL="Pop the top item from the stack as a VM Number. Move the item at that depth (zero-indexed) to the top of the stack. (E.g. [a, b, c, 2] -> [b, c, a])",e.OP_ROT="Rotate the top 3 items on the stack, bringing the third item to the top. (E.g. [a, b, c] -> [b, c, a])",e.OP_SWAP="Swap the top two items on the stack. (E.g. [a, b] -> [b, a])",e.OP_TUCK="Duplicate the item at the top of the stack, inserting it below the second-to-top item. (E.g. [a, b] -> [b, a, b])",e.OP_CAT="Pop the top 2 items from the stack and concatenate them, pushing the result.",e.OP_SPLIT="Pop the top item from the stack as an index (VM Number) and the next item as a byte array. Split the byte array into two stack items at the index (zero-based), pushing the results.",e.OP_NUM2BIN="Pop the top item from the stack as an item length (VM Number) and the next item as a VM Number (without encoding restrictions). Re-encode the number using a byte array of the provided length, filling any unused bytes with zeros, then push the result. (If the requested length is too short to encode the number, error.)",e.OP_BIN2NUM="Pop the top item from the stack as a VM Number without encoding restrictions. Minimally-encode the number and push the result. (If the number can't be encoded in 4 bytes or less, error.)",e.OP_SIZE="Push the byte-length of the top stack item as a VM Number.",e.OP_INVERT="Error, even when found in an unexecuted conditional branch. (Historically, this flipped all the bits in a stack item.)",e.OP_AND="Pop the top 2 items from the stack and perform a bitwise AND on each byte, pushing the result. If the length of the items are not equal, error.",e.OP_OR="Pop the top 2 items from the stack and perform a bitwise OR on each byte, pushing the result. If the length of the items are not equal, error.",e.OP_XOR="Pop the top 2 items from the stack and perform a bitwise XOR on each byte, pushing the result. If the length of the items are not equal, error.",e.OP_EQUAL="Pop the top two items from the stack and compare them byte-by-byte. If they are the same, push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_EQUALVERIFY="Pop the top two items from the stack and compare them byte-by-byte. If the values are different, error. (This operation is a combination of OP_EQUAL followed by OP_VERIFY.)",e.OP_RESERVED1="Error unless found in an unexecuted conditional branch. Note: OP_RESERVED1 counts toward the opcode limit.",e.OP_RESERVED2="Error unless found in an unexecuted conditional branch. Note: OP_RESERVED2 counts toward the opcode limit.",e.OP_1ADD="Pop the top item from the stack as a VM Number, add 1, then push the result.",e.OP_1SUB="Pop the top item from the stack as a VM Number, subtract 1, then push the result.",e.OP_2MUL="Error, even when found in an unexecuted conditional branch. (Historically, this multiplied a VM Number by 2.)",e.OP_2DIV="Error, even when found in an unexecuted conditional branch. (Historically, this divided a VM Number by 2.)",e.OP_NEGATE="Pop the top item from the stack as a VM Number, negate it, then push the result.",e.OP_ABS="Pop the top item from the stack as a VM Number, take its absolute value, then push the result.",e.OP_NOT="Pop the top item from the stack as a VM Number. If its value is 0, push a 1 (VM Number), otherwise, push a 0 (VM Number).",e.OP_0NOTEQUAL="Pop the top item from the stack as a VM Number. If its value is not 0, push a 1 (VM Number), otherwise, push a 0 (VM Number).",e.OP_ADD="Pop the top two items from the stack as VM Numbers. Add them, then push the result.",e.OP_SUB="Pop the top two items from the stack as VM Numbers. Subtract the top item from the second item, then push the result.",e.OP_MUL="Pop the top two items from the stack as VM Numbers. Multiply them, then push the result.",e.OP_DIV="Pop the top item from the stack as a denominator (VM Number) and the next as a numerator (VM Number). Divide and push the result to the stack.",e.OP_MOD="Pop the top item from the stack as a denominator (VM Number) and the next as a numerator (VM Number). Divide and push the remainder to the stack.",e.OP_LSHIFT="Error, even when found in an unexecuted conditional branch. (Historically, this performed a sign-preserving, left bit shift.)",e.OP_RSHIFT="Error, even when found in an unexecuted conditional branch. (Historically, this performed a sign-preserving, right bit shift.)",e.OP_BOOLAND="Pop the top two items from the stack as VM Numbers. If neither value is a 0 (VM Number), push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_BOOLOR="Pop the top two items from the stack as VM Numbers. If either value is a 1 (VM Number), push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_NUMEQUAL="Pop the top two items from the stack as VM Numbers. If the values are equal, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_NUMEQUALVERIFY="Pop the top two items from the stack as VM Numbers. If the values are different, error. (This operation is a combination of OP_NUMEQUAL followed by OP_VERIFY.)",e.OP_NUMNOTEQUAL="Pop the top two items from the stack as VM Numbers. If the values are not equal, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_LESSTHAN="Pop the top two items from the stack as VM Numbers. If the second item is less than top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_GREATERTHAN="Pop the top two items from the stack as VM Numbers. If the second item is greater than top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_LESSTHANOREQUAL="Pop the top two items from the stack as VM Numbers. If the second item is less than or equal to the top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_GREATERTHANOREQUAL="Pop the top two items from the stack as VM Numbers. If the second item is greater than or equal to the top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_MIN="Pop the top two items from the stack as VM Numbers. Push the smaller of the two numbers.",e.OP_MAX="Pop the top two items from the stack as VM Numbers. Push the larger of the two numbers.",e.OP_WITHIN="Pop the top three items from the stack as VM Numbers. If the top number is within the range defined by the following two numbers (left-inclusive), push a 1 (VM Number). Otherwise, push a 0 (VM Number). (E.g. for [a, b, c]: if (b <= a), and (a < c), [1]. Else [0].)",e.OP_RIPEMD160="Pop the top item from the stack and pass it through ripemd160, pushing the result onto the stack.",e.OP_SHA1="Pop the top item from the stack and pass it through sha1, pushing the result onto the stack.",e.OP_SHA256="Pop the top item from the stack and pass it through sha256, pushing the result onto the stack.",e.OP_HASH160="Pop the top item from the stack and pass it through sha256, then ripemd160, pushing the result onto the stack.",e.OP_HASH256="Pop the top item from the stack and pass it through sha256 twice, pushing the result onto the stack.",e.OP_CODESEPARATOR="Update the value of lastCodeSeparator to the instruction pointer's current value. (This reduces the coverage of signing serializations used in signature verification operations.)",e.OP_CHECKSIG="Pop the top two items from the stack. Treat the top as a signature and the second as a public key. If the signature is valid, push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_CHECKSIGVERIFY="Pop the top two items from the stack. Treat the top as a signature and the second as a public key. If the signature is not valid, error. (This operation is a combination of OP_CHECKSIG followed by OP_VERIFY.)",e.OP_CHECKMULTISIG="Pop items from the stack: first pop the VM Number of public keys, then pop each of those public keys. Next, pop the VM Number of required signatures, then pop each of those signatures. Finally, pop a final VM Number that must be 0 due to a protocol bug. Checking each signature against each public key in order, if all signatures are valid \u2013 and the required number of signatures have been provided \u2013 push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_CHECKMULTISIGVERIFY="Pop items from the stack: first pop the VM Number of public keys, then pop each of those public keys. Next, pop the VM Number of required signatures, then pop each of those signatures. Finally, (due to a protocol bug) pop an unused final VM Number that must be 0. Checking each signature against each public key in order, if any signatures are invalid \u2013 or the required number of signatures have not been provided \u2013 error. (This operation is a combination of OP_CHECKMULTISIG followed by OP_VERIFY.)",e.OP_NOP1="No operation (reserved for future expansion). Note: OP_NOP1 counts toward the opcode limit.",e.OP_CHECKLOCKTIMEVERIFY="Verify the transaction occurs after an absolute block time or height: read the top item on the stack as a VM Number (without removing it), and compare it to the transaction's locktime. If the required locktime has not passed, or if locktime has been disabled for this input by a maximized sequence number, error.",e.OP_CHECKSEQUENCEVERIFY=`Verify the transaction occurs after the output being spent has "aged" by a relative block time or block height since it was created: read the top item on the stack as a VM Number (without removing it), and compare it to the age encoded in the input's sequence number. If the required relative locktime has not passed, or if relative locktime has been disabled by the sequence number or the transaction version, error.`,e.OP_NOP4="No operation (reserved for future expansion). Note: OP_NOP4 counts toward the opcode limit.",e.OP_NOP6="No operation (reserved for future expansion). Note: OP_NOP6 counts toward the opcode limit.",e.OP_NOP5="No operation (reserved for future expansion). Note: OP_NOP5 counts toward the opcode limit.",e.OP_NOP7="No operation (reserved for future expansion). Note: OP_NOP7 counts toward the opcode limit.",e.OP_NOP8="No operation (reserved for future expansion). Note: OP_NOP8 counts toward the opcode limit.",e.OP_NOP9="No operation (reserved for future expansion). Note: OP_NOP9 counts toward the opcode limit.",e.OP_NOP10="No operation (reserved for future expansion). Note: OP_NOP10 counts toward the opcode limit.",e.OP_CHECKDATASIG="Pop the top 3 items from the stack. Treat the top as a public key, the second as a message, and the third as a signature. If the signature is valid, push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_CHECKDATASIGVERIFY="Pop the top 3 items from the stack. Treat the top as a public key, the second as a message, and the third as a signature. If the signature is not valid, error. (This operation is a combination of OP_CHECKDATASIG followed by OP_VERIFY.)",e.OP_REVERSEBYTES="Pop the top item from the stack and reverse it, pushing the result.",e.OP_INPUTINDEX="Push the index of the input being evaluated to the stack as a VM Number.",e.OP_ACTIVEBYTECODE="Push the bytecode currently being evaluated, beginning after the last executed OP_CODESEPARATOR, to the stack. For Pay-to-Script-Hash (P2SH) evaluations, this is the redeem bytecode of the Unspent Transaction Output (UTXO) being spent; for all other evaluations, this is the locking bytecode of the UTXO being spent.",e.OP_TXVERSION="Push the version of the current transaction to the stack as a VM Number.",e.OP_TXINPUTCOUNT="Push the count of inputs in the current transaction to the stack as a VM Number.",e.OP_TXOUTPUTCOUNT="Push the count of outputs in the current transaction to the stack as a VM Number.",e.OP_TXLOCKTIME="Push the locktime of the current transaction to the stack as a VM Number.",e.OP_UTXOVALUE="Pop the top item from the stack as an input index (VM Number). Push the value (in satoshis) of the Unspent Transaction Output (UTXO) spent by that input to the stack as a VM Number.",e.OP_UTXOBYTECODE="Pop the top item from the stack as an input index (VM Number). Push the full locking bytecode of the Unspent Transaction Output (UTXO) spent by that input to the stack.",e.OP_OUTPOINTTXHASH="Pop the top item from the stack as an input index (VM Number). From that input, push the outpoint transaction hash \u2013 the hash of the transaction that created the Unspent Transaction Output (UTXO) that is being spent \u2013 to the stack in OP_HASH256 byte order.",e.OP_OUTPOINTINDEX="Pop the top item from the stack as an input index (VM Number). From that input, push the outpoint index \u2013 the index of the output in the transaction that created the Unspent Transaction Output (UTXO) that is being spent \u2013 to the stack as a VM Number.",e.OP_INPUTBYTECODE="Pop the top item from the stack as an input index (VM Number). Push the unlocking bytecode of the input at that index to the stack.",e.OP_INPUTSEQUENCENUMBER="Pop the top item from the stack as an input index (VM Number). Push the sequence number of the input at that index to the stack as a VM Number.",e.OP_OUTPUTVALUE="Pop the top item from the stack as an output index (VM Number). Push the value (in satoshis) of the output at that index to the stack as a VM Number.",e.OP_OUTPUTBYTECODE="Pop the top item from the stack as an output index (VM Number). Push the locking bytecode of the output at that index to the stack.",e.OP_UTXOTOKENCATEGORY="Pop the top item from the stack as an input index (VM Number). If the Unspent Transaction Output (UTXO) spent by that input includes no tokens, push a 0 (VM Number) to the stack. If the UTXO does not include a non-fungible token with a capability, push the UTXO's token category, otherwise, push the concatenation of the token category and capability, where the mutable capability is represented by 1 (VM Number) and the minting capability is represented by 2 (VM Number).",e.OP_UTXOTOKENCOMMITMENT="Pop the top item from the stack as an input index (VM Number). Push the token commitment of the Unspent Transaction Output (UTXO) spent by that input to the stack. If the UTXO does not include a non-fungible token, or if it includes a non-fungible token with a zero-length commitment, push a 0 (VM Number).",e.OP_UTXOTOKENAMOUNT="Pop the top item from the stack as an input index (VM Number). Push the fungible token amount of the Unspent Transaction Output (UTXO) spent by that input to the stack as a VM Number. If the UTXO includes no fungible tokens, push a 0 (VM Number).",e.OP_OUTPUTTOKENCATEGORY="Pop the top item from the stack as an output index (VM Number). If the output spent by that input includes no tokens, push a 0 (VM Number) to the stack. If the output does not include a non-fungible token with a capability, push the output's token category, otherwise, push the concatenation of the token category and capability, where the mutable capability is represented by 1 (VM Number) and the minting capability is represented by 2 (VM Number).",e.OP_OUTPUTTOKENCOMMITMENT="Pop the top item from the stack as an output index (VM Number). Push the token commitment of the output at that index to the stack. If the output does not include a non-fungible token, or if it includes a non-fungible token with a zero-length commitment, push a 0 (VM Number).",e.OP_OUTPUTTOKENAMOUNT="Pop the top item from the stack as an output index (VM Number). Push the fungible token amount of the output at that index to the stack as a VM Number. If the output includes no fungible tokens, push a 0 (VM Number)."})(xn||(xn={}));var sl=xn,mm=sl;var On;(function(e){e.exceededMaximumVmNumberLength="Program attempted an OP_BIN2NUM operation on a byte sequence that cannot be encoded within the maximum VM Number length (8 bytes)."})(On||(On={}));var ym=On;var gl=e=>e.reduce((A,a)=>a.outpointIndex===0?[...A,$(a.outpointTransactionHash)]:A,[]),Il=e=>e.reduce((A,a)=>{if(a.token===void 0)return A;let r=$(a.token.category);return{availableImmutableTokens:[...A.availableImmutableTokens,...a.token.nft?.capability==="none"?[{categoryHex:$(a.token.category),commitmentHex:$(a.token.nft.commitment)}]:[]],availableMutableTokensByCategory:a.token.nft?.capability==="mutable"?{...A.availableMutableTokensByCategory,[r]:(A.availableMutableTokensByCategory[r]??0)+1}:A.availableMutableTokensByCategory,availableSumsByCategory:{...A.availableSumsByCategory,[r]:(A.availableSumsByCategory[r]??0n)+a.token.amount},inputMintingCategories:[...A.inputMintingCategories,...a.token.nft?.capability==="minting"?[$(a.token.category)]:[]]}},{availableImmutableTokens:[],availableMutableTokensByCategory:{},availableSumsByCategory:{},inputMintingCategories:[]}),cl=e=>e.reduce((A,a)=>{if(a.token===void 0)return A;let r=$(a.token.category);return{outputImmutableTokens:[...A.outputImmutableTokens,...a.token.nft?.capability==="none"?[{categoryHex:$(a.token.category),commitmentHex:$(a.token.nft.commitment)}]:[]],outputMintingCategories:[...A.outputMintingCategories,...a.token.nft?.capability==="minting"?[$(a.token.category)]:[]],outputMutableTokensByCategory:a.token.nft?.capability==="mutable"?{...A.outputMutableTokensByCategory,[r]:(A.outputMutableTokensByCategory[r]??0)+1}:A.outputMutableTokensByCategory,outputSumsByCategory:{...A.outputSumsByCategory,[r]:(A.outputSumsByCategory[r]??0n)+a.token.amount}}},{outputImmutableTokens:[],outputMintingCategories:[],outputMutableTokensByCategory:{},outputSumsByCategory:{}}),Us=(e,A)=>{let a=[...A,...e.outputs].find(c=>c.token?.nft?.commitment!==void 0&&c.token.nft.commitment.length>Be.maximumCommitmentLength);if(a!==void 0)return`Transaction violates token validation: a token commitment exceeds the consensus limit of ${Be.maximumCommitmentLength} bytes. Excessive token commitment length: ${a.token.nft.commitment.length}`;let r=gl(e.inputs),{availableSumsByCategory:n,availableMutableTokensByCategory:i,inputMintingCategories:t,availableImmutableTokens:o}=Il(A),{outputSumsByCategory:s,outputMutableTokensByCategory:g,outputMintingCategories:l,outputImmutableTokens:I}=cl(e.outputs),E=[...r,...t],u=l.find(c=>!E.includes(c));if(u!==void 0)return`Transaction violates token validation: the transaction outputs include a minting token that is not substantiated by the transaction's inputs. Invalid output minting token category: ${u}`;for(let[c,B]of Object.entries(s)){if(B>BigInt(Be.maxVmNumber))return`Transaction violates token validation: the transaction outputs include a sum of fungible tokens for a category exceeding the maximum supply (${Be.maxVmNumber}). Category: ${c}, total amount: ${B.toString()}.`;let S=n[c];if(S===void 0&&B>0&&!r.includes(c))return`Transaction violates token validation: the transaction creates new fungible tokens for a category without a matching genesis input. Category: ${c}, tokens created: ${B}`;if(S!==void 0&&B>S)return`Transaction violates token validation: the sum of fungible tokens in the transaction's outputs exceed that of the transactions inputs for a category. Category: ${c}, input amount: ${S}, output amount: ${B}`}let k=Object.entries(g).reduce((c,[B,S])=>E.includes(B)?c:{...c,[B]:(c[B]??0)-S},i);for(let[c,B]of Object.entries(k))if(B<0)return`Transaction violates token validation: the transaction creates more mutable tokens than are available for a category without a matching minting token. Category: ${c}, excess mutable tokens: ${0-B}`;let{unmatchedImmutableTokens:U}=I.reduce((c,B)=>{let{categoryHex:S,commitmentHex:P}=B;if(E.includes(S))return c;let h=o.findIndex(y=>y.categoryHex===S&&y.commitmentHex===P);return h===-1?{availableImmutableTokens:c.availableImmutableTokens,unmatchedImmutableTokens:[...c.unmatchedImmutableTokens,B]}:(c.availableImmutableTokens.splice(h,1),c)},{availableImmutableTokens:o,unmatchedImmutableTokens:[]}),N=U.reduce((c,B)=>({...c,[B.categoryHex]:(c[B.categoryHex]??0)+1}),{});for(let[c,B]of Object.entries(N)){let S=k[c]??0;if(S<B)return`Transaction violates token validation: the transaction creates an immutable token for a category without a matching minting token or sufficient mutable tokens. Category ${c}, available mutable tokens: ${S}, new immutable tokens: ${B}`}return!0},_s=(e,A)=>{let{token:a}=A;if(a===void 0)return ba(e,0n);let r=a.nft?.capability==="minting"?[2]:a.nft?.capability==="mutable"?[1]:[],n=ee([a.category.slice().reverse(),Uint8Array.from(r)]);return EA(e,n)},vs=(e,A)=>{let{token:a}=A;return a?.nft===void 0?ba(e,0n):EA(e,a.nft.commitment)},Ds=(e,A)=>{let{token:a}=A;return a===void 0?ba(e,0n):Le(e,a.amount)},Er=e=>ki(e,(A,[a])=>_s(A,a)),Br=e=>ki(e,(A,[a])=>vs(A,a)),pr=e=>ki(e,(A,[a])=>Ds(A,a)),mr=e=>Ti(e,(A,[a])=>_s(A,a)),Qr=e=>Ti(e,(A,[a])=>vs(A,a)),yr=e=>Ti(e,(A,[a])=>Ds(A,a));var Rn=(e=!0,{ripemd160:A,secp256k1:a,sha1:r,sha256:n}={ripemd160:Ee,secp256k1:Ae,sha1:fA,sha256:q})=>{let i=hr();return{clone:ka,continue:t=>t.error===void 0&&t.ip<t.instructions.length,evaluate:(t,o)=>{let{unlockingBytecode:s}=t.transaction.inputs[t.inputIndex],{lockingBytecode:g}=t.sourceOutputs[t.inputIndex],l=we(s),I=we(g),E=jA({instructions:l,program:t,stack:[]});if(s.length>Be.maximumBytecodeLength)return w(E,`The provided unlocking bytecode (${s.length} bytes) exceeds the maximum bytecode length (${Be.maximumBytecodeLength} bytes).`);if(tA(l))return w(E,v.malformedUnlockingBytecode);if(!bA(s))return w(E,v.requiresPushOnly);if(g.length>Be.maximumBytecodeLength)return w(E,v.exceededMaximumBytecodeLengthLocking);if(tA(I))return w(E,v.malformedLockingBytecode);let u=o(E);if(u.error!==void 0)return u;if(u.controlStack.length!==0)return w(E,v.nonEmptyControlStack);let k=o(jA({instructions:I,program:t,stack:u.stack})),U=PA(g),N=ma(g);if(!U&&!N)return k;let c=BA(u.stack),B=c.pop()??Uint8Array.of();if(U&&c.length===0&&Dt(B))return k;let S=we(B);return tA(S)?{...k,error:v.malformedP2shBytecode}:o(jA({instructions:S,program:t,stack:c}))},every:t=>t.stack.length+t.alternateStack.length>Be.maximumStackDepth?w(t,v.exceededMaximumStackDepth):t.operationCount>Be.maximumOperationCount?w(t,v.exceededMaximumOperationCount):t,operations:{[Q.OP_0]:i,[Q.OP_PUSHBYTES_1]:i,[Q.OP_PUSHBYTES_2]:i,[Q.OP_PUSHBYTES_3]:i,[Q.OP_PUSHBYTES_4]:i,[Q.OP_PUSHBYTES_5]:i,[Q.OP_PUSHBYTES_6]:i,[Q.OP_PUSHBYTES_7]:i,[Q.OP_PUSHBYTES_8]:i,[Q.OP_PUSHBYTES_9]:i,[Q.OP_PUSHBYTES_10]:i,[Q.OP_PUSHBYTES_11]:i,[Q.OP_PUSHBYTES_12]:i,[Q.OP_PUSHBYTES_13]:i,[Q.OP_PUSHBYTES_14]:i,[Q.OP_PUSHBYTES_15]:i,[Q.OP_PUSHBYTES_16]:i,[Q.OP_PUSHBYTES_17]:i,[Q.OP_PUSHBYTES_18]:i,[Q.OP_PUSHBYTES_19]:i,[Q.OP_PUSHBYTES_20]:i,[Q.OP_PUSHBYTES_21]:i,[Q.OP_PUSHBYTES_22]:i,[Q.OP_PUSHBYTES_23]:i,[Q.OP_PUSHBYTES_24]:i,[Q.OP_PUSHBYTES_25]:i,[Q.OP_PUSHBYTES_26]:i,[Q.OP_PUSHBYTES_27]:i,[Q.OP_PUSHBYTES_28]:i,[Q.OP_PUSHBYTES_29]:i,[Q.OP_PUSHBYTES_30]:i,[Q.OP_PUSHBYTES_31]:i,[Q.OP_PUSHBYTES_32]:i,[Q.OP_PUSHBYTES_33]:i,[Q.OP_PUSHBYTES_34]:i,[Q.OP_PUSHBYTES_35]:i,[Q.OP_PUSHBYTES_36]:i,[Q.OP_PUSHBYTES_37]:i,[Q.OP_PUSHBYTES_38]:i,[Q.OP_PUSHBYTES_39]:i,[Q.OP_PUSHBYTES_40]:i,[Q.OP_PUSHBYTES_41]:i,[Q.OP_PUSHBYTES_42]:i,[Q.OP_PUSHBYTES_43]:i,[Q.OP_PUSHBYTES_44]:i,[Q.OP_PUSHBYTES_45]:i,[Q.OP_PUSHBYTES_46]:i,[Q.OP_PUSHBYTES_47]:i,[Q.OP_PUSHBYTES_48]:i,[Q.OP_PUSHBYTES_49]:i,[Q.OP_PUSHBYTES_50]:i,[Q.OP_PUSHBYTES_51]:i,[Q.OP_PUSHBYTES_52]:i,[Q.OP_PUSHBYTES_53]:i,[Q.OP_PUSHBYTES_54]:i,[Q.OP_PUSHBYTES_55]:i,[Q.OP_PUSHBYTES_56]:i,[Q.OP_PUSHBYTES_57]:i,[Q.OP_PUSHBYTES_58]:i,[Q.OP_PUSHBYTES_59]:i,[Q.OP_PUSHBYTES_60]:i,[Q.OP_PUSHBYTES_61]:i,[Q.OP_PUSHBYTES_62]:i,[Q.OP_PUSHBYTES_63]:i,[Q.OP_PUSHBYTES_64]:i,[Q.OP_PUSHBYTES_65]:i,[Q.OP_PUSHBYTES_66]:i,[Q.OP_PUSHBYTES_67]:i,[Q.OP_PUSHBYTES_68]:i,[Q.OP_PUSHBYTES_69]:i,[Q.OP_PUSHBYTES_70]:i,[Q.OP_PUSHBYTES_71]:i,[Q.OP_PUSHBYTES_72]:i,[Q.OP_PUSHBYTES_73]:i,[Q.OP_PUSHBYTES_74]:i,[Q.OP_PUSHBYTES_75]:i,[Q.OP_PUSHDATA_1]:i,[Q.OP_PUSHDATA_2]:i,[Q.OP_PUSHDATA_4]:i,[Q.OP_1NEGATE]:d(z(-1)),[Q.OP_RESERVED]:d(Ye),[Q.OP_1]:d(z(1)),[Q.OP_2]:d(z(2)),[Q.OP_3]:d(z(3)),[Q.OP_4]:d(z(4)),[Q.OP_5]:d(z(5)),[Q.OP_6]:d(z(6)),[Q.OP_7]:d(z(7)),[Q.OP_8]:d(z(8)),[Q.OP_9]:d(z(9)),[Q.OP_10]:d(z(10)),[Q.OP_11]:d(z(11)),[Q.OP_12]:d(z(12)),[Q.OP_13]:d(z(13)),[Q.OP_14]:d(z(14)),[Q.OP_15]:d(z(15)),[Q.OP_16]:d(z(16)),...Yt([Tt],{[Q.OP_NOP]:d(Ie),[Q.OP_VER]:d(Ye),[Q.OP_IF]:gr,[Q.OP_NOTIF]:Ir,[Q.OP_VERIF]:Ye,[Q.OP_VERNOTIF]:Ye,[Q.OP_ELSE]:lr,[Q.OP_ENDIF]:cr,[Q.OP_VERIFY]:d(me),[Q.OP_RETURN]:d(xt),[Q.OP_TOALTSTACK]:d(Oi),[Q.OP_FROMALTSTACK]:d(Ri),[Q.OP_2DROP]:d(Fi),[Q.OP_2DUP]:d(Ki),[Q.OP_3DUP]:d(Mi),[Q.OP_2OVER]:d(Gi),[Q.OP_2ROT]:d(qi),[Q.OP_2SWAP]:d(Hi),[Q.OP_IFDUP]:d(Ji),[Q.OP_DEPTH]:d(Li),[Q.OP_DROP]:d(Vi),[Q.OP_DUP]:d(zi),[Q.OP_NIP]:d(ji),[Q.OP_OVER]:d(Wi),[Q.OP_PICK]:d(Zi),[Q.OP_ROLL]:d(Xi),[Q.OP_ROT]:d($i),[Q.OP_SWAP]:d(ea),[Q.OP_TUCK]:d(Aa),[Q.OP_CAT]:d(Bi),[Q.OP_SPLIT]:d(pi),[Q.OP_NUM2BIN]:d(mi),[Q.OP_BIN2NUM]:d(Qi),[Q.OP_SIZE]:d(ta),[Q.OP_INVERT]:Te,[Q.OP_AND]:d(ni),[Q.OP_OR]:d(oi),[Q.OP_XOR]:d(si),[Q.OP_EQUAL]:d(lt),[Q.OP_EQUALVERIFY]:d(ri),[Q.OP_RESERVED1]:d(Ye),[Q.OP_RESERVED2]:d(Ye),[Q.OP_1ADD]:d(Ot),[Q.OP_1SUB]:d(Rt),[Q.OP_2MUL]:Te,[Q.OP_2DIV]:Te,[Q.OP_NEGATE]:d(Ft),[Q.OP_ABS]:d(Kt),[Q.OP_NOT]:d(Mt),[Q.OP_0NOTEQUAL]:d(Gt),[Q.OP_ADD]:d(qt),[Q.OP_SUB]:d(Ht),[Q.OP_MUL]:d(ti),[Q.OP_DIV]:d(ii),[Q.OP_MOD]:d(ai),[Q.OP_LSHIFT]:Te,[Q.OP_RSHIFT]:Te,[Q.OP_BOOLAND]:d(Jt),[Q.OP_BOOLOR]:d(Lt),[Q.OP_NUMEQUAL]:d(ct),[Q.OP_NUMEQUALVERIFY]:d(Vt),[Q.OP_NUMNOTEQUAL]:d(zt),[Q.OP_LESSTHAN]:d(jt),[Q.OP_GREATERTHAN]:d(Zt),[Q.OP_LESSTHANOREQUAL]:d(Wt),[Q.OP_GREATERTHANOREQUAL]:d(Xt),[Q.OP_MIN]:d($t),[Q.OP_MAX]:d(ei),[Q.OP_WITHIN]:d(Ai),[Q.OP_RIPEMD160]:d(gi({ripemd160:A})),[Q.OP_SHA1]:d(Ii({sha1:r})),[Q.OP_SHA256]:d(ci({sha256:n})),[Q.OP_HASH160]:d(li({ripemd160:A,sha256:n})),[Q.OP_HASH256]:d(ui({sha256:n})),[Q.OP_CODESEPARATOR]:d(hi),[Q.OP_CHECKSIG]:d(Tn({secp256k1:a,sha256:n})),[Q.OP_CHECKSIGVERIFY]:d(ks({secp256k1:a,sha256:n})),[Q.OP_CHECKMULTISIG]:d(Yn({secp256k1:a,sha256:n})),[Q.OP_CHECKMULTISIGVERIFY]:d(Ns({secp256k1:a,sha256:n})),...e?{[Q.OP_NOP1]:d(ue),[Q.OP_CHECKLOCKTIMEVERIFY]:d(xA),[Q.OP_CHECKSEQUENCEVERIFY]:d(OA),[Q.OP_NOP4]:d(ue),[Q.OP_NOP5]:d(ue),[Q.OP_NOP6]:d(ue),[Q.OP_NOP7]:d(ue),[Q.OP_NOP8]:d(ue),[Q.OP_NOP9]:d(ue),[Q.OP_NOP10]:d(ue)}:{[Q.OP_NOP1]:d(Ie),[Q.OP_CHECKLOCKTIMEVERIFY]:d(xA),[Q.OP_CHECKSEQUENCEVERIFY]:d(OA),[Q.OP_NOP4]:d(Ie),[Q.OP_NOP5]:d(Ie),[Q.OP_NOP6]:d(Ie),[Q.OP_NOP7]:d(Ie),[Q.OP_NOP8]:d(Ie),[Q.OP_NOP9]:d(Ie),[Q.OP_NOP10]:d(Ie)},[Q.OP_CHECKDATASIG]:d(ut({secp256k1:a,sha256:n})),[Q.OP_CHECKDATASIGVERIFY]:d(di({secp256k1:a,sha256:n})),[Q.OP_REVERSEBYTES]:d(Ei),[Q.OP_INPUTINDEX]:d(yi),[Q.OP_ACTIVEBYTECODE]:d(fi),[Q.OP_TXVERSION]:d(Ci),[Q.OP_TXINPUTCOUNT]:d(Pi),[Q.OP_TXOUTPUTCOUNT]:d(Si),[Q.OP_TXLOCKTIME]:d(bi),[Q.OP_UTXOVALUE]:d(Ni),[Q.OP_UTXOBYTECODE]:d(Ui),[Q.OP_OUTPOINTTXHASH]:d(_i),[Q.OP_OUTPOINTINDEX]:d(vi),[Q.OP_INPUTBYTECODE]:d(Di),[Q.OP_INPUTSEQUENCENUMBER]:d(wi),[Q.OP_OUTPUTVALUE]:d(Yi),[Q.OP_OUTPUTBYTECODE]:d(xi),[Q.OP_UTXOTOKENCATEGORY]:d(Er),[Q.OP_UTXOTOKENCOMMITMENT]:d(Br),[Q.OP_UTXOTOKENAMOUNT]:d(pr),[Q.OP_OUTPUTTOKENCATEGORY]:d(mr),[Q.OP_OUTPUTTOKENCOMMITMENT]:d(Qr),[Q.OP_OUTPUTTOKENAMOUNT]:d(yr)})},success:t=>t.error!==void 0?t.error:t.controlStack.length!==0?v.nonEmptyControlStack:t.stack.length!==1?v.requiresCleanStack:We(t.stack[0])?!0:v.unsuccessfulEvaluation,undefined:xe,verify:({sourceOutputs:t,transaction:o},s,g)=>{if(o.inputs.length===0)return"Transactions must have at least one input.";if(o.outputs.length===0)return"Transactions must have at least one output.";if(o.inputs.length!==t.length)return"Unable to verify transaction: a single spent output must be provided for each transaction input.";let l=gt(o).length;if(l<Be.minimumTransactionSize)return`Invalid transaction size: the transaction is ${l} bytes, but transactions must be no smaller than ${Be.minimumTransactionSize} bytes to prevent an exploit of the transaction Merkle tree design.`;if(l>Be.maximumTransactionSize)return`Transaction exceeds maximum size: the transaction is ${l} bytes, but the maximum transaction size is ${Be.maximumTransactionSize} bytes.`;let I=t.reduce((N,c)=>N+c.valueSatoshis,0n),E=o.outputs.reduce((N,c)=>N+c.valueSatoshis,0n);if(E>I)return`Unable to verify transaction: the sum of transaction outputs exceeds the sum of transaction inputs. Input value: ${I}, output value: ${E}`;let u=o.inputs.map(N=>`outpointTransactionHash: ${$(N.outpointTransactionHash)}, outpointIndex: ${N.outpointIndex}`),k=u.find((N,c)=>u.lastIndexOf(N)!==c);if(k!==void 0)return`Unable to verify transaction: the transaction attempts to spend the same outpoint in multiple inputs. ${k}`;if(e){if(o.version<1||o.version>Be.maximumStandardVersion)return`Standard transactions must have a version no less than 1 and no greater than ${Be.maximumStandardVersion}.`;if(l>Be.maximumStandardTransactionSize)return`Transaction exceeds maximum standard size: this transaction is ${l} bytes, but the maximum standard transaction size is ${Be.maximumStandardTransactionSize} bytes.`;for(let[c,B]of t.entries())if(!Sn(B.lockingBytecode))return`Standard transactions may only spend standard output types, but source output ${c} is non-standard.`;let N=0;for(let[c,B]of o.outputs.entries()){if(!Sn(B.lockingBytecode))return`Standard transactions may only create standard output types, but transaction output ${c} is non-standard.`;if(wA(B.lockingBytecode)&&(N+=B.lockingBytecode.length+1),ms(B))return`Standard transactions may not have dust outputs, but transaction output ${c} is a dust output. Output ${c} must have a value of at least ${Pn(B)} satoshis. Current value: ${B.valueSatoshis}`}if(N>Be.maximumDataCarrierBytes)return`Standard transactions may carry no more than ${Be.maximumDataCarrierBytes} bytes in arbitrary data outputs; this transaction includes ${N} bytes of arbitrary data.`;for(let[c,B]of o.inputs.entries()){if(B.unlockingBytecode.length>Be.maximumStandardUnlockingBytecodeLength)return`Input index ${c} is non-standard: the unlocking bytecode (${B.unlockingBytecode.length} bytes) exceeds the maximum standard unlocking bytecode length (${Be.maximumStandardUnlockingBytecodeLength} bytes).`;if(!bA(B.unlockingBytecode))return`Input index ${c} is non-standard: unlocking bytecode may contain only push operations.`}}let U=Us(o,t);if(U!==!0)return U;for(let N of o.inputs.keys()){let c=s({inputIndex:N,sourceOutputs:t,transaction:o}),B=g(c);if(typeof B=="string")return`Error in evaluating input index ${N}: ${B}`}return!0}}},xm=Rn;var RA=e=>{let a=qr(256).map(P=>e.operations[P]??e.undefined),r=P=>P.instructions[P.ip],n=P=>(P.ip+=1,P),i=P=>a[r(P).opcode],t=(P=>P),o=e.every??t,s=P=>{let h=i(P);return n(o(h(P)))},g=e.continue,l=(P,h)=>{for(;g(P);)P=h(P);return P},I=e.clone,{success:E}=e,u=P=>l(I(P),s),k=P=>{let h=i(P);return n(o(h(I(P))))},U=P=>{let h=[];return h.push(P),l(P,y=>{let p=k(y);return h.push(p),p}),h},N=P=>s(I(P)),c=P=>e.evaluate(P,u);return{debug:P=>{let h=[],y=C=>{let b=U(C);return h.push(...b),b[b.length-1]??C},p=e.evaluate(P,y);return[...h,p]},evaluate:c,stateClone:I,stateContinue:g,stateDebug:U,stateEvaluate:u,stateStep:N,stateStepMutate:s,stateSuccess:E,verify:P=>e.verify(P,c,E)}},Fm=RA;var ll=(e=!0)=>RA(Rn(e)),ws=ll;var fr=(e=!0,{ripemd160:A,secp256k1:a,sha1:r,sha256:n}={ripemd160:Ee,secp256k1:Ae,sha1:fA,sha256:q})=>{let i=hr();return{clone:ka,continue:t=>t.error===void 0&&t.ip<t.instructions.length,evaluate:(t,o)=>{let{unlockingBytecode:s}=t.transaction.inputs[t.inputIndex],{lockingBytecode:g}=t.sourceOutputs[t.inputIndex],l=we(s),I=we(g),E=jA({instructions:l,program:t,stack:[]});if(s.length>re.maximumBytecodeLength)return w(E,`The provided unlocking bytecode (${s.length} bytes) exceeds the maximum bytecode length (${re.maximumBytecodeLength} bytes).`);if(tA(l))return w(E,v.malformedUnlockingBytecode);if(!bA(s))return w(E,v.requiresPushOnly);if(g.length>re.maximumBytecodeLength)return w(E,v.exceededMaximumBytecodeLengthLocking);if(tA(I))return w(E,v.malformedLockingBytecode);let u=o(E);if(u.error!==void 0)return u;if(u.controlStack.length!==0)return w(E,v.nonEmptyControlStack);let k=o(jA({instructions:I,program:t,stack:u.stack}));if(!PA(g))return k;let U=BA(u.stack),N=U.pop()??Uint8Array.of();if(U.length===0&&Dt(N))return k;let c=we(N);return tA(c)?{...k,error:v.malformedP2shBytecode}:o(jA({instructions:c,program:t,stack:U}))},every:t=>t.stack.length+t.alternateStack.length>re.maximumStackDepth?w(t,v.exceededMaximumStackDepth):t.operationCount>re.maximumOperationCount?w(t,v.exceededMaximumOperationCount):t,operations:{[f.OP_0]:i,[f.OP_PUSHBYTES_1]:i,[f.OP_PUSHBYTES_2]:i,[f.OP_PUSHBYTES_3]:i,[f.OP_PUSHBYTES_4]:i,[f.OP_PUSHBYTES_5]:i,[f.OP_PUSHBYTES_6]:i,[f.OP_PUSHBYTES_7]:i,[f.OP_PUSHBYTES_8]:i,[f.OP_PUSHBYTES_9]:i,[f.OP_PUSHBYTES_10]:i,[f.OP_PUSHBYTES_11]:i,[f.OP_PUSHBYTES_12]:i,[f.OP_PUSHBYTES_13]:i,[f.OP_PUSHBYTES_14]:i,[f.OP_PUSHBYTES_15]:i,[f.OP_PUSHBYTES_16]:i,[f.OP_PUSHBYTES_17]:i,[f.OP_PUSHBYTES_18]:i,[f.OP_PUSHBYTES_19]:i,[f.OP_PUSHBYTES_20]:i,[f.OP_PUSHBYTES_21]:i,[f.OP_PUSHBYTES_22]:i,[f.OP_PUSHBYTES_23]:i,[f.OP_PUSHBYTES_24]:i,[f.OP_PUSHBYTES_25]:i,[f.OP_PUSHBYTES_26]:i,[f.OP_PUSHBYTES_27]:i,[f.OP_PUSHBYTES_28]:i,[f.OP_PUSHBYTES_29]:i,[f.OP_PUSHBYTES_30]:i,[f.OP_PUSHBYTES_31]:i,[f.OP_PUSHBYTES_32]:i,[f.OP_PUSHBYTES_33]:i,[f.OP_PUSHBYTES_34]:i,[f.OP_PUSHBYTES_35]:i,[f.OP_PUSHBYTES_36]:i,[f.OP_PUSHBYTES_37]:i,[f.OP_PUSHBYTES_38]:i,[f.OP_PUSHBYTES_39]:i,[f.OP_PUSHBYTES_40]:i,[f.OP_PUSHBYTES_41]:i,[f.OP_PUSHBYTES_42]:i,[f.OP_PUSHBYTES_43]:i,[f.OP_PUSHBYTES_44]:i,[f.OP_PUSHBYTES_45]:i,[f.OP_PUSHBYTES_46]:i,[f.OP_PUSHBYTES_47]:i,[f.OP_PUSHBYTES_48]:i,[f.OP_PUSHBYTES_49]:i,[f.OP_PUSHBYTES_50]:i,[f.OP_PUSHBYTES_51]:i,[f.OP_PUSHBYTES_52]:i,[f.OP_PUSHBYTES_53]:i,[f.OP_PUSHBYTES_54]:i,[f.OP_PUSHBYTES_55]:i,[f.OP_PUSHBYTES_56]:i,[f.OP_PUSHBYTES_57]:i,[f.OP_PUSHBYTES_58]:i,[f.OP_PUSHBYTES_59]:i,[f.OP_PUSHBYTES_60]:i,[f.OP_PUSHBYTES_61]:i,[f.OP_PUSHBYTES_62]:i,[f.OP_PUSHBYTES_63]:i,[f.OP_PUSHBYTES_64]:i,[f.OP_PUSHBYTES_65]:i,[f.OP_PUSHBYTES_66]:i,[f.OP_PUSHBYTES_67]:i,[f.OP_PUSHBYTES_68]:i,[f.OP_PUSHBYTES_69]:i,[f.OP_PUSHBYTES_70]:i,[f.OP_PUSHBYTES_71]:i,[f.OP_PUSHBYTES_72]:i,[f.OP_PUSHBYTES_73]:i,[f.OP_PUSHBYTES_74]:i,[f.OP_PUSHBYTES_75]:i,[f.OP_PUSHDATA_1]:i,[f.OP_PUSHDATA_2]:i,[f.OP_PUSHDATA_4]:i,[f.OP_1NEGATE]:d(z(-1)),[f.OP_RESERVED]:d(Ye),[f.OP_1]:d(z(1)),[f.OP_2]:d(z(2)),[f.OP_3]:d(z(3)),[f.OP_4]:d(z(4)),[f.OP_5]:d(z(5)),[f.OP_6]:d(z(6)),[f.OP_7]:d(z(7)),[f.OP_8]:d(z(8)),[f.OP_9]:d(z(9)),[f.OP_10]:d(z(10)),[f.OP_11]:d(z(11)),[f.OP_12]:d(z(12)),[f.OP_13]:d(z(13)),[f.OP_14]:d(z(14)),[f.OP_15]:d(z(15)),[f.OP_16]:d(z(16)),...Yt([Tt],{[f.OP_NOP]:d(Ie),[f.OP_VER]:d(Ye),[f.OP_IF]:gr,[f.OP_NOTIF]:Ir,[f.OP_VERIF]:Ye,[f.OP_VERNOTIF]:Ye,[f.OP_ELSE]:lr,[f.OP_ENDIF]:cr,[f.OP_VERIFY]:d(me),[f.OP_RETURN]:d(xt),[f.OP_TOALTSTACK]:d(Oi),[f.OP_FROMALTSTACK]:d(Ri),[f.OP_2DROP]:d(Fi),[f.OP_2DUP]:d(Ki),[f.OP_3DUP]:d(Mi),[f.OP_2OVER]:d(Gi),[f.OP_2ROT]:d(qi),[f.OP_2SWAP]:d(Hi),[f.OP_IFDUP]:d(Ji),[f.OP_DEPTH]:d(Li),[f.OP_DROP]:d(Vi),[f.OP_DUP]:d(zi),[f.OP_NIP]:d(ji),[f.OP_OVER]:d(Wi),[f.OP_PICK]:d(Zi),[f.OP_ROLL]:d(Xi),[f.OP_ROT]:d($i),[f.OP_SWAP]:d(ea),[f.OP_TUCK]:d(Aa),[f.OP_CAT]:d(Bi),[f.OP_SPLIT]:d(pi),[f.OP_NUM2BIN]:d(mi),[f.OP_BIN2NUM]:d(Qi),[f.OP_SIZE]:d(ta),[f.OP_INVERT]:Te,[f.OP_AND]:d(ni),[f.OP_OR]:d(oi),[f.OP_XOR]:d(si),[f.OP_EQUAL]:d(lt),[f.OP_EQUALVERIFY]:d(ri),[f.OP_RESERVED1]:d(Ye),[f.OP_RESERVED2]:d(Ye),[f.OP_1ADD]:d(Ot),[f.OP_1SUB]:d(Rt),[f.OP_2MUL]:Te,[f.OP_2DIV]:Te,[f.OP_NEGATE]:d(Ft),[f.OP_ABS]:d(Kt),[f.OP_NOT]:d(Mt),[f.OP_0NOTEQUAL]:d(Gt),[f.OP_ADD]:d(qt),[f.OP_SUB]:d(Ht),[f.OP_MUL]:d(ti),[f.OP_DIV]:d(ii),[f.OP_MOD]:d(ai),[f.OP_LSHIFT]:Te,[f.OP_RSHIFT]:Te,[f.OP_BOOLAND]:d(Jt),[f.OP_BOOLOR]:d(Lt),[f.OP_NUMEQUAL]:d(ct),[f.OP_NUMEQUALVERIFY]:d(Vt),[f.OP_NUMNOTEQUAL]:d(zt),[f.OP_LESSTHAN]:d(jt),[f.OP_GREATERTHAN]:d(Zt),[f.OP_LESSTHANOREQUAL]:d(Wt),[f.OP_GREATERTHANOREQUAL]:d(Xt),[f.OP_MIN]:d($t),[f.OP_MAX]:d(ei),[f.OP_WITHIN]:d(Ai),[f.OP_RIPEMD160]:d(gi({ripemd160:A})),[f.OP_SHA1]:d(Ii({sha1:r})),[f.OP_SHA256]:d(ci({sha256:n})),[f.OP_HASH160]:d(li({ripemd160:A,sha256:n})),[f.OP_HASH256]:d(ui({sha256:n})),[f.OP_CODESEPARATOR]:d(hi),[f.OP_CHECKSIG]:d(Un({secp256k1:a,sha256:n})),[f.OP_CHECKSIGVERIFY]:d(Ps({secp256k1:a,sha256:n})),[f.OP_CHECKMULTISIG]:d(_n({secp256k1:a,sha256:n})),[f.OP_CHECKMULTISIGVERIFY]:d(Ss({secp256k1:a,sha256:n})),...e?{[f.OP_NOP1]:d(ue),[f.OP_CHECKLOCKTIMEVERIFY]:d(xA),[f.OP_CHECKSEQUENCEVERIFY]:d(OA),[f.OP_NOP4]:d(ue),[f.OP_NOP5]:d(ue),[f.OP_NOP6]:d(ue),[f.OP_NOP7]:d(ue),[f.OP_NOP8]:d(ue),[f.OP_NOP9]:d(ue),[f.OP_NOP10]:d(ue)}:{[f.OP_NOP1]:d(Ie),[f.OP_CHECKLOCKTIMEVERIFY]:d(xA),[f.OP_CHECKSEQUENCEVERIFY]:d(OA),[f.OP_NOP4]:d(Ie),[f.OP_NOP5]:d(Ie),[f.OP_NOP6]:d(Ie),[f.OP_NOP7]:d(Ie),[f.OP_NOP8]:d(Ie),[f.OP_NOP9]:d(Ie),[f.OP_NOP10]:d(Ie)},[f.OP_CHECKDATASIG]:d(ut({secp256k1:a,sha256:n})),[f.OP_CHECKDATASIGVERIFY]:d(di({secp256k1:a,sha256:n})),[f.OP_REVERSEBYTES]:d(Ei),[f.OP_INPUTINDEX]:d(yi),[f.OP_ACTIVEBYTECODE]:d(fi),[f.OP_TXVERSION]:d(Ci),[f.OP_TXINPUTCOUNT]:d(Pi),[f.OP_TXOUTPUTCOUNT]:d(Si),[f.OP_TXLOCKTIME]:d(bi),[f.OP_UTXOVALUE]:d(Ni),[f.OP_UTXOBYTECODE]:d(Ui),[f.OP_OUTPOINTTXHASH]:d(_i),[f.OP_OUTPOINTINDEX]:d(vi),[f.OP_INPUTBYTECODE]:d(Di),[f.OP_INPUTSEQUENCENUMBER]:d(wi),[f.OP_OUTPUTVALUE]:d(Yi),[f.OP_OUTPUTBYTECODE]:d(xi)})},success:t=>t.error!==void 0?t.error:t.controlStack.length!==0?v.nonEmptyControlStack:t.stack.length!==1?v.requiresCleanStack:We(t.stack[0])?!0:v.unsuccessfulEvaluation,undefined:xe,verify:({sourceOutputs:t,transaction:o},s,g)=>{if(o.inputs.length===0)return"Transactions must have at least one input.";if(o.outputs.length===0)return"Transactions must have at least one output.";if(o.inputs.length!==t.length)return"Unable to verify transaction: a single spent output must be provided for each transaction input.";let l=gt(o).length;if(l<re.minimumTransactionSize)return`Transaction does not meet minimum size: the transaction is ${l} bytes, but the minimum transaction size is ${re.minimumTransactionSize} bytes.`;if(l>re.maximumTransactionSize)return`Transaction exceeds maximum size: the transaction is ${l} bytes, but the maximum transaction size is ${re.maximumTransactionSize} bytes.`;if(e){if(o.version<1||o.version>re.maximumStandardVersion)return`Standard transactions must have a version no less than 1 and no greater than ${re.maximumStandardVersion}.`;if(l>re.maximumStandardTransactionSize)return`Transaction exceeds maximum standard size: this transaction is ${l} bytes, but the maximum standard transaction size is ${re.maximumStandardTransactionSize} bytes.`;for(let[E,u]of t.entries())if(!vt(u.lockingBytecode))return`Standard transactions may only spend standard output types, but source output ${E} is non-standard.`;let I=0;for(let[E,u]of o.outputs.entries()){if(!vt(u.lockingBytecode))return`Standard transactions may only create standard output types, but transaction output ${E} is non-standard.`;wA(u.lockingBytecode)&&(I+=u.lockingBytecode.length+1)}if(I>re.maximumDataCarrierBytes)return`Standard transactions may carry no more than ${re.maximumDataCarrierBytes} bytes in arbitrary data outputs; this transaction includes ${I} bytes of arbitrary data.`;for(let[E,u]of o.inputs.entries()){if(u.unlockingBytecode.length>re.maximumStandardUnlockingBytecodeLength)return`Input index ${E} is non-standard: the unlocking bytecode (${u.unlockingBytecode.length} bytes) exceeds the maximum standard unlocking bytecode length (${re.maximumStandardUnlockingBytecodeLength} bytes).`;if(!bA(u.unlockingBytecode))return`Input index ${E} is non-standard: unlocking bytecode may contain only push operations.`}}for(let I of o.inputs.keys()){let E=s({inputIndex:I,sourceOutputs:t,transaction:o}),u=g(E);if(typeof u=="string")return`Error in evaluating input index ${I}: ${u}`}return!0}}};var Z;(function(e){e[e.OP_0=0]="OP_0",e[e.OP_PUSHBYTES_1=1]="OP_PUSHBYTES_1",e[e.OP_PUSHBYTES_2=2]="OP_PUSHBYTES_2",e[e.OP_PUSHBYTES_3=3]="OP_PUSHBYTES_3",e[e.OP_PUSHBYTES_4=4]="OP_PUSHBYTES_4",e[e.OP_PUSHBYTES_5=5]="OP_PUSHBYTES_5",e[e.OP_PUSHBYTES_6=6]="OP_PUSHBYTES_6",e[e.OP_PUSHBYTES_7=7]="OP_PUSHBYTES_7",e[e.OP_PUSHBYTES_8=8]="OP_PUSHBYTES_8",e[e.OP_PUSHBYTES_9=9]="OP_PUSHBYTES_9",e[e.OP_PUSHBYTES_10=10]="OP_PUSHBYTES_10",e[e.OP_PUSHBYTES_11=11]="OP_PUSHBYTES_11",e[e.OP_PUSHBYTES_12=12]="OP_PUSHBYTES_12",e[e.OP_PUSHBYTES_13=13]="OP_PUSHBYTES_13",e[e.OP_PUSHBYTES_14=14]="OP_PUSHBYTES_14",e[e.OP_PUSHBYTES_15=15]="OP_PUSHBYTES_15",e[e.OP_PUSHBYTES_16=16]="OP_PUSHBYTES_16",e[e.OP_PUSHBYTES_17=17]="OP_PUSHBYTES_17",e[e.OP_PUSHBYTES_18=18]="OP_PUSHBYTES_18",e[e.OP_PUSHBYTES_19=19]="OP_PUSHBYTES_19",e[e.OP_PUSHBYTES_20=20]="OP_PUSHBYTES_20",e[e.OP_PUSHBYTES_21=21]="OP_PUSHBYTES_21",e[e.OP_PUSHBYTES_22=22]="OP_PUSHBYTES_22",e[e.OP_PUSHBYTES_23=23]="OP_PUSHBYTES_23",e[e.OP_PUSHBYTES_24=24]="OP_PUSHBYTES_24",e[e.OP_PUSHBYTES_25=25]="OP_PUSHBYTES_25",e[e.OP_PUSHBYTES_26=26]="OP_PUSHBYTES_26",e[e.OP_PUSHBYTES_27=27]="OP_PUSHBYTES_27",e[e.OP_PUSHBYTES_28=28]="OP_PUSHBYTES_28",e[e.OP_PUSHBYTES_29=29]="OP_PUSHBYTES_29",e[e.OP_PUSHBYTES_30=30]="OP_PUSHBYTES_30",e[e.OP_PUSHBYTES_31=31]="OP_PUSHBYTES_31",e[e.OP_PUSHBYTES_32=32]="OP_PUSHBYTES_32",e[e.OP_PUSHBYTES_33=33]="OP_PUSHBYTES_33",e[e.OP_PUSHBYTES_34=34]="OP_PUSHBYTES_34",e[e.OP_PUSHBYTES_35=35]="OP_PUSHBYTES_35",e[e.OP_PUSHBYTES_36=36]="OP_PUSHBYTES_36",e[e.OP_PUSHBYTES_37=37]="OP_PUSHBYTES_37",e[e.OP_PUSHBYTES_38=38]="OP_PUSHBYTES_38",e[e.OP_PUSHBYTES_39=39]="OP_PUSHBYTES_39",e[e.OP_PUSHBYTES_40=40]="OP_PUSHBYTES_40",e[e.OP_PUSHBYTES_41=41]="OP_PUSHBYTES_41",e[e.OP_PUSHBYTES_42=42]="OP_PUSHBYTES_42",e[e.OP_PUSHBYTES_43=43]="OP_PUSHBYTES_43",e[e.OP_PUSHBYTES_44=44]="OP_PUSHBYTES_44",e[e.OP_PUSHBYTES_45=45]="OP_PUSHBYTES_45",e[e.OP_PUSHBYTES_46=46]="OP_PUSHBYTES_46",e[e.OP_PUSHBYTES_47=47]="OP_PUSHBYTES_47",e[e.OP_PUSHBYTES_48=48]="OP_PUSHBYTES_48",e[e.OP_PUSHBYTES_49=49]="OP_PUSHBYTES_49",e[e.OP_PUSHBYTES_50=50]="OP_PUSHBYTES_50",e[e.OP_PUSHBYTES_51=51]="OP_PUSHBYTES_51",e[e.OP_PUSHBYTES_52=52]="OP_PUSHBYTES_52",e[e.OP_PUSHBYTES_53=53]="OP_PUSHBYTES_53",e[e.OP_PUSHBYTES_54=54]="OP_PUSHBYTES_54",e[e.OP_PUSHBYTES_55=55]="OP_PUSHBYTES_55",e[e.OP_PUSHBYTES_56=56]="OP_PUSHBYTES_56",e[e.OP_PUSHBYTES_57=57]="OP_PUSHBYTES_57",e[e.OP_PUSHBYTES_58=58]="OP_PUSHBYTES_58",e[e.OP_PUSHBYTES_59=59]="OP_PUSHBYTES_59",e[e.OP_PUSHBYTES_60=60]="OP_PUSHBYTES_60",e[e.OP_PUSHBYTES_61=61]="OP_PUSHBYTES_61",e[e.OP_PUSHBYTES_62=62]="OP_PUSHBYTES_62",e[e.OP_PUSHBYTES_63=63]="OP_PUSHBYTES_63",e[e.OP_PUSHBYTES_64=64]="OP_PUSHBYTES_64",e[e.OP_PUSHBYTES_65=65]="OP_PUSHBYTES_65",e[e.OP_PUSHBYTES_66=66]="OP_PUSHBYTES_66",e[e.OP_PUSHBYTES_67=67]="OP_PUSHBYTES_67",e[e.OP_PUSHBYTES_68=68]="OP_PUSHBYTES_68",e[e.OP_PUSHBYTES_69=69]="OP_PUSHBYTES_69",e[e.OP_PUSHBYTES_70=70]="OP_PUSHBYTES_70",e[e.OP_PUSHBYTES_71=71]="OP_PUSHBYTES_71",e[e.OP_PUSHBYTES_72=72]="OP_PUSHBYTES_72",e[e.OP_PUSHBYTES_73=73]="OP_PUSHBYTES_73",e[e.OP_PUSHBYTES_74=74]="OP_PUSHBYTES_74",e[e.OP_PUSHBYTES_75=75]="OP_PUSHBYTES_75",e[e.OP_PUSHDATA_1=76]="OP_PUSHDATA_1",e[e.OP_PUSHDATA_2=77]="OP_PUSHDATA_2",e[e.OP_PUSHDATA_4=78]="OP_PUSHDATA_4",e[e.OP_1NEGATE=79]="OP_1NEGATE",e[e.OP_RESERVED=80]="OP_RESERVED",e[e.OP_1=81]="OP_1",e[e.OP_2=82]="OP_2",e[e.OP_3=83]="OP_3",e[e.OP_4=84]="OP_4",e[e.OP_5=85]="OP_5",e[e.OP_6=86]="OP_6",e[e.OP_7=87]="OP_7",e[e.OP_8=88]="OP_8",e[e.OP_9=89]="OP_9",e[e.OP_10=90]="OP_10",e[e.OP_11=91]="OP_11",e[e.OP_12=92]="OP_12",e[e.OP_13=93]="OP_13",e[e.OP_14=94]="OP_14",e[e.OP_15=95]="OP_15",e[e.OP_16=96]="OP_16",e[e.OP_NOP=97]="OP_NOP",e[e.OP_VER=98]="OP_VER",e[e.OP_IF=99]="OP_IF",e[e.OP_NOTIF=100]="OP_NOTIF",e[e.OP_VERIF=101]="OP_VERIF",e[e.OP_VERNOTIF=102]="OP_VERNOTIF",e[e.OP_ELSE=103]="OP_ELSE",e[e.OP_ENDIF=104]="OP_ENDIF",e[e.OP_VERIFY=105]="OP_VERIFY",e[e.OP_RETURN=106]="OP_RETURN",e[e.OP_TOALTSTACK=107]="OP_TOALTSTACK",e[e.OP_FROMALTSTACK=108]="OP_FROMALTSTACK",e[e.OP_2DROP=109]="OP_2DROP",e[e.OP_2DUP=110]="OP_2DUP",e[e.OP_3DUP=111]="OP_3DUP",e[e.OP_2OVER=112]="OP_2OVER",e[e.OP_2ROT=113]="OP_2ROT",e[e.OP_2SWAP=114]="OP_2SWAP",e[e.OP_IFDUP=115]="OP_IFDUP",e[e.OP_DEPTH=116]="OP_DEPTH",e[e.OP_DROP=117]="OP_DROP",e[e.OP_DUP=118]="OP_DUP",e[e.OP_NIP=119]="OP_NIP",e[e.OP_OVER=120]="OP_OVER",e[e.OP_PICK=121]="OP_PICK",e[e.OP_ROLL=122]="OP_ROLL",e[e.OP_ROT=123]="OP_ROT",e[e.OP_SWAP=124]="OP_SWAP",e[e.OP_TUCK=125]="OP_TUCK",e[e.OP_CAT=126]="OP_CAT",e[e.OP_SPLIT=127]="OP_SPLIT",e[e.OP_NUM2BIN=128]="OP_NUM2BIN",e[e.OP_BIN2NUM=129]="OP_BIN2NUM",e[e.OP_SIZE=130]="OP_SIZE",e[e.OP_INVERT=131]="OP_INVERT",e[e.OP_AND=132]="OP_AND",e[e.OP_OR=133]="OP_OR",e[e.OP_XOR=134]="OP_XOR",e[e.OP_EQUAL=135]="OP_EQUAL",e[e.OP_EQUALVERIFY=136]="OP_EQUALVERIFY",e[e.OP_RESERVED1=137]="OP_RESERVED1",e[e.OP_RESERVED2=138]="OP_RESERVED2",e[e.OP_1ADD=139]="OP_1ADD",e[e.OP_1SUB=140]="OP_1SUB",e[e.OP_2MUL=141]="OP_2MUL",e[e.OP_2DIV=142]="OP_2DIV",e[e.OP_NEGATE=143]="OP_NEGATE",e[e.OP_ABS=144]="OP_ABS",e[e.OP_NOT=145]="OP_NOT",e[e.OP_0NOTEQUAL=146]="OP_0NOTEQUAL",e[e.OP_ADD=147]="OP_ADD",e[e.OP_SUB=148]="OP_SUB",e[e.OP_MUL=149]="OP_MUL",e[e.OP_DIV=150]="OP_DIV",e[e.OP_MOD=151]="OP_MOD",e[e.OP_LSHIFT=152]="OP_LSHIFT",e[e.OP_RSHIFT=153]="OP_RSHIFT",e[e.OP_BOOLAND=154]="OP_BOOLAND",e[e.OP_BOOLOR=155]="OP_BOOLOR",e[e.OP_NUMEQUAL=156]="OP_NUMEQUAL",e[e.OP_NUMEQUALVERIFY=157]="OP_NUMEQUALVERIFY",e[e.OP_NUMNOTEQUAL=158]="OP_NUMNOTEQUAL",e[e.OP_LESSTHAN=159]="OP_LESSTHAN",e[e.OP_GREATERTHAN=160]="OP_GREATERTHAN",e[e.OP_LESSTHANOREQUAL=161]="OP_LESSTHANOREQUAL",e[e.OP_GREATERTHANOREQUAL=162]="OP_GREATERTHANOREQUAL",e[e.OP_MIN=163]="OP_MIN",e[e.OP_MAX=164]="OP_MAX",e[e.OP_WITHIN=165]="OP_WITHIN",e[e.OP_RIPEMD160=166]="OP_RIPEMD160",e[e.OP_SHA1=167]="OP_SHA1",e[e.OP_SHA256=168]="OP_SHA256",e[e.OP_HASH160=169]="OP_HASH160",e[e.OP_HASH256=170]="OP_HASH256",e[e.OP_CODESEPARATOR=171]="OP_CODESEPARATOR",e[e.OP_CHECKSIG=172]="OP_CHECKSIG",e[e.OP_CHECKSIGVERIFY=173]="OP_CHECKSIGVERIFY",e[e.OP_CHECKMULTISIG=174]="OP_CHECKMULTISIG",e[e.OP_CHECKMULTISIGVERIFY=175]="OP_CHECKMULTISIGVERIFY",e[e.OP_NOP1=176]="OP_NOP1",e[e.OP_CHECKLOCKTIMEVERIFY=177]="OP_CHECKLOCKTIMEVERIFY",e[e.OP_CHECKSEQUENCEVERIFY=178]="OP_CHECKSEQUENCEVERIFY",e[e.OP_NOP4=179]="OP_NOP4",e[e.OP_NOP5=180]="OP_NOP5",e[e.OP_NOP6=181]="OP_NOP6",e[e.OP_NOP7=182]="OP_NOP7",e[e.OP_NOP8=183]="OP_NOP8",e[e.OP_NOP9=184]="OP_NOP9",e[e.OP_NOP10=185]="OP_NOP10",e[e.OP_CHECKDATASIG=186]="OP_CHECKDATASIG",e[e.OP_CHECKDATASIGVERIFY=187]="OP_CHECKDATASIGVERIFY",e[e.OP_REVERSEBYTES=188]="OP_REVERSEBYTES",e[e.OP_UNKNOWN189=189]="OP_UNKNOWN189",e[e.OP_UNKNOWN190=190]="OP_UNKNOWN190",e[e.OP_UNKNOWN191=191]="OP_UNKNOWN191",e[e.OP_INPUTINDEX=192]="OP_INPUTINDEX",e[e.OP_ACTIVEBYTECODE=193]="OP_ACTIVEBYTECODE",e[e.OP_TXVERSION=194]="OP_TXVERSION",e[e.OP_TXINPUTCOUNT=195]="OP_TXINPUTCOUNT",e[e.OP_TXOUTPUTCOUNT=196]="OP_TXOUTPUTCOUNT",e[e.OP_TXLOCKTIME=197]="OP_TXLOCKTIME",e[e.OP_UTXOVALUE=198]="OP_UTXOVALUE",e[e.OP_UTXOBYTECODE=199]="OP_UTXOBYTECODE",e[e.OP_OUTPOINTTXHASH=200]="OP_OUTPOINTTXHASH",e[e.OP_OUTPOINTINDEX=201]="OP_OUTPOINTINDEX",e[e.OP_INPUTBYTECODE=202]="OP_INPUTBYTECODE",e[e.OP_INPUTSEQUENCENUMBER=203]="OP_INPUTSEQUENCENUMBER",e[e.OP_OUTPUTVALUE=204]="OP_OUTPUTVALUE",e[e.OP_OUTPUTBYTECODE=205]="OP_OUTPUTBYTECODE",e[e.OP_RESERVED3=206]="OP_RESERVED3",e[e.OP_RESERVED4=207]="OP_RESERVED4",e[e.OP_UNKNOWN208=208]="OP_UNKNOWN208",e[e.OP_UNKNOWN209=209]="OP_UNKNOWN209",e[e.OP_UNKNOWN210=210]="OP_UNKNOWN210",e[e.OP_UNKNOWN211=211]="OP_UNKNOWN211",e[e.OP_UNKNOWN212=212]="OP_UNKNOWN212",e[e.OP_UNKNOWN213=213]="OP_UNKNOWN213",e[e.OP_UNKNOWN214=214]="OP_UNKNOWN214",e[e.OP_UNKNOWN215=215]="OP_UNKNOWN215",e[e.OP_UNKNOWN216=216]="OP_UNKNOWN216",e[e.OP_UNKNOWN217=217]="OP_UNKNOWN217",e[e.OP_UNKNOWN218=218]="OP_UNKNOWN218",e[e.OP_UNKNOWN219=219]="OP_UNKNOWN219",e[e.OP_UNKNOWN220=220]="OP_UNKNOWN220",e[e.OP_UNKNOWN221=221]="OP_UNKNOWN221",e[e.OP_UNKNOWN222=222]="OP_UNKNOWN222",e[e.OP_UNKNOWN223=223]="OP_UNKNOWN223",e[e.OP_UNKNOWN224=224]="OP_UNKNOWN224",e[e.OP_UNKNOWN225=225]="OP_UNKNOWN225",e[e.OP_UNKNOWN226=226]="OP_UNKNOWN226",e[e.OP_UNKNOWN227=227]="OP_UNKNOWN227",e[e.OP_UNKNOWN228=228]="OP_UNKNOWN228",e[e.OP_UNKNOWN229=229]="OP_UNKNOWN229",e[e.OP_UNKNOWN230=230]="OP_UNKNOWN230",e[e.OP_UNKNOWN231=231]="OP_UNKNOWN231",e[e.OP_UNKNOWN232=232]="OP_UNKNOWN232",e[e.OP_UNKNOWN233=233]="OP_UNKNOWN233",e[e.OP_UNKNOWN234=234]="OP_UNKNOWN234",e[e.OP_UNKNOWN235=235]="OP_UNKNOWN235",e[e.OP_UNKNOWN236=236]="OP_UNKNOWN236",e[e.OP_UNKNOWN237=237]="OP_UNKNOWN237",e[e.OP_UNKNOWN238=238]="OP_UNKNOWN238",e[e.OP_UNKNOWN239=239]="OP_UNKNOWN239",e[e.OP_UNKNOWN240=240]="OP_UNKNOWN240",e[e.OP_UNKNOWN241=241]="OP_UNKNOWN241",e[e.OP_UNKNOWN242=242]="OP_UNKNOWN242",e[e.OP_UNKNOWN243=243]="OP_UNKNOWN243",e[e.OP_UNKNOWN244=244]="OP_UNKNOWN244",e[e.OP_UNKNOWN245=245]="OP_UNKNOWN245",e[e.OP_UNKNOWN246=246]="OP_UNKNOWN246",e[e.OP_UNKNOWN247=247]="OP_UNKNOWN247",e[e.OP_UNKNOWN248=248]="OP_UNKNOWN248",e[e.OP_UNKNOWN249=249]="OP_UNKNOWN249",e[e.OP_UNKNOWN250=250]="OP_UNKNOWN250",e[e.OP_UNKNOWN251=251]="OP_UNKNOWN251",e[e.OP_UNKNOWN252=252]="OP_UNKNOWN252",e[e.OP_UNKNOWN253=253]="OP_UNKNOWN253",e[e.OP_UNKNOWN254=254]="OP_UNKNOWN254",e[e.OP_UNKNOWN255=255]="OP_UNKNOWN255"})(Z||(Z={}));var WA;(function(e){e[e.maximumStackItemLength=520]="maximumStackItemLength",e[e.maximumVmNumberLength=4]="maximumVmNumberLength",e[e.maximumOperationCount=201]="maximumOperationCount",e[e.maximumBytecodeLength=1e4]="maximumBytecodeLength",e[e.maximumStackDepth=1e3]="maximumStackDepth",e[e.schnorrSignatureLength=64]="schnorrSignatureLength"})(WA||(WA={}));var ke=WA.maximumVmNumberLength,Ts=e=>X(e,(A,a)=>{let r=A.stack[A.stack.length-1-Number(a)];return r===void 0?w(e,v.invalidStackIndex):M(A,r.slice())}),Ys=e=>X(e,(A,a)=>{let r=A.stack.length-1-Number(a);return r<0||r>A.stack.length-1?w(e,v.invalidStackIndex):M(A,A.stack.splice(r,1)[0])}),xs=e=>X(e,(A,a)=>{let r=Number(a);return te(A,(n,[i])=>r<0||r>i.length?w(n,v.invalidSplitIndex):M(n,i.slice(0,r),i.slice(r)))},{maximumVmNumberByteLength:ke}),Os=e=>X(e,(A,a)=>{let r=Number(a);return r>WA.maximumStackItemLength?w(A,v.exceededMaximumStackItemLength):X(A,(n,[i])=>{let t=W(i);return t.length>r?w(n,v.insufficientLength):t.length===r?M(n,t):M(n,Dn(t,r))},{maximumVmNumberByteLength:WA.maximumStackItemLength,requireMinimalEncoding:!1})}),Rs=e=>X(e,(A,[a])=>{let r=W(a);return r.length>WA.maximumVmNumberLength?w(A,v.exceededMaximumVmNumberLength):M(A,r)},{maximumVmNumberByteLength:WA.maximumStackItemLength,requireMinimalEncoding:!1}),Fs=e=>X(e,(A,[a])=>M(A,W(a+1n)),{maximumVmNumberByteLength:ke}),Ks=e=>X(e,(A,[a])=>M(A,W(a-1n)),{maximumVmNumberByteLength:ke}),Ms=e=>X(e,(A,[a])=>M(A,W(-a)),{maximumVmNumberByteLength:ke}),Gs=e=>X(e,(A,[a])=>M(A,W(a<0?-a:a)),{maximumVmNumberByteLength:ke}),qs=e=>X(e,(A,[a])=>M(A,a===0n?W(1n):W(0n)),{maximumVmNumberByteLength:ke}),Hs=e=>X(e,(A,[a])=>M(A,a===0n?W(0n):W(1n)),{maximumVmNumberByteLength:ke}),Js=e=>ge(e,(A,[a,r])=>M(A,W(a+r)),{maximumVmNumberByteLength:ke}),Ls=e=>ge(e,(A,[a,r])=>M(A,W(a-r)),{maximumVmNumberByteLength:ke}),Vs=e=>ge(e,(A,[a,r])=>r===0n?w(A,v.divisionByZero):M(A,W(a/r)),{maximumVmNumberByteLength:ke}),zs=e=>ge(e,(A,[a,r])=>r===0n?w(A,v.divisionByZero):M(A,W(a%r)),{maximumVmNumberByteLength:ke}),js=e=>ge(e,(A,[a,r])=>M(A,oe(a!==0n&&r!==0n)),{maximumVmNumberByteLength:ke}),Ws=e=>ge(e,(A,[a,r])=>M(A,oe(a!==0n||r!==0n)),{maximumVmNumberByteLength:ke}),Fn=e=>ge(e,(A,[a,r])=>M(A,oe(a===r)),{maximumVmNumberByteLength:ke}),Zs=qe(Fn,me),Xs=e=>ge(e,(A,[a,r])=>M(A,oe(a!==r)),{maximumVmNumberByteLength:ke}),$s=e=>ge(e,(A,[a,r])=>M(A,oe(a<r)),{maximumVmNumberByteLength:ke}),eg=e=>ge(e,(A,[a,r])=>M(A,oe(a<=r)),{maximumVmNumberByteLength:ke}),Ag=e=>ge(e,(A,[a,r])=>M(A,oe(a>r)),{maximumVmNumberByteLength:ke}),tg=e=>ge(e,(A,[a,r])=>M(A,oe(a>=r)),{maximumVmNumberByteLength:ke}),ig=e=>ge(e,(A,[a,r])=>M(A,W(a<r?a:r)),{maximumVmNumberByteLength:ke}),ag=e=>ge(e,(A,[a,r])=>M(A,W(a>r?a:r)),{maximumVmNumberByteLength:ke}),rg=e=>sr(e,(A,[a,r,n])=>M(A,oe(r<=a&&a<n)),{maximumVmNumberByteLength:ke});var ng=(e=!0)=>{let A=fr(e);return{...A,operations:{...A.operations,...Yt([d,Tt],{[Z.OP_PICK]:Ts,[Z.OP_ROLL]:Ys,[Z.OP_SPLIT]:xs,[Z.OP_NUM2BIN]:Os,[Z.OP_BIN2NUM]:Rs,[Z.OP_1ADD]:Fs,[Z.OP_1SUB]:Ks,[Z.OP_NEGATE]:Ms,[Z.OP_ABS]:Gs,[Z.OP_NOT]:qs,[Z.OP_0NOTEQUAL]:Hs,[Z.OP_ADD]:Js,[Z.OP_SUB]:Ls,[Z.OP_MUL]:Te,[Z.OP_DIV]:Vs,[Z.OP_MOD]:zs,[Z.OP_BOOLAND]:js,[Z.OP_BOOLOR]:Ws,[Z.OP_NUMEQUAL]:Fn,[Z.OP_NUMEQUALVERIFY]:Zs,[Z.OP_NUMNOTEQUAL]:Xs,[Z.OP_LESSTHAN]:$s,[Z.OP_GREATERTHAN]:Ag,[Z.OP_LESSTHANOREQUAL]:eg,[Z.OP_GREATERTHANOREQUAL]:tg,[Z.OP_MIN]:ig,[Z.OP_MAX]:ag,[Z.OP_WITHIN]:rg}),[Z.OP_INPUTINDEX]:xe,[Z.OP_ACTIVEBYTECODE]:xe,[Z.OP_TXVERSION]:xe,[Z.OP_TXINPUTCOUNT]:xe,[Z.OP_TXOUTPUTCOUNT]:xe,[Z.OP_TXLOCKTIME]:xe,[Z.OP_UTXOVALUE]:xe,[Z.OP_UTXOBYTECODE]:xe,[Z.OP_OUTPOINTTXHASH]:xe,[Z.OP_OUTPOINTINDEX]:xe,[Z.OP_INPUTBYTECODE]:xe,[Z.OP_INPUTSEQUENCENUMBER]:xe,[Z.OP_OUTPUTVALUE]:xe,[Z.OP_OUTPUTBYTECODE]:xe}}};var ht;(function(e){e[e.OP_0=0]="OP_0",e[e.OP_PUSHBYTES_1=1]="OP_PUSHBYTES_1",e[e.OP_PUSHBYTES_2=2]="OP_PUSHBYTES_2",e[e.OP_PUSHBYTES_3=3]="OP_PUSHBYTES_3",e[e.OP_PUSHBYTES_4=4]="OP_PUSHBYTES_4",e[e.OP_PUSHBYTES_5=5]="OP_PUSHBYTES_5",e[e.OP_PUSHBYTES_6=6]="OP_PUSHBYTES_6",e[e.OP_PUSHBYTES_7=7]="OP_PUSHBYTES_7",e[e.OP_PUSHBYTES_8=8]="OP_PUSHBYTES_8",e[e.OP_PUSHBYTES_9=9]="OP_PUSHBYTES_9",e[e.OP_PUSHBYTES_10=10]="OP_PUSHBYTES_10",e[e.OP_PUSHBYTES_11=11]="OP_PUSHBYTES_11",e[e.OP_PUSHBYTES_12=12]="OP_PUSHBYTES_12",e[e.OP_PUSHBYTES_13=13]="OP_PUSHBYTES_13",e[e.OP_PUSHBYTES_14=14]="OP_PUSHBYTES_14",e[e.OP_PUSHBYTES_15=15]="OP_PUSHBYTES_15",e[e.OP_PUSHBYTES_16=16]="OP_PUSHBYTES_16",e[e.OP_PUSHBYTES_17=17]="OP_PUSHBYTES_17",e[e.OP_PUSHBYTES_18=18]="OP_PUSHBYTES_18",e[e.OP_PUSHBYTES_19=19]="OP_PUSHBYTES_19",e[e.OP_PUSHBYTES_20=20]="OP_PUSHBYTES_20",e[e.OP_PUSHBYTES_21=21]="OP_PUSHBYTES_21",e[e.OP_PUSHBYTES_22=22]="OP_PUSHBYTES_22",e[e.OP_PUSHBYTES_23=23]="OP_PUSHBYTES_23",e[e.OP_PUSHBYTES_24=24]="OP_PUSHBYTES_24",e[e.OP_PUSHBYTES_25=25]="OP_PUSHBYTES_25",e[e.OP_PUSHBYTES_26=26]="OP_PUSHBYTES_26",e[e.OP_PUSHBYTES_27=27]="OP_PUSHBYTES_27",e[e.OP_PUSHBYTES_28=28]="OP_PUSHBYTES_28",e[e.OP_PUSHBYTES_29=29]="OP_PUSHBYTES_29",e[e.OP_PUSHBYTES_30=30]="OP_PUSHBYTES_30",e[e.OP_PUSHBYTES_31=31]="OP_PUSHBYTES_31",e[e.OP_PUSHBYTES_32=32]="OP_PUSHBYTES_32",e[e.OP_PUSHBYTES_33=33]="OP_PUSHBYTES_33",e[e.OP_PUSHBYTES_34=34]="OP_PUSHBYTES_34",e[e.OP_PUSHBYTES_35=35]="OP_PUSHBYTES_35",e[e.OP_PUSHBYTES_36=36]="OP_PUSHBYTES_36",e[e.OP_PUSHBYTES_37=37]="OP_PUSHBYTES_37",e[e.OP_PUSHBYTES_38=38]="OP_PUSHBYTES_38",e[e.OP_PUSHBYTES_39=39]="OP_PUSHBYTES_39",e[e.OP_PUSHBYTES_40=40]="OP_PUSHBYTES_40",e[e.OP_PUSHBYTES_41=41]="OP_PUSHBYTES_41",e[e.OP_PUSHBYTES_42=42]="OP_PUSHBYTES_42",e[e.OP_PUSHBYTES_43=43]="OP_PUSHBYTES_43",e[e.OP_PUSHBYTES_44=44]="OP_PUSHBYTES_44",e[e.OP_PUSHBYTES_45=45]="OP_PUSHBYTES_45",e[e.OP_PUSHBYTES_46=46]="OP_PUSHBYTES_46",e[e.OP_PUSHBYTES_47=47]="OP_PUSHBYTES_47",e[e.OP_PUSHBYTES_48=48]="OP_PUSHBYTES_48",e[e.OP_PUSHBYTES_49=49]="OP_PUSHBYTES_49",e[e.OP_PUSHBYTES_50=50]="OP_PUSHBYTES_50",e[e.OP_PUSHBYTES_51=51]="OP_PUSHBYTES_51",e[e.OP_PUSHBYTES_52=52]="OP_PUSHBYTES_52",e[e.OP_PUSHBYTES_53=53]="OP_PUSHBYTES_53",e[e.OP_PUSHBYTES_54=54]="OP_PUSHBYTES_54",e[e.OP_PUSHBYTES_55=55]="OP_PUSHBYTES_55",e[e.OP_PUSHBYTES_56=56]="OP_PUSHBYTES_56",e[e.OP_PUSHBYTES_57=57]="OP_PUSHBYTES_57",e[e.OP_PUSHBYTES_58=58]="OP_PUSHBYTES_58",e[e.OP_PUSHBYTES_59=59]="OP_PUSHBYTES_59",e[e.OP_PUSHBYTES_60=60]="OP_PUSHBYTES_60",e[e.OP_PUSHBYTES_61=61]="OP_PUSHBYTES_61",e[e.OP_PUSHBYTES_62=62]="OP_PUSHBYTES_62",e[e.OP_PUSHBYTES_63=63]="OP_PUSHBYTES_63",e[e.OP_PUSHBYTES_64=64]="OP_PUSHBYTES_64",e[e.OP_PUSHBYTES_65=65]="OP_PUSHBYTES_65",e[e.OP_PUSHBYTES_66=66]="OP_PUSHBYTES_66",e[e.OP_PUSHBYTES_67=67]="OP_PUSHBYTES_67",e[e.OP_PUSHBYTES_68=68]="OP_PUSHBYTES_68",e[e.OP_PUSHBYTES_69=69]="OP_PUSHBYTES_69",e[e.OP_PUSHBYTES_70=70]="OP_PUSHBYTES_70",e[e.OP_PUSHBYTES_71=71]="OP_PUSHBYTES_71",e[e.OP_PUSHBYTES_72=72]="OP_PUSHBYTES_72",e[e.OP_PUSHBYTES_73=73]="OP_PUSHBYTES_73",e[e.OP_PUSHBYTES_74=74]="OP_PUSHBYTES_74",e[e.OP_PUSHBYTES_75=75]="OP_PUSHBYTES_75",e[e.OP_PUSHDATA_1=76]="OP_PUSHDATA_1",e[e.OP_PUSHDATA_2=77]="OP_PUSHDATA_2",e[e.OP_PUSHDATA_4=78]="OP_PUSHDATA_4",e[e.OP_1NEGATE=79]="OP_1NEGATE",e[e.OP_RESERVED=80]="OP_RESERVED",e[e.OP_1=81]="OP_1",e[e.OP_2=82]="OP_2",e[e.OP_3=83]="OP_3",e[e.OP_4=84]="OP_4",e[e.OP_5=85]="OP_5",e[e.OP_6=86]="OP_6",e[e.OP_7=87]="OP_7",e[e.OP_8=88]="OP_8",e[e.OP_9=89]="OP_9",e[e.OP_10=90]="OP_10",e[e.OP_11=91]="OP_11",e[e.OP_12=92]="OP_12",e[e.OP_13=93]="OP_13",e[e.OP_14=94]="OP_14",e[e.OP_15=95]="OP_15",e[e.OP_16=96]="OP_16",e[e.OP_NOP=97]="OP_NOP",e[e.OP_VER=98]="OP_VER",e[e.OP_IF=99]="OP_IF",e[e.OP_NOTIF=100]="OP_NOTIF",e[e.OP_VERIF=101]="OP_VERIF",e[e.OP_VERNOTIF=102]="OP_VERNOTIF",e[e.OP_ELSE=103]="OP_ELSE",e[e.OP_ENDIF=104]="OP_ENDIF",e[e.OP_VERIFY=105]="OP_VERIFY",e[e.OP_RETURN=106]="OP_RETURN",e[e.OP_TOALTSTACK=107]="OP_TOALTSTACK",e[e.OP_FROMALTSTACK=108]="OP_FROMALTSTACK",e[e.OP_2DROP=109]="OP_2DROP",e[e.OP_2DUP=110]="OP_2DUP",e[e.OP_3DUP=111]="OP_3DUP",e[e.OP_2OVER=112]="OP_2OVER",e[e.OP_2ROT=113]="OP_2ROT",e[e.OP_2SWAP=114]="OP_2SWAP",e[e.OP_IFDUP=115]="OP_IFDUP",e[e.OP_DEPTH=116]="OP_DEPTH",e[e.OP_DROP=117]="OP_DROP",e[e.OP_DUP=118]="OP_DUP",e[e.OP_NIP=119]="OP_NIP",e[e.OP_OVER=120]="OP_OVER",e[e.OP_PICK=121]="OP_PICK",e[e.OP_ROLL=122]="OP_ROLL",e[e.OP_ROT=123]="OP_ROT",e[e.OP_SWAP=124]="OP_SWAP",e[e.OP_TUCK=125]="OP_TUCK",e[e.OP_CAT=126]="OP_CAT",e[e.OP_SPLIT=127]="OP_SPLIT",e[e.OP_NUM2BIN=128]="OP_NUM2BIN",e[e.OP_BIN2NUM=129]="OP_BIN2NUM",e[e.OP_SIZE=130]="OP_SIZE",e[e.OP_INVERT=131]="OP_INVERT",e[e.OP_AND=132]="OP_AND",e[e.OP_OR=133]="OP_OR",e[e.OP_XOR=134]="OP_XOR",e[e.OP_EQUAL=135]="OP_EQUAL",e[e.OP_EQUALVERIFY=136]="OP_EQUALVERIFY",e[e.OP_RESERVED1=137]="OP_RESERVED1",e[e.OP_RESERVED2=138]="OP_RESERVED2",e[e.OP_1ADD=139]="OP_1ADD",e[e.OP_1SUB=140]="OP_1SUB",e[e.OP_2MUL=141]="OP_2MUL",e[e.OP_2DIV=142]="OP_2DIV",e[e.OP_NEGATE=143]="OP_NEGATE",e[e.OP_ABS=144]="OP_ABS",e[e.OP_NOT=145]="OP_NOT",e[e.OP_0NOTEQUAL=146]="OP_0NOTEQUAL",e[e.OP_ADD=147]="OP_ADD",e[e.OP_SUB=148]="OP_SUB",e[e.OP_MUL=149]="OP_MUL",e[e.OP_DIV=150]="OP_DIV",e[e.OP_MOD=151]="OP_MOD",e[e.OP_LSHIFT=152]="OP_LSHIFT",e[e.OP_RSHIFT=153]="OP_RSHIFT",e[e.OP_BOOLAND=154]="OP_BOOLAND",e[e.OP_BOOLOR=155]="OP_BOOLOR",e[e.OP_NUMEQUAL=156]="OP_NUMEQUAL",e[e.OP_NUMEQUALVERIFY=157]="OP_NUMEQUALVERIFY",e[e.OP_NUMNOTEQUAL=158]="OP_NUMNOTEQUAL",e[e.OP_LESSTHAN=159]="OP_LESSTHAN",e[e.OP_GREATERTHAN=160]="OP_GREATERTHAN",e[e.OP_LESSTHANOREQUAL=161]="OP_LESSTHANOREQUAL",e[e.OP_GREATERTHANOREQUAL=162]="OP_GREATERTHANOREQUAL",e[e.OP_MIN=163]="OP_MIN",e[e.OP_MAX=164]="OP_MAX",e[e.OP_WITHIN=165]="OP_WITHIN",e[e.OP_RIPEMD160=166]="OP_RIPEMD160",e[e.OP_SHA1=167]="OP_SHA1",e[e.OP_SHA256=168]="OP_SHA256",e[e.OP_HASH160=169]="OP_HASH160",e[e.OP_HASH256=170]="OP_HASH256",e[e.OP_CODESEPARATOR=171]="OP_CODESEPARATOR",e[e.OP_CHECKSIG=172]="OP_CHECKSIG",e[e.OP_CHECKSIGVERIFY=173]="OP_CHECKSIGVERIFY",e[e.OP_CHECKMULTISIG=174]="OP_CHECKMULTISIG",e[e.OP_CHECKMULTISIGVERIFY=175]="OP_CHECKMULTISIGVERIFY",e[e.OP_NOP1=176]="OP_NOP1",e[e.OP_CHECKLOCKTIMEVERIFY=177]="OP_CHECKLOCKTIMEVERIFY",e[e.OP_CHECKSEQUENCEVERIFY=178]="OP_CHECKSEQUENCEVERIFY",e[e.OP_NOP4=179]="OP_NOP4",e[e.OP_NOP5=180]="OP_NOP5",e[e.OP_NOP6=181]="OP_NOP6",e[e.OP_NOP7=182]="OP_NOP7",e[e.OP_NOP8=183]="OP_NOP8",e[e.OP_NOP9=184]="OP_NOP9",e[e.OP_NOP10=185]="OP_NOP10",e[e.OP_CHECKDATASIG=186]="OP_CHECKDATASIG",e[e.OP_CHECKDATASIGVERIFY=187]="OP_CHECKDATASIGVERIFY",e[e.OP_REVERSEBYTES=188]="OP_REVERSEBYTES",e[e.OP_UNKNOWN189=189]="OP_UNKNOWN189",e[e.OP_UNKNOWN190=190]="OP_UNKNOWN190",e[e.OP_UNKNOWN191=191]="OP_UNKNOWN191",e[e.OP_UNKNOWN192=192]="OP_UNKNOWN192",e[e.OP_UNKNOWN193=193]="OP_UNKNOWN193",e[e.OP_UNKNOWN194=194]="OP_UNKNOWN194",e[e.OP_UNKNOWN195=195]="OP_UNKNOWN195",e[e.OP_UNKNOWN196=196]="OP_UNKNOWN196",e[e.OP_UNKNOWN197=197]="OP_UNKNOWN197",e[e.OP_UNKNOWN198=198]="OP_UNKNOWN198",e[e.OP_UNKNOWN199=199]="OP_UNKNOWN199",e[e.OP_UNKNOWN200=200]="OP_UNKNOWN200",e[e.OP_UNKNOWN201=201]="OP_UNKNOWN201",e[e.OP_UNKNOWN202=202]="OP_UNKNOWN202",e[e.OP_UNKNOWN203=203]="OP_UNKNOWN203",e[e.OP_UNKNOWN204=204]="OP_UNKNOWN204",e[e.OP_UNKNOWN205=205]="OP_UNKNOWN205",e[e.OP_UNKNOWN206=206]="OP_UNKNOWN206",e[e.OP_UNKNOWN207=207]="OP_UNKNOWN207",e[e.OP_UNKNOWN208=208]="OP_UNKNOWN208",e[e.OP_UNKNOWN209=209]="OP_UNKNOWN209",e[e.OP_UNKNOWN210=210]="OP_UNKNOWN210",e[e.OP_UNKNOWN211=211]="OP_UNKNOWN211",e[e.OP_UNKNOWN212=212]="OP_UNKNOWN212",e[e.OP_UNKNOWN213=213]="OP_UNKNOWN213",e[e.OP_UNKNOWN214=214]="OP_UNKNOWN214",e[e.OP_UNKNOWN215=215]="OP_UNKNOWN215",e[e.OP_UNKNOWN216=216]="OP_UNKNOWN216",e[e.OP_UNKNOWN217=217]="OP_UNKNOWN217",e[e.OP_UNKNOWN218=218]="OP_UNKNOWN218",e[e.OP_UNKNOWN219=219]="OP_UNKNOWN219",e[e.OP_UNKNOWN220=220]="OP_UNKNOWN220",e[e.OP_UNKNOWN221=221]="OP_UNKNOWN221",e[e.OP_UNKNOWN222=222]="OP_UNKNOWN222",e[e.OP_UNKNOWN223=223]="OP_UNKNOWN223",e[e.OP_UNKNOWN224=224]="OP_UNKNOWN224",e[e.OP_UNKNOWN225=225]="OP_UNKNOWN225",e[e.OP_UNKNOWN226=226]="OP_UNKNOWN226",e[e.OP_UNKNOWN227=227]="OP_UNKNOWN227",e[e.OP_UNKNOWN228=228]="OP_UNKNOWN228",e[e.OP_UNKNOWN229=229]="OP_UNKNOWN229",e[e.OP_UNKNOWN230=230]="OP_UNKNOWN230",e[e.OP_UNKNOWN231=231]="OP_UNKNOWN231",e[e.OP_UNKNOWN232=232]="OP_UNKNOWN232",e[e.OP_UNKNOWN233=233]="OP_UNKNOWN233",e[e.OP_UNKNOWN234=234]="OP_UNKNOWN234",e[e.OP_UNKNOWN235=235]="OP_UNKNOWN235",e[e.OP_UNKNOWN236=236]="OP_UNKNOWN236",e[e.OP_UNKNOWN237=237]="OP_UNKNOWN237",e[e.OP_UNKNOWN238=238]="OP_UNKNOWN238",e[e.OP_UNKNOWN239=239]="OP_UNKNOWN239",e[e.OP_UNKNOWN240=240]="OP_UNKNOWN240",e[e.OP_UNKNOWN241=241]="OP_UNKNOWN241",e[e.OP_UNKNOWN242=242]="OP_UNKNOWN242",e[e.OP_UNKNOWN243=243]="OP_UNKNOWN243",e[e.OP_UNKNOWN244=244]="OP_UNKNOWN244",e[e.OP_UNKNOWN245=245]="OP_UNKNOWN245",e[e.OP_UNKNOWN246=246]="OP_UNKNOWN246",e[e.OP_UNKNOWN247=247]="OP_UNKNOWN247",e[e.OP_UNKNOWN248=248]="OP_UNKNOWN248",e[e.OP_UNKNOWN249=249]="OP_UNKNOWN249",e[e.OP_UNKNOWN250=250]="OP_UNKNOWN250",e[e.OP_UNKNOWN251=251]="OP_UNKNOWN251",e[e.OP_UNKNOWN252=252]="OP_UNKNOWN252",e[e.OP_UNKNOWN253=253]="OP_UNKNOWN253",e[e.OP_UNKNOWN254=254]="OP_UNKNOWN254",e[e.OP_UNKNOWN255=255]="OP_UNKNOWN255"})(ht||(ht={}));var pQ=(e=!0)=>RA(ng(e));var ul=Object.entries(zA(ht)).reduce((e,A)=>({...e,[A[0].slice(3)]:A[1]}),{PUSHDATA1:Uint8Array.of(ht.OP_PUSHDATA_1),PUSHDATA2:Uint8Array.of(ht.OP_PUSHDATA_2),PUSHDATA4:Uint8Array.of(ht.OP_PUSHDATA_4)}),CQ=e=>ee(e.split(" ").filter(A=>A!=="").map(A=>A.startsWith("0x")?ze(A.slice(2)):A.startsWith("'")?Na(DA(A.slice(1,A.length-1))):ul[A]??Na(W(BigInt(A)))));var og;(function(e){e.OP_0="Push the VM Number 0 onto the stack.",e.OP_PUSHBYTES_1="Push the next byte onto the stack.",e.OP_PUSHBYTES_2="Push the next 2 bytes onto the stack.",e.OP_PUSHBYTES_3="Push the next 3 bytes onto the stack.",e.OP_PUSHBYTES_4="Push the next 4 bytes onto the stack.",e.OP_PUSHBYTES_5="Push the next 5 bytes onto the stack.",e.OP_PUSHBYTES_6="Push the next 6 bytes onto the stack.",e.OP_PUSHBYTES_7="Push the next 7 bytes onto the stack.",e.OP_PUSHBYTES_8="Push the next 8 bytes onto the stack.",e.OP_PUSHBYTES_9="Push the next 9 bytes onto the stack.",e.OP_PUSHBYTES_10="Push the next 10 bytes onto the stack.",e.OP_PUSHBYTES_11="Push the next 11 bytes onto the stack.",e.OP_PUSHBYTES_12="Push the next 12 bytes onto the stack.",e.OP_PUSHBYTES_13="Push the next 13 bytes onto the stack.",e.OP_PUSHBYTES_14="Push the next 14 bytes onto the stack.",e.OP_PUSHBYTES_15="Push the next 15 bytes onto the stack.",e.OP_PUSHBYTES_16="Push the next 16 bytes onto the stack.",e.OP_PUSHBYTES_17="Push the next 17 bytes onto the stack.",e.OP_PUSHBYTES_18="Push the next 18 bytes onto the stack.",e.OP_PUSHBYTES_19="Push the next 19 bytes onto the stack.",e.OP_PUSHBYTES_20="Push the next 20 bytes onto the stack.",e.OP_PUSHBYTES_21="Push the next 21 bytes onto the stack.",e.OP_PUSHBYTES_22="Push the next 22 bytes onto the stack.",e.OP_PUSHBYTES_23="Push the next 23 bytes onto the stack.",e.OP_PUSHBYTES_24="Push the next 24 bytes onto the stack.",e.OP_PUSHBYTES_25="Push the next 25 bytes onto the stack.",e.OP_PUSHBYTES_26="Push the next 26 bytes onto the stack.",e.OP_PUSHBYTES_27="Push the next 27 bytes onto the stack.",e.OP_PUSHBYTES_28="Push the next 28 bytes onto the stack.",e.OP_PUSHBYTES_29="Push the next 29 bytes onto the stack.",e.OP_PUSHBYTES_30="Push the next 30 bytes onto the stack.",e.OP_PUSHBYTES_31="Push the next 31 bytes onto the stack.",e.OP_PUSHBYTES_32="Push the next 32 bytes onto the stack.",e.OP_PUSHBYTES_33="Push the next 33 bytes onto the stack.",e.OP_PUSHBYTES_34="Push the next 34 bytes onto the stack.",e.OP_PUSHBYTES_35="Push the next 35 bytes onto the stack.",e.OP_PUSHBYTES_36="Push the next 36 bytes onto the stack.",e.OP_PUSHBYTES_37="Push the next 37 bytes onto the stack.",e.OP_PUSHBYTES_38="Push the next 38 bytes onto the stack.",e.OP_PUSHBYTES_39="Push the next 39 bytes onto the stack.",e.OP_PUSHBYTES_40="Push the next 40 bytes onto the stack.",e.OP_PUSHBYTES_41="Push the next 41 bytes onto the stack.",e.OP_PUSHBYTES_42="Push the next 42 bytes onto the stack.",e.OP_PUSHBYTES_43="Push the next 43 bytes onto the stack.",e.OP_PUSHBYTES_44="Push the next 44 bytes onto the stack.",e.OP_PUSHBYTES_45="Push the next 45 bytes onto the stack.",e.OP_PUSHBYTES_46="Push the next 46 bytes onto the stack.",e.OP_PUSHBYTES_47="Push the next 47 bytes onto the stack.",e.OP_PUSHBYTES_48="Push the next 48 bytes onto the stack.",e.OP_PUSHBYTES_49="Push the next 49 bytes onto the stack.",e.OP_PUSHBYTES_50="Push the next 50 bytes onto the stack.",e.OP_PUSHBYTES_51="Push the next 51 bytes onto the stack.",e.OP_PUSHBYTES_52="Push the next 52 bytes onto the stack.",e.OP_PUSHBYTES_53="Push the next 53 bytes onto the stack.",e.OP_PUSHBYTES_54="Push the next 54 bytes onto the stack.",e.OP_PUSHBYTES_55="Push the next 55 bytes onto the stack.",e.OP_PUSHBYTES_56="Push the next 56 bytes onto the stack.",e.OP_PUSHBYTES_57="Push the next 57 bytes onto the stack.",e.OP_PUSHBYTES_58="Push the next 58 bytes onto the stack.",e.OP_PUSHBYTES_59="Push the next 59 bytes onto the stack.",e.OP_PUSHBYTES_60="Push the next 60 bytes onto the stack.",e.OP_PUSHBYTES_61="Push the next 61 bytes onto the stack.",e.OP_PUSHBYTES_62="Push the next 62 bytes onto the stack.",e.OP_PUSHBYTES_63="Push the next 63 bytes onto the stack.",e.OP_PUSHBYTES_64="Push the next 64 bytes onto the stack.",e.OP_PUSHBYTES_65="Push the next 65 bytes onto the stack.",e.OP_PUSHBYTES_66="Push the next 66 bytes onto the stack.",e.OP_PUSHBYTES_67="Push the next 67 bytes onto the stack.",e.OP_PUSHBYTES_68="Push the next 68 bytes onto the stack.",e.OP_PUSHBYTES_69="Push the next 69 bytes onto the stack.",e.OP_PUSHBYTES_70="Push the next 70 bytes onto the stack.",e.OP_PUSHBYTES_71="Push the next 71 bytes onto the stack.",e.OP_PUSHBYTES_72="Push the next 72 bytes onto the stack.",e.OP_PUSHBYTES_73="Push the next 73 bytes onto the stack.",e.OP_PUSHBYTES_74="Push the next 74 bytes onto the stack.",e.OP_PUSHBYTES_75="Push the next 75 bytes onto the stack.",e.OP_PUSHDATA_1="Read the next Uint8 and push that number of bytes onto the stack.",e.OP_PUSHDATA_2="Read the next little-endian Uint16 and push that number of bytes onto the stack.",e.OP_PUSHDATA_4="Read the next little-endian Uint32 and push that number of bytes onto the stack.",e.OP_1NEGATE="Push the VM Number -1 onto the stack.",e.OP_RESERVED="Error unless found in an unexecuted conditional branch. Note: OP_RESERVED does not count toward the opcode limit.",e.OP_1="Push a 1 (VM Number) onto the stack.",e.OP_2="Push a 2 (VM Number) onto the stack.",e.OP_3="Push a 3 (VM Number) onto the stack.",e.OP_4="Push a 4 (VM Number) onto the stack.",e.OP_5="Push a 5 (VM Number) onto the stack.",e.OP_6="Push a 6 (VM Number) onto the stack.",e.OP_7="Push a 7 (VM Number) onto the stack.",e.OP_8="Push a 8 (VM Number) onto the stack.",e.OP_9="Push a 9 (VM Number) onto the stack.",e.OP_10="Push a 10 (VM Number) onto the stack.",e.OP_11="Push a 11 (VM Number) onto the stack.",e.OP_12="Push a 12 (VM Number) onto the stack.",e.OP_13="Push a 13 (VM Number) onto the stack.",e.OP_14="Push a 14 (VM Number) onto the stack.",e.OP_15="Push a 15 (VM Number) onto the stack.",e.OP_16="Push a 16 (VM Number) onto the stack.",e.OP_NOP="No operation. Note: OP_NOP counts toward the opcode limit.",e.OP_VER="Error unless found in an unexecuted conditional branch. Note: OP_VER counts toward the opcode limit. (Historically, this pushed a protocol version number to the stack.)",e.OP_IF='Pop the top item from the stack. If it is not "truthy", skip evaluation until a matching OP_ELSE or OP_ENDIF.',e.OP_NOTIF='Pop the top item from the stack. If it is "truthy", skip evaluation until a matching OP_ELSE or OP_ENDIF.',e.OP_VERIF="Error, even when found in an unexecuted conditional branch. (Historically, this was a combination of OP_VER and OP_IF.)",e.OP_VERNOTIF="Error, even when found in an unexecuted conditional branch. (Historically, this was a combination of OP_VER and OP_NOTIF.)",e.OP_ELSE="Invert conditional evaluation within the current OP_IF ... OP_ENDIF block. (If evaluation is enabled, disable it, if it is disabled, enable it.)",e.OP_ENDIF="End the current OP_IF/OP_NOTIF ... OP_ENDIF block.",e.OP_VERIFY=`Pop the top item from the stack and error if it isn't "truthy".`,e.OP_RETURN="Error when executed.",e.OP_TOALTSTACK="Pop the top item from the stack and push it onto the alternate stack.",e.OP_FROMALTSTACK="Pop the top item from the alternate stack and push it onto the stack.",e.OP_2DROP="Pop the top 2 items from the stack and discard them.",e.OP_2DUP="Duplicate the top 2 items on the stack. (E.g. [a, b] -> [a, b, a, b])",e.OP_3DUP="Duplicate the top 3 items on the stack. (E.g. [a, b, c] -> [a, b, c, a, b, c])",e.OP_2OVER="Duplicate the 2 items beginning at a depth of 2 on the stack. (E.g. [a, b, c, d] -> [a, b, c, d, a, b])",e.OP_2ROT="Rotate the top 6 items on the stack, bringing the fifth and sixth items to the top. (E.g. [a, b, c, d, e, f] -> [c, d, e, f, a, b])",e.OP_2SWAP="Swap the positions of the top two pairs of items on the stack. (E.g. [a, b, c, d] -> [c, d, a, b])",e.OP_IFDUP='If the top item on the stack is "truthy", duplicate it.',e.OP_DEPTH="Push the current number of stack items as a VM Number.",e.OP_DROP="Pop the top item from the stack and discard it. (E.g. [a] -> [])",e.OP_DUP="Duplicate the top item on the stack. (E.g. [a] -> [a, a])",e.OP_NIP="Remove the second-to-top item from the stack. (E.g. [a, b] -> [b])",e.OP_OVER="Duplicate the second-to-top item on the stack. (E.g. [a, b] -> [a, b, a])",e.OP_PICK="Pop the top item from the stack as a VM Number. Duplicate the item at that depth (zero-indexed), placing it on top of the stack. (E.g. [a, b, c, 2] -> [a, b, c, a])",e.OP_ROLL="Pop the top item from the stack as a VM Number. Move the item at that depth (zero-indexed) to the top of the stack. (E.g. [a, b, c, 2] -> [b, c, a])",e.OP_ROT="Rotate the top 3 items on the stack, bringing the third item to the top. (E.g. [a, b, c] -> [b, c, a])",e.OP_SWAP="Swap the top two items on the stack. (E.g. [a, b] -> [b, a])",e.OP_TUCK="Duplicate the item at the top of the stack, inserting it below the second-to-top item. (E.g. [a, b] -> [b, a, b])",e.OP_CAT="Pop the top 2 items from the stack and concatenate them, pushing the result.",e.OP_SPLIT="Pop the top item from the stack as an index (VM Number) and the next item as a byte array. Split the byte array into two stack items at the index (zero-based), pushing the results.",e.OP_NUM2BIN="Pop the top item from the stack as an item length (VM Number) and the next item as a VM Number (without encoding restrictions). Re-encode the number using a byte array of the provided length, filling any unused bytes with zeros, then push the result. (If the requested length is too short to encode the number, error.)",e.OP_BIN2NUM="Pop the top item from the stack as a VM Number without encoding restrictions. Minimally-encode the number and push the result. (If the number can't be encoded in 4 bytes or less, error.)",e.OP_SIZE="Push the byte-length of the top stack item as a VM Number.",e.OP_INVERT="Error, even when found in an unexecuted conditional branch. (Historically, this flipped all the bits in a stack item.)",e.OP_AND="Pop the top 2 items from the stack and perform a bitwise AND on each byte, pushing the result. If the length of the items are not equal, error.",e.OP_OR="Pop the top 2 items from the stack and perform a bitwise OR on each byte, pushing the result. If the length of the items are not equal, error.",e.OP_XOR="Pop the top 2 items from the stack and perform a bitwise XOR on each byte, pushing the result. If the length of the items are not equal, error.",e.OP_EQUAL="Pop the top two items from the stack and compare them byte-by-byte. If they are the same, push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_EQUALVERIFY="Pop the top two items from the stack and compare them byte-by-byte. If the values are different, error. (This operation is a combination of OP_EQUAL followed by OP_VERIFY.)",e.OP_RESERVED1="Error unless found in an unexecuted conditional branch. Note: OP_RESERVED1 counts toward the opcode limit.",e.OP_RESERVED2="Error unless found in an unexecuted conditional branch. Note: OP_RESERVED2 counts toward the opcode limit.",e.OP_1ADD="Pop the top item from the stack as a VM Number, add 1, then push the result.",e.OP_1SUB="Pop the top item from the stack as a VM Number, subtract 1, then push the result.",e.OP_2MUL="Error, even when found in an unexecuted conditional branch. (Historically, this multiplied a VM Number by 2.)",e.OP_2DIV="Error, even when found in an unexecuted conditional branch. (Historically, this divided a VM Number by 2.)",e.OP_NEGATE="Pop the top item from the stack as a VM Number, negate it, then push the result.",e.OP_ABS="Pop the top item from the stack as a VM Number, take its absolute value, then push the result.",e.OP_NOT="Pop the top item from the stack as a VM Number. If its value is 0, push a 1 (VM Number), otherwise, push a 0 (VM Number).",e.OP_0NOTEQUAL="Pop the top item from the stack as a VM Number. If its value is not 0, push a 1 (VM Number), otherwise, push a 0 (VM Number).",e.OP_ADD="Pop the top two items from the stack as VM Numbers. Add them, then push the result.",e.OP_SUB="Pop the top two items from the stack as VM Numbers. Subtract the top item from the second item, then push the result.",e.OP_MUL="Pop the top two items from the stack as VM Numbers. Multiply them, then push the result.",e.OP_DIV="Pop the top item from the stack as a denominator (VM Number) and the next as a numerator (VM Number). Divide and push the result to the stack.",e.OP_MOD="Pop the top item from the stack as a denominator (VM Number) and the next as a numerator (VM Number). Divide and push the remainder to the stack.",e.OP_LSHIFT="Error, even when found in an unexecuted conditional branch. (Historically, this performed a sign-preserving, left bit shift.)",e.OP_RSHIFT="Error, even when found in an unexecuted conditional branch. (Historically, this performed a sign-preserving, right bit shift.)",e.OP_BOOLAND="Pop the top two items from the stack as VM Numbers. If neither value is a 0 (VM Number), push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_BOOLOR="Pop the top two items from the stack as VM Numbers. If either value is a 1 (VM Number), push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_NUMEQUAL="Pop the top two items from the stack as VM Numbers. If the values are equal, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_NUMEQUALVERIFY="Pop the top two items from the stack as VM Numbers. If the values are different, error. (This operation is a combination of OP_NUMEQUAL followed by OP_VERIFY.)",e.OP_NUMNOTEQUAL="Pop the top two items from the stack as VM Numbers. If the values are not equal, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_LESSTHAN="Pop the top two items from the stack as VM Numbers. If the second item is less than top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_GREATERTHAN="Pop the top two items from the stack as VM Numbers. If the second item is greater than top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_LESSTHANOREQUAL="Pop the top two items from the stack as VM Numbers. If the second item is less than or equal to the top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_GREATERTHANOREQUAL="Pop the top two items from the stack as VM Numbers. If the second item is greater than or equal to the top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_MIN="Pop the top two items from the stack as VM Numbers. Push the smaller of the two numbers.",e.OP_MAX="Pop the top two items from the stack as VM Numbers. Push the larger of the two numbers.",e.OP_WITHIN="Pop the top three items from the stack as VM Numbers. If the top number is within the range defined by the following two numbers (left-inclusive), push a 1 (VM Number). Otherwise, push a 0 (VM Number). (E.g. for [a, b, c]: if (b <= a), and (a < c), [1]. Else [0].)",e.OP_RIPEMD160="Pop the top item from the stack and pass it through ripemd160, pushing the result onto the stack.",e.OP_SHA1="Pop the top item from the stack and pass it through sha1, pushing the result onto the stack.",e.OP_SHA256="Pop the top item from the stack and pass it through sha256, pushing the result onto the stack.",e.OP_HASH160="Pop the top item from the stack and pass it through sha256, then ripemd160, pushing the result onto the stack.",e.OP_HASH256="Pop the top item from the stack and pass it through sha256 twice, pushing the result onto the stack.",e.OP_CODESEPARATOR="Update the value of lastCodeSeparator to the instruction pointer's current value. (This reduces the coverage of signing serializations used in signature verification operations.)",e.OP_CHECKSIG="Pop the top two items from the stack. Treat the top as a signature and the second as a public key. If the signature is valid, push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_CHECKSIGVERIFY="Pop the top two items from the stack. Treat the top as a signature and the second as a public key. If the signature is not valid, error. (This operation is a combination of OP_CHECKSIG followed by OP_VERIFY.)",e.OP_CHECKMULTISIG="Pop items from the stack: first pop the VM Number of public keys, then pop each of those public keys. Next, pop the VM Number of required signatures, then pop each of those signatures. Finally, pop a final VM Number that must be 0 due to a protocol bug. Checking each signature against each public key in order, if all signatures are valid \u2013 and the required number of signatures have been provided \u2013 push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_CHECKMULTISIGVERIFY="Pop items from the stack: first pop the VM Number of public keys, then pop each of those public keys. Next, pop the VM Number of required signatures, then pop each of those signatures. Finally, (due to a protocol bug) pop an unused final VM Number that must be 0. Checking each signature against each public key in order, if any signatures are invalid \u2013 or the required number of signatures have not been provided \u2013 error. (This operation is a combination of OP_CHECKMULTISIG followed by OP_VERIFY.)",e.OP_NOP1="No operation (reserved for future expansion). Note: OP_NOP1 counts toward the opcode limit.",e.OP_CHECKLOCKTIMEVERIFY="Verify the transaction occurs after an absolute block time or height: read the top item on the stack as a VM Number (without removing it), and compare it to the transaction's locktime. If the required locktime has not passed, or if locktime has been disabled for this input by a maximized sequence number, error.",e.OP_CHECKSEQUENCEVERIFY=`Verify the transaction occurs after the output being spent has "aged" by a relative block time or block height since it was created: read the top item on the stack as a VM Number (without removing it), and compare it to the age encoded in the input's sequence number. If the required relative locktime has not passed, or if relative locktime has been disabled by the sequence number or the transaction version, error.`,e.OP_NOP4="No operation (reserved for future expansion). Note: OP_NOP4 counts toward the opcode limit.",e.OP_NOP6="No operation (reserved for future expansion). Note: OP_NOP6 counts toward the opcode limit.",e.OP_NOP5="No operation (reserved for future expansion). Note: OP_NOP5 counts toward the opcode limit.",e.OP_NOP7="No operation (reserved for future expansion). Note: OP_NOP7 counts toward the opcode limit.",e.OP_NOP8="No operation (reserved for future expansion). Note: OP_NOP8 counts toward the opcode limit.",e.OP_NOP9="No operation (reserved for future expansion). Note: OP_NOP9 counts toward the opcode limit.",e.OP_NOP10="No operation (reserved for future expansion). Note: OP_NOP10 counts toward the opcode limit.",e.OP_CHECKDATASIG="Pop the top 3 items from the stack. Treat the top as a public key, the second as a message, and the third as a signature. If the signature is valid, push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_CHECKDATASIGVERIFY="Pop the top 3 items from the stack. Treat the top as a public key, the second as a message, and the third as a signature. If the signature is not valid, error. (This operation is a combination of OP_CHECKDATASIG followed by OP_VERIFY.)",e.OP_REVERSEBYTES="Pop the top item from the stack and reverse it, pushing the result.",e.OP_INPUTINDEX="Push the index of the input being evaluated to the stack as a VM Number.",e.OP_ACTIVEBYTECODE="Push the bytecode currently being evaluated, beginning after the last executed OP_CODESEPARATOR, to the stack. For Pay-to-Script-Hash (P2SH) evaluations, this is the redeem bytecode of the Unspent Transaction Output (UTXO) being spent; for all other evaluations, this is the locking bytecode of the UTXO being spent.",e.OP_TXVERSION="Push the version of the current transaction to the stack as a VM Number.",e.OP_TXINPUTCOUNT="Push the count of inputs in the current transaction to the stack as a VM Number.",e.OP_TXOUTPUTCOUNT="Push the count of outputs in the current transaction to the stack as a VM Number.",e.OP_TXLOCKTIME="Push the locktime of the current transaction to the stack as a VM Number.",e.OP_UTXOVALUE="Pop the top item from the stack as an input index (VM Number). Push the value (in satoshis) of the Unspent Transaction Output (UTXO) spent by that input to the stack as a VM Number.",e.OP_UTXOBYTECODE="Pop the top item from the stack as an input index (VM Number). Push the full locking bytecode of the Unspent Transaction Output (UTXO) spent by that input to the stack.",e.OP_OUTPOINTTXHASH="Pop the top item from the stack as an input index (VM Number). From that input, push the outpoint transaction hash \u2013 the hash of the transaction that created the Unspent Transaction Output (UTXO) that is being spent \u2013 to the stack in OP_HASH256 byte order.",e.OP_OUTPOINTINDEX="Pop the top item from the stack as an input index (VM Number). From that input, push the outpoint index \u2013 the index of the output in the transaction that created the Unspent Transaction Output (UTXO) that is being spent \u2013 to the stack as a VM Number.",e.OP_INPUTBYTECODE="Pop the top item from the stack as an input index (VM Number). Push the unlocking bytecode of the input at that index to the stack.",e.OP_INPUTSEQUENCENUMBER="Pop the top item from the stack as an input index (VM Number). Push the sequence number of the input at that index to the stack as a VM Number.",e.OP_OUTPUTVALUE="Pop the top item from the stack as an output index (VM Number). Push the value (in satoshis) of the output at that index to the stack as a VM Number.",e.OP_OUTPUTBYTECODE="Pop the top item from the stack as an output index (VM Number). Push the locking bytecode of the output at that index to the stack."})(og||(og={}));var sg;(function(e){e.exceededMaximumVmNumberLength="Program attempted an OP_BIN2NUM operation on a byte sequence that cannot be encoded within the maximum VM Number length (8 bytes)."})(sg||(sg={}));var xQ=({lockingBytecode:e,valueSatoshis:A,unlockingBytecode:a})=>{let r={inputs:[{outpointIndex:4294967295,outpointTransactionHash:ze("0000000000000000000000000000000000000000000000000000000000000000"),sequenceNumber:4294967295,unlockingBytecode:Uint8Array.of(0,0)}],locktime:0,outputs:[{lockingBytecode:e,valueSatoshis:A}],version:1},n={inputs:[{outpointIndex:0,outpointTransactionHash:Bn(dn(r)),sequenceNumber:4294967295,unlockingBytecode:a}],locktime:0,outputs:[{lockingBytecode:Uint8Array.of(),valueSatoshis:A}],version:1};return{inputIndex:0,sourceOutputs:r.outputs,transaction:n}};var KQ=(e=!0)=>RA(fr(e));var kA;(function(e){e.invalidBoolean="Invalid input: this operation requires a valid boolean (VM Number 0 or VM Number 1).",e.unexpectedUntil="Encountered an OP_UNTIL that is not following a matching OP_BEGIN.",e.excessiveHashing="Program attempted a hashing operation that would exceed the hashing limit (660 hash digest iterations).",e.excessiveLooping="Program attempted an OP_UNTIL operation that would exceed the limit of repeated bytes (10,000 bytes minus active bytecode length)."})(kA||(kA={}));var dt;(function(e){e[e.maximumTransactionVersion=2]="maximumTransactionVersion",e[e.bannedTransactionSize=64]="bannedTransactionSize",e[e.maximumHashDigestIterations=660]="maximumHashDigestIterations"})(dt||(dt={}));var gg=e=>({...e.error===void 0?{}:{error:e.error},alternateStack:BA(e.alternateStack),controlStack:e.controlStack.slice(),hashDigestIterations:e.hashDigestIterations,instructions:e.instructions.map(ir),ip:e.ip,lastCodeSeparator:e.lastCodeSeparator,program:kn(e.program),repeatedBytes:e.repeatedBytes,signedMessages:e.signedMessages.map(A=>({digest:A.digest.slice(),..."serialization"in A?{serialization:A.serialization.slice()}:{message:A.message.slice()}})),stack:BA(e.stack)}),Cr=({program:e,instructions:A,stack:a})=>({alternateStack:[],controlStack:[],hashDigestIterations:0,instructions:A,ip:0,lastCodeSeparator:-1,program:e,repeatedBytes:0,signedMessages:[],stack:a});var Pr=e=>1+((e+8)/64|0),Ua=(e,A,a)=>{let r=e.hashDigestIterations+Pr(A);return r>dt.maximumHashDigestIterations?w(e,kA.excessiveHashing,`Required cumulative iterations: ${r}`):a(e)},ay=({ripemd160:e}={ripemd160:Ee})=>A=>te(A,(a,[r])=>Ua(a,r.length,n=>M(n,e.hash(r)))),ry=({sha1:e}={sha1:fA})=>A=>te(A,(a,[r])=>Ua(a,r.length,n=>M(n,e.hash(r)))),ny=({sha256:e}={sha256:q})=>A=>te(A,(a,[r])=>Ua(a,r.length,n=>M(n,e.hash(r)))),oy=({ripemd160:e,sha256:A}={ripemd160:Ee,sha256:q})=>a=>te(a,(r,[n])=>Ua(r,n.length,i=>M(i,e.hash(A.hash(n))))),sy=({sha256:e}={sha256:q})=>A=>te(A,(a,[r])=>Ua(a,r.length,n=>M(n,pe(r,e)))),Kn=({secp256k1:e,sha256:A}={secp256k1:Ae,sha256:q})=>a=>be(a,(r,[n,i])=>{if(!lA(i))return w(r,v.invalidPublicKeyEncoding);if(!TA(n,ia))return w(r,v.invalidSignatureEncoding,`Transaction signature (including signing serialization type): ${$(n)}`);let t=iA(r.instructions).subarray(r.lastCodeSeparator+1),{signingSerializationType:o,signature:s}=YA(n),g=cA(r.program,{coveredBytecode:t,signingSerializationType:o},A),l=r.hashDigestIterations+Pr(g.length);if(l>dt.maximumHashDigestIterations)return w(r,kA.excessiveHashing,`Required cumulative iterations: ${l}`);let I=pe(g,A);r.signedMessages.push({digest:I,serialization:g});let u=s.length===ae.schnorrSignatureLength?e.verifySignatureSchnorr(s,i,I):e.verifySignatureDERLowS(s,i,I);return!u&&s.length!==0?w(r,v.nonNullSignatureFailure):M(r,oe(u))}),Mn=({secp256k1:e,sha256:A}={secp256k1:Ae,sha256:q})=>a=>X(a,(r,n)=>{let i=Number(n);if(i<0)return w(r,v.invalidNaturalNumber);if(i>20)return w(r,v.exceedsMaximumMultisigPublicKeyCount);let t=i>0?r.stack.splice(-i):[];return X(r,(o,s)=>{let g=Number(s);if(g<0)return w(o,v.invalidNaturalNumber);if(g>i)return w(o,v.insufficientPublicKeys);let l=g>0?o.stack.splice(-g):[];return te(o,(I,[E])=>{if(E.length!==0)return w(I,v.invalidProtocolBugValue);let u=iA(I.instructions).subarray(I.lastCodeSeparator+1),k=0,U=l.length,N=t.length;for(;U>0&&N>0&&k+N>=U&&k!==g;){let B=t[N-1],S=l[U-1];if(!lA(B))return w(I,v.invalidPublicKeyEncoding);if(!TA(S,ia))return w(I,v.invalidSignatureEncoding,`Transaction signature (including signing serialization type): ${$(S)}`);let{signingSerializationType:P,signature:h}=YA(S),y=cA(r.program,{coveredBytecode:u,signingSerializationType:P},A),p=r.hashDigestIterations+Pr(y.length);if(p>dt.maximumHashDigestIterations)return w(r,kA.excessiveHashing,`Required cumulative iterations: ${p}`);let C=pe(y,A);if(I.signedMessages.push({digest:C,serialization:y}),h.length===ae.schnorrSignatureLength)return w(I,v.schnorrSizedSignatureInCheckMultiSig);e.verifySignatureDERLowS(h,B,C)&&(k+=1,U-=1),N-=1}let c=k===g;return!c&&!l.every(B=>B.length===0)?w(I,v.nonNullSignatureFailure):M(I,oe(c))})})}),Ig=({secp256k1:e,sha256:A}={secp256k1:Ae,sha256:q})=>qe(Kn({secp256k1:e,sha256:A}),me),cg=({secp256k1:e,sha256:A})=>qe(Mn({secp256k1:e,sha256:A}),me),hl=({secp256k1:e,sha256:A})=>a=>It(a,(r,[n,i,t])=>{if(!vn(n))return w(r,v.invalidSignatureEncoding,`Data signature: ${$(n)}`);if(!lA(t))return w(r,v.invalidPublicKeyEncoding);let o=a.hashDigestIterations+Pr(i.length);if(o>dt.maximumHashDigestIterations)return w(a,kA.excessiveHashing,`Required cumulative iterations: ${o}`);let s=A.hash(i);r.signedMessages.push({digest:s,message:i});let l=n.length===ae.schnorrSignatureLength?e.verifySignatureSchnorr(n,t,s):e.verifySignatureDERLowS(n,t,s);return!l&&n.length!==0?w(r,v.nonNullSignatureFailure):M(r,oe(l))}),gy=({secp256k1:e,sha256:A}={secp256k1:Ae,sha256:q})=>qe(hl({secp256k1:e,sha256:A}),me);var lg;(function(e){e.OP_0="Push the VM Number 0 onto the stack.",e.OP_PUSHBYTES_1="Push the next byte onto the stack.",e.OP_PUSHBYTES_2="Push the next 2 bytes onto the stack.",e.OP_PUSHBYTES_3="Push the next 3 bytes onto the stack.",e.OP_PUSHBYTES_4="Push the next 4 bytes onto the stack.",e.OP_PUSHBYTES_5="Push the next 5 bytes onto the stack.",e.OP_PUSHBYTES_6="Push the next 6 bytes onto the stack.",e.OP_PUSHBYTES_7="Push the next 7 bytes onto the stack.",e.OP_PUSHBYTES_8="Push the next 8 bytes onto the stack.",e.OP_PUSHBYTES_9="Push the next 9 bytes onto the stack.",e.OP_PUSHBYTES_10="Push the next 10 bytes onto the stack.",e.OP_PUSHBYTES_11="Push the next 11 bytes onto the stack.",e.OP_PUSHBYTES_12="Push the next 12 bytes onto the stack.",e.OP_PUSHBYTES_13="Push the next 13 bytes onto the stack.",e.OP_PUSHBYTES_14="Push the next 14 bytes onto the stack.",e.OP_PUSHBYTES_15="Push the next 15 bytes onto the stack.",e.OP_PUSHBYTES_16="Push the next 16 bytes onto the stack.",e.OP_PUSHBYTES_17="Push the next 17 bytes onto the stack.",e.OP_PUSHBYTES_18="Push the next 18 bytes onto the stack.",e.OP_PUSHBYTES_19="Push the next 19 bytes onto the stack.",e.OP_PUSHBYTES_20="Push the next 20 bytes onto the stack.",e.OP_PUSHBYTES_21="Push the next 21 bytes onto the stack.",e.OP_PUSHBYTES_22="Push the next 22 bytes onto the stack.",e.OP_PUSHBYTES_23="Push the next 23 bytes onto the stack.",e.OP_PUSHBYTES_24="Push the next 24 bytes onto the stack.",e.OP_PUSHBYTES_25="Push the next 25 bytes onto the stack.",e.OP_PUSHBYTES_26="Push the next 26 bytes onto the stack.",e.OP_PUSHBYTES_27="Push the next 27 bytes onto the stack.",e.OP_PUSHBYTES_28="Push the next 28 bytes onto the stack.",e.OP_PUSHBYTES_29="Push the next 29 bytes onto the stack.",e.OP_PUSHBYTES_30="Push the next 30 bytes onto the stack.",e.OP_PUSHBYTES_31="Push the next 31 bytes onto the stack.",e.OP_PUSHBYTES_32="Push the next 32 bytes onto the stack.",e.OP_PUSHBYTES_33="Push the next 33 bytes onto the stack.",e.OP_PUSHBYTES_34="Push the next 34 bytes onto the stack.",e.OP_PUSHBYTES_35="Push the next 35 bytes onto the stack.",e.OP_PUSHBYTES_36="Push the next 36 bytes onto the stack.",e.OP_PUSHBYTES_37="Push the next 37 bytes onto the stack.",e.OP_PUSHBYTES_38="Push the next 38 bytes onto the stack.",e.OP_PUSHBYTES_39="Push the next 39 bytes onto the stack.",e.OP_PUSHBYTES_40="Push the next 40 bytes onto the stack.",e.OP_PUSHBYTES_41="Push the next 41 bytes onto the stack.",e.OP_PUSHBYTES_42="Push the next 42 bytes onto the stack.",e.OP_PUSHBYTES_43="Push the next 43 bytes onto the stack.",e.OP_PUSHBYTES_44="Push the next 44 bytes onto the stack.",e.OP_PUSHBYTES_45="Push the next 45 bytes onto the stack.",e.OP_PUSHBYTES_46="Push the next 46 bytes onto the stack.",e.OP_PUSHBYTES_47="Push the next 47 bytes onto the stack.",e.OP_PUSHBYTES_48="Push the next 48 bytes onto the stack.",e.OP_PUSHBYTES_49="Push the next 49 bytes onto the stack.",e.OP_PUSHBYTES_50="Push the next 50 bytes onto the stack.",e.OP_PUSHBYTES_51="Push the next 51 bytes onto the stack.",e.OP_PUSHBYTES_52="Push the next 52 bytes onto the stack.",e.OP_PUSHBYTES_53="Push the next 53 bytes onto the stack.",e.OP_PUSHBYTES_54="Push the next 54 bytes onto the stack.",e.OP_PUSHBYTES_55="Push the next 55 bytes onto the stack.",e.OP_PUSHBYTES_56="Push the next 56 bytes onto the stack.",e.OP_PUSHBYTES_57="Push the next 57 bytes onto the stack.",e.OP_PUSHBYTES_58="Push the next 58 bytes onto the stack.",e.OP_PUSHBYTES_59="Push the next 59 bytes onto the stack.",e.OP_PUSHBYTES_60="Push the next 60 bytes onto the stack.",e.OP_PUSHBYTES_61="Push the next 61 bytes onto the stack.",e.OP_PUSHBYTES_62="Push the next 62 bytes onto the stack.",e.OP_PUSHBYTES_63="Push the next 63 bytes onto the stack.",e.OP_PUSHBYTES_64="Push the next 64 bytes onto the stack.",e.OP_PUSHBYTES_65="Push the next 65 bytes onto the stack.",e.OP_PUSHBYTES_66="Push the next 66 bytes onto the stack.",e.OP_PUSHBYTES_67="Push the next 67 bytes onto the stack.",e.OP_PUSHBYTES_68="Push the next 68 bytes onto the stack.",e.OP_PUSHBYTES_69="Push the next 69 bytes onto the stack.",e.OP_PUSHBYTES_70="Push the next 70 bytes onto the stack.",e.OP_PUSHBYTES_71="Push the next 71 bytes onto the stack.",e.OP_PUSHBYTES_72="Push the next 72 bytes onto the stack.",e.OP_PUSHBYTES_73="Push the next 73 bytes onto the stack.",e.OP_PUSHBYTES_74="Push the next 74 bytes onto the stack.",e.OP_PUSHBYTES_75="Push the next 75 bytes onto the stack.",e.OP_PUSHDATA_1="Read the next Uint8 and push that number of bytes onto the stack.",e.OP_PUSHDATA_2="Read the next little-endian Uint16 and push that number of bytes onto the stack.",e.OP_PUSHDATA_4="Read the next little-endian Uint32 and push that number of bytes onto the stack.",e.OP_1NEGATE="Push the VM Number -1 onto the stack.",e.OP_RESERVED="Error unless found in an unexecuted conditional branch. Note: OP_RESERVED does not count toward the opcode limit.",e.OP_1="Push a 1 (VM Number) onto the stack.",e.OP_2="Push a 2 (VM Number) onto the stack.",e.OP_3="Push a 3 (VM Number) onto the stack.",e.OP_4="Push a 4 (VM Number) onto the stack.",e.OP_5="Push a 5 (VM Number) onto the stack.",e.OP_6="Push a 6 (VM Number) onto the stack.",e.OP_7="Push a 7 (VM Number) onto the stack.",e.OP_8="Push a 8 (VM Number) onto the stack.",e.OP_9="Push a 9 (VM Number) onto the stack.",e.OP_10="Push a 10 (VM Number) onto the stack.",e.OP_11="Push a 11 (VM Number) onto the stack.",e.OP_12="Push a 12 (VM Number) onto the stack.",e.OP_13="Push a 13 (VM Number) onto the stack.",e.OP_14="Push a 14 (VM Number) onto the stack.",e.OP_15="Push a 15 (VM Number) onto the stack.",e.OP_16="Push a 16 (VM Number) onto the stack.",e.OP_NOP="No operation. Note: OP_NOP counts toward the opcode limit.",e.OP_VER="Error unless found in an unexecuted conditional branch. Note: OP_VER counts toward the opcode limit. (Historically, this pushed a protocol version number to the stack.)",e.OP_IF='Pop the top item from the stack. If it is not "truthy", skip evaluation until a matching OP_ELSE or OP_ENDIF.',e.OP_NOTIF='Pop the top item from the stack. If it is "truthy", skip evaluation until a matching OP_ELSE or OP_ENDIF.',e.OP_BEGIN="Push the current instruction pointer index to the control stack as an integer (to be read by OP_UNTIL).",e.OP_UNTIL="Pop the top item from the control stack (if the control value is not an integer, error). Add the difference between the control value and the current instruction pointer index to the repeated bytes counter, if the sum of the repeated bytes counter and the active bytecode length is greater than the maximum bytecode length, error. Pop the top item from the stack, if the value is a 0 (VM Number), move the instruction pointer to the control value (and re-evaluate the OP_BEGIN).",e.OP_ELSE="Invert conditional evaluation within the current OP_IF ... OP_ENDIF block. (If evaluation is enabled, disable it, if it is disabled, enable it.)",e.OP_ENDIF="End the current OP_IF/OP_NOTIF ... OP_ENDIF block.",e.OP_VERIFY=`Pop the top item from the stack and error if it isn't "truthy".`,e.OP_RETURN="Error when executed.",e.OP_TOALTSTACK="Pop the top item from the stack and push it onto the alternate stack.",e.OP_FROMALTSTACK="Pop the top item from the alternate stack and push it onto the stack.",e.OP_2DROP="Pop the top 2 items from the stack and discard them.",e.OP_2DUP="Duplicate the top 2 items on the stack. (E.g. [a, b] -> [a, b, a, b])",e.OP_3DUP="Duplicate the top 3 items on the stack. (E.g. [a, b, c] -> [a, b, c, a, b, c])",e.OP_2OVER="Duplicate the 2 items beginning at a depth of 2 on the stack. (E.g. [a, b, c, d] -> [a, b, c, d, a, b])",e.OP_2ROT="Rotate the top 6 items on the stack, bringing the fifth and sixth items to the top. (E.g. [a, b, c, d, e, f] -> [c, d, e, f, a, b])",e.OP_2SWAP="Swap the positions of the top two pairs of items on the stack. (E.g. [a, b, c, d] -> [c, d, a, b])",e.OP_IFDUP='If the top item on the stack is "truthy", duplicate it.',e.OP_DEPTH="Push the current number of stack items as a VM Number.",e.OP_DROP="Pop the top item from the stack and discard it. (E.g. [a] -> [])",e.OP_DUP="Duplicate the top item on the stack. (E.g. [a] -> [a, a])",e.OP_NIP="Remove the second-to-top item from the stack. (E.g. [a, b] -> [b])",e.OP_OVER="Duplicate the second-to-top item on the stack. (E.g. [a, b] -> [a, b, a])",e.OP_PICK="Pop the top item from the stack as a VM Number. Duplicate the item at that depth (zero-indexed), placing it on top of the stack. (E.g. [a, b, c, 2] -> [a, b, c, a])",e.OP_ROLL="Pop the top item from the stack as a VM Number. Move the item at that depth (zero-indexed) to the top of the stack. (E.g. [a, b, c, 2] -> [b, c, a])",e.OP_ROT="Rotate the top 3 items on the stack, bringing the third item to the top. (E.g. [a, b, c] -> [b, c, a])",e.OP_SWAP="Swap the top two items on the stack. (E.g. [a, b] -> [b, a])",e.OP_TUCK="Duplicate the item at the top of the stack, inserting it below the second-to-top item. (E.g. [a, b] -> [b, a, b])",e.OP_CAT="Pop the top 2 items from the stack and concatenate them, pushing the result.",e.OP_SPLIT="Pop the top item from the stack as an index (VM Number) and the next item as a byte array. Split the byte array into two stack items at the index (zero-based), pushing the results.",e.OP_NUM2BIN="Pop the top item from the stack as an item length (VM Number) and the next item as a VM Number (without encoding restrictions). Re-encode the number using a byte array of the provided length, filling any unused bytes with zeros, then push the result. (If the requested length is too short to encode the number, error.)",e.OP_BIN2NUM="Pop the top item from the stack as a VM Number without encoding restrictions. Minimally-encode the number and push the result. (If the number can't be encoded in 4 bytes or less, error.)",e.OP_SIZE="Push the byte-length of the top stack item as a VM Number.",e.OP_INVERT="Error, even when found in an unexecuted conditional branch. (Historically, this flipped all the bits in a stack item.)",e.OP_AND="Pop the top 2 items from the stack and perform a bitwise AND on each byte, pushing the result. If the length of the items are not equal, error.",e.OP_OR="Pop the top 2 items from the stack and perform a bitwise OR on each byte, pushing the result. If the length of the items are not equal, error.",e.OP_XOR="Pop the top 2 items from the stack and perform a bitwise XOR on each byte, pushing the result. If the length of the items are not equal, error.",e.OP_EQUAL="Pop the top two items from the stack and compare them byte-by-byte. If they are the same, push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_EQUALVERIFY="Pop the top two items from the stack and compare them byte-by-byte. If the values are different, error. (This operation is a combination of OP_EQUAL followed by OP_VERIFY.)",e.OP_RESERVED1="Error unless found in an unexecuted conditional branch. Note: OP_RESERVED1 counts toward the opcode limit.",e.OP_RESERVED2="Error unless found in an unexecuted conditional branch. Note: OP_RESERVED2 counts toward the opcode limit.",e.OP_1ADD="Pop the top item from the stack as a VM Number, add 1, then push the result.",e.OP_1SUB="Pop the top item from the stack as a VM Number, subtract 1, then push the result.",e.OP_2MUL="Error, even when found in an unexecuted conditional branch. (Historically, this multiplied a VM Number by 2.)",e.OP_2DIV="Error, even when found in an unexecuted conditional branch. (Historically, this divided a VM Number by 2.)",e.OP_NEGATE="Pop the top item from the stack as a VM Number, negate it, then push the result.",e.OP_ABS="Pop the top item from the stack as a VM Number, take its absolute value, then push the result.",e.OP_NOT="Pop the top item from the stack as a VM Number. If its value is 0, push a 1 (VM Number), otherwise, push a 0 (VM Number).",e.OP_0NOTEQUAL="Pop the top item from the stack as a VM Number. If its value is not 0, push a 1 (VM Number), otherwise, push a 0 (VM Number).",e.OP_ADD="Pop the top two items from the stack as VM Numbers. Add them, then push the result.",e.OP_SUB="Pop the top two items from the stack as VM Numbers. Subtract the top item from the second item, then push the result.",e.OP_MUL="Pop the top two items from the stack as VM Numbers. Multiply them, then push the result.",e.OP_DIV="Pop the top item from the stack as a denominator (VM Number) and the next as a numerator (VM Number). Divide and push the result to the stack.",e.OP_MOD="Pop the top item from the stack as a denominator (VM Number) and the next as a numerator (VM Number). Divide and push the remainder to the stack.",e.OP_LSHIFT="Error, even when found in an unexecuted conditional branch. (Historically, this performed a sign-preserving, left bit shift.)",e.OP_RSHIFT="Error, even when found in an unexecuted conditional branch. (Historically, this performed a sign-preserving, right bit shift.)",e.OP_BOOLAND="Pop the top two items from the stack as VM Numbers. If neither value is a 0 (VM Number), push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_BOOLOR="Pop the top two items from the stack as VM Numbers. If either value is a 1 (VM Number), push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_NUMEQUAL="Pop the top two items from the stack as VM Numbers. If the values are equal, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_NUMEQUALVERIFY="Pop the top two items from the stack as VM Numbers. If the values are different, error. (This operation is a combination of OP_NUMEQUAL followed by OP_VERIFY.)",e.OP_NUMNOTEQUAL="Pop the top two items from the stack as VM Numbers. If the values are not equal, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_LESSTHAN="Pop the top two items from the stack as VM Numbers. If the second item is less than top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_GREATERTHAN="Pop the top two items from the stack as VM Numbers. If the second item is greater than top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_LESSTHANOREQUAL="Pop the top two items from the stack as VM Numbers. If the second item is less than or equal to the top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_GREATERTHANOREQUAL="Pop the top two items from the stack as VM Numbers. If the second item is greater than or equal to the top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_MIN="Pop the top two items from the stack as VM Numbers. Push the smaller of the two numbers.",e.OP_MAX="Pop the top two items from the stack as VM Numbers. Push the larger of the two numbers.",e.OP_WITHIN="Pop the top three items from the stack as VM Numbers. If the top number is within the range defined by the following two numbers (left-inclusive), push a 1 (VM Number). Otherwise, push a 0 (VM Number). (E.g. for [a, b, c]: if (b <= a), and (a < c), [1]. Else [0].)",e.OP_RIPEMD160="Pop the top item from the stack and pass it through ripemd160, pushing the result onto the stack.",e.OP_SHA1="Pop the top item from the stack and pass it through sha1, pushing the result onto the stack.",e.OP_SHA256="Pop the top item from the stack and pass it through sha256, pushing the result onto the stack.",e.OP_HASH160="Pop the top item from the stack and pass it through sha256, then ripemd160, pushing the result onto the stack.",e.OP_HASH256="Pop the top item from the stack and pass it through sha256 twice, pushing the result onto the stack.",e.OP_CODESEPARATOR="Update the value of lastCodeSeparator to the instruction pointer's current value. (This reduces the coverage of signing serializations used in signature verification operations.)",e.OP_CHECKSIG="Pop the top two items from the stack. Treat the top as a signature and the second as a public key. If the signature is valid, push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_CHECKSIGVERIFY="Pop the top two items from the stack. Treat the top as a signature and the second as a public key. If the signature is not valid, error. (This operation is a combination of OP_CHECKSIG followed by OP_VERIFY.)",e.OP_CHECKMULTISIG="Pop items from the stack: first pop the VM Number of public keys, then pop each of those public keys. Next, pop the VM Number of required signatures, then pop each of those signatures. Finally, pop a final VM Number that must be 0 due to a protocol bug. Checking each signature against each public key in order, if all signatures are valid \u2013 and the required number of signatures have been provided \u2013 push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_CHECKMULTISIGVERIFY="Pop items from the stack: first pop the VM Number of public keys, then pop each of those public keys. Next, pop the VM Number of required signatures, then pop each of those signatures. Finally, (due to a protocol bug) pop an unused final VM Number that must be 0. Checking each signature against each public key in order, if any signatures are invalid \u2013 or the required number of signatures have not been provided \u2013 error. (This operation is a combination of OP_CHECKMULTISIG followed by OP_VERIFY.)",e.OP_NOP1="No operation (reserved for future expansion). Note: OP_NOP1 counts toward the opcode limit.",e.OP_CHECKLOCKTIMEVERIFY="Verify the transaction occurs after an absolute block time or height: read the top item on the stack as a VM Number (without removing it), and compare it to the transaction's locktime. If the required locktime has not passed, or if locktime has been disabled for this input by a maximized sequence number, error.",e.OP_CHECKSEQUENCEVERIFY=`Verify the transaction occurs after the output being spent has "aged" by a relative block time or block height since it was created: read the top item on the stack as a VM Number (without removing it), and compare it to the age encoded in the input's sequence number. If the required relative locktime has not passed, or if relative locktime has been disabled by the sequence number or the transaction version, error.`,e.OP_NOP4="No operation (reserved for future expansion). Note: OP_NOP4 counts toward the opcode limit.",e.OP_NOP6="No operation (reserved for future expansion). Note: OP_NOP6 counts toward the opcode limit.",e.OP_NOP5="No operation (reserved for future expansion). Note: OP_NOP5 counts toward the opcode limit.",e.OP_NOP7="No operation (reserved for future expansion). Note: OP_NOP7 counts toward the opcode limit.",e.OP_NOP8="No operation (reserved for future expansion). Note: OP_NOP8 counts toward the opcode limit.",e.OP_NOP9="No operation (reserved for future expansion). Note: OP_NOP9 counts toward the opcode limit.",e.OP_NOP10="No operation (reserved for future expansion). Note: OP_NOP10 counts toward the opcode limit.",e.OP_CHECKDATASIG="Pop the top 3 items from the stack. Treat the top as a public key, the second as a message, and the third as a signature. If the signature is valid, push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_CHECKDATASIGVERIFY="Pop the top 3 items from the stack. Treat the top as a public key, the second as a message, and the third as a signature. If the signature is not valid, error. (This operation is a combination of OP_CHECKDATASIG followed by OP_VERIFY.)",e.OP_REVERSEBYTES="Pop the top item from the stack and reverse it, pushing the result.",e.OP_INPUTINDEX="Push the index of the input being evaluated to the stack as a VM Number.",e.OP_ACTIVEBYTECODE="Push the bytecode currently being evaluated, beginning after the last executed OP_CODESEPARATOR, to the stack. For Pay-to-Script-Hash (P2SH) evaluations, this is the redeem bytecode of the Unspent Transaction Output (UTXO) being spent; for all other evaluations, this is the locking bytecode of the UTXO being spent.",e.OP_TXVERSION="Push the version of the current transaction to the stack as a VM Number.",e.OP_TXINPUTCOUNT="Push the count of inputs in the current transaction to the stack as a VM Number.",e.OP_TXOUTPUTCOUNT="Push the count of outputs in the current transaction to the stack as a VM Number.",e.OP_TXLOCKTIME="Push the locktime of the current transaction to the stack as a VM Number.",e.OP_UTXOVALUE="Pop the top item from the stack as an input index (VM Number). Push the value (in satoshis) of the Unspent Transaction Output (UTXO) spent by that input to the stack as a VM Number.",e.OP_UTXOBYTECODE="Pop the top item from the stack as an input index (VM Number). Push the full locking bytecode of the Unspent Transaction Output (UTXO) spent by that input to the stack.",e.OP_OUTPOINTTXHASH="Pop the top item from the stack as an input index (VM Number). From that input, push the outpoint transaction hash \u2013 the hash of the transaction that created the Unspent Transaction Output (UTXO) that is being spent \u2013 to the stack in OP_HASH256 byte order.",e.OP_OUTPOINTINDEX="Pop the top item from the stack as an input index (VM Number). From that input, push the outpoint index \u2013 the index of the output in the transaction that created the Unspent Transaction Output (UTXO) that is being spent \u2013 to the stack as a VM Number.",e.OP_INPUTBYTECODE="Pop the top item from the stack as an input index (VM Number). Push the unlocking bytecode of the input at that index to the stack.",e.OP_INPUTSEQUENCENUMBER="Pop the top item from the stack as an input index (VM Number). Push the sequence number of the input at that index to the stack as a VM Number.",e.OP_OUTPUTVALUE="Pop the top item from the stack as an output index (VM Number). Push the value (in satoshis) of the output at that index to the stack as a VM Number.",e.OP_OUTPUTBYTECODE="Pop the top item from the stack as an output index (VM Number). Push the locking bytecode of the output at that index to the stack.",e.OP_UTXOTOKENCATEGORY="Pop the top item from the stack as an input index (VM Number). If the Unspent Transaction Output (UTXO) spent by that input includes no tokens, push a 0 (VM Number) to the stack. If the UTXO does not include a non-fungible token with a capability, push the UTXO's token category, otherwise, push the concatenation of the token category and capability, where the mutable capability is represented by 1 (VM Number) and the minting capability is represented by 2 (VM Number).",e.OP_UTXOTOKENCOMMITMENT="Pop the top item from the stack as an input index (VM Number). Push the token commitment of the Unspent Transaction Output (UTXO) spent by that input to the stack. If the UTXO does not include a non-fungible token, or if it includes a non-fungible token with a zero-length commitment, push a 0 (VM Number).",e.OP_UTXOTOKENAMOUNT="Pop the top item from the stack as an input index (VM Number). Push the fungible token amount of the Unspent Transaction Output (UTXO) spent by that input to the stack as a VM Number. If the UTXO includes no fungible tokens, push a 0 (VM Number).",e.OP_OUTPUTTOKENCATEGORY="Pop the top item from the stack as an output index (VM Number). If the output spent by that input includes no tokens, push a 0 (VM Number) to the stack. If the output does not include a non-fungible token with a capability, push the output's token category, otherwise, push the concatenation of the token category and capability, where the mutable capability is represented by 1 (VM Number) and the minting capability is represented by 2 (VM Number).",e.OP_OUTPUTTOKENCOMMITMENT="Pop the top item from the stack as an output index (VM Number). Push the token commitment of the output at that index to the stack. If the output does not include a non-fungible token, or if it includes a non-fungible token with a zero-length commitment, push a 0 (VM Number).",e.OP_OUTPUTTOKENAMOUNT="Pop the top item from the stack as an output index (VM Number). Push the fungible token amount of the output at that index to the stack as a VM Number. If the output includes no fungible tokens, push a 0 (VM Number)."})(lg||(lg={}));var Sr=e=>e.controlStack.every(A=>A!==!1),T=e=>A=>Sr(A)?e(A):A,ug=T(e=>w(e,v.unknownOpcode)),hg=(e=ae.maximumStackItemLength)=>A=>{let a=A.instructions[A.ip];return a.data.length>e?w(A,`${v.exceededMaximumStackItemLength} Item length: ${a.data.length} bytes.`):Sr(A)?wn(a.opcode,a.data)?M(A,a.data):w(A,v.nonMinimalPush):A},_a=(e,A)=>(e.controlStack.push(A),e),dg=e=>Sr(e)?te(e,(A,[a])=>_a(A,We(a))):_a(e,!1),Eg=e=>Sr(e)?te(e,(A,[a])=>_a(A,!We(a))):_a(e,!1),Bg=e=>typeof e.controlStack.pop()!="boolean"?w(e,v.unexpectedEndIf):e,pg=e=>{let A=e.controlStack[e.controlStack.length-1];return typeof A!="boolean"?w(e,v.unexpectedElse):(e.controlStack[e.controlStack.length-1]=!A,e)},mg=e=>_a(e,e.ip),Qg=e=>{let A=e.controlStack.pop();if(typeof A!="number")return w(e,kA.unexpectedUntil);e.repeatedBytes+=iA(e.instructions.slice(A,e.ip)).length;let a=iA(e.instructions).length;return e.repeatedBytes+a>ae.maximumBytecodeLength?w(e,kA.excessiveLooping,`Repeated bytes: ${e.repeatedBytes}; active bytecode length: ${a}`):te(e,(r,[n])=>(n.length===1&&n[0]===1||(r.ip=A-1),r))};var m;(function(e){e[e.OP_0=0]="OP_0",e[e.OP_PUSHBYTES_1=1]="OP_PUSHBYTES_1",e[e.OP_PUSHBYTES_2=2]="OP_PUSHBYTES_2",e[e.OP_PUSHBYTES_3=3]="OP_PUSHBYTES_3",e[e.OP_PUSHBYTES_4=4]="OP_PUSHBYTES_4",e[e.OP_PUSHBYTES_5=5]="OP_PUSHBYTES_5",e[e.OP_PUSHBYTES_6=6]="OP_PUSHBYTES_6",e[e.OP_PUSHBYTES_7=7]="OP_PUSHBYTES_7",e[e.OP_PUSHBYTES_8=8]="OP_PUSHBYTES_8",e[e.OP_PUSHBYTES_9=9]="OP_PUSHBYTES_9",e[e.OP_PUSHBYTES_10=10]="OP_PUSHBYTES_10",e[e.OP_PUSHBYTES_11=11]="OP_PUSHBYTES_11",e[e.OP_PUSHBYTES_12=12]="OP_PUSHBYTES_12",e[e.OP_PUSHBYTES_13=13]="OP_PUSHBYTES_13",e[e.OP_PUSHBYTES_14=14]="OP_PUSHBYTES_14",e[e.OP_PUSHBYTES_15=15]="OP_PUSHBYTES_15",e[e.OP_PUSHBYTES_16=16]="OP_PUSHBYTES_16",e[e.OP_PUSHBYTES_17=17]="OP_PUSHBYTES_17",e[e.OP_PUSHBYTES_18=18]="OP_PUSHBYTES_18",e[e.OP_PUSHBYTES_19=19]="OP_PUSHBYTES_19",e[e.OP_PUSHBYTES_20=20]="OP_PUSHBYTES_20",e[e.OP_PUSHBYTES_21=21]="OP_PUSHBYTES_21",e[e.OP_PUSHBYTES_22=22]="OP_PUSHBYTES_22",e[e.OP_PUSHBYTES_23=23]="OP_PUSHBYTES_23",e[e.OP_PUSHBYTES_24=24]="OP_PUSHBYTES_24",e[e.OP_PUSHBYTES_25=25]="OP_PUSHBYTES_25",e[e.OP_PUSHBYTES_26=26]="OP_PUSHBYTES_26",e[e.OP_PUSHBYTES_27=27]="OP_PUSHBYTES_27",e[e.OP_PUSHBYTES_28=28]="OP_PUSHBYTES_28",e[e.OP_PUSHBYTES_29=29]="OP_PUSHBYTES_29",e[e.OP_PUSHBYTES_30=30]="OP_PUSHBYTES_30",e[e.OP_PUSHBYTES_31=31]="OP_PUSHBYTES_31",e[e.OP_PUSHBYTES_32=32]="OP_PUSHBYTES_32",e[e.OP_PUSHBYTES_33=33]="OP_PUSHBYTES_33",e[e.OP_PUSHBYTES_34=34]="OP_PUSHBYTES_34",e[e.OP_PUSHBYTES_35=35]="OP_PUSHBYTES_35",e[e.OP_PUSHBYTES_36=36]="OP_PUSHBYTES_36",e[e.OP_PUSHBYTES_37=37]="OP_PUSHBYTES_37",e[e.OP_PUSHBYTES_38=38]="OP_PUSHBYTES_38",e[e.OP_PUSHBYTES_39=39]="OP_PUSHBYTES_39",e[e.OP_PUSHBYTES_40=40]="OP_PUSHBYTES_40",e[e.OP_PUSHBYTES_41=41]="OP_PUSHBYTES_41",e[e.OP_PUSHBYTES_42=42]="OP_PUSHBYTES_42",e[e.OP_PUSHBYTES_43=43]="OP_PUSHBYTES_43",e[e.OP_PUSHBYTES_44=44]="OP_PUSHBYTES_44",e[e.OP_PUSHBYTES_45=45]="OP_PUSHBYTES_45",e[e.OP_PUSHBYTES_46=46]="OP_PUSHBYTES_46",e[e.OP_PUSHBYTES_47=47]="OP_PUSHBYTES_47",e[e.OP_PUSHBYTES_48=48]="OP_PUSHBYTES_48",e[e.OP_PUSHBYTES_49=49]="OP_PUSHBYTES_49",e[e.OP_PUSHBYTES_50=50]="OP_PUSHBYTES_50",e[e.OP_PUSHBYTES_51=51]="OP_PUSHBYTES_51",e[e.OP_PUSHBYTES_52=52]="OP_PUSHBYTES_52",e[e.OP_PUSHBYTES_53=53]="OP_PUSHBYTES_53",e[e.OP_PUSHBYTES_54=54]="OP_PUSHBYTES_54",e[e.OP_PUSHBYTES_55=55]="OP_PUSHBYTES_55",e[e.OP_PUSHBYTES_56=56]="OP_PUSHBYTES_56",e[e.OP_PUSHBYTES_57=57]="OP_PUSHBYTES_57",e[e.OP_PUSHBYTES_58=58]="OP_PUSHBYTES_58",e[e.OP_PUSHBYTES_59=59]="OP_PUSHBYTES_59",e[e.OP_PUSHBYTES_60=60]="OP_PUSHBYTES_60",e[e.OP_PUSHBYTES_61=61]="OP_PUSHBYTES_61",e[e.OP_PUSHBYTES_62=62]="OP_PUSHBYTES_62",e[e.OP_PUSHBYTES_63=63]="OP_PUSHBYTES_63",e[e.OP_PUSHBYTES_64=64]="OP_PUSHBYTES_64",e[e.OP_PUSHBYTES_65=65]="OP_PUSHBYTES_65",e[e.OP_PUSHBYTES_66=66]="OP_PUSHBYTES_66",e[e.OP_PUSHBYTES_67=67]="OP_PUSHBYTES_67",e[e.OP_PUSHBYTES_68=68]="OP_PUSHBYTES_68",e[e.OP_PUSHBYTES_69=69]="OP_PUSHBYTES_69",e[e.OP_PUSHBYTES_70=70]="OP_PUSHBYTES_70",e[e.OP_PUSHBYTES_71=71]="OP_PUSHBYTES_71",e[e.OP_PUSHBYTES_72=72]="OP_PUSHBYTES_72",e[e.OP_PUSHBYTES_73=73]="OP_PUSHBYTES_73",e[e.OP_PUSHBYTES_74=74]="OP_PUSHBYTES_74",e[e.OP_PUSHBYTES_75=75]="OP_PUSHBYTES_75",e[e.OP_PUSHDATA_1=76]="OP_PUSHDATA_1",e[e.OP_PUSHDATA_2=77]="OP_PUSHDATA_2",e[e.OP_PUSHDATA_4=78]="OP_PUSHDATA_4",e[e.OP_1NEGATE=79]="OP_1NEGATE",e[e.OP_RESERVED=80]="OP_RESERVED",e[e.OP_1=81]="OP_1",e[e.OP_2=82]="OP_2",e[e.OP_3=83]="OP_3",e[e.OP_4=84]="OP_4",e[e.OP_5=85]="OP_5",e[e.OP_6=86]="OP_6",e[e.OP_7=87]="OP_7",e[e.OP_8=88]="OP_8",e[e.OP_9=89]="OP_9",e[e.OP_10=90]="OP_10",e[e.OP_11=91]="OP_11",e[e.OP_12=92]="OP_12",e[e.OP_13=93]="OP_13",e[e.OP_14=94]="OP_14",e[e.OP_15=95]="OP_15",e[e.OP_16=96]="OP_16",e[e.OP_NOP=97]="OP_NOP",e[e.OP_VER=98]="OP_VER",e[e.OP_IF=99]="OP_IF",e[e.OP_NOTIF=100]="OP_NOTIF",e[e.OP_VERIF=101]="OP_VERIF",e[e.OP_BEGIN=101]="OP_BEGIN",e[e.OP_VERNOTIF=102]="OP_VERNOTIF",e[e.OP_UNTIL=102]="OP_UNTIL",e[e.OP_ELSE=103]="OP_ELSE",e[e.OP_ENDIF=104]="OP_ENDIF",e[e.OP_VERIFY=105]="OP_VERIFY",e[e.OP_RETURN=106]="OP_RETURN",e[e.OP_TOALTSTACK=107]="OP_TOALTSTACK",e[e.OP_FROMALTSTACK=108]="OP_FROMALTSTACK",e[e.OP_2DROP=109]="OP_2DROP",e[e.OP_2DUP=110]="OP_2DUP",e[e.OP_3DUP=111]="OP_3DUP",e[e.OP_2OVER=112]="OP_2OVER",e[e.OP_2ROT=113]="OP_2ROT",e[e.OP_2SWAP=114]="OP_2SWAP",e[e.OP_IFDUP=115]="OP_IFDUP",e[e.OP_DEPTH=116]="OP_DEPTH",e[e.OP_DROP=117]="OP_DROP",e[e.OP_DUP=118]="OP_DUP",e[e.OP_NIP=119]="OP_NIP",e[e.OP_OVER=120]="OP_OVER",e[e.OP_PICK=121]="OP_PICK",e[e.OP_ROLL=122]="OP_ROLL",e[e.OP_ROT=123]="OP_ROT",e[e.OP_SWAP=124]="OP_SWAP",e[e.OP_TUCK=125]="OP_TUCK",e[e.OP_CAT=126]="OP_CAT",e[e.OP_SPLIT=127]="OP_SPLIT",e[e.OP_NUM2BIN=128]="OP_NUM2BIN",e[e.OP_BIN2NUM=129]="OP_BIN2NUM",e[e.OP_SIZE=130]="OP_SIZE",e[e.OP_INVERT=131]="OP_INVERT",e[e.OP_AND=132]="OP_AND",e[e.OP_OR=133]="OP_OR",e[e.OP_XOR=134]="OP_XOR",e[e.OP_EQUAL=135]="OP_EQUAL",e[e.OP_EQUALVERIFY=136]="OP_EQUALVERIFY",e[e.OP_RESERVED1=137]="OP_RESERVED1",e[e.OP_RESERVED2=138]="OP_RESERVED2",e[e.OP_1ADD=139]="OP_1ADD",e[e.OP_1SUB=140]="OP_1SUB",e[e.OP_2MUL=141]="OP_2MUL",e[e.OP_2DIV=142]="OP_2DIV",e[e.OP_NEGATE=143]="OP_NEGATE",e[e.OP_ABS=144]="OP_ABS",e[e.OP_NOT=145]="OP_NOT",e[e.OP_0EQUAL=145]="OP_0EQUAL",e[e.OP_0NOTEQUAL=146]="OP_0NOTEQUAL",e[e.OP_ADD=147]="OP_ADD",e[e.OP_SUB=148]="OP_SUB",e[e.OP_MUL=149]="OP_MUL",e[e.OP_DIV=150]="OP_DIV",e[e.OP_MOD=151]="OP_MOD",e[e.OP_LSHIFT=152]="OP_LSHIFT",e[e.OP_RSHIFT=153]="OP_RSHIFT",e[e.OP_BOOLAND=154]="OP_BOOLAND",e[e.OP_BOOLOR=155]="OP_BOOLOR",e[e.OP_NUMEQUAL=156]="OP_NUMEQUAL",e[e.OP_NUMEQUALVERIFY=157]="OP_NUMEQUALVERIFY",e[e.OP_NUMNOTEQUAL=158]="OP_NUMNOTEQUAL",e[e.OP_LESSTHAN=159]="OP_LESSTHAN",e[e.OP_GREATERTHAN=160]="OP_GREATERTHAN",e[e.OP_LESSTHANOREQUAL=161]="OP_LESSTHANOREQUAL",e[e.OP_GREATERTHANOREQUAL=162]="OP_GREATERTHANOREQUAL",e[e.OP_MIN=163]="OP_MIN",e[e.OP_MAX=164]="OP_MAX",e[e.OP_WITHIN=165]="OP_WITHIN",e[e.OP_RIPEMD160=166]="OP_RIPEMD160",e[e.OP_SHA1=167]="OP_SHA1",e[e.OP_SHA256=168]="OP_SHA256",e[e.OP_HASH160=169]="OP_HASH160",e[e.OP_HASH256=170]="OP_HASH256",e[e.OP_CODESEPARATOR=171]="OP_CODESEPARATOR",e[e.OP_CHECKSIG=172]="OP_CHECKSIG",e[e.OP_CHECKSIGVERIFY=173]="OP_CHECKSIGVERIFY",e[e.OP_CHECKMULTISIG=174]="OP_CHECKMULTISIG",e[e.OP_CHECKMULTISIGVERIFY=175]="OP_CHECKMULTISIGVERIFY",e[e.OP_NOP1=176]="OP_NOP1",e[e.OP_CHECKLOCKTIMEVERIFY=177]="OP_CHECKLOCKTIMEVERIFY",e[e.OP_CHECKSEQUENCEVERIFY=178]="OP_CHECKSEQUENCEVERIFY",e[e.OP_NOP4=179]="OP_NOP4",e[e.OP_NOP5=180]="OP_NOP5",e[e.OP_NOP6=181]="OP_NOP6",e[e.OP_NOP7=182]="OP_NOP7",e[e.OP_NOP8=183]="OP_NOP8",e[e.OP_NOP9=184]="OP_NOP9",e[e.OP_NOP10=185]="OP_NOP10",e[e.OP_CHECKDATASIG=186]="OP_CHECKDATASIG",e[e.OP_CHECKDATASIGVERIFY=187]="OP_CHECKDATASIGVERIFY",e[e.OP_REVERSEBYTES=188]="OP_REVERSEBYTES",e[e.OP_UNKNOWN189=189]="OP_UNKNOWN189",e[e.OP_UNKNOWN190=190]="OP_UNKNOWN190",e[e.OP_UNKNOWN191=191]="OP_UNKNOWN191",e[e.OP_INPUTINDEX=192]="OP_INPUTINDEX",e[e.OP_ACTIVEBYTECODE=193]="OP_ACTIVEBYTECODE",e[e.OP_TXVERSION=194]="OP_TXVERSION",e[e.OP_TXINPUTCOUNT=195]="OP_TXINPUTCOUNT",e[e.OP_TXOUTPUTCOUNT=196]="OP_TXOUTPUTCOUNT",e[e.OP_TXLOCKTIME=197]="OP_TXLOCKTIME",e[e.OP_UTXOVALUE=198]="OP_UTXOVALUE",e[e.OP_UTXOBYTECODE=199]="OP_UTXOBYTECODE",e[e.OP_OUTPOINTTXHASH=200]="OP_OUTPOINTTXHASH",e[e.OP_OUTPOINTINDEX=201]="OP_OUTPOINTINDEX",e[e.OP_INPUTBYTECODE=202]="OP_INPUTBYTECODE",e[e.OP_INPUTSEQUENCENUMBER=203]="OP_INPUTSEQUENCENUMBER",e[e.OP_OUTPUTVALUE=204]="OP_OUTPUTVALUE",e[e.OP_OUTPUTBYTECODE=205]="OP_OUTPUTBYTECODE",e[e.OP_UTXOTOKENCATEGORY=206]="OP_UTXOTOKENCATEGORY",e[e.OP_UTXOTOKENCOMMITMENT=207]="OP_UTXOTOKENCOMMITMENT",e[e.OP_UTXOTOKENAMOUNT=208]="OP_UTXOTOKENAMOUNT",e[e.OP_OUTPUTTOKENCATEGORY=209]="OP_OUTPUTTOKENCATEGORY",e[e.OP_OUTPUTTOKENCOMMITMENT=210]="OP_OUTPUTTOKENCOMMITMENT",e[e.OP_OUTPUTTOKENAMOUNT=211]="OP_OUTPUTTOKENAMOUNT",e[e.OP_UNKNOWN212=212]="OP_UNKNOWN212",e[e.OP_UNKNOWN213=213]="OP_UNKNOWN213",e[e.OP_UNKNOWN214=214]="OP_UNKNOWN214",e[e.OP_UNKNOWN215=215]="OP_UNKNOWN215",e[e.OP_UNKNOWN216=216]="OP_UNKNOWN216",e[e.OP_UNKNOWN217=217]="OP_UNKNOWN217",e[e.OP_UNKNOWN218=218]="OP_UNKNOWN218",e[e.OP_UNKNOWN219=219]="OP_UNKNOWN219",e[e.OP_UNKNOWN220=220]="OP_UNKNOWN220",e[e.OP_UNKNOWN221=221]="OP_UNKNOWN221",e[e.OP_UNKNOWN222=222]="OP_UNKNOWN222",e[e.OP_UNKNOWN223=223]="OP_UNKNOWN223",e[e.OP_UNKNOWN224=224]="OP_UNKNOWN224",e[e.OP_UNKNOWN225=225]="OP_UNKNOWN225",e[e.OP_UNKNOWN226=226]="OP_UNKNOWN226",e[e.OP_UNKNOWN227=227]="OP_UNKNOWN227",e[e.OP_UNKNOWN228=228]="OP_UNKNOWN228",e[e.OP_UNKNOWN229=229]="OP_UNKNOWN229",e[e.OP_UNKNOWN230=230]="OP_UNKNOWN230",e[e.OP_UNKNOWN231=231]="OP_UNKNOWN231",e[e.OP_UNKNOWN232=232]="OP_UNKNOWN232",e[e.OP_UNKNOWN233=233]="OP_UNKNOWN233",e[e.OP_UNKNOWN234=234]="OP_UNKNOWN234",e[e.OP_UNKNOWN235=235]="OP_UNKNOWN235",e[e.OP_UNKNOWN236=236]="OP_UNKNOWN236",e[e.OP_UNKNOWN237=237]="OP_UNKNOWN237",e[e.OP_UNKNOWN238=238]="OP_UNKNOWN238",e[e.OP_UNKNOWN239=239]="OP_UNKNOWN239",e[e.OP_UNKNOWN240=240]="OP_UNKNOWN240",e[e.OP_UNKNOWN241=241]="OP_UNKNOWN241",e[e.OP_UNKNOWN242=242]="OP_UNKNOWN242",e[e.OP_UNKNOWN243=243]="OP_UNKNOWN243",e[e.OP_UNKNOWN244=244]="OP_UNKNOWN244",e[e.OP_UNKNOWN245=245]="OP_UNKNOWN245",e[e.OP_UNKNOWN246=246]="OP_UNKNOWN246",e[e.OP_UNKNOWN247=247]="OP_UNKNOWN247",e[e.OP_UNKNOWN248=248]="OP_UNKNOWN248",e[e.OP_UNKNOWN249=249]="OP_UNKNOWN249",e[e.OP_UNKNOWN250=250]="OP_UNKNOWN250",e[e.OP_UNKNOWN251=251]="OP_UNKNOWN251",e[e.OP_UNKNOWN252=252]="OP_UNKNOWN252",e[e.OP_UNKNOWN253=253]="OP_UNKNOWN253",e[e.OP_UNKNOWN254=254]="OP_UNKNOWN254",e[e.OP_UNKNOWN255=255]="OP_UNKNOWN255"})(m||(m={}));var yg=(e=!0,{ripemd160:A,secp256k1:a,sha1:r,sha256:n}={ripemd160:Ee,secp256k1:Ae,sha1:fA,sha256:q})=>{let i=hg();return{clone:gg,continue:t=>t.error===void 0&&t.ip<t.instructions.length,evaluate:(t,o)=>{let{unlockingBytecode:s}=t.transaction.inputs[t.inputIndex],{lockingBytecode:g}=t.sourceOutputs[t.inputIndex],l=we(s),I=we(g),E=Cr({instructions:l,program:t,stack:[]});if(s.length>re.maximumBytecodeLength)return w(E,`The provided unlocking bytecode (${s.length} bytes) exceeds the maximum bytecode length (${re.maximumBytecodeLength} bytes).`);if(tA(l))return w(E,v.malformedUnlockingBytecode);if(!bA(s))return w(E,v.requiresPushOnly);if(g.length>re.maximumBytecodeLength)return w(E,v.exceededMaximumBytecodeLengthLocking);if(tA(I))return w(E,v.malformedLockingBytecode);let u=o(E);if(u.error!==void 0)return u;if(u.controlStack.length!==0)return w(E,v.nonEmptyControlStack);let k=o(Cr({instructions:I,program:t,stack:u.stack}));if(!PA(g))return k;let U=BA(u.stack),N=U.pop()??Uint8Array.of();if(U.length===0&&Dt(N))return k;let c=we(N);return tA(c)?{...k,error:v.malformedP2shBytecode}:o(Cr({instructions:c,program:t,stack:U}))},every:t=>t.stack.length+t.alternateStack.length>re.maximumStackDepth?w(t,v.exceededMaximumStackDepth):t,operations:{[m.OP_0]:i,[m.OP_PUSHBYTES_1]:i,[m.OP_PUSHBYTES_2]:i,[m.OP_PUSHBYTES_3]:i,[m.OP_PUSHBYTES_4]:i,[m.OP_PUSHBYTES_5]:i,[m.OP_PUSHBYTES_6]:i,[m.OP_PUSHBYTES_7]:i,[m.OP_PUSHBYTES_8]:i,[m.OP_PUSHBYTES_9]:i,[m.OP_PUSHBYTES_10]:i,[m.OP_PUSHBYTES_11]:i,[m.OP_PUSHBYTES_12]:i,[m.OP_PUSHBYTES_13]:i,[m.OP_PUSHBYTES_14]:i,[m.OP_PUSHBYTES_15]:i,[m.OP_PUSHBYTES_16]:i,[m.OP_PUSHBYTES_17]:i,[m.OP_PUSHBYTES_18]:i,[m.OP_PUSHBYTES_19]:i,[m.OP_PUSHBYTES_20]:i,[m.OP_PUSHBYTES_21]:i,[m.OP_PUSHBYTES_22]:i,[m.OP_PUSHBYTES_23]:i,[m.OP_PUSHBYTES_24]:i,[m.OP_PUSHBYTES_25]:i,[m.OP_PUSHBYTES_26]:i,[m.OP_PUSHBYTES_27]:i,[m.OP_PUSHBYTES_28]:i,[m.OP_PUSHBYTES_29]:i,[m.OP_PUSHBYTES_30]:i,[m.OP_PUSHBYTES_31]:i,[m.OP_PUSHBYTES_32]:i,[m.OP_PUSHBYTES_33]:i,[m.OP_PUSHBYTES_34]:i,[m.OP_PUSHBYTES_35]:i,[m.OP_PUSHBYTES_36]:i,[m.OP_PUSHBYTES_37]:i,[m.OP_PUSHBYTES_38]:i,[m.OP_PUSHBYTES_39]:i,[m.OP_PUSHBYTES_40]:i,[m.OP_PUSHBYTES_41]:i,[m.OP_PUSHBYTES_42]:i,[m.OP_PUSHBYTES_43]:i,[m.OP_PUSHBYTES_44]:i,[m.OP_PUSHBYTES_45]:i,[m.OP_PUSHBYTES_46]:i,[m.OP_PUSHBYTES_47]:i,[m.OP_PUSHBYTES_48]:i,[m.OP_PUSHBYTES_49]:i,[m.OP_PUSHBYTES_50]:i,[m.OP_PUSHBYTES_51]:i,[m.OP_PUSHBYTES_52]:i,[m.OP_PUSHBYTES_53]:i,[m.OP_PUSHBYTES_54]:i,[m.OP_PUSHBYTES_55]:i,[m.OP_PUSHBYTES_56]:i,[m.OP_PUSHBYTES_57]:i,[m.OP_PUSHBYTES_58]:i,[m.OP_PUSHBYTES_59]:i,[m.OP_PUSHBYTES_60]:i,[m.OP_PUSHBYTES_61]:i,[m.OP_PUSHBYTES_62]:i,[m.OP_PUSHBYTES_63]:i,[m.OP_PUSHBYTES_64]:i,[m.OP_PUSHBYTES_65]:i,[m.OP_PUSHBYTES_66]:i,[m.OP_PUSHBYTES_67]:i,[m.OP_PUSHBYTES_68]:i,[m.OP_PUSHBYTES_69]:i,[m.OP_PUSHBYTES_70]:i,[m.OP_PUSHBYTES_71]:i,[m.OP_PUSHBYTES_72]:i,[m.OP_PUSHBYTES_73]:i,[m.OP_PUSHBYTES_74]:i,[m.OP_PUSHBYTES_75]:i,[m.OP_PUSHDATA_1]:i,[m.OP_PUSHDATA_2]:i,[m.OP_PUSHDATA_4]:i,[m.OP_1NEGATE]:T(z(-1)),[m.OP_RESERVED]:T(Ye),[m.OP_1]:T(z(1)),[m.OP_2]:T(z(2)),[m.OP_3]:T(z(3)),[m.OP_4]:T(z(4)),[m.OP_5]:T(z(5)),[m.OP_6]:T(z(6)),[m.OP_7]:T(z(7)),[m.OP_8]:T(z(8)),[m.OP_9]:T(z(9)),[m.OP_10]:T(z(10)),[m.OP_11]:T(z(11)),[m.OP_12]:T(z(12)),[m.OP_13]:T(z(13)),[m.OP_14]:T(z(14)),[m.OP_15]:T(z(15)),[m.OP_16]:T(z(16)),[m.OP_NOP]:T(Ie),[m.OP_VER]:T(Ye),[m.OP_IF]:dg,[m.OP_NOTIF]:Eg,[m.OP_BEGIN]:T(mg),[m.OP_UNTIL]:T(Qg),[m.OP_ELSE]:pg,[m.OP_ENDIF]:Bg,[m.OP_VERIFY]:T(me),[m.OP_RETURN]:T(xt),[m.OP_TOALTSTACK]:T(Oi),[m.OP_FROMALTSTACK]:T(Ri),[m.OP_2DROP]:T(Fi),[m.OP_2DUP]:T(Ki),[m.OP_3DUP]:T(Mi),[m.OP_2OVER]:T(Gi),[m.OP_2ROT]:T(qi),[m.OP_2SWAP]:T(Hi),[m.OP_IFDUP]:T(Ji),[m.OP_DEPTH]:T(Li),[m.OP_DROP]:T(Vi),[m.OP_DUP]:T(zi),[m.OP_NIP]:T(ji),[m.OP_OVER]:T(Wi),[m.OP_PICK]:T(Zi),[m.OP_ROLL]:T(Xi),[m.OP_ROT]:T($i),[m.OP_SWAP]:T(ea),[m.OP_TUCK]:T(Aa),[m.OP_CAT]:T(Bi),[m.OP_SPLIT]:T(pi),[m.OP_NUM2BIN]:T(mi),[m.OP_BIN2NUM]:T(Qi),[m.OP_SIZE]:T(ta),[m.OP_INVERT]:Te,[m.OP_AND]:T(ni),[m.OP_OR]:T(oi),[m.OP_XOR]:T(si),[m.OP_EQUAL]:T(lt),[m.OP_EQUALVERIFY]:T(ri),[m.OP_RESERVED1]:T(Ye),[m.OP_RESERVED2]:T(Ye),[m.OP_1ADD]:T(Ot),[m.OP_1SUB]:T(Rt),[m.OP_2MUL]:Te,[m.OP_2DIV]:Te,[m.OP_NEGATE]:T(Ft),[m.OP_ABS]:T(Kt),[m.OP_NOT]:T(Mt),[m.OP_0NOTEQUAL]:T(Gt),[m.OP_ADD]:T(qt),[m.OP_SUB]:T(Ht),[m.OP_MUL]:T(ti),[m.OP_DIV]:T(ii),[m.OP_MOD]:T(ai),[m.OP_LSHIFT]:Te,[m.OP_RSHIFT]:Te,[m.OP_BOOLAND]:T(Jt),[m.OP_BOOLOR]:T(Lt),[m.OP_NUMEQUAL]:T(ct),[m.OP_NUMEQUALVERIFY]:T(Vt),[m.OP_NUMNOTEQUAL]:T(zt),[m.OP_LESSTHAN]:T(jt),[m.OP_GREATERTHAN]:T(Zt),[m.OP_LESSTHANOREQUAL]:T(Wt),[m.OP_GREATERTHANOREQUAL]:T(Xt),[m.OP_MIN]:T($t),[m.OP_MAX]:T(ei),[m.OP_WITHIN]:T(Ai),[m.OP_RIPEMD160]:T(gi({ripemd160:A})),[m.OP_SHA1]:T(Ii({sha1:r})),[m.OP_SHA256]:T(ci({sha256:n})),[m.OP_HASH160]:T(li({ripemd160:A,sha256:n})),[m.OP_HASH256]:T(ui({sha256:n})),[m.OP_CODESEPARATOR]:T(hi),[m.OP_CHECKSIG]:T(Kn({secp256k1:a,sha256:n})),[m.OP_CHECKSIGVERIFY]:T(Ig({secp256k1:a,sha256:n})),[m.OP_CHECKMULTISIG]:T(Mn({secp256k1:a,sha256:n})),[m.OP_CHECKMULTISIGVERIFY]:T(cg({secp256k1:a,sha256:n})),...e?{[m.OP_NOP1]:T(ue),[m.OP_CHECKLOCKTIMEVERIFY]:T(xA),[m.OP_CHECKSEQUENCEVERIFY]:T(OA),[m.OP_NOP4]:T(ue),[m.OP_NOP5]:T(ue),[m.OP_NOP6]:T(ue),[m.OP_NOP7]:T(ue),[m.OP_NOP8]:T(ue),[m.OP_NOP9]:T(ue),[m.OP_NOP10]:T(ue)}:{[m.OP_NOP1]:T(Ie),[m.OP_CHECKLOCKTIMEVERIFY]:T(xA),[m.OP_CHECKSEQUENCEVERIFY]:T(OA),[m.OP_NOP4]:T(Ie),[m.OP_NOP5]:T(Ie),[m.OP_NOP6]:T(Ie),[m.OP_NOP7]:T(Ie),[m.OP_NOP8]:T(Ie),[m.OP_NOP9]:T(Ie),[m.OP_NOP10]:T(Ie)},[m.OP_CHECKDATASIG]:T(ut({secp256k1:a,sha256:n})),[m.OP_CHECKDATASIGVERIFY]:T(di({secp256k1:a,sha256:n})),[m.OP_REVERSEBYTES]:T(Ei),[m.OP_INPUTINDEX]:T(yi),[m.OP_ACTIVEBYTECODE]:T(fi),[m.OP_TXVERSION]:T(Ci),[m.OP_TXINPUTCOUNT]:T(Pi),[m.OP_TXOUTPUTCOUNT]:T(Si),[m.OP_TXLOCKTIME]:T(bi),[m.OP_UTXOVALUE]:T(Ni),[m.OP_UTXOBYTECODE]:T(Ui),[m.OP_OUTPOINTTXHASH]:T(_i),[m.OP_OUTPOINTINDEX]:T(vi),[m.OP_INPUTBYTECODE]:T(Di),[m.OP_INPUTSEQUENCENUMBER]:T(wi),[m.OP_OUTPUTVALUE]:T(Yi),[m.OP_OUTPUTBYTECODE]:T(xi),[m.OP_UTXOTOKENCATEGORY]:T(Er),[m.OP_UTXOTOKENCOMMITMENT]:T(Br),[m.OP_UTXOTOKENAMOUNT]:T(pr),[m.OP_OUTPUTTOKENCATEGORY]:T(mr),[m.OP_OUTPUTTOKENCOMMITMENT]:T(Qr),[m.OP_OUTPUTTOKENAMOUNT]:T(yr)},success:t=>t.error!==void 0?t.error:t.controlStack.length!==0?v.nonEmptyControlStack:t.stack.length!==1?v.requiresCleanStack:We(t.stack[0])?!0:v.unsuccessfulEvaluation,undefined:ug,verify:({sourceOutputs:t,transaction:o},s,g)=>{if(o.inputs.length===0)return"Transactions must have at least one input.";if(o.outputs.length===0)return"Transactions must have at least one output.";if(o.inputs.length!==t.length)return"Unable to verify transaction: a single spent output must be provided for each transaction input.";let l=gt(o).length;if(l<re.minimumTransactionSize)return`Transaction does not meet minimum size: the transaction is ${l} bytes, but the minimum transaction size is ${re.minimumTransactionSize} bytes.`;if(l>re.maximumTransactionSize)return`Transaction exceeds maximum size: the transaction is ${l} bytes, but the maximum transaction size is ${re.maximumTransactionSize} bytes.`;if(e){if(o.version<1||o.version>re.maximumStandardVersion)return`Standard transactions must have a version no less than 1 and no greater than ${re.maximumStandardVersion}.`;if(l>re.maximumStandardTransactionSize)return`Transaction exceeds maximum standard size: this transaction is ${l} bytes, but the maximum standard transaction size is ${re.maximumStandardTransactionSize} bytes.`;for(let[E,u]of t.entries())if(!vt(u.lockingBytecode))return`Standard transactions may only spend standard output types, but source output ${E} is non-standard.`;let I=0;for(let[E,u]of o.outputs.entries()){if(!vt(u.lockingBytecode))return`Standard transactions may only create standard output types, but transaction output ${E} is non-standard.`;wA(u.lockingBytecode)&&(I+=u.lockingBytecode.length+1)}if(I>re.maximumDataCarrierBytes)return`Standard transactions may carry no more than ${re.maximumDataCarrierBytes} bytes in arbitrary data outputs; this transaction includes ${I} bytes of arbitrary data.`;for(let[E,u]of o.inputs.entries()){if(u.unlockingBytecode.length>re.maximumStandardUnlockingBytecodeLength)return`Input index ${E} is non-standard: the unlocking bytecode (${u.unlockingBytecode.length} bytes) exceeds the maximum standard unlocking bytecode length (${re.maximumStandardUnlockingBytecodeLength} bytes).`;if(!bA(u.unlockingBytecode))return`Input index ${E} is non-standard: unlocking bytecode may contain only push operations.`}}for(let I of o.inputs.keys()){let E=s({inputIndex:I,sourceOutputs:t,transaction:o}),u=g(E);if(typeof u=="string")return`Error in evaluating input index ${I}: ${u}`}return!0}}};var Ny=(e=!0)=>RA(yg(e));var fg;(function(e){e.OP_0="Push the VM Number 0 onto the stack.",e.OP_PUSHBYTES_1="Push the next byte onto the stack.",e.OP_PUSHBYTES_2="Push the next 2 bytes onto the stack.",e.OP_PUSHBYTES_3="Push the next 3 bytes onto the stack.",e.OP_PUSHBYTES_4="Push the next 4 bytes onto the stack.",e.OP_PUSHBYTES_5="Push the next 5 bytes onto the stack.",e.OP_PUSHBYTES_6="Push the next 6 bytes onto the stack.",e.OP_PUSHBYTES_7="Push the next 7 bytes onto the stack.",e.OP_PUSHBYTES_8="Push the next 8 bytes onto the stack.",e.OP_PUSHBYTES_9="Push the next 9 bytes onto the stack.",e.OP_PUSHBYTES_10="Push the next 10 bytes onto the stack.",e.OP_PUSHBYTES_11="Push the next 11 bytes onto the stack.",e.OP_PUSHBYTES_12="Push the next 12 bytes onto the stack.",e.OP_PUSHBYTES_13="Push the next 13 bytes onto the stack.",e.OP_PUSHBYTES_14="Push the next 14 bytes onto the stack.",e.OP_PUSHBYTES_15="Push the next 15 bytes onto the stack.",e.OP_PUSHBYTES_16="Push the next 16 bytes onto the stack.",e.OP_PUSHBYTES_17="Push the next 17 bytes onto the stack.",e.OP_PUSHBYTES_18="Push the next 18 bytes onto the stack.",e.OP_PUSHBYTES_19="Push the next 19 bytes onto the stack.",e.OP_PUSHBYTES_20="Push the next 20 bytes onto the stack.",e.OP_PUSHBYTES_21="Push the next 21 bytes onto the stack.",e.OP_PUSHBYTES_22="Push the next 22 bytes onto the stack.",e.OP_PUSHBYTES_23="Push the next 23 bytes onto the stack.",e.OP_PUSHBYTES_24="Push the next 24 bytes onto the stack.",e.OP_PUSHBYTES_25="Push the next 25 bytes onto the stack.",e.OP_PUSHBYTES_26="Push the next 26 bytes onto the stack.",e.OP_PUSHBYTES_27="Push the next 27 bytes onto the stack.",e.OP_PUSHBYTES_28="Push the next 28 bytes onto the stack.",e.OP_PUSHBYTES_29="Push the next 29 bytes onto the stack.",e.OP_PUSHBYTES_30="Push the next 30 bytes onto the stack.",e.OP_PUSHBYTES_31="Push the next 31 bytes onto the stack.",e.OP_PUSHBYTES_32="Push the next 32 bytes onto the stack.",e.OP_PUSHBYTES_33="Push the next 33 bytes onto the stack.",e.OP_PUSHBYTES_34="Push the next 34 bytes onto the stack.",e.OP_PUSHBYTES_35="Push the next 35 bytes onto the stack.",e.OP_PUSHBYTES_36="Push the next 36 bytes onto the stack.",e.OP_PUSHBYTES_37="Push the next 37 bytes onto the stack.",e.OP_PUSHBYTES_38="Push the next 38 bytes onto the stack.",e.OP_PUSHBYTES_39="Push the next 39 bytes onto the stack.",e.OP_PUSHBYTES_40="Push the next 40 bytes onto the stack.",e.OP_PUSHBYTES_41="Push the next 41 bytes onto the stack.",e.OP_PUSHBYTES_42="Push the next 42 bytes onto the stack.",e.OP_PUSHBYTES_43="Push the next 43 bytes onto the stack.",e.OP_PUSHBYTES_44="Push the next 44 bytes onto the stack.",e.OP_PUSHBYTES_45="Push the next 45 bytes onto the stack.",e.OP_PUSHBYTES_46="Push the next 46 bytes onto the stack.",e.OP_PUSHBYTES_47="Push the next 47 bytes onto the stack.",e.OP_PUSHBYTES_48="Push the next 48 bytes onto the stack.",e.OP_PUSHBYTES_49="Push the next 49 bytes onto the stack.",e.OP_PUSHBYTES_50="Push the next 50 bytes onto the stack.",e.OP_PUSHBYTES_51="Push the next 51 bytes onto the stack.",e.OP_PUSHBYTES_52="Push the next 52 bytes onto the stack.",e.OP_PUSHBYTES_53="Push the next 53 bytes onto the stack.",e.OP_PUSHBYTES_54="Push the next 54 bytes onto the stack.",e.OP_PUSHBYTES_55="Push the next 55 bytes onto the stack.",e.OP_PUSHBYTES_56="Push the next 56 bytes onto the stack.",e.OP_PUSHBYTES_57="Push the next 57 bytes onto the stack.",e.OP_PUSHBYTES_58="Push the next 58 bytes onto the stack.",e.OP_PUSHBYTES_59="Push the next 59 bytes onto the stack.",e.OP_PUSHBYTES_60="Push the next 60 bytes onto the stack.",e.OP_PUSHBYTES_61="Push the next 61 bytes onto the stack.",e.OP_PUSHBYTES_62="Push the next 62 bytes onto the stack.",e.OP_PUSHBYTES_63="Push the next 63 bytes onto the stack.",e.OP_PUSHBYTES_64="Push the next 64 bytes onto the stack.",e.OP_PUSHBYTES_65="Push the next 65 bytes onto the stack.",e.OP_PUSHBYTES_66="Push the next 66 bytes onto the stack.",e.OP_PUSHBYTES_67="Push the next 67 bytes onto the stack.",e.OP_PUSHBYTES_68="Push the next 68 bytes onto the stack.",e.OP_PUSHBYTES_69="Push the next 69 bytes onto the stack.",e.OP_PUSHBYTES_70="Push the next 70 bytes onto the stack.",e.OP_PUSHBYTES_71="Push the next 71 bytes onto the stack.",e.OP_PUSHBYTES_72="Push the next 72 bytes onto the stack.",e.OP_PUSHBYTES_73="Push the next 73 bytes onto the stack.",e.OP_PUSHBYTES_74="Push the next 74 bytes onto the stack.",e.OP_PUSHBYTES_75="Push the next 75 bytes onto the stack.",e.OP_PUSHDATA_1="Read the next Uint8 and push that number of bytes onto the stack.",e.OP_PUSHDATA_2="Read the next little-endian Uint16 and push that number of bytes onto the stack.",e.OP_PUSHDATA_4="Read the next little-endian Uint32 and push that number of bytes onto the stack.",e.OP_1NEGATE="Push the VM Number -1 onto the stack.",e.OP_RESERVED="Error unless found in an unexecuted conditional branch. Note: OP_RESERVED does not count toward the opcode limit.",e.OP_1="Push a 1 (VM Number) onto the stack.",e.OP_2="Push a 2 (VM Number) onto the stack.",e.OP_3="Push a 3 (VM Number) onto the stack.",e.OP_4="Push a 4 (VM Number) onto the stack.",e.OP_5="Push a 5 (VM Number) onto the stack.",e.OP_6="Push a 6 (VM Number) onto the stack.",e.OP_7="Push a 7 (VM Number) onto the stack.",e.OP_8="Push a 8 (VM Number) onto the stack.",e.OP_9="Push a 9 (VM Number) onto the stack.",e.OP_10="Push a 10 (VM Number) onto the stack.",e.OP_11="Push a 11 (VM Number) onto the stack.",e.OP_12="Push a 12 (VM Number) onto the stack.",e.OP_13="Push a 13 (VM Number) onto the stack.",e.OP_14="Push a 14 (VM Number) onto the stack.",e.OP_15="Push a 15 (VM Number) onto the stack.",e.OP_16="Push a 16 (VM Number) onto the stack.",e.OP_NOP="No operation. Note: OP_NOP counts toward the opcode limit.",e.OP_VER="Error unless found in an unexecuted conditional branch. Note: OP_VER counts toward the opcode limit. (Historically, this pushed a protocol version number to the stack.)",e.OP_IF='Pop the top item from the stack. If it is not "truthy", skip evaluation until a matching OP_ELSE or OP_ENDIF.',e.OP_NOTIF='Pop the top item from the stack. If it is "truthy", skip evaluation until a matching OP_ELSE or OP_ENDIF.',e.OP_VERIF="Error, even when found in an unexecuted conditional branch. (Historically, this was a combination of OP_VER and OP_IF.)",e.OP_VERNOTIF="Error, even when found in an unexecuted conditional branch. (Historically, this was a combination of OP_VER and OP_NOTIF.)",e.OP_ELSE="Invert conditional evaluation within the current OP_IF ... OP_ENDIF block. (If evaluation is enabled, disable it, if it is disabled, enable it.)",e.OP_ENDIF="End the current OP_IF/OP_NOTIF ... OP_ENDIF block.",e.OP_VERIFY=`Pop the top item from the stack and error if it isn't "truthy".`,e.OP_RETURN="Error when executed.",e.OP_TOALTSTACK="Pop the top item from the stack and push it onto the alternate stack.",e.OP_FROMALTSTACK="Pop the top item from the alternate stack and push it onto the stack.",e.OP_2DROP="Pop the top 2 items from the stack and discard them.",e.OP_2DUP="Duplicate the top 2 items on the stack. (E.g. [a, b] -> [a, b, a, b])",e.OP_3DUP="Duplicate the top 3 items on the stack. (E.g. [a, b, c] -> [a, b, c, a, b, c])",e.OP_2OVER="Duplicate the 2 items beginning at a depth of 2 on the stack. (E.g. [a, b, c, d] -> [a, b, c, d, a, b])",e.OP_2ROT="Rotate the top 6 items on the stack, bringing the fifth and sixth items to the top. (E.g. [a, b, c, d, e, f] -> [c, d, e, f, a, b])",e.OP_2SWAP="Swap the positions of the top two pairs of items on the stack. (E.g. [a, b, c, d] -> [c, d, a, b])",e.OP_IFDUP='If the top item on the stack is "truthy", duplicate it.',e.OP_DEPTH="Push the current number of stack items as a VM Number.",e.OP_DROP="Pop the top item from the stack and discard it. (E.g. [a] -> [])",e.OP_DUP="Duplicate the top item on the stack. (E.g. [a] -> [a, a])",e.OP_NIP="Remove the second-to-top item from the stack. (E.g. [a, b] -> [b])",e.OP_OVER="Duplicate the second-to-top item on the stack. (E.g. [a, b] -> [a, b, a])",e.OP_PICK="Pop the top item from the stack as a VM Number. Duplicate the item at that depth (zero-indexed), placing it on top of the stack. (E.g. [a, b, c, 2] -> [a, b, c, a])",e.OP_ROLL="Pop the top item from the stack as a VM Number. Move the item at that depth (zero-indexed) to the top of the stack. (E.g. [a, b, c, 2] -> [b, c, a])",e.OP_ROT="Rotate the top 3 items on the stack, bringing the third item to the top. (E.g. [a, b, c] -> [b, c, a])",e.OP_SWAP="Swap the top two items on the stack. (E.g. [a, b] -> [b, a])",e.OP_TUCK="Duplicate the item at the top of the stack, inserting it below the second-to-top item. (E.g. [a, b] -> [b, a, b])",e.OP_CAT="Error, even when found in an unexecuted conditional branch. (Historically, this concatenated two stack items.)",e.OP_SUBSTR="Error, even when found in an unexecuted conditional branch. (Historically, this returned a section of a stack item.)",e.OP_LEFT="Error, even when found in an unexecuted conditional branch. (Historically, this returned a section to the left of a point in a stack item.)",e.OP_RIGHT="Error, even when found in an unexecuted conditional branch. (Historically, this returned a section to the right of a point in a stack item.)",e.OP_SIZE="Push the byte-length of the top stack item as a VM Number.",e.OP_INVERT="Error, even when found in an unexecuted conditional branch. (Historically, this flipped all the bits in a stack item.)",e.OP_AND="Error, even when found in an unexecuted conditional branch. (Historically, this performed a boolean AND on each bit in two stack items.)",e.OP_OR="Error, even when found in an unexecuted conditional branch. (Historically, this performed a boolean OR on each bit in two stack items.)",e.OP_XOR="Error, even when found in an unexecuted conditional branch. (Historically, this performed a boolean XOR on each bit in two stack items.)",e.OP_EQUAL="Pop the top two items from the stack and compare them byte-by-byte. If they are the same, push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_EQUALVERIFY="Pop the top two items from the stack and compare them byte-by-byte. If the values are different, error. (This operation is a combination of OP_EQUAL followed by OP_VERIFY.)",e.OP_RESERVED1="Error unless found in an unexecuted conditional branch. Note: OP_RESERVED1 counts toward the opcode limit.",e.OP_RESERVED2="Error unless found in an unexecuted conditional branch. Note: OP_RESERVED2 counts toward the opcode limit.",e.OP_MUL="Error, even when found in an unexecuted conditional branch. (Historically, this multiplied two VM Numbers.)",e.OP_DIV="Error, even when found in an unexecuted conditional branch. (Historically, this divided a VM Number by another.)",e.OP_MOD="Error, even when found in an unexecuted conditional branch. (Historically, this returned the remainder after dividing one VM Number by another.)",e.OP_1ADD="Pop the top item from the stack as a VM Number, add 1, then push the result.",e.OP_1SUB="Pop the top item from the stack as a VM Number, subtract 1, then push the result.",e.OP_2MUL="Error, even when found in an unexecuted conditional branch. (Historically, this multiplied a VM Number by 2.)",e.OP_2DIV="Error, even when found in an unexecuted conditional branch. (Historically, this divided a VM Number by 2.)",e.OP_NEGATE="Pop the top item from the stack as a VM Number, negate it, then push the result.",e.OP_ABS="Pop the top item from the stack as a VM Number, take its absolute value, then push the result.",e.OP_NOT="Pop the top item from the stack as a VM Number. If its value is 0, push a 1 (VM Number), otherwise, push a 0 (VM Number).",e.OP_0NOTEQUAL="Pop the top item from the stack as a VM Number. If its value is not 0, push a 1 (VM Number), otherwise, push a 0 (VM Number).",e.OP_ADD="Pop the top two items from the stack as VM Numbers. Add them, then push the result.",e.OP_SUB="Pop the top two items from the stack as VM Numbers. Subtract the top item from the second item, then push the result.",e.OP_LSHIFT="Error, even when found in an unexecuted conditional branch. (Historically, this performed a sign-preserving, left bit shift.)",e.OP_RSHIFT="Error, even when found in an unexecuted conditional branch. (Historically, this performed a sign-preserving, right bit shift.)",e.OP_BOOLAND="Pop the top two items from the stack as VM Numbers. If neither value is a 0 (VM Number), push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_BOOLOR="Pop the top two items from the stack as VM Numbers. If either value is a 1 (VM Number), push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_NUMEQUAL="Pop the top two items from the stack as VM Numbers. If the values are equal, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_NUMEQUALVERIFY="Pop the top two items from the stack as VM Numbers. If the values are different, error. (This operation is a combination of OP_NUMEQUAL followed by OP_VERIFY.)",e.OP_NUMNOTEQUAL="Pop the top two items from the stack as VM Numbers. If the values are not equal, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_LESSTHAN="Pop the top two items from the stack as VM Numbers. If the second item is less than top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_GREATERTHAN="Pop the top two items from the stack as VM Numbers. If the second item is greater than top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_LESSTHANOREQUAL="Pop the top two items from the stack as VM Numbers. If the second item is less than or equal to the top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_GREATERTHANOREQUAL="Pop the top two items from the stack as VM Numbers. If the second item is greater than or equal to the top item, push a 1 (VM Number). Otherwise, push a 0 (VM Number).",e.OP_MIN="Pop the top two items from the stack as VM Numbers. Push the smaller of the two numbers.",e.OP_MAX="Pop the top two items from the stack as VM Numbers. Push the larger of the two numbers.",e.OP_WITHIN="Pop the top three items from the stack as VM Numbers. If the top number is within the range defined by the following two numbers (left-inclusive), push a 1 (VM Number). Otherwise, push a 0 (VM Number). (E.g. for [a, b, c]: if (b <= a), and (a < c), [1]. Else [0].)",e.OP_RIPEMD160="Pop the top item from the stack and pass it through ripemd160, pushing the result onto the stack.",e.OP_SHA1="Pop the top item from the stack and pass it through sha1, pushing the result onto the stack.",e.OP_SHA256="Pop the top item from the stack and pass it through sha256, pushing the result onto the stack.",e.OP_HASH160="Pop the top item from the stack and pass it through sha256, then ripemd160, pushing the result onto the stack.",e.OP_HASH256="Pop the top item from the stack and pass it through sha256 twice, pushing the result onto the stack.",e.OP_CODESEPARATOR="Update the value of lastCodeSeparator to the instruction pointer's current value. (This reduces the coverage of signing serializations used in signature verification operations.)",e.OP_CHECKSIG="Pop the top two items from the stack. Treat the top as a signature and the second as a public key. If the signature is valid, push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_CHECKSIGVERIFY="Pop the top two items from the stack. Treat the top as a signature and the second as a public key. If the signature is not valid, error. (This operation is a combination of OP_CHECKSIG followed by OP_VERIFY.)",e.OP_CHECKMULTISIG="Pop items from the stack: first pop the VM Number of public keys, then pop each of those public keys. Next, pop the VM Number of required signatures, then pop each of those signatures. Finally, pop a final VM Number that must be 0 due to a protocol bug. Checking each signature against each public key in order, if all signatures are valid \u2013 and the required number of signatures have been provided \u2013 push a 1 (VM Number), otherwise push a 0 (VM Number).",e.OP_CHECKMULTISIGVERIFY="Pop items from the stack: first pop the VM Number of public keys, then pop each of those public keys. Next, pop the VM Number of required signatures, then pop each of those signatures. Finally, (due to a protocol bug) pop an unused final VM Number that must be 0. Checking each signature against each public key in order, if any signatures are invalid \u2013 or the required number of signatures have not been provided \u2013 error. (This operation is a combination of OP_CHECKMULTISIG followed by OP_VERIFY.)",e.OP_NOP1="No operation (reserved for future expansion). Note: OP_NOP1 counts toward the opcode limit.",e.OP_CHECKLOCKTIMEVERIFY="Verify the transaction occurs after an absolute block time or height: read the top item on the stack as a VM Number (without removing it), and compare it to the transaction's locktime. If the required locktime has not passed, or if locktime has been disabled for this input by a maximized sequence number, error.",e.OP_CHECKSEQUENCEVERIFY=`Verify the transaction occurs after the output being spent has "aged" by a relative block time or block height since it was created: read the top item on the stack as a VM Number (without removing it), and compare it to the age encoded in the input's sequence number. If the required relative locktime has not passed, or if relative locktime has been disabled by the sequence number or the transaction version, error.`,e.OP_NOP4="No operation (reserved for future expansion). Note: OP_NOP4 counts toward the opcode limit.",e.OP_NOP6="No operation (reserved for future expansion). Note: OP_NOP6 counts toward the opcode limit.",e.OP_NOP5="No operation (reserved for future expansion). Note: OP_NOP5 counts toward the opcode limit.",e.OP_NOP7="No operation (reserved for future expansion). Note: OP_NOP7 counts toward the opcode limit.",e.OP_NOP8="No operation (reserved for future expansion). Note: OP_NOP8 counts toward the opcode limit.",e.OP_NOP9="No operation (reserved for future expansion). Note: OP_NOP9 counts toward the opcode limit.",e.OP_NOP10="No operation (reserved for future expansion). Note: OP_NOP10 counts toward the opcode limit."})(fg||(fg={}));var aa=e=>{if(e.length!==32||e.every(r=>r===0))return!1;let A=[255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,254,186,174,220,230,175,72,160,59,191,210,94,140,208,54,65,64],a=e.findIndex((r,n)=>r!==A[n]);return a===-1||e[a]<A[a]},uA;(function(e){e.childIndexExceedsMaximum="HD node derivation error: child index exceeds maximum (4294967295).",e.requiresZeroDepthNode="HD node derivation error: absolute derivation requires an HD node with a depth of 0.",e.hardenedDerivationRequiresPrivateNode="HD node derivation error: derivation for hardened child indexes (indexes greater than or equal to 2147483648) requires an HD private node.",e.invalidAbsoluteDerivationPath=`HD node derivation error: invalid absolute derivation path; path must begin with "m" or "M" and contain only positive child index numbers, separated by forward slashes ("/"), with zero or one apostrophe ("'") after each child index number.`,e.invalidRelativeDerivationPath=`HD node derivation error: invalid relative derivation path; path must contain only positive child index numbers, separated by forward slashes ("/"), with zero or one apostrophe ("'") after each child index number.`,e.invalidDerivedKey="HD node derivation error: an astronomically rare HMAC-SHA512 result produced an invalid Secp256k1 key.",e.invalidPrivateDerivationPrefix='HD node derivation error: private derivation paths must begin with "m".',e.invalidPublicDerivationPrefix='HD node derivation error: public derivation paths must begin with "M".'})(uA||(uA={}));var oA;(function(e){e.incorrectLength="HD key decoding error: length is incorrect (must encode 82 bytes).",e.invalidChecksum="HD key decoding error: checksum is invalid.",e.invalidPublicKey="HD key decoding error: the public key for this HD public node is not a valid Secp256k1 public key.",e.invalidPrivateKey="HD key decoding error: the key for this HD private node is not a valid Secp256k1 private key.",e.missingPrivateKeyPaddingByte="HD key decoding error: version indicates a private key, but the key data is missing a padding byte.",e.privateKeyExpected="HD key decoding error: expected an HD private key, but encountered an HD public key.",e.publicKeyExpected="HD key decoding error: expected an HD public key, but encountered an HD private key.",e.unknownCharacter="HD key decoding error: key includes a non-base58 character.",e.unknownVersion="HD key decoding error: key uses an unknown version.",e.zeroDepthWithNonZeroChildIndex="HD key decoding error: key encodes a depth of zero with a non-zero child index.",e.zeroDepthWithNonZeroParentFingerprint="HD key decoding error: key encodes a depth of zero with a non-zero parent fingerprint."})(oA||(oA={}));var pA;(function(e){e.invalidChainCodeLength="HD key encoding error: invalid chain code length. Chain code must be 32 bytes.",e.invalidChildDepth="HD key encoding error: invalid child depth. Child depth must be between 0 and 255 (inclusive).",e.invalidChildIndex="HD key encoding error: invalid child index. Child index must be between 0 and 4294967295 (inclusive).",e.invalidParentFingerprintLength="HD key encoding error: invalid parent fingerprint length. Parent fingerprint must be 4 bytes.",e.invalidPrivateKeyLength="HD key encoding error: invalid private key length. Secp256k1 private keys must be 32 bytes.",e.invalidPublicKeyLength="HD key encoding error: invalid public key length. Public key must be 33 bytes (compressed).",e.invalidPublicKey="HD key encoding error: the public key for this HD public node is not a valid Secp256k1 public key.",e.zeroDepthWithNonZeroChildIndex="HD key encoding error: attempted to encode a zero depth key with a non-zero child index.",e.zeroDepthWithNonZeroParentFingerprint="HD key encoding error: attempted to encode a zero depth key with a non-zero parent fingerprint."})(pA||(pA={}));var qn=Uint8Array.from([0,0,0,0]),dl=DA("Bitcoin seed"),ra=(e,{assumeValidity:A,crypto:a={sha512:je},hmacSha512Key:r=dl,throwErrors:n=!0}={})=>{let i=rt(r,e,a.sha512),t=i.slice(0,32),o=i.slice(32),s=0,g=0,l=qn.slice(),I=A??aa(t);if(n&&!I)throw new Error(uA.invalidDerivedKey);return I?{chainCode:o,childIndex:g,depth:s,parentFingerprint:l,privateKey:t}:{chainCode:o,childIndex:g,depth:s,invalidMaterial:t,parentFingerprint:l}},Cg=(e,{crypto:A={ripemd160:Ee,secp256k1:Ae,sha256:q}}={})=>{let a=A.secp256k1.derivePublicKeyCompressed(e.privateKey);return typeof a=="string"?a:A.ripemd160.hash(A.sha256.hash(a))},Pg=(e,{crypto:A={ripemd160:Ee,sha256:q}}={})=>A.ripemd160.hash(A.sha256.hash(e.publicKey)),hA;(function(e){e[e.mainnetPrivateKey=76066276]="mainnetPrivateKey",e[e.mainnetPublicKey=76067358]="mainnetPublicKey",e[e.testnetPrivateKey=70615956]="testnetPrivateKey",e[e.testnetPublicKey=70617039]="testnetPublicKey"})(hA||(hA={}));var Sg=e=>e===hA.mainnetPublicKey||e===hA.testnetPublicKey,El=e=>e===hA.mainnetPrivateKey||e===hA.testnetPrivateKey,Bl=(e,{crypto:A={secp256k1:Ae,sha256:q}}={})=>{let a=Ka(e);if(typeof a=="string")return R(oA.unknownCharacter,a);if(a.length!==82)return R(oA.incorrectLength,`Length: ${a.length}.`);let r=a.slice(0,78),n=a.slice(78),i=A.sha256.hash(A.sha256.hash(r));if(!n.every((h,y)=>h===i[y]))return R(oA.invalidChecksum,`Encoded: ${$(n)}; computed: ${$(i.slice(0,4))}.`);let t=4,o=5,s=9,g=13,l=45,I=new DataView(a.buffer,a.byteOffset,t).getUint32(0),E=a[t],u=a.slice(o,s),k=new DataView(a.buffer,a.byteOffset+s,a.byteOffset+g).getUint32(0),U=a.slice(g,l),N=a.slice(l,78),c=El(I);if(c&&N[0]!==0)return oA.missingPrivateKeyPaddingByte;if(c){let h=N.slice(1);return{node:aa(h)?{chainCode:U,childIndex:k,depth:E,parentFingerprint:u,privateKey:h}:{chainCode:U,childIndex:k,depth:E,invalidMaterial:h,parentFingerprint:u},version:I}}if(!Sg(I))return R(oA.unknownVersion,`Version: ${I}`);let S=N;return{node:A.secp256k1.validatePublicKey(S)?{chainCode:U,childIndex:k,depth:E,parentFingerprint:u,publicKey:S}:{chainCode:U,childIndex:k,depth:E,invalidMaterial:S,parentFingerprint:u},version:I}},bg=(e,{crypto:A={secp256k1:Ae,sha256:q}}={})=>{let a=Bl(e,{crypto:A});if(typeof a=="string")return a;let{node:r,version:n}=a;if(r.depth===0){if(r.childIndex!==0)return R(oA.zeroDepthWithNonZeroChildIndex,`Child index: ${r.childIndex}.`);if(!tt(r.parentFingerprint,qn))return R(oA.zeroDepthWithNonZeroParentFingerprint,`Parent fingerprint: ${r.parentFingerprint.join(",")}.`)}let i=Sg(n);return"invalidMaterial"in r?i?R(oA.invalidPublicKey,`Invalid public key: ${$(r.invalidMaterial)}.`):R(oA.invalidPrivateKey):{network:n===hA.mainnetPrivateKey||n===hA.mainnetPublicKey?"mainnet":"testnet",node:r}},na=(e,{crypto:A={secp256k1:Ae,sha256:q}}={})=>{let a=bg(e,{crypto:A});if(typeof a=="string")return a;let{network:r,node:n}=a;return"publicKey"in n?oA.privateKeyExpected:{network:r,node:n}},va=(e,{crypto:A={secp256k1:Ae,sha256:q}}={})=>{let a=bg(e,{crypto:A});if(typeof a=="string")return a;let{network:r,node:n}=a;return"privateKey"in n?oA.publicKeyExpected:{network:r,node:n}},af=(e,{crypto:A={secp256k1:Ae,sha256:q}}={})=>{let a=na(e,{crypto:A});return typeof a=="string"?a:Cg(a.node)},rf=(e,{crypto:A={secp256k1:Ae,sha256:q}}={})=>{let a=va(e,{crypto:A});return typeof a=="string"?a:Pg(a.node)},kg=({version:e,keyParameters:A,throwErrors:a=!0})=>{if(A.node.depth===0){if(A.node.childIndex!==0)return R(pA.zeroDepthWithNonZeroChildIndex,`Child index: ${A.node.childIndex}.`,a);if(!tt(A.node.parentFingerprint,qn))return R(pA.zeroDepthWithNonZeroParentFingerprint,`Parent fingerprint: ${A.node.parentFingerprint.join(",")}.`,a)}if(A.node.chainCode.length!==32)return R(pA.invalidChainCodeLength,`Chain code length: ${A.node.chainCode.length}.`,a);if(A.node.parentFingerprint.length!==4)return R(pA.invalidParentFingerprintLength,`Parent fingerprint length: ${A.node.parentFingerprint.length}.`,a);if(A.node.depth<0||A.node.depth>255)return R(pA.invalidChildDepth,`Depth: ${A.node.depth}.`,a);let r=Uint8Array.of(A.node.depth);if(A.node.childIndex<0||A.node.childIndex>4294967295)return R(pA.invalidChildIndex,`Child index: ${A.node.childIndex}.`,a);let n=vA(A.node.childIndex);return ee([e,r,A.node.parentFingerprint,n,A.node.chainCode])},pl=(e,{throwErrors:A=!0}={})=>{let a=vA(e.network==="mainnet"?hA.mainnetPrivateKey:hA.testnetPrivateKey);if(e.node.privateKey.length!==32)return R(pA.invalidPrivateKeyLength,`Private key length: ${e.node.privateKey.length}.`,A);let r=kg({keyParameters:e,throwErrors:A,version:a});if(typeof r=="string")return r;let n=Uint8Array.of(0);return ee([r,n,e.node.privateKey])},ml=(e,{throwErrors:A=!0}={})=>{let a=vA(e.network==="mainnet"?hA.mainnetPublicKey:hA.testnetPublicKey);if(e.node.publicKey.length!==33)return R(pA.invalidPublicKeyLength,`Public key length: ${e.node.publicKey.length}.`,A);let r=kg({keyParameters:e,throwErrors:A,version:a});return typeof r=="string"?r:ee([r,e.node.publicKey])},Ng=(e,{crypto:A={sha256:q}}={})=>{let r=A.sha256.hash(A.sha256.hash(e)).slice(0,4);return Ma(ee([e,r]))},Ug=(e,{crypto:A={sha256:q},throwErrors:a=!0}={})=>{let r=pl(e,{throwErrors:a});return typeof r=="string"?r:{hdPrivateKey:Ng(r,{crypto:A})}},Ql=(e,{crypto:A={secp256k1:Ae,sha256:q},throwErrors:a=!0}={})=>{if(!A.secp256k1.validatePublicKey(e.node.publicKey))return R(pA.invalidPublicKey,`Invalid public key: "${$(e.node.publicKey)}".`,a);let r=ml(e,{throwErrors:a});return typeof r=="string"?r:{hdPublicKey:Ng(r,{crypto:A})}},yl=(e,{crypto:A={secp256k1:Ae}}={})=>({chainCode:e.chainCode,childIndex:e.childIndex,depth:e.depth,parentFingerprint:e.parentFingerprint,...e.parentIdentifier===void 0?{}:{parentIdentifier:e.parentIdentifier},publicKey:A.secp256k1.derivePublicKeyCompressed(e.privateKey)}),nf=(e,{crypto:A={secp256k1:Ae,sha256:q},throwErrors:a=!0}={})=>{let r=na(e,{crypto:A});if(typeof r=="string")return R(r,void 0,a);let n=yl(r.node,{crypto:A});return Ql({network:r.network,node:n},{crypto:A,throwErrors:a})},fl=(e,A,{crypto:a={ripemd160:Ee,secp256k1:Ae,sha256:q,sha512:je},throwErrors:r=!0,returnInvalidNodes:n=!1}={})=>{if(A>4294967295)return R(uA.childIndexExceedsMaximum,`Child index: ${A}.`,r);let t=Cg(e,{crypto:a}),o=t.slice(0,4),s=e.depth+1,l=A>=2147483648,I=l?e.privateKey:a.secp256k1.derivePublicKeyCompressed(e.privateKey),E=Uint8Array.from([...l?[0]:[],...I,...vA(A)]),u=rt(e.chainCode,E,a.sha512),k=32,U=u.slice(0,k),N=u.slice(k),c=a.secp256k1.addTweakPrivateKey(e.privateKey,U);if(typeof c=="string"){let B=R(uA.invalidDerivedKey,`Invalid child index: ${A}.`,r);return n?{chainCode:N,childIndex:A,depth:s,invalidMaterial:U,parentFingerprint:o,parentIdentifier:t}:B}return{chainCode:N,childIndex:A,depth:s,parentFingerprint:o,parentIdentifier:t,privateKey:c}},Cl=(e,A,{crypto:a={ripemd160:Ee,secp256k1:Ae,sha256:q,sha512:je},returnInvalidNodes:r=!1,throwErrors:n=!0}={})=>{if(A>=2147483648)return R(uA.hardenedDerivationRequiresPrivateNode,`Requested index: ${A}.`,n);let t=Pg(e,{crypto:a}),o=t.slice(0,4),s=e.depth+1,g=Uint8Array.from([...e.publicKey,...vA(A)]),l=rt(e.chainCode,g,a.sha512),I=32,E=l.slice(0,I),u=l.slice(I),k=a.secp256k1.addTweakPublicKeyCompressed(e.publicKey,E);if(typeof k=="string"){let U=R(uA.invalidDerivedKey,`Invalid child index: ${A}.`,n);return r?{chainCode:u,childIndex:A,depth:s,invalidMaterial:E,parentFingerprint:o,parentIdentifier:t}:U}return{chainCode:u,childIndex:A,depth:s,parentFingerprint:o,parentIdentifier:t,publicKey:k}},Da=(e,A,{crypto:a={ripemd160:Ee,secp256k1:Ae,sha256:q,sha512:je},throwErrors:r=!0}={})=>{if(A==="")return e;if(!/^(?:[0-9]+'?)(?:\/[0-9]+'?)*$/u.test(A))return R(uA.invalidRelativeDerivationPath,`Invalid path: "${A}".`,r);let i=A.split("/"),t="privateKey"in e,o=10,s=2147483648,g=i.map(l=>l.endsWith("'")?parseInt(l.slice(0,-1),o)+s:parseInt(l,o));return t?g.reduce((l,I)=>typeof l=="string"?l:fl(l,I,{crypto:a,throwErrors:r}),e):g.reduce((l,I)=>typeof l=="string"?l:Cl(l,I,{crypto:a,throwErrors:r}),e)},_g=(e,A,{crypto:a={ripemd160:Ee,secp256k1:Ae,sha256:q,sha512:je},throwErrors:r=!0}={})=>{if(e.depth!==0)return R(uA.requiresZeroDepthNode,`Depth of provided HD node: ${e.depth}.`,r);if(!/^[mM](?:\/[0-9]+'?)*$/u.test(A))return R(uA.invalidAbsoluteDerivationPath,`Invalid path: "${A}".`,r);let i=A.split("/"),t="privateKey"in e;if(t&&i[0]!=="m")return R(uA.invalidPrivateDerivationPrefix,`Invalid path: "${A}".`,r);if(!t&&i[0]!=="M")return R(uA.invalidPublicDerivationPrefix,`Invalid path: "${A}".`,r);if(i.length===1)return e;let o=i.slice(1).join("/");return Da(e,o,{crypto:a,throwErrors:r})},Gn;(function(e){e.cannotCrackHardenedDerivation="HD node cracking error: cannot crack an HD parent node using hardened child node."})(Gn||(Gn={}));var of=(e,A,{crypto:a={sha512:je}}={})=>{if(A.childIndex>=2147483648)return Gn.cannotCrackHardenedDerivation;let n=Uint8Array.from([...e.publicKey,...vA(A.childIndex)]),i=rt(e.chainCode,n,a.sha512),o=zr(i.slice(0,32)),s=zr(A.privateKey),I=((u,k)=>(u%k+k)%k)(s-o,0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141n),E=Ja(I);return{chainCode:e.chainCode,childIndex:e.childIndex,depth:e.depth,parentFingerprint:e.parentFingerprint,...e.parentIdentifier===void 0?{}:{parentIdentifier:e.parentIdentifier},privateKey:E}};var br;(function(e){e.duplicateResults='Entropy generation error: the "getRandomValues" function provided by this JavaScript environment returned duplicate results across two evaluations; entropy generation was halted for safety.',e.insufficientEntropy="Entropy generation error: the provided list of events contains insufficient entropy."})(br||(br={}));var Pl=(e,A=crypto)=>A.getRandomValues(new Uint8Array(e)),Hn=(e,A=Pl)=>{let a=A(e),r=A(e);return a===r||tt(a,r)?R(br.duplicateResults,`First result: [${String(a)}]; second result: [${String(r)}].`,!0):a},vg=()=>Hn(32),lf=(e=vg)=>{let A;do A=e();while(!aa(A));return A},uf=(e=vg)=>{let A,a;do A=e(),a=ra(A);while("invalidMaterial"in a);return{hdPrivateNode:a,seed:A}},Sl=e=>Math.log2(e),bl=(e,A=128)=>Math.ceil(A/Sl(e)),hf=(e,A,{crypto:a={sha256:q},requiredEntropyBits:r=128}={})=>{let n=bl(e,r);if(e===0||A.length<n)return R(br.insufficientEntropy,`With ${e} possible results per event, a minimum of ${n} events are required to obtain sufficient entropy. Events provided: ${A.length}.`);let i=[...A.join("")].map(o=>Number(o)+48),t=Uint8Array.from(i);return a.sha256.hash(t)};var kl=`\u7684
\u4E00
\u662F
\u5728
\u4E0D
\u4E86
\u6709
\u548C
\u4EBA
\u8FD9
\u4E2D
\u5927
\u4E3A
\u4E0A
\u4E2A
\u56FD
\u6211
\u4EE5
\u8981
\u4ED6
\u65F6
\u6765
\u7528
\u4EEC
\u751F
\u5230
\u4F5C
\u5730
\u4E8E
\u51FA
\u5C31
\u5206
\u5BF9
\u6210
\u4F1A
\u53EF
\u4E3B
\u53D1
\u5E74
\u52A8
\u540C
\u5DE5
\u4E5F
\u80FD
\u4E0B
\u8FC7
\u5B50
\u8BF4
\u4EA7
\u79CD
\u9762
\u800C
\u65B9
\u540E
\u591A
\u5B9A
\u884C
\u5B66
\u6CD5
\u6240
\u6C11
\u5F97
\u7ECF
\u5341
\u4E09
\u4E4B
\u8FDB
\u7740
\u7B49
\u90E8
\u5EA6
\u5BB6
\u7535
\u529B
\u91CC
\u5982
\u6C34
\u5316
\u9AD8
\u81EA
\u4E8C
\u7406
\u8D77
\u5C0F
\u7269
\u73B0
\u5B9E
\u52A0
\u91CF
\u90FD
\u4E24
\u4F53
\u5236
\u673A
\u5F53
\u4F7F
\u70B9
\u4ECE
\u4E1A
\u672C
\u53BB
\u628A
\u6027
\u597D
\u5E94
\u5F00
\u5B83
\u5408
\u8FD8
\u56E0
\u7531
\u5176
\u4E9B
\u7136
\u524D
\u5916
\u5929
\u653F
\u56DB
\u65E5
\u90A3
\u793E
\u4E49
\u4E8B
\u5E73
\u5F62
\u76F8
\u5168
\u8868
\u95F4
\u6837
\u4E0E
\u5173
\u5404
\u91CD
\u65B0
\u7EBF
\u5185
\u6570
\u6B63
\u5FC3
\u53CD
\u4F60
\u660E
\u770B
\u539F
\u53C8
\u4E48
\u5229
\u6BD4
\u6216
\u4F46
\u8D28
\u6C14
\u7B2C
\u5411
\u9053
\u547D
\u6B64
\u53D8
\u6761
\u53EA
\u6CA1
\u7ED3
\u89E3
\u95EE
\u610F
\u5EFA
\u6708
\u516C
\u65E0
\u7CFB
\u519B
\u5F88
\u60C5
\u8005
\u6700
\u7ACB
\u4EE3
\u60F3
\u5DF2
\u901A
\u5E76
\u63D0
\u76F4
\u9898
\u515A
\u7A0B
\u5C55
\u4E94
\u679C
\u6599
\u8C61
\u5458
\u9769
\u4F4D
\u5165
\u5E38
\u6587
\u603B
\u6B21
\u54C1
\u5F0F
\u6D3B
\u8BBE
\u53CA
\u7BA1
\u7279
\u4EF6
\u957F
\u6C42
\u8001
\u5934
\u57FA
\u8D44
\u8FB9
\u6D41
\u8DEF
\u7EA7
\u5C11
\u56FE
\u5C71
\u7EDF
\u63A5
\u77E5
\u8F83
\u5C06
\u7EC4
\u89C1
\u8BA1
\u522B
\u5979
\u624B
\u89D2
\u671F
\u6839
\u8BBA
\u8FD0
\u519C
\u6307
\u51E0
\u4E5D
\u533A
\u5F3A
\u653E
\u51B3
\u897F
\u88AB
\u5E72
\u505A
\u5FC5
\u6218
\u5148
\u56DE
\u5219
\u4EFB
\u53D6
\u636E
\u5904
\u961F
\u5357
\u7ED9
\u8272
\u5149
\u95E8
\u5373
\u4FDD
\u6CBB
\u5317
\u9020
\u767E
\u89C4
\u70ED
\u9886
\u4E03
\u6D77
\u53E3
\u4E1C
\u5BFC
\u5668
\u538B
\u5FD7
\u4E16
\u91D1
\u589E
\u4E89
\u6D4E
\u9636
\u6CB9
\u601D
\u672F
\u6781
\u4EA4
\u53D7
\u8054
\u4EC0
\u8BA4
\u516D
\u5171
\u6743
\u6536
\u8BC1
\u6539
\u6E05
\u7F8E
\u518D
\u91C7
\u8F6C
\u66F4
\u5355
\u98CE
\u5207
\u6253
\u767D
\u6559
\u901F
\u82B1
\u5E26
\u5B89
\u573A
\u8EAB
\u8F66
\u4F8B
\u771F
\u52A1
\u5177
\u4E07
\u6BCF
\u76EE
\u81F3
\u8FBE
\u8D70
\u79EF
\u793A
\u8BAE
\u58F0
\u62A5
\u6597
\u5B8C
\u7C7B
\u516B
\u79BB
\u534E
\u540D
\u786E
\u624D
\u79D1
\u5F20
\u4FE1
\u9A6C
\u8282
\u8BDD
\u7C73
\u6574
\u7A7A
\u5143
\u51B5
\u4ECA
\u96C6
\u6E29
\u4F20
\u571F
\u8BB8
\u6B65
\u7FA4
\u5E7F
\u77F3
\u8BB0
\u9700
\u6BB5
\u7814
\u754C
\u62C9
\u6797
\u5F8B
\u53EB
\u4E14
\u7A76
\u89C2
\u8D8A
\u7EC7
\u88C5
\u5F71
\u7B97
\u4F4E
\u6301
\u97F3
\u4F17
\u4E66
\u5E03
\u590D
\u5BB9
\u513F
\u987B
\u9645
\u5546
\u975E
\u9A8C
\u8FDE
\u65AD
\u6DF1
\u96BE
\u8FD1
\u77FF
\u5343
\u5468
\u59D4
\u7D20
\u6280
\u5907
\u534A
\u529E
\u9752
\u7701
\u5217
\u4E60
\u54CD
\u7EA6
\u652F
\u822C
\u53F2
\u611F
\u52B3
\u4FBF
\u56E2
\u5F80
\u9178
\u5386
\u5E02
\u514B
\u4F55
\u9664
\u6D88
\u6784
\u5E9C
\u79F0
\u592A
\u51C6
\u7CBE
\u503C
\u53F7
\u7387
\u65CF
\u7EF4
\u5212
\u9009
\u6807
\u5199
\u5B58
\u5019
\u6BDB
\u4EB2
\u5FEB
\u6548
\u65AF
\u9662
\u67E5
\u6C5F
\u578B
\u773C
\u738B
\u6309
\u683C
\u517B
\u6613
\u7F6E
\u6D3E
\u5C42
\u7247
\u59CB
\u5374
\u4E13
\u72B6
\u80B2
\u5382
\u4EAC
\u8BC6
\u9002
\u5C5E
\u5706
\u5305
\u706B
\u4F4F
\u8C03
\u6EE1
\u53BF
\u5C40
\u7167
\u53C2
\u7EA2
\u7EC6
\u5F15
\u542C
\u8BE5
\u94C1
\u4EF7
\u4E25
\u9996
\u5E95
\u6DB2
\u5B98
\u5FB7
\u968F
\u75C5
\u82CF
\u5931
\u5C14
\u6B7B
\u8BB2
\u914D
\u5973
\u9EC4
\u63A8
\u663E
\u8C08
\u7F6A
\u795E
\u827A
\u5462
\u5E2D
\u542B
\u4F01
\u671B
\u5BC6
\u6279
\u8425
\u9879
\u9632
\u4E3E
\u7403
\u82F1
\u6C27
\u52BF
\u544A
\u674E
\u53F0
\u843D
\u6728
\u5E2E
\u8F6E
\u7834
\u4E9A
\u5E08
\u56F4
\u6CE8
\u8FDC
\u5B57
\u6750
\u6392
\u4F9B
\u6CB3
\u6001
\u5C01
\u53E6
\u65BD
\u51CF
\u6811
\u6EB6
\u600E
\u6B62
\u6848
\u8A00
\u58EB
\u5747
\u6B66
\u56FA
\u53F6
\u9C7C
\u6CE2
\u89C6
\u4EC5
\u8D39
\u7D27
\u7231
\u5DE6
\u7AE0
\u65E9
\u671D
\u5BB3
\u7EED
\u8F7B
\u670D
\u8BD5
\u98DF
\u5145
\u5175
\u6E90
\u5224
\u62A4
\u53F8
\u8DB3
\u67D0
\u7EC3
\u5DEE
\u81F4
\u677F
\u7530
\u964D
\u9ED1
\u72AF
\u8D1F
\u51FB
\u8303
\u7EE7
\u5174
\u4F3C
\u4F59
\u575A
\u66F2
\u8F93
\u4FEE
\u6545
\u57CE
\u592B
\u591F
\u9001
\u7B14
\u8239
\u5360
\u53F3
\u8D22
\u5403
\u5BCC
\u6625
\u804C
\u89C9
\u6C49
\u753B
\u529F
\u5DF4
\u8DDF
\u867D
\u6742
\u98DE
\u68C0
\u5438
\u52A9
\u5347
\u9633
\u4E92
\u521D
\u521B
\u6297
\u8003
\u6295
\u574F
\u7B56
\u53E4
\u5F84
\u6362
\u672A
\u8DD1
\u7559
\u94A2
\u66FE
\u7AEF
\u8D23
\u7AD9
\u7B80
\u8FF0
\u94B1
\u526F
\u5C3D
\u5E1D
\u5C04
\u8349
\u51B2
\u627F
\u72EC
\u4EE4
\u9650
\u963F
\u5BA3
\u73AF
\u53CC
\u8BF7
\u8D85
\u5FAE
\u8BA9
\u63A7
\u5DDE
\u826F
\u8F74
\u627E
\u5426
\u7EAA
\u76CA
\u4F9D
\u4F18
\u9876
\u7840
\u8F7D
\u5012
\u623F
\u7A81
\u5750
\u7C89
\u654C
\u7565
\u5BA2
\u8881
\u51B7
\u80DC
\u7EDD
\u6790
\u5757
\u5242
\u6D4B
\u4E1D
\u534F
\u8BC9
\u5FF5
\u9648
\u4ECD
\u7F57
\u76D0
\u53CB
\u6D0B
\u9519
\u82E6
\u591C
\u5211
\u79FB
\u9891
\u9010
\u9760
\u6DF7
\u6BCD
\u77ED
\u76AE
\u7EC8
\u805A
\u6C7D
\u6751
\u4E91
\u54EA
\u65E2
\u8DDD
\u536B
\u505C
\u70C8
\u592E
\u5BDF
\u70E7
\u8FC5
\u5883
\u82E5
\u5370
\u6D32
\u523B
\u62EC
\u6FC0
\u5B54
\u641E
\u751A
\u5BA4
\u5F85
\u6838
\u6821
\u6563
\u4FB5
\u5427
\u7532
\u6E38
\u4E45
\u83DC
\u5473
\u65E7
\u6A21
\u6E56
\u8D27
\u635F
\u9884
\u963B
\u6BEB
\u666E
\u7A33
\u4E59
\u5988
\u690D
\u606F
\u6269
\u94F6
\u8BED
\u6325
\u9152
\u5B88
\u62FF
\u5E8F
\u7EB8
\u533B
\u7F3A
\u96E8
\u5417
\u9488
\u5218
\u554A
\u6025
\u5531
\u8BEF
\u8BAD
\u613F
\u5BA1
\u9644
\u83B7
\u8336
\u9C9C
\u7CAE
\u65A4
\u5B69
\u8131
\u786B
\u80A5
\u5584
\u9F99
\u6F14
\u7236
\u6E10
\u8840
\u6B22
\u68B0
\u638C
\u6B4C
\u6C99
\u521A
\u653B
\u8C13
\u76FE
\u8BA8
\u665A
\u7C92
\u4E71
\u71C3
\u77DB
\u4E4E
\u6740
\u836F
\u5B81
\u9C81
\u8D35
\u949F
\u7164
\u8BFB
\u73ED
\u4F2F
\u9999
\u4ECB
\u8FEB
\u53E5
\u4E30
\u57F9
\u63E1
\u5170
\u62C5
\u5F26
\u86CB
\u6C89
\u5047
\u7A7F
\u6267
\u7B54
\u4E50
\u8C01
\u987A
\u70DF
\u7F29
\u5F81
\u8138
\u559C
\u677E
\u811A
\u56F0
\u5F02
\u514D
\u80CC
\u661F
\u798F
\u4E70
\u67D3
\u4E95
\u6982
\u6162
\u6015
\u78C1
\u500D
\u7956
\u7687
\u4FC3
\u9759
\u8865
\u8BC4
\u7FFB
\u8089
\u8DF5
\u5C3C
\u8863
\u5BBD
\u626C
\u68C9
\u5E0C
\u4F24
\u64CD
\u5782
\u79CB
\u5B9C
\u6C22
\u5957
\u7763
\u632F
\u67B6
\u4EAE
\u672B
\u5BAA
\u5E86
\u7F16
\u725B
\u89E6
\u6620
\u96F7
\u9500
\u8BD7
\u5EA7
\u5C45
\u6293
\u88C2
\u80DE
\u547C
\u5A18
\u666F
\u5A01
\u7EFF
\u6676
\u539A
\u76DF
\u8861
\u9E21
\u5B59
\u5EF6
\u5371
\u80F6
\u5C4B
\u4E61
\u4E34
\u9646
\u987E
\u6389
\u5440
\u706F
\u5C81
\u63AA
\u675F
\u8010
\u5267
\u7389
\u8D75
\u8DF3
\u54E5
\u5B63
\u8BFE
\u51EF
\u80E1
\u989D
\u6B3E
\u7ECD
\u5377
\u9F50
\u4F1F
\u84B8
\u6B96
\u6C38
\u5B97
\u82D7
\u5DDD
\u7089
\u5CA9
\u5F31
\u96F6
\u6768
\u594F
\u6CBF
\u9732
\u6746
\u63A2
\u6ED1
\u9547
\u996D
\u6D53
\u822A
\u6000
\u8D76
\u5E93
\u593A
\u4F0A
\u7075
\u7A0E
\u9014
\u706D
\u8D5B
\u5F52
\u53EC
\u9F13
\u64AD
\u76D8
\u88C1
\u9669
\u5EB7
\u552F
\u5F55
\u83CC
\u7EAF
\u501F
\u7CD6
\u76D6
\u6A2A
\u7B26
\u79C1
\u52AA
\u5802
\u57DF
\u67AA
\u6DA6
\u5E45
\u54C8
\u7ADF
\u719F
\u866B
\u6CFD
\u8111
\u58E4
\u78B3
\u6B27
\u904D
\u4FA7
\u5BE8
\u6562
\u5F7B
\u8651
\u659C
\u8584
\u5EAD
\u7EB3
\u5F39
\u9972
\u4F38
\u6298
\u9EA6
\u6E7F
\u6697
\u8377
\u74E6
\u585E
\u5E8A
\u7B51
\u6076
\u6237
\u8BBF
\u5854
\u5947
\u900F
\u6881
\u5200
\u65CB
\u8FF9
\u5361
\u6C2F
\u9047
\u4EFD
\u6BD2
\u6CE5
\u9000
\u6D17
\u6446
\u7070
\u5F69
\u5356
\u8017
\u590F
\u62E9
\u5FD9
\u94DC
\u732E
\u786C
\u4E88
\u7E41
\u5708
\u96EA
\u51FD
\u4EA6
\u62BD
\u7BC7
\u9635
\u9634
\u4E01
\u5C3A
\u8FFD
\u5806
\u96C4
\u8FCE
\u6CDB
\u7238
\u697C
\u907F
\u8C0B
\u5428
\u91CE
\u732A
\u65D7
\u7D2F
\u504F
\u5178
\u9986
\u7D22
\u79E6
\u8102
\u6F6E
\u7237
\u8C46
\u5FFD
\u6258
\u60CA
\u5851
\u9057
\u6108
\u6731
\u66FF
\u7EA4
\u7C97
\u503E
\u5C1A
\u75DB
\u695A
\u8C22
\u594B
\u8D2D
\u78E8
\u541B
\u6C60
\u65C1
\u788E
\u9AA8
\u76D1
\u6355
\u5F1F
\u66B4
\u5272
\u8D2F
\u6B8A
\u91CA
\u8BCD
\u4EA1
\u58C1
\u987F
\u5B9D
\u5348
\u5C18
\u95FB
\u63ED
\u70AE
\u6B8B
\u51AC
\u6865
\u5987
\u8B66
\u7EFC
\u62DB
\u5434
\u4ED8
\u6D6E
\u906D
\u5F90
\u60A8
\u6447
\u8C37
\u8D5E
\u7BB1
\u9694
\u8BA2
\u7537
\u5439
\u56ED
\u7EB7
\u5510
\u8D25
\u5B8B
\u73BB
\u5DE8
\u8015
\u5766
\u8363
\u95ED
\u6E7E
\u952E
\u51E1
\u9A7B
\u9505
\u6551
\u6069
\u5265
\u51DD
\u78B1
\u9F7F
\u622A
\u70BC
\u9EBB
\u7EBA
\u7981
\u5E9F
\u76DB
\u7248
\u7F13
\u51C0
\u775B
\u660C
\u5A5A
\u6D89
\u7B52
\u5634
\u63D2
\u5CB8
\u6717
\u5E84
\u8857
\u85CF
\u59D1
\u8D38
\u8150
\u5974
\u5566
\u60EF
\u4E58
\u4F19
\u6062
\u5300
\u7EB1
\u624E
\u8FA9
\u8033
\u5F6A
\u81E3
\u4EBF
\u7483
\u62B5
\u8109
\u79C0
\u8428
\u4FC4
\u7F51
\u821E
\u5E97
\u55B7
\u7EB5
\u5BF8
\u6C57
\u6302
\u6D2A
\u8D3A
\u95EA
\u67EC
\u7206
\u70EF
\u6D25
\u7A3B
\u5899
\u8F6F
\u52C7
\u50CF
\u6EDA
\u5398
\u8499
\u82B3
\u80AF
\u5761
\u67F1
\u8361
\u817F
\u4EEA
\u65C5
\u5C3E
\u8F67
\u51B0
\u8D21
\u767B
\u9ECE
\u524A
\u94BB
\u52D2
\u9003
\u969C
\u6C28
\u90ED
\u5CF0
\u5E01
\u6E2F
\u4F0F
\u8F68
\u4EA9
\u6BD5
\u64E6
\u83AB
\u523A
\u6D6A
\u79D8
\u63F4
\u682A
\u5065
\u552E
\u80A1
\u5C9B
\u7518
\u6CE1
\u7761
\u7AE5
\u94F8
\u6C64
\u9600
\u4F11
\u6C47
\u820D
\u7267
\u7ED5
\u70B8
\u54F2
\u78F7
\u7EE9
\u670B
\u6DE1
\u5C16
\u542F
\u9677
\u67F4
\u5448
\u5F92
\u989C
\u6CEA
\u7A0D
\u5FD8
\u6CF5
\u84DD
\u62D6
\u6D1E
\u6388
\u955C
\u8F9B
\u58EE
\u950B
\u8D2B
\u865A
\u5F2F
\u6469
\u6CF0
\u5E7C
\u5EF7
\u5C0A
\u7A97
\u7EB2
\u5F04
\u96B6
\u7591
\u6C0F
\u5BAB
\u59D0
\u9707
\u745E
\u602A
\u5C24
\u7434
\u5FAA
\u63CF
\u819C
\u8FDD
\u5939
\u8170
\u7F18
\u73E0
\u7A77
\u68EE
\u679D
\u7AF9
\u6C9F
\u50AC
\u7EF3
\u5FC6
\u90A6
\u5269
\u5E78
\u6D46
\u680F
\u62E5
\u7259
\u8D2E
\u793C
\u6EE4
\u94A0
\u7EB9
\u7F62
\u62CD
\u54B1
\u558A
\u8896
\u57C3
\u52E4
\u7F5A
\u7126
\u6F5C
\u4F0D
\u58A8
\u6B32
\u7F1D
\u59D3
\u520A
\u9971
\u4EFF
\u5956
\u94DD
\u9B3C
\u4E3D
\u8DE8
\u9ED8
\u6316
\u94FE
\u626B
\u559D
\u888B
\u70AD
\u6C61
\u5E55
\u8BF8
\u5F27
\u52B1
\u6885
\u5976
\u6D01
\u707E
\u821F
\u9274
\u82EF
\u8BBC
\u62B1
\u6BC1
\u61C2
\u5BD2
\u667A
\u57D4
\u5BC4
\u5C4A
\u8DC3
\u6E21
\u6311
\u4E39
\u8270
\u8D1D
\u78B0
\u62D4
\u7239
\u6234
\u7801
\u68A6
\u82BD
\u7194
\u8D64
\u6E14
\u54ED
\u656C
\u9897
\u5954
\u94C5
\u4EF2
\u864E
\u7A00
\u59B9
\u4E4F
\u73CD
\u7533
\u684C
\u9075
\u5141
\u9686
\u87BA
\u4ED3
\u9B4F
\u9510
\u6653
\u6C2E
\u517C
\u9690
\u788D
\u8D6B
\u62E8
\u5FE0
\u8083
\u7F38
\u7275
\u62A2
\u535A
\u5DE7
\u58F3
\u5144
\u675C
\u8BAF
\u8BDA
\u78A7
\u7965
\u67EF
\u9875
\u5DE1
\u77E9
\u60B2
\u704C
\u9F84
\u4F26
\u7968
\u5BFB
\u6842
\u94FA
\u5723
\u6050
\u6070
\u90D1
\u8DA3
\u62AC
\u8352
\u817E
\u8D34
\u67D4
\u6EF4
\u731B
\u9614
\u8F86
\u59BB
\u586B
\u64A4
\u50A8
\u7B7E
\u95F9
\u6270
\u7D2B
\u7802
\u9012
\u620F
\u540A
\u9676
\u4F10
\u5582
\u7597
\u74F6
\u5A46
\u629A
\u81C2
\u6478
\u5FCD
\u867E
\u8721
\u90BB
\u80F8
\u5DE9
\u6324
\u5076
\u5F03
\u69FD
\u52B2
\u4E73
\u9093
\u5409
\u4EC1
\u70C2
\u7816
\u79DF
\u4E4C
\u8230
\u4F34
\u74DC
\u6D45
\u4E19
\u6682
\u71E5
\u6A61
\u67F3
\u8FF7
\u6696
\u724C
\u79E7
\u80C6
\u8BE6
\u7C27
\u8E0F
\u74F7
\u8C31
\u5446
\u5BBE
\u7CCA
\u6D1B
\u8F89
\u6124
\u7ADE
\u9699
\u6012
\u7C98
\u4E43
\u7EEA
\u80A9
\u7C4D
\u654F
\u6D82
\u7199
\u7686
\u4FA6
\u60AC
\u6398
\u4EAB
\u7EA0
\u9192
\u72C2
\u9501
\u6DC0
\u6068
\u7272
\u9738
\u722C
\u8D4F
\u9006
\u73A9
\u9675
\u795D
\u79D2
\u6D59
\u8C8C
\u5F79
\u5F7C
\u6089
\u9E2D
\u8D8B
\u51E4
\u6668
\u755C
\u8F88
\u79E9
\u5375
\u7F72
\u68AF
\u708E
\u6EE9
\u68CB
\u9A71
\u7B5B
\u5CE1
\u5192
\u5565
\u5BFF
\u8BD1
\u6D78
\u6CC9
\u5E3D
\u8FDF
\u7845
\u7586
\u8D37
\u6F0F
\u7A3F
\u51A0
\u5AE9
\u80C1
\u82AF
\u7262
\u53DB
\u8680
\u5965
\u9E23
\u5CAD
\u7F8A
\u51ED
\u4E32
\u5858
\u7ED8
\u9175
\u878D
\u76C6
\u9521
\u5E99
\u7B79
\u51BB
\u8F85
\u6444
\u88AD
\u7B4B
\u62D2
\u50DA
\u65F1
\u94BE
\u9E1F
\u6F06
\u6C88
\u7709
\u758F
\u6DFB
\u68D2
\u7A57
\u785D
\u97E9
\u903C
\u626D
\u4FA8
\u51C9
\u633A
\u7897
\u683D
\u7092
\u676F
\u60A3
\u998F
\u529D
\u8C6A
\u8FBD
\u52C3
\u9E3F
\u65E6
\u540F
\u62DC
\u72D7
\u57CB
\u8F8A
\u63A9
\u996E
\u642C
\u9A82
\u8F9E
\u52FE
\u6263
\u4F30
\u848B
\u7ED2
\u96FE
\u4E08
\u6735
\u59C6
\u62DF
\u5B87
\u8F91
\u9655
\u96D5
\u507F
\u84C4
\u5D07
\u526A
\u5021
\u5385
\u54AC
\u9A76
\u85AF
\u5237
\u65A5
\u756A
\u8D4B
\u5949
\u4F5B
\u6D47
\u6F2B
\u66FC
\u6247
\u9499
\u6843
\u6276
\u4ED4
\u8FD4
\u4FD7
\u4E8F
\u8154
\u978B
\u68F1
\u8986
\u6846
\u6084
\u53D4
\u649E
\u9A97
\u52D8
\u65FA
\u6CB8
\u5B64
\u5410
\u5B5F
\u6E20
\u5C48
\u75BE
\u5999
\u60DC
\u4EF0
\u72E0
\u80C0
\u8C10
\u629B
\u9709
\u6851
\u5C97
\u561B
\u8870
\u76D7
\u6E17
\u810F
\u8D56
\u6D8C
\u751C
\u66F9
\u9605
\u808C
\u54E9
\u5389
\u70C3
\u7EAC
\u6BC5
\u6628
\u4F2A
\u75C7
\u716E
\u53F9
\u9489
\u642D
\u830E
\u7B3C
\u9177
\u5077
\u5F13
\u9525
\u6052
\u6770
\u5751
\u9F3B
\u7FFC
\u7EB6
\u53D9
\u72F1
\u902E
\u7F50
\u7EDC
\u68DA
\u6291
\u81A8
\u852C
\u5BFA
\u9AA4
\u7A46
\u51B6
\u67AF
\u518C
\u5C38
\u51F8
\u7EC5
\u576F
\u727A
\u7130
\u8F70
\u6B23
\u664B
\u7626
\u5FA1
\u952D
\u9526
\u4E27
\u65EC
\u953B
\u5784
\u641C
\u6251
\u9080
\u4EAD
\u916F
\u8FC8
\u8212
\u8106
\u9176
\u95F2
\u5FE7
\u915A
\u987D
\u7FBD
\u6DA8
\u5378
\u4ED7
\u966A
\u8F9F
\u60E9
\u676D
\u59DA
\u809A
\u6349
\u98D8
\u6F02
\u6606
\u6B3A
\u543E
\u90CE
\u70F7
\u6C41
\u5475
\u9970
\u8427
\u96C5
\u90AE
\u8FC1
\u71D5
\u6492
\u59FB
\u8D74
\u5BB4
\u70E6
\u503A
\u5E10
\u6591
\u94C3
\u65E8
\u9187
\u8463
\u997C
\u96CF
\u59FF
\u62CC
\u5085
\u8179
\u59A5
\u63C9
\u8D24
\u62C6
\u6B6A
\u8461
\u80FA
\u4E22
\u6D69
\u5FBD
\u6602
\u57AB
\u6321
\u89C8
\u8D2A
\u6170
\u7F34
\u6C6A
\u614C
\u51AF
\u8BFA
\u59DC
\u8C0A
\u51F6
\u52A3
\u8BEC
\u8000
\u660F
\u8EBA
\u76C8
\u9A91
\u4E54
\u6EAA
\u4E1B
\u5362
\u62B9
\u95F7
\u54A8
\u522E
\u9A7E
\u7F06
\u609F
\u6458
\u94D2
\u63B7
\u9887
\u5E7B
\u67C4
\u60E0
\u60E8
\u4F73
\u4EC7
\u814A
\u7A9D
\u6DA4
\u5251
\u77A7
\u5821
\u6CFC
\u8471
\u7F69
\u970D
\u635E
\u80CE
\u82CD
\u6EE8
\u4FE9
\u6345
\u6E58
\u780D
\u971E
\u90B5
\u8404
\u75AF
\u6DEE
\u9042
\u718A
\u7CAA
\u70D8
\u5BBF
\u6863
\u6208
\u9A73
\u5AC2
\u88D5
\u5F99
\u7BAD
\u6350
\u80A0
\u6491
\u6652
\u8FA8
\u6BBF
\u83B2
\u644A
\u6405
\u9171
\u5C4F
\u75AB
\u54C0
\u8521
\u5835
\u6CAB
\u76B1
\u7545
\u53E0
\u9601
\u83B1
\u6572
\u8F96
\u94A9
\u75D5
\u575D
\u5DF7
\u997F
\u7978
\u4E18
\u7384
\u6E9C
\u66F0
\u903B
\u5F6D
\u5C1D
\u537F
\u59A8
\u8247
\u541E
\u97E6
\u6028
\u77EE
\u6B47`,Nl=kl.split(`
`);var Ul=`\u7684
\u4E00
\u662F
\u5728
\u4E0D
\u4E86
\u6709
\u548C
\u4EBA
\u9019
\u4E2D
\u5927
\u70BA
\u4E0A
\u500B
\u570B
\u6211
\u4EE5
\u8981
\u4ED6
\u6642
\u4F86
\u7528
\u5011
\u751F
\u5230
\u4F5C
\u5730
\u65BC
\u51FA
\u5C31
\u5206
\u5C0D
\u6210
\u6703
\u53EF
\u4E3B
\u767C
\u5E74
\u52D5
\u540C
\u5DE5
\u4E5F
\u80FD
\u4E0B
\u904E
\u5B50
\u8AAA
\u7522
\u7A2E
\u9762
\u800C
\u65B9
\u5F8C
\u591A
\u5B9A
\u884C
\u5B78
\u6CD5
\u6240
\u6C11
\u5F97
\u7D93
\u5341
\u4E09
\u4E4B
\u9032
\u8457
\u7B49
\u90E8
\u5EA6
\u5BB6
\u96FB
\u529B
\u88E1
\u5982
\u6C34
\u5316
\u9AD8
\u81EA
\u4E8C
\u7406
\u8D77
\u5C0F
\u7269
\u73FE
\u5BE6
\u52A0
\u91CF
\u90FD
\u5169
\u9AD4
\u5236
\u6A5F
\u7576
\u4F7F
\u9EDE
\u5F9E
\u696D
\u672C
\u53BB
\u628A
\u6027
\u597D
\u61C9
\u958B
\u5B83
\u5408
\u9084
\u56E0
\u7531
\u5176
\u4E9B
\u7136
\u524D
\u5916
\u5929
\u653F
\u56DB
\u65E5
\u90A3
\u793E
\u7FA9
\u4E8B
\u5E73
\u5F62
\u76F8
\u5168
\u8868
\u9593
\u6A23
\u8207
\u95DC
\u5404
\u91CD
\u65B0
\u7DDA
\u5167
\u6578
\u6B63
\u5FC3
\u53CD
\u4F60
\u660E
\u770B
\u539F
\u53C8
\u9EBC
\u5229
\u6BD4
\u6216
\u4F46
\u8CEA
\u6C23
\u7B2C
\u5411
\u9053
\u547D
\u6B64
\u8B8A
\u689D
\u53EA
\u6C92
\u7D50
\u89E3
\u554F
\u610F
\u5EFA
\u6708
\u516C
\u7121
\u7CFB
\u8ECD
\u5F88
\u60C5
\u8005
\u6700
\u7ACB
\u4EE3
\u60F3
\u5DF2
\u901A
\u4E26
\u63D0
\u76F4
\u984C
\u9EE8
\u7A0B
\u5C55
\u4E94
\u679C
\u6599
\u8C61
\u54E1
\u9769
\u4F4D
\u5165
\u5E38
\u6587
\u7E3D
\u6B21
\u54C1
\u5F0F
\u6D3B
\u8A2D
\u53CA
\u7BA1
\u7279
\u4EF6
\u9577
\u6C42
\u8001
\u982D
\u57FA
\u8CC7
\u908A
\u6D41
\u8DEF
\u7D1A
\u5C11
\u5716
\u5C71
\u7D71
\u63A5
\u77E5
\u8F03
\u5C07
\u7D44
\u898B
\u8A08
\u5225
\u5979
\u624B
\u89D2
\u671F
\u6839
\u8AD6
\u904B
\u8FB2
\u6307
\u5E7E
\u4E5D
\u5340
\u5F37
\u653E
\u6C7A
\u897F
\u88AB
\u5E79
\u505A
\u5FC5
\u6230
\u5148
\u56DE
\u5247
\u4EFB
\u53D6
\u64DA
\u8655
\u968A
\u5357
\u7D66
\u8272
\u5149
\u9580
\u5373
\u4FDD
\u6CBB
\u5317
\u9020
\u767E
\u898F
\u71B1
\u9818
\u4E03
\u6D77
\u53E3
\u6771
\u5C0E
\u5668
\u58D3
\u5FD7
\u4E16
\u91D1
\u589E
\u722D
\u6FDF
\u968E
\u6CB9
\u601D
\u8853
\u6975
\u4EA4
\u53D7
\u806F
\u4EC0
\u8A8D
\u516D
\u5171
\u6B0A
\u6536
\u8B49
\u6539
\u6E05
\u7F8E
\u518D
\u63A1
\u8F49
\u66F4
\u55AE
\u98A8
\u5207
\u6253
\u767D
\u6559
\u901F
\u82B1
\u5E36
\u5B89
\u5834
\u8EAB
\u8ECA
\u4F8B
\u771F
\u52D9
\u5177
\u842C
\u6BCF
\u76EE
\u81F3
\u9054
\u8D70
\u7A4D
\u793A
\u8B70
\u8072
\u5831
\u9B25
\u5B8C
\u985E
\u516B
\u96E2
\u83EF
\u540D
\u78BA
\u624D
\u79D1
\u5F35
\u4FE1
\u99AC
\u7BC0
\u8A71
\u7C73
\u6574
\u7A7A
\u5143
\u6CC1
\u4ECA
\u96C6
\u6EAB
\u50B3
\u571F
\u8A31
\u6B65
\u7FA4
\u5EE3
\u77F3
\u8A18
\u9700
\u6BB5
\u7814
\u754C
\u62C9
\u6797
\u5F8B
\u53EB
\u4E14
\u7A76
\u89C0
\u8D8A
\u7E54
\u88DD
\u5F71
\u7B97
\u4F4E
\u6301
\u97F3
\u773E
\u66F8
\u5E03
\u590D
\u5BB9
\u5152
\u9808
\u969B
\u5546
\u975E
\u9A57
\u9023
\u65B7
\u6DF1
\u96E3
\u8FD1
\u7926
\u5343
\u9031
\u59D4
\u7D20
\u6280
\u5099
\u534A
\u8FA6
\u9752
\u7701
\u5217
\u7FD2
\u97FF
\u7D04
\u652F
\u822C
\u53F2
\u611F
\u52DE
\u4FBF
\u5718
\u5F80
\u9178
\u6B77
\u5E02
\u514B
\u4F55
\u9664
\u6D88
\u69CB
\u5E9C
\u7A31
\u592A
\u6E96
\u7CBE
\u503C
\u865F
\u7387
\u65CF
\u7DAD
\u5283
\u9078
\u6A19
\u5BEB
\u5B58
\u5019
\u6BDB
\u89AA
\u5FEB
\u6548
\u65AF
\u9662
\u67E5
\u6C5F
\u578B
\u773C
\u738B
\u6309
\u683C
\u990A
\u6613
\u7F6E
\u6D3E
\u5C64
\u7247
\u59CB
\u537B
\u5C08
\u72C0
\u80B2
\u5EE0
\u4EAC
\u8B58
\u9069
\u5C6C
\u5713
\u5305
\u706B
\u4F4F
\u8ABF
\u6EFF
\u7E23
\u5C40
\u7167
\u53C3
\u7D05
\u7D30
\u5F15
\u807D
\u8A72
\u9435
\u50F9
\u56B4
\u9996
\u5E95
\u6DB2
\u5B98
\u5FB7
\u96A8
\u75C5
\u8607
\u5931
\u723E
\u6B7B
\u8B1B
\u914D
\u5973
\u9EC3
\u63A8
\u986F
\u8AC7
\u7F6A
\u795E
\u85DD
\u5462
\u5E2D
\u542B
\u4F01
\u671B
\u5BC6
\u6279
\u71DF
\u9805
\u9632
\u8209
\u7403
\u82F1
\u6C27
\u52E2
\u544A
\u674E
\u53F0
\u843D
\u6728
\u5E6B
\u8F2A
\u7834
\u4E9E
\u5E2B
\u570D
\u6CE8
\u9060
\u5B57
\u6750
\u6392
\u4F9B
\u6CB3
\u614B
\u5C01
\u53E6
\u65BD
\u6E1B
\u6A39
\u6EB6
\u600E
\u6B62
\u6848
\u8A00
\u58EB
\u5747
\u6B66
\u56FA
\u8449
\u9B5A
\u6CE2
\u8996
\u50C5
\u8CBB
\u7DCA
\u611B
\u5DE6
\u7AE0
\u65E9
\u671D
\u5BB3
\u7E8C
\u8F15
\u670D
\u8A66
\u98DF
\u5145
\u5175
\u6E90
\u5224
\u8B77
\u53F8
\u8DB3
\u67D0
\u7DF4
\u5DEE
\u81F4
\u677F
\u7530
\u964D
\u9ED1
\u72AF
\u8CA0
\u64CA
\u8303
\u7E7C
\u8208
\u4F3C
\u9918
\u5805
\u66F2
\u8F38
\u4FEE
\u6545
\u57CE
\u592B
\u5920
\u9001
\u7B46
\u8239
\u4F54
\u53F3
\u8CA1
\u5403
\u5BCC
\u6625
\u8077
\u89BA
\u6F22
\u756B
\u529F
\u5DF4
\u8DDF
\u96D6
\u96DC
\u98DB
\u6AA2
\u5438
\u52A9
\u6607
\u967D
\u4E92
\u521D
\u5275
\u6297
\u8003
\u6295
\u58DE
\u7B56
\u53E4
\u5F91
\u63DB
\u672A
\u8DD1
\u7559
\u92FC
\u66FE
\u7AEF
\u8CAC
\u7AD9
\u7C21
\u8FF0
\u9322
\u526F
\u76E1
\u5E1D
\u5C04
\u8349
\u885D
\u627F
\u7368
\u4EE4
\u9650
\u963F
\u5BA3
\u74B0
\u96D9
\u8ACB
\u8D85
\u5FAE
\u8B93
\u63A7
\u5DDE
\u826F
\u8EF8
\u627E
\u5426
\u7D00
\u76CA
\u4F9D
\u512A
\u9802
\u790E
\u8F09
\u5012
\u623F
\u7A81
\u5750
\u7C89
\u6575
\u7565
\u5BA2
\u8881
\u51B7
\u52DD
\u7D55
\u6790
\u584A
\u5291
\u6E2C
\u7D72
\u5354
\u8A34
\u5FF5
\u9673
\u4ECD
\u7F85
\u9E7D
\u53CB
\u6D0B
\u932F
\u82E6
\u591C
\u5211
\u79FB
\u983B
\u9010
\u9760
\u6DF7
\u6BCD
\u77ED
\u76AE
\u7D42
\u805A
\u6C7D
\u6751
\u96F2
\u54EA
\u65E2
\u8DDD
\u885B
\u505C
\u70C8
\u592E
\u5BDF
\u71D2
\u8FC5
\u5883
\u82E5
\u5370
\u6D32
\u523B
\u62EC
\u6FC0
\u5B54
\u641E
\u751A
\u5BA4
\u5F85
\u6838
\u6821
\u6563
\u4FB5
\u5427
\u7532
\u904A
\u4E45
\u83DC
\u5473
\u820A
\u6A21
\u6E56
\u8CA8
\u640D
\u9810
\u963B
\u6BEB
\u666E
\u7A69
\u4E59
\u5ABD
\u690D
\u606F
\u64F4
\u9280
\u8A9E
\u63EE
\u9152
\u5B88
\u62FF
\u5E8F
\u7D19
\u91AB
\u7F3A
\u96E8
\u55CE
\u91DD
\u5289
\u554A
\u6025
\u5531
\u8AA4
\u8A13
\u9858
\u5BE9
\u9644
\u7372
\u8336
\u9BAE
\u7CE7
\u65A4
\u5B69
\u812B
\u786B
\u80A5
\u5584
\u9F8D
\u6F14
\u7236
\u6F38
\u8840
\u6B61
\u68B0
\u638C
\u6B4C
\u6C99
\u525B
\u653B
\u8B02
\u76FE
\u8A0E
\u665A
\u7C92
\u4E82
\u71C3
\u77DB
\u4E4E
\u6BBA
\u85E5
\u5BE7
\u9B6F
\u8CB4
\u9418
\u7164
\u8B80
\u73ED
\u4F2F
\u9999
\u4ECB
\u8FEB
\u53E5
\u8C50
\u57F9
\u63E1
\u862D
\u64D4
\u5F26
\u86CB
\u6C89
\u5047
\u7A7F
\u57F7
\u7B54
\u6A02
\u8AB0
\u9806
\u7159
\u7E2E
\u5FB5
\u81C9
\u559C
\u677E
\u8173
\u56F0
\u7570
\u514D
\u80CC
\u661F
\u798F
\u8CB7
\u67D3
\u4E95
\u6982
\u6162
\u6015
\u78C1
\u500D
\u7956
\u7687
\u4FC3
\u975C
\u88DC
\u8A55
\u7FFB
\u8089
\u8E10
\u5C3C
\u8863
\u5BEC
\u63DA
\u68C9
\u5E0C
\u50B7
\u64CD
\u5782
\u79CB
\u5B9C
\u6C2B
\u5957
\u7763
\u632F
\u67B6
\u4EAE
\u672B
\u61B2
\u6176
\u7DE8
\u725B
\u89F8
\u6620
\u96F7
\u92B7
\u8A69
\u5EA7
\u5C45
\u6293
\u88C2
\u80DE
\u547C
\u5A18
\u666F
\u5A01
\u7DA0
\u6676
\u539A
\u76DF
\u8861
\u96DE
\u5B6B
\u5EF6
\u5371
\u81A0
\u5C4B
\u9109
\u81E8
\u9678
\u9867
\u6389
\u5440
\u71C8
\u6B72
\u63AA
\u675F
\u8010
\u5287
\u7389
\u8D99
\u8DF3
\u54E5
\u5B63
\u8AB2
\u51F1
\u80E1
\u984D
\u6B3E
\u7D39
\u5377
\u9F4A
\u5049
\u84B8
\u6B96
\u6C38
\u5B97
\u82D7
\u5DDD
\u7210
\u5CA9
\u5F31
\u96F6
\u694A
\u594F
\u6CBF
\u9732
\u687F
\u63A2
\u6ED1
\u93AE
\u98EF
\u6FC3
\u822A
\u61F7
\u8D95
\u5EAB
\u596A
\u4F0A
\u9748
\u7A05
\u9014
\u6EC5
\u8CFD
\u6B78
\u53EC
\u9F13
\u64AD
\u76E4
\u88C1
\u96AA
\u5EB7
\u552F
\u9304
\u83CC
\u7D14
\u501F
\u7CD6
\u84CB
\u6A6B
\u7B26
\u79C1
\u52AA
\u5802
\u57DF
\u69CD
\u6F64
\u5E45
\u54C8
\u7ADF
\u719F
\u87F2
\u6FA4
\u8166
\u58E4
\u78B3
\u6B50
\u904D
\u5074
\u5BE8
\u6562
\u5FB9
\u616E
\u659C
\u8584
\u5EAD
\u7D0D
\u5F48
\u98FC
\u4F38
\u6298
\u9EA5
\u6FD5
\u6697
\u8377
\u74E6
\u585E
\u5E8A
\u7BC9
\u60E1
\u6236
\u8A2A
\u5854
\u5947
\u900F
\u6881
\u5200
\u65CB
\u8DE1
\u5361
\u6C2F
\u9047
\u4EFD
\u6BD2
\u6CE5
\u9000
\u6D17
\u64FA
\u7070
\u5F69
\u8CE3
\u8017
\u590F
\u64C7
\u5FD9
\u9285
\u737B
\u786C
\u4E88
\u7E41
\u5708
\u96EA
\u51FD
\u4EA6
\u62BD
\u7BC7
\u9663
\u9670
\u4E01
\u5C3A
\u8FFD
\u5806
\u96C4
\u8FCE
\u6CDB
\u7238
\u6A13
\u907F
\u8B00
\u5678
\u91CE
\u8C6C
\u65D7
\u7D2F
\u504F
\u5178
\u9928
\u7D22
\u79E6
\u8102
\u6F6E
\u723A
\u8C46
\u5FFD
\u6258
\u9A5A
\u5851
\u907A
\u6108
\u6731
\u66FF
\u7E96
\u7C97
\u50BE
\u5C1A
\u75DB
\u695A
\u8B1D
\u596E
\u8CFC
\u78E8
\u541B
\u6C60
\u65C1
\u788E
\u9AA8
\u76E3
\u6355
\u5F1F
\u66B4
\u5272
\u8CAB
\u6B8A
\u91CB
\u8A5E
\u4EA1
\u58C1
\u9813
\u5BF6
\u5348
\u5875
\u805E
\u63ED
\u70AE
\u6B98
\u51AC
\u6A4B
\u5A66
\u8B66
\u7D9C
\u62DB
\u5433
\u4ED8
\u6D6E
\u906D
\u5F90
\u60A8
\u6416
\u8C37
\u8D0A
\u7BB1
\u9694
\u8A02
\u7537
\u5439
\u5712
\u7D1B
\u5510
\u6557
\u5B8B
\u73BB
\u5DE8
\u8015
\u5766
\u69AE
\u9589
\u7063
\u9375
\u51E1
\u99D0
\u934B
\u6551
\u6069
\u525D
\u51DD
\u9E7C
\u9F52
\u622A
\u7149
\u9EBB
\u7D21
\u7981
\u5EE2
\u76DB
\u7248
\u7DE9
\u6DE8
\u775B
\u660C
\u5A5A
\u6D89
\u7B52
\u5634
\u63D2
\u5CB8
\u6717
\u838A
\u8857
\u85CF
\u59D1
\u8CBF
\u8150
\u5974
\u5566
\u6163
\u4E58
\u5925
\u6062
\u52FB
\u7D17
\u624E
\u8FAF
\u8033
\u5F6A
\u81E3
\u5104
\u7483
\u62B5
\u8108
\u79C0
\u85A9
\u4FC4
\u7DB2
\u821E
\u5E97
\u5674
\u7E31
\u5BF8
\u6C57
\u639B
\u6D2A
\u8CC0
\u9583
\u67EC
\u7206
\u70EF
\u6D25
\u7A3B
\u7246
\u8EDF
\u52C7
\u50CF
\u6EFE
\u5398
\u8499
\u82B3
\u80AF
\u5761
\u67F1
\u76EA
\u817F
\u5100
\u65C5
\u5C3E
\u8ECB
\u51B0
\u8CA2
\u767B
\u9ECE
\u524A
\u947D
\u52D2
\u9003
\u969C
\u6C28
\u90ED
\u5CF0
\u5E63
\u6E2F
\u4F0F
\u8ECC
\u755D
\u7562
\u64E6
\u83AB
\u523A
\u6D6A
\u79D8
\u63F4
\u682A
\u5065
\u552E
\u80A1
\u5CF6
\u7518
\u6CE1
\u7761
\u7AE5
\u9444
\u6E6F
\u95A5
\u4F11
\u532F
\u820D
\u7267
\u7E5E
\u70B8
\u54F2
\u78F7
\u7E3E
\u670B
\u6DE1
\u5C16
\u555F
\u9677
\u67F4
\u5448
\u5F92
\u984F
\u6DDA
\u7A0D
\u5FD8
\u6CF5
\u85CD
\u62D6
\u6D1E
\u6388
\u93E1
\u8F9B
\u58EF
\u92D2
\u8CA7
\u865B
\u5F4E
\u6469
\u6CF0
\u5E7C
\u5EF7
\u5C0A
\u7A97
\u7DB1
\u5F04
\u96B8
\u7591
\u6C0F
\u5BAE
\u59D0
\u9707
\u745E
\u602A
\u5C24
\u7434
\u5FAA
\u63CF
\u819C
\u9055
\u593E
\u8170
\u7DE3
\u73E0
\u7AAE
\u68EE
\u679D
\u7AF9
\u6E9D
\u50AC
\u7E69
\u61B6
\u90A6
\u5269
\u5E78
\u6F3F
\u6B04
\u64C1
\u7259
\u8CAF
\u79AE
\u6FFE
\u9209
\u7D0B
\u7F77
\u62CD
\u54B1
\u558A
\u8896
\u57C3
\u52E4
\u7F70
\u7126
\u6F5B
\u4F0D
\u58A8
\u6B32
\u7E2B
\u59D3
\u520A
\u98FD
\u4EFF
\u734E
\u92C1
\u9B3C
\u9E97
\u8DE8
\u9ED8
\u6316
\u93C8
\u6383
\u559D
\u888B
\u70AD
\u6C61
\u5E55
\u8AF8
\u5F27
\u52F5
\u6885
\u5976
\u6F54
\u707D
\u821F
\u9451
\u82EF
\u8A1F
\u62B1
\u6BC0
\u61C2
\u5BD2
\u667A
\u57D4
\u5BC4
\u5C46
\u8E8D
\u6E21
\u6311
\u4E39
\u8271
\u8C9D
\u78B0
\u62D4
\u7239
\u6234
\u78BC
\u5922
\u82BD
\u7194
\u8D64
\u6F01
\u54ED
\u656C
\u9846
\u5954
\u925B
\u4EF2
\u864E
\u7A00
\u59B9
\u4E4F
\u73CD
\u7533
\u684C
\u9075
\u5141
\u9686
\u87BA
\u5009
\u9B4F
\u92B3
\u66C9
\u6C2E
\u517C
\u96B1
\u7919
\u8D6B
\u64A5
\u5FE0
\u8085
\u7F38
\u727D
\u6436
\u535A
\u5DE7
\u6BBC
\u5144
\u675C
\u8A0A
\u8AA0
\u78A7
\u7965
\u67EF
\u9801
\u5DE1
\u77E9
\u60B2
\u704C
\u9F61
\u502B
\u7968
\u5C0B
\u6842
\u92EA
\u8056
\u6050
\u6070
\u912D
\u8DA3
\u62AC
\u8352
\u9A30
\u8CBC
\u67D4
\u6EF4
\u731B
\u95CA
\u8F1B
\u59BB
\u586B
\u64A4
\u5132
\u7C3D
\u9B27
\u64FE
\u7D2B
\u7802
\u905E
\u6232
\u540A
\u9676
\u4F10
\u9935
\u7642
\u74F6
\u5A46
\u64AB
\u81C2
\u6478
\u5FCD
\u8766
\u881F
\u9130
\u80F8
\u978F
\u64E0
\u5076
\u68C4
\u69FD
\u52C1
\u4E73
\u9127
\u5409
\u4EC1
\u721B
\u78DA
\u79DF
\u70CF
\u8266
\u4F34
\u74DC
\u6DFA
\u4E19
\u66AB
\u71E5
\u6A61
\u67F3
\u8FF7
\u6696
\u724C
\u79E7
\u81BD
\u8A73
\u7C27
\u8E0F
\u74F7
\u8B5C
\u5446
\u8CD3
\u7CCA
\u6D1B
\u8F1D
\u61A4
\u7AF6
\u9699
\u6012
\u7C98
\u4E43
\u7DD2
\u80A9
\u7C4D
\u654F
\u5857
\u7199
\u7686
\u5075
\u61F8
\u6398
\u4EAB
\u7CFE
\u9192
\u72C2
\u9396
\u6DC0
\u6068
\u7272
\u9738
\u722C
\u8CDE
\u9006
\u73A9
\u9675
\u795D
\u79D2
\u6D59
\u8C8C
\u5F79
\u5F7C
\u6089
\u9D28
\u8DA8
\u9CF3
\u6668
\u755C
\u8F29
\u79E9
\u5375
\u7F72
\u68AF
\u708E
\u7058
\u68CB
\u9A45
\u7BE9
\u5CFD
\u5192
\u5565
\u58FD
\u8B6F
\u6D78
\u6CC9
\u5E3D
\u9072
\u77FD
\u7586
\u8CB8
\u6F0F
\u7A3F
\u51A0
\u5AE9
\u8105
\u82AF
\u7262
\u53DB
\u8755
\u5967
\u9CF4
\u5DBA
\u7F8A
\u6191
\u4E32
\u5858
\u7E6A
\u9175
\u878D
\u76C6
\u932B
\u5EDF
\u7C4C
\u51CD
\u8F14
\u651D
\u8972
\u7B4B
\u62D2
\u50DA
\u65F1
\u9240
\u9CE5
\u6F06
\u6C88
\u7709
\u758F
\u6DFB
\u68D2
\u7A57
\u785D
\u97D3
\u903C
\u626D
\u50D1
\u6DBC
\u633A
\u7897
\u683D
\u7092
\u676F
\u60A3
\u993E
\u52F8
\u8C6A
\u907C
\u52C3
\u9D3B
\u65E6
\u540F
\u62DC
\u72D7
\u57CB
\u8F25
\u63A9
\u98F2
\u642C
\u7F75
\u8FAD
\u52FE
\u6263
\u4F30
\u8523
\u7D68
\u9727
\u4E08
\u6735
\u59C6
\u64EC
\u5B87
\u8F2F
\u965D
\u96D5
\u511F
\u84C4
\u5D07
\u526A
\u5021
\u5EF3
\u54AC
\u99DB
\u85AF
\u5237
\u65A5
\u756A
\u8CE6
\u5949
\u4F5B
\u6F86
\u6F2B
\u66FC
\u6247
\u9223
\u6843
\u6276
\u4ED4
\u8FD4
\u4FD7
\u8667
\u8154
\u978B
\u68F1
\u8986
\u6846
\u6084
\u53D4
\u649E
\u9A19
\u52D8
\u65FA
\u6CB8
\u5B64
\u5410
\u5B5F
\u6E20
\u5C48
\u75BE
\u5999
\u60DC
\u4EF0
\u72E0
\u8139
\u8AE7
\u62CB
\u9EF4
\u6851
\u5D17
\u561B
\u8870
\u76DC
\u6EF2
\u81DF
\u8CF4
\u6E67
\u751C
\u66F9
\u95B1
\u808C
\u54E9
\u53B2
\u70F4
\u7DEF
\u6BC5
\u6628
\u507D
\u75C7
\u716E
\u5606
\u91D8
\u642D
\u8396
\u7C60
\u9177
\u5077
\u5F13
\u9310
\u6046
\u5091
\u5751
\u9F3B
\u7FFC
\u7DB8
\u6558
\u7344
\u902E
\u7F50
\u7D61
\u68DA
\u6291
\u81A8
\u852C
\u5BFA
\u9A5F
\u7A46
\u51B6
\u67AF
\u518A
\u5C4D
\u51F8
\u7D33
\u576F
\u72A7
\u7130
\u8F5F
\u6B23
\u6649
\u7626
\u79A6
\u9320
\u9326
\u55AA
\u65EC
\u935B
\u58DF
\u641C
\u64B2
\u9080
\u4EAD
\u916F
\u9081
\u8212
\u8106
\u9176
\u9592
\u6182
\u915A
\u9811
\u7FBD
\u6F32
\u5378
\u4ED7
\u966A
\u95E2
\u61F2
\u676D
\u59DA
\u809A
\u6349
\u98C4
\u6F02
\u6606
\u6B3A
\u543E
\u90CE
\u70F7
\u6C41
\u5475
\u98FE
\u856D
\u96C5
\u90F5
\u9077
\u71D5
\u6492
\u59FB
\u8D74
\u5BB4
\u7169
\u50B5
\u5E33
\u6591
\u9234
\u65E8
\u9187
\u8463
\u9905
\u96DB
\u59FF
\u62CC
\u5085
\u8179
\u59A5
\u63C9
\u8CE2
\u62C6
\u6B6A
\u8461
\u80FA
\u4E1F
\u6D69
\u5FBD
\u6602
\u588A
\u64CB
\u89BD
\u8CAA
\u6170
\u7E73
\u6C6A
\u614C
\u99AE
\u8AFE
\u59DC
\u8ABC
\u5147
\u52A3
\u8AA3
\u8000
\u660F
\u8EBA
\u76C8
\u9A0E
\u55AC
\u6EAA
\u53E2
\u76E7
\u62B9
\u60B6
\u8AEE
\u522E
\u99D5
\u7E9C
\u609F
\u6458
\u927A
\u64F2
\u9817
\u5E7B
\u67C4
\u60E0
\u6158
\u4F73
\u4EC7
\u81D8
\u7AA9
\u6ECC
\u528D
\u77A7
\u5821
\u6F51
\u8525
\u7F69
\u970D
\u6488
\u80CE
\u84BC
\u6FF1
\u5006
\u6345
\u6E58
\u780D
\u971E
\u90B5
\u8404
\u760B
\u6DEE
\u9042
\u718A
\u7CDE
\u70D8
\u5BBF
\u6A94
\u6208
\u99C1
\u5AC2
\u88D5
\u5F99
\u7BAD
\u6350
\u8178
\u6490
\u66EC
\u8FA8
\u6BBF
\u84EE
\u6524
\u652A
\u91AC
\u5C4F
\u75AB
\u54C0
\u8521
\u5835
\u6CAB
\u76BA
\u66A2
\u758A
\u95A3
\u840A
\u6572
\u8F44
\u9264
\u75D5
\u58E9
\u5DF7
\u9913
\u798D
\u4E18
\u7384
\u6E9C
\u66F0
\u908F
\u5F6D
\u5617
\u537F
\u59A8
\u8247
\u541E
\u97CB
\u6028
\u77EE
\u6B47`,_l=Ul.split(`
`);var vl=`abdikace
abeceda
adresa
agrese
akce
aktovka
alej
alkohol
amputace
ananas
andulka
anekdota
anketa
antika
anulovat
archa
arogance
asfalt
asistent
aspirace
astma
astronom
atlas
atletika
atol
autobus
azyl
babka
bachor
bacil
baculka
badatel
bageta
bagr
bahno
bakterie
balada
baletka
balkon
balonek
balvan
balza
bambus
bankomat
barbar
baret
barman
baroko
barva
baterka
batoh
bavlna
bazalka
bazilika
bazuka
bedna
beran
beseda
bestie
beton
bezinka
bezmoc
beztak
bicykl
bidlo
biftek
bikiny
bilance
biograf
biolog
bitva
bizon
blahobyt
blatouch
blecha
bledule
blesk
blikat
blizna
blokovat
bloudit
blud
bobek
bobr
bodlina
bodnout
bohatost
bojkot
bojovat
bokorys
bolest
borec
borovice
bota
boubel
bouchat
bouda
boule
bourat
boxer
bradavka
brambora
branka
bratr
brepta
briketa
brko
brloh
bronz
broskev
brunetka
brusinka
brzda
brzy
bublina
bubnovat
buchta
buditel
budka
budova
bufet
bujarost
bukvice
buldok
bulva
bunda
bunkr
burza
butik
buvol
buzola
bydlet
bylina
bytovka
bzukot
capart
carevna
cedr
cedule
cejch
cejn
cela
celer
celkem
celnice
cenina
cennost
cenovka
centrum
cenzor
cestopis
cetka
chalupa
chapadlo
charita
chata
chechtat
chemie
chichot
chirurg
chlad
chleba
chlubit
chmel
chmura
chobot
chochol
chodba
cholera
chomout
chopit
choroba
chov
chrapot
chrlit
chrt
chrup
chtivost
chudina
chutnat
chvat
chvilka
chvost
chyba
chystat
chytit
cibule
cigareta
cihelna
cihla
cinkot
cirkus
cisterna
citace
citrus
cizinec
cizost
clona
cokoliv
couvat
ctitel
ctnost
cudnost
cuketa
cukr
cupot
cvaknout
cval
cvik
cvrkot
cyklista
daleko
dareba
datel
datum
dcera
debata
dechovka
decibel
deficit
deflace
dekl
dekret
demokrat
deprese
derby
deska
detektiv
dikobraz
diktovat
dioda
diplom
disk
displej
divadlo
divoch
dlaha
dlouho
dluhopis
dnes
dobro
dobytek
docent
dochutit
dodnes
dohled
dohoda
dohra
dojem
dojnice
doklad
dokola
doktor
dokument
dolar
doleva
dolina
doma
dominant
domluvit
domov
donutit
dopad
dopis
doplnit
doposud
doprovod
dopustit
dorazit
dorost
dort
dosah
doslov
dostatek
dosud
dosyta
dotaz
dotek
dotknout
doufat
doutnat
dovozce
dozadu
doznat
dozorce
drahota
drak
dramatik
dravec
draze
drdol
drobnost
drogerie
drozd
drsnost
drtit
drzost
duben
duchovno
dudek
duha
duhovka
dusit
dusno
dutost
dvojice
dvorec
dynamit
ekolog
ekonomie
elektron
elipsa
email
emise
emoce
empatie
epizoda
epocha
epopej
epos
esej
esence
eskorta
eskymo
etiketa
euforie
evoluce
exekuce
exkurze
expedice
exploze
export
extrakt
facka
fajfka
fakulta
fanatik
fantazie
farmacie
favorit
fazole
federace
fejeton
fenka
fialka
figurant
filozof
filtr
finance
finta
fixace
fjord
flanel
flirt
flotila
fond
fosfor
fotbal
fotka
foton
frakce
freska
fronta
fukar
funkce
fyzika
galeje
garant
genetika
geolog
gilotina
glazura
glejt
golem
golfista
gotika
graf
gramofon
granule
grep
gril
grog
groteska
guma
hadice
hadr
hala
halenka
hanba
hanopis
harfa
harpuna
havran
hebkost
hejkal
hejno
hejtman
hektar
helma
hematom
herec
herna
heslo
hezky
historik
hladovka
hlasivky
hlava
hledat
hlen
hlodavec
hloh
hloupost
hltat
hlubina
hluchota
hmat
hmota
hmyz
hnis
hnojivo
hnout
hoblina
hoboj
hoch
hodiny
hodlat
hodnota
hodovat
hojnost
hokej
holinka
holka
holub
homole
honitba
honorace
horal
horda
horizont
horko
horlivec
hormon
hornina
horoskop
horstvo
hospoda
hostina
hotovost
houba
houf
houpat
houska
hovor
hradba
hranice
hravost
hrazda
hrbolek
hrdina
hrdlo
hrdost
hrnek
hrobka
hromada
hrot
hrouda
hrozen
hrstka
hrubost
hryzat
hubenost
hubnout
hudba
hukot
humr
husita
hustota
hvozd
hybnost
hydrant
hygiena
hymna
hysterik
idylka
ihned
ikona
iluze
imunita
infekce
inflace
inkaso
inovace
inspekce
internet
invalida
investor
inzerce
ironie
jablko
jachta
jahoda
jakmile
jakost
jalovec
jantar
jarmark
jaro
jasan
jasno
jatka
javor
jazyk
jedinec
jedle
jednatel
jehlan
jekot
jelen
jelito
jemnost
jenom
jepice
jeseter
jevit
jezdec
jezero
jinak
jindy
jinoch
jiskra
jistota
jitrnice
jizva
jmenovat
jogurt
jurta
kabaret
kabel
kabinet
kachna
kadet
kadidlo
kahan
kajak
kajuta
kakao
kaktus
kalamita
kalhoty
kalibr
kalnost
kamera
kamkoliv
kamna
kanibal
kanoe
kantor
kapalina
kapela
kapitola
kapka
kaple
kapota
kapr
kapusta
kapybara
karamel
karotka
karton
kasa
katalog
katedra
kauce
kauza
kavalec
kazajka
kazeta
kazivost
kdekoliv
kdesi
kedluben
kemp
keramika
kino
klacek
kladivo
klam
klapot
klasika
klaun
klec
klenba
klepat
klesnout
klid
klima
klisna
klobouk
klokan
klopa
kloub
klubovna
klusat
kluzkost
kmen
kmitat
kmotr
kniha
knot
koalice
koberec
kobka
kobliha
kobyla
kocour
kohout
kojenec
kokos
koktejl
kolaps
koleda
kolize
kolo
komando
kometa
komik
komnata
komora
kompas
komunita
konat
koncept
kondice
konec
konfese
kongres
konina
konkurs
kontakt
konzerva
kopanec
kopie
kopnout
koprovka
korbel
korektor
kormidlo
koroptev
korpus
koruna
koryto
korzet
kosatec
kostka
kotel
kotleta
kotoul
koukat
koupelna
kousek
kouzlo
kovboj
koza
kozoroh
krabice
krach
krajina
kralovat
krasopis
kravata
kredit
krejcar
kresba
kreveta
kriket
kritik
krize
krkavec
krmelec
krmivo
krocan
krok
kronika
kropit
kroupa
krovka
krtek
kruhadlo
krupice
krutost
krvinka
krychle
krypta
krystal
kryt
kudlanka
kufr
kujnost
kukla
kulajda
kulich
kulka
kulomet
kultura
kuna
kupodivu
kurt
kurzor
kutil
kvalita
kvasinka
kvestor
kynolog
kyselina
kytara
kytice
kytka
kytovec
kyvadlo
labrador
lachtan
ladnost
laik
lakomec
lamela
lampa
lanovka
lasice
laso
lastura
latinka
lavina
lebka
leckdy
leden
lednice
ledovka
ledvina
legenda
legie
legrace
lehce
lehkost
lehnout
lektvar
lenochod
lentilka
lepenka
lepidlo
letadlo
letec
letmo
letokruh
levhart
levitace
levobok
libra
lichotka
lidojed
lidskost
lihovina
lijavec
lilek
limetka
linie
linka
linoleum
listopad
litina
litovat
lobista
lodivod
logika
logoped
lokalita
loket
lomcovat
lopata
lopuch
lord
losos
lotr
loudal
louh
louka
louskat
lovec
lstivost
lucerna
lucifer
lump
lusk
lustrace
lvice
lyra
lyrika
lysina
madam
madlo
magistr
mahagon
majetek
majitel
majorita
makak
makovice
makrela
malba
malina
malovat
malvice
maminka
mandle
manko
marnost
masakr
maskot
masopust
matice
matrika
maturita
mazanec
mazivo
mazlit
mazurka
mdloba
mechanik
meditace
medovina
melasa
meloun
mentolka
metla
metoda
metr
mezera
migrace
mihnout
mihule
mikina
mikrofon
milenec
milimetr
milost
mimika
mincovna
minibar
minomet
minulost
miska
mistr
mixovat
mladost
mlha
mlhovina
mlok
mlsat
mluvit
mnich
mnohem
mobil
mocnost
modelka
modlitba
mohyla
mokro
molekula
momentka
monarcha
monokl
monstrum
montovat
monzun
mosaz
moskyt
most
motivace
motorka
motyka
moucha
moudrost
mozaika
mozek
mozol
mramor
mravenec
mrkev
mrtvola
mrzet
mrzutost
mstitel
mudrc
muflon
mulat
mumie
munice
muset
mutace
muzeum
muzikant
myslivec
mzda
nabourat
nachytat
nadace
nadbytek
nadhoz
nadobro
nadpis
nahlas
nahnat
nahodile
nahradit
naivita
najednou
najisto
najmout
naklonit
nakonec
nakrmit
nalevo
namazat
namluvit
nanometr
naoko
naopak
naostro
napadat
napevno
naplnit
napnout
naposled
naprosto
narodit
naruby
narychlo
nasadit
nasekat
naslepo
nastat
natolik
navenek
navrch
navzdory
nazvat
nebe
nechat
necky
nedaleko
nedbat
neduh
negace
nehet
nehoda
nejen
nejprve
neklid
nelibost
nemilost
nemoc
neochota
neonka
nepokoj
nerost
nerv
nesmysl
nesoulad
netvor
neuron
nevina
nezvykle
nicota
nijak
nikam
nikdy
nikl
nikterak
nitro
nocleh
nohavice
nominace
nora
norek
nositel
nosnost
nouze
noviny
novota
nozdra
nuda
nudle
nuget
nutit
nutnost
nutrie
nymfa
obal
obarvit
obava
obdiv
obec
obehnat
obejmout
obezita
obhajoba
obilnice
objasnit
objekt
obklopit
oblast
oblek
obliba
obloha
obluda
obnos
obohatit
obojek
obout
obrazec
obrna
obruba
obrys
obsah
obsluha
obstarat
obuv
obvaz
obvinit
obvod
obvykle
obyvatel
obzor
ocas
ocel
ocenit
ochladit
ochota
ochrana
ocitnout
odboj
odbyt
odchod
odcizit
odebrat
odeslat
odevzdat
odezva
odhadce
odhodit
odjet
odjinud
odkaz
odkoupit
odliv
odluka
odmlka
odolnost
odpad
odpis
odplout
odpor
odpustit
odpykat
odrazka
odsoudit
odstup
odsun
odtok
odtud
odvaha
odveta
odvolat
odvracet
odznak
ofina
ofsajd
ohlas
ohnisko
ohrada
ohrozit
ohryzek
okap
okenice
oklika
okno
okouzlit
okovy
okrasa
okres
okrsek
okruh
okupant
okurka
okusit
olejnina
olizovat
omak
omeleta
omezit
omladina
omlouvat
omluva
omyl
onehdy
opakovat
opasek
operace
opice
opilost
opisovat
opora
opozice
opravdu
oproti
orbital
orchestr
orgie
orlice
orloj
ortel
osada
oschnout
osika
osivo
oslava
oslepit
oslnit
oslovit
osnova
osoba
osolit
ospalec
osten
ostraha
ostuda
ostych
osvojit
oteplit
otisk
otop
otrhat
otrlost
otrok
otruby
otvor
ovanout
ovar
oves
ovlivnit
ovoce
oxid
ozdoba
pachatel
pacient
padouch
pahorek
pakt
palanda
palec
palivo
paluba
pamflet
pamlsek
panenka
panika
panna
panovat
panstvo
pantofle
paprika
parketa
parodie
parta
paruka
paryba
paseka
pasivita
pastelka
patent
patrona
pavouk
pazneht
pazourek
pecka
pedagog
pejsek
peklo
peloton
penalta
pendrek
penze
periskop
pero
pestrost
petarda
petice
petrolej
pevnina
pexeso
pianista
piha
pijavice
pikle
piknik
pilina
pilnost
pilulka
pinzeta
pipeta
pisatel
pistole
pitevna
pivnice
pivovar
placenta
plakat
plamen
planeta
plastika
platit
plavidlo
plaz
plech
plemeno
plenta
ples
pletivo
plevel
plivat
plnit
plno
plocha
plodina
plomba
plout
pluk
plyn
pobavit
pobyt
pochod
pocit
poctivec
podat
podcenit
podepsat
podhled
podivit
podklad
podmanit
podnik
podoba
podpora
podraz
podstata
podvod
podzim
poezie
pohanka
pohnutka
pohovor
pohroma
pohyb
pointa
pojistka
pojmout
pokazit
pokles
pokoj
pokrok
pokuta
pokyn
poledne
polibek
polknout
poloha
polynom
pomalu
pominout
pomlka
pomoc
pomsta
pomyslet
ponechat
ponorka
ponurost
popadat
popel
popisek
poplach
poprosit
popsat
popud
poradce
porce
porod
porucha
poryv
posadit
posed
posila
poskok
poslanec
posoudit
pospolu
postava
posudek
posyp
potah
potkan
potlesk
potomek
potrava
potupa
potvora
poukaz
pouto
pouzdro
povaha
povidla
povlak
povoz
povrch
povstat
povyk
povzdech
pozdrav
pozemek
poznatek
pozor
pozvat
pracovat
prahory
praktika
prales
praotec
praporek
prase
pravda
princip
prkno
probudit
procento
prodej
profese
prohra
projekt
prolomit
promile
pronikat
propad
prorok
prosba
proton
proutek
provaz
prskavka
prsten
prudkost
prut
prvek
prvohory
psanec
psovod
pstruh
ptactvo
puberta
puch
pudl
pukavec
puklina
pukrle
pult
pumpa
punc
pupen
pusa
pusinka
pustina
putovat
putyka
pyramida
pysk
pytel
racek
rachot
radiace
radnice
radon
raft
ragby
raketa
rakovina
rameno
rampouch
rande
rarach
rarita
rasovna
rastr
ratolest
razance
razidlo
reagovat
reakce
recept
redaktor
referent
reflex
rejnok
reklama
rekord
rekrut
rektor
reputace
revize
revma
revolver
rezerva
riskovat
riziko
robotika
rodokmen
rohovka
rokle
rokoko
romaneto
ropovod
ropucha
rorejs
rosol
rostlina
rotmistr
rotoped
rotunda
roubenka
roucho
roup
roura
rovina
rovnice
rozbor
rozchod
rozdat
rozeznat
rozhodce
rozinka
rozjezd
rozkaz
rozloha
rozmar
rozpad
rozruch
rozsah
roztok
rozum
rozvod
rubrika
ruchadlo
rukavice
rukopis
ryba
rybolov
rychlost
rydlo
rypadlo
rytina
ryzost
sadista
sahat
sako
samec
samizdat
samota
sanitka
sardinka
sasanka
satelit
sazba
sazenice
sbor
schovat
sebranka
secese
sedadlo
sediment
sedlo
sehnat
sejmout
sekera
sekta
sekunda
sekvoje
semeno
seno
servis
sesadit
seshora
seskok
seslat
sestra
sesuv
sesypat
setba
setina
setkat
setnout
setrvat
sever
seznam
shoda
shrnout
sifon
silnice
sirka
sirotek
sirup
situace
skafandr
skalisko
skanzen
skaut
skeptik
skica
skladba
sklenice
sklo
skluz
skoba
skokan
skoro
skripta
skrz
skupina
skvost
skvrna
slabika
sladidlo
slanina
slast
slavnost
sledovat
slepec
sleva
slezina
slib
slina
sliznice
slon
sloupek
slovo
sluch
sluha
slunce
slupka
slza
smaragd
smetana
smilstvo
smlouva
smog
smrad
smrk
smrtka
smutek
smysl
snad
snaha
snob
sobota
socha
sodovka
sokol
sopka
sotva
souboj
soucit
soudce
souhlas
soulad
soumrak
souprava
soused
soutok
souviset
spalovna
spasitel
spis
splav
spodek
spojenec
spolu
sponzor
spornost
spousta
sprcha
spustit
sranda
sraz
srdce
srna
srnec
srovnat
srpen
srst
srub
stanice
starosta
statika
stavba
stehno
stezka
stodola
stolek
stopa
storno
stoupat
strach
stres
strhnout
strom
struna
studna
stupnice
stvol
styk
subjekt
subtropy
suchar
sudost
sukno
sundat
sunout
surikata
surovina
svah
svalstvo
svetr
svatba
svazek
svisle
svitek
svoboda
svodidlo
svorka
svrab
sykavka
sykot
synek
synovec
sypat
sypkost
syrovost
sysel
sytost
tabletka
tabule
tahoun
tajemno
tajfun
tajga
tajit
tajnost
taktika
tamhle
tampon
tancovat
tanec
tanker
tapeta
tavenina
tazatel
technika
tehdy
tekutina
telefon
temnota
tendence
tenista
tenor
teplota
tepna
teprve
terapie
termoska
textil
ticho
tiskopis
titulek
tkadlec
tkanina
tlapka
tleskat
tlukot
tlupa
tmel
toaleta
topinka
topol
torzo
touha
toulec
tradice
traktor
tramp
trasa
traverza
trefit
trest
trezor
trhavina
trhlina
trochu
trojice
troska
trouba
trpce
trpitel
trpkost
trubec
truchlit
truhlice
trus
trvat
tudy
tuhnout
tuhost
tundra
turista
turnaj
tuzemsko
tvaroh
tvorba
tvrdost
tvrz
tygr
tykev
ubohost
uboze
ubrat
ubrousek
ubrus
ubytovna
ucho
uctivost
udivit
uhradit
ujednat
ujistit
ujmout
ukazatel
uklidnit
uklonit
ukotvit
ukrojit
ulice
ulita
ulovit
umyvadlo
unavit
uniforma
uniknout
upadnout
uplatnit
uplynout
upoutat
upravit
uran
urazit
usednout
usilovat
usmrtit
usnadnit
usnout
usoudit
ustlat
ustrnout
utahovat
utkat
utlumit
utonout
utopenec
utrousit
uvalit
uvolnit
uvozovka
uzdravit
uzel
uzenina
uzlina
uznat
vagon
valcha
valoun
vana
vandal
vanilka
varan
varhany
varovat
vcelku
vchod
vdova
vedro
vegetace
vejce
velbloud
veletrh
velitel
velmoc
velryba
venkov
veranda
verze
veselka
veskrze
vesnice
vespodu
vesta
veterina
veverka
vibrace
vichr
videohra
vidina
vidle
vila
vinice
viset
vitalita
vize
vizitka
vjezd
vklad
vkus
vlajka
vlak
vlasec
vlevo
vlhkost
vliv
vlnovka
vloupat
vnucovat
vnuk
voda
vodivost
vodoznak
vodstvo
vojensky
vojna
vojsko
volant
volba
volit
volno
voskovka
vozidlo
vozovna
vpravo
vrabec
vracet
vrah
vrata
vrba
vrcholek
vrhat
vrstva
vrtule
vsadit
vstoupit
vstup
vtip
vybavit
vybrat
vychovat
vydat
vydra
vyfotit
vyhledat
vyhnout
vyhodit
vyhradit
vyhubit
vyjasnit
vyjet
vyjmout
vyklopit
vykonat
vylekat
vymazat
vymezit
vymizet
vymyslet
vynechat
vynikat
vynutit
vypadat
vyplatit
vypravit
vypustit
vyrazit
vyrovnat
vyrvat
vyslovit
vysoko
vystavit
vysunout
vysypat
vytasit
vytesat
vytratit
vyvinout
vyvolat
vyvrhel
vyzdobit
vyznat
vzadu
vzbudit
vzchopit
vzdor
vzduch
vzdychat
vzestup
vzhledem
vzkaz
vzlykat
vznik
vzorek
vzpoura
vztah
vztek
xylofon
zabrat
zabydlet
zachovat
zadarmo
zadusit
zafoukat
zahltit
zahodit
zahrada
zahynout
zajatec
zajet
zajistit
zaklepat
zakoupit
zalepit
zamezit
zamotat
zamyslet
zanechat
zanikat
zaplatit
zapojit
zapsat
zarazit
zastavit
zasunout
zatajit
zatemnit
zatknout
zaujmout
zavalit
zavelet
zavinit
zavolat
zavrtat
zazvonit
zbavit
zbrusu
zbudovat
zbytek
zdaleka
zdarma
zdatnost
zdivo
zdobit
zdroj
zdvih
zdymadlo
zelenina
zeman
zemina
zeptat
zezadu
zezdola
zhatit
zhltnout
zhluboka
zhotovit
zhruba
zima
zimnice
zjemnit
zklamat
zkoumat
zkratka
zkumavka
zlato
zlehka
zloba
zlom
zlost
zlozvyk
zmapovat
zmar
zmatek
zmije
zmizet
zmocnit
zmodrat
zmrzlina
zmutovat
znak
znalost
znamenat
znovu
zobrazit
zotavit
zoubek
zoufale
zplodit
zpomalit
zprava
zprostit
zprudka
zprvu
zrada
zranit
zrcadlo
zrnitost
zrno
zrovna
zrychlit
zrzavost
zticha
ztratit
zubovina
zubr
zvednout
zvenku
zvesela
zvon
zvrat
zvukovod
zvyk`,Dl=vl.split(`
`);var wl=`abandon
ability
able
about
above
absent
absorb
abstract
absurd
abuse
access
accident
account
accuse
achieve
acid
acoustic
acquire
across
act
action
actor
actress
actual
adapt
add
addict
address
adjust
admit
adult
advance
advice
aerobic
affair
afford
afraid
again
age
agent
agree
ahead
aim
air
airport
aisle
alarm
album
alcohol
alert
alien
all
alley
allow
almost
alone
alpha
already
also
alter
always
amateur
amazing
among
amount
amused
analyst
anchor
ancient
anger
angle
angry
animal
ankle
announce
annual
another
answer
antenna
antique
anxiety
any
apart
apology
appear
apple
approve
april
arch
arctic
area
arena
argue
arm
armed
armor
army
around
arrange
arrest
arrive
arrow
art
artefact
artist
artwork
ask
aspect
assault
asset
assist
assume
asthma
athlete
atom
attack
attend
attitude
attract
auction
audit
august
aunt
author
auto
autumn
average
avocado
avoid
awake
aware
away
awesome
awful
awkward
axis
baby
bachelor
bacon
badge
bag
balance
balcony
ball
bamboo
banana
banner
bar
barely
bargain
barrel
base
basic
basket
battle
beach
bean
beauty
because
become
beef
before
begin
behave
behind
believe
below
belt
bench
benefit
best
betray
better
between
beyond
bicycle
bid
bike
bind
biology
bird
birth
bitter
black
blade
blame
blanket
blast
bleak
bless
blind
blood
blossom
blouse
blue
blur
blush
board
boat
body
boil
bomb
bone
bonus
book
boost
border
boring
borrow
boss
bottom
bounce
box
boy
bracket
brain
brand
brass
brave
bread
breeze
brick
bridge
brief
bright
bring
brisk
broccoli
broken
bronze
broom
brother
brown
brush
bubble
buddy
budget
buffalo
build
bulb
bulk
bullet
bundle
bunker
burden
burger
burst
bus
business
busy
butter
buyer
buzz
cabbage
cabin
cable
cactus
cage
cake
call
calm
camera
camp
can
canal
cancel
candy
cannon
canoe
canvas
canyon
capable
capital
captain
car
carbon
card
cargo
carpet
carry
cart
case
cash
casino
castle
casual
cat
catalog
catch
category
cattle
caught
cause
caution
cave
ceiling
celery
cement
census
century
cereal
certain
chair
chalk
champion
change
chaos
chapter
charge
chase
chat
cheap
check
cheese
chef
cherry
chest
chicken
chief
child
chimney
choice
choose
chronic
chuckle
chunk
churn
cigar
cinnamon
circle
citizen
city
civil
claim
clap
clarify
claw
clay
clean
clerk
clever
click
client
cliff
climb
clinic
clip
clock
clog
close
cloth
cloud
clown
club
clump
cluster
clutch
coach
coast
coconut
code
coffee
coil
coin
collect
color
column
combine
come
comfort
comic
common
company
concert
conduct
confirm
congress
connect
consider
control
convince
cook
cool
copper
copy
coral
core
corn
correct
cost
cotton
couch
country
couple
course
cousin
cover
coyote
crack
cradle
craft
cram
crane
crash
crater
crawl
crazy
cream
credit
creek
crew
cricket
crime
crisp
critic
crop
cross
crouch
crowd
crucial
cruel
cruise
crumble
crunch
crush
cry
crystal
cube
culture
cup
cupboard
curious
current
curtain
curve
cushion
custom
cute
cycle
dad
damage
damp
dance
danger
daring
dash
daughter
dawn
day
deal
debate
debris
decade
december
decide
decline
decorate
decrease
deer
defense
define
defy
degree
delay
deliver
demand
demise
denial
dentist
deny
depart
depend
deposit
depth
deputy
derive
describe
desert
design
desk
despair
destroy
detail
detect
develop
device
devote
diagram
dial
diamond
diary
dice
diesel
diet
differ
digital
dignity
dilemma
dinner
dinosaur
direct
dirt
disagree
discover
disease
dish
dismiss
disorder
display
distance
divert
divide
divorce
dizzy
doctor
document
dog
doll
dolphin
domain
donate
donkey
donor
door
dose
double
dove
draft
dragon
drama
drastic
draw
dream
dress
drift
drill
drink
drip
drive
drop
drum
dry
duck
dumb
dune
during
dust
dutch
duty
dwarf
dynamic
eager
eagle
early
earn
earth
easily
east
easy
echo
ecology
economy
edge
edit
educate
effort
egg
eight
either
elbow
elder
electric
elegant
element
elephant
elevator
elite
else
embark
embody
embrace
emerge
emotion
employ
empower
empty
enable
enact
end
endless
endorse
enemy
energy
enforce
engage
engine
enhance
enjoy
enlist
enough
enrich
enroll
ensure
enter
entire
entry
envelope
episode
equal
equip
era
erase
erode
erosion
error
erupt
escape
essay
essence
estate
eternal
ethics
evidence
evil
evoke
evolve
exact
example
excess
exchange
excite
exclude
excuse
execute
exercise
exhaust
exhibit
exile
exist
exit
exotic
expand
expect
expire
explain
expose
express
extend
extra
eye
eyebrow
fabric
face
faculty
fade
faint
faith
fall
false
fame
family
famous
fan
fancy
fantasy
farm
fashion
fat
fatal
father
fatigue
fault
favorite
feature
february
federal
fee
feed
feel
female
fence
festival
fetch
fever
few
fiber
fiction
field
figure
file
film
filter
final
find
fine
finger
finish
fire
firm
first
fiscal
fish
fit
fitness
fix
flag
flame
flash
flat
flavor
flee
flight
flip
float
flock
floor
flower
fluid
flush
fly
foam
focus
fog
foil
fold
follow
food
foot
force
forest
forget
fork
fortune
forum
forward
fossil
foster
found
fox
fragile
frame
frequent
fresh
friend
fringe
frog
front
frost
frown
frozen
fruit
fuel
fun
funny
furnace
fury
future
gadget
gain
galaxy
gallery
game
gap
garage
garbage
garden
garlic
garment
gas
gasp
gate
gather
gauge
gaze
general
genius
genre
gentle
genuine
gesture
ghost
giant
gift
giggle
ginger
giraffe
girl
give
glad
glance
glare
glass
glide
glimpse
globe
gloom
glory
glove
glow
glue
goat
goddess
gold
good
goose
gorilla
gospel
gossip
govern
gown
grab
grace
grain
grant
grape
grass
gravity
great
green
grid
grief
grit
grocery
group
grow
grunt
guard
guess
guide
guilt
guitar
gun
gym
habit
hair
half
hammer
hamster
hand
happy
harbor
hard
harsh
harvest
hat
have
hawk
hazard
head
health
heart
heavy
hedgehog
height
hello
helmet
help
hen
hero
hidden
high
hill
hint
hip
hire
history
hobby
hockey
hold
hole
holiday
hollow
home
honey
hood
hope
horn
horror
horse
hospital
host
hotel
hour
hover
hub
huge
human
humble
humor
hundred
hungry
hunt
hurdle
hurry
hurt
husband
hybrid
ice
icon
idea
identify
idle
ignore
ill
illegal
illness
image
imitate
immense
immune
impact
impose
improve
impulse
inch
include
income
increase
index
indicate
indoor
industry
infant
inflict
inform
inhale
inherit
initial
inject
injury
inmate
inner
innocent
input
inquiry
insane
insect
inside
inspire
install
intact
interest
into
invest
invite
involve
iron
island
isolate
issue
item
ivory
jacket
jaguar
jar
jazz
jealous
jeans
jelly
jewel
job
join
joke
journey
joy
judge
juice
jump
jungle
junior
junk
just
kangaroo
keen
keep
ketchup
key
kick
kid
kidney
kind
kingdom
kiss
kit
kitchen
kite
kitten
kiwi
knee
knife
knock
know
lab
label
labor
ladder
lady
lake
lamp
language
laptop
large
later
latin
laugh
laundry
lava
law
lawn
lawsuit
layer
lazy
leader
leaf
learn
leave
lecture
left
leg
legal
legend
leisure
lemon
lend
length
lens
leopard
lesson
letter
level
liar
liberty
library
license
life
lift
light
like
limb
limit
link
lion
liquid
list
little
live
lizard
load
loan
lobster
local
lock
logic
lonely
long
loop
lottery
loud
lounge
love
loyal
lucky
luggage
lumber
lunar
lunch
luxury
lyrics
machine
mad
magic
magnet
maid
mail
main
major
make
mammal
man
manage
mandate
mango
mansion
manual
maple
marble
march
margin
marine
market
marriage
mask
mass
master
match
material
math
matrix
matter
maximum
maze
meadow
mean
measure
meat
mechanic
medal
media
melody
melt
member
memory
mention
menu
mercy
merge
merit
merry
mesh
message
metal
method
middle
midnight
milk
million
mimic
mind
minimum
minor
minute
miracle
mirror
misery
miss
mistake
mix
mixed
mixture
mobile
model
modify
mom
moment
monitor
monkey
monster
month
moon
moral
more
morning
mosquito
mother
motion
motor
mountain
mouse
move
movie
much
muffin
mule
multiply
muscle
museum
mushroom
music
must
mutual
myself
mystery
myth
naive
name
napkin
narrow
nasty
nation
nature
near
neck
need
negative
neglect
neither
nephew
nerve
nest
net
network
neutral
never
news
next
nice
night
noble
noise
nominee
noodle
normal
north
nose
notable
note
nothing
notice
novel
now
nuclear
number
nurse
nut
oak
obey
object
oblige
obscure
observe
obtain
obvious
occur
ocean
october
odor
off
offer
office
often
oil
okay
old
olive
olympic
omit
once
one
onion
online
only
open
opera
opinion
oppose
option
orange
orbit
orchard
order
ordinary
organ
orient
original
orphan
ostrich
other
outdoor
outer
output
outside
oval
oven
over
own
owner
oxygen
oyster
ozone
pact
paddle
page
pair
palace
palm
panda
panel
panic
panther
paper
parade
parent
park
parrot
party
pass
patch
path
patient
patrol
pattern
pause
pave
payment
peace
peanut
pear
peasant
pelican
pen
penalty
pencil
people
pepper
perfect
permit
person
pet
phone
photo
phrase
physical
piano
picnic
picture
piece
pig
pigeon
pill
pilot
pink
pioneer
pipe
pistol
pitch
pizza
place
planet
plastic
plate
play
please
pledge
pluck
plug
plunge
poem
poet
point
polar
pole
police
pond
pony
pool
popular
portion
position
possible
post
potato
pottery
poverty
powder
power
practice
praise
predict
prefer
prepare
present
pretty
prevent
price
pride
primary
print
priority
prison
private
prize
problem
process
produce
profit
program
project
promote
proof
property
prosper
protect
proud
provide
public
pudding
pull
pulp
pulse
pumpkin
punch
pupil
puppy
purchase
purity
purpose
purse
push
put
puzzle
pyramid
quality
quantum
quarter
question
quick
quit
quiz
quote
rabbit
raccoon
race
rack
radar
radio
rail
rain
raise
rally
ramp
ranch
random
range
rapid
rare
rate
rather
raven
raw
razor
ready
real
reason
rebel
rebuild
recall
receive
recipe
record
recycle
reduce
reflect
reform
refuse
region
regret
regular
reject
relax
release
relief
rely
remain
remember
remind
remove
render
renew
rent
reopen
repair
repeat
replace
report
require
rescue
resemble
resist
resource
response
result
retire
retreat
return
reunion
reveal
review
reward
rhythm
rib
ribbon
rice
rich
ride
ridge
rifle
right
rigid
ring
riot
ripple
risk
ritual
rival
river
road
roast
robot
robust
rocket
romance
roof
rookie
room
rose
rotate
rough
round
route
royal
rubber
rude
rug
rule
run
runway
rural
sad
saddle
sadness
safe
sail
salad
salmon
salon
salt
salute
same
sample
sand
satisfy
satoshi
sauce
sausage
save
say
scale
scan
scare
scatter
scene
scheme
school
science
scissors
scorpion
scout
scrap
screen
script
scrub
sea
search
season
seat
second
secret
section
security
seed
seek
segment
select
sell
seminar
senior
sense
sentence
series
service
session
settle
setup
seven
shadow
shaft
shallow
share
shed
shell
sheriff
shield
shift
shine
ship
shiver
shock
shoe
shoot
shop
short
shoulder
shove
shrimp
shrug
shuffle
shy
sibling
sick
side
siege
sight
sign
silent
silk
silly
silver
similar
simple
since
sing
siren
sister
situate
six
size
skate
sketch
ski
skill
skin
skirt
skull
slab
slam
sleep
slender
slice
slide
slight
slim
slogan
slot
slow
slush
small
smart
smile
smoke
smooth
snack
snake
snap
sniff
snow
soap
soccer
social
sock
soda
soft
solar
soldier
solid
solution
solve
someone
song
soon
sorry
sort
soul
sound
soup
source
south
space
spare
spatial
spawn
speak
special
speed
spell
spend
sphere
spice
spider
spike
spin
spirit
split
spoil
sponsor
spoon
sport
spot
spray
spread
spring
spy
square
squeeze
squirrel
stable
stadium
staff
stage
stairs
stamp
stand
start
state
stay
steak
steel
stem
step
stereo
stick
still
sting
stock
stomach
stone
stool
story
stove
strategy
street
strike
strong
struggle
student
stuff
stumble
style
subject
submit
subway
success
such
sudden
suffer
sugar
suggest
suit
summer
sun
sunny
sunset
super
supply
supreme
sure
surface
surge
surprise
surround
survey
suspect
sustain
swallow
swamp
swap
swarm
swear
sweet
swift
swim
swing
switch
sword
symbol
symptom
syrup
system
table
tackle
tag
tail
talent
talk
tank
tape
target
task
taste
tattoo
taxi
teach
team
tell
ten
tenant
tennis
tent
term
test
text
thank
that
theme
then
theory
there
they
thing
this
thought
three
thrive
throw
thumb
thunder
ticket
tide
tiger
tilt
timber
time
tiny
tip
tired
tissue
title
toast
tobacco
today
toddler
toe
together
toilet
token
tomato
tomorrow
tone
tongue
tonight
tool
tooth
top
topic
topple
torch
tornado
tortoise
toss
total
tourist
toward
tower
town
toy
track
trade
traffic
tragic
train
transfer
trap
trash
travel
tray
treat
tree
trend
trial
tribe
trick
trigger
trim
trip
trophy
trouble
truck
true
truly
trumpet
trust
truth
try
tube
tuition
tumble
tuna
tunnel
turkey
turn
turtle
twelve
twenty
twice
twin
twist
two
type
typical
ugly
umbrella
unable
unaware
uncle
uncover
under
undo
unfair
unfold
unhappy
uniform
unique
unit
universe
unknown
unlock
until
unusual
unveil
update
upgrade
uphold
upon
upper
upset
urban
urge
usage
use
used
useful
useless
usual
utility
vacant
vacuum
vague
valid
valley
valve
van
vanish
vapor
various
vast
vault
vehicle
velvet
vendor
venture
venue
verb
verify
version
very
vessel
veteran
viable
vibrant
vicious
victory
video
view
village
vintage
violin
virtual
virus
visa
visit
visual
vital
vivid
vocal
voice
void
volcano
volume
vote
voyage
wage
wagon
wait
walk
wall
walnut
want
warfare
warm
warrior
wash
wasp
waste
water
wave
way
wealth
weapon
wear
weasel
weather
web
wedding
weekend
weird
welcome
west
wet
whale
what
wheat
wheel
when
where
whip
whisper
wide
width
wife
wild
will
win
window
wine
wing
wink
winner
winter
wire
wisdom
wise
wish
witness
wolf
woman
wonder
wood
wool
word
work
world
worry
worth
wrap
wreck
wrestle
wrist
write
wrong
yard
year
yellow
you
young
youth
zebra
zero
zone
zoo`,kr=wl.split(`
`);var Tl=`abaisser
abandon
abdiquer
abeille
abolir
aborder
aboutir
aboyer
abrasif
abreuver
abriter
abroger
abrupt
absence
absolu
absurde
abusif
abyssal
acade\u0301mie
acajou
acarien
accabler
accepter
acclamer
accolade
accroche
accuser
acerbe
achat
acheter
aciduler
acier
acompte
acque\u0301rir
acronyme
acteur
actif
actuel
adepte
ade\u0301quat
adhe\u0301sif
adjectif
adjuger
admettre
admirer
adopter
adorer
adoucir
adresse
adroit
adulte
adverbe
ae\u0301rer
ae\u0301ronef
affaire
affecter
affiche
affreux
affubler
agacer
agencer
agile
agiter
agrafer
agre\u0301able
agrume
aider
aiguille
ailier
aimable
aisance
ajouter
ajuster
alarmer
alchimie
alerte
alge\u0300bre
algue
alie\u0301ner
aliment
alle\u0301ger
alliage
allouer
allumer
alourdir
alpaga
altesse
alve\u0301ole
amateur
ambigu
ambre
ame\u0301nager
amertume
amidon
amiral
amorcer
amour
amovible
amphibie
ampleur
amusant
analyse
anaphore
anarchie
anatomie
ancien
ane\u0301antir
angle
angoisse
anguleux
animal
annexer
annonce
annuel
anodin
anomalie
anonyme
anormal
antenne
antidote
anxieux
apaiser
ape\u0301ritif
aplanir
apologie
appareil
appeler
apporter
appuyer
aquarium
aqueduc
arbitre
arbuste
ardeur
ardoise
argent
arlequin
armature
armement
armoire
armure
arpenter
arracher
arriver
arroser
arsenic
arte\u0301riel
article
aspect
asphalte
aspirer
assaut
asservir
assiette
associer
assurer
asticot
astre
astuce
atelier
atome
atrium
atroce
attaque
attentif
attirer
attraper
aubaine
auberge
audace
audible
augurer
aurore
automne
autruche
avaler
avancer
avarice
avenir
averse
aveugle
aviateur
avide
avion
aviser
avoine
avouer
avril
axial
axiome
badge
bafouer
bagage
baguette
baignade
balancer
balcon
baleine
balisage
bambin
bancaire
bandage
banlieue
bannie\u0300re
banquier
barbier
baril
baron
barque
barrage
bassin
bastion
bataille
bateau
batterie
baudrier
bavarder
belette
be\u0301lier
belote
be\u0301ne\u0301fice
berceau
berger
berline
bermuda
besace
besogne
be\u0301tail
beurre
biberon
bicycle
bidule
bijou
bilan
bilingue
billard
binaire
biologie
biopsie
biotype
biscuit
bison
bistouri
bitume
bizarre
blafard
blague
blanchir
blessant
blinder
blond
bloquer
blouson
bobard
bobine
boire
boiser
bolide
bonbon
bondir
bonheur
bonifier
bonus
bordure
borne
botte
boucle
boueux
bougie
boulon
bouquin
bourse
boussole
boutique
boxeur
branche
brasier
brave
brebis
bre\u0300che
breuvage
bricoler
brigade
brillant
brioche
brique
brochure
broder
bronzer
brousse
broyeur
brume
brusque
brutal
bruyant
buffle
buisson
bulletin
bureau
burin
bustier
butiner
butoir
buvable
buvette
cabanon
cabine
cachette
cadeau
cadre
cafe\u0301ine
caillou
caisson
calculer
calepin
calibre
calmer
calomnie
calvaire
camarade
came\u0301ra
camion
campagne
canal
caneton
canon
cantine
canular
capable
caporal
caprice
capsule
capter
capuche
carabine
carbone
caresser
caribou
carnage
carotte
carreau
carton
cascade
casier
casque
cassure
causer
caution
cavalier
caverne
caviar
ce\u0301dille
ceinture
ce\u0301leste
cellule
cendrier
censurer
central
cercle
ce\u0301re\u0301bral
cerise
cerner
cerveau
cesser
chagrin
chaise
chaleur
chambre
chance
chapitre
charbon
chasseur
chaton
chausson
chavirer
chemise
chenille
che\u0301quier
chercher
cheval
chien
chiffre
chignon
chime\u0300re
chiot
chlorure
chocolat
choisir
chose
chouette
chrome
chute
cigare
cigogne
cimenter
cine\u0301ma
cintrer
circuler
cirer
cirque
citerne
citoyen
citron
civil
clairon
clameur
claquer
classe
clavier
client
cligner
climat
clivage
cloche
clonage
cloporte
cobalt
cobra
cocasse
cocotier
coder
codifier
coffre
cogner
cohe\u0301sion
coiffer
coincer
cole\u0300re
colibri
colline
colmater
colonel
combat
come\u0301die
commande
compact
concert
conduire
confier
congeler
connoter
consonne
contact
convexe
copain
copie
corail
corbeau
cordage
corniche
corpus
correct
corte\u0300ge
cosmique
costume
coton
coude
coupure
courage
couteau
couvrir
coyote
crabe
crainte
cravate
crayon
cre\u0301ature
cre\u0301diter
cre\u0301meux
creuser
crevette
cribler
crier
cristal
crite\u0300re
croire
croquer
crotale
crucial
cruel
crypter
cubique
cueillir
cuille\u0300re
cuisine
cuivre
culminer
cultiver
cumuler
cupide
curatif
curseur
cyanure
cycle
cylindre
cynique
daigner
damier
danger
danseur
dauphin
de\u0301battre
de\u0301biter
de\u0301border
de\u0301brider
de\u0301butant
de\u0301caler
de\u0301cembre
de\u0301chirer
de\u0301cider
de\u0301clarer
de\u0301corer
de\u0301crire
de\u0301cupler
de\u0301dale
de\u0301ductif
de\u0301esse
de\u0301fensif
de\u0301filer
de\u0301frayer
de\u0301gager
de\u0301givrer
de\u0301glutir
de\u0301grafer
de\u0301jeuner
de\u0301lice
de\u0301loger
demander
demeurer
de\u0301molir
de\u0301nicher
de\u0301nouer
dentelle
de\u0301nuder
de\u0301part
de\u0301penser
de\u0301phaser
de\u0301placer
de\u0301poser
de\u0301ranger
de\u0301rober
de\u0301sastre
descente
de\u0301sert
de\u0301signer
de\u0301sobe\u0301ir
dessiner
destrier
de\u0301tacher
de\u0301tester
de\u0301tourer
de\u0301tresse
devancer
devenir
deviner
devoir
diable
dialogue
diamant
dicter
diffe\u0301rer
dige\u0301rer
digital
digne
diluer
dimanche
diminuer
dioxyde
directif
diriger
discuter
disposer
dissiper
distance
divertir
diviser
docile
docteur
dogme
doigt
domaine
domicile
dompter
donateur
donjon
donner
dopamine
dortoir
dorure
dosage
doseur
dossier
dotation
douanier
double
douceur
douter
doyen
dragon
draper
dresser
dribbler
droiture
duperie
duplexe
durable
durcir
dynastie
e\u0301blouir
e\u0301carter
e\u0301charpe
e\u0301chelle
e\u0301clairer
e\u0301clipse
e\u0301clore
e\u0301cluse
e\u0301cole
e\u0301conomie
e\u0301corce
e\u0301couter
e\u0301craser
e\u0301cre\u0301mer
e\u0301crivain
e\u0301crou
e\u0301cume
e\u0301cureuil
e\u0301difier
e\u0301duquer
effacer
effectif
effigie
effort
effrayer
effusion
e\u0301galiser
e\u0301garer
e\u0301jecter
e\u0301laborer
e\u0301largir
e\u0301lectron
e\u0301le\u0301gant
e\u0301le\u0301phant
e\u0301le\u0300ve
e\u0301ligible
e\u0301litisme
e\u0301loge
e\u0301lucider
e\u0301luder
emballer
embellir
embryon
e\u0301meraude
e\u0301mission
emmener
e\u0301motion
e\u0301mouvoir
empereur
employer
emporter
emprise
e\u0301mulsion
encadrer
enche\u0300re
enclave
encoche
endiguer
endosser
endroit
enduire
e\u0301nergie
enfance
enfermer
enfouir
engager
engin
englober
e\u0301nigme
enjamber
enjeu
enlever
ennemi
ennuyeux
enrichir
enrobage
enseigne
entasser
entendre
entier
entourer
entraver
e\u0301nume\u0301rer
envahir
enviable
envoyer
enzyme
e\u0301olien
e\u0301paissir
e\u0301pargne
e\u0301patant
e\u0301paule
e\u0301picerie
e\u0301pide\u0301mie
e\u0301pier
e\u0301pilogue
e\u0301pine
e\u0301pisode
e\u0301pitaphe
e\u0301poque
e\u0301preuve
e\u0301prouver
e\u0301puisant
e\u0301querre
e\u0301quipe
e\u0301riger
e\u0301rosion
erreur
e\u0301ruption
escalier
espadon
espe\u0300ce
espie\u0300gle
espoir
esprit
esquiver
essayer
essence
essieu
essorer
estime
estomac
estrade
e\u0301tage\u0300re
e\u0301taler
e\u0301tanche
e\u0301tatique
e\u0301teindre
e\u0301tendoir
e\u0301ternel
e\u0301thanol
e\u0301thique
ethnie
e\u0301tirer
e\u0301toffer
e\u0301toile
e\u0301tonnant
e\u0301tourdir
e\u0301trange
e\u0301troit
e\u0301tude
euphorie
e\u0301valuer
e\u0301vasion
e\u0301ventail
e\u0301vidence
e\u0301viter
e\u0301volutif
e\u0301voquer
exact
exage\u0301rer
exaucer
exceller
excitant
exclusif
excuse
exe\u0301cuter
exemple
exercer
exhaler
exhorter
exigence
exiler
exister
exotique
expe\u0301dier
explorer
exposer
exprimer
exquis
extensif
extraire
exulter
fable
fabuleux
facette
facile
facture
faiblir
falaise
fameux
famille
farceur
farfelu
farine
farouche
fasciner
fatal
fatigue
faucon
fautif
faveur
favori
fe\u0301brile
fe\u0301conder
fe\u0301de\u0301rer
fe\u0301lin
femme
fe\u0301mur
fendoir
fe\u0301odal
fermer
fe\u0301roce
ferveur
festival
feuille
feutre
fe\u0301vrier
fiasco
ficeler
fictif
fide\u0300le
figure
filature
filetage
filie\u0300re
filleul
filmer
filou
filtrer
financer
finir
fiole
firme
fissure
fixer
flairer
flamme
flasque
flatteur
fle\u0301au
fle\u0300che
fleur
flexion
flocon
flore
fluctuer
fluide
fluvial
folie
fonderie
fongible
fontaine
forcer
forgeron
formuler
fortune
fossile
foudre
fouge\u0300re
fouiller
foulure
fourmi
fragile
fraise
franchir
frapper
frayeur
fre\u0301gate
freiner
frelon
fre\u0301mir
fre\u0301ne\u0301sie
fre\u0300re
friable
friction
frisson
frivole
froid
fromage
frontal
frotter
fruit
fugitif
fuite
fureur
furieux
furtif
fusion
futur
gagner
galaxie
galerie
gambader
garantir
gardien
garnir
garrigue
gazelle
gazon
ge\u0301ant
ge\u0301latine
ge\u0301lule
gendarme
ge\u0301ne\u0301ral
ge\u0301nie
genou
gentil
ge\u0301ologie
ge\u0301ome\u0300tre
ge\u0301ranium
germe
gestuel
geyser
gibier
gicler
girafe
givre
glace
glaive
glisser
globe
gloire
glorieux
golfeur
gomme
gonfler
gorge
gorille
goudron
gouffre
goulot
goupille
gourmand
goutte
graduel
graffiti
graine
grand
grappin
gratuit
gravir
grenat
griffure
griller
grimper
grogner
gronder
grotte
groupe
gruger
grutier
gruye\u0300re
gue\u0301pard
guerrier
guide
guimauve
guitare
gustatif
gymnaste
gyrostat
habitude
hachoir
halte
hameau
hangar
hanneton
haricot
harmonie
harpon
hasard
he\u0301lium
he\u0301matome
herbe
he\u0301risson
hermine
he\u0301ron
he\u0301siter
heureux
hiberner
hibou
hilarant
histoire
hiver
homard
hommage
homoge\u0300ne
honneur
honorer
honteux
horde
horizon
horloge
hormone
horrible
houleux
housse
hublot
huileux
humain
humble
humide
humour
hurler
hydromel
hygie\u0300ne
hymne
hypnose
idylle
ignorer
iguane
illicite
illusion
image
imbiber
imiter
immense
immobile
immuable
impact
impe\u0301rial
implorer
imposer
imprimer
imputer
incarner
incendie
incident
incliner
incolore
indexer
indice
inductif
ine\u0301dit
ineptie
inexact
infini
infliger
informer
infusion
inge\u0301rer
inhaler
inhiber
injecter
injure
innocent
inoculer
inonder
inscrire
insecte
insigne
insolite
inspirer
instinct
insulter
intact
intense
intime
intrigue
intuitif
inutile
invasion
inventer
inviter
invoquer
ironique
irradier
irre\u0301el
irriter
isoler
ivoire
ivresse
jaguar
jaillir
jambe
janvier
jardin
jauger
jaune
javelot
jetable
jeton
jeudi
jeunesse
joindre
joncher
jongler
joueur
jouissif
journal
jovial
joyau
joyeux
jubiler
jugement
junior
jupon
juriste
justice
juteux
juve\u0301nile
kayak
kimono
kiosque
label
labial
labourer
lace\u0301rer
lactose
lagune
laine
laisser
laitier
lambeau
lamelle
lampe
lanceur
langage
lanterne
lapin
largeur
larme
laurier
lavabo
lavoir
lecture
le\u0301gal
le\u0301ger
le\u0301gume
lessive
lettre
levier
lexique
le\u0301zard
liasse
libe\u0301rer
libre
licence
licorne
lie\u0300ge
lie\u0300vre
ligature
ligoter
ligue
limer
limite
limonade
limpide
line\u0301aire
lingot
lionceau
liquide
lisie\u0300re
lister
lithium
litige
littoral
livreur
logique
lointain
loisir
lombric
loterie
louer
lourd
loutre
louve
loyal
lubie
lucide
lucratif
lueur
lugubre
luisant
lumie\u0300re
lunaire
lundi
luron
lutter
luxueux
machine
magasin
magenta
magique
maigre
maillon
maintien
mairie
maison
majorer
malaxer
male\u0301fice
malheur
malice
mallette
mammouth
mandater
maniable
manquant
manteau
manuel
marathon
marbre
marchand
mardi
maritime
marqueur
marron
marteler
mascotte
massif
mate\u0301riel
matie\u0300re
matraque
maudire
maussade
mauve
maximal
me\u0301chant
me\u0301connu
me\u0301daille
me\u0301decin
me\u0301diter
me\u0301duse
meilleur
me\u0301lange
me\u0301lodie
membre
me\u0301moire
menacer
mener
menhir
mensonge
mentor
mercredi
me\u0301rite
merle
messager
mesure
me\u0301tal
me\u0301te\u0301ore
me\u0301thode
me\u0301tier
meuble
miauler
microbe
miette
mignon
migrer
milieu
million
mimique
mince
mine\u0301ral
minimal
minorer
minute
miracle
miroiter
missile
mixte
mobile
moderne
moelleux
mondial
moniteur
monnaie
monotone
monstre
montagne
monument
moqueur
morceau
morsure
mortier
moteur
motif
mouche
moufle
moulin
mousson
mouton
mouvant
multiple
munition
muraille
mure\u0300ne
murmure
muscle
muse\u0301um
musicien
mutation
muter
mutuel
myriade
myrtille
myste\u0300re
mythique
nageur
nappe
narquois
narrer
natation
nation
nature
naufrage
nautique
navire
ne\u0301buleux
nectar
ne\u0301faste
ne\u0301gation
ne\u0301gliger
ne\u0301gocier
neige
nerveux
nettoyer
neurone
neutron
neveu
niche
nickel
nitrate
niveau
noble
nocif
nocturne
noirceur
noisette
nomade
nombreux
nommer
normatif
notable
notifier
notoire
nourrir
nouveau
novateur
novembre
novice
nuage
nuancer
nuire
nuisible
nume\u0301ro
nuptial
nuque
nutritif
obe\u0301ir
objectif
obliger
obscur
observer
obstacle
obtenir
obturer
occasion
occuper
oce\u0301an
octobre
octroyer
octupler
oculaire
odeur
odorant
offenser
officier
offrir
ogive
oiseau
oisillon
olfactif
olivier
ombrage
omettre
onctueux
onduler
one\u0301reux
onirique
opale
opaque
ope\u0301rer
opinion
opportun
opprimer
opter
optique
orageux
orange
orbite
ordonner
oreille
organe
orgueil
orifice
ornement
orque
ortie
osciller
osmose
ossature
otarie
ouragan
ourson
outil
outrager
ouvrage
ovation
oxyde
oxyge\u0300ne
ozone
paisible
palace
palmare\u0300s
palourde
palper
panache
panda
pangolin
paniquer
panneau
panorama
pantalon
papaye
papier
papoter
papyrus
paradoxe
parcelle
paresse
parfumer
parler
parole
parrain
parsemer
partager
parure
parvenir
passion
paste\u0300que
paternel
patience
patron
pavillon
pavoiser
payer
paysage
peigne
peintre
pelage
pe\u0301lican
pelle
pelouse
peluche
pendule
pe\u0301ne\u0301trer
pe\u0301nible
pensif
pe\u0301nurie
pe\u0301pite
pe\u0301plum
perdrix
perforer
pe\u0301riode
permuter
perplexe
persil
perte
peser
pe\u0301tale
petit
pe\u0301trir
peuple
pharaon
phobie
phoque
photon
phrase
physique
piano
pictural
pie\u0300ce
pierre
pieuvre
pilote
pinceau
pipette
piquer
pirogue
piscine
piston
pivoter
pixel
pizza
placard
plafond
plaisir
planer
plaque
plastron
plateau
pleurer
plexus
pliage
plomb
plonger
pluie
plumage
pochette
poe\u0301sie
poe\u0300te
pointe
poirier
poisson
poivre
polaire
policier
pollen
polygone
pommade
pompier
ponctuel
ponde\u0301rer
poney
portique
position
posse\u0301der
posture
potager
poteau
potion
pouce
poulain
poumon
pourpre
poussin
pouvoir
prairie
pratique
pre\u0301cieux
pre\u0301dire
pre\u0301fixe
pre\u0301lude
pre\u0301nom
pre\u0301sence
pre\u0301texte
pre\u0301voir
primitif
prince
prison
priver
proble\u0300me
proce\u0301der
prodige
profond
progre\u0300s
proie
projeter
prologue
promener
propre
prospe\u0300re
prote\u0301ger
prouesse
proverbe
prudence
pruneau
psychose
public
puceron
puiser
pulpe
pulsar
punaise
punitif
pupitre
purifier
puzzle
pyramide
quasar
querelle
question
quie\u0301tude
quitter
quotient
racine
raconter
radieux
ragondin
raideur
raisin
ralentir
rallonge
ramasser
rapide
rasage
ratisser
ravager
ravin
rayonner
re\u0301actif
re\u0301agir
re\u0301aliser
re\u0301animer
recevoir
re\u0301citer
re\u0301clamer
re\u0301colter
recruter
reculer
recycler
re\u0301diger
redouter
refaire
re\u0301flexe
re\u0301former
refrain
refuge
re\u0301galien
re\u0301gion
re\u0301glage
re\u0301gulier
re\u0301ite\u0301rer
rejeter
rejouer
relatif
relever
relief
remarque
reme\u0300de
remise
remonter
remplir
remuer
renard
renfort
renifler
renoncer
rentrer
renvoi
replier
reporter
reprise
reptile
requin
re\u0301serve
re\u0301sineux
re\u0301soudre
respect
rester
re\u0301sultat
re\u0301tablir
retenir
re\u0301ticule
retomber
retracer
re\u0301union
re\u0301ussir
revanche
revivre
re\u0301volte
re\u0301vulsif
richesse
rideau
rieur
rigide
rigoler
rincer
riposter
risible
risque
rituel
rival
rivie\u0300re
rocheux
romance
rompre
ronce
rondin
roseau
rosier
rotatif
rotor
rotule
rouge
rouille
rouleau
routine
royaume
ruban
rubis
ruche
ruelle
rugueux
ruiner
ruisseau
ruser
rustique
rythme
sabler
saboter
sabre
sacoche
safari
sagesse
saisir
salade
salive
salon
saluer
samedi
sanction
sanglier
sarcasme
sardine
saturer
saugrenu
saumon
sauter
sauvage
savant
savonner
scalpel
scandale
sce\u0301le\u0301rat
sce\u0301nario
sceptre
sche\u0301ma
science
scinder
score
scrutin
sculpter
se\u0301ance
se\u0301cable
se\u0301cher
secouer
se\u0301cre\u0301ter
se\u0301datif
se\u0301duire
seigneur
se\u0301jour
se\u0301lectif
semaine
sembler
semence
se\u0301minal
se\u0301nateur
sensible
sentence
se\u0301parer
se\u0301quence
serein
sergent
se\u0301rieux
serrure
se\u0301rum
service
se\u0301same
se\u0301vir
sevrage
sextuple
side\u0301ral
sie\u0300cle
sie\u0301ger
siffler
sigle
signal
silence
silicium
simple
since\u0300re
sinistre
siphon
sirop
sismique
situer
skier
social
socle
sodium
soigneux
soldat
soleil
solitude
soluble
sombre
sommeil
somnoler
sonde
songeur
sonnette
sonore
sorcier
sortir
sosie
sottise
soucieux
soudure
souffle
soulever
soupape
source
soutirer
souvenir
spacieux
spatial
spe\u0301cial
sphe\u0300re
spiral
stable
station
sternum
stimulus
stipuler
strict
studieux
stupeur
styliste
sublime
substrat
subtil
subvenir
succe\u0300s
sucre
suffixe
sugge\u0301rer
suiveur
sulfate
superbe
supplier
surface
suricate
surmener
surprise
sursaut
survie
suspect
syllabe
symbole
syme\u0301trie
synapse
syntaxe
syste\u0300me
tabac
tablier
tactile
tailler
talent
talisman
talonner
tambour
tamiser
tangible
tapis
taquiner
tarder
tarif
tartine
tasse
tatami
tatouage
taupe
taureau
taxer
te\u0301moin
temporel
tenaille
tendre
teneur
tenir
tension
terminer
terne
terrible
te\u0301tine
texte
the\u0300me
the\u0301orie
the\u0301rapie
thorax
tibia
tie\u0300de
timide
tirelire
tiroir
tissu
titane
titre
tituber
toboggan
tole\u0301rant
tomate
tonique
tonneau
toponyme
torche
tordre
tornade
torpille
torrent
torse
tortue
totem
toucher
tournage
tousser
toxine
traction
trafic
tragique
trahir
train
trancher
travail
tre\u0300fle
tremper
tre\u0301sor
treuil
triage
tribunal
tricoter
trilogie
triomphe
tripler
triturer
trivial
trombone
tronc
tropical
troupeau
tuile
tulipe
tumulte
tunnel
turbine
tuteur
tutoyer
tuyau
tympan
typhon
typique
tyran
ubuesque
ultime
ultrason
unanime
unifier
union
unique
unitaire
univers
uranium
urbain
urticant
usage
usine
usuel
usure
utile
utopie
vacarme
vaccin
vagabond
vague
vaillant
vaincre
vaisseau
valable
valise
vallon
valve
vampire
vanille
vapeur
varier
vaseux
vassal
vaste
vecteur
vedette
ve\u0301ge\u0301tal
ve\u0301hicule
veinard
ve\u0301loce
vendredi
ve\u0301ne\u0301rer
venger
venimeux
ventouse
verdure
ve\u0301rin
vernir
verrou
verser
vertu
veston
ve\u0301te\u0301ran
ve\u0301tuste
vexant
vexer
viaduc
viande
victoire
vidange
vide\u0301o
vignette
vigueur
vilain
village
vinaigre
violon
vipe\u0300re
virement
virtuose
virus
visage
viseur
vision
visqueux
visuel
vital
vitesse
viticole
vitrine
vivace
vivipare
vocation
voguer
voile
voisin
voiture
volaille
volcan
voltiger
volume
vorace
vortex
voter
vouloir
voyage
voyelle
wagon
xe\u0301non
yacht
ze\u0300bre
ze\u0301nith
zeste
zoologie`,Yl=Tl.split(`
`);var xl=`abaco
abbaglio
abbinato
abete
abisso
abolire
abrasivo
abrogato
accadere
accenno
accusato
acetone
achille
acido
acqua
acre
acrilico
acrobata
acuto
adagio
addebito
addome
adeguato
aderire
adipe
adottare
adulare
affabile
affetto
affisso
affranto
aforisma
afoso
africano
agave
agente
agevole
aggancio
agire
agitare
agonismo
agricolo
agrumeto
aguzzo
alabarda
alato
albatro
alberato
albo
albume
alce
alcolico
alettone
alfa
algebra
aliante
alibi
alimento
allagato
allegro
allievo
allodola
allusivo
almeno
alogeno
alpaca
alpestre
altalena
alterno
alticcio
altrove
alunno
alveolo
alzare
amalgama
amanita
amarena
ambito
ambrato
ameba
america
ametista
amico
ammasso
ammenda
ammirare
ammonito
amore
ampio
ampliare
amuleto
anacardo
anagrafe
analista
anarchia
anatra
anca
ancella
ancora
andare
andrea
anello
angelo
angolare
angusto
anima
annegare
annidato
anno
annuncio
anonimo
anticipo
anzi
apatico
apertura
apode
apparire
appetito
appoggio
approdo
appunto
aprile
arabica
arachide
aragosta
araldica
arancio
aratura
arazzo
arbitro
archivio
ardito
arenile
argento
argine
arguto
aria
armonia
arnese
arredato
arringa
arrosto
arsenico
arso
artefice
arzillo
asciutto
ascolto
asepsi
asettico
asfalto
asino
asola
aspirato
aspro
assaggio
asse
assoluto
assurdo
asta
astenuto
astice
astratto
atavico
ateismo
atomico
atono
attesa
attivare
attorno
attrito
attuale
ausilio
austria
autista
autonomo
autunno
avanzato
avere
avvenire
avviso
avvolgere
azione
azoto
azzimo
azzurro
babele
baccano
bacino
baco
badessa
badilata
bagnato
baita
balcone
baldo
balena
ballata
balzano
bambino
bandire
baraonda
barbaro
barca
baritono
barlume
barocco
basilico
basso
batosta
battuto
baule
bava
bavosa
becco
beffa
belgio
belva
benda
benevole
benigno
benzina
bere
berlina
beta
bibita
bici
bidone
bifido
biga
bilancia
bimbo
binocolo
biologo
bipede
bipolare
birbante
birra
biscotto
bisesto
bisnonno
bisonte
bisturi
bizzarro
blando
blatta
bollito
bonifico
bordo
bosco
botanico
bottino
bozzolo
braccio
bradipo
brama
branca
bravura
bretella
brevetto
brezza
briglia
brillante
brindare
broccolo
brodo
bronzina
brullo
bruno
bubbone
buca
budino
buffone
buio
bulbo
buono
burlone
burrasca
bussola
busta
cadetto
caduco
calamaro
calcolo
calesse
calibro
calmo
caloria
cambusa
camerata
camicia
cammino
camola
campale
canapa
candela
cane
canino
canotto
cantina
capace
capello
capitolo
capogiro
cappero
capra
capsula
carapace
carcassa
cardo
carisma
carovana
carretto
cartolina
casaccio
cascata
caserma
caso
cassone
castello
casuale
catasta
catena
catrame
cauto
cavillo
cedibile
cedrata
cefalo
celebre
cellulare
cena
cenone
centesimo
ceramica
cercare
certo
cerume
cervello
cesoia
cespo
ceto
chela
chiaro
chicca
chiedere
chimera
china
chirurgo
chitarra
ciao
ciclismo
cifrare
cigno
cilindro
ciottolo
circa
cirrosi
citrico
cittadino
ciuffo
civetta
civile
classico
clinica
cloro
cocco
codardo
codice
coerente
cognome
collare
colmato
colore
colposo
coltivato
colza
coma
cometa
commando
comodo
computer
comune
conciso
condurre
conferma
congelare
coniuge
connesso
conoscere
consumo
continuo
convegno
coperto
copione
coppia
copricapo
corazza
cordata
coricato
cornice
corolla
corpo
corredo
corsia
cortese
cosmico
costante
cottura
covato
cratere
cravatta
creato
credere
cremoso
crescita
creta
criceto
crinale
crisi
critico
croce
cronaca
crostata
cruciale
crusca
cucire
cuculo
cugino
cullato
cupola
curatore
cursore
curvo
cuscino
custode
dado
daino
dalmata
damerino
daniela
dannoso
danzare
datato
davanti
davvero
debutto
decennio
deciso
declino
decollo
decreto
dedicato
definito
deforme
degno
delegare
delfino
delirio
delta
demenza
denotato
dentro
deposito
derapata
derivare
deroga
descritto
deserto
desiderio
desumere
detersivo
devoto
diametro
dicembre
diedro
difeso
diffuso
digerire
digitale
diluvio
dinamico
dinnanzi
dipinto
diploma
dipolo
diradare
dire
dirotto
dirupo
disagio
discreto
disfare
disgelo
disposto
distanza
disumano
dito
divano
divelto
dividere
divorato
doblone
docente
doganale
dogma
dolce
domato
domenica
dominare
dondolo
dono
dormire
dote
dottore
dovuto
dozzina
drago
druido
dubbio
dubitare
ducale
duna
duomo
duplice
duraturo
ebano
eccesso
ecco
eclissi
economia
edera
edicola
edile
editoria
educare
egemonia
egli
egoismo
egregio
elaborato
elargire
elegante
elencato
eletto
elevare
elfico
elica
elmo
elsa
eluso
emanato
emblema
emesso
emiro
emotivo
emozione
empirico
emulo
endemico
enduro
energia
enfasi
enoteca
entrare
enzima
epatite
epilogo
episodio
epocale
eppure
equatore
erario
erba
erboso
erede
eremita
erigere
ermetico
eroe
erosivo
errante
esagono
esame
esanime
esaudire
esca
esempio
esercito
esibito
esigente
esistere
esito
esofago
esortato
esoso
espanso
espresso
essenza
esso
esteso
estimare
estonia
estroso
esultare
etilico
etnico
etrusco
etto
euclideo
europa
evaso
evidenza
evitato
evoluto
evviva
fabbrica
faccenda
fachiro
falco
famiglia
fanale
fanfara
fango
fantasma
fare
farfalla
farinoso
farmaco
fascia
fastoso
fasullo
faticare
fato
favoloso
febbre
fecola
fede
fegato
felpa
feltro
femmina
fendere
fenomeno
fermento
ferro
fertile
fessura
festivo
fetta
feudo
fiaba
fiducia
fifa
figurato
filo
finanza
finestra
finire
fiore
fiscale
fisico
fiume
flacone
flamenco
flebo
flemma
florido
fluente
fluoro
fobico
focaccia
focoso
foderato
foglio
folata
folclore
folgore
fondente
fonetico
fonia
fontana
forbito
forchetta
foresta
formica
fornaio
foro
fortezza
forzare
fosfato
fosso
fracasso
frana
frassino
fratello
freccetta
frenata
fresco
frigo
frollino
fronde
frugale
frutta
fucilata
fucsia
fuggente
fulmine
fulvo
fumante
fumetto
fumoso
fune
funzione
fuoco
furbo
furgone
furore
fuso
futile
gabbiano
gaffe
galateo
gallina
galoppo
gambero
gamma
garanzia
garbo
garofano
garzone
gasdotto
gasolio
gastrico
gatto
gaudio
gazebo
gazzella
geco
gelatina
gelso
gemello
gemmato
gene
genitore
gennaio
genotipo
gergo
ghepardo
ghiaccio
ghisa
giallo
gilda
ginepro
giocare
gioiello
giorno
giove
girato
girone
gittata
giudizio
giurato
giusto
globulo
glutine
gnomo
gobba
golf
gomito
gommone
gonfio
gonna
governo
gracile
grado
grafico
grammo
grande
grattare
gravoso
grazia
greca
gregge
grifone
grigio
grinza
grotta
gruppo
guadagno
guaio
guanto
guardare
gufo
guidare
ibernato
icona
identico
idillio
idolo
idra
idrico
idrogeno
igiene
ignaro
ignorato
ilare
illeso
illogico
illudere
imballo
imbevuto
imbocco
imbuto
immane
immerso
immolato
impacco
impeto
impiego
importo
impronta
inalare
inarcare
inattivo
incanto
incendio
inchino
incisivo
incluso
incontro
incrocio
incubo
indagine
india
indole
inedito
infatti
infilare
inflitto
ingaggio
ingegno
inglese
ingordo
ingrosso
innesco
inodore
inoltrare
inondato
insano
insetto
insieme
insonnia
insulina
intasato
intero
intonaco
intuito
inumidire
invalido
invece
invito
iperbole
ipnotico
ipotesi
ippica
iride
irlanda
ironico
irrigato
irrorare
isolato
isotopo
isterico
istituto
istrice
italia
iterare
labbro
labirinto
lacca
lacerato
lacrima
lacuna
laddove
lago
lampo
lancetta
lanterna
lardoso
larga
laringe
lastra
latenza
latino
lattuga
lavagna
lavoro
legale
leggero
lembo
lentezza
lenza
leone
lepre
lesivo
lessato
lesto
letterale
leva
levigato
libero
lido
lievito
lilla
limatura
limitare
limpido
lineare
lingua
liquido
lira
lirica
lisca
lite
litigio
livrea
locanda
lode
logica
lombare
londra
longevo
loquace
lorenzo
loto
lotteria
luce
lucidato
lumaca
luminoso
lungo
lupo
luppolo
lusinga
lusso
lutto
macabro
macchina
macero
macinato
madama
magico
maglia
magnete
magro
maiolica
malafede
malgrado
malinteso
malsano
malto
malumore
mana
mancia
mandorla
mangiare
manifesto
mannaro
manovra
mansarda
mantide
manubrio
mappa
maratona
marcire
maretta
marmo
marsupio
maschera
massaia
mastino
materasso
matricola
mattone
maturo
mazurca
meandro
meccanico
mecenate
medesimo
meditare
mega
melassa
melis
melodia
meninge
meno
mensola
mercurio
merenda
merlo
meschino
mese
messere
mestolo
metallo
metodo
mettere
miagolare
mica
micelio
michele
microbo
midollo
miele
migliore
milano
milite
mimosa
minerale
mini
minore
mirino
mirtillo
miscela
missiva
misto
misurare
mitezza
mitigare
mitra
mittente
mnemonico
modello
modifica
modulo
mogano
mogio
mole
molosso
monastero
monco
mondina
monetario
monile
monotono
monsone
montato
monviso
mora
mordere
morsicato
mostro
motivato
motosega
motto
movenza
movimento
mozzo
mucca
mucosa
muffa
mughetto
mugnaio
mulatto
mulinello
multiplo
mummia
munto
muovere
murale
musa
muscolo
musica
mutevole
muto
nababbo
nafta
nanometro
narciso
narice
narrato
nascere
nastrare
naturale
nautica
naviglio
nebulosa
necrosi
negativo
negozio
nemmeno
neofita
neretto
nervo
nessuno
nettuno
neutrale
neve
nevrotico
nicchia
ninfa
nitido
nobile
nocivo
nodo
nome
nomina
nordico
normale
norvegese
nostrano
notare
notizia
notturno
novella
nucleo
nulla
numero
nuovo
nutrire
nuvola
nuziale
oasi
obbedire
obbligo
obelisco
oblio
obolo
obsoleto
occasione
occhio
occidente
occorrere
occultare
ocra
oculato
odierno
odorare
offerta
offrire
offuscato
oggetto
oggi
ognuno
olandese
olfatto
oliato
oliva
ologramma
oltre
omaggio
ombelico
ombra
omega
omissione
ondoso
onere
onice
onnivoro
onorevole
onta
operato
opinione
opposto
oracolo
orafo
ordine
orecchino
orefice
orfano
organico
origine
orizzonte
orma
ormeggio
ornativo
orologio
orrendo
orribile
ortensia
ortica
orzata
orzo
osare
oscurare
osmosi
ospedale
ospite
ossa
ossidare
ostacolo
oste
otite
otre
ottagono
ottimo
ottobre
ovale
ovest
ovino
oviparo
ovocito
ovunque
ovviare
ozio
pacchetto
pace
pacifico
padella
padrone
paese
paga
pagina
palazzina
palesare
pallido
palo
palude
pandoro
pannello
paolo
paonazzo
paprica
parabola
parcella
parere
pargolo
pari
parlato
parola
partire
parvenza
parziale
passivo
pasticca
patacca
patologia
pattume
pavone
peccato
pedalare
pedonale
peggio
peloso
penare
pendice
penisola
pennuto
penombra
pensare
pentola
pepe
pepita
perbene
percorso
perdonato
perforare
pergamena
periodo
permesso
perno
perplesso
persuaso
pertugio
pervaso
pesatore
pesista
peso
pestifero
petalo
pettine
petulante
pezzo
piacere
pianta
piattino
piccino
picozza
piega
pietra
piffero
pigiama
pigolio
pigro
pila
pilifero
pillola
pilota
pimpante
pineta
pinna
pinolo
pioggia
piombo
piramide
piretico
pirite
pirolisi
pitone
pizzico
placebo
planare
plasma
platano
plenario
pochezza
poderoso
podismo
poesia
poggiare
polenta
poligono
pollice
polmonite
polpetta
polso
poltrona
polvere
pomice
pomodoro
ponte
popoloso
porfido
poroso
porpora
porre
portata
posa
positivo
possesso
postulato
potassio
potere
pranzo
prassi
pratica
precluso
predica
prefisso
pregiato
prelievo
premere
prenotare
preparato
presenza
pretesto
prevalso
prima
principe
privato
problema
procura
produrre
profumo
progetto
prolunga
promessa
pronome
proposta
proroga
proteso
prova
prudente
prugna
prurito
psiche
pubblico
pudica
pugilato
pugno
pulce
pulito
pulsante
puntare
pupazzo
pupilla
puro
quadro
qualcosa
quasi
querela
quota
raccolto
raddoppio
radicale
radunato
raffica
ragazzo
ragione
ragno
ramarro
ramingo
ramo
randagio
rantolare
rapato
rapina
rappreso
rasatura
raschiato
rasente
rassegna
rastrello
rata
ravveduto
reale
recepire
recinto
recluta
recondito
recupero
reddito
redimere
regalato
registro
regola
regresso
relazione
remare
remoto
renna
replica
reprimere
reputare
resa
residente
responso
restauro
rete
retina
retorica
rettifica
revocato
riassunto
ribadire
ribelle
ribrezzo
ricarica
ricco
ricevere
riciclato
ricordo
ricreduto
ridicolo
ridurre
rifasare
riflesso
riforma
rifugio
rigare
rigettato
righello
rilassato
rilevato
rimanere
rimbalzo
rimedio
rimorchio
rinascita
rincaro
rinforzo
rinnovo
rinomato
rinsavito
rintocco
rinuncia
rinvenire
riparato
ripetuto
ripieno
riportare
ripresa
ripulire
risata
rischio
riserva
risibile
riso
rispetto
ristoro
risultato
risvolto
ritardo
ritegno
ritmico
ritrovo
riunione
riva
riverso
rivincita
rivolto
rizoma
roba
robotico
robusto
roccia
roco
rodaggio
rodere
roditore
rogito
rollio
romantico
rompere
ronzio
rosolare
rospo
rotante
rotondo
rotula
rovescio
rubizzo
rubrica
ruga
rullino
rumine
rumoroso
ruolo
rupe
russare
rustico
sabato
sabbiare
sabotato
sagoma
salasso
saldatura
salgemma
salivare
salmone
salone
saltare
saluto
salvo
sapere
sapido
saporito
saraceno
sarcasmo
sarto
sassoso
satellite
satira
satollo
saturno
savana
savio
saziato
sbadiglio
sbalzo
sbancato
sbarra
sbattere
sbavare
sbendare
sbirciare
sbloccato
sbocciato
sbrinare
sbruffone
sbuffare
scabroso
scadenza
scala
scambiare
scandalo
scapola
scarso
scatenare
scavato
scelto
scenico
scettro
scheda
schiena
sciarpa
scienza
scindere
scippo
sciroppo
scivolo
sclerare
scodella
scolpito
scomparto
sconforto
scoprire
scorta
scossone
scozzese
scriba
scrollare
scrutinio
scuderia
scultore
scuola
scuro
scusare
sdebitare
sdoganare
seccatura
secondo
sedano
seggiola
segnalato
segregato
seguito
selciato
selettivo
sella
selvaggio
semaforo
sembrare
seme
seminato
sempre
senso
sentire
sepolto
sequenza
serata
serbato
sereno
serio
serpente
serraglio
servire
sestina
setola
settimana
sfacelo
sfaldare
sfamato
sfarzoso
sfaticato
sfera
sfida
sfilato
sfinge
sfocato
sfoderare
sfogo
sfoltire
sforzato
sfratto
sfruttato
sfuggito
sfumare
sfuso
sgabello
sgarbato
sgonfiare
sgorbio
sgrassato
sguardo
sibilo
siccome
sierra
sigla
signore
silenzio
sillaba
simbolo
simpatico
simulato
sinfonia
singolo
sinistro
sino
sintesi
sinusoide
sipario
sisma
sistole
situato
slitta
slogatura
sloveno
smarrito
smemorato
smentito
smeraldo
smilzo
smontare
smottato
smussato
snellire
snervato
snodo
sobbalzo
sobrio
soccorso
sociale
sodale
soffitto
sogno
soldato
solenne
solido
sollazzo
solo
solubile
solvente
somatico
somma
sonda
sonetto
sonnifero
sopire
soppeso
sopra
sorgere
sorpasso
sorriso
sorso
sorteggio
sorvolato
sospiro
sosta
sottile
spada
spalla
spargere
spatola
spavento
spazzola
specie
spedire
spegnere
spelatura
speranza
spessore
spettrale
spezzato
spia
spigoloso
spillato
spinoso
spirale
splendido
sportivo
sposo
spranga
sprecare
spronato
spruzzo
spuntino
squillo
sradicare
srotolato
stabile
stacco
staffa
stagnare
stampato
stantio
starnuto
stasera
statuto
stelo
steppa
sterzo
stiletto
stima
stirpe
stivale
stizzoso
stonato
storico
strappo
stregato
stridulo
strozzare
strutto
stuccare
stufo
stupendo
subentro
succoso
sudore
suggerito
sugo
sultano
suonare
superbo
supporto
surgelato
surrogato
sussurro
sutura
svagare
svedese
sveglio
svelare
svenuto
svezia
sviluppo
svista
svizzera
svolta
svuotare
tabacco
tabulato
tacciare
taciturno
tale
talismano
tampone
tannino
tara
tardivo
targato
tariffa
tarpare
tartaruga
tasto
tattico
taverna
tavolata
tazza
teca
tecnico
telefono
temerario
tempo
temuto
tendone
tenero
tensione
tentacolo
teorema
terme
terrazzo
terzetto
tesi
tesserato
testato
tetro
tettoia
tifare
tigella
timbro
tinto
tipico
tipografo
tiraggio
tiro
titanio
titolo
titubante
tizio
tizzone
toccare
tollerare
tolto
tombola
tomo
tonfo
tonsilla
topazio
topologia
toppa
torba
tornare
torrone
tortora
toscano
tossire
tostatura
totano
trabocco
trachea
trafila
tragedia
tralcio
tramonto
transito
trapano
trarre
trasloco
trattato
trave
treccia
tremolio
trespolo
tributo
tricheco
trifoglio
trillo
trincea
trio
tristezza
triturato
trivella
tromba
trono
troppo
trottola
trovare
truccato
tubatura
tuffato
tulipano
tumulto
tunisia
turbare
turchino
tuta
tutela
ubicato
uccello
uccisore
udire
uditivo
uffa
ufficio
uguale
ulisse
ultimato
umano
umile
umorismo
uncinetto
ungere
ungherese
unicorno
unificato
unisono
unitario
unte
uovo
upupa
uragano
urgenza
urlo
usanza
usato
uscito
usignolo
usuraio
utensile
utilizzo
utopia
vacante
vaccinato
vagabondo
vagliato
valanga
valgo
valico
valletta
valoroso
valutare
valvola
vampata
vangare
vanitoso
vano
vantaggio
vanvera
vapore
varano
varcato
variante
vasca
vedetta
vedova
veduto
vegetale
veicolo
velcro
velina
velluto
veloce
venato
vendemmia
vento
verace
verbale
vergogna
verifica
vero
verruca
verticale
vescica
vessillo
vestale
veterano
vetrina
vetusto
viandante
vibrante
vicenda
vichingo
vicinanza
vidimare
vigilia
vigneto
vigore
vile
villano
vimini
vincitore
viola
vipera
virgola
virologo
virulento
viscoso
visione
vispo
vissuto
visura
vita
vitello
vittima
vivanda
vivido
viziare
voce
voga
volatile
volere
volpe
voragine
vulcano
zampogna
zanna
zappato
zattera
zavorra
zefiro
zelante
zelo
zenzero
zerbino
zibetto
zinco
zircone
zitto
zolla
zotico
zucchero
zufolo
zulu
zuppa`,Ol=xl.split(`
`);var Rl=`\u3042\u3044\u3053\u304F\u3057\u3093
\u3042\u3044\u3055\u3064
\u3042\u3044\u305F\u3099
\u3042\u304A\u305D\u3099\u3089
\u3042\u304B\u3061\u3083\u3093
\u3042\u304D\u308B
\u3042\u3051\u304B\u3099\u305F
\u3042\u3051\u308B
\u3042\u3053\u304B\u3099\u308C\u308B
\u3042\u3055\u3044
\u3042\u3055\u3072
\u3042\u3057\u3042\u3068
\u3042\u3057\u3099\u308F\u3046
\u3042\u3059\u3099\u304B\u308B
\u3042\u3059\u3099\u304D
\u3042\u305D\u3075\u3099
\u3042\u305F\u3048\u308B
\u3042\u305F\u305F\u3081\u308B
\u3042\u305F\u308A\u307E\u3048
\u3042\u305F\u308B
\u3042\u3064\u3044
\u3042\u3064\u304B\u3046
\u3042\u3063\u3057\u3085\u304F
\u3042\u3064\u307E\u308A
\u3042\u3064\u3081\u308B
\u3042\u3066\u306A
\u3042\u3066\u306F\u307E\u308B
\u3042\u3072\u308B
\u3042\u3075\u3099\u3089
\u3042\u3075\u3099\u308B
\u3042\u3075\u308C\u308B
\u3042\u307E\u3044
\u3042\u307E\u3068\u3099
\u3042\u307E\u3084\u304B\u3059
\u3042\u307E\u308A
\u3042\u307F\u3082\u306E
\u3042\u3081\u308A\u304B
\u3042\u3084\u307E\u308B
\u3042\u3086\u3080
\u3042\u3089\u3044\u304F\u3099\u307E
\u3042\u3089\u3057
\u3042\u3089\u3059\u3057\u3099
\u3042\u3089\u305F\u3081\u308B
\u3042\u3089\u3086\u308B
\u3042\u3089\u308F\u3059
\u3042\u308A\u304B\u3099\u3068\u3046
\u3042\u308F\u305B\u308B
\u3042\u308F\u3066\u308B
\u3042\u3093\u3044
\u3042\u3093\u304B\u3099\u3044
\u3042\u3093\u3053
\u3042\u3093\u305B\u3099\u3093
\u3042\u3093\u3066\u3044
\u3042\u3093\u306A\u3044
\u3042\u3093\u307E\u308A
\u3044\u3044\u305F\u3099\u3059
\u3044\u304A\u3093
\u3044\u304B\u3099\u3044
\u3044\u304B\u3099\u304F
\u3044\u304D\u304A\u3044
\u3044\u304D\u306A\u308A
\u3044\u304D\u3082\u306E
\u3044\u304D\u308B
\u3044\u304F\u3057\u3099
\u3044\u304F\u3075\u3099\u3093
\u3044\u3051\u306F\u3099\u306A
\u3044\u3051\u3093
\u3044\u3053\u3046
\u3044\u3053\u304F
\u3044\u3053\u3064
\u3044\u3055\u307E\u3057\u3044
\u3044\u3055\u3093
\u3044\u3057\u304D
\u3044\u3057\u3099\u3085\u3046
\u3044\u3057\u3099\u3087\u3046
\u3044\u3057\u3099\u308F\u308B
\u3044\u3059\u3099\u307F
\u3044\u3059\u3099\u308C
\u3044\u305B\u3044
\u3044\u305B\u3048\u3072\u3099
\u3044\u305B\u304B\u3044
\u3044\u305B\u304D
\u3044\u305B\u3099\u3093
\u3044\u305D\u3046\u308D\u3046
\u3044\u305D\u304B\u3099\u3057\u3044
\u3044\u305F\u3099\u3044
\u3044\u305F\u3099\u304F
\u3044\u305F\u3059\u3099\u3089
\u3044\u305F\u307F
\u3044\u305F\u308A\u3042
\u3044\u3061\u304A\u3046
\u3044\u3061\u3057\u3099
\u3044\u3061\u3068\u3099
\u3044\u3061\u306F\u3099
\u3044\u3061\u3075\u3099
\u3044\u3061\u308A\u3085\u3046
\u3044\u3064\u304B
\u3044\u3063\u3057\u3085\u3093
\u3044\u3063\u305B\u3044
\u3044\u3063\u305D\u3046
\u3044\u3063\u305F\u3093
\u3044\u3063\u3061
\u3044\u3063\u3066\u3044
\u3044\u3063\u307B\u309A\u3046
\u3044\u3066\u3055\u3099
\u3044\u3066\u3093
\u3044\u3068\u3099\u3046
\u3044\u3068\u3053
\u3044\u306A\u3044
\u3044\u306A\u304B
\u3044\u306D\u3080\u308A
\u3044\u306E\u3061
\u3044\u306E\u308B
\u3044\u306F\u3064
\u3044\u306F\u3099\u308B
\u3044\u306F\u3093
\u3044\u3072\u3099\u304D
\u3044\u3072\u3093
\u3044\u3075\u304F
\u3044\u3078\u3093
\u3044\u307B\u3046
\u3044\u307F\u3093
\u3044\u3082\u3046\u3068
\u3044\u3082\u305F\u308C
\u3044\u3082\u308A
\u3044\u3084\u304B\u3099\u308B
\u3044\u3084\u3059
\u3044\u3088\u304B\u3093
\u3044\u3088\u304F
\u3044\u3089\u3044
\u3044\u3089\u3059\u3068
\u3044\u308A\u304F\u3099\u3061
\u3044\u308A\u3087\u3046
\u3044\u308C\u3044
\u3044\u308C\u3082\u306E
\u3044\u308C\u308B
\u3044\u308D\u3048\u3093\u3072\u309A\u3064
\u3044\u308F\u3044
\u3044\u308F\u3046
\u3044\u308F\u304B\u3093
\u3044\u308F\u306F\u3099
\u3044\u308F\u3086\u308B
\u3044\u3093\u3051\u3099\u3093\u307E\u3081
\u3044\u3093\u3055\u3064
\u3044\u3093\u3057\u3087\u3046
\u3044\u3093\u3088\u3046
\u3046\u3048\u304D
\u3046\u3048\u308B
\u3046\u304A\u3055\u3099
\u3046\u304B\u3099\u3044
\u3046\u304B\u3075\u3099
\u3046\u304B\u3078\u3099\u308B
\u3046\u304D\u308F
\u3046\u304F\u3089\u3044\u306A
\u3046\u304F\u308C\u308C
\u3046\u3051\u305F\u307E\u308F\u308B
\u3046\u3051\u3064\u3051
\u3046\u3051\u3068\u308B
\u3046\u3051\u3082\u3064
\u3046\u3051\u308B
\u3046\u3053\u3099\u304B\u3059
\u3046\u3053\u3099\u304F
\u3046\u3053\u3093
\u3046\u3055\u304D\u3099
\u3046\u3057\u306A\u3046
\u3046\u3057\u308D\u304B\u3099\u307F
\u3046\u3059\u3044
\u3046\u3059\u304D\u3099
\u3046\u3059\u304F\u3099\u3089\u3044
\u3046\u3059\u3081\u308B
\u3046\u305B\u3064
\u3046\u3061\u3042\u308F\u305B
\u3046\u3061\u304B\u3099\u308F
\u3046\u3061\u304D
\u3046\u3061\u3085\u3046
\u3046\u3063\u304B\u308A
\u3046\u3064\u304F\u3057\u3044
\u3046\u3063\u305F\u3048\u308B
\u3046\u3064\u308B
\u3046\u3068\u3099\u3093
\u3046\u306A\u304D\u3099
\u3046\u306A\u3057\u3099
\u3046\u306A\u3059\u3099\u304F
\u3046\u306A\u308B
\u3046\u306D\u308B
\u3046\u306E\u3046
\u3046\u3075\u3099\u3051\u3099
\u3046\u3075\u3099\u3053\u3099\u3048
\u3046\u307E\u308C\u308B
\u3046\u3081\u308B
\u3046\u3082\u3046
\u3046\u3084\u307E\u3046
\u3046\u3088\u304F
\u3046\u3089\u304B\u3099\u3048\u3059
\u3046\u3089\u304F\u3099\u3061
\u3046\u3089\u306A\u3044
\u3046\u308A\u3042\u3051\u3099
\u3046\u308A\u304D\u308C
\u3046\u308B\u3055\u3044
\u3046\u308C\u3057\u3044
\u3046\u308C\u3086\u304D
\u3046\u308C\u308B
\u3046\u308D\u3053
\u3046\u308F\u304D
\u3046\u308F\u3055
\u3046\u3093\u3053\u3046
\u3046\u3093\u3061\u3093
\u3046\u3093\u3066\u3093
\u3046\u3093\u3068\u3099\u3046
\u3048\u3044\u3048\u3093
\u3048\u3044\u304B\u3099
\u3048\u3044\u304D\u3087\u3046
\u3048\u3044\u3053\u3099
\u3048\u3044\u305B\u3044
\u3048\u3044\u3075\u3099\u3093
\u3048\u3044\u3088\u3046
\u3048\u3044\u308F
\u3048\u304A\u308A
\u3048\u304B\u3099\u304A
\u3048\u304B\u3099\u304F
\u3048\u304D\u305F\u3044
\u3048\u304F\u305B\u308B
\u3048\u3057\u3083\u304F
\u3048\u3059\u3066
\u3048\u3064\u3089\u3093
\u3048\u306E\u304F\u3099
\u3048\u307B\u3046\u307E\u304D
\u3048\u307B\u3093
\u3048\u307E\u304D
\u3048\u3082\u3057\u3099
\u3048\u3082\u306E
\u3048\u3089\u3044
\u3048\u3089\u3075\u3099
\u3048\u308A\u3042
\u3048\u3093\u3048\u3093
\u3048\u3093\u304B\u3044
\u3048\u3093\u304D\u3099
\u3048\u3093\u3051\u3099\u304D
\u3048\u3093\u3057\u3085\u3046
\u3048\u3093\u305B\u3099\u3064
\u3048\u3093\u305D\u304F
\u3048\u3093\u3061\u3087\u3046
\u3048\u3093\u3068\u3064
\u304A\u3044\u304B\u3051\u308B
\u304A\u3044\u3053\u3059
\u304A\u3044\u3057\u3044
\u304A\u3044\u3064\u304F
\u304A\u3046\u3048\u3093
\u304A\u3046\u3055\u307E
\u304A\u3046\u3057\u3099
\u304A\u3046\u305B\u3064
\u304A\u3046\u305F\u3044
\u304A\u3046\u3075\u304F
\u304A\u3046\u3078\u3099\u3044
\u304A\u3046\u3088\u3046
\u304A\u3048\u308B
\u304A\u304A\u3044
\u304A\u304A\u3046
\u304A\u304A\u3068\u3099\u304A\u308A
\u304A\u304A\u3084
\u304A\u304A\u3088\u305D
\u304A\u304B\u3048\u308A
\u304A\u304B\u3059\u3099
\u304A\u304B\u3099\u3080
\u304A\u304B\u308F\u308A
\u304A\u304D\u3099\u306A\u3046
\u304A\u304D\u308B
\u304A\u304F\u3055\u307E
\u304A\u304F\u3057\u3099\u3087\u3046
\u304A\u304F\u308A\u304B\u3099\u306A
\u304A\u304F\u308B
\u304A\u304F\u308C\u308B
\u304A\u3053\u3059
\u304A\u3053\u306A\u3046
\u304A\u3053\u308B
\u304A\u3055\u3048\u308B
\u304A\u3055\u306A\u3044
\u304A\u3055\u3081\u308B
\u304A\u3057\u3044\u308C
\u304A\u3057\u3048\u308B
\u304A\u3057\u3099\u304D\u3099
\u304A\u3057\u3099\u3055\u3093
\u304A\u3057\u3083\u308C
\u304A\u305D\u3089\u304F
\u304A\u305D\u308F\u308B
\u304A\u305F\u304B\u3099\u3044
\u304A\u305F\u304F
\u304A\u305F\u3099\u3084\u304B
\u304A\u3061\u3064\u304F
\u304A\u3063\u3068
\u304A\u3064\u308A
\u304A\u3066\u3099\u304B\u3051
\u304A\u3068\u3057\u3082\u306E
\u304A\u3068\u306A\u3057\u3044
\u304A\u3068\u3099\u308A
\u304A\u3068\u3099\u308D\u304B\u3059
\u304A\u306F\u3099\u3055\u3093
\u304A\u307E\u3044\u308A
\u304A\u3081\u3066\u3099\u3068\u3046
\u304A\u3082\u3044\u3066\u3099
\u304A\u3082\u3046
\u304A\u3082\u305F\u3044
\u304A\u3082\u3061\u3083
\u304A\u3084\u3064
\u304A\u3084\u3086\u3072\u3099
\u304A\u3088\u307B\u3099\u3059
\u304A\u3089\u3093\u305F\u3099
\u304A\u308D\u3059
\u304A\u3093\u304B\u3099\u304F
\u304A\u3093\u3051\u3044
\u304A\u3093\u3057\u3083
\u304A\u3093\u305B\u3093
\u304A\u3093\u305F\u3099\u3093
\u304A\u3093\u3061\u3085\u3046
\u304A\u3093\u3068\u3099\u3051\u3044
\u304B\u3042\u3064
\u304B\u3044\u304B\u3099
\u304B\u3099\u3044\u304D
\u304B\u3099\u3044\u3051\u3093
\u304B\u3099\u3044\u3053\u3046
\u304B\u3044\u3055\u3064
\u304B\u3044\u3057\u3083
\u304B\u3044\u3059\u3044\u3088\u304F
\u304B\u3044\u305B\u3099\u3093
\u304B\u3044\u305D\u3099\u3046\u3068\u3099
\u304B\u3044\u3064\u3046
\u304B\u3044\u3066\u3093
\u304B\u3044\u3068\u3046
\u304B\u3044\u3075\u304F
\u304B\u3099\u3044\u3078\u304D
\u304B\u3044\u307B\u3046
\u304B\u3044\u3088\u3046
\u304B\u3099\u3044\u3089\u3044
\u304B\u3044\u308F
\u304B\u3048\u308B
\u304B\u304A\u308A
\u304B\u304B\u3048\u308B
\u304B\u304B\u3099\u304F
\u304B\u304B\u3099\u3057
\u304B\u304B\u3099\u307F
\u304B\u304F\u3053\u3099
\u304B\u304F\u3068\u304F
\u304B\u3055\u3099\u308B
\u304B\u3099\u305D\u3099\u3046
\u304B\u305F\u3044
\u304B\u305F\u3061
\u304B\u3099\u3061\u3087\u3046
\u304B\u3099\u3063\u304D\u3085\u3046
\u304B\u3099\u3063\u3053\u3046
\u304B\u3099\u3063\u3055\u3093
\u304B\u3099\u3063\u3057\u3087\u3046
\u304B\u306A\u3055\u3099\u308F\u3057
\u304B\u306E\u3046
\u304B\u3099\u306F\u304F
\u304B\u3075\u3099\u304B
\u304B\u307B\u3046
\u304B\u307B\u3053\u3099
\u304B\u307E\u3046
\u304B\u307E\u307B\u3099\u3053
\u304B\u3081\u308C\u304A\u3093
\u304B\u3086\u3044
\u304B\u3088\u3046\u3072\u3099
\u304B\u3089\u3044
\u304B\u308B\u3044
\u304B\u308D\u3046
\u304B\u308F\u304F
\u304B\u308F\u3089
\u304B\u3099\u3093\u304B
\u304B\u3093\u3051\u3044
\u304B\u3093\u3053\u3046
\u304B\u3093\u3057\u3083
\u304B\u3093\u305D\u3046
\u304B\u3093\u305F\u3093
\u304B\u3093\u3061
\u304B\u3099\u3093\u306F\u3099\u308B
\u304D\u3042\u3044
\u304D\u3042\u3064
\u304D\u3044\u308D
\u304D\u3099\u3044\u3093
\u304D\u3046\u3044
\u304D\u3046\u3093
\u304D\u3048\u308B
\u304D\u304A\u3046
\u304D\u304A\u304F
\u304D\u304A\u3061
\u304D\u304A\u3093
\u304D\u304B\u3044
\u304D\u304B\u304F
\u304D\u304B\u3093\u3057\u3083
\u304D\u304D\u3066
\u304D\u304F\u306F\u3099\u308A
\u304D\u304F\u3089\u3051\u3099
\u304D\u3051\u3093\u305B\u3044
\u304D\u3053\u3046
\u304D\u3053\u3048\u308B
\u304D\u3053\u304F
\u304D\u3055\u3044
\u304D\u3055\u304F
\u304D\u3055\u307E
\u304D\u3055\u3089\u304D\u3099
\u304D\u3099\u3057\u3099\u304B\u304B\u3099\u304F
\u304D\u3099\u3057\u304D
\u304D\u3099\u3057\u3099\u305F\u3044\u3051\u3093
\u304D\u3099\u3057\u3099\u306B\u3063\u3066\u3044
\u304D\u3099\u3057\u3099\u3085\u3064\u3057\u3083
\u304D\u3059\u3046
\u304D\u305B\u3044
\u304D\u305B\u304D
\u304D\u305B\u3064
\u304D\u305D\u3046
\u304D\u305D\u3099\u304F
\u304D\u305D\u3099\u3093
\u304D\u305F\u3048\u308B
\u304D\u3061\u3087\u3046
\u304D\u3064\u3048\u3093
\u304D\u3099\u3063\u3061\u308A
\u304D\u3064\u3064\u304D
\u304D\u3064\u306D
\u304D\u3066\u3044
\u304D\u3068\u3099\u3046
\u304D\u3068\u3099\u304F
\u304D\u306A\u3044
\u304D\u306A\u304B\u3099
\u304D\u306A\u3053
\u304D\u306C\u3053\u3099\u3057
\u304D\u306D\u3093
\u304D\u306E\u3046
\u304D\u306E\u3057\u305F
\u304D\u306F\u304F
\u304D\u3072\u3099\u3057\u3044
\u304D\u3072\u3093
\u304D\u3075\u304F
\u304D\u3075\u3099\u3093
\u304D\u307B\u3099\u3046
\u304D\u307B\u3093
\u304D\u307E\u308B
\u304D\u307F\u3064
\u304D\u3080\u3059\u3099\u304B\u3057\u3044
\u304D\u3081\u308B
\u304D\u3082\u305F\u3099\u3081\u3057
\u304D\u3082\u3061
\u304D\u3082\u306E
\u304D\u3083\u304F
\u304D\u3084\u304F
\u304D\u3099\u3085\u3046\u306B\u304F
\u304D\u3088\u3046
\u304D\u3087\u3046\u308A\u3085\u3046
\u304D\u3089\u3044
\u304D\u3089\u304F
\u304D\u308A\u3093
\u304D\u308C\u3044
\u304D\u308C\u3064
\u304D\u308D\u304F
\u304D\u3099\u308D\u3093
\u304D\u308F\u3081\u308B
\u304D\u3099\u3093\u3044\u308D
\u304D\u3093\u304B\u304F\u3057\u3099
\u304D\u3093\u3057\u3099\u3087
\u304D\u3093\u3088\u3046\u3072\u3099
\u304F\u3099\u3042\u3044
\u304F\u3044\u3059\u3099
\u304F\u3046\u304B\u3093
\u304F\u3046\u304D
\u304F\u3046\u304F\u3099\u3093
\u304F\u3046\u3053\u3046
\u304F\u3099\u3046\u305B\u3044
\u304F\u3046\u305D\u3046
\u304F\u3099\u3046\u305F\u3089
\u304F\u3046\u3075\u304F
\u304F\u3046\u307B\u3099
\u304F\u304B\u3093
\u304F\u304D\u3087\u3046
\u304F\u3051\u3099\u3093
\u304F\u3099\u3053\u3046
\u304F\u3055\u3044
\u304F\u3055\u304D
\u304F\u3055\u306F\u3099\u306A
\u304F\u3055\u308B
\u304F\u3057\u3083\u307F
\u304F\u3057\u3087\u3046
\u304F\u3059\u306E\u304D
\u304F\u3059\u308A\u3086\u3072\u3099
\u304F\u305B\u3051\u3099
\u304F\u305B\u3093
\u304F\u3099\u305F\u3044\u3066\u304D
\u304F\u305F\u3099\u3055\u308B
\u304F\u305F\u3072\u3099\u308C\u308B
\u304F\u3061\u3053\u307F
\u304F\u3061\u3055\u304D
\u304F\u3064\u3057\u305F
\u304F\u3099\u3063\u3059\u308A
\u304F\u3064\u308D\u304F\u3099
\u304F\u3068\u3046\u3066\u3093
\u304F\u3068\u3099\u304F
\u304F\u306A\u3093
\u304F\u306D\u304F\u306D
\u304F\u306E\u3046
\u304F\u3075\u3046
\u304F\u307F\u3042\u308F\u305B
\u304F\u307F\u305F\u3066\u308B
\u304F\u3081\u308B
\u304F\u3084\u304F\u3057\u3087
\u304F\u3089\u3059
\u304F\u3089\u3078\u3099\u308B
\u304F\u308B\u307E
\u304F\u308C\u308B
\u304F\u308D\u3046
\u304F\u308F\u3057\u3044
\u304F\u3099\u3093\u304B\u3093
\u304F\u3099\u3093\u3057\u3087\u304F
\u304F\u3099\u3093\u305F\u3044
\u304F\u3099\u3093\u3066
\u3051\u3042\u306A
\u3051\u3044\u304B\u304F
\u3051\u3044\u3051\u3093
\u3051\u3044\u3053
\u3051\u3044\u3055\u3064
\u3051\u3099\u3044\u3057\u3099\u3085\u3064
\u3051\u3044\u305F\u3044
\u3051\u3099\u3044\u306E\u3046\u3057\u3099\u3093
\u3051\u3044\u308C\u304D
\u3051\u3044\u308D
\u3051\u304A\u3068\u3059
\u3051\u304A\u308A\u3082\u306E
\u3051\u3099\u304D\u304B
\u3051\u3099\u304D\u3051\u3099\u3093
\u3051\u3099\u304D\u305F\u3099\u3093
\u3051\u3099\u304D\u3061\u3093
\u3051\u3099\u304D\u3068\u3064
\u3051\u3099\u304D\u306F
\u3051\u3099\u304D\u3084\u304F
\u3051\u3099\u3053\u3046
\u3051\u3099\u3053\u304F\u3057\u3099\u3087\u3046
\u3051\u3099\u3055\u3099\u3044
\u3051\u3055\u304D
\u3051\u3099\u3055\u3099\u3093
\u3051\u3057\u304D
\u3051\u3057\u3053\u3099\u3080
\u3051\u3057\u3087\u3046
\u3051\u3099\u3059\u3068
\u3051\u305F\u306F\u3099
\u3051\u3061\u3083\u3063\u3075\u309A
\u3051\u3061\u3089\u3059
\u3051\u3064\u3042\u3064
\u3051\u3064\u3044
\u3051\u3064\u3048\u304D
\u3051\u3063\u3053\u3093
\u3051\u3064\u3057\u3099\u3087
\u3051\u3063\u305B\u304D
\u3051\u3063\u3066\u3044
\u3051\u3064\u307E\u3064
\u3051\u3099\u3064\u3088\u3046\u3072\u3099
\u3051\u3099\u3064\u308C\u3044
\u3051\u3064\u308D\u3093
\u3051\u3099\u3068\u3099\u304F
\u3051\u3068\u306F\u3099\u3059
\u3051\u3068\u308B
\u3051\u306A\u3051\u3099
\u3051\u306A\u3059
\u3051\u306A\u307F
\u3051\u306C\u304D
\u3051\u3099\u306D\u3064
\u3051\u306D\u3093
\u3051\u306F\u3044
\u3051\u3099\u3072\u3093
\u3051\u3075\u3099\u304B\u3044
\u3051\u3099\u307B\u3099\u304F
\u3051\u307E\u308A
\u3051\u307F\u304B\u308B
\u3051\u3080\u3057
\u3051\u3080\u308A
\u3051\u3082\u306E
\u3051\u3089\u3044
\u3051\u308D\u3051\u308D
\u3051\u308F\u3057\u3044
\u3051\u3093\u3044
\u3051\u3093\u3048\u3064
\u3051\u3093\u304A
\u3051\u3093\u304B
\u3051\u3099\u3093\u304D
\u3051\u3093\u3051\u3099\u3093
\u3051\u3093\u3053\u3046
\u3051\u3093\u3055\u304F
\u3051\u3093\u3057\u3085\u3046
\u3051\u3093\u3059\u3046
\u3051\u3099\u3093\u305D\u3046
\u3051\u3093\u3061\u304F
\u3051\u3093\u3066\u3044
\u3051\u3093\u3068\u3046
\u3051\u3093\u306A\u3044
\u3051\u3093\u306B\u3093
\u3051\u3099\u3093\u3075\u3099\u3064
\u3051\u3093\u307E
\u3051\u3093\u307F\u3093
\u3051\u3093\u3081\u3044
\u3051\u3093\u3089\u3093
\u3051\u3093\u308A
\u3053\u3042\u304F\u307E
\u3053\u3044\u306C
\u3053\u3044\u3072\u3099\u3068
\u3053\u3099\u3046\u3044
\u3053\u3046\u3048\u3093
\u3053\u3046\u304A\u3093
\u3053\u3046\u304B\u3093
\u3053\u3099\u3046\u304D\u3085\u3046
\u3053\u3099\u3046\u3051\u3044
\u3053\u3046\u3053\u3046
\u3053\u3046\u3055\u3044
\u3053\u3046\u3057\u3099
\u3053\u3046\u3059\u3044
\u3053\u3099\u3046\u305B\u3044
\u3053\u3046\u305D\u304F
\u3053\u3046\u305F\u3044
\u3053\u3046\u3061\u3083
\u3053\u3046\u3064\u3046
\u3053\u3046\u3066\u3044
\u3053\u3046\u3068\u3099\u3046
\u3053\u3046\u306A\u3044
\u3053\u3046\u306F\u3044
\u3053\u3099\u3046\u307B\u3046
\u3053\u3099\u3046\u307E\u3093
\u3053\u3046\u3082\u304F
\u3053\u3046\u308A\u3064
\u3053\u3048\u308B
\u3053\u304A\u308A
\u3053\u3099\u304B\u3044
\u3053\u3099\u304B\u3099\u3064
\u3053\u3099\u304B\u3093
\u3053\u304F\u3053\u3099
\u3053\u304F\u3055\u3044
\u3053\u304F\u3068\u3046
\u3053\u304F\u306A\u3044
\u3053\u304F\u306F\u304F
\u3053\u304F\u3099\u307E
\u3053\u3051\u3044
\u3053\u3051\u308B
\u3053\u3053\u306E\u304B
\u3053\u3053\u308D
\u3053\u3055\u3081
\u3053\u3057\u3064
\u3053\u3059\u3046
\u3053\u305B\u3044
\u3053\u305B\u304D
\u3053\u305B\u3099\u3093
\u3053\u305D\u305F\u3099\u3066
\u3053\u305F\u3044
\u3053\u305F\u3048\u308B
\u3053\u305F\u3064
\u3053\u3061\u3087\u3046
\u3053\u3063\u304B
\u3053\u3064\u3053\u3064
\u3053\u3064\u306F\u3099\u3093
\u3053\u3064\u3075\u3099
\u3053\u3066\u3044
\u3053\u3066\u3093
\u3053\u3068\u304B\u3099\u3089
\u3053\u3068\u3057
\u3053\u3068\u306F\u3099
\u3053\u3068\u308A
\u3053\u306A\u3053\u3099\u306A
\u3053\u306D\u3053\u306D
\u3053\u306E\u307E\u307E
\u3053\u306E\u307F
\u3053\u306E\u3088
\u3053\u3099\u306F\u3093
\u3053\u3072\u3064\u3057\u3099
\u3053\u3075\u3046
\u3053\u3075\u3093
\u3053\u307B\u3099\u308C\u308B
\u3053\u3099\u307E\u3042\u3075\u3099\u3089
\u3053\u307E\u304B\u3044
\u3053\u3099\u307E\u3059\u308A
\u3053\u307E\u3064\u306A
\u3053\u307E\u308B
\u3053\u3080\u304D\u3099\u3053
\u3053\u3082\u3057\u3099
\u3053\u3082\u3061
\u3053\u3082\u306E
\u3053\u3082\u3093
\u3053\u3084\u304F
\u3053\u3084\u307E
\u3053\u3086\u3046
\u3053\u3086\u3072\u3099
\u3053\u3088\u3044
\u3053\u3088\u3046
\u3053\u308A\u308B
\u3053\u308C\u304F\u3057\u3087\u3093
\u3053\u308D\u3063\u3051
\u3053\u308F\u3082\u3066
\u3053\u308F\u308C\u308B
\u3053\u3093\u3044\u3093
\u3053\u3093\u304B\u3044
\u3053\u3093\u304D
\u3053\u3093\u3057\u3085\u3046
\u3053\u3093\u3059\u3044
\u3053\u3093\u305F\u3099\u3066
\u3053\u3093\u3068\u3093
\u3053\u3093\u306A\u3093
\u3053\u3093\u3072\u3099\u306B
\u3053\u3093\u307B\u309A\u3093
\u3053\u3093\u307E\u3051
\u3053\u3093\u3084
\u3053\u3093\u308C\u3044
\u3053\u3093\u308F\u304F
\u3055\u3099\u3044\u3048\u304D
\u3055\u3044\u304B\u3044
\u3055\u3044\u304D\u3093
\u3055\u3099\u3044\u3051\u3099\u3093
\u3055\u3099\u3044\u3053
\u3055\u3044\u3057\u3087
\u3055\u3044\u305B\u3044
\u3055\u3099\u3044\u305F\u304F
\u3055\u3099\u3044\u3061\u3085\u3046
\u3055\u3044\u3066\u304D
\u3055\u3099\u3044\u308A\u3087\u3046
\u3055\u3046\u306A
\u3055\u304B\u3044\u3057
\u3055\u304B\u3099\u3059
\u3055\u304B\u306A
\u3055\u304B\u307F\u3061
\u3055\u304B\u3099\u308B
\u3055\u304D\u3099\u3087\u3046
\u3055\u304F\u3057
\u3055\u304F\u3072\u3093
\u3055\u304F\u3089
\u3055\u3053\u304F
\u3055\u3053\u3064
\u3055\u3059\u3099\u304B\u308B
\u3055\u3099\u305B\u304D
\u3055\u305F\u3093
\u3055\u3064\u3048\u3044
\u3055\u3099\u3064\u304A\u3093
\u3055\u3099\u3063\u304B
\u3055\u3099\u3064\u304B\u3099\u304F
\u3055\u3063\u304D\u3087\u304F
\u3055\u3099\u3063\u3057
\u3055\u3064\u3057\u3099\u3093
\u3055\u3099\u3063\u305D\u3046
\u3055\u3064\u305F\u306F\u3099
\u3055\u3064\u307E\u3044\u3082
\u3055\u3066\u3044
\u3055\u3068\u3044\u3082
\u3055\u3068\u3046
\u3055\u3068\u304A\u3084
\u3055\u3068\u3057
\u3055\u3068\u308B
\u3055\u306E\u3046
\u3055\u306F\u3099\u304F
\u3055\u3072\u3099\u3057\u3044
\u3055\u3078\u3099\u3064
\u3055\u307B\u3046
\u3055\u307B\u3068\u3099
\u3055\u307E\u3059
\u3055\u307F\u3057\u3044
\u3055\u307F\u305F\u3099\u308C
\u3055\u3080\u3051
\u3055\u3081\u308B
\u3055\u3084\u3048\u3093\u3068\u3099\u3046
\u3055\u3086\u3046
\u3055\u3088\u3046
\u3055\u3088\u304F
\u3055\u3089\u305F\u3099
\u3055\u3099\u308B\u305D\u306F\u3099
\u3055\u308F\u3084\u304B
\u3055\u308F\u308B
\u3055\u3093\u3044\u3093
\u3055\u3093\u304B
\u3055\u3093\u304D\u3083\u304F
\u3055\u3093\u3053\u3046
\u3055\u3093\u3055\u3044
\u3055\u3099\u3093\u3057\u3087
\u3055\u3093\u3059\u3046
\u3055\u3093\u305B\u3044
\u3055\u3093\u305D
\u3055\u3093\u3061
\u3055\u3093\u307E
\u3055\u3093\u307F
\u3055\u3093\u3089\u3093
\u3057\u3042\u3044
\u3057\u3042\u3051\u3099
\u3057\u3042\u3055\u3063\u3066
\u3057\u3042\u308F\u305B
\u3057\u3044\u304F
\u3057\u3044\u3093
\u3057\u3046\u3061
\u3057\u3048\u3044
\u3057\u304A\u3051
\u3057\u304B\u3044
\u3057\u304B\u304F
\u3057\u3099\u304B\u3093
\u3057\u3053\u3099\u3068
\u3057\u3059\u3046
\u3057\u3099\u305F\u3099\u3044
\u3057\u305F\u3046\u3051
\u3057\u305F\u304D\u3099
\u3057\u305F\u3066
\u3057\u305F\u307F
\u3057\u3061\u3087\u3046
\u3057\u3061\u308A\u3093
\u3057\u3063\u304B\u308A
\u3057\u3064\u3057\u3099
\u3057\u3064\u3082\u3093
\u3057\u3066\u3044
\u3057\u3066\u304D
\u3057\u3066\u3064
\u3057\u3099\u3066\u3093
\u3057\u3099\u3068\u3099\u3046
\u3057\u306A\u304D\u3099\u308C
\u3057\u306A\u3082\u306E
\u3057\u306A\u3093
\u3057\u306D\u307E
\u3057\u306D\u3093
\u3057\u306E\u304F\u3099
\u3057\u306E\u3075\u3099
\u3057\u306F\u3044
\u3057\u306F\u3099\u304B\u308A
\u3057\u306F\u3064
\u3057\u306F\u3089\u3044
\u3057\u306F\u3093
\u3057\u3072\u3087\u3046
\u3057\u3075\u304F
\u3057\u3099\u3075\u3099\u3093
\u3057\u3078\u3044
\u3057\u307B\u3046
\u3057\u307B\u3093
\u3057\u307E\u3046
\u3057\u307E\u308B
\u3057\u307F\u3093
\u3057\u3080\u3051\u308B
\u3057\u3099\u3080\u3057\u3087
\u3057\u3081\u3044
\u3057\u3081\u308B
\u3057\u3082\u3093
\u3057\u3083\u3044\u3093
\u3057\u3083\u3046\u3093
\u3057\u3083\u304A\u3093
\u3057\u3099\u3083\u304B\u3099\u3044\u3082
\u3057\u3084\u304F\u3057\u3087
\u3057\u3083\u304F\u307B\u3046
\u3057\u3083\u3051\u3093
\u3057\u3083\u3053
\u3057\u3083\u3055\u3099\u3044
\u3057\u3083\u3057\u3093
\u3057\u3083\u305B\u3093
\u3057\u3083\u305D\u3046
\u3057\u3083\u305F\u3044
\u3057\u3083\u3061\u3087\u3046
\u3057\u3083\u3063\u304D\u3093
\u3057\u3099\u3083\u307E
\u3057\u3083\u308A\u3093
\u3057\u3083\u308C\u3044
\u3057\u3099\u3086\u3046
\u3057\u3099\u3085\u3046\u3057\u3087
\u3057\u3085\u304F\u306F\u304F
\u3057\u3099\u3085\u3057\u3093
\u3057\u3085\u3063\u305B\u304D
\u3057\u3085\u307F
\u3057\u3085\u3089\u306F\u3099
\u3057\u3099\u3085\u3093\u306F\u3099\u3093
\u3057\u3087\u3046\u304B\u3044
\u3057\u3087\u304F\u305F\u304F
\u3057\u3087\u3063\u3051\u3093
\u3057\u3087\u3068\u3099\u3046
\u3057\u3087\u3082\u3064
\u3057\u3089\u305B\u308B
\u3057\u3089\u3078\u3099\u308B
\u3057\u3093\u304B
\u3057\u3093\u3053\u3046
\u3057\u3099\u3093\u3057\u3099\u3083
\u3057\u3093\u305B\u3044\u3057\u3099
\u3057\u3093\u3061\u304F
\u3057\u3093\u308A\u3093
\u3059\u3042\u3051\u3099
\u3059\u3042\u3057
\u3059\u3042\u306A
\u3059\u3099\u3042\u3093
\u3059\u3044\u3048\u3044
\u3059\u3044\u304B
\u3059\u3044\u3068\u3046
\u3059\u3099\u3044\u3075\u3099\u3093
\u3059\u3044\u3088\u3046\u3072\u3099
\u3059\u3046\u304B\u3099\u304F
\u3059\u3046\u3057\u3099\u3064
\u3059\u3046\u305B\u3093
\u3059\u304A\u3068\u3099\u308A
\u3059\u304D\u307E
\u3059\u304F\u3046
\u3059\u304F\u306A\u3044
\u3059\u3051\u308B
\u3059\u3053\u3099\u3044
\u3059\u3053\u3057
\u3059\u3099\u3055\u3093
\u3059\u3059\u3099\u3057\u3044
\u3059\u3059\u3080
\u3059\u3059\u3081\u308B
\u3059\u3063\u304B\u308A
\u3059\u3099\u3063\u3057\u308A
\u3059\u3099\u3063\u3068
\u3059\u3066\u304D
\u3059\u3066\u308B
\u3059\u306D\u308B
\u3059\u306E\u3053
\u3059\u306F\u305F\u3099
\u3059\u306F\u3099\u3089\u3057\u3044
\u3059\u3099\u3072\u3087\u3046
\u3059\u3099\u3075\u3099\u306C\u308C
\u3059\u3075\u3099\u308A
\u3059\u3075\u308C
\u3059\u3078\u3099\u3066
\u3059\u3078\u3099\u308B
\u3059\u3099\u307B\u3046
\u3059\u307B\u3099\u3093
\u3059\u307E\u3044
\u3059\u3081\u3057
\u3059\u3082\u3046
\u3059\u3084\u304D
\u3059\u3089\u3059\u3089
\u3059\u308B\u3081
\u3059\u308C\u3061\u304B\u3099\u3046
\u3059\u308D\u3063\u3068
\u3059\u308F\u308B
\u3059\u3093\u305B\u3099\u3093
\u3059\u3093\u307B\u309A\u3046
\u305B\u3042\u3075\u3099\u3089
\u305B\u3044\u304B\u3064
\u305B\u3044\u3051\u3099\u3093
\u305B\u3044\u3057\u3099
\u305B\u3044\u3088\u3046
\u305B\u304A\u3046
\u305B\u304B\u3044\u304B\u3093
\u305B\u304D\u306B\u3093
\u305B\u304D\u3080
\u305B\u304D\u3086
\u305B\u304D\u3089\u3093\u3046\u3093
\u305B\u3051\u3093
\u305B\u3053\u3046
\u305B\u3059\u3057\u3099
\u305B\u305F\u3044
\u305B\u305F\u3051
\u305B\u3063\u304B\u304F
\u305B\u3063\u304D\u3083\u304F
\u305B\u3099\u3063\u304F
\u305B\u3063\u3051\u3093
\u305B\u3063\u3053\u3064
\u305B\u3063\u3055\u305F\u304F\u307E
\u305B\u3064\u305D\u3099\u304F
\u305B\u3064\u305F\u3099\u3093
\u305B\u3064\u3066\u3099\u3093
\u305B\u3063\u306F\u309A\u3093
\u305B\u3064\u3072\u3099
\u305B\u3064\u3075\u3099\u3093
\u305B\u3064\u3081\u3044
\u305B\u3064\u308A\u3064
\u305B\u306A\u304B
\u305B\u306E\u3072\u3099
\u305B\u306F\u306F\u3099
\u305B\u3072\u3099\u308D
\u305B\u307B\u3099\u306D
\u305B\u307E\u3044
\u305B\u307E\u308B
\u305B\u3081\u308B
\u305B\u3082\u305F\u308C
\u305B\u308A\u3075
\u305B\u3099\u3093\u3042\u304F
\u305B\u3093\u3044
\u305B\u3093\u3048\u3044
\u305B\u3093\u304B
\u305B\u3093\u304D\u3087
\u305B\u3093\u304F
\u305B\u3093\u3051\u3099\u3093
\u305B\u3099\u3093\u3053\u3099
\u305B\u3093\u3055\u3044
\u305B\u3093\u3057\u3085
\u305B\u3093\u3059\u3044
\u305B\u3093\u305B\u3044
\u305B\u3093\u305D\u3099
\u305B\u3093\u305F\u304F
\u305B\u3093\u3061\u3087\u3046
\u305B\u3093\u3066\u3044
\u305B\u3093\u3068\u3046
\u305B\u3093\u306C\u304D
\u305B\u3093\u306D\u3093
\u305B\u3093\u306F\u309A\u3044
\u305B\u3099\u3093\u3075\u3099
\u305B\u3099\u3093\u307B\u309A\u3046
\u305B\u3093\u3080
\u305B\u3093\u3081\u3093\u3057\u3099\u3087
\u305B\u3093\u3082\u3093
\u305B\u3093\u3084\u304F
\u305B\u3093\u3086\u3046
\u305B\u3093\u3088\u3046
\u305B\u3099\u3093\u3089
\u305B\u3099\u3093\u308A\u3083\u304F
\u305B\u3093\u308C\u3044
\u305B\u3093\u308D
\u305D\u3042\u304F
\u305D\u3044\u3068\u3051\u3099\u308B
\u305D\u3044\u306D
\u305D\u3046\u304B\u3099\u3093\u304D\u3087\u3046
\u305D\u3046\u304D
\u305D\u3046\u3053\u3099
\u305D\u3046\u3057\u3093
\u305D\u3046\u305F\u3099\u3093
\u305D\u3046\u306A\u3093
\u305D\u3046\u3072\u3099
\u305D\u3046\u3081\u3093
\u305D\u3046\u308A
\u305D\u3048\u3082\u306E
\u305D\u3048\u3093
\u305D\u304B\u3099\u3044
\u305D\u3051\u3099\u304D
\u305D\u3053\u3046
\u305D\u3053\u305D\u3053
\u305D\u3055\u3099\u3044
\u305D\u3057\u306A
\u305D\u305B\u3044
\u305D\u305B\u3093
\u305D\u305D\u304F\u3099
\u305D\u305F\u3099\u3066\u308B
\u305D\u3064\u3046
\u305D\u3064\u3048\u3093
\u305D\u3063\u304B\u3093
\u305D\u3064\u304D\u3099\u3087\u3046
\u305D\u3063\u3051\u3064
\u305D\u3063\u3053\u3046
\u305D\u3063\u305B\u3093
\u305D\u3063\u3068
\u305D\u3068\u304B\u3099\u308F
\u305D\u3068\u3064\u3099\u3089
\u305D\u306A\u3048\u308B
\u305D\u306A\u305F
\u305D\u3075\u307B\u3099
\u305D\u307B\u3099\u304F
\u305D\u307B\u3099\u308D
\u305D\u307E\u3064
\u305D\u307E\u308B
\u305D\u3080\u304F
\u305D\u3080\u308A\u3048
\u305D\u3081\u308B
\u305D\u3082\u305D\u3082
\u305D\u3088\u304B\u305B\u3099
\u305D\u3089\u307E\u3081
\u305D\u308D\u3046
\u305D\u3093\u304B\u3044
\u305D\u3093\u3051\u3044
\u305D\u3093\u3055\u3099\u3044
\u305D\u3093\u3057\u3064
\u305D\u3093\u305D\u3099\u304F
\u305D\u3093\u3061\u3087\u3046
\u305D\u3099\u3093\u3072\u3099
\u305D\u3099\u3093\u3075\u3099\u3093
\u305D\u3093\u307F\u3093
\u305F\u3042\u3044
\u305F\u3044\u3044\u3093
\u305F\u3044\u3046\u3093
\u305F\u3044\u3048\u304D
\u305F\u3044\u304A\u3046
\u305F\u3099\u3044\u304B\u3099\u304F
\u305F\u3044\u304D
\u305F\u3044\u304F\u3099\u3046
\u305F\u3044\u3051\u3093
\u305F\u3044\u3053
\u305F\u3044\u3055\u3099\u3044
\u305F\u3099\u3044\u3057\u3099\u3087\u3046\u3075\u3099
\u305F\u3099\u3044\u3059\u304D
\u305F\u3044\u305B\u3064
\u305F\u3044\u305D\u3046
\u305F\u3099\u3044\u305F\u3044
\u305F\u3044\u3061\u3087\u3046
\u305F\u3044\u3066\u3044
\u305F\u3099\u3044\u3068\u3099\u3053\u308D
\u305F\u3044\u306A\u3044
\u305F\u3044\u306D\u3064
\u305F\u3044\u306E\u3046
\u305F\u3044\u306F\u3093
\u305F\u3099\u3044\u3072\u3087\u3046
\u305F\u3044\u3075\u3046
\u305F\u3044\u3078\u3093
\u305F\u3044\u307B
\u305F\u3044\u307E\u3064\u306F\u3099\u306A
\u305F\u3044\u307F\u3093\u304F\u3099
\u305F\u3044\u3080
\u305F\u3044\u3081\u3093
\u305F\u3044\u3084\u304D
\u305F\u3044\u3088\u3046
\u305F\u3044\u3089
\u305F\u3044\u308A\u3087\u304F
\u305F\u3044\u308B
\u305F\u3044\u308F\u3093
\u305F\u3046\u3048
\u305F\u3048\u308B
\u305F\u304A\u3059
\u305F\u304A\u308B
\u305F\u304A\u308C\u308B
\u305F\u304B\u3044
\u305F\u304B\u306D
\u305F\u304D\u3072\u3099
\u305F\u304F\u3055\u3093
\u305F\u3053\u304F
\u305F\u3053\u3084\u304D
\u305F\u3055\u3044
\u305F\u3057\u3055\u3099\u3093
\u305F\u3099\u3057\u3099\u3083\u308C
\u305F\u3059\u3051\u308B
\u305F\u3059\u3099\u3055\u308F\u308B
\u305F\u305D\u304B\u3099\u308C
\u305F\u305F\u304B\u3046
\u305F\u305F\u304F
\u305F\u305F\u3099\u3057\u3044
\u305F\u305F\u307F
\u305F\u3061\u306F\u3099\u306A
\u305F\u3099\u3063\u304B\u3044
\u305F\u3099\u3063\u304D\u3083\u304F
\u305F\u3099\u3063\u3053
\u305F\u3099\u3063\u3057\u3085\u3064
\u305F\u3099\u3063\u305F\u3044
\u305F\u3066\u308B
\u305F\u3068\u3048\u308B
\u305F\u306A\u306F\u3099\u305F
\u305F\u306B\u3093
\u305F\u306C\u304D
\u305F\u306E\u3057\u307F
\u305F\u306F\u3064
\u305F\u3075\u3099\u3093
\u305F\u3078\u3099\u308B
\u305F\u307B\u3099\u3046
\u305F\u307E\u3053\u3099
\u305F\u307E\u308B
\u305F\u3099\u3080\u308B
\u305F\u3081\u3044\u304D
\u305F\u3081\u3059
\u305F\u3081\u308B
\u305F\u3082\u3064
\u305F\u3084\u3059\u3044
\u305F\u3088\u308B
\u305F\u3089\u3059
\u305F\u308A\u304D\u307B\u3093\u304B\u3099\u3093
\u305F\u308A\u3087\u3046
\u305F\u308A\u308B
\u305F\u308B\u3068
\u305F\u308C\u308B
\u305F\u308C\u3093\u3068
\u305F\u308D\u3063\u3068
\u305F\u308F\u3080\u308C\u308B
\u305F\u3099\u3093\u3042\u3064
\u305F\u3093\u3044
\u305F\u3093\u304A\u3093
\u305F\u3093\u304B
\u305F\u3093\u304D
\u305F\u3093\u3051\u3093
\u305F\u3093\u3053\u3099
\u305F\u3093\u3055\u3093
\u305F\u3093\u3057\u3099\u3087\u3046\u3072\u3099
\u305F\u3099\u3093\u305B\u3044
\u305F\u3093\u305D\u304F
\u305F\u3093\u305F\u3044
\u305F\u3099\u3093\u3061
\u305F\u3093\u3066\u3044
\u305F\u3093\u3068\u3046
\u305F\u3099\u3093\u306A
\u305F\u3093\u306B\u3093
\u305F\u3099\u3093\u306D\u3064
\u305F\u3093\u306E\u3046
\u305F\u3093\u3072\u309A\u3093
\u305F\u3099\u3093\u307B\u3099\u3046
\u305F\u3093\u307E\u3064
\u305F\u3093\u3081\u3044
\u305F\u3099\u3093\u308C\u3064
\u305F\u3099\u3093\u308D
\u305F\u3099\u3093\u308F
\u3061\u3042\u3044
\u3061\u3042\u3093
\u3061\u3044\u304D
\u3061\u3044\u3055\u3044
\u3061\u3048\u3093
\u3061\u304B\u3044
\u3061\u304B\u3089
\u3061\u304D\u3085\u3046
\u3061\u304D\u3093
\u3061\u3051\u3044\u3059\u3099
\u3061\u3051\u3093
\u3061\u3053\u304F
\u3061\u3055\u3044
\u3061\u3057\u304D
\u3061\u3057\u308A\u3087\u3046
\u3061\u305B\u3044
\u3061\u305D\u3046
\u3061\u305F\u3044
\u3061\u305F\u3093
\u3061\u3061\u304A\u3084
\u3061\u3064\u3057\u3099\u3087
\u3061\u3066\u304D
\u3061\u3066\u3093
\u3061\u306C\u304D
\u3061\u306C\u308A
\u3061\u306E\u3046
\u3061\u3072\u3087\u3046
\u3061\u3078\u3044\u305B\u3093
\u3061\u307B\u3046
\u3061\u307E\u305F
\u3061\u307F\u3064
\u3061\u307F\u3068\u3099\u308D
\u3061\u3081\u3044\u3068\u3099
\u3061\u3083\u3093\u3053\u306A\u3078\u3099
\u3061\u3085\u3046\u3044
\u3061\u3086\u308A\u3087\u304F
\u3061\u3087\u3046\u3057
\u3061\u3087\u3055\u304F\u3051\u3093
\u3061\u3089\u3057
\u3061\u3089\u307F
\u3061\u308A\u304B\u3099\u307F
\u3061\u308A\u3087\u3046
\u3061\u308B\u3068\u3099
\u3061\u308F\u308F
\u3061\u3093\u305F\u3044
\u3061\u3093\u3082\u304F
\u3064\u3044\u304B
\u3064\u3044\u305F\u3061
\u3064\u3046\u304B
\u3064\u3046\u3057\u3099\u3087\u3046
\u3064\u3046\u306F\u3093
\u3064\u3046\u308F
\u3064\u304B\u3046
\u3064\u304B\u308C\u308B
\u3064\u304F\u306D
\u3064\u304F\u308B
\u3064\u3051\u306D
\u3064\u3051\u308B
\u3064\u3053\u3099\u3046
\u3064\u305F\u3048\u308B
\u3064\u3064\u3099\u304F
\u3064\u3064\u3057\u3099
\u3064\u3064\u3080
\u3064\u3068\u3081\u308B
\u3064\u306A\u304B\u3099\u308B
\u3064\u306A\u307F
\u3064\u306D\u3064\u3099\u306D
\u3064\u306E\u308B
\u3064\u3075\u3099\u3059
\u3064\u307E\u3089\u306A\u3044
\u3064\u307E\u308B
\u3064\u307F\u304D
\u3064\u3081\u305F\u3044
\u3064\u3082\u308A
\u3064\u3082\u308B
\u3064\u3088\u3044
\u3064\u308B\u307B\u3099
\u3064\u308B\u307F\u304F
\u3064\u308F\u3082\u306E
\u3064\u308F\u308A
\u3066\u3042\u3057
\u3066\u3042\u3066
\u3066\u3042\u307F
\u3066\u3044\u304A\u3093
\u3066\u3044\u304B
\u3066\u3044\u304D
\u3066\u3044\u3051\u3044
\u3066\u3044\u3053\u304F
\u3066\u3044\u3055\u3064
\u3066\u3044\u3057
\u3066\u3044\u305B\u3044
\u3066\u3044\u305F\u3044
\u3066\u3044\u3068\u3099
\u3066\u3044\u306D\u3044
\u3066\u3044\u3072\u3087\u3046
\u3066\u3044\u3078\u3093
\u3066\u3044\u307B\u3099\u3046
\u3066\u3046\u3061
\u3066\u304A\u304F\u308C
\u3066\u304D\u3068\u3046
\u3066\u304F\u3072\u3099
\u3066\u3099\u3053\u307B\u3099\u3053
\u3066\u3055\u304D\u3099\u3087\u3046
\u3066\u3055\u3051\u3099
\u3066\u3059\u308A
\u3066\u305D\u3046
\u3066\u3061\u304B\u3099\u3044
\u3066\u3061\u3087\u3046
\u3066\u3064\u304B\u3099\u304F
\u3066\u3064\u3064\u3099\u304D
\u3066\u3099\u3063\u306F\u309A
\u3066\u3064\u307B\u3099\u3046
\u3066\u3064\u3084
\u3066\u3099\u306C\u304B\u3048
\u3066\u306C\u304D
\u3066\u306C\u304F\u3099\u3044
\u3066\u306E\u3072\u3089
\u3066\u306F\u3044
\u3066\u3075\u3099\u304F\u308D
\u3066\u3075\u305F\u3099
\u3066\u307B\u3068\u3099\u304D
\u3066\u307B\u3093
\u3066\u307E\u3048
\u3066\u307E\u304D\u3059\u3099\u3057
\u3066\u307F\u3057\u3099\u304B
\u3066\u307F\u3084\u3051\u3099
\u3066\u3089\u3059
\u3066\u308C\u3072\u3099
\u3066\u308F\u3051
\u3066\u308F\u305F\u3057
\u3066\u3099\u3093\u3042\u3064
\u3066\u3093\u3044\u3093
\u3066\u3093\u304B\u3044
\u3066\u3093\u304D
\u3066\u3093\u304F\u3099
\u3066\u3093\u3051\u3093
\u3066\u3093\u3053\u3099\u304F
\u3066\u3093\u3055\u3044
\u3066\u3093\u3057
\u3066\u3093\u3059\u3046
\u3066\u3099\u3093\u3061
\u3066\u3093\u3066\u304D
\u3066\u3093\u3068\u3046
\u3066\u3093\u306A\u3044
\u3066\u3093\u3075\u309A\u3089
\u3066\u3093\u307B\u3099\u3046\u305F\u3099\u3044
\u3066\u3093\u3081\u3064
\u3066\u3093\u3089\u3093\u304B\u3044
\u3066\u3099\u3093\u308A\u3087\u304F
\u3066\u3099\u3093\u308F
\u3068\u3099\u3042\u3044
\u3068\u3044\u308C
\u3068\u3099\u3046\u304B\u3093
\u3068\u3046\u304D\u3085\u3046
\u3068\u3099\u3046\u304F\u3099
\u3068\u3046\u3057
\u3068\u3046\u3080\u304D\u3099
\u3068\u304A\u3044
\u3068\u304A\u304B
\u3068\u304A\u304F
\u3068\u304A\u3059
\u3068\u304A\u308B
\u3068\u304B\u3044
\u3068\u304B\u3059
\u3068\u304D\u304A\u308A
\u3068\u304D\u3068\u3099\u304D
\u3068\u304F\u3044
\u3068\u304F\u3057\u3085\u3046
\u3068\u304F\u3066\u3093
\u3068\u304F\u306B
\u3068\u304F\u3078\u3099\u3064
\u3068\u3051\u3044
\u3068\u3051\u308B
\u3068\u3053\u3084
\u3068\u3055\u304B
\u3068\u3057\u3087\u304B\u3093
\u3068\u305D\u3046
\u3068\u305F\u3093
\u3068\u3061\u3085\u3046
\u3068\u3063\u304D\u3085\u3046
\u3068\u3063\u304F\u3093
\u3068\u3064\u305B\u3099\u3093
\u3068\u3064\u306B\u3085\u3046
\u3068\u3068\u3099\u3051\u308B
\u3068\u3068\u306E\u3048\u308B
\u3068\u306A\u3044
\u3068\u306A\u3048\u308B
\u3068\u306A\u308A
\u3068\u306E\u3055\u307E
\u3068\u306F\u3099\u3059
\u3068\u3099\u3075\u3099\u304B\u3099\u308F
\u3068\u307B\u3046
\u3068\u307E\u308B
\u3068\u3081\u308B
\u3068\u3082\u305F\u3099\u3061
\u3068\u3082\u308B
\u3068\u3099\u3088\u3046\u3072\u3099
\u3068\u3089\u3048\u308B
\u3068\u3093\u304B\u3064
\u3068\u3099\u3093\u3075\u3099\u308A
\u306A\u3044\u304B\u304F
\u306A\u3044\u3053\u3046
\u306A\u3044\u3057\u3087
\u306A\u3044\u3059
\u306A\u3044\u305B\u3093
\u306A\u3044\u305D\u3046
\u306A\u304A\u3059
\u306A\u304B\u3099\u3044
\u306A\u304F\u3059
\u306A\u3051\u3099\u308B
\u306A\u3053\u3046\u3068\u3099
\u306A\u3055\u3051
\u306A\u305F\u3066\u3099\u3053\u3053
\u306A\u3063\u3068\u3046
\u306A\u3064\u3084\u3059\u307F
\u306A\u306A\u304A\u3057
\u306A\u306B\u3053\u3099\u3068
\u306A\u306B\u3082\u306E
\u306A\u306B\u308F
\u306A\u306E\u304B
\u306A\u3075\u305F\u3099
\u306A\u307E\u3044\u304D
\u306A\u307E\u3048
\u306A\u307E\u307F
\u306A\u307F\u305F\u3099
\u306A\u3081\u3089\u304B
\u306A\u3081\u308B
\u306A\u3084\u3080
\u306A\u3089\u3046
\u306A\u3089\u3072\u3099
\u306A\u3089\u3075\u3099
\u306A\u308C\u308B
\u306A\u308F\u3068\u3072\u3099
\u306A\u308F\u306F\u3099\u308A
\u306B\u3042\u3046
\u306B\u3044\u304B\u3099\u305F
\u306B\u3046\u3051
\u306B\u304A\u3044
\u306B\u304B\u3044
\u306B\u304B\u3099\u3066
\u306B\u304D\u3072\u3099
\u306B\u304F\u3057\u307F
\u306B\u304F\u307E\u3093
\u306B\u3051\u3099\u308B
\u306B\u3055\u3093\u304B\u305F\u3093\u305D
\u306B\u3057\u304D
\u306B\u305B\u3082\u306E
\u306B\u3061\u3057\u3099\u3087\u3046
\u306B\u3061\u3088\u3046\u3072\u3099
\u306B\u3063\u304B
\u306B\u3063\u304D
\u306B\u3063\u3051\u3044
\u306B\u3063\u3053\u3046
\u306B\u3063\u3055\u3093
\u306B\u3063\u3057\u3087\u304F
\u306B\u3063\u3059\u3046
\u306B\u3063\u305B\u304D
\u306B\u3063\u3066\u3044
\u306B\u306A\u3046
\u306B\u307B\u3093
\u306B\u307E\u3081
\u306B\u3082\u3064
\u306B\u3084\u308A
\u306B\u3085\u3046\u3044\u3093
\u306B\u308A\u3093\u3057\u3083
\u306B\u308F\u3068\u308A
\u306B\u3093\u3044
\u306B\u3093\u304B
\u306B\u3093\u304D
\u306B\u3093\u3051\u3099\u3093
\u306B\u3093\u3057\u304D
\u306B\u3093\u3059\u3099\u3046
\u306B\u3093\u305D\u3046
\u306B\u3093\u305F\u3044
\u306B\u3093\u3061
\u306B\u3093\u3066\u3044
\u306B\u3093\u306B\u304F
\u306B\u3093\u3075\u309A
\u306B\u3093\u307E\u308A
\u306B\u3093\u3080
\u306B\u3093\u3081\u3044
\u306B\u3093\u3088\u3046
\u306C\u3044\u304F\u304D\u3099
\u306C\u304B\u3059
\u306C\u304F\u3099\u3044\u3068\u308B
\u306C\u304F\u3099\u3046
\u306C\u304F\u3082\u308A
\u306C\u3059\u3080
\u306C\u307E\u3048\u3072\u3099
\u306C\u3081\u308A
\u306C\u3089\u3059
\u306C\u3093\u3061\u3083\u304F
\u306D\u3042\u3051\u3099
\u306D\u3044\u304D
\u306D\u3044\u308B
\u306D\u3044\u308D
\u306D\u304F\u3099\u305B
\u306D\u304F\u305F\u3044
\u306D\u304F\u3089
\u306D\u3053\u305B\u3099
\u306D\u3053\u3080
\u306D\u3055\u3051\u3099
\u306D\u3059\u3053\u3099\u3059
\u306D\u305D\u3078\u3099\u308B
\u306D\u305F\u3099\u3093
\u306D\u3064\u3044
\u306D\u3063\u3057\u3093
\u306D\u3064\u305D\u3099\u3046
\u306D\u3063\u305F\u3044\u304D\u3099\u3087
\u306D\u3075\u3099\u305D\u304F
\u306D\u3075\u305F\u3099
\u306D\u307B\u3099\u3046
\u306D\u307B\u308A\u306F\u307B\u308A
\u306D\u307E\u304D
\u306D\u307E\u308F\u3057
\u306D\u307F\u307F
\u306D\u3080\u3044
\u306D\u3080\u305F\u3044
\u306D\u3082\u3068
\u306D\u3089\u3046
\u306D\u308F\u3055\u3099
\u306D\u3093\u3044\u308A
\u306D\u3093\u304A\u3057
\u306D\u3093\u304B\u3093
\u306D\u3093\u304D\u3093
\u306D\u3093\u304F\u3099
\u306D\u3093\u3055\u3099
\u306D\u3093\u3057
\u306D\u3093\u3061\u3083\u304F
\u306D\u3093\u3068\u3099
\u306D\u3093\u3072\u309A
\u306D\u3093\u3075\u3099\u3064
\u306D\u3093\u307E\u3064
\u306D\u3093\u308A\u3087\u3046
\u306D\u3093\u308C\u3044
\u306E\u3044\u3059\u3099
\u306E\u304A\u3064\u3099\u307E
\u306E\u304B\u3099\u3059
\u306E\u304D\u306A\u307F
\u306E\u3053\u304D\u3099\u308A
\u306E\u3053\u3059
\u306E\u3053\u308B
\u306E\u305B\u308B
\u306E\u305D\u3099\u304F
\u306E\u305D\u3099\u3080
\u306E\u305F\u307E\u3046
\u306E\u3061\u307B\u3068\u3099
\u306E\u3063\u304F
\u306E\u306F\u3099\u3059
\u306E\u306F\u3089
\u306E\u3078\u3099\u308B
\u306E\u307B\u3099\u308B
\u306E\u307F\u3082\u306E
\u306E\u3084\u307E
\u306E\u3089\u3044\u306C
\u306E\u3089\u306D\u3053
\u306E\u308A\u3082\u306E
\u306E\u308A\u3086\u304D
\u306E\u308C\u3093
\u306E\u3093\u304D
\u306F\u3099\u3042\u3044
\u306F\u3042\u304F
\u306F\u3099\u3042\u3055\u3093
\u306F\u3099\u3044\u304B
\u306F\u3099\u3044\u304F
\u306F\u3044\u3051\u3093
\u306F\u3044\u3053\u3099
\u306F\u3044\u3057\u3093
\u306F\u3044\u3059\u3044
\u306F\u3044\u305B\u3093
\u306F\u3044\u305D\u3046
\u306F\u3044\u3061
\u306F\u3099\u3044\u306F\u3099\u3044
\u306F\u3044\u308C\u3064
\u306F\u3048\u308B
\u306F\u304A\u308B
\u306F\u304B\u3044
\u306F\u3099\u304B\u308A
\u306F\u304B\u308B
\u306F\u304F\u3057\u3085
\u306F\u3051\u3093
\u306F\u3053\u3075\u3099
\u306F\u3055\u307F
\u306F\u3055\u3093
\u306F\u3057\u3053\u3099
\u306F\u3099\u3057\u3087
\u306F\u3057\u308B
\u306F\u305B\u308B
\u306F\u309A\u305D\u3053\u3093
\u306F\u305D\u3093
\u306F\u305F\u3093
\u306F\u3061\u307F\u3064
\u306F\u3064\u304A\u3093
\u306F\u3063\u304B\u304F
\u306F\u3064\u3099\u304D
\u306F\u3063\u304D\u308A
\u306F\u3063\u304F\u3064
\u306F\u3063\u3051\u3093
\u306F\u3063\u3053\u3046
\u306F\u3063\u3055\u3093
\u306F\u3063\u3057\u3093
\u306F\u3063\u305F\u3064
\u306F\u3063\u3061\u3085\u3046
\u306F\u3063\u3066\u3093
\u306F\u3063\u3072\u309A\u3087\u3046
\u306F\u3063\u307B\u309A\u3046
\u306F\u306A\u3059
\u306F\u306A\u3072\u3099
\u306F\u306B\u304B\u3080
\u306F\u3075\u3099\u3089\u3057
\u306F\u307F\u304B\u3099\u304D
\u306F\u3080\u304B\u3046
\u306F\u3081\u3064
\u306F\u3084\u3044
\u306F\u3084\u3057
\u306F\u3089\u3046
\u306F\u308D\u3046\u3043\u3093
\u306F\u308F\u3044
\u306F\u3093\u3044
\u306F\u3093\u3048\u3044
\u306F\u3093\u304A\u3093
\u306F\u3093\u304B\u304F
\u306F\u3093\u304D\u3087\u3046
\u306F\u3099\u3093\u304F\u3099\u307F
\u306F\u3093\u3053
\u306F\u3093\u3057\u3083
\u306F\u3093\u3059\u3046
\u306F\u3093\u305F\u3099\u3093
\u306F\u309A\u3093\u3061
\u306F\u309A\u3093\u3064
\u306F\u3093\u3066\u3044
\u306F\u3093\u3068\u3057
\u306F\u3093\u306E\u3046
\u306F\u3093\u306F\u309A
\u306F\u3093\u3075\u3099\u3093
\u306F\u3093\u3078\u309A\u3093
\u306F\u3093\u307B\u3099\u3046\u304D
\u306F\u3093\u3081\u3044
\u306F\u3093\u3089\u3093
\u306F\u3093\u308D\u3093
\u3072\u3044\u304D
\u3072\u3046\u3093
\u3072\u3048\u308B
\u3072\u304B\u304F
\u3072\u304B\u308A
\u3072\u304B\u308B
\u3072\u304B\u3093
\u3072\u304F\u3044
\u3072\u3051\u3064
\u3072\u3053\u3046\u304D
\u3072\u3053\u304F
\u3072\u3055\u3044
\u3072\u3055\u3057\u3075\u3099\u308A
\u3072\u3055\u3093
\u3072\u3099\u3057\u3099\u3085\u3064\u304B\u3093
\u3072\u3057\u3087
\u3072\u305D\u304B
\u3072\u305D\u3080
\u3072\u305F\u3080\u304D
\u3072\u305F\u3099\u308A
\u3072\u305F\u308B
\u3072\u3064\u304D\u3099
\u3072\u3063\u3053\u3057
\u3072\u3063\u3057
\u3072\u3064\u3057\u3099\u3085\u3072\u3093
\u3072\u3063\u3059
\u3072\u3064\u305B\u3099\u3093
\u3072\u309A\u3063\u305F\u308A
\u3072\u309A\u3063\u3061\u308A
\u3072\u3064\u3088\u3046
\u3072\u3066\u3044
\u3072\u3068\u3053\u3099\u307F
\u3072\u306A\u307E\u3064\u308A
\u3072\u306A\u3093
\u3072\u306D\u308B
\u3072\u306F\u3093
\u3072\u3072\u3099\u304F
\u3072\u3072\u3087\u3046
\u3072\u307B\u3046
\u3072\u307E\u308F\u308A
\u3072\u307E\u3093
\u3072\u307F\u3064
\u3072\u3081\u3044
\u3072\u3081\u3057\u3099\u3057
\u3072\u3084\u3051
\u3072\u3084\u3059
\u3072\u3088\u3046
\u3072\u3099\u3087\u3046\u304D
\u3072\u3089\u304B\u3099\u306A
\u3072\u3089\u304F
\u3072\u308A\u3064
\u3072\u308A\u3087\u3046
\u3072\u308B\u307E
\u3072\u308B\u3084\u3059\u307F
\u3072\u308C\u3044
\u3072\u308D\u3044
\u3072\u308D\u3046
\u3072\u308D\u304D
\u3072\u308D\u3086\u304D
\u3072\u3093\u304B\u304F
\u3072\u3093\u3051\u3064
\u3072\u3093\u3053\u3093
\u3072\u3093\u3057\u3085
\u3072\u3093\u305D\u3046
\u3072\u309A\u3093\u3061
\u3072\u3093\u306F\u309A\u3093
\u3072\u3099\u3093\u307B\u3099\u3046
\u3075\u3042\u3093
\u3075\u3044\u3046\u3061
\u3075\u3046\u3051\u3044
\u3075\u3046\u305B\u3093
\u3075\u309A\u3046\u305F\u308D\u3046
\u3075\u3046\u3068\u3046
\u3075\u3046\u3075
\u3075\u3048\u308B
\u3075\u304A\u3093
\u3075\u304B\u3044
\u3075\u304D\u3093
\u3075\u304F\u3055\u3099\u3064
\u3075\u304F\u3075\u3099\u304F\u308D
\u3075\u3053\u3046
\u3075\u3055\u3044
\u3075\u3057\u304D\u3099
\u3075\u3057\u3099\u307F
\u3075\u3059\u307E
\u3075\u305B\u3044
\u3075\u305B\u304F\u3099
\u3075\u305D\u304F
\u3075\u3099\u305F\u306B\u304F
\u3075\u305F\u3093
\u3075\u3061\u3087\u3046
\u3075\u3064\u3046
\u3075\u3064\u304B
\u3075\u3063\u304B\u3064
\u3075\u3063\u304D
\u3075\u3063\u3053\u304F
\u3075\u3099\u3068\u3099\u3046
\u3075\u3068\u308B
\u3075\u3068\u3093
\u3075\u306E\u3046
\u3075\u306F\u3044
\u3075\u3072\u3087\u3046
\u3075\u3078\u3093
\u3075\u307E\u3093
\u3075\u307F\u3093
\u3075\u3081\u3064
\u3075\u3081\u3093
\u3075\u3088\u3046
\u3075\u308A\u3053
\u3075\u308A\u308B
\u3075\u308B\u3044
\u3075\u3093\u3044\u304D
\u3075\u3099\u3093\u304B\u3099\u304F
\u3075\u3099\u3093\u304F\u3099
\u3075\u3093\u3057\u3064
\u3075\u3099\u3093\u305B\u304D
\u3075\u3093\u305D\u3046
\u3075\u3099\u3093\u307B\u309A\u3046
\u3078\u3044\u3042\u3093
\u3078\u3044\u304A\u3093
\u3078\u3044\u304B\u3099\u3044
\u3078\u3044\u304D
\u3078\u3044\u3051\u3099\u3093
\u3078\u3044\u3053\u3046
\u3078\u3044\u3055
\u3078\u3044\u3057\u3083
\u3078\u3044\u305B\u3064
\u3078\u3044\u305D
\u3078\u3044\u305F\u304F
\u3078\u3044\u3066\u3093
\u3078\u3044\u306D\u3064
\u3078\u3044\u308F
\u3078\u304D\u304B\u3099
\u3078\u3053\u3080
\u3078\u3099\u306B\u3044\u308D
\u3078\u3099\u306B\u3057\u3087\u3046\u304B\u3099
\u3078\u3089\u3059
\u3078\u3093\u304B\u3093
\u3078\u3099\u3093\u304D\u3087\u3046
\u3078\u3099\u3093\u3053\u3099\u3057
\u3078\u3093\u3055\u3044
\u3078\u3093\u305F\u3044
\u3078\u3099\u3093\u308A
\u307B\u3042\u3093
\u307B\u3044\u304F
\u307B\u3099\u3046\u304D\u3099\u3087
\u307B\u3046\u3053\u304F
\u307B\u3046\u305D\u3046
\u307B\u3046\u307B\u3046
\u307B\u3046\u3082\u3093
\u307B\u3046\u308A\u3064
\u307B\u3048\u308B
\u307B\u304A\u3093
\u307B\u304B\u3093
\u307B\u304D\u3087\u3046
\u307B\u3099\u304D\u3093
\u307B\u304F\u308D
\u307B\u3051\u3064
\u307B\u3051\u3093
\u307B\u3053\u3046
\u307B\u3053\u308B
\u307B\u3057\u3044
\u307B\u3057\u3064
\u307B\u3057\u3085
\u307B\u3057\u3087\u3046
\u307B\u305B\u3044
\u307B\u305D\u3044
\u307B\u305D\u304F
\u307B\u305F\u3066
\u307B\u305F\u308B
\u307B\u309A\u3061\u3075\u3099\u304F\u308D
\u307B\u3063\u304D\u3087\u304F
\u307B\u3063\u3055
\u307B\u3063\u305F\u3093
\u307B\u3068\u3093\u3068\u3099
\u307B\u3081\u308B
\u307B\u3093\u3044
\u307B\u3093\u304D
\u307B\u3093\u3051
\u307B\u3093\u3057\u3064
\u307B\u3093\u3084\u304F
\u307E\u3044\u306B\u3061
\u307E\u304B\u3044
\u307E\u304B\u305B\u308B
\u307E\u304B\u3099\u308B
\u307E\u3051\u308B
\u307E\u3053\u3068
\u307E\u3055\u3064
\u307E\u3057\u3099\u3081
\u307E\u3059\u304F
\u307E\u305B\u3099\u308B
\u307E\u3064\u308A
\u307E\u3068\u3081
\u307E\u306A\u3075\u3099
\u307E\u306C\u3051
\u307E\u306D\u304F
\u307E\u307B\u3046
\u307E\u3082\u308B
\u307E\u3086\u3051\u3099
\u307E\u3088\u3046
\u307E\u308D\u3084\u304B
\u307E\u308F\u3059
\u307E\u308F\u308A
\u307E\u308F\u308B
\u307E\u3093\u304B\u3099
\u307E\u3093\u304D\u3064
\u307E\u3093\u305D\u3099\u304F
\u307E\u3093\u306A\u304B
\u307F\u3044\u3089
\u307F\u3046\u3061
\u307F\u3048\u308B
\u307F\u304B\u3099\u304F
\u307F\u304B\u305F
\u307F\u304B\u3093
\u307F\u3051\u3093
\u307F\u3053\u3093
\u307F\u3057\u3099\u304B\u3044
\u307F\u3059\u3044
\u307F\u3059\u3048\u308B
\u307F\u305B\u308B
\u307F\u3063\u304B
\u307F\u3064\u304B\u308B
\u307F\u3064\u3051\u308B
\u307F\u3066\u3044
\u307F\u3068\u3081\u308B
\u307F\u306A\u3068
\u307F\u306A\u307F\u304B\u3055\u3044
\u307F\u306D\u3089\u308B
\u307F\u306E\u3046
\u307F\u306E\u304B\u3099\u3059
\u307F\u307B\u3093
\u307F\u3082\u3068
\u307F\u3084\u3051\u3099
\u307F\u3089\u3044
\u307F\u308A\u3087\u304F
\u307F\u308F\u304F
\u307F\u3093\u304B
\u307F\u3093\u305D\u3099\u304F
\u3080\u3044\u304B
\u3080\u3048\u304D
\u3080\u3048\u3093
\u3080\u304B\u3044
\u3080\u304B\u3046
\u3080\u304B\u3048
\u3080\u304B\u3057
\u3080\u304D\u3099\u3061\u3083
\u3080\u3051\u308B
\u3080\u3051\u3099\u3093
\u3080\u3055\u307B\u3099\u308B
\u3080\u3057\u3042\u3064\u3044
\u3080\u3057\u306F\u3099
\u3080\u3057\u3099\u3085\u3093
\u3080\u3057\u308D
\u3080\u3059\u3046
\u3080\u3059\u3053
\u3080\u3059\u3075\u3099
\u3080\u3059\u3081
\u3080\u305B\u308B
\u3080\u305B\u3093
\u3080\u3061\u3085\u3046
\u3080\u306A\u3057\u3044
\u3080\u306E\u3046
\u3080\u3084\u307F
\u3080\u3088\u3046
\u3080\u3089\u3055\u304D
\u3080\u308A\u3087\u3046
\u3080\u308D\u3093
\u3081\u3044\u3042\u3093
\u3081\u3044\u3046\u3093
\u3081\u3044\u3048\u3093
\u3081\u3044\u304B\u304F
\u3081\u3044\u304D\u3087\u304F
\u3081\u3044\u3055\u3044
\u3081\u3044\u3057
\u3081\u3044\u305D\u3046
\u3081\u3044\u3075\u3099\u3064
\u3081\u3044\u308C\u3044
\u3081\u3044\u308F\u304F
\u3081\u304F\u3099\u307E\u308C\u308B
\u3081\u3055\u3099\u3059
\u3081\u3057\u305F
\u3081\u3059\u3099\u3089\u3057\u3044
\u3081\u305F\u3099\u3064
\u3081\u307E\u3044
\u3081\u3084\u3059
\u3081\u3093\u304D\u3087
\u3081\u3093\u305B\u304D
\u3081\u3093\u3068\u3099\u3046
\u3082\u3046\u3057\u3042\u3051\u3099\u308B
\u3082\u3046\u3068\u3099\u3046\u3051\u3093
\u3082\u3048\u308B
\u3082\u304F\u3057
\u3082\u304F\u3066\u304D
\u3082\u304F\u3088\u3046\u3072\u3099
\u3082\u3061\u308D\u3093
\u3082\u3068\u3099\u308B
\u3082\u3089\u3046
\u3082\u3093\u304F
\u3082\u3093\u305F\u3099\u3044
\u3084\u304A\u3084
\u3084\u3051\u308B
\u3084\u3055\u3044
\u3084\u3055\u3057\u3044
\u3084\u3059\u3044
\u3084\u3059\u305F\u308D\u3046
\u3084\u3059\u307F
\u3084\u305B\u308B
\u3084\u305D\u3046
\u3084\u305F\u3044
\u3084\u3061\u3093
\u3084\u3063\u3068
\u3084\u3063\u306F\u309A\u308A
\u3084\u3075\u3099\u308B
\u3084\u3081\u308B
\u3084\u3084\u3053\u3057\u3044
\u3084\u3088\u3044
\u3084\u308F\u3089\u304B\u3044
\u3086\u3046\u304D
\u3086\u3046\u3072\u3099\u3093\u304D\u3087\u304F
\u3086\u3046\u3078\u3099
\u3086\u3046\u3081\u3044
\u3086\u3051\u3064
\u3086\u3057\u3085\u3064
\u3086\u305B\u3093
\u3086\u305D\u3046
\u3086\u305F\u304B
\u3086\u3061\u3083\u304F
\u3086\u3066\u3099\u308B
\u3086\u306B\u3085\u3046
\u3086\u3072\u3099\u308F
\u3086\u3089\u3044
\u3086\u308C\u308B
\u3088\u3046\u3044
\u3088\u3046\u304B
\u3088\u3046\u304D\u3085\u3046
\u3088\u3046\u3057\u3099
\u3088\u3046\u3059
\u3088\u3046\u3061\u3048\u3093
\u3088\u304B\u305B\u3099
\u3088\u304B\u3093
\u3088\u304D\u3093
\u3088\u304F\u305B\u3044
\u3088\u304F\u307B\u3099\u3046
\u3088\u3051\u3044
\u3088\u3053\u3099\u308C\u308B
\u3088\u3055\u3093
\u3088\u3057\u3085\u3046
\u3088\u305D\u3046
\u3088\u305D\u304F
\u3088\u3063\u304B
\u3088\u3066\u3044
\u3088\u3068\u3099\u304B\u3099\u308F\u304F
\u3088\u306D\u3064
\u3088\u3084\u304F
\u3088\u3086\u3046
\u3088\u308D\u3053\u3075\u3099
\u3088\u308D\u3057\u3044
\u3089\u3044\u3046
\u3089\u304F\u304B\u3099\u304D
\u3089\u304F\u3053\u3099
\u3089\u304F\u3055\u3064
\u3089\u304F\u305F\u3099
\u3089\u3057\u3093\u306F\u3099\u3093
\u3089\u305B\u3093
\u3089\u305D\u3099\u304F
\u3089\u305F\u3044
\u3089\u3063\u304B
\u3089\u308C\u3064
\u308A\u3048\u304D
\u308A\u304B\u3044
\u308A\u304D\u3055\u304F
\u308A\u304D\u305B\u3064
\u308A\u304F\u304F\u3099\u3093
\u308A\u304F\u3064
\u308A\u3051\u3093
\u308A\u3053\u3046
\u308A\u305B\u3044
\u308A\u305D\u3046
\u308A\u305D\u304F
\u308A\u3066\u3093
\u308A\u306D\u3093
\u308A\u3086\u3046
\u308A\u3085\u3046\u304B\u3099\u304F
\u308A\u3088\u3046
\u308A\u3087\u3046\u308A
\u308A\u3087\u304B\u3093
\u308A\u3087\u304F\u3061\u3083
\u308A\u3087\u3053\u3046
\u308A\u308A\u304F
\u308A\u308C\u304D
\u308A\u308D\u3093
\u308A\u3093\u3053\u3099
\u308B\u3044\u3051\u3044
\u308B\u3044\u3055\u3044
\u308B\u3044\u3057\u3099
\u308B\u3044\u305B\u304D
\u308B\u3059\u306F\u3099\u3093
\u308B\u308A\u304B\u3099\u308F\u3089
\u308C\u3044\u304B\u3093
\u308C\u3044\u304D\u3099
\u308C\u3044\u305B\u3044
\u308C\u3044\u305D\u3099\u3046\u3053
\u308C\u3044\u3068\u3046
\u308C\u3044\u307B\u3099\u3046
\u308C\u304D\u3057
\u308C\u304D\u305F\u3099\u3044
\u308C\u3093\u3042\u3044
\u308C\u3093\u3051\u3044
\u308C\u3093\u3053\u3093
\u308C\u3093\u3055\u3044
\u308C\u3093\u3057\u3085\u3046
\u308C\u3093\u305D\u3099\u304F
\u308C\u3093\u3089\u304F
\u308D\u3046\u304B
\u308D\u3046\u3053\u3099
\u308D\u3046\u3057\u3099\u3093
\u308D\u3046\u305D\u304F
\u308D\u304F\u304B\u3099
\u308D\u3053\u3064
\u308D\u3057\u3099\u3046\u3089
\u308D\u3057\u3085\u3064
\u308D\u305B\u3093
\u308D\u3066\u3093
\u308D\u3081\u3093
\u308D\u308C\u3064
\u308D\u3093\u304D\u3099
\u308D\u3093\u306F\u309A
\u308D\u3093\u3075\u3099\u3093
\u308D\u3093\u308A
\u308F\u304B\u3059
\u308F\u304B\u3081
\u308F\u304B\u3084\u307E
\u308F\u304B\u308C\u308B
\u308F\u3057\u3064
\u308F\u3057\u3099\u307E\u3057
\u308F\u3059\u308C\u3082\u306E
\u308F\u3089\u3046
\u308F\u308C\u308B`,Fl=Rl.split(`
`);var Kl=`\u1100\u1161\u1100\u1167\u11A8
\u1100\u1161\u1101\u1173\u11B7
\u1100\u1161\u1102\u1161\u11AB
\u1100\u1161\u1102\u1173\u11BC
\u1100\u1161\u1103\u1173\u11A8
\u1100\u1161\u1105\u1173\u110E\u1175\u11B7
\u1100\u1161\u1106\u116E\u11B7
\u1100\u1161\u1107\u1161\u11BC
\u1100\u1161\u1109\u1161\u11BC
\u1100\u1161\u1109\u1173\u11B7
\u1100\u1161\u110B\u116E\u11AB\u1103\u1166
\u1100\u1161\u110B\u1173\u11AF
\u1100\u1161\u110B\u1175\u1103\u1173
\u1100\u1161\u110B\u1175\u11B8
\u1100\u1161\u110C\u1161\u11BC
\u1100\u1161\u110C\u1165\u11BC
\u1100\u1161\u110C\u1169\u11A8
\u1100\u1161\u110C\u116E\u11A8
\u1100\u1161\u11A8\u110B\u1169
\u1100\u1161\u11A8\u110C\u1161
\u1100\u1161\u11AB\u1100\u1167\u11A8
\u1100\u1161\u11AB\u1107\u116E
\u1100\u1161\u11AB\u1109\u1165\u11B8
\u1100\u1161\u11AB\u110C\u1161\u11BC
\u1100\u1161\u11AB\u110C\u1165\u11B8
\u1100\u1161\u11AB\u1111\u1161\u11AB
\u1100\u1161\u11AF\u1103\u1173\u11BC
\u1100\u1161\u11AF\u1107\u1175
\u1100\u1161\u11AF\u1109\u1162\u11A8
\u1100\u1161\u11AF\u110C\u1173\u11BC
\u1100\u1161\u11B7\u1100\u1161\u11A8
\u1100\u1161\u11B7\u1100\u1175
\u1100\u1161\u11B7\u1109\u1169
\u1100\u1161\u11B7\u1109\u116E\u1109\u1165\u11BC
\u1100\u1161\u11B7\u110C\u1161
\u1100\u1161\u11B7\u110C\u1165\u11BC
\u1100\u1161\u11B8\u110C\u1161\u1100\u1175
\u1100\u1161\u11BC\u1102\u1161\u11B7
\u1100\u1161\u11BC\u1103\u1161\u11BC
\u1100\u1161\u11BC\u1103\u1169
\u1100\u1161\u11BC\u1105\u1167\u11A8\u1112\u1175
\u1100\u1161\u11BC\u1107\u1167\u11AB
\u1100\u1161\u11BC\u1107\u116E\u11A8
\u1100\u1161\u11BC\u1109\u1161
\u1100\u1161\u11BC\u1109\u116E\u1105\u1163\u11BC
\u1100\u1161\u11BC\u110B\u1161\u110C\u1175
\u1100\u1161\u11BC\u110B\u116F\u11AB\u1103\u1169
\u1100\u1161\u11BC\u110B\u1174
\u1100\u1161\u11BC\u110C\u1166
\u1100\u1161\u11BC\u110C\u1169
\u1100\u1161\u11C0\u110B\u1175
\u1100\u1162\u1100\u116E\u1105\u1175
\u1100\u1162\u1102\u1161\u1105\u1175
\u1100\u1162\u1107\u1161\u11BC
\u1100\u1162\u1107\u1167\u11AF
\u1100\u1162\u1109\u1165\u11AB
\u1100\u1162\u1109\u1165\u11BC
\u1100\u1162\u110B\u1175\u11AB
\u1100\u1162\u11A8\u1100\u116A\u11AB\u110C\u1165\u11A8
\u1100\u1165\u1109\u1175\u11AF
\u1100\u1165\u110B\u1162\u11A8
\u1100\u1165\u110B\u116E\u11AF
\u1100\u1165\u110C\u1175\u11BA
\u1100\u1165\u1111\u116E\u11B7
\u1100\u1165\u11A8\u110C\u1165\u11BC
\u1100\u1165\u11AB\u1100\u1161\u11BC
\u1100\u1165\u11AB\u1106\u116E\u11AF
\u1100\u1165\u11AB\u1109\u1165\u11AF
\u1100\u1165\u11AB\u110C\u1169
\u1100\u1165\u11AB\u110E\u116E\u11A8
\u1100\u1165\u11AF\u110B\u1173\u11B7
\u1100\u1165\u11B7\u1109\u1161
\u1100\u1165\u11B7\u1110\u1169
\u1100\u1166\u1109\u1175\u1111\u1161\u11AB
\u1100\u1166\u110B\u1175\u11B7
\u1100\u1167\u110B\u116E\u11AF
\u1100\u1167\u11AB\u1112\u1162
\u1100\u1167\u11AF\u1100\u116A
\u1100\u1167\u11AF\u1100\u116E\u11A8
\u1100\u1167\u11AF\u1105\u1169\u11AB
\u1100\u1167\u11AF\u1109\u1165\u11A8
\u1100\u1167\u11AF\u1109\u1173\u11BC
\u1100\u1167\u11AF\u1109\u1175\u11B7
\u1100\u1167\u11AF\u110C\u1165\u11BC
\u1100\u1167\u11AF\u1112\u1169\u11AB
\u1100\u1167\u11BC\u1100\u1168
\u1100\u1167\u11BC\u1100\u1169
\u1100\u1167\u11BC\u1100\u1175
\u1100\u1167\u11BC\u1105\u1167\u11A8
\u1100\u1167\u11BC\u1107\u1169\u11A8\u1100\u116E\u11BC
\u1100\u1167\u11BC\u1107\u1175
\u1100\u1167\u11BC\u1109\u1161\u11BC\u1103\u1169
\u1100\u1167\u11BC\u110B\u1167\u11BC
\u1100\u1167\u11BC\u110B\u116E
\u1100\u1167\u11BC\u110C\u1162\u11BC
\u1100\u1167\u11BC\u110C\u1166
\u1100\u1167\u11BC\u110C\u116E
\u1100\u1167\u11BC\u110E\u1161\u11AF
\u1100\u1167\u11BC\u110E\u1175
\u1100\u1167\u11BC\u1112\u1163\u11BC
\u1100\u1167\u11BC\u1112\u1165\u11B7
\u1100\u1168\u1100\u1169\u11A8
\u1100\u1168\u1103\u1161\u11AB
\u1100\u1168\u1105\u1161\u11AB
\u1100\u1168\u1109\u1161\u11AB
\u1100\u1168\u1109\u1169\u11A8
\u1100\u1168\u110B\u1163\u11A8
\u1100\u1168\u110C\u1165\u11AF
\u1100\u1168\u110E\u1173\u11BC
\u1100\u1168\u1112\u116C\u11A8
\u1100\u1169\u1100\u1162\u11A8
\u1100\u1169\u1100\u116E\u1105\u1167
\u1100\u1169\u1100\u116E\u11BC
\u1100\u1169\u1100\u1173\u11B8
\u1100\u1169\u1103\u1173\u11BC\u1112\u1161\u11A8\u1109\u1162\u11BC
\u1100\u1169\u1106\u116E\u1109\u1175\u11AB
\u1100\u1169\u1106\u1175\u11AB
\u1100\u1169\u110B\u1163\u11BC\u110B\u1175
\u1100\u1169\u110C\u1161\u11BC
\u1100\u1169\u110C\u1165\u11AB
\u1100\u1169\u110C\u1175\u11B8
\u1100\u1169\u110E\u116E\u11BA\u1100\u1161\u1105\u116E
\u1100\u1169\u1110\u1169\u11BC
\u1100\u1169\u1112\u1163\u11BC
\u1100\u1169\u11A8\u1109\u1175\u11A8
\u1100\u1169\u11AF\u1106\u1169\u11A8
\u1100\u1169\u11AF\u110D\u1161\u1100\u1175
\u1100\u1169\u11AF\u1111\u1173
\u1100\u1169\u11BC\u1100\u1161\u11AB
\u1100\u1169\u11BC\u1100\u1162
\u1100\u1169\u11BC\u1100\u1167\u11A8
\u1100\u1169\u11BC\u1100\u116E\u11AB
\u1100\u1169\u11BC\u1100\u1173\u11B8
\u1100\u1169\u11BC\u1100\u1175
\u1100\u1169\u11BC\u1103\u1169\u11BC
\u1100\u1169\u11BC\u1106\u116E\u110B\u116F\u11AB
\u1100\u1169\u11BC\u1107\u116E
\u1100\u1169\u11BC\u1109\u1161
\u1100\u1169\u11BC\u1109\u1175\u11A8
\u1100\u1169\u11BC\u110B\u1165\u11B8
\u1100\u1169\u11BC\u110B\u1167\u11AB
\u1100\u1169\u11BC\u110B\u116F\u11AB
\u1100\u1169\u11BC\u110C\u1161\u11BC
\u1100\u1169\u11BC\u110D\u1161
\u1100\u1169\u11BC\u110E\u1162\u11A8
\u1100\u1169\u11BC\u1110\u1169\u11BC
\u1100\u1169\u11BC\u1111\u1169
\u1100\u1169\u11BC\u1112\u1161\u11BC
\u1100\u1169\u11BC\u1112\u1172\u110B\u1175\u11AF
\u1100\u116A\u1106\u1169\u11A8
\u1100\u116A\u110B\u1175\u11AF
\u1100\u116A\u110C\u1161\u11BC
\u1100\u116A\u110C\u1165\u11BC
\u1100\u116A\u1112\u1161\u11A8
\u1100\u116A\u11AB\u1100\u1162\u11A8
\u1100\u116A\u11AB\u1100\u1168
\u1100\u116A\u11AB\u1100\u116A\u11BC
\u1100\u116A\u11AB\u1102\u1167\u11B7
\u1100\u116A\u11AB\u1105\u1161\u11B7
\u1100\u116A\u11AB\u1105\u1167\u11AB
\u1100\u116A\u11AB\u1105\u1175
\u1100\u116A\u11AB\u1109\u1173\u11B8
\u1100\u116A\u11AB\u1109\u1175\u11B7
\u1100\u116A\u11AB\u110C\u1165\u11B7
\u1100\u116A\u11AB\u110E\u1161\u11AF
\u1100\u116A\u11BC\u1100\u1167\u11BC
\u1100\u116A\u11BC\u1100\u1169
\u1100\u116A\u11BC\u110C\u1161\u11BC
\u1100\u116A\u11BC\u110C\u116E
\u1100\u116C\u1105\u1169\u110B\u116E\u11B7
\u1100\u116C\u11BC\u110C\u1161\u11BC\u1112\u1175
\u1100\u116D\u1100\u116A\u1109\u1165
\u1100\u116D\u1106\u116E\u11AB
\u1100\u116D\u1107\u1169\u11A8
\u1100\u116D\u1109\u1175\u11AF
\u1100\u116D\u110B\u1163\u11BC
\u1100\u116D\u110B\u1172\u11A8
\u1100\u116D\u110C\u1161\u11BC
\u1100\u116D\u110C\u1175\u11A8
\u1100\u116D\u1110\u1169\u11BC
\u1100\u116D\u1112\u116A\u11AB
\u1100\u116D\u1112\u116E\u11AB
\u1100\u116E\u1100\u1167\u11BC
\u1100\u116E\u1105\u1173\u11B7
\u1100\u116E\u1106\u1165\u11BC
\u1100\u116E\u1107\u1167\u11AF
\u1100\u116E\u1107\u116E\u11AB
\u1100\u116E\u1109\u1165\u11A8
\u1100\u116E\u1109\u1165\u11BC
\u1100\u116E\u1109\u1169\u11A8
\u1100\u116E\u110B\u1167\u11A8
\u1100\u116E\u110B\u1175\u11B8
\u1100\u116E\u110E\u1165\u11BC
\u1100\u116E\u110E\u1166\u110C\u1165\u11A8
\u1100\u116E\u11A8\u1100\u1161
\u1100\u116E\u11A8\u1100\u1175
\u1100\u116E\u11A8\u1102\u1162
\u1100\u116E\u11A8\u1105\u1175\u11B8
\u1100\u116E\u11A8\u1106\u116E\u11AF
\u1100\u116E\u11A8\u1106\u1175\u11AB
\u1100\u116E\u11A8\u1109\u116E
\u1100\u116E\u11A8\u110B\u1165
\u1100\u116E\u11A8\u110B\u116A\u11BC
\u1100\u116E\u11A8\u110C\u1165\u11A8
\u1100\u116E\u11A8\u110C\u1166
\u1100\u116E\u11A8\u1112\u116C
\u1100\u116E\u11AB\u1103\u1162
\u1100\u116E\u11AB\u1109\u1161
\u1100\u116E\u11AB\u110B\u1175\u11AB
\u1100\u116E\u11BC\u1100\u1173\u11A8\u110C\u1165\u11A8
\u1100\u116F\u11AB\u1105\u1175
\u1100\u116F\u11AB\u110B\u1171
\u1100\u116F\u11AB\u1110\u116E
\u1100\u1171\u1100\u116E\u11A8
\u1100\u1171\u1109\u1175\u11AB
\u1100\u1172\u110C\u1165\u11BC
\u1100\u1172\u110E\u1175\u11A8
\u1100\u1172\u11AB\u1112\u1167\u11BC
\u1100\u1173\u1102\u1161\u11AF
\u1100\u1173\u1102\u1163\u11BC
\u1100\u1173\u1102\u1173\u11AF
\u1100\u1173\u1105\u1165\u1102\u1161
\u1100\u1173\u1105\u116E\u11B8
\u1100\u1173\u1105\u1173\u11BA
\u1100\u1173\u1105\u1175\u11B7
\u1100\u1173\u110C\u1166\u1109\u1165\u110B\u1163
\u1100\u1173\u1110\u1169\u1105\u1169\u11A8
\u1100\u1173\u11A8\u1107\u1169\u11A8
\u1100\u1173\u11A8\u1112\u1175
\u1100\u1173\u11AB\u1100\u1165
\u1100\u1173\u11AB\u1100\u116D
\u1100\u1173\u11AB\u1105\u1162
\u1100\u1173\u11AB\u1105\u1169
\u1100\u1173\u11AB\u1106\u116E
\u1100\u1173\u11AB\u1107\u1169\u11AB
\u1100\u1173\u11AB\u110B\u116F\u11AB
\u1100\u1173\u11AB\u110B\u1172\u11A8
\u1100\u1173\u11AB\u110E\u1165
\u1100\u1173\u11AF\u110A\u1175
\u1100\u1173\u11AF\u110C\u1161
\u1100\u1173\u11B7\u1100\u1161\u11BC\u1109\u1161\u11AB
\u1100\u1173\u11B7\u1100\u1169
\u1100\u1173\u11B7\u1102\u1167\u11AB
\u1100\u1173\u11B7\u1106\u1166\u1103\u1161\u11AF
\u1100\u1173\u11B7\u110B\u1162\u11A8
\u1100\u1173\u11B7\u110B\u1167\u11AB
\u1100\u1173\u11B7\u110B\u116D\u110B\u1175\u11AF
\u1100\u1173\u11B7\u110C\u1175
\u1100\u1173\u11BC\u110C\u1165\u11BC\u110C\u1165\u11A8
\u1100\u1175\u1100\u1161\u11AB
\u1100\u1175\u1100\u116A\u11AB
\u1100\u1175\u1102\u1167\u11B7
\u1100\u1175\u1102\u1173\u11BC
\u1100\u1175\u1103\u1169\u11A8\u1100\u116D
\u1100\u1175\u1103\u116E\u11BC
\u1100\u1175\u1105\u1169\u11A8
\u1100\u1175\u1105\u1173\u11B7
\u1100\u1175\u1107\u1165\u11B8
\u1100\u1175\u1107\u1169\u11AB
\u1100\u1175\u1107\u116E\u11AB
\u1100\u1175\u1108\u1173\u11B7
\u1100\u1175\u1109\u116E\u11A8\u1109\u1161
\u1100\u1175\u1109\u116E\u11AF
\u1100\u1175\u110B\u1165\u11A8
\u1100\u1175\u110B\u1165\u11B8
\u1100\u1175\u110B\u1169\u11AB
\u1100\u1175\u110B\u116E\u11AB
\u1100\u1175\u110B\u116F\u11AB
\u1100\u1175\u110C\u1165\u11A8
\u1100\u1175\u110C\u116E\u11AB
\u1100\u1175\u110E\u1175\u11B7
\u1100\u1175\u1112\u1169\u11AB
\u1100\u1175\u1112\u116C\u11A8
\u1100\u1175\u11AB\u1100\u1173\u11B8
\u1100\u1175\u11AB\u110C\u1161\u11BC
\u1100\u1175\u11AF\u110B\u1175
\u1100\u1175\u11B7\u1107\u1161\u11B8
\u1100\u1175\u11B7\u110E\u1175
\u1100\u1175\u11B7\u1111\u1169\u1100\u1169\u11BC\u1112\u1161\u11BC
\u1101\u1161\u11A8\u1103\u116E\u1100\u1175
\u1101\u1161\u11B7\u1108\u1161\u11A8
\u1101\u1162\u1103\u1161\u11AF\u110B\u1173\u11B7
\u1101\u1162\u1109\u1169\u1100\u1173\u11B7
\u1101\u1165\u11B8\u110C\u1175\u11AF
\u1101\u1169\u11A8\u1103\u1162\u1100\u1175
\u1101\u1169\u11BE\u110B\u1175\u11C1
\u1102\u1161\u1103\u1173\u11AF\u110B\u1175
\u1102\u1161\u1105\u1161\u11AB\u1112\u1175
\u1102\u1161\u1106\u1165\u110C\u1175
\u1102\u1161\u1106\u116E\u11AF
\u1102\u1161\u110E\u1175\u11B7\u1107\u1161\u11AB
\u1102\u1161\u1112\u1173\u11AF
\u1102\u1161\u11A8\u110B\u1167\u11B8
\u1102\u1161\u11AB\u1107\u1161\u11BC
\u1102\u1161\u11AF\u1100\u1162
\u1102\u1161\u11AF\u110A\u1175
\u1102\u1161\u11AF\u110D\u1161
\u1102\u1161\u11B7\u1102\u1167
\u1102\u1161\u11B7\u1103\u1162\u1106\u116E\u11AB
\u1102\u1161\u11B7\u1106\u1162
\u1102\u1161\u11B7\u1109\u1161\u11AB
\u1102\u1161\u11B7\u110C\u1161
\u1102\u1161\u11B7\u1111\u1167\u11AB
\u1102\u1161\u11B7\u1112\u1161\u11A8\u1109\u1162\u11BC
\u1102\u1161\u11BC\u1107\u1175
\u1102\u1161\u11C0\u1106\u1161\u11AF
\u1102\u1162\u1102\u1167\u11AB
\u1102\u1162\u110B\u116D\u11BC
\u1102\u1162\u110B\u1175\u11AF
\u1102\u1162\u11B7\u1107\u1175
\u1102\u1162\u11B7\u1109\u1162
\u1102\u1162\u11BA\u1106\u116E\u11AF
\u1102\u1162\u11BC\u1103\u1169\u11BC
\u1102\u1162\u11BC\u1106\u1167\u11AB
\u1102\u1162\u11BC\u1107\u1161\u11BC
\u1102\u1162\u11BC\u110C\u1161\u11BC\u1100\u1169
\u1102\u1166\u11A8\u1110\u1161\u110B\u1175
\u1102\u1166\u11BA\u110D\u1162
\u1102\u1169\u1103\u1169\u11BC
\u1102\u1169\u1105\u1161\u11AB\u1109\u1162\u11A8
\u1102\u1169\u1105\u1167\u11A8
\u1102\u1169\u110B\u1175\u11AB
\u1102\u1169\u11A8\u110B\u1173\u11B7
\u1102\u1169\u11A8\u110E\u1161
\u1102\u1169\u11A8\u1112\u116A
\u1102\u1169\u11AB\u1105\u1175
\u1102\u1169\u11AB\u1106\u116E\u11AB
\u1102\u1169\u11AB\u110C\u1162\u11BC
\u1102\u1169\u11AF\u110B\u1175
\u1102\u1169\u11BC\u1100\u116E
\u1102\u1169\u11BC\u1103\u1161\u11B7
\u1102\u1169\u11BC\u1106\u1175\u11AB
\u1102\u1169\u11BC\u1107\u116E
\u1102\u1169\u11BC\u110B\u1165\u11B8
\u1102\u1169\u11BC\u110C\u1161\u11BC
\u1102\u1169\u11BC\u110E\u1169\u11AB
\u1102\u1169\u11C1\u110B\u1175
\u1102\u116E\u11AB\u1103\u1169\u11BC\u110C\u1161
\u1102\u116E\u11AB\u1106\u116E\u11AF
\u1102\u116E\u11AB\u110A\u1165\u11B8
\u1102\u1172\u110B\u116D\u11A8
\u1102\u1173\u1101\u1175\u11B7
\u1102\u1173\u11A8\u1103\u1162
\u1102\u1173\u11BC\u1103\u1169\u11BC\u110C\u1165\u11A8
\u1102\u1173\u11BC\u1105\u1167\u11A8
\u1103\u1161\u1107\u1161\u11BC
\u1103\u1161\u110B\u1163\u11BC\u1109\u1165\u11BC
\u1103\u1161\u110B\u1173\u11B7
\u1103\u1161\u110B\u1175\u110B\u1165\u1110\u1173
\u1103\u1161\u1112\u1162\u11BC
\u1103\u1161\u11AB\u1100\u1168
\u1103\u1161\u11AB\u1100\u1169\u11AF
\u1103\u1161\u11AB\u1103\u1169\u11A8
\u1103\u1161\u11AB\u1106\u1161\u11BA
\u1103\u1161\u11AB\u1109\u116E\u11AB
\u1103\u1161\u11AB\u110B\u1165
\u1103\u1161\u11AB\u110B\u1171
\u1103\u1161\u11AB\u110C\u1165\u11B7
\u1103\u1161\u11AB\u110E\u1166
\u1103\u1161\u11AB\u110E\u116E
\u1103\u1161\u11AB\u1111\u1167\u11AB
\u1103\u1161\u11AB\u1111\u116E\u11BC
\u1103\u1161\u11AF\u1100\u1163\u11AF
\u1103\u1161\u11AF\u1105\u1165
\u1103\u1161\u11AF\u1105\u1167\u11A8
\u1103\u1161\u11AF\u1105\u1175
\u1103\u1161\u11B0\u1100\u1169\u1100\u1175
\u1103\u1161\u11B7\u1103\u1161\u11BC
\u1103\u1161\u11B7\u1107\u1162
\u1103\u1161\u11B7\u110B\u116D
\u1103\u1161\u11B7\u110B\u1175\u11B7
\u1103\u1161\u11B8\u1107\u1167\u11AB
\u1103\u1161\u11B8\u110C\u1161\u11BC
\u1103\u1161\u11BC\u1100\u1173\u11AB
\u1103\u1161\u11BC\u1107\u116E\u11AB\u1100\u1161\u11AB
\u1103\u1161\u11BC\u110B\u1167\u11AB\u1112\u1175
\u1103\u1161\u11BC\u110C\u1161\u11BC
\u1103\u1162\u1100\u1172\u1106\u1169
\u1103\u1162\u1102\u1161\u11BD
\u1103\u1162\u1103\u1161\u11AB\u1112\u1175
\u1103\u1162\u1103\u1161\u11B8
\u1103\u1162\u1103\u1169\u1109\u1175
\u1103\u1162\u1105\u1163\u11A8
\u1103\u1162\u1105\u1163\u11BC
\u1103\u1162\u1105\u1172\u11A8
\u1103\u1162\u1106\u116E\u11AB
\u1103\u1162\u1107\u116E\u1107\u116E\u11AB
\u1103\u1162\u1109\u1175\u11AB
\u1103\u1162\u110B\u1173\u11BC
\u1103\u1162\u110C\u1161\u11BC
\u1103\u1162\u110C\u1165\u11AB
\u1103\u1162\u110C\u1165\u11B8
\u1103\u1162\u110C\u116E\u11BC
\u1103\u1162\u110E\u1162\u11A8
\u1103\u1162\u110E\u116E\u11AF
\u1103\u1162\u110E\u116E\u11BC
\u1103\u1162\u1110\u1169\u11BC\u1105\u1167\u11BC
\u1103\u1162\u1112\u1161\u11A8
\u1103\u1162\u1112\u1161\u11AB\u1106\u1175\u11AB\u1100\u116E\u11A8
\u1103\u1162\u1112\u1161\u11B8\u1109\u1175\u11AF
\u1103\u1162\u1112\u1167\u11BC
\u1103\u1165\u11BC\u110B\u1165\u1105\u1175
\u1103\u1166\u110B\u1175\u1110\u1173
\u1103\u1169\u1103\u1162\u110E\u1166
\u1103\u1169\u1103\u1165\u11A8
\u1103\u1169\u1103\u116E\u11A8
\u1103\u1169\u1106\u1161\u11BC
\u1103\u1169\u1109\u1165\u1100\u116A\u11AB
\u1103\u1169\u1109\u1175\u11B7
\u1103\u1169\u110B\u116E\u11B7
\u1103\u1169\u110B\u1175\u11B8
\u1103\u1169\u110C\u1161\u1100\u1175
\u1103\u1169\u110C\u1165\u1112\u1175
\u1103\u1169\u110C\u1165\u11AB
\u1103\u1169\u110C\u116E\u11BC
\u1103\u1169\u110E\u1161\u11A8
\u1103\u1169\u11A8\u1100\u1161\u11B7
\u1103\u1169\u11A8\u1105\u1175\u11B8
\u1103\u1169\u11A8\u1109\u1165
\u1103\u1169\u11A8\u110B\u1175\u11AF
\u1103\u1169\u11A8\u110E\u1161\u11BC\u110C\u1165\u11A8
\u1103\u1169\u11BC\u1112\u116A\u110E\u1162\u11A8
\u1103\u1171\u11BA\u1106\u1169\u1109\u1173\u11B8
\u1103\u1171\u11BA\u1109\u1161\u11AB
\u1104\u1161\u11AF\u110B\u1161\u110B\u1175
\u1106\u1161\u1102\u116E\u1105\u1161
\u1106\u1161\u1102\u1173\u11AF
\u1106\u1161\u1103\u1161\u11BC
\u1106\u1161\u1105\u1161\u1110\u1169\u11AB
\u1106\u1161\u1105\u1167\u11AB
\u1106\u1161\u1106\u116E\u1105\u1175
\u1106\u1161\u1109\u1161\u110C\u1175
\u1106\u1161\u110B\u1163\u11A8
\u1106\u1161\u110B\u116D\u1102\u1166\u110C\u1173
\u1106\u1161\u110B\u1173\u11AF
\u1106\u1161\u110B\u1173\u11B7
\u1106\u1161\u110B\u1175\u110F\u1173
\u1106\u1161\u110C\u116E\u11BC
\u1106\u1161\u110C\u1175\u1106\u1161\u11A8
\u1106\u1161\u110E\u1161\u11AB\u1100\u1161\u110C\u1175
\u1106\u1161\u110E\u1161\u11AF
\u1106\u1161\u1112\u1173\u11AB
\u1106\u1161\u11A8\u1100\u1165\u11AF\u1105\u1175
\u1106\u1161\u11A8\u1102\u1162
\u1106\u1161\u11A8\u1109\u1161\u11BC
\u1106\u1161\u11AB\u1102\u1161\u11B7
\u1106\u1161\u11AB\u1103\u116E
\u1106\u1161\u11AB\u1109\u1166
\u1106\u1161\u11AB\u110B\u1163\u11A8
\u1106\u1161\u11AB\u110B\u1175\u11AF
\u1106\u1161\u11AB\u110C\u1165\u11B7
\u1106\u1161\u11AB\u110C\u1169\u11A8
\u1106\u1161\u11AB\u1112\u116A
\u1106\u1161\u11AD\u110B\u1175
\u1106\u1161\u11AF\u1100\u1175
\u1106\u1161\u11AF\u110A\u1173\u11B7
\u1106\u1161\u11AF\u1110\u116E
\u1106\u1161\u11B7\u1103\u1162\u1105\u1169
\u1106\u1161\u11BC\u110B\u116F\u11AB\u1100\u1167\u11BC
\u1106\u1162\u1102\u1167\u11AB
\u1106\u1162\u1103\u1161\u11AF
\u1106\u1162\u1105\u1167\u11A8
\u1106\u1162\u1107\u1165\u11AB
\u1106\u1162\u1109\u1173\u110F\u1165\u11B7
\u1106\u1162\u110B\u1175\u11AF
\u1106\u1162\u110C\u1161\u11BC
\u1106\u1162\u11A8\u110C\u116E
\u1106\u1165\u11A8\u110B\u1175
\u1106\u1165\u11AB\u110C\u1165
\u1106\u1165\u11AB\u110C\u1175
\u1106\u1165\u11AF\u1105\u1175
\u1106\u1166\u110B\u1175\u11AF
\u1106\u1167\u1102\u1173\u1105\u1175
\u1106\u1167\u110E\u1175\u11AF
\u1106\u1167\u11AB\u1103\u1161\u11B7
\u1106\u1167\u11AF\u110E\u1175
\u1106\u1167\u11BC\u1103\u1161\u11AB
\u1106\u1167\u11BC\u1105\u1167\u11BC
\u1106\u1167\u11BC\u110B\u1168
\u1106\u1167\u11BC\u110B\u1174
\u1106\u1167\u11BC\u110C\u1165\u11AF
\u1106\u1167\u11BC\u110E\u1175\u11BC
\u1106\u1167\u11BC\u1112\u1161\u11B7
\u1106\u1169\u1100\u1173\u11B7
\u1106\u1169\u1102\u1175\u1110\u1165
\u1106\u1169\u1103\u1166\u11AF
\u1106\u1169\u1103\u1173\u11AB
\u1106\u1169\u1107\u1165\u11B7
\u1106\u1169\u1109\u1173\u11B8
\u1106\u1169\u110B\u1163\u11BC
\u1106\u1169\u110B\u1175\u11B7
\u1106\u1169\u110C\u1169\u1105\u1175
\u1106\u1169\u110C\u1175\u11B8
\u1106\u1169\u1110\u116E\u11BC\u110B\u1175
\u1106\u1169\u11A8\u1100\u1165\u11AF\u110B\u1175
\u1106\u1169\u11A8\u1105\u1169\u11A8
\u1106\u1169\u11A8\u1109\u1161
\u1106\u1169\u11A8\u1109\u1169\u1105\u1175
\u1106\u1169\u11A8\u1109\u116E\u11B7
\u1106\u1169\u11A8\u110C\u1165\u11A8
\u1106\u1169\u11A8\u1111\u116D
\u1106\u1169\u11AF\u1105\u1162
\u1106\u1169\u11B7\u1106\u1162
\u1106\u1169\u11B7\u1106\u116E\u1100\u1166
\u1106\u1169\u11B7\u1109\u1161\u11AF
\u1106\u1169\u11B7\u1109\u1169\u11A8
\u1106\u1169\u11B7\u110C\u1175\u11BA
\u1106\u1169\u11B7\u1110\u1169\u11BC
\u1106\u1169\u11B8\u1109\u1175
\u1106\u116E\u1100\u116A\u11AB\u1109\u1175\u11B7
\u1106\u116E\u1100\u116E\u11BC\u1112\u116A
\u1106\u116E\u1103\u1165\u110B\u1171
\u1106\u116E\u1103\u1165\u11B7
\u1106\u116E\u1105\u1173\u11C1
\u1106\u116E\u1109\u1173\u11AB
\u1106\u116E\u110B\u1165\u11BA
\u1106\u116E\u110B\u1167\u11A8
\u1106\u116E\u110B\u116D\u11BC
\u1106\u116E\u110C\u1169\u1100\u1165\u11AB
\u1106\u116E\u110C\u1175\u1100\u1162
\u1106\u116E\u110E\u1165\u11A8
\u1106\u116E\u11AB\u1100\u116E
\u1106\u116E\u11AB\u1103\u1173\u11A8
\u1106\u116E\u11AB\u1107\u1165\u11B8
\u1106\u116E\u11AB\u1109\u1165
\u1106\u116E\u11AB\u110C\u1166
\u1106\u116E\u11AB\u1112\u1161\u11A8
\u1106\u116E\u11AB\u1112\u116A
\u1106\u116E\u11AF\u1100\u1161
\u1106\u116E\u11AF\u1100\u1165\u11AB
\u1106\u116E\u11AF\u1100\u1167\u11AF
\u1106\u116E\u11AF\u1100\u1169\u1100\u1175
\u1106\u116E\u11AF\u1105\u1169\u11AB
\u1106\u116E\u11AF\u1105\u1175\u1112\u1161\u11A8
\u1106\u116E\u11AF\u110B\u1173\u11B7
\u1106\u116E\u11AF\u110C\u1175\u11AF
\u1106\u116E\u11AF\u110E\u1166
\u1106\u1175\u1100\u116E\u11A8
\u1106\u1175\u1103\u1175\u110B\u1165
\u1106\u1175\u1109\u1161\u110B\u1175\u11AF
\u1106\u1175\u1109\u116E\u11AF
\u1106\u1175\u110B\u1167\u11A8
\u1106\u1175\u110B\u116D\u11BC\u1109\u1175\u11AF
\u1106\u1175\u110B\u116E\u11B7
\u1106\u1175\u110B\u1175\u11AB
\u1106\u1175\u1110\u1175\u11BC
\u1106\u1175\u1112\u1169\u11AB
\u1106\u1175\u11AB\u1100\u1161\u11AB
\u1106\u1175\u11AB\u110C\u1169\u11A8
\u1106\u1175\u11AB\u110C\u116E
\u1106\u1175\u11AE\u110B\u1173\u11B7
\u1106\u1175\u11AF\u1100\u1161\u1105\u116E
\u1106\u1175\u11AF\u1105\u1175\u1106\u1175\u1110\u1165
\u1106\u1175\u11C0\u1107\u1161\u1103\u1161\u11A8
\u1107\u1161\u1100\u1161\u110C\u1175
\u1107\u1161\u1100\u116E\u1102\u1175
\u1107\u1161\u1102\u1161\u1102\u1161
\u1107\u1161\u1102\u1173\u11AF
\u1107\u1161\u1103\u1161\u11A8
\u1107\u1161\u1103\u1161\u11BA\u1100\u1161
\u1107\u1161\u1105\u1161\u11B7
\u1107\u1161\u110B\u1175\u1105\u1165\u1109\u1173
\u1107\u1161\u1110\u1161\u11BC
\u1107\u1161\u11A8\u1106\u116E\u11AF\u1100\u116A\u11AB
\u1107\u1161\u11A8\u1109\u1161
\u1107\u1161\u11A8\u1109\u116E
\u1107\u1161\u11AB\u1103\u1162
\u1107\u1161\u11AB\u1103\u1173\u1109\u1175
\u1107\u1161\u11AB\u1106\u1161\u11AF
\u1107\u1161\u11AB\u1107\u1161\u11AF
\u1107\u1161\u11AB\u1109\u1165\u11BC
\u1107\u1161\u11AB\u110B\u1173\u11BC
\u1107\u1161\u11AB\u110C\u1161\u11BC
\u1107\u1161\u11AB\u110C\u116E\u11A8
\u1107\u1161\u11AB\u110C\u1175
\u1107\u1161\u11AB\u110E\u1161\u11AB
\u1107\u1161\u11AE\u110E\u1175\u11B7
\u1107\u1161\u11AF\u1100\u1161\u1105\u1161\u11A8
\u1107\u1161\u11AF\u1100\u1165\u11AF\u110B\u1173\u11B7
\u1107\u1161\u11AF\u1100\u1167\u11AB
\u1107\u1161\u11AF\u1103\u1161\u11AF
\u1107\u1161\u11AF\u1105\u1166
\u1107\u1161\u11AF\u1106\u1169\u11A8
\u1107\u1161\u11AF\u1107\u1161\u1103\u1161\u11A8
\u1107\u1161\u11AF\u1109\u1162\u11BC
\u1107\u1161\u11AF\u110B\u1173\u11B7
\u1107\u1161\u11AF\u110C\u1161\u1100\u116E\u11A8
\u1107\u1161\u11AF\u110C\u1165\u11AB
\u1107\u1161\u11AF\u1110\u1169\u11B8
\u1107\u1161\u11AF\u1111\u116D
\u1107\u1161\u11B7\u1112\u1161\u1102\u1173\u11AF
\u1107\u1161\u11B8\u1100\u1173\u1105\u1173\u11BA
\u1107\u1161\u11B8\u1106\u1161\u11BA
\u1107\u1161\u11B8\u1109\u1161\u11BC
\u1107\u1161\u11B8\u1109\u1169\u11C0
\u1107\u1161\u11BC\u1100\u1173\u11B7
\u1107\u1161\u11BC\u1106\u1167\u11AB
\u1107\u1161\u11BC\u1106\u116E\u11AB
\u1107\u1161\u11BC\u1107\u1161\u1103\u1161\u11A8
\u1107\u1161\u11BC\u1107\u1165\u11B8
\u1107\u1161\u11BC\u1109\u1169\u11BC
\u1107\u1161\u11BC\u1109\u1175\u11A8
\u1107\u1161\u11BC\u110B\u1161\u11AB
\u1107\u1161\u11BC\u110B\u116E\u11AF
\u1107\u1161\u11BC\u110C\u1175
\u1107\u1161\u11BC\u1112\u1161\u11A8
\u1107\u1161\u11BC\u1112\u1162
\u1107\u1161\u11BC\u1112\u1163\u11BC
\u1107\u1162\u1100\u1167\u11BC
\u1107\u1162\u1101\u1169\u11B8
\u1107\u1162\u1103\u1161\u11AF
\u1107\u1162\u1103\u1173\u1106\u1175\u11AB\u1110\u1165\u11AB
\u1107\u1162\u11A8\u1103\u116E\u1109\u1161\u11AB
\u1107\u1162\u11A8\u1109\u1162\u11A8
\u1107\u1162\u11A8\u1109\u1165\u11BC
\u1107\u1162\u11A8\u110B\u1175\u11AB
\u1107\u1162\u11A8\u110C\u1166
\u1107\u1162\u11A8\u1112\u116A\u110C\u1165\u11B7
\u1107\u1165\u1105\u1173\u11BA
\u1107\u1165\u1109\u1165\u11BA
\u1107\u1165\u1110\u1173\u11AB
\u1107\u1165\u11AB\u1100\u1162
\u1107\u1165\u11AB\u110B\u1167\u11A8
\u1107\u1165\u11AB\u110C\u1175
\u1107\u1165\u11AB\u1112\u1169
\u1107\u1165\u11AF\u1100\u1173\u11B7
\u1107\u1165\u11AF\u1105\u1166
\u1107\u1165\u11AF\u110A\u1165
\u1107\u1165\u11B7\u110B\u1171
\u1107\u1165\u11B7\u110B\u1175\u11AB
\u1107\u1165\u11B7\u110C\u116C
\u1107\u1165\u11B8\u1105\u1172\u11AF
\u1107\u1165\u11B8\u110B\u116F\u11AB
\u1107\u1165\u11B8\u110C\u1165\u11A8
\u1107\u1165\u11B8\u110E\u1175\u11A8
\u1107\u1166\u110B\u1175\u110C\u1175\u11BC
\u1107\u1166\u11AF\u1110\u1173
\u1107\u1167\u11AB\u1100\u1167\u11BC
\u1107\u1167\u11AB\u1103\u1169\u11BC
\u1107\u1167\u11AB\u1106\u1167\u11BC
\u1107\u1167\u11AB\u1109\u1175\u11AB
\u1107\u1167\u11AB\u1112\u1169\u1109\u1161
\u1107\u1167\u11AB\u1112\u116A
\u1107\u1167\u11AF\u1103\u1169
\u1107\u1167\u11AF\u1106\u1167\u11BC
\u1107\u1167\u11AF\u110B\u1175\u11AF
\u1107\u1167\u11BC\u1109\u1175\u11AF
\u1107\u1167\u11BC\u110B\u1161\u1105\u1175
\u1107\u1167\u11BC\u110B\u116F\u11AB
\u1107\u1169\u1100\u116A\u11AB
\u1107\u1169\u1102\u1165\u1109\u1173
\u1107\u1169\u1105\u1161\u1109\u1162\u11A8
\u1107\u1169\u1105\u1161\u11B7
\u1107\u1169\u1105\u1173\u11B7
\u1107\u1169\u1109\u1161\u11BC
\u1107\u1169\u110B\u1161\u11AB
\u1107\u1169\u110C\u1161\u1100\u1175
\u1107\u1169\u110C\u1161\u11BC
\u1107\u1169\u110C\u1165\u11AB
\u1107\u1169\u110C\u1169\u11AB
\u1107\u1169\u1110\u1169\u11BC
\u1107\u1169\u1111\u1167\u11AB\u110C\u1165\u11A8
\u1107\u1169\u1112\u1165\u11B7
\u1107\u1169\u11A8\u1103\u1169
\u1107\u1169\u11A8\u1109\u1161
\u1107\u1169\u11A8\u1109\u116E\u11BC\u110B\u1161
\u1107\u1169\u11A8\u1109\u1173\u11B8
\u1107\u1169\u11A9\u110B\u1173\u11B7
\u1107\u1169\u11AB\u1100\u1167\u11A8\u110C\u1165\u11A8
\u1107\u1169\u11AB\u1105\u1162
\u1107\u1169\u11AB\u1107\u116E
\u1107\u1169\u11AB\u1109\u1161
\u1107\u1169\u11AB\u1109\u1165\u11BC
\u1107\u1169\u11AB\u110B\u1175\u11AB
\u1107\u1169\u11AB\u110C\u1175\u11AF
\u1107\u1169\u11AF\u1111\u1166\u11AB
\u1107\u1169\u11BC\u1109\u1161
\u1107\u1169\u11BC\u110C\u1175
\u1107\u1169\u11BC\u1110\u116E
\u1107\u116E\u1100\u1173\u11AB
\u1107\u116E\u1101\u1173\u1105\u1165\u110B\u116E\u11B7
\u1107\u116E\u1103\u1161\u11B7
\u1107\u116E\u1103\u1169\u11BC\u1109\u1161\u11AB
\u1107\u116E\u1106\u116E\u11AB
\u1107\u116E\u1107\u116E\u11AB
\u1107\u116E\u1109\u1161\u11AB
\u1107\u116E\u1109\u1161\u11BC
\u1107\u116E\u110B\u1165\u11BF
\u1107\u116E\u110B\u1175\u11AB
\u1107\u116E\u110C\u1161\u11A8\u110B\u116D\u11BC
\u1107\u116E\u110C\u1161\u11BC
\u1107\u116E\u110C\u1165\u11BC
\u1107\u116E\u110C\u1169\u11A8
\u1107\u116E\u110C\u1175\u1105\u1165\u11AB\u1112\u1175
\u1107\u116E\u110E\u1175\u11AB
\u1107\u116E\u1110\u1161\u11A8
\u1107\u116E\u1111\u116E\u11B7
\u1107\u116E\u1112\u116C\u110C\u1161\u11BC
\u1107\u116E\u11A8\u1107\u116E
\u1107\u116E\u11A8\u1112\u1161\u11AB
\u1107\u116E\u11AB\u1102\u1169
\u1107\u116E\u11AB\u1105\u1163\u11BC
\u1107\u116E\u11AB\u1105\u1175
\u1107\u116E\u11AB\u1106\u1167\u11BC
\u1107\u116E\u11AB\u1109\u1165\u11A8
\u1107\u116E\u11AB\u110B\u1163
\u1107\u116E\u11AB\u110B\u1171\u1100\u1175
\u1107\u116E\u11AB\u1111\u1175\u11AF
\u1107\u116E\u11AB\u1112\u1169\u11BC\u1109\u1162\u11A8
\u1107\u116E\u11AF\u1100\u1169\u1100\u1175
\u1107\u116E\u11AF\u1100\u116A
\u1107\u116E\u11AF\u1100\u116D
\u1107\u116E\u11AF\u1101\u1169\u11BE
\u1107\u116E\u11AF\u1106\u1161\u11AB
\u1107\u116E\u11AF\u1107\u1165\u11B8
\u1107\u116E\u11AF\u1107\u1175\u11BE
\u1107\u116E\u11AF\u110B\u1161\u11AB
\u1107\u116E\u11AF\u110B\u1175\u110B\u1175\u11A8
\u1107\u116E\u11AF\u1112\u1162\u11BC
\u1107\u1173\u1105\u1162\u11AB\u1103\u1173
\u1107\u1175\u1100\u1173\u11A8
\u1107\u1175\u1102\u1161\u11AB
\u1107\u1175\u1102\u1175\u11AF
\u1107\u1175\u1103\u116E\u11AF\u1100\u1175
\u1107\u1175\u1103\u1175\u110B\u1169
\u1107\u1175\u1105\u1169\u1109\u1169
\u1107\u1175\u1106\u1161\u11AB
\u1107\u1175\u1106\u1167\u11BC
\u1107\u1175\u1106\u1175\u11AF
\u1107\u1175\u1107\u1161\u1105\u1161\u11B7
\u1107\u1175\u1107\u1175\u11B7\u1107\u1161\u11B8
\u1107\u1175\u1109\u1161\u11BC
\u1107\u1175\u110B\u116D\u11BC
\u1107\u1175\u110B\u1172\u11AF
\u1107\u1175\u110C\u116E\u11BC
\u1107\u1175\u1110\u1161\u1106\u1175\u11AB
\u1107\u1175\u1111\u1161\u11AB
\u1107\u1175\u11AF\u1103\u1175\u11BC
\u1107\u1175\u11BA\u1106\u116E\u11AF
\u1107\u1175\u11BA\u1107\u1161\u11BC\u110B\u116E\u11AF
\u1107\u1175\u11BA\u110C\u116E\u11AF\u1100\u1175
\u1107\u1175\u11BE\u1101\u1161\u11AF
\u1108\u1161\u11AF\u1100\u1161\u11AB\u1109\u1162\u11A8
\u1108\u1161\u11AF\u1105\u1162
\u1108\u1161\u11AF\u1105\u1175
\u1109\u1161\u1100\u1165\u11AB
\u1109\u1161\u1100\u1168\u110C\u1165\u11AF
\u1109\u1161\u1102\u1161\u110B\u1175
\u1109\u1161\u1102\u1163\u11BC
\u1109\u1161\u1105\u1161\u11B7
\u1109\u1161\u1105\u1161\u11BC
\u1109\u1161\u1105\u1175\u11B8
\u1109\u1161\u1106\u1169\u1102\u1175\u11B7
\u1109\u1161\u1106\u116E\u11AF
\u1109\u1161\u1107\u1161\u11BC
\u1109\u1161\u1109\u1161\u11BC
\u1109\u1161\u1109\u1162\u11BC\u1112\u116A\u11AF
\u1109\u1161\u1109\u1165\u11AF
\u1109\u1161\u1109\u1173\u11B7
\u1109\u1161\u1109\u1175\u11AF
\u1109\u1161\u110B\u1165\u11B8
\u1109\u1161\u110B\u116D\u11BC
\u1109\u1161\u110B\u116F\u11AF
\u1109\u1161\u110C\u1161\u11BC
\u1109\u1161\u110C\u1165\u11AB
\u1109\u1161\u110C\u1175\u11AB
\u1109\u1161\u110E\u1169\u11AB
\u1109\u1161\u110E\u116E\u11AB\u1100\u1175
\u1109\u1161\u1110\u1161\u11BC
\u1109\u1161\u1110\u116E\u1105\u1175
\u1109\u1161\u1112\u1173\u11AF
\u1109\u1161\u11AB\u1100\u1175\u11AF
\u1109\u1161\u11AB\u1107\u116E\u110B\u1175\u11AB\u1100\u116A
\u1109\u1161\u11AB\u110B\u1165\u11B8
\u1109\u1161\u11AB\u110E\u1162\u11A8
\u1109\u1161\u11AF\u1105\u1175\u11B7
\u1109\u1161\u11AF\u110B\u1175\u11AB
\u1109\u1161\u11AF\u110D\u1161\u11A8
\u1109\u1161\u11B7\u1100\u1168\u1110\u1161\u11BC
\u1109\u1161\u11B7\u1100\u116E\u11A8
\u1109\u1161\u11B7\u1109\u1175\u11B8
\u1109\u1161\u11B7\u110B\u116F\u11AF
\u1109\u1161\u11B7\u110E\u1169\u11AB
\u1109\u1161\u11BC\u1100\u116A\u11AB
\u1109\u1161\u11BC\u1100\u1173\u11B7
\u1109\u1161\u11BC\u1103\u1162
\u1109\u1161\u11BC\u1105\u1172
\u1109\u1161\u11BC\u1107\u1161\u11AB\u1100\u1175
\u1109\u1161\u11BC\u1109\u1161\u11BC
\u1109\u1161\u11BC\u1109\u1175\u11A8
\u1109\u1161\u11BC\u110B\u1165\u11B8
\u1109\u1161\u11BC\u110B\u1175\u11AB
\u1109\u1161\u11BC\u110C\u1161
\u1109\u1161\u11BC\u110C\u1165\u11B7
\u1109\u1161\u11BC\u110E\u1165
\u1109\u1161\u11BC\u110E\u116E
\u1109\u1161\u11BC\u1110\u1162
\u1109\u1161\u11BC\u1111\u116D
\u1109\u1161\u11BC\u1111\u116E\u11B7
\u1109\u1161\u11BC\u1112\u116A\u11BC
\u1109\u1162\u1107\u1167\u11A8
\u1109\u1162\u11A8\u1101\u1161\u11AF
\u1109\u1162\u11A8\u110B\u1167\u11AB\u1111\u1175\u11AF
\u1109\u1162\u11BC\u1100\u1161\u11A8
\u1109\u1162\u11BC\u1106\u1167\u11BC
\u1109\u1162\u11BC\u1106\u116E\u11AF
\u1109\u1162\u11BC\u1107\u1161\u11BC\u1109\u1169\u11BC
\u1109\u1162\u11BC\u1109\u1161\u11AB
\u1109\u1162\u11BC\u1109\u1165\u11AB
\u1109\u1162\u11BC\u1109\u1175\u11AB
\u1109\u1162\u11BC\u110B\u1175\u11AF
\u1109\u1162\u11BC\u1112\u116A\u11AF
\u1109\u1165\u1105\u1161\u11B8
\u1109\u1165\u1105\u1173\u11AB
\u1109\u1165\u1106\u1167\u11BC
\u1109\u1165\u1106\u1175\u11AB
\u1109\u1165\u1107\u1175\u1109\u1173
\u1109\u1165\u110B\u1163\u11BC
\u1109\u1165\u110B\u116E\u11AF
\u1109\u1165\u110C\u1165\u11A8
\u1109\u1165\u110C\u1165\u11B7
\u1109\u1165\u110D\u1169\u11A8
\u1109\u1165\u110F\u1173\u11AF
\u1109\u1165\u11A8\u1109\u1161
\u1109\u1165\u11A8\u110B\u1172
\u1109\u1165\u11AB\u1100\u1165
\u1109\u1165\u11AB\u1106\u116E\u11AF
\u1109\u1165\u11AB\u1107\u1162
\u1109\u1165\u11AB\u1109\u1162\u11BC
\u1109\u1165\u11AB\u1109\u116E
\u1109\u1165\u11AB\u110B\u116F\u11AB
\u1109\u1165\u11AB\u110C\u1161\u11BC
\u1109\u1165\u11AB\u110C\u1165\u11AB
\u1109\u1165\u11AB\u1110\u1162\u11A8
\u1109\u1165\u11AB\u1111\u116E\u11BC\u1100\u1175
\u1109\u1165\u11AF\u1100\u1165\u110C\u1175
\u1109\u1165\u11AF\u1102\u1161\u11AF
\u1109\u1165\u11AF\u1105\u1165\u11BC\u1110\u1161\u11BC
\u1109\u1165\u11AF\u1106\u1167\u11BC
\u1109\u1165\u11AF\u1106\u116E\u11AB
\u1109\u1165\u11AF\u1109\u1161
\u1109\u1165\u11AF\u110B\u1161\u11A8\u1109\u1161\u11AB
\u1109\u1165\u11AF\u110E\u1175
\u1109\u1165\u11AF\u1110\u1161\u11BC
\u1109\u1165\u11B8\u110A\u1175
\u1109\u1165\u11BC\u1100\u1169\u11BC
\u1109\u1165\u11BC\u1103\u1161\u11BC
\u1109\u1165\u11BC\u1106\u1167\u11BC
\u1109\u1165\u11BC\u1107\u1167\u11AF
\u1109\u1165\u11BC\u110B\u1175\u11AB
\u1109\u1165\u11BC\u110C\u1161\u11BC
\u1109\u1165\u11BC\u110C\u1165\u11A8
\u1109\u1165\u11BC\u110C\u1175\u11AF
\u1109\u1165\u11BC\u1112\u1161\u11B7
\u1109\u1166\u1100\u1173\u11B7
\u1109\u1166\u1106\u1175\u1102\u1161
\u1109\u1166\u1109\u1161\u11BC
\u1109\u1166\u110B\u116F\u11AF
\u1109\u1166\u110C\u1169\u11BC\u1103\u1162\u110B\u116A\u11BC
\u1109\u1166\u1110\u1161\u11A8
\u1109\u1166\u11AB\u1110\u1165
\u1109\u1166\u11AB\u1110\u1175\u1106\u1175\u1110\u1165
\u1109\u1166\u11BA\u110D\u1162
\u1109\u1169\u1100\u1172\u1106\u1169
\u1109\u1169\u1100\u1173\u11A8\u110C\u1165\u11A8
\u1109\u1169\u1100\u1173\u11B7
\u1109\u1169\u1102\u1161\u1100\u1175
\u1109\u1169\u1102\u1167\u11AB
\u1109\u1169\u1103\u1173\u11A8
\u1109\u1169\u1106\u1161\u11BC
\u1109\u1169\u1106\u116E\u11AB
\u1109\u1169\u1109\u1165\u11AF
\u1109\u1169\u1109\u1169\u11A8
\u1109\u1169\u110B\u1161\u1100\u116A
\u1109\u1169\u110B\u116D\u11BC
\u1109\u1169\u110B\u116F\u11AB
\u1109\u1169\u110B\u1173\u11B7
\u1109\u1169\u110C\u116E\u11BC\u1112\u1175
\u1109\u1169\u110C\u1175\u1111\u116E\u11B7
\u1109\u1169\u110C\u1175\u11AF
\u1109\u1169\u1111\u116E\u11BC
\u1109\u1169\u1112\u1167\u11BC
\u1109\u1169\u11A8\u1103\u1161\u11B7
\u1109\u1169\u11A8\u1103\u1169
\u1109\u1169\u11A8\u110B\u1169\u11BA
\u1109\u1169\u11AB\u1100\u1161\u1105\u1161\u11A8
\u1109\u1169\u11AB\u1100\u1175\u11AF
\u1109\u1169\u11AB\u1102\u1167
\u1109\u1169\u11AB\u1102\u1175\u11B7
\u1109\u1169\u11AB\u1103\u1173\u11BC
\u1109\u1169\u11AB\u1106\u1169\u11A8
\u1109\u1169\u11AB\u1108\u1167\u11A8
\u1109\u1169\u11AB\u1109\u1175\u11AF
\u1109\u1169\u11AB\u110C\u1175\u11AF
\u1109\u1169\u11AB\u1110\u1169\u11B8
\u1109\u1169\u11AB\u1112\u1162
\u1109\u1169\u11AF\u110C\u1175\u11A8\u1112\u1175
\u1109\u1169\u11B7\u110A\u1175
\u1109\u1169\u11BC\u110B\u1161\u110C\u1175
\u1109\u1169\u11BC\u110B\u1175
\u1109\u1169\u11BC\u1111\u1167\u11AB
\u1109\u116C\u1100\u1169\u1100\u1175
\u1109\u116D\u1111\u1175\u11BC
\u1109\u116E\u1100\u1165\u11AB
\u1109\u116E\u1102\u1167\u11AB
\u1109\u116E\u1103\u1161\u11AB
\u1109\u116E\u1103\u1169\u11BA\u1106\u116E\u11AF
\u1109\u116E\u1103\u1169\u11BC\u110C\u1165\u11A8
\u1109\u116E\u1106\u1167\u11AB
\u1109\u116E\u1106\u1167\u11BC
\u1109\u116E\u1107\u1161\u11A8
\u1109\u116E\u1109\u1161\u11BC
\u1109\u116E\u1109\u1165\u11A8
\u1109\u116E\u1109\u116E\u11AF
\u1109\u116E\u1109\u1175\u1105\u1169
\u1109\u116E\u110B\u1165\u11B8
\u1109\u116E\u110B\u1167\u11B7
\u1109\u116E\u110B\u1167\u11BC
\u1109\u116E\u110B\u1175\u11B8
\u1109\u116E\u110C\u116E\u11AB
\u1109\u116E\u110C\u1175\u11B8
\u1109\u116E\u110E\u116E\u11AF
\u1109\u116E\u110F\u1165\u11BA
\u1109\u116E\u1111\u1175\u11AF
\u1109\u116E\u1112\u1161\u11A8
\u1109\u116E\u1112\u1165\u11B7\u1109\u1162\u11BC
\u1109\u116E\u1112\u116A\u1100\u1175
\u1109\u116E\u11A8\u1102\u1167
\u1109\u116E\u11A8\u1109\u1169
\u1109\u116E\u11A8\u110C\u1166
\u1109\u116E\u11AB\u1100\u1161\u11AB
\u1109\u116E\u11AB\u1109\u1165
\u1109\u116E\u11AB\u1109\u116E
\u1109\u116E\u11AB\u1109\u1175\u11A8\u1100\u1161\u11AB
\u1109\u116E\u11AB\u110B\u1171
\u1109\u116E\u11AE\u1100\u1161\u1105\u1161\u11A8
\u1109\u116E\u11AF\u1107\u1167\u11BC
\u1109\u116E\u11AF\u110C\u1175\u11B8
\u1109\u116E\u11BA\u110C\u1161
\u1109\u1173\u1102\u1175\u11B7
\u1109\u1173\u1106\u116E\u11AF
\u1109\u1173\u1109\u1173\u1105\u1169
\u1109\u1173\u1109\u1173\u11BC
\u1109\u1173\u110B\u1170\u1110\u1165
\u1109\u1173\u110B\u1171\u110E\u1175
\u1109\u1173\u110F\u1166\u110B\u1175\u1110\u1173
\u1109\u1173\u1110\u1172\u1103\u1175\u110B\u1169
\u1109\u1173\u1110\u1173\u1105\u1166\u1109\u1173
\u1109\u1173\u1111\u1169\u110E\u1173
\u1109\u1173\u11AF\u110D\u1165\u11A8
\u1109\u1173\u11AF\u1111\u1173\u11B7
\u1109\u1173\u11B8\u1100\u116A\u11AB
\u1109\u1173\u11B8\u1100\u1175
\u1109\u1173\u11BC\u1100\u1162\u11A8
\u1109\u1173\u11BC\u1105\u1175
\u1109\u1173\u11BC\u1107\u116E
\u1109\u1173\u11BC\u110B\u116D\u11BC\u110E\u1161
\u1109\u1173\u11BC\u110C\u1175\u11AB
\u1109\u1175\u1100\u1161\u11A8
\u1109\u1175\u1100\u1161\u11AB
\u1109\u1175\u1100\u1169\u11AF
\u1109\u1175\u1100\u1173\u11B7\u110E\u1175
\u1109\u1175\u1102\u1161\u1105\u1175\u110B\u1169
\u1109\u1175\u1103\u1162\u11A8
\u1109\u1175\u1105\u1175\u110C\u1173
\u1109\u1175\u1106\u1166\u11AB\u1110\u1173
\u1109\u1175\u1106\u1175\u11AB
\u1109\u1175\u1107\u116E\u1106\u1169
\u1109\u1175\u1109\u1165\u11AB
\u1109\u1175\u1109\u1165\u11AF
\u1109\u1175\u1109\u1173\u1110\u1166\u11B7
\u1109\u1175\u110B\u1161\u1107\u1165\u110C\u1175
\u1109\u1175\u110B\u1165\u1106\u1165\u1102\u1175
\u1109\u1175\u110B\u116F\u11AF
\u1109\u1175\u110B\u1175\u11AB
\u1109\u1175\u110B\u1175\u11AF
\u1109\u1175\u110C\u1161\u11A8
\u1109\u1175\u110C\u1161\u11BC
\u1109\u1175\u110C\u1165\u11AF
\u1109\u1175\u110C\u1165\u11B7
\u1109\u1175\u110C\u116E\u11BC
\u1109\u1175\u110C\u1173\u11AB
\u1109\u1175\u110C\u1175\u11B8
\u1109\u1175\u110E\u1165\u11BC
\u1109\u1175\u1112\u1161\u11B8
\u1109\u1175\u1112\u1165\u11B7
\u1109\u1175\u11A8\u1100\u116E
\u1109\u1175\u11A8\u1100\u1175
\u1109\u1175\u11A8\u1103\u1161\u11BC
\u1109\u1175\u11A8\u1105\u1163\u11BC
\u1109\u1175\u11A8\u1105\u116D\u1111\u116E\u11B7
\u1109\u1175\u11A8\u1106\u116E\u11AF
\u1109\u1175\u11A8\u1108\u1161\u11BC
\u1109\u1175\u11A8\u1109\u1161
\u1109\u1175\u11A8\u1109\u1162\u11BC\u1112\u116A\u11AF
\u1109\u1175\u11A8\u110E\u1169
\u1109\u1175\u11A8\u1110\u1161\u11A8
\u1109\u1175\u11A8\u1111\u116E\u11B7
\u1109\u1175\u11AB\u1100\u1169
\u1109\u1175\u11AB\u1100\u1172
\u1109\u1175\u11AB\u1102\u1167\u11B7
\u1109\u1175\u11AB\u1106\u116E\u11AB
\u1109\u1175\u11AB\u1107\u1161\u11AF
\u1109\u1175\u11AB\u1107\u1175
\u1109\u1175\u11AB\u1109\u1161
\u1109\u1175\u11AB\u1109\u1166
\u1109\u1175\u11AB\u110B\u116D\u11BC
\u1109\u1175\u11AB\u110C\u1166\u1111\u116E\u11B7
\u1109\u1175\u11AB\u110E\u1165\u11BC
\u1109\u1175\u11AB\u110E\u1166
\u1109\u1175\u11AB\u1112\u116A
\u1109\u1175\u11AF\u1100\u1161\u11B7
\u1109\u1175\u11AF\u1102\u1162
\u1109\u1175\u11AF\u1105\u1167\u11A8
\u1109\u1175\u11AF\u1105\u1168
\u1109\u1175\u11AF\u1106\u1161\u11BC
\u1109\u1175\u11AF\u1109\u116E
\u1109\u1175\u11AF\u1109\u1173\u11B8
\u1109\u1175\u11AF\u1109\u1175
\u1109\u1175\u11AF\u110C\u1161\u11BC
\u1109\u1175\u11AF\u110C\u1165\u11BC
\u1109\u1175\u11AF\u110C\u1175\u11AF\u110C\u1165\u11A8
\u1109\u1175\u11AF\u110E\u1165\u11AB
\u1109\u1175\u11AF\u110E\u1166
\u1109\u1175\u11AF\u110F\u1165\u11BA
\u1109\u1175\u11AF\u1110\u1162
\u1109\u1175\u11AF\u1111\u1162
\u1109\u1175\u11AF\u1112\u1165\u11B7
\u1109\u1175\u11AF\u1112\u1167\u11AB
\u1109\u1175\u11B7\u1105\u1175
\u1109\u1175\u11B7\u1107\u116E\u1105\u1173\u11B7
\u1109\u1175\u11B7\u1109\u1161
\u1109\u1175\u11B7\u110C\u1161\u11BC
\u1109\u1175\u11B7\u110C\u1165\u11BC
\u1109\u1175\u11B7\u1111\u1161\u11AB
\u110A\u1161\u11BC\u1103\u116E\u11BC\u110B\u1175
\u110A\u1175\u1105\u1173\u11B7
\u110A\u1175\u110B\u1161\u11BA
\u110B\u1161\u1100\u1161\u110A\u1175
\u110B\u1161\u1102\u1161\u110B\u116E\u11AB\u1109\u1165
\u110B\u1161\u1103\u1173\u1102\u1175\u11B7
\u110B\u1161\u1103\u1173\u11AF
\u110B\u1161\u1109\u1171\u110B\u116E\u11B7
\u110B\u1161\u1109\u1173\u1111\u1161\u11AF\u1110\u1173
\u110B\u1161\u1109\u1175\u110B\u1161
\u110B\u1161\u110B\u116E\u11AF\u1105\u1165
\u110B\u1161\u110C\u1165\u110A\u1175
\u110B\u1161\u110C\u116E\u11B7\u1106\u1161
\u110B\u1161\u110C\u1175\u11A8
\u110B\u1161\u110E\u1175\u11B7
\u110B\u1161\u1111\u1161\u1110\u1173
\u110B\u1161\u1111\u1173\u1105\u1175\u110F\u1161
\u110B\u1161\u1111\u1173\u11B7
\u110B\u1161\u1112\u1169\u11B8
\u110B\u1161\u1112\u1173\u11AB
\u110B\u1161\u11A8\u1100\u1175
\u110B\u1161\u11A8\u1106\u1169\u11BC
\u110B\u1161\u11A8\u1109\u116E
\u110B\u1161\u11AB\u1100\u1162
\u110B\u1161\u11AB\u1100\u1167\u11BC
\u110B\u1161\u11AB\u1100\u116A
\u110B\u1161\u11AB\u1102\u1162
\u110B\u1161\u11AB\u1102\u1167\u11BC
\u110B\u1161\u11AB\u1103\u1169\u11BC
\u110B\u1161\u11AB\u1107\u1161\u11BC
\u110B\u1161\u11AB\u1107\u116E
\u110B\u1161\u11AB\u110C\u116E
\u110B\u1161\u11AF\u1105\u116E\u1106\u1175\u1102\u1172\u11B7
\u110B\u1161\u11AF\u110F\u1169\u110B\u1169\u11AF
\u110B\u1161\u11B7\u1109\u1175
\u110B\u1161\u11B7\u110F\u1165\u11BA
\u110B\u1161\u11B8\u1105\u1167\u11A8
\u110B\u1161\u11C1\u1102\u1161\u11AF
\u110B\u1161\u11C1\u1106\u116E\u11AB
\u110B\u1162\u110B\u1175\u11AB
\u110B\u1162\u110C\u1165\u11BC
\u110B\u1162\u11A8\u1109\u116E
\u110B\u1162\u11AF\u1107\u1165\u11B7
\u110B\u1163\u1100\u1161\u11AB
\u110B\u1163\u1103\u1161\u11AB
\u110B\u1163\u110B\u1169\u11BC
\u110B\u1163\u11A8\u1100\u1161\u11AB
\u110B\u1163\u11A8\u1100\u116E\u11A8
\u110B\u1163\u11A8\u1109\u1169\u11A8
\u110B\u1163\u11A8\u1109\u116E
\u110B\u1163\u11A8\u110C\u1165\u11B7
\u110B\u1163\u11A8\u1111\u116E\u11B7
\u110B\u1163\u11A8\u1112\u1169\u11AB\u1102\u1167
\u110B\u1163\u11BC\u1102\u1167\u11B7
\u110B\u1163\u11BC\u1105\u1167\u11A8
\u110B\u1163\u11BC\u1106\u1161\u11AF
\u110B\u1163\u11BC\u1107\u1162\u110E\u116E
\u110B\u1163\u11BC\u110C\u116E
\u110B\u1163\u11BC\u1111\u1161
\u110B\u1165\u1103\u116E\u11B7
\u110B\u1165\u1105\u1167\u110B\u116E\u11B7
\u110B\u1165\u1105\u1173\u11AB
\u110B\u1165\u110C\u1166\u11BA\u1107\u1161\u11B7
\u110B\u1165\u110D\u1162\u11BB\u1103\u1173\u11AB
\u110B\u1165\u110D\u1165\u1103\u1161\u1100\u1161
\u110B\u1165\u110D\u1165\u11AB\u110C\u1175
\u110B\u1165\u11AB\u1102\u1175
\u110B\u1165\u11AB\u1103\u1165\u11A8
\u110B\u1165\u11AB\u1105\u1169\u11AB
\u110B\u1165\u11AB\u110B\u1165
\u110B\u1165\u11AF\u1100\u116E\u11AF
\u110B\u1165\u11AF\u1105\u1173\u11AB
\u110B\u1165\u11AF\u110B\u1173\u11B7
\u110B\u1165\u11AF\u1111\u1175\u11BA
\u110B\u1165\u11B7\u1106\u1161
\u110B\u1165\u11B8\u1106\u116E
\u110B\u1165\u11B8\u110C\u1169\u11BC
\u110B\u1165\u11B8\u110E\u1166
\u110B\u1165\u11BC\u1103\u1165\u11BC\u110B\u1175
\u110B\u1165\u11BC\u1106\u1161\u11BC
\u110B\u1165\u11BC\u1110\u1165\u1105\u1175
\u110B\u1165\u11BD\u1100\u1173\u110C\u1166
\u110B\u1166\u1102\u1165\u110C\u1175
\u110B\u1166\u110B\u1165\u110F\u1165\u11AB
\u110B\u1166\u11AB\u110C\u1175\u11AB
\u110B\u1167\u1100\u1165\u11AB
\u110B\u1167\u1100\u1169\u1109\u1162\u11BC
\u110B\u1167\u1100\u116A\u11AB
\u110B\u1167\u1100\u116E\u11AB
\u110B\u1167\u1100\u116F\u11AB
\u110B\u1167\u1103\u1162\u1109\u1162\u11BC
\u110B\u1167\u1103\u1165\u11B2
\u110B\u1167\u1103\u1169\u11BC\u1109\u1162\u11BC
\u110B\u1167\u1103\u1173\u11AB
\u110B\u1167\u1105\u1169\u11AB
\u110B\u1167\u1105\u1173\u11B7
\u110B\u1167\u1109\u1165\u11BA
\u110B\u1167\u1109\u1165\u11BC
\u110B\u1167\u110B\u116A\u11BC
\u110B\u1167\u110B\u1175\u11AB
\u110B\u1167\u110C\u1165\u11AB\u1112\u1175
\u110B\u1167\u110C\u1175\u11A8\u110B\u116F\u11AB
\u110B\u1167\u1112\u1161\u11A8\u1109\u1162\u11BC
\u110B\u1167\u1112\u1162\u11BC
\u110B\u1167\u11A8\u1109\u1161
\u110B\u1167\u11A8\u1109\u1175
\u110B\u1167\u11A8\u1112\u1161\u11AF
\u110B\u1167\u11AB\u1100\u1167\u11AF
\u110B\u1167\u11AB\u1100\u116E
\u110B\u1167\u11AB\u1100\u1173\u11A8
\u110B\u1167\u11AB\u1100\u1175
\u110B\u1167\u11AB\u1105\u1161\u11A8
\u110B\u1167\u11AB\u1109\u1165\u11AF
\u110B\u1167\u11AB\u1109\u1166
\u110B\u1167\u11AB\u1109\u1169\u11A8
\u110B\u1167\u11AB\u1109\u1173\u11B8
\u110B\u1167\u11AB\u110B\u1162
\u110B\u1167\u11AB\u110B\u1168\u110B\u1175\u11AB
\u110B\u1167\u11AB\u110B\u1175\u11AB
\u110B\u1167\u11AB\u110C\u1161\u11BC
\u110B\u1167\u11AB\u110C\u116E
\u110B\u1167\u11AB\u110E\u116E\u11AF
\u110B\u1167\u11AB\u1111\u1175\u11AF
\u110B\u1167\u11AB\u1112\u1161\u11B8
\u110B\u1167\u11AB\u1112\u1172
\u110B\u1167\u11AF\u1100\u1175
\u110B\u1167\u11AF\u1106\u1162
\u110B\u1167\u11AF\u1109\u116C
\u110B\u1167\u11AF\u1109\u1175\u11B7\u1112\u1175
\u110B\u1167\u11AF\u110C\u1165\u11BC
\u110B\u1167\u11AF\u110E\u1161
\u110B\u1167\u11AF\u1112\u1173\u11AF
\u110B\u1167\u11B7\u1105\u1167
\u110B\u1167\u11B8\u1109\u1165
\u110B\u1167\u11BC\u1100\u116E\u11A8
\u110B\u1167\u11BC\u1102\u1161\u11B7
\u110B\u1167\u11BC\u1109\u1161\u11BC
\u110B\u1167\u11BC\u110B\u1163\u11BC
\u110B\u1167\u11BC\u110B\u1167\u11A8
\u110B\u1167\u11BC\u110B\u116E\u11BC
\u110B\u1167\u11BC\u110B\u116F\u11AB\u1112\u1175
\u110B\u1167\u11BC\u1112\u1161
\u110B\u1167\u11BC\u1112\u1163\u11BC
\u110B\u1167\u11BC\u1112\u1169\u11AB
\u110B\u1167\u11BC\u1112\u116A
\u110B\u1167\u11C1\u1100\u116E\u1105\u1175
\u110B\u1167\u11C1\u1107\u1161\u11BC
\u110B\u1167\u11C1\u110C\u1175\u11B8
\u110B\u1168\u1100\u1161\u11B7
\u110B\u1168\u1100\u1173\u11B7
\u110B\u1168\u1107\u1161\u11BC
\u110B\u1168\u1109\u1161\u11AB
\u110B\u1168\u1109\u1161\u11BC
\u110B\u1168\u1109\u1165\u11AB
\u110B\u1168\u1109\u116E\u11AF
\u110B\u1168\u1109\u1173\u11B8
\u110B\u1168\u1109\u1175\u11A8\u110C\u1161\u11BC
\u110B\u1168\u110B\u1163\u11A8
\u110B\u1168\u110C\u1165\u11AB
\u110B\u1168\u110C\u1165\u11AF
\u110B\u1168\u110C\u1165\u11BC
\u110B\u1168\u110F\u1165\u11AB\u1103\u1162
\u110B\u1168\u11BA\u1102\u1161\u11AF
\u110B\u1169\u1102\u1173\u11AF
\u110B\u1169\u1105\u1161\u11A8
\u110B\u1169\u1105\u1162\u11BA\u1103\u1169\u11BC\u110B\u1161\u11AB
\u110B\u1169\u1105\u1166\u11AB\u110C\u1175
\u110B\u1169\u1105\u1169\u110C\u1175
\u110B\u1169\u1105\u1173\u11AB\u1107\u1161\u11AF
\u110B\u1169\u1107\u1173\u11AB
\u110B\u1169\u1109\u1175\u11B8
\u110B\u1169\u110B\u1167\u11B7
\u110B\u1169\u110B\u116F\u11AF
\u110B\u1169\u110C\u1165\u11AB
\u110B\u1169\u110C\u1175\u11A8
\u110B\u1169\u110C\u1175\u11BC\u110B\u1165
\u110B\u1169\u1111\u1166\u1105\u1161
\u110B\u1169\u1111\u1175\u1109\u1173\u1110\u1166\u11AF
\u110B\u1169\u1112\u1175\u1105\u1167
\u110B\u1169\u11A8\u1109\u1161\u11BC
\u110B\u1169\u11A8\u1109\u116E\u1109\u116E
\u110B\u1169\u11AB\u1100\u1161\u11BD
\u110B\u1169\u11AB\u1105\u1161\u110B\u1175\u11AB
\u110B\u1169\u11AB\u1106\u1169\u11B7
\u110B\u1169\u11AB\u110C\u1169\u11BC\u110B\u1175\u11AF
\u110B\u1169\u11AB\u1110\u1169\u11BC
\u110B\u1169\u11AF\u1100\u1161\u110B\u1173\u11AF
\u110B\u1169\u11AF\u1105\u1175\u11B7\u1111\u1175\u11A8
\u110B\u1169\u11AF\u1112\u1162
\u110B\u1169\u11BA\u110E\u1161\u1105\u1175\u11B7
\u110B\u116A\u110B\u1175\u1109\u1167\u110E\u1173
\u110B\u116A\u110B\u1175\u11AB
\u110B\u116A\u11AB\u1109\u1165\u11BC
\u110B\u116A\u11AB\u110C\u1165\u11AB
\u110B\u116A\u11BC\u1107\u1175
\u110B\u116A\u11BC\u110C\u1161
\u110B\u116B\u1102\u1163\u1112\u1161\u1106\u1167\u11AB
\u110B\u116B\u11AB\u110C\u1175
\u110B\u116C\u1100\u1161\u11BA\u110C\u1175\u11B8
\u110B\u116C\u1100\u116E\u11A8
\u110B\u116C\u1105\u1169\u110B\u116E\u11B7
\u110B\u116C\u1109\u1161\u11B7\u110E\u1169\u11AB
\u110B\u116C\u110E\u116E\u11AF
\u110B\u116C\u110E\u1175\u11B7
\u110B\u116C\u1112\u1161\u11AF\u1106\u1165\u1102\u1175
\u110B\u116C\u11AB\u1107\u1161\u11AF
\u110B\u116C\u11AB\u1109\u1169\u11AB
\u110B\u116C\u11AB\u110D\u1169\u11A8
\u110B\u116D\u1100\u1173\u11B7
\u110B\u116D\u110B\u1175\u11AF
\u110B\u116D\u110C\u1173\u11B7
\u110B\u116D\u110E\u1165\u11BC
\u110B\u116D\u11BC\u1100\u1175
\u110B\u116D\u11BC\u1109\u1165
\u110B\u116D\u11BC\u110B\u1165
\u110B\u116E\u1109\u1161\u11AB
\u110B\u116E\u1109\u1165\u11AB
\u110B\u116E\u1109\u1173\u11BC
\u110B\u116E\u110B\u1167\u11AB\u1112\u1175
\u110B\u116E\u110C\u1165\u11BC
\u110B\u116E\u110E\u1166\u1100\u116E\u11A8
\u110B\u116E\u1111\u1167\u11AB
\u110B\u116E\u11AB\u1103\u1169\u11BC
\u110B\u116E\u11AB\u1106\u1167\u11BC
\u110B\u116E\u11AB\u1107\u1161\u11AB
\u110B\u116E\u11AB\u110C\u1165\u11AB
\u110B\u116E\u11AB\u1112\u1162\u11BC
\u110B\u116E\u11AF\u1109\u1161\u11AB
\u110B\u116E\u11AF\u110B\u1173\u11B7
\u110B\u116E\u11B7\u110C\u1175\u11A8\u110B\u1175\u11B7
\u110B\u116E\u11BA\u110B\u1165\u1105\u1173\u11AB
\u110B\u116E\u11BA\u110B\u1173\u11B7
\u110B\u116F\u1102\u1161\u11A8
\u110B\u116F\u11AB\u1100\u1169
\u110B\u116F\u11AB\u1105\u1162
\u110B\u116F\u11AB\u1109\u1165
\u110B\u116F\u11AB\u1109\u116E\u11BC\u110B\u1175
\u110B\u116F\u11AB\u110B\u1175\u11AB
\u110B\u116F\u11AB\u110C\u1161\u11BC
\u110B\u116F\u11AB\u1111\u1175\u1109\u1173
\u110B\u116F\u11AF\u1100\u1173\u11B8
\u110B\u116F\u11AF\u1103\u1173\u110F\u1165\u11B8
\u110B\u116F\u11AF\u1109\u1166
\u110B\u116F\u11AF\u110B\u116D\u110B\u1175\u11AF
\u110B\u1170\u110B\u1175\u1110\u1165
\u110B\u1171\u1107\u1161\u11AB
\u110B\u1171\u1107\u1165\u11B8
\u110B\u1171\u1109\u1165\u11BC
\u110B\u1171\u110B\u116F\u11AB
\u110B\u1171\u1112\u1165\u11B7
\u110B\u1171\u1112\u1167\u11B8
\u110B\u1171\u11BA\u1109\u1161\u1105\u1161\u11B7
\u110B\u1172\u1102\u1161\u11AB\u1112\u1175
\u110B\u1172\u1105\u1165\u11B8
\u110B\u1172\u1106\u1167\u11BC
\u110B\u1172\u1106\u116E\u11AF
\u110B\u1172\u1109\u1161\u11AB
\u110B\u1172\u110C\u1165\u11A8
\u110B\u1172\u110E\u1175\u110B\u116F\u11AB
\u110B\u1172\u1112\u1161\u11A8
\u110B\u1172\u1112\u1162\u11BC
\u110B\u1172\u1112\u1167\u11BC
\u110B\u1172\u11A8\u1100\u116E\u11AB
\u110B\u1172\u11A8\u1109\u1161\u11BC
\u110B\u1172\u11A8\u1109\u1175\u11B8
\u110B\u1172\u11A8\u110E\u1166
\u110B\u1173\u11AB\u1112\u1162\u11BC
\u110B\u1173\u11B7\u1105\u1167\u11A8
\u110B\u1173\u11B7\u1105\u116D
\u110B\u1173\u11B7\u1107\u1161\u11AB
\u110B\u1173\u11B7\u1109\u1165\u11BC
\u110B\u1173\u11B7\u1109\u1175\u11A8
\u110B\u1173\u11B7\u110B\u1161\u11A8
\u110B\u1173\u11B7\u110C\u116E
\u110B\u1174\u1100\u1167\u11AB
\u110B\u1174\u1102\u1169\u11AB
\u110B\u1174\u1106\u116E\u11AB
\u110B\u1174\u1107\u1169\u11A8
\u110B\u1174\u1109\u1175\u11A8
\u110B\u1174\u1109\u1175\u11B7
\u110B\u1174\u110B\u116C\u1105\u1169
\u110B\u1174\u110B\u116D\u11A8
\u110B\u1174\u110B\u116F\u11AB
\u110B\u1174\u1112\u1161\u11A8
\u110B\u1175\u1100\u1165\u11BA
\u110B\u1175\u1100\u1169\u11BA
\u110B\u1175\u1102\u1167\u11B7
\u110B\u1175\u1102\u1169\u11B7
\u110B\u1175\u1103\u1161\u11AF
\u110B\u1175\u1103\u1162\u1105\u1169
\u110B\u1175\u1103\u1169\u11BC
\u110B\u1175\u1105\u1165\u11C2\u1100\u1166
\u110B\u1175\u1105\u1167\u11A8\u1109\u1165
\u110B\u1175\u1105\u1169\u11AB\u110C\u1165\u11A8
\u110B\u1175\u1105\u1173\u11B7
\u110B\u1175\u1106\u1175\u11AB
\u110B\u1175\u1107\u1161\u11AF\u1109\u1169
\u110B\u1175\u1107\u1167\u11AF
\u110B\u1175\u1107\u116E\u11AF
\u110B\u1175\u1108\u1161\u11AF
\u110B\u1175\u1109\u1161\u11BC
\u110B\u1175\u1109\u1165\u11BC
\u110B\u1175\u1109\u1173\u11AF
\u110B\u1175\u110B\u1163\u1100\u1175
\u110B\u1175\u110B\u116D\u11BC
\u110B\u1175\u110B\u116E\u11BA
\u110B\u1175\u110B\u116F\u11AF
\u110B\u1175\u110B\u1173\u11A8\u1100\u1169
\u110B\u1175\u110B\u1175\u11A8
\u110B\u1175\u110C\u1165\u11AB
\u110B\u1175\u110C\u116E\u11BC
\u110B\u1175\u1110\u1173\u11AE\u1102\u1161\u11AF
\u110B\u1175\u1110\u1173\u11AF
\u110B\u1175\u1112\u1169\u11AB
\u110B\u1175\u11AB\u1100\u1161\u11AB
\u110B\u1175\u11AB\u1100\u1167\u11A8
\u110B\u1175\u11AB\u1100\u1169\u11BC
\u110B\u1175\u11AB\u1100\u116E
\u110B\u1175\u11AB\u1100\u1173\u11AB
\u110B\u1175\u11AB\u1100\u1175
\u110B\u1175\u11AB\u1103\u1169
\u110B\u1175\u11AB\u1105\u1172
\u110B\u1175\u11AB\u1106\u116E\u11AF
\u110B\u1175\u11AB\u1109\u1162\u11BC
\u110B\u1175\u11AB\u1109\u116B
\u110B\u1175\u11AB\u110B\u1167\u11AB
\u110B\u1175\u11AB\u110B\u116F\u11AB
\u110B\u1175\u11AB\u110C\u1162
\u110B\u1175\u11AB\u110C\u1169\u11BC
\u110B\u1175\u11AB\u110E\u1165\u11AB
\u110B\u1175\u11AB\u110E\u1166
\u110B\u1175\u11AB\u1110\u1165\u1102\u1166\u11BA
\u110B\u1175\u11AB\u1112\u1161
\u110B\u1175\u11AB\u1112\u1167\u11BC
\u110B\u1175\u11AF\u1100\u1169\u11B8
\u110B\u1175\u11AF\u1100\u1175
\u110B\u1175\u11AF\u1103\u1161\u11AB
\u110B\u1175\u11AF\u1103\u1162
\u110B\u1175\u11AF\u1103\u1173\u11BC
\u110B\u1175\u11AF\u1107\u1161\u11AB
\u110B\u1175\u11AF\u1107\u1169\u11AB
\u110B\u1175\u11AF\u1107\u116E
\u110B\u1175\u11AF\u1109\u1161\u11BC
\u110B\u1175\u11AF\u1109\u1162\u11BC
\u110B\u1175\u11AF\u1109\u1169\u11AB
\u110B\u1175\u11AF\u110B\u116D\u110B\u1175\u11AF
\u110B\u1175\u11AF\u110B\u116F\u11AF
\u110B\u1175\u11AF\u110C\u1165\u11BC
\u110B\u1175\u11AF\u110C\u1169\u11BC
\u110B\u1175\u11AF\u110C\u116E\u110B\u1175\u11AF
\u110B\u1175\u11AF\u110D\u1175\u11A8
\u110B\u1175\u11AF\u110E\u1166
\u110B\u1175\u11AF\u110E\u1175
\u110B\u1175\u11AF\u1112\u1162\u11BC
\u110B\u1175\u11AF\u1112\u116C\u110B\u116D\u11BC
\u110B\u1175\u11B7\u1100\u1173\u11B7
\u110B\u1175\u11B7\u1106\u116E
\u110B\u1175\u11B8\u1103\u1162
\u110B\u1175\u11B8\u1105\u1167\u11A8
\u110B\u1175\u11B8\u1106\u1161\u11BA
\u110B\u1175\u11B8\u1109\u1161
\u110B\u1175\u11B8\u1109\u116E\u11AF
\u110B\u1175\u11B8\u1109\u1175
\u110B\u1175\u11B8\u110B\u116F\u11AB
\u110B\u1175\u11B8\u110C\u1161\u11BC
\u110B\u1175\u11B8\u1112\u1161\u11A8
\u110C\u1161\u1100\u1161\u110B\u116D\u11BC
\u110C\u1161\u1100\u1167\u11A8
\u110C\u1161\u1100\u1173\u11A8
\u110C\u1161\u1103\u1169\u11BC
\u110C\u1161\u1105\u1161\u11BC
\u110C\u1161\u1107\u116E\u1109\u1175\u11B7
\u110C\u1161\u1109\u1175\u11A8
\u110C\u1161\u1109\u1175\u11AB
\u110C\u1161\u110B\u1167\u11AB
\u110C\u1161\u110B\u116F\u11AB
\u110C\u1161\u110B\u1172\u11AF
\u110C\u1161\u110C\u1165\u11AB\u1100\u1165
\u110C\u1161\u110C\u1165\u11BC
\u110C\u1161\u110C\u1169\u11AB\u1109\u1175\u11B7
\u110C\u1161\u1111\u1161\u11AB
\u110C\u1161\u11A8\u1100\u1161
\u110C\u1161\u11A8\u1102\u1167\u11AB
\u110C\u1161\u11A8\u1109\u1165\u11BC
\u110C\u1161\u11A8\u110B\u1165\u11B8
\u110C\u1161\u11A8\u110B\u116D\u11BC
\u110C\u1161\u11A8\u110B\u1173\u11AB\u1104\u1161\u11AF
\u110C\u1161\u11A8\u1111\u116E\u11B7
\u110C\u1161\u11AB\u1103\u1175
\u110C\u1161\u11AB\u1104\u1173\u11A8
\u110C\u1161\u11AB\u110E\u1175
\u110C\u1161\u11AF\u1106\u1169\u11BA
\u110C\u1161\u11B7\u1101\u1161\u11AB
\u110C\u1161\u11B7\u1109\u116E\u1112\u1161\u11B7
\u110C\u1161\u11B7\u1109\u1175
\u110C\u1161\u11B7\u110B\u1169\u11BA
\u110C\u1161\u11B7\u110C\u1161\u1105\u1175
\u110C\u1161\u11B8\u110C\u1175
\u110C\u1161\u11BC\u1100\u116A\u11AB
\u110C\u1161\u11BC\u1100\u116E\u11AB
\u110C\u1161\u11BC\u1100\u1175\u1100\u1161\u11AB
\u110C\u1161\u11BC\u1105\u1162
\u110C\u1161\u11BC\u1105\u1168
\u110C\u1161\u11BC\u1105\u1173
\u110C\u1161\u11BC\u1106\u1161
\u110C\u1161\u11BC\u1106\u1167\u11AB
\u110C\u1161\u11BC\u1106\u1169
\u110C\u1161\u11BC\u1106\u1175
\u110C\u1161\u11BC\u1107\u1175
\u110C\u1161\u11BC\u1109\u1161
\u110C\u1161\u11BC\u1109\u1169
\u110C\u1161\u11BC\u1109\u1175\u11A8
\u110C\u1161\u11BC\u110B\u1162\u110B\u1175\u11AB
\u110C\u1161\u11BC\u110B\u1175\u11AB
\u110C\u1161\u11BC\u110C\u1165\u11B7
\u110C\u1161\u11BC\u110E\u1161
\u110C\u1161\u11BC\u1112\u1161\u11A8\u1100\u1173\u11B7
\u110C\u1162\u1102\u1173\u11BC
\u110C\u1162\u1108\u1161\u11AF\u1105\u1175
\u110C\u1162\u1109\u1161\u11AB
\u110C\u1162\u1109\u1162\u11BC
\u110C\u1162\u110C\u1161\u11A8\u1102\u1167\u11AB
\u110C\u1162\u110C\u1165\u11BC
\u110C\u1162\u110E\u1162\u1100\u1175
\u110C\u1162\u1111\u1161\u11AB
\u110C\u1162\u1112\u1161\u11A8
\u110C\u1162\u1112\u116A\u11AF\u110B\u116D\u11BC
\u110C\u1165\u1100\u1165\u11BA
\u110C\u1165\u1100\u1169\u1105\u1175
\u110C\u1165\u1100\u1169\u11BA
\u110C\u1165\u1102\u1167\u11A8
\u110C\u1165\u1105\u1165\u11AB
\u110C\u1165\u1105\u1165\u11C2\u1100\u1166
\u110C\u1165\u1107\u1165\u11AB
\u110C\u1165\u110B\u116E\u11AF
\u110C\u1165\u110C\u1165\u11AF\u1105\u1169
\u110C\u1165\u110E\u116E\u11A8
\u110C\u1165\u11A8\u1100\u1173\u11A8
\u110C\u1165\u11A8\u1103\u1161\u11BC\u1112\u1175
\u110C\u1165\u11A8\u1109\u1165\u11BC
\u110C\u1165\u11A8\u110B\u116D\u11BC
\u110C\u1165\u11A8\u110B\u1173\u11BC
\u110C\u1165\u11AB\u1100\u1162
\u110C\u1165\u11AB\u1100\u1169\u11BC
\u110C\u1165\u11AB\u1100\u1175
\u110C\u1165\u11AB\u1103\u1161\u11AF
\u110C\u1165\u11AB\u1105\u1161\u1103\u1169
\u110C\u1165\u11AB\u1106\u1161\u11BC
\u110C\u1165\u11AB\u1106\u116E\u11AB
\u110C\u1165\u11AB\u1107\u1161\u11AB
\u110C\u1165\u11AB\u1107\u116E
\u110C\u1165\u11AB\u1109\u1166
\u110C\u1165\u11AB\u1109\u1175
\u110C\u1165\u11AB\u110B\u116D\u11BC
\u110C\u1165\u11AB\u110C\u1161
\u110C\u1165\u11AB\u110C\u1162\u11BC
\u110C\u1165\u11AB\u110C\u116E
\u110C\u1165\u11AB\u110E\u1165\u11AF
\u110C\u1165\u11AB\u110E\u1166
\u110C\u1165\u11AB\u1110\u1169\u11BC
\u110C\u1165\u11AB\u1112\u1167
\u110C\u1165\u11AB\u1112\u116E
\u110C\u1165\u11AF\u1103\u1162
\u110C\u1165\u11AF\u1106\u1161\u11BC
\u110C\u1165\u11AF\u1107\u1161\u11AB
\u110C\u1165\u11AF\u110B\u1163\u11A8
\u110C\u1165\u11AF\u110E\u1161
\u110C\u1165\u11B7\u1100\u1165\u11B7
\u110C\u1165\u11B7\u1109\u116E
\u110C\u1165\u11B7\u1109\u1175\u11B7
\u110C\u1165\u11B7\u110B\u116F\u11AB
\u110C\u1165\u11B7\u110C\u1165\u11B7
\u110C\u1165\u11B7\u110E\u1161
\u110C\u1165\u11B8\u1100\u1173\u11AB
\u110C\u1165\u11B8\u1109\u1175
\u110C\u1165\u11B8\u110E\u1169\u11A8
\u110C\u1165\u11BA\u1100\u1161\u1105\u1161\u11A8
\u110C\u1165\u11BC\u1100\u1165\u110C\u1161\u11BC
\u110C\u1165\u11BC\u1103\u1169
\u110C\u1165\u11BC\u1105\u1172\u110C\u1161\u11BC
\u110C\u1165\u11BC\u1105\u1175
\u110C\u1165\u11BC\u1106\u1161\u11AF
\u110C\u1165\u11BC\u1106\u1167\u11AB
\u110C\u1165\u11BC\u1106\u116E\u11AB
\u110C\u1165\u11BC\u1107\u1161\u11AB\u1103\u1162
\u110C\u1165\u11BC\u1107\u1169
\u110C\u1165\u11BC\u1107\u116E
\u110C\u1165\u11BC\u1107\u1175
\u110C\u1165\u11BC\u1109\u1161\u11BC
\u110C\u1165\u11BC\u1109\u1165\u11BC
\u110C\u1165\u11BC\u110B\u1169
\u110C\u1165\u11BC\u110B\u116F\u11AB
\u110C\u1165\u11BC\u110C\u1161\u11BC
\u110C\u1165\u11BC\u110C\u1175
\u110C\u1165\u11BC\u110E\u1175
\u110C\u1165\u11BC\u1112\u116A\u11A8\u1112\u1175
\u110C\u1166\u1100\u1169\u11BC
\u110C\u1166\u1100\u116A\u110C\u1165\u11B7
\u110C\u1166\u1103\u1162\u1105\u1169
\u110C\u1166\u1106\u1169\u11A8
\u110C\u1166\u1107\u1161\u11AF
\u110C\u1166\u1107\u1165\u11B8
\u110C\u1166\u1109\u1161\u11BA\u1102\u1161\u11AF
\u110C\u1166\u110B\u1161\u11AB
\u110C\u1166\u110B\u1175\u11AF
\u110C\u1166\u110C\u1161\u11A8
\u110C\u1166\u110C\u116E\u1103\u1169
\u110C\u1166\u110E\u116E\u11AF
\u110C\u1166\u1111\u116E\u11B7
\u110C\u1166\u1112\u1161\u11AB
\u110C\u1169\u1100\u1161\u11A8
\u110C\u1169\u1100\u1165\u11AB
\u110C\u1169\u1100\u1173\u11B7
\u110C\u1169\u1100\u1175\u11BC
\u110C\u1169\u1106\u1167\u11BC
\u110C\u1169\u1106\u1175\u1105\u116D
\u110C\u1169\u1109\u1161\u11BC
\u110C\u1169\u1109\u1165\u11AB
\u110C\u1169\u110B\u116D\u11BC\u1112\u1175
\u110C\u1169\u110C\u1165\u11AF
\u110C\u1169\u110C\u1165\u11BC
\u110C\u1169\u110C\u1175\u11A8
\u110C\u1169\u11AB\u1103\u1162\u11BA\u1106\u1161\u11AF
\u110C\u1169\u11AB\u110C\u1162
\u110C\u1169\u11AF\u110B\u1165\u11B8
\u110C\u1169\u11AF\u110B\u1173\u11B7
\u110C\u1169\u11BC\u1100\u116D
\u110C\u1169\u11BC\u1105\u1169
\u110C\u1169\u11BC\u1105\u1172
\u110C\u1169\u11BC\u1109\u1169\u1105\u1175
\u110C\u1169\u11BC\u110B\u1165\u11B8\u110B\u116F\u11AB
\u110C\u1169\u11BC\u110C\u1169\u11BC
\u110C\u1169\u11BC\u1112\u1161\u11B8
\u110C\u116A\u1109\u1165\u11A8
\u110C\u116C\u110B\u1175\u11AB
\u110C\u116E\u1100\u116A\u11AB\u110C\u1165\u11A8
\u110C\u116E\u1105\u1173\u11B7
\u110C\u116E\u1106\u1161\u11AF
\u110C\u116E\u1106\u1165\u1102\u1175
\u110C\u116E\u1106\u1165\u11A8
\u110C\u116E\u1106\u116E\u11AB
\u110C\u116E\u1106\u1175\u11AB
\u110C\u116E\u1107\u1161\u11BC
\u110C\u116E\u1107\u1167\u11AB
\u110C\u116E\u1109\u1175\u11A8
\u110C\u116E\u110B\u1175\u11AB
\u110C\u116E\u110B\u1175\u11AF
\u110C\u116E\u110C\u1161\u11BC
\u110C\u116E\u110C\u1165\u11AB\u110C\u1161
\u110C\u116E\u1110\u1162\u11A8
\u110C\u116E\u11AB\u1107\u1175
\u110C\u116E\u11AF\u1100\u1165\u1105\u1175
\u110C\u116E\u11AF\u1100\u1175
\u110C\u116E\u11AF\u1106\u116E\u1102\u1174
\u110C\u116E\u11BC\u1100\u1161\u11AB
\u110C\u116E\u11BC\u1100\u1168\u1107\u1161\u11BC\u1109\u1169\u11BC
\u110C\u116E\u11BC\u1100\u116E\u11A8
\u110C\u116E\u11BC\u1102\u1167\u11AB
\u110C\u116E\u11BC\u1103\u1161\u11AB
\u110C\u116E\u11BC\u1103\u1169\u11A8
\u110C\u116E\u11BC\u1107\u1161\u11AB
\u110C\u116E\u11BC\u1107\u116E
\u110C\u116E\u11BC\u1109\u1166
\u110C\u116E\u11BC\u1109\u1169\u1100\u1175\u110B\u1165\u11B8
\u110C\u116E\u11BC\u1109\u116E\u11AB
\u110C\u116E\u11BC\u110B\u1161\u11BC
\u110C\u116E\u11BC\u110B\u116D
\u110C\u116E\u11BC\u1112\u1161\u11A8\u1100\u116D
\u110C\u1173\u11A8\u1109\u1165\u11A8
\u110C\u1173\u11A8\u1109\u1175
\u110C\u1173\u11AF\u1100\u1165\u110B\u116E\u11B7
\u110C\u1173\u11BC\u1100\u1161
\u110C\u1173\u11BC\u1100\u1165
\u110C\u1173\u11BC\u1100\u116F\u11AB
\u110C\u1173\u11BC\u1109\u1161\u11BC
\u110C\u1173\u11BC\u1109\u1166
\u110C\u1175\u1100\u1161\u11A8
\u110C\u1175\u1100\u1161\u11B8
\u110C\u1175\u1100\u1167\u11BC
\u110C\u1175\u1100\u1173\u11A8\u1112\u1175
\u110C\u1175\u1100\u1173\u11B7
\u110C\u1175\u1100\u1173\u11B8
\u110C\u1175\u1102\u1173\u11BC
\u110C\u1175\u1105\u1173\u11B7\u1100\u1175\u11AF
\u110C\u1175\u1105\u1175\u1109\u1161\u11AB
\u110C\u1175\u1107\u1161\u11BC
\u110C\u1175\u1107\u116E\u11BC
\u110C\u1175\u1109\u1175\u11A8
\u110C\u1175\u110B\u1167\u11A8
\u110C\u1175\u110B\u116E\u1100\u1162
\u110C\u1175\u110B\u116F\u11AB
\u110C\u1175\u110C\u1165\u11A8
\u110C\u1175\u110C\u1165\u11B7
\u110C\u1175\u110C\u1175\u11AB
\u110C\u1175\u110E\u116E\u11AF
\u110C\u1175\u11A8\u1109\u1165\u11AB
\u110C\u1175\u11A8\u110B\u1165\u11B8
\u110C\u1175\u11A8\u110B\u116F\u11AB
\u110C\u1175\u11A8\u110C\u1161\u11BC
\u110C\u1175\u11AB\u1100\u1173\u11B8
\u110C\u1175\u11AB\u1103\u1169\u11BC
\u110C\u1175\u11AB\u1105\u1169
\u110C\u1175\u11AB\u1105\u116D
\u110C\u1175\u11AB\u1105\u1175
\u110C\u1175\u11AB\u110D\u1161
\u110C\u1175\u11AB\u110E\u1161\u11AF
\u110C\u1175\u11AB\u110E\u116E\u11AF
\u110C\u1175\u11AB\u1110\u1169\u11BC
\u110C\u1175\u11AB\u1112\u1162\u11BC
\u110C\u1175\u11AF\u1106\u116E\u11AB
\u110C\u1175\u11AF\u1107\u1167\u11BC
\u110C\u1175\u11AF\u1109\u1165
\u110C\u1175\u11B7\u110C\u1161\u11A8
\u110C\u1175\u11B8\u1103\u1161\u11AB
\u110C\u1175\u11B8\u110B\u1161\u11AB
\u110C\u1175\u11B8\u110C\u116E\u11BC
\u110D\u1161\u110C\u1173\u11BC
\u110D\u1175\u1101\u1165\u1100\u1175
\u110E\u1161\u1102\u1161\u11B7
\u110E\u1161\u1105\u1161\u1105\u1175
\u110E\u1161\u1105\u1163\u11BC
\u110E\u1161\u1105\u1175\u11B7
\u110E\u1161\u1107\u1167\u11AF
\u110E\u1161\u1109\u1165\u11AB
\u110E\u1161\u110E\u1173\u11B7
\u110E\u1161\u11A8\u1100\u1161\u11A8
\u110E\u1161\u11AB\u1106\u116E\u11AF
\u110E\u1161\u11AB\u1109\u1165\u11BC
\u110E\u1161\u11B7\u1100\u1161
\u110E\u1161\u11B7\u1100\u1175\u1105\u1173\u11B7
\u110E\u1161\u11B7\u1109\u1162
\u110E\u1161\u11B7\u1109\u1165\u11A8
\u110E\u1161\u11B7\u110B\u1167
\u110E\u1161\u11B7\u110B\u116C
\u110E\u1161\u11B7\u110C\u1169
\u110E\u1161\u11BA\u110C\u1161\u11AB
\u110E\u1161\u11BC\u1100\u1161
\u110E\u1161\u11BC\u1100\u1169
\u110E\u1161\u11BC\u1100\u116E
\u110E\u1161\u11BC\u1106\u116E\u11AB
\u110E\u1161\u11BC\u1107\u1161\u11A9
\u110E\u1161\u11BC\u110C\u1161\u11A8
\u110E\u1161\u11BC\u110C\u1169
\u110E\u1162\u1102\u1165\u11AF
\u110E\u1162\u110C\u1165\u11B7
\u110E\u1162\u11A8\u1100\u1161\u1107\u1161\u11BC
\u110E\u1162\u11A8\u1107\u1161\u11BC
\u110E\u1162\u11A8\u1109\u1161\u11BC
\u110E\u1162\u11A8\u110B\u1175\u11B7
\u110E\u1162\u11B7\u1111\u1175\u110B\u1165\u11AB
\u110E\u1165\u1107\u1165\u11AF
\u110E\u1165\u110B\u1173\u11B7
\u110E\u1165\u11AB\u1100\u116E\u11A8
\u110E\u1165\u11AB\u1103\u116E\u11BC
\u110E\u1165\u11AB\u110C\u1161\u11BC
\u110E\u1165\u11AB\u110C\u1162
\u110E\u1165\u11AB\u110E\u1165\u11AB\u1112\u1175
\u110E\u1165\u11AF\u1103\u1169
\u110E\u1165\u11AF\u110C\u1165\u1112\u1175
\u110E\u1165\u11AF\u1112\u1161\u11A8
\u110E\u1165\u11BA\u1102\u1161\u11AF
\u110E\u1165\u11BA\u110D\u1162
\u110E\u1165\u11BC\u1102\u1167\u11AB
\u110E\u1165\u11BC\u1107\u1161\u110C\u1175
\u110E\u1165\u11BC\u1109\u1169
\u110E\u1165\u11BC\u110E\u116E\u11AB
\u110E\u1166\u1100\u1168
\u110E\u1166\u1105\u1167\u11A8
\u110E\u1166\u110B\u1169\u11AB
\u110E\u1166\u110B\u1172\u11A8
\u110E\u1166\u110C\u116E\u11BC
\u110E\u1166\u1112\u1165\u11B7
\u110E\u1169\u1103\u1173\u11BC\u1112\u1161\u11A8\u1109\u1162\u11BC
\u110E\u1169\u1107\u1161\u11AB
\u110E\u1169\u1107\u1161\u11B8
\u110E\u1169\u1109\u1161\u11BC\u1112\u116A
\u110E\u1169\u1109\u116E\u11AB
\u110E\u1169\u110B\u1167\u1105\u1173\u11B7
\u110E\u1169\u110B\u116F\u11AB
\u110E\u1169\u110C\u1165\u1102\u1167\u11A8
\u110E\u1169\u110C\u1165\u11B7
\u110E\u1169\u110E\u1165\u11BC
\u110E\u1169\u110F\u1169\u11AF\u1105\u1175\u11BA
\u110E\u1169\u11BA\u1107\u116E\u11AF
\u110E\u1169\u11BC\u1100\u1161\u11A8
\u110E\u1169\u11BC\u1105\u1175
\u110E\u1169\u11BC\u110C\u1161\u11BC
\u110E\u116A\u11AF\u110B\u1167\u11BC
\u110E\u116C\u1100\u1173\u11AB
\u110E\u116C\u1109\u1161\u11BC
\u110E\u116C\u1109\u1165\u11AB
\u110E\u116C\u1109\u1175\u11AB
\u110E\u116C\u110B\u1161\u11A8
\u110E\u116C\u110C\u1169\u11BC
\u110E\u116E\u1109\u1165\u11A8
\u110E\u116E\u110B\u1165\u11A8
\u110E\u116E\u110C\u1175\u11AB
\u110E\u116E\u110E\u1165\u11AB
\u110E\u116E\u110E\u1173\u11A8
\u110E\u116E\u11A8\u1100\u116E
\u110E\u116E\u11A8\u1109\u1169
\u110E\u116E\u11A8\u110C\u1166
\u110E\u116E\u11A8\u1112\u1161
\u110E\u116E\u11AF\u1100\u1173\u11AB
\u110E\u116E\u11AF\u1107\u1161\u11AF
\u110E\u116E\u11AF\u1109\u1161\u11AB
\u110E\u116E\u11AF\u1109\u1175\u11AB
\u110E\u116E\u11AF\u110B\u1167\u11AB
\u110E\u116E\u11AF\u110B\u1175\u11B8
\u110E\u116E\u11AF\u110C\u1161\u11BC
\u110E\u116E\u11AF\u1111\u1161\u11AB
\u110E\u116E\u11BC\u1100\u1167\u11A8
\u110E\u116E\u11BC\u1100\u1169
\u110E\u116E\u11BC\u1103\u1169\u11AF
\u110E\u116E\u11BC\u1107\u116E\u11AB\u1112\u1175
\u110E\u116E\u11BC\u110E\u1165\u11BC\u1103\u1169
\u110E\u1171\u110B\u1165\u11B8
\u110E\u1171\u110C\u1175\u11A8
\u110E\u1171\u1112\u1163\u11BC
\u110E\u1175\u110B\u1163\u11A8
\u110E\u1175\u11AB\u1100\u116E
\u110E\u1175\u11AB\u110E\u1165\u11A8
\u110E\u1175\u11AF\u1109\u1175\u11B8
\u110E\u1175\u11AF\u110B\u116F\u11AF
\u110E\u1175\u11AF\u1111\u1161\u11AB
\u110E\u1175\u11B7\u1103\u1162
\u110E\u1175\u11B7\u1106\u116E\u11A8
\u110E\u1175\u11B7\u1109\u1175\u11AF
\u110E\u1175\u11BA\u1109\u1169\u11AF
\u110E\u1175\u11BC\u110E\u1161\u11AB
\u110F\u1161\u1106\u1166\u1105\u1161
\u110F\u1161\u110B\u116E\u11AB\u1110\u1165
\u110F\u1161\u11AF\u1100\u116E\u11A8\u1109\u116E
\u110F\u1162\u1105\u1175\u11A8\u1110\u1165
\u110F\u1162\u11B7\u1111\u1165\u1109\u1173
\u110F\u1162\u11B7\u1111\u1166\u110B\u1175\u11AB
\u110F\u1165\u1110\u1173\u11AB
\u110F\u1165\u11AB\u1103\u1175\u1109\u1167\u11AB
\u110F\u1165\u11AF\u1105\u1165
\u110F\u1165\u11B7\u1111\u1172\u1110\u1165
\u110F\u1169\u1101\u1175\u1105\u1175
\u110F\u1169\u1106\u1175\u1103\u1175
\u110F\u1169\u11AB\u1109\u1165\u1110\u1173
\u110F\u1169\u11AF\u1105\u1161
\u110F\u1169\u11B7\u1111\u1173\u11AF\u1105\u1166\u11A8\u1109\u1173
\u110F\u1169\u11BC\u1102\u1161\u1106\u116E\u11AF
\u110F\u116B\u1100\u1161\u11B7
\u110F\u116E\u1103\u1166\u1110\u1161
\u110F\u1173\u1105\u1175\u11B7
\u110F\u1173\u11AB\u1100\u1175\u11AF
\u110F\u1173\u11AB\u1104\u1161\u11AF
\u110F\u1173\u11AB\u1109\u1169\u1105\u1175
\u110F\u1173\u11AB\u110B\u1161\u1103\u1173\u11AF
\u110F\u1173\u11AB\u110B\u1165\u1106\u1165\u1102\u1175
\u110F\u1173\u11AB\u110B\u1175\u11AF
\u110F\u1173\u11AB\u110C\u1165\u11AF
\u110F\u1173\u11AF\u1105\u1162\u1109\u1175\u11A8
\u110F\u1173\u11AF\u1105\u1165\u11B8
\u110F\u1175\u11AF\u1105\u1169
\u1110\u1161\u110B\u1175\u11B8
\u1110\u1161\u110C\u1161\u1100\u1175
\u1110\u1161\u11A8\u1100\u116E
\u1110\u1161\u11A8\u110C\u1161
\u1110\u1161\u11AB\u1109\u1162\u11BC
\u1110\u1162\u1100\u116F\u11AB\u1103\u1169
\u1110\u1162\u110B\u1163\u11BC
\u1110\u1162\u1111\u116E\u11BC
\u1110\u1162\u11A8\u1109\u1175
\u1110\u1162\u11AF\u1105\u1165\u11AB\u1110\u1173
\u1110\u1165\u1102\u1165\u11AF
\u1110\u1165\u1106\u1175\u1102\u1165\u11AF
\u1110\u1166\u1102\u1175\u1109\u1173
\u1110\u1166\u1109\u1173\u1110\u1173
\u1110\u1166\u110B\u1175\u1107\u1173\u11AF
\u1110\u1166\u11AF\u1105\u1166\u1107\u1175\u110C\u1165\u11AB
\u1110\u1169\u1105\u1169\u11AB
\u1110\u1169\u1106\u1161\u1110\u1169
\u1110\u1169\u110B\u116D\u110B\u1175\u11AF
\u1110\u1169\u11BC\u1100\u1168
\u1110\u1169\u11BC\u1100\u116A
\u1110\u1169\u11BC\u1105\u1169
\u1110\u1169\u11BC\u1109\u1175\u11AB
\u1110\u1169\u11BC\u110B\u1167\u11A8
\u1110\u1169\u11BC\u110B\u1175\u11AF
\u1110\u1169\u11BC\u110C\u1161\u11BC
\u1110\u1169\u11BC\u110C\u1166
\u1110\u1169\u11BC\u110C\u1173\u11BC
\u1110\u1169\u11BC\u1112\u1161\u11B8
\u1110\u1169\u11BC\u1112\u116A
\u1110\u116C\u1100\u1173\u11AB
\u1110\u116C\u110B\u116F\u11AB
\u1110\u116C\u110C\u1175\u11A8\u1100\u1173\u11B7
\u1110\u1171\u1100\u1175\u11B7
\u1110\u1173\u1105\u1165\u11A8
\u1110\u1173\u11A8\u1100\u1173\u11B8
\u1110\u1173\u11A8\u1107\u1167\u11AF
\u1110\u1173\u11A8\u1109\u1165\u11BC
\u1110\u1173\u11A8\u1109\u116E
\u1110\u1173\u11A8\u110C\u1175\u11BC
\u1110\u1173\u11A8\u1112\u1175
\u1110\u1173\u11AB\u1110\u1173\u11AB\u1112\u1175
\u1110\u1175\u1109\u1167\u110E\u1173
\u1111\u1161\u1105\u1161\u11AB\u1109\u1162\u11A8
\u1111\u1161\u110B\u1175\u11AF
\u1111\u1161\u110E\u116E\u11AF\u1109\u1169
\u1111\u1161\u11AB\u1100\u1167\u11AF
\u1111\u1161\u11AB\u1103\u1161\u11AB
\u1111\u1161\u11AB\u1106\u1162
\u1111\u1161\u11AB\u1109\u1161
\u1111\u1161\u11AF\u1109\u1175\u11B8
\u1111\u1161\u11AF\u110B\u116F\u11AF
\u1111\u1161\u11B8\u1109\u1169\u11BC
\u1111\u1162\u1109\u1167\u11AB
\u1111\u1162\u11A8\u1109\u1173
\u1111\u1162\u11A8\u1109\u1175\u1106\u1175\u11AF\u1105\u1175
\u1111\u1162\u11AB\u1110\u1175
\u1111\u1165\u1109\u1166\u11AB\u1110\u1173
\u1111\u1166\u110B\u1175\u11AB\u1110\u1173
\u1111\u1167\u11AB\u1100\u1167\u11AB
\u1111\u1167\u11AB\u110B\u1174
\u1111\u1167\u11AB\u110C\u1175
\u1111\u1167\u11AB\u1112\u1175
\u1111\u1167\u11BC\u1100\u1161
\u1111\u1167\u11BC\u1100\u1172\u11AB
\u1111\u1167\u11BC\u1109\u1162\u11BC
\u1111\u1167\u11BC\u1109\u1169
\u1111\u1167\u11BC\u110B\u1163\u11BC
\u1111\u1167\u11BC\u110B\u1175\u11AF
\u1111\u1167\u11BC\u1112\u116A
\u1111\u1169\u1109\u1173\u1110\u1165
\u1111\u1169\u110B\u1175\u11AB\u1110\u1173
\u1111\u1169\u110C\u1161\u11BC
\u1111\u1169\u1112\u1161\u11B7
\u1111\u116D\u1106\u1167\u11AB
\u1111\u116D\u110C\u1165\u11BC
\u1111\u116D\u110C\u116E\u11AB
\u1111\u116D\u1112\u1167\u11AB
\u1111\u116E\u11B7\u1106\u1169\u11A8
\u1111\u116E\u11B7\u110C\u1175\u11AF
\u1111\u116E\u11BC\u1100\u1167\u11BC
\u1111\u116E\u11BC\u1109\u1169\u11A8
\u1111\u116E\u11BC\u1109\u1173\u11B8
\u1111\u1173\u1105\u1161\u11BC\u1109\u1173
\u1111\u1173\u1105\u1175\u11AB\u1110\u1165
\u1111\u1173\u11AF\u1105\u1161\u1109\u1173\u1110\u1175\u11A8
\u1111\u1175\u1100\u1169\u11AB
\u1111\u1175\u1106\u1161\u11BC
\u1111\u1175\u110B\u1161\u1102\u1169
\u1111\u1175\u11AF\u1105\u1173\u11B7
\u1111\u1175\u11AF\u1109\u116E
\u1111\u1175\u11AF\u110B\u116D
\u1111\u1175\u11AF\u110C\u1161
\u1111\u1175\u11AF\u1110\u1169\u11BC
\u1111\u1175\u11BC\u1100\u1168
\u1112\u1161\u1102\u1173\u1102\u1175\u11B7
\u1112\u1161\u1102\u1173\u11AF
\u1112\u1161\u1103\u1173\u110B\u1170\u110B\u1165
\u1112\u1161\u1105\u116E\u11BA\u1107\u1161\u11B7
\u1112\u1161\u1107\u1161\u11AB\u1100\u1175
\u1112\u1161\u1109\u116E\u11A8\u110C\u1175\u11B8
\u1112\u1161\u1109\u116E\u11AB
\u1112\u1161\u110B\u1167\u1110\u1173\u11AB
\u1112\u1161\u110C\u1175\u1106\u1161\u11AB
\u1112\u1161\u110E\u1165\u11AB
\u1112\u1161\u1111\u116E\u11B7
\u1112\u1161\u1111\u1175\u11AF
\u1112\u1161\u11A8\u1100\u116A
\u1112\u1161\u11A8\u1100\u116D
\u1112\u1161\u11A8\u1100\u1173\u11B8
\u1112\u1161\u11A8\u1100\u1175
\u1112\u1161\u11A8\u1102\u1167\u11AB
\u1112\u1161\u11A8\u1105\u1167\u11A8
\u1112\u1161\u11A8\u1107\u1165\u11AB
\u1112\u1161\u11A8\u1107\u116E\u1106\u1169
\u1112\u1161\u11A8\u1107\u1175
\u1112\u1161\u11A8\u1109\u1162\u11BC
\u1112\u1161\u11A8\u1109\u116E\u11AF
\u1112\u1161\u11A8\u1109\u1173\u11B8
\u1112\u1161\u11A8\u110B\u116D\u11BC\u1111\u116E\u11B7
\u1112\u1161\u11A8\u110B\u116F\u11AB
\u1112\u1161\u11A8\u110B\u1171
\u1112\u1161\u11A8\u110C\u1161
\u1112\u1161\u11A8\u110C\u1165\u11B7
\u1112\u1161\u11AB\u1100\u1168
\u1112\u1161\u11AB\u1100\u1173\u11AF
\u1112\u1161\u11AB\u1101\u1165\u1107\u1165\u11AB\u110B\u1166
\u1112\u1161\u11AB\u1102\u1161\u11BD
\u1112\u1161\u11AB\u1102\u116E\u11AB
\u1112\u1161\u11AB\u1103\u1169\u11BC\u110B\u1161\u11AB
\u1112\u1161\u11AB\u1104\u1162
\u1112\u1161\u11AB\u1105\u1161\u1109\u1161\u11AB
\u1112\u1161\u11AB\u1106\u1161\u1103\u1175
\u1112\u1161\u11AB\u1106\u116E\u11AB
\u1112\u1161\u11AB\u1107\u1165\u11AB
\u1112\u1161\u11AB\u1107\u1169\u11A8
\u1112\u1161\u11AB\u1109\u1175\u11A8
\u1112\u1161\u11AB\u110B\u1167\u1105\u1173\u11B7
\u1112\u1161\u11AB\u110D\u1169\u11A8
\u1112\u1161\u11AF\u1106\u1165\u1102\u1175
\u1112\u1161\u11AF\u110B\u1161\u1107\u1165\u110C\u1175
\u1112\u1161\u11AF\u110B\u1175\u11AB
\u1112\u1161\u11B7\u1101\u1166
\u1112\u1161\u11B7\u1107\u116E\u1105\u1169
\u1112\u1161\u11B8\u1100\u1167\u11A8
\u1112\u1161\u11B8\u1105\u1175\u110C\u1165\u11A8
\u1112\u1161\u11BC\u1100\u1169\u11BC
\u1112\u1161\u11BC\u1100\u116E
\u1112\u1161\u11BC\u1109\u1161\u11BC
\u1112\u1161\u11BC\u110B\u1174
\u1112\u1162\u1100\u1167\u11AF
\u1112\u1162\u1100\u116E\u11AB
\u1112\u1162\u1103\u1161\u11B8
\u1112\u1162\u1103\u1161\u11BC
\u1112\u1162\u1106\u116E\u11AF
\u1112\u1162\u1109\u1165\u11A8
\u1112\u1162\u1109\u1165\u11AF
\u1112\u1162\u1109\u116E\u110B\u116D\u11A8\u110C\u1161\u11BC
\u1112\u1162\u110B\u1161\u11AB
\u1112\u1162\u11A8\u1109\u1175\u11B7
\u1112\u1162\u11AB\u1103\u1173\u1107\u1162\u11A8
\u1112\u1162\u11B7\u1107\u1165\u1100\u1165
\u1112\u1162\u11BA\u1107\u1167\u11C0
\u1112\u1162\u11BA\u1109\u1161\u11AF
\u1112\u1162\u11BC\u1103\u1169\u11BC
\u1112\u1162\u11BC\u1107\u1169\u11A8
\u1112\u1162\u11BC\u1109\u1161
\u1112\u1162\u11BC\u110B\u116E\u11AB
\u1112\u1162\u11BC\u110B\u1171
\u1112\u1163\u11BC\u1100\u1175
\u1112\u1163\u11BC\u1109\u1161\u11BC
\u1112\u1163\u11BC\u1109\u116E
\u1112\u1165\u1105\u1161\u11A8
\u1112\u1165\u110B\u116D\u11BC
\u1112\u1166\u11AF\u1100\u1175
\u1112\u1167\u11AB\u1100\u116A\u11AB
\u1112\u1167\u11AB\u1100\u1173\u11B7
\u1112\u1167\u11AB\u1103\u1162
\u1112\u1167\u11AB\u1109\u1161\u11BC
\u1112\u1167\u11AB\u1109\u1175\u11AF
\u1112\u1167\u11AB\u110C\u1161\u11BC
\u1112\u1167\u11AB\u110C\u1162
\u1112\u1167\u11AB\u110C\u1175
\u1112\u1167\u11AF\u110B\u1162\u11A8
\u1112\u1167\u11B8\u1105\u1167\u11A8
\u1112\u1167\u11BC\u1107\u116E
\u1112\u1167\u11BC\u1109\u1161
\u1112\u1167\u11BC\u1109\u116E
\u1112\u1167\u11BC\u1109\u1175\u11A8
\u1112\u1167\u11BC\u110C\u1166
\u1112\u1167\u11BC\u1110\u1162
\u1112\u1167\u11BC\u1111\u1167\u11AB
\u1112\u1168\u1110\u1162\u11A8
\u1112\u1169\u1100\u1175\u1109\u1175\u11B7
\u1112\u1169\u1102\u1161\u11B7
\u1112\u1169\u1105\u1161\u11BC\u110B\u1175
\u1112\u1169\u1107\u1161\u11A8
\u1112\u1169\u1110\u1166\u11AF
\u1112\u1169\u1112\u1173\u11B8
\u1112\u1169\u11A8\u1109\u1175
\u1112\u1169\u11AF\u1105\u1169
\u1112\u1169\u11B7\u1111\u1166\u110B\u1175\u110C\u1175
\u1112\u1169\u11BC\u1107\u1169
\u1112\u1169\u11BC\u1109\u116E
\u1112\u1169\u11BC\u110E\u1161
\u1112\u116A\u1106\u1167\u11AB
\u1112\u116A\u1107\u116E\u11AB
\u1112\u116A\u1109\u1161\u11AF
\u1112\u116A\u110B\u116D\u110B\u1175\u11AF
\u1112\u116A\u110C\u1161\u11BC
\u1112\u116A\u1112\u1161\u11A8
\u1112\u116A\u11A8\u1107\u1169
\u1112\u116A\u11A8\u110B\u1175\u11AB
\u1112\u116A\u11A8\u110C\u1161\u11BC
\u1112\u116A\u11A8\u110C\u1165\u11BC
\u1112\u116A\u11AB\u1100\u1161\u11B8
\u1112\u116A\u11AB\u1100\u1167\u11BC
\u1112\u116A\u11AB\u110B\u1167\u11BC
\u1112\u116A\u11AB\u110B\u1172\u11AF
\u1112\u116A\u11AB\u110C\u1161
\u1112\u116A\u11AF\u1100\u1175
\u1112\u116A\u11AF\u1103\u1169\u11BC
\u1112\u116A\u11AF\u1107\u1161\u11AF\u1112\u1175
\u1112\u116A\u11AF\u110B\u116D\u11BC
\u1112\u116A\u11AF\u110D\u1161\u11A8
\u1112\u116C\u1100\u1167\u11AB
\u1112\u116C\u1100\u116A\u11AB
\u1112\u116C\u1107\u1169\u11A8
\u1112\u116C\u1109\u1162\u11A8
\u1112\u116C\u110B\u116F\u11AB
\u1112\u116C\u110C\u1161\u11BC
\u1112\u116C\u110C\u1165\u11AB
\u1112\u116C\u11BA\u1109\u116E
\u1112\u116C\u11BC\u1103\u1161\u11AB\u1107\u1169\u1103\u1169
\u1112\u116D\u110B\u1172\u11AF\u110C\u1165\u11A8
\u1112\u116E\u1107\u1161\u11AB
\u1112\u116E\u110E\u116E\u11BA\u1100\u1161\u1105\u116E
\u1112\u116E\u11AB\u1105\u1167\u11AB
\u1112\u116F\u11AF\u110A\u1175\u11AB
\u1112\u1172\u1109\u1175\u11A8
\u1112\u1172\u110B\u1175\u11AF
\u1112\u1172\u11BC\u1102\u1162
\u1112\u1173\u1105\u1173\u11B7
\u1112\u1173\u11A8\u1107\u1162\u11A8
\u1112\u1173\u11A8\u110B\u1175\u11AB
\u1112\u1173\u11AB\u110C\u1165\u11A8
\u1112\u1173\u11AB\u1112\u1175
\u1112\u1173\u11BC\u1106\u1175
\u1112\u1173\u11BC\u1107\u116E\u11AB
\u1112\u1174\u1100\u1169\u11A8
\u1112\u1174\u1106\u1161\u11BC
\u1112\u1174\u1109\u1162\u11BC
\u1112\u1174\u11AB\u1109\u1162\u11A8
\u1112\u1175\u11B7\u1101\u1165\u11BA`,Ml=Kl.split(`
`);var Gl=`abacate
abaixo
abalar
abater
abduzir
abelha
aberto
abismo
abotoar
abranger
abreviar
abrigar
abrupto
absinto
absoluto
absurdo
abutre
acabado
acalmar
acampar
acanhar
acaso
aceitar
acelerar
acenar
acervo
acessar
acetona
achatar
acidez
acima
acionado
acirrar
aclamar
aclive
acolhida
acomodar
acoplar
acordar
acumular
acusador
adaptar
adega
adentro
adepto
adequar
aderente
adesivo
adeus
adiante
aditivo
adjetivo
adjunto
admirar
adorar
adquirir
adubo
adverso
advogado
aeronave
afastar
aferir
afetivo
afinador
afivelar
aflito
afluente
afrontar
agachar
agarrar
agasalho
agenciar
agilizar
agiota
agitado
agora
agradar
agreste
agrupar
aguardar
agulha
ajoelhar
ajudar
ajustar
alameda
alarme
alastrar
alavanca
albergue
albino
alcatra
aldeia
alecrim
alegria
alertar
alface
alfinete
algum
alheio
aliar
alicate
alienar
alinhar
aliviar
almofada
alocar
alpiste
alterar
altitude
alucinar
alugar
aluno
alusivo
alvo
amaciar
amador
amarelo
amassar
ambas
ambiente
ameixa
amenizar
amido
amistoso
amizade
amolador
amontoar
amoroso
amostra
amparar
ampliar
ampola
anagrama
analisar
anarquia
anatomia
andaime
anel
anexo
angular
animar
anjo
anomalia
anotado
ansioso
anterior
anuidade
anunciar
anzol
apagador
apalpar
apanhado
apego
apelido
apertada
apesar
apetite
apito
aplauso
aplicada
apoio
apontar
aposta
aprendiz
aprovar
aquecer
arame
aranha
arara
arcada
ardente
areia
arejar
arenito
aresta
argiloso
argola
arma
arquivo
arraial
arrebate
arriscar
arroba
arrumar
arsenal
arterial
artigo
arvoredo
asfaltar
asilado
aspirar
assador
assinar
assoalho
assunto
astral
atacado
atadura
atalho
atarefar
atear
atender
aterro
ateu
atingir
atirador
ativo
atoleiro
atracar
atrevido
atriz
atual
atum
auditor
aumentar
aura
aurora
autismo
autoria
autuar
avaliar
avante
avaria
avental
avesso
aviador
avisar
avulso
axila
azarar
azedo
azeite
azulejo
babar
babosa
bacalhau
bacharel
bacia
bagagem
baiano
bailar
baioneta
bairro
baixista
bajular
baleia
baliza
balsa
banal
bandeira
banho
banir
banquete
barato
barbado
baronesa
barraca
barulho
baseado
bastante
batata
batedor
batida
batom
batucar
baunilha
beber
beijo
beirada
beisebol
beldade
beleza
belga
beliscar
bendito
bengala
benzer
berimbau
berlinda
berro
besouro
bexiga
bezerro
bico
bicudo
bienal
bifocal
bifurcar
bigorna
bilhete
bimestre
bimotor
biologia
biombo
biosfera
bipolar
birrento
biscoito
bisneto
bispo
bissexto
bitola
bizarro
blindado
bloco
bloquear
boato
bobagem
bocado
bocejo
bochecha
boicotar
bolada
boletim
bolha
bolo
bombeiro
bonde
boneco
bonita
borbulha
borda
boreal
borracha
bovino
boxeador
branco
brasa
braveza
breu
briga
brilho
brincar
broa
brochura
bronzear
broto
bruxo
bucha
budismo
bufar
bule
buraco
busca
busto
buzina
cabana
cabelo
cabide
cabo
cabrito
cacau
cacetada
cachorro
cacique
cadastro
cadeado
cafezal
caiaque
caipira
caixote
cajado
caju
calafrio
calcular
caldeira
calibrar
calmante
calota
camada
cambista
camisa
camomila
campanha
camuflar
canavial
cancelar
caneta
canguru
canhoto
canivete
canoa
cansado
cantar
canudo
capacho
capela
capinar
capotar
capricho
captador
capuz
caracol
carbono
cardeal
careca
carimbar
carneiro
carpete
carreira
cartaz
carvalho
casaco
casca
casebre
castelo
casulo
catarata
cativar
caule
causador
cautelar
cavalo
caverna
cebola
cedilha
cegonha
celebrar
celular
cenoura
censo
centeio
cercar
cerrado
certeiro
cerveja
cetim
cevada
chacota
chaleira
chamado
chapada
charme
chatice
chave
chefe
chegada
cheiro
cheque
chicote
chifre
chinelo
chocalho
chover
chumbo
chutar
chuva
cicatriz
ciclone
cidade
cidreira
ciente
cigana
cimento
cinto
cinza
ciranda
circuito
cirurgia
citar
clareza
clero
clicar
clone
clube
coado
coagir
cobaia
cobertor
cobrar
cocada
coelho
coentro
coeso
cogumelo
coibir
coifa
coiote
colar
coleira
colher
colidir
colmeia
colono
coluna
comando
combinar
comentar
comitiva
comover
complexo
comum
concha
condor
conectar
confuso
congelar
conhecer
conjugar
consumir
contrato
convite
cooperar
copeiro
copiador
copo
coquetel
coragem
cordial
corneta
coronha
corporal
correio
cortejo
coruja
corvo
cosseno
costela
cotonete
couro
couve
covil
cozinha
cratera
cravo
creche
credor
creme
crer
crespo
criada
criminal
crioulo
crise
criticar
crosta
crua
cruzeiro
cubano
cueca
cuidado
cujo
culatra
culminar
culpar
cultura
cumprir
cunhado
cupido
curativo
curral
cursar
curto
cuspir
custear
cutelo
damasco
datar
debater
debitar
deboche
debulhar
decalque
decimal
declive
decote
decretar
dedal
dedicado
deduzir
defesa
defumar
degelo
degrau
degustar
deitado
deixar
delator
delegado
delinear
delonga
demanda
demitir
demolido
dentista
depenado
depilar
depois
depressa
depurar
deriva
derramar
desafio
desbotar
descanso
desenho
desfiado
desgaste
desigual
deslize
desmamar
desova
despesa
destaque
desviar
detalhar
detentor
detonar
detrito
deusa
dever
devido
devotado
dezena
diagrama
dialeto
didata
difuso
digitar
dilatado
diluente
diminuir
dinastia
dinheiro
diocese
direto
discreta
disfarce
disparo
disquete
dissipar
distante
ditador
diurno
diverso
divisor
divulgar
dizer
dobrador
dolorido
domador
dominado
donativo
donzela
dormente
dorsal
dosagem
dourado
doutor
drenagem
drible
drogaria
duelar
duende
dueto
duplo
duquesa
durante
duvidoso
eclodir
ecoar
ecologia
edificar
edital
educado
efeito
efetivar
ejetar
elaborar
eleger
eleitor
elenco
elevador
eliminar
elogiar
embargo
embolado
embrulho
embutido
emenda
emergir
emissor
empatia
empenho
empinado
empolgar
emprego
empurrar
emulador
encaixe
encenado
enchente
encontro
endeusar
endossar
enfaixar
enfeite
enfim
engajado
engenho
englobar
engomado
engraxar
enguia
enjoar
enlatar
enquanto
enraizar
enrolado
enrugar
ensaio
enseada
ensino
ensopado
entanto
enteado
entidade
entortar
entrada
entulho
envergar
enviado
envolver
enxame
enxerto
enxofre
enxuto
epiderme
equipar
ereto
erguido
errata
erva
ervilha
esbanjar
esbelto
escama
escola
escrita
escuta
esfinge
esfolar
esfregar
esfumado
esgrima
esmalte
espanto
espelho
espiga
esponja
espreita
espumar
esquerda
estaca
esteira
esticar
estofado
estrela
estudo
esvaziar
etanol
etiqueta
euforia
europeu
evacuar
evaporar
evasivo
eventual
evidente
evoluir
exagero
exalar
examinar
exato
exausto
excesso
excitar
exclamar
executar
exemplo
exibir
exigente
exonerar
expandir
expelir
expirar
explanar
exposto
expresso
expulsar
externo
extinto
extrato
fabricar
fabuloso
faceta
facial
fada
fadiga
faixa
falar
falta
familiar
fandango
fanfarra
fantoche
fardado
farelo
farinha
farofa
farpa
fartura
fatia
fator
favorita
faxina
fazenda
fechado
feijoada
feirante
felino
feminino
fenda
feno
fera
feriado
ferrugem
ferver
festejar
fetal
feudal
fiapo
fibrose
ficar
ficheiro
figurado
fileira
filho
filme
filtrar
firmeza
fisgada
fissura
fita
fivela
fixador
fixo
flacidez
flamingo
flanela
flechada
flora
flutuar
fluxo
focal
focinho
fofocar
fogo
foguete
foice
folgado
folheto
forjar
formiga
forno
forte
fosco
fossa
fragata
fralda
frango
frasco
fraterno
freira
frente
fretar
frieza
friso
fritura
fronha
frustrar
fruteira
fugir
fulano
fuligem
fundar
fungo
funil
furador
furioso
futebol
gabarito
gabinete
gado
gaiato
gaiola
gaivota
galega
galho
galinha
galocha
ganhar
garagem
garfo
gargalo
garimpo
garoupa
garrafa
gasoduto
gasto
gata
gatilho
gaveta
gazela
gelado
geleia
gelo
gemada
gemer
gemido
generoso
gengiva
genial
genoma
genro
geologia
gerador
germinar
gesso
gestor
ginasta
gincana
gingado
girafa
girino
glacial
glicose
global
glorioso
goela
goiaba
golfe
golpear
gordura
gorjeta
gorro
gostoso
goteira
governar
gracejo
gradual
grafite
gralha
grampo
granada
gratuito
graveto
graxa
grego
grelhar
greve
grilo
grisalho
gritaria
grosso
grotesco
grudado
grunhido
gruta
guache
guarani
guaxinim
guerrear
guiar
guincho
guisado
gula
guloso
guru
habitar
harmonia
haste
haver
hectare
herdar
heresia
hesitar
hiato
hibernar
hidratar
hiena
hino
hipismo
hipnose
hipoteca
hoje
holofote
homem
honesto
honrado
hormonal
hospedar
humorado
iate
ideia
idoso
ignorado
igreja
iguana
ileso
ilha
iludido
iluminar
ilustrar
imagem
imediato
imenso
imersivo
iminente
imitador
imortal
impacto
impedir
implante
impor
imprensa
impune
imunizar
inalador
inapto
inativo
incenso
inchar
incidir
incluir
incolor
indeciso
indireto
indutor
ineficaz
inerente
infantil
infestar
infinito
inflamar
informal
infrator
ingerir
inibido
inicial
inimigo
injetar
inocente
inodoro
inovador
inox
inquieto
inscrito
inseto
insistir
inspetor
instalar
insulto
intacto
integral
intimar
intocado
intriga
invasor
inverno
invicto
invocar
iogurte
iraniano
ironizar
irreal
irritado
isca
isento
isolado
isqueiro
italiano
janeiro
jangada
janta
jararaca
jardim
jarro
jasmim
jato
javali
jazida
jejum
joaninha
joelhada
jogador
joia
jornal
jorrar
jovem
juba
judeu
judoca
juiz
julgador
julho
jurado
jurista
juro
justa
labareda
laboral
lacre
lactante
ladrilho
lagarta
lagoa
laje
lamber
lamentar
laminar
lampejo
lanche
lapidar
lapso
laranja
lareira
largura
lasanha
lastro
lateral
latido
lavanda
lavoura
lavrador
laxante
lazer
lealdade
lebre
legado
legendar
legista
leigo
leiloar
leitura
lembrete
leme
lenhador
lentilha
leoa
lesma
leste
letivo
letreiro
levar
leveza
levitar
liberal
libido
liderar
ligar
ligeiro
limitar
limoeiro
limpador
linda
linear
linhagem
liquidez
listagem
lisura
litoral
livro
lixa
lixeira
locador
locutor
lojista
lombo
lona
longe
lontra
lorde
lotado
loteria
loucura
lousa
louvar
luar
lucidez
lucro
luneta
lustre
lutador
luva
macaco
macete
machado
macio
madeira
madrinha
magnata
magreza
maior
mais
malandro
malha
malote
maluco
mamilo
mamoeiro
mamute
manada
mancha
mandato
manequim
manhoso
manivela
manobrar
mansa
manter
manusear
mapeado
maquinar
marcador
maresia
marfim
margem
marinho
marmita
maroto
marquise
marreco
martelo
marujo
mascote
masmorra
massagem
mastigar
matagal
materno
matinal
matutar
maxilar
medalha
medida
medusa
megafone
meiga
melancia
melhor
membro
memorial
menino
menos
mensagem
mental
merecer
mergulho
mesada
mesclar
mesmo
mesquita
mestre
metade
meteoro
metragem
mexer
mexicano
micro
migalha
migrar
milagre
milenar
milhar
mimado
minerar
minhoca
ministro
minoria
miolo
mirante
mirtilo
misturar
mocidade
moderno
modular
moeda
moer
moinho
moita
moldura
moleza
molho
molinete
molusco
montanha
moqueca
morango
morcego
mordomo
morena
mosaico
mosquete
mostarda
motel
motim
moto
motriz
muda
muito
mulata
mulher
multar
mundial
munido
muralha
murcho
muscular
museu
musical
nacional
nadador
naja
namoro
narina
narrado
nascer
nativa
natureza
navalha
navegar
navio
neblina
nebuloso
negativa
negociar
negrito
nervoso
neta
neural
nevasca
nevoeiro
ninar
ninho
nitidez
nivelar
nobreza
noite
noiva
nomear
nominal
nordeste
nortear
notar
noticiar
noturno
novelo
novilho
novo
nublado
nudez
numeral
nupcial
nutrir
nuvem
obcecado
obedecer
objetivo
obrigado
obscuro
obstetra
obter
obturar
ocidente
ocioso
ocorrer
oculista
ocupado
ofegante
ofensiva
oferenda
oficina
ofuscado
ogiva
olaria
oleoso
olhar
oliveira
ombro
omelete
omisso
omitir
ondulado
oneroso
ontem
opcional
operador
oponente
oportuno
oposto
orar
orbitar
ordem
ordinal
orfanato
orgasmo
orgulho
oriental
origem
oriundo
orla
ortodoxo
orvalho
oscilar
ossada
osso
ostentar
otimismo
ousadia
outono
outubro
ouvido
ovelha
ovular
oxidar
oxigenar
pacato
paciente
pacote
pactuar
padaria
padrinho
pagar
pagode
painel
pairar
paisagem
palavra
palestra
palheta
palito
palmada
palpitar
pancada
panela
panfleto
panqueca
pantanal
papagaio
papelada
papiro
parafina
parcial
pardal
parede
partida
pasmo
passado
pastel
patamar
patente
patinar
patrono
paulada
pausar
peculiar
pedalar
pedestre
pediatra
pedra
pegada
peitoral
peixe
pele
pelicano
penca
pendurar
peneira
penhasco
pensador
pente
perceber
perfeito
pergunta
perito
permitir
perna
perplexo
persiana
pertence
peruca
pescado
pesquisa
pessoa
petiscar
piada
picado
piedade
pigmento
pilastra
pilhado
pilotar
pimenta
pincel
pinguim
pinha
pinote
pintar
pioneiro
pipoca
piquete
piranha
pires
pirueta
piscar
pistola
pitanga
pivete
planta
plaqueta
platina
plebeu
plumagem
pluvial
pneu
poda
poeira
poetisa
polegada
policiar
poluente
polvilho
pomar
pomba
ponderar
pontaria
populoso
porta
possuir
postal
pote
poupar
pouso
povoar
praia
prancha
prato
praxe
prece
predador
prefeito
premiar
prensar
preparar
presilha
pretexto
prevenir
prezar
primata
princesa
prisma
privado
processo
produto
profeta
proibido
projeto
prometer
propagar
prosa
protetor
provador
publicar
pudim
pular
pulmonar
pulseira
punhal
punir
pupilo
pureza
puxador
quadra
quantia
quarto
quase
quebrar
queda
queijo
quente
querido
quimono
quina
quiosque
rabanada
rabisco
rachar
racionar
radial
raiar
rainha
raio
raiva
rajada
ralado
ramal
ranger
ranhura
rapadura
rapel
rapidez
raposa
raquete
raridade
rasante
rascunho
rasgar
raspador
rasteira
rasurar
ratazana
ratoeira
realeza
reanimar
reaver
rebaixar
rebelde
rebolar
recado
recente
recheio
recibo
recordar
recrutar
recuar
rede
redimir
redonda
reduzida
reenvio
refinar
refletir
refogar
refresco
refugiar
regalia
regime
regra
reinado
reitor
rejeitar
relativo
remador
remendo
remorso
renovado
reparo
repelir
repleto
repolho
represa
repudiar
requerer
resenha
resfriar
resgatar
residir
resolver
respeito
ressaca
restante
resumir
retalho
reter
retirar
retomada
retratar
revelar
revisor
revolta
riacho
rica
rigidez
rigoroso
rimar
ringue
risada
risco
risonho
robalo
rochedo
rodada
rodeio
rodovia
roedor
roleta
romano
roncar
rosado
roseira
rosto
rota
roteiro
rotina
rotular
rouco
roupa
roxo
rubro
rugido
rugoso
ruivo
rumo
rupestre
russo
sabor
saciar
sacola
sacudir
sadio
safira
saga
sagrada
saibro
salada
saleiro
salgado
saliva
salpicar
salsicha
saltar
salvador
sambar
samurai
sanar
sanfona
sangue
sanidade
sapato
sarda
sargento
sarjeta
saturar
saudade
saxofone
sazonal
secar
secular
seda
sedento
sediado
sedoso
sedutor
segmento
segredo
segundo
seiva
seleto
selvagem
semanal
semente
senador
senhor
sensual
sentado
separado
sereia
seringa
serra
servo
setembro
setor
sigilo
silhueta
silicone
simetria
simpatia
simular
sinal
sincero
singular
sinopse
sintonia
sirene
siri
situado
soberano
sobra
socorro
sogro
soja
solda
soletrar
solteiro
sombrio
sonata
sondar
sonegar
sonhador
sono
soprano
soquete
sorrir
sorteio
sossego
sotaque
soterrar
sovado
sozinho
suavizar
subida
submerso
subsolo
subtrair
sucata
sucesso
suco
sudeste
sufixo
sugador
sugerir
sujeito
sulfato
sumir
suor
superior
suplicar
suposto
suprimir
surdina
surfista
surpresa
surreal
surtir
suspiro
sustento
tabela
tablete
tabuada
tacho
tagarela
talher
talo
talvez
tamanho
tamborim
tampa
tangente
tanto
tapar
tapioca
tardio
tarefa
tarja
tarraxa
tatuagem
taurino
taxativo
taxista
teatral
tecer
tecido
teclado
tedioso
teia
teimar
telefone
telhado
tempero
tenente
tensor
tentar
termal
terno
terreno
tese
tesoura
testado
teto
textura
texugo
tiara
tigela
tijolo
timbrar
timidez
tingido
tinteiro
tiragem
titular
toalha
tocha
tolerar
tolice
tomada
tomilho
tonel
tontura
topete
tora
torcido
torneio
torque
torrada
torto
tostar
touca
toupeira
toxina
trabalho
tracejar
tradutor
trafegar
trajeto
trama
trancar
trapo
traseiro
tratador
travar
treino
tremer
trepidar
trevo
triagem
tribo
triciclo
tridente
trilogia
trindade
triplo
triturar
triunfal
trocar
trombeta
trova
trunfo
truque
tubular
tucano
tudo
tulipa
tupi
turbo
turma
turquesa
tutelar
tutorial
uivar
umbigo
unha
unidade
uniforme
urologia
urso
urtiga
urubu
usado
usina
usufruir
vacina
vadiar
vagaroso
vaidoso
vala
valente
validade
valores
vantagem
vaqueiro
varanda
vareta
varrer
vascular
vasilha
vassoura
vazar
vazio
veado
vedar
vegetar
veicular
veleiro
velhice
veludo
vencedor
vendaval
venerar
ventre
verbal
verdade
vereador
vergonha
vermelho
verniz
versar
vertente
vespa
vestido
vetorial
viaduto
viagem
viajar
viatura
vibrador
videira
vidraria
viela
viga
vigente
vigiar
vigorar
vilarejo
vinco
vinheta
vinil
violeta
virada
virtude
visitar
visto
vitral
viveiro
vizinho
voador
voar
vogal
volante
voleibol
voltagem
volumoso
vontade
vulto
vuvuzela
xadrez
xarope
xeque
xeretar
xerife
xingar
zangado
zarpar
zebu
zelador
zombar
zoologia
zumbido`,ql=Gl.split(`
`);var Hl=`a\u0301baco
abdomen
abeja
abierto
abogado
abono
aborto
abrazo
abrir
abuelo
abuso
acabar
academia
acceso
accio\u0301n
aceite
acelga
acento
aceptar
a\u0301cido
aclarar
acne\u0301
acoger
acoso
activo
acto
actriz
actuar
acudir
acuerdo
acusar
adicto
admitir
adoptar
adorno
aduana
adulto
ae\u0301reo
afectar
aficio\u0301n
afinar
afirmar
a\u0301gil
agitar
agoni\u0301a
agosto
agotar
agregar
agrio
agua
agudo
a\u0301guila
aguja
ahogo
ahorro
aire
aislar
ajedrez
ajeno
ajuste
alacra\u0301n
alambre
alarma
alba
a\u0301lbum
alcalde
aldea
alegre
alejar
alerta
aleta
alfiler
alga
algodo\u0301n
aliado
aliento
alivio
alma
almeja
almi\u0301bar
altar
alteza
altivo
alto
altura
alumno
alzar
amable
amante
amapola
amargo
amasar
a\u0301mbar
a\u0301mbito
ameno
amigo
amistad
amor
amparo
amplio
ancho
anciano
ancla
andar
ande\u0301n
anemia
a\u0301ngulo
anillo
a\u0301nimo
ani\u0301s
anotar
antena
antiguo
antojo
anual
anular
anuncio
an\u0303adir
an\u0303ejo
an\u0303o
apagar
aparato
apetito
apio
aplicar
apodo
aporte
apoyo
aprender
aprobar
apuesta
apuro
arado
aran\u0303a
arar
a\u0301rbitro
a\u0301rbol
arbusto
archivo
arco
arder
ardilla
arduo
a\u0301rea
a\u0301rido
aries
armoni\u0301a
arne\u0301s
aroma
arpa
arpo\u0301n
arreglo
arroz
arruga
arte
artista
asa
asado
asalto
ascenso
asegurar
aseo
asesor
asiento
asilo
asistir
asno
asombro
a\u0301spero
astilla
astro
astuto
asumir
asunto
atajo
ataque
atar
atento
ateo
a\u0301tico
atleta
a\u0301tomo
atraer
atroz
atu\u0301n
audaz
audio
auge
aula
aumento
ausente
autor
aval
avance
avaro
ave
avellana
avena
avestruz
avio\u0301n
aviso
ayer
ayuda
ayuno
azafra\u0301n
azar
azote
azu\u0301car
azufre
azul
baba
babor
bache
bahi\u0301a
baile
bajar
balanza
balco\u0301n
balde
bambu\u0301
banco
banda
ban\u0303o
barba
barco
barniz
barro
ba\u0301scula
basto\u0301n
basura
batalla
bateri\u0301a
batir
batuta
bau\u0301l
bazar
bebe\u0301
bebida
bello
besar
beso
bestia
bicho
bien
bingo
blanco
bloque
blusa
boa
bobina
bobo
boca
bocina
boda
bodega
boina
bola
bolero
bolsa
bomba
bondad
bonito
bono
bonsa\u0301i
borde
borrar
bosque
bote
boti\u0301n
bo\u0301veda
bozal
bravo
brazo
brecha
breve
brillo
brinco
brisa
broca
broma
bronce
brote
bruja
brusco
bruto
buceo
bucle
bueno
buey
bufanda
bufo\u0301n
bu\u0301ho
buitre
bulto
burbuja
burla
burro
buscar
butaca
buzo\u0301n
caballo
cabeza
cabina
cabra
cacao
cada\u0301ver
cadena
caer
cafe\u0301
cai\u0301da
caima\u0301n
caja
cajo\u0301n
cal
calamar
calcio
caldo
calidad
calle
calma
calor
calvo
cama
cambio
camello
camino
campo
ca\u0301ncer
candil
canela
canguro
canica
canto
can\u0303a
can\u0303o\u0301n
caoba
caos
capaz
capita\u0301n
capote
captar
capucha
cara
carbo\u0301n
ca\u0301rcel
careta
carga
carin\u0303o
carne
carpeta
carro
carta
casa
casco
casero
caspa
castor
catorce
catre
caudal
causa
cazo
cebolla
ceder
cedro
celda
ce\u0301lebre
celoso
ce\u0301lula
cemento
ceniza
centro
cerca
cerdo
cereza
cero
cerrar
certeza
ce\u0301sped
cetro
chacal
chaleco
champu\u0301
chancla
chapa
charla
chico
chiste
chivo
choque
choza
chuleta
chupar
ciclo\u0301n
ciego
cielo
cien
cierto
cifra
cigarro
cima
cinco
cine
cinta
cipre\u0301s
circo
ciruela
cisne
cita
ciudad
clamor
clan
claro
clase
clave
cliente
clima
cli\u0301nica
cobre
coccio\u0301n
cochino
cocina
coco
co\u0301digo
codo
cofre
coger
cohete
coji\u0301n
cojo
cola
colcha
colegio
colgar
colina
collar
colmo
columna
combate
comer
comida
co\u0301modo
compra
conde
conejo
conga
conocer
consejo
contar
copa
copia
corazo\u0301n
corbata
corcho
cordo\u0301n
corona
correr
coser
cosmos
costa
cra\u0301neo
cra\u0301ter
crear
crecer
crei\u0301do
crema
cri\u0301a
crimen
cripta
crisis
cromo
cro\u0301nica
croqueta
crudo
cruz
cuadro
cuarto
cuatro
cubo
cubrir
cuchara
cuello
cuento
cuerda
cuesta
cueva
cuidar
culebra
culpa
culto
cumbre
cumplir
cuna
cuneta
cuota
cupo\u0301n
cu\u0301pula
curar
curioso
curso
curva
cutis
dama
danza
dar
dardo
da\u0301til
deber
de\u0301bil
de\u0301cada
decir
dedo
defensa
definir
dejar
delfi\u0301n
delgado
delito
demora
denso
dental
deporte
derecho
derrota
desayuno
deseo
desfile
desnudo
destino
desvi\u0301o
detalle
detener
deuda
di\u0301a
diablo
diadema
diamante
diana
diario
dibujo
dictar
diente
dieta
diez
difi\u0301cil
digno
dilema
diluir
dinero
directo
dirigir
disco
disen\u0303o
disfraz
diva
divino
doble
doce
dolor
domingo
don
donar
dorado
dormir
dorso
dos
dosis
drago\u0301n
droga
ducha
duda
duelo
duen\u0303o
dulce
du\u0301o
duque
durar
dureza
duro
e\u0301bano
ebrio
echar
eco
ecuador
edad
edicio\u0301n
edificio
editor
educar
efecto
eficaz
eje
ejemplo
elefante
elegir
elemento
elevar
elipse
e\u0301lite
elixir
elogio
eludir
embudo
emitir
emocio\u0301n
empate
empen\u0303o
empleo
empresa
enano
encargo
enchufe
enci\u0301a
enemigo
enero
enfado
enfermo
engan\u0303o
enigma
enlace
enorme
enredo
ensayo
ensen\u0303ar
entero
entrar
envase
envi\u0301o
e\u0301poca
equipo
erizo
escala
escena
escolar
escribir
escudo
esencia
esfera
esfuerzo
espada
espejo
espi\u0301a
esposa
espuma
esqui\u0301
estar
este
estilo
estufa
etapa
eterno
e\u0301tica
etnia
evadir
evaluar
evento
evitar
exacto
examen
exceso
excusa
exento
exigir
exilio
existir
e\u0301xito
experto
explicar
exponer
extremo
fa\u0301brica
fa\u0301bula
fachada
fa\u0301cil
factor
faena
faja
falda
fallo
falso
faltar
fama
familia
famoso
farao\u0301n
farmacia
farol
farsa
fase
fatiga
fauna
favor
fax
febrero
fecha
feliz
feo
feria
feroz
fe\u0301rtil
fervor
festi\u0301n
fiable
fianza
fiar
fibra
ficcio\u0301n
ficha
fideo
fiebre
fiel
fiera
fiesta
figura
fijar
fijo
fila
filete
filial
filtro
fin
finca
fingir
finito
firma
flaco
flauta
flecha
flor
flota
fluir
flujo
flu\u0301or
fobia
foca
fogata
fogo\u0301n
folio
folleto
fondo
forma
forro
fortuna
forzar
fosa
foto
fracaso
fra\u0301gil
franja
frase
fraude
frei\u0301r
freno
fresa
fri\u0301o
frito
fruta
fuego
fuente
fuerza
fuga
fumar
funcio\u0301n
funda
furgo\u0301n
furia
fusil
fu\u0301tbol
futuro
gacela
gafas
gaita
gajo
gala
galeri\u0301a
gallo
gamba
ganar
gancho
ganga
ganso
garaje
garza
gasolina
gastar
gato
gavila\u0301n
gemelo
gemir
gen
ge\u0301nero
genio
gente
geranio
gerente
germen
gesto
gigante
gimnasio
girar
giro
glaciar
globo
gloria
gol
golfo
goloso
golpe
goma
gordo
gorila
gorra
gota
goteo
gozar
grada
gra\u0301fico
grano
grasa
gratis
grave
grieta
grillo
gripe
gris
grito
grosor
gru\u0301a
grueso
grumo
grupo
guante
guapo
guardia
guerra
gui\u0301a
guin\u0303o
guion
guiso
guitarra
gusano
gustar
haber
ha\u0301bil
hablar
hacer
hacha
hada
hallar
hamaca
harina
haz
hazan\u0303a
hebilla
hebra
hecho
helado
helio
hembra
herir
hermano
he\u0301roe
hervir
hielo
hierro
hi\u0301gado
higiene
hijo
himno
historia
hocico
hogar
hoguera
hoja
hombre
hongo
honor
honra
hora
hormiga
horno
hostil
hoyo
hueco
huelga
huerta
hueso
huevo
huida
huir
humano
hu\u0301medo
humilde
humo
hundir
huraca\u0301n
hurto
icono
ideal
idioma
i\u0301dolo
iglesia
iglu\u0301
igual
ilegal
ilusio\u0301n
imagen
ima\u0301n
imitar
impar
imperio
imponer
impulso
incapaz
i\u0301ndice
inerte
infiel
informe
ingenio
inicio
inmenso
inmune
innato
insecto
instante
intere\u0301s
i\u0301ntimo
intuir
inu\u0301til
invierno
ira
iris
ironi\u0301a
isla
islote
jabali\u0301
jabo\u0301n
jamo\u0301n
jarabe
jardi\u0301n
jarra
jaula
jazmi\u0301n
jefe
jeringa
jinete
jornada
joroba
joven
joya
juerga
jueves
juez
jugador
jugo
juguete
juicio
junco
jungla
junio
juntar
ju\u0301piter
jurar
justo
juvenil
juzgar
kilo
koala
labio
lacio
lacra
lado
ladro\u0301n
lagarto
la\u0301grima
laguna
laico
lamer
la\u0301mina
la\u0301mpara
lana
lancha
langosta
lanza
la\u0301piz
largo
larva
la\u0301stima
lata
la\u0301tex
latir
laurel
lavar
lazo
leal
leccio\u0301n
leche
lector
leer
legio\u0301n
legumbre
lejano
lengua
lento
len\u0303a
leo\u0301n
leopardo
lesio\u0301n
letal
letra
leve
leyenda
libertad
libro
licor
li\u0301der
lidiar
lienzo
liga
ligero
lima
li\u0301mite
limo\u0301n
limpio
lince
lindo
li\u0301nea
lingote
lino
linterna
li\u0301quido
liso
lista
litera
litio
litro
llaga
llama
llanto
llave
llegar
llenar
llevar
llorar
llover
lluvia
lobo
locio\u0301n
loco
locura
lo\u0301gica
logro
lombriz
lomo
lonja
lote
lucha
lucir
lugar
lujo
luna
lunes
lupa
lustro
luto
luz
maceta
macho
madera
madre
maduro
maestro
mafia
magia
mago
mai\u0301z
maldad
maleta
malla
malo
mama\u0301
mambo
mamut
manco
mando
manejar
manga
maniqui\u0301
manjar
mano
manso
manta
man\u0303ana
mapa
ma\u0301quina
mar
marco
marea
marfil
margen
marido
ma\u0301rmol
marro\u0301n
martes
marzo
masa
ma\u0301scara
masivo
matar
materia
matiz
matriz
ma\u0301ximo
mayor
mazorca
mecha
medalla
medio
me\u0301dula
mejilla
mejor
melena
melo\u0301n
memoria
menor
mensaje
mente
menu\u0301
mercado
merengue
me\u0301rito
mes
meso\u0301n
meta
meter
me\u0301todo
metro
mezcla
miedo
miel
miembro
miga
mil
milagro
militar
millo\u0301n
mimo
mina
minero
mi\u0301nimo
minuto
miope
mirar
misa
miseria
misil
mismo
mitad
mito
mochila
mocio\u0301n
moda
modelo
moho
mojar
molde
moler
molino
momento
momia
monarca
moneda
monja
monto
mon\u0303o
morada
morder
moreno
morir
morro
morsa
mortal
mosca
mostrar
motivo
mover
mo\u0301vil
mozo
mucho
mudar
mueble
muela
muerte
muestra
mugre
mujer
mula
muleta
multa
mundo
mun\u0303eca
mural
muro
mu\u0301sculo
museo
musgo
mu\u0301sica
muslo
na\u0301car
nacio\u0301n
nadar
naipe
naranja
nariz
narrar
nasal
natal
nativo
natural
na\u0301usea
naval
nave
navidad
necio
ne\u0301ctar
negar
negocio
negro
neo\u0301n
nervio
neto
neutro
nevar
nevera
nicho
nido
niebla
nieto
nin\u0303ez
nin\u0303o
ni\u0301tido
nivel
nobleza
noche
no\u0301mina
noria
norma
norte
nota
noticia
novato
novela
novio
nube
nuca
nu\u0301cleo
nudillo
nudo
nuera
nueve
nuez
nulo
nu\u0301mero
nutria
oasis
obeso
obispo
objeto
obra
obrero
observar
obtener
obvio
oca
ocaso
oce\u0301ano
ochenta
ocho
ocio
ocre
octavo
octubre
oculto
ocupar
ocurrir
odiar
odio
odisea
oeste
ofensa
oferta
oficio
ofrecer
ogro
oi\u0301do
oi\u0301r
ojo
ola
oleada
olfato
olivo
olla
olmo
olor
olvido
ombligo
onda
onza
opaco
opcio\u0301n
o\u0301pera
opinar
oponer
optar
o\u0301ptica
opuesto
oracio\u0301n
orador
oral
o\u0301rbita
orca
orden
oreja
o\u0301rgano
orgi\u0301a
orgullo
oriente
origen
orilla
oro
orquesta
oruga
osadi\u0301a
oscuro
osezno
oso
ostra
oton\u0303o
otro
oveja
o\u0301vulo
o\u0301xido
oxi\u0301geno
oyente
ozono
pacto
padre
paella
pa\u0301gina
pago
pai\u0301s
pa\u0301jaro
palabra
palco
paleta
pa\u0301lido
palma
paloma
palpar
pan
panal
pa\u0301nico
pantera
pan\u0303uelo
papa\u0301
papel
papilla
paquete
parar
parcela
pared
parir
paro
pa\u0301rpado
parque
pa\u0301rrafo
parte
pasar
paseo
pasio\u0301n
paso
pasta
pata
patio
patria
pausa
pauta
pavo
payaso
peato\u0301n
pecado
pecera
pecho
pedal
pedir
pegar
peine
pelar
peldan\u0303o
pelea
peligro
pellejo
pelo
peluca
pena
pensar
pen\u0303o\u0301n
peo\u0301n
peor
pepino
pequen\u0303o
pera
percha
perder
pereza
perfil
perico
perla
permiso
perro
persona
pesa
pesca
pe\u0301simo
pestan\u0303a
pe\u0301talo
petro\u0301leo
pez
pezun\u0303a
picar
picho\u0301n
pie
piedra
pierna
pieza
pijama
pilar
piloto
pimienta
pino
pintor
pinza
pin\u0303a
piojo
pipa
pirata
pisar
piscina
piso
pista
pito\u0301n
pizca
placa
plan
plata
playa
plaza
pleito
pleno
plomo
pluma
plural
pobre
poco
poder
podio
poema
poesi\u0301a
poeta
polen
polici\u0301a
pollo
polvo
pomada
pomelo
pomo
pompa
poner
porcio\u0301n
portal
posada
poseer
posible
poste
potencia
potro
pozo
prado
precoz
pregunta
premio
prensa
preso
previo
primo
pri\u0301ncipe
prisio\u0301n
privar
proa
probar
proceso
producto
proeza
profesor
programa
prole
promesa
pronto
propio
pro\u0301ximo
prueba
pu\u0301blico
puchero
pudor
pueblo
puerta
puesto
pulga
pulir
pulmo\u0301n
pulpo
pulso
puma
punto
pun\u0303al
pun\u0303o
pupa
pupila
pure\u0301
quedar
queja
quemar
querer
queso
quieto
qui\u0301mica
quince
quitar
ra\u0301bano
rabia
rabo
racio\u0301n
radical
rai\u0301z
rama
rampa
rancho
rango
rapaz
ra\u0301pido
rapto
rasgo
raspa
rato
rayo
raza
razo\u0301n
reaccio\u0301n
realidad
reban\u0303o
rebote
recaer
receta
rechazo
recoger
recreo
recto
recurso
red
redondo
reducir
reflejo
reforma
refra\u0301n
refugio
regalo
regir
regla
regreso
rehe\u0301n
reino
rei\u0301r
reja
relato
relevo
relieve
relleno
reloj
remar
remedio
remo
rencor
rendir
renta
reparto
repetir
reposo
reptil
res
rescate
resina
respeto
resto
resumen
retiro
retorno
retrato
reunir
reve\u0301s
revista
rey
rezar
rico
riego
rienda
riesgo
rifa
ri\u0301gido
rigor
rinco\u0301n
rin\u0303o\u0301n
ri\u0301o
riqueza
risa
ritmo
rito
rizo
roble
roce
rociar
rodar
rodeo
rodilla
roer
rojizo
rojo
romero
romper
ron
ronco
ronda
ropa
ropero
rosa
rosca
rostro
rotar
rubi\u0301
rubor
rudo
rueda
rugir
ruido
ruina
ruleta
rulo
rumbo
rumor
ruptura
ruta
rutina
sa\u0301bado
saber
sabio
sable
sacar
sagaz
sagrado
sala
saldo
salero
salir
salmo\u0301n
salo\u0301n
salsa
salto
salud
salvar
samba
sancio\u0301n
sandi\u0301a
sanear
sangre
sanidad
sano
santo
sapo
saque
sardina
sarte\u0301n
sastre
sata\u0301n
sauna
saxofo\u0301n
seccio\u0301n
seco
secreto
secta
sed
seguir
seis
sello
selva
semana
semilla
senda
sensor
sen\u0303al
sen\u0303or
separar
sepia
sequi\u0301a
ser
serie
sermo\u0301n
servir
sesenta
sesio\u0301n
seta
setenta
severo
sexo
sexto
sidra
siesta
siete
siglo
signo
si\u0301laba
silbar
silencio
silla
si\u0301mbolo
simio
sirena
sistema
sitio
situar
sobre
socio
sodio
sol
solapa
soldado
soledad
so\u0301lido
soltar
solucio\u0301n
sombra
sondeo
sonido
sonoro
sonrisa
sopa
soplar
soporte
sordo
sorpresa
sorteo
soste\u0301n
so\u0301tano
suave
subir
suceso
sudor
suegra
suelo
suen\u0303o
suerte
sufrir
sujeto
sulta\u0301n
sumar
superar
suplir
suponer
supremo
sur
surco
suren\u0303o
surgir
susto
sutil
tabaco
tabique
tabla
tabu\u0301
taco
tacto
tajo
talar
talco
talento
talla
talo\u0301n
taman\u0303o
tambor
tango
tanque
tapa
tapete
tapia
tapo\u0301n
taquilla
tarde
tarea
tarifa
tarjeta
tarot
tarro
tarta
tatuaje
tauro
taza
tazo\u0301n
teatro
techo
tecla
te\u0301cnica
tejado
tejer
tejido
tela
tele\u0301fono
tema
temor
templo
tenaz
tender
tener
tenis
tenso
teori\u0301a
terapia
terco
te\u0301rmino
ternura
terror
tesis
tesoro
testigo
tetera
texto
tez
tibio
tiburo\u0301n
tiempo
tienda
tierra
tieso
tigre
tijera
tilde
timbre
ti\u0301mido
timo
tinta
ti\u0301o
ti\u0301pico
tipo
tira
tiro\u0301n
tita\u0301n
ti\u0301tere
ti\u0301tulo
tiza
toalla
tobillo
tocar
tocino
todo
toga
toldo
tomar
tono
tonto
topar
tope
toque
to\u0301rax
torero
tormenta
torneo
toro
torpedo
torre
torso
tortuga
tos
tosco
toser
to\u0301xico
trabajo
tractor
traer
tra\u0301fico
trago
traje
tramo
trance
trato
trauma
trazar
tre\u0301bol
tregua
treinta
tren
trepar
tres
tribu
trigo
tripa
triste
triunfo
trofeo
trompa
tronco
tropa
trote
trozo
truco
trueno
trufa
tuberi\u0301a
tubo
tuerto
tumba
tumor
tu\u0301nel
tu\u0301nica
turbina
turismo
turno
tutor
ubicar
u\u0301lcera
umbral
unidad
unir
universo
uno
untar
un\u0303a
urbano
urbe
urgente
urna
usar
usuario
u\u0301til
utopi\u0301a
uva
vaca
vaci\u0301o
vacuna
vagar
vago
vaina
vajilla
vale
va\u0301lido
valle
valor
va\u0301lvula
vampiro
vara
variar
varo\u0301n
vaso
vecino
vector
vehi\u0301culo
veinte
vejez
vela
velero
veloz
vena
vencer
venda
veneno
vengar
venir
venta
venus
ver
verano
verbo
verde
vereda
verja
verso
verter
vi\u0301a
viaje
vibrar
vicio
vi\u0301ctima
vida
vi\u0301deo
vidrio
viejo
viernes
vigor
vil
villa
vinagre
vino
vin\u0303edo
violi\u0301n
viral
virgo
virtud
visor
vi\u0301spera
vista
vitamina
viudo
vivaz
vivero
vivir
vivo
volca\u0301n
volumen
volver
voraz
votar
voto
voz
vuelo
vulgar
yacer
yate
yegua
yema
yerno
yeso
yodo
yoga
yogur
zafiro
zanja
zapato
zarza
zona
zorro
zumo
zurdo`,Jl=Hl.split(`
`);var NA;(function(e){e.invalidEntropyLength="BIP39 Error: invalid entropy length. Entropy length must be 16, 20, 24, 28, or 32 bytes.",e.invalidMnemonicLength="BIP39 Error: invalid mnemonic length. Word count must be 12, 15, 18, 21, or 24.",e.invalidWordListLength="BIP39 Error: invalid word list length. BIP39 word lists must contain exactly 2048 words.",e.invalidChecksum="BIP39 Error: invalid checksum for the given mnemonic phrase.",e.unknownWord="BIP39 Error: unknown word(s). The mnemonic phrase contains one or more words that do not exist in the word list."})(NA||(NA={}));var Jn=e=>e.length===2048,Dg=e=>e.length>=16&&e.length<=32&&e.length%4===0,wg=e=>{let a=e.length*8/32,r=q.hash(e);return Jr(r).slice(0,a)},Ll=(e,A)=>{if(!Jn(A))return R(NA.invalidWordListLength,`Word list length: ${A.length}.`);let a=e.normalize("NFKD").split(" ");if(a.length%3!==0||a.length<12||a.length>24)return R(NA.invalidMnemonicLength,`Word count: ${a.length}.`);let r=a.filter(l=>!A.includes(l));if(r.length!==0)return R(NA.unknownWord,`Unknown word(s): ${r.join(", ")}.`);let n=a.map(l=>A.indexOf(l).toString(2).padStart(11,"0")).join(""),i=a.length/3*32,t=n.slice(0,i),o=n.slice(i),s=Ga(t),g=wg(s);return g!==o?R(NA.invalidChecksum,`Encoded: ${o}; computed: ${g}.`):s},Kf=e=>Ll(e,kr),Tg=(e,A)=>{if(!Dg(e))return R(NA.invalidEntropyLength,`Entropy length: ${e.length}.`);if(!Jn(A))return R(NA.invalidWordListLength,`Word list length: ${A.length}.`);let a=Jr(e),r=wg(e),n=a+r,t=ca(n,11).map(s=>{let g=parseInt(s,2);return A[g]});return{phrase:A[0]==="\u3042\u3044\u3053\u304F\u3057\u3093"?t.join("\u3000"):t.join(" ")}},Mf=e=>Tg(e,kr),Vl=(e,{crypto:A={pbkdf2HmacSha512:Xr},passphrase:a=""}={})=>{let r=e.normalize("NFKD"),i=`mnemonic${a}`.normalize("NFKD"),t=DA(r),o=DA(i);return A.pbkdf2HmacSha512({derivedKeyLength:64,iterations:2048,password:t,salt:o})},Gf=(e,{crypto:A={pbkdf2HmacSha512:Xr,sha512:je},hmacSha512Key:a,passphrase:r}={})=>ra(Vl(e,{crypto:A,passphrase:r}),{crypto:A,hmacSha512Key:a}),zl=(e,A=16,{generateRandomBytes:a=Hn}={})=>{if(!Jn(e))return R(NA.invalidWordListLength,`Word list length: ${e.length}.`);let r=a(A);return Dg(r)?Tg(r,e):R(NA.invalidEntropyLength,`Entropy length: ${r.length}.`)},qf=()=>zl(kr,16).phrase,Hf=(e,A)=>"TODO: not yet implemented";var Yg;(function(e){e.incorrectLength="The WIF private key payload is not the correct length."})(Yg||(Yg={}));var zf=(e,A,a=q)=>{let n=A==="mainnet"||A==="mainnetUncompressed",t=A==="mainnet"||A==="testnet"?Uint8Array.from([...e,1]):e;return ft(n?le.wif:le.wifTestnet,t,a)},jf=(e,A=q)=>{let r=$r(e,A);if(typeof r=="string")return r;let n=r.version===le.wif,i=r.payload.length===33;return{privateKey:i?r.payload.slice(0,-1):r.payload,type:n?i?"mainnet":"mainnetUncompressed":i?"testnet":"testnetUncompressed"}};var FA;(function(e){e.opcode="opcode",e.variable="variable",e.script="script"})(FA||(FA={}));var oa;(function(e){e.unknown="unknown",e.variable="variable",e.script="script"})(oa||(oa={}));var Nr=e=>({startColumn:e.startColumn,startLineNumber:e.startLineNumber}),Ur=e=>({endColumn:e.endColumn,endLineNumber:e.endLineNumber}),Vn=(e,A={endColumn:0,endLineNumber:0,startColumn:0,startLineNumber:0})=>{let r=e.length<2?e.length===1?e[0]:A:e.reduce((n,i)=>({...i.endLineNumber>n.endLineNumber||i.endLineNumber===n.endLineNumber&&i.endColumn>n.endColumn?Ur(i):Ur(n),...i.startLineNumber<n.startLineNumber||i.startLineNumber===n.startLineNumber&&i.startColumn<n.startColumn?Nr(i):Nr(n)}),e[0]);return{...Ur(r),...Nr(r)}},jl=(e,A,a=!0)=>{let r=e.startLineNumber<A.startLineNumber?!0:e.startLineNumber===A.startLineNumber?a?e.startColumn<A.startColumn:e.startColumn<=A.startColumn:!1,n=e.endLineNumber>A.endLineNumber?!0:e.endLineNumber===A.endLineNumber?a?e.endColumn>A.endColumn:e.endColumn>=A.endColumn:!1;return r&&n},zn=e=>e.reduce((A,a)=>{switch(a.type){case"error":return[...A,{error:a.value,...a.missingIdentifier===void 0?{}:{missingIdentifier:a.missingIdentifier,owningEntity:a.owningEntity},range:a.range}];case"push":case"evaluation":return[...A,...zn(a.value)];default:return A}},[]),Fg=e=>e.every(A=>"missingIdentifier"in A&&"owningEntity"in A),Ln=e=>e.reduce((A,a)=>{switch(a.type){case"push":case"evaluation":return[...A,...Ln(a.value)];case"bytecode":return"variable"in a?[...A,{bytecode:a.value,text:a.variable,type:"variable"}]:"script"in a?[...A,...Ln(a.source.resolve),{bytecode:a.value,text:a.script,type:"script"}]:"opcode"in a?[...A,{bytecode:a.value,text:a.opcode,type:"opcode"}]:[...A,{bytecode:a.value,text:a.literal,type:a.literalType}];default:return A}},[]),Kg=e=>Ln(e).reduce((A,a)=>a.type==="variable"?{...A,[a.text]:a.bytecode}:A,{}),KA=(e,A="; ")=>e.map(a=>`[${a.range.startLineNumber}, ${a.range.startColumn}] ${a.error}`).join(A),xg=({evaluationRange:e,nodes:A,trace:a})=>{let r=a.length>1?a.slice(0,-1):a.slice();if(r.length===0)return{samples:[],unmatchedStates:[]};let n=[{evaluationRange:e,internalStates:[],range:{endColumn:e.startColumn,endLineNumber:e.startLineNumber,startColumn:e.startColumn,startLineNumber:e.startLineNumber},state:r[0]}],i=1,t=0,o;for(;i<r.length&&t<A.length;){let l=A[t],{mergedBytecode:I,mergedRange:E}=o===void 0?{mergedBytecode:l.bytecode,mergedRange:l.range}:{mergedBytecode:ee([o.bytecode,l.bytecode]),mergedRange:Vn([o.range,l.range])},u=we(I),[k]=u;if(k!==void 0&&!("malformed"in k)){let N=u[u.length-1],c=Ut(N)?u.slice(0,u.length-1):u,B=i+c.length,S=r.slice(i,B),P=c.map((_,x)=>({instruction:_,state:S[x]})),h=P[0],y=o!==void 0;y&&n.push({evaluationRange:e,instruction:h.instruction,internalStates:[],range:E,state:h.state});let p=P.findIndex(({state:_})=>_===void 0),b=p!==-1?p-1:P.length-1;if(!y||b>0){let _=P[b],x=y?1:0,H=P.slice(x,b);n.push({evaluationRange:e,instruction:_.instruction,internalStates:H,range:l.range,state:_.state})}i=B,Ut(N)?o={bytecode:rr(N),range:l.range}:o=void 0}else{let N=u[u.length-1];o=N===void 0?void 0:{bytecode:rr(N),range:E}}t+=1}let g=t<A.length?[]:a.slice(i);return{samples:n,unmatchedStates:g}},rC=({evaluationRange:e,nodes:A,trace:a})=>{let r=(s,g=1)=>{if("push"in s)return s.push.script.reduce((l,I)=>[...l,...r(I,g)],[]);if("source"in s){let l=s.source.script.reduce((U,N)=>[...U,...r(N,g+1)],[]),I=s.trace.slice(1);return[...xg({evaluationRange:{endColumn:s.range.endColumn-")".length,endLineNumber:s.range.endLineNumber,startColumn:s.range.startColumn+"$(".length,startLineNumber:s.range.startLineNumber},nodes:s.source.script,trace:I}).samples,...l]}return[]},{samples:n,unmatchedStates:i}=xg({evaluationRange:e,nodes:A,trace:a}),t=A.reduce((s,g)=>[...s,...r(g)],[]);return{samples:[...n,...t].sort((s,g)=>{let l=s.range.endLineNumber-g.range.endLineNumber;return l===0?s.range.endColumn-g.range.endColumn:l}),unmatchedStates:i}},Og=e=>e.controlStack.every(A=>A!==!1),nC=(e,A="1,1")=>{let a=e.reduce((i,t)=>{let{precedingStateSkipsByEvaluation:o,unexecutedRanges:s}=i,g=`${t.evaluationRange.startLineNumber},${t.evaluationRange.startColumn}`,l=o[g],I=!Og(t.state),E=I&&t.internalStates.every(u=>!Og(u.state));return l&&E?{precedingStateSkipsByEvaluation:{...o,[g]:!0},unexecutedRanges:[...s,t.range]}:{precedingStateSkipsByEvaluation:{...o,[g]:I},unexecutedRanges:s}},{precedingStateSkipsByEvaluation:{[A]:!1},unexecutedRanges:[]});return a.unexecutedRanges.length<2?a.unexecutedRanges:a.unexecutedRanges.slice(0,-1).reduceRight((i,t)=>jl(i[0],t)?i:[t,...i],[a.unexecutedRanges[a.unexecutedRanges.length-1]])},Rg=e=>e.map(A=>{let a=_t(A);return`0x${$(A)}${typeof a=="string"?"":`(${a.toString()})`}`}),oC=e=>e.reduce((A,a,r,n)=>{let i=n[r+1];return i===void 0?A:[...A,{alternateStack:Rg(i.alternateStack),...i.error===void 0?{}:{error:i.error},execute:a.controlStack[a.controlStack.length-1]!==!1,instruction:a.instructions[a.ip],ip:a.ip,stack:Rg(i.stack)}]},[]),Wl=23,sC=(e,{opcodes:A=m,padInstruction:a=Wl}={})=>e.map(r=>`${(r.instruction===void 0?"=>":`${r.ip}. ${r.execute?"":"(skip)"}${A[r.instruction.opcode]??`OP_UNKNOWN${r.instruction.opcode}`}:`).padEnd(a)} ${typeof r.error=="string"?r.error:`${r.stack.join(" ")}${r.alternateStack.length===0?"":`| alt: ${r.alternateStack.join(" ")}`}`}`).join(`
`);function aA(e){if(!(this instanceof aA))return new aA(e);this._=e}var MA=aA.prototype;function GA(e,A){return{expected:[],furthest:-1,index:e,status:!0,value:A}}function _r(e,A){return A=[A],{expected:A,furthest:e,index:-1,status:!1,value:null}}function sa(e,A){return!A||e.furthest>A.furthest?e:{expected:e.furthest===A.furthest?Zl(e.expected,A.expected):A.expected,furthest:A.furthest,index:e.index,status:e.status,value:e.value}}function Mg(e,A){let a=e.slice(0,A).split(`
`),r=a.length;return{column:a[a.length-1].length+1,line:r,offset:A}}function Zl(e,A){let a={};for(let n=0;n<e.length;n++)a[e[n]]=!0;for(let n=0;n<A.length;n++)a[A[n]]=!0;let r=[];for(let n in a)r.push(n);return r.sort(),r}function Xl(e){let A=String(e);return A.slice(A.lastIndexOf("/")+1)}function $l(e){return RegExp(`^(?:${e.source})`,Xl(e))}function vr(...e){let A=[].slice.call(e),a=A.length;return aA(function(r,n){let i,t=new Array(a);for(let o=0;o<a;o+=1){if(i=sa(A[o]._(r,n),i),!i.status)return i;t[o]=i.value,n=i.index}return sa(GA(n,t),i)})}function Zn(...e){let A=[].slice.call(e),a=A.pop();return vr.apply(null,A).map(function(r){return a.apply(null,r)})}function eu(e){let A={};for(let a in e)(function(r){let n=function(){return e[r](A)};A[r]=Jg(n)})(a);return A}function Gg(...e){let A=[].slice.call(e);return aA(function(a,r){let n;for(let i=0;i<A.length;i+=1)if(n=sa(A[i]._(a,r),n),n.status)return n;return n})}function qg(e,A){return Hg(e,A).or(jn([]))}function Hg(e,A){let a=A.then(e).many();return Zn(e,a,function(r,n){return[r].concat(n)})}MA.parse=function(e){let A=this.skip(tu)._(e,0);return A.status?{status:!0,value:A.value}:{expected:A.expected,index:Mg(e,A.furthest),status:!1}};MA.or=function(e){return Gg(this,e)};MA.then=function(e){return vr(this,e).map(function(A){return A[1]})};MA.many=function(){let e=this;return aA(function(A,a){let r=[],n;for(;;)if(n=sa(e._(A,a),n),n.status){if(a===n.index)throw new Error("infinite loop detected in .many() parser --- calling .many() on a parser that can accept zero characters is usually the cause");a=n.index,r.push(n.value)}else return sa(GA(a,r),n)})};MA.map=function(e){let A=this;return aA(function(a,r){let n=A._(a,r);return n.status?sa(GA(n.index,e(n.value)),n):n})};MA.skip=function(e){return vr(this,e).map(function(A){return A[0]})};MA.node=function(e){return Zn(Wn,this,Wn,function(A,a,r){return{end:r,name:e,start:A,value:a}})};MA.sepBy=function(e){return qg(this,e)};MA.desc=function(e){e=[e];let A=this;return aA(function(a,r){let n=A._(a,r);return n.status||(n.expected=e),n})};function Au(e){let A=`'${e}'`;return aA(function(a,r){let n=r+e.length,i=a.slice(r,n);return i===e?GA(n,i):_r(r,A)})}function Xn(e,A=0){let a=$l(e),r=String(e);return aA(function(n,i){let t=a.exec(n.slice(i));if(t){let o=t[0],s=t[A];return GA(i+o.length,s)}return _r(i,r)})}function jn(e){return aA(function(A,a){return GA(a,e)})}function Jg(e){let A=aA(function(a,r){return A._=e()._,A._(a,r)});return A}var Wn=aA(function(e,A){return GA(A,Mg(e,A))}),tu=aA(function(e,A){return A<e.length?_r(A,"EOF"):GA(A,null)}),iu=Xn(/\s*/u).desc("optional whitespace"),au=Xn(/\s+/u).desc("whitespace"),ie={alt:Gg,createLanguage:eu,index:Wn,lazy:Jg,makeFailure:_r,makeSuccess:GA,of:jn,optWhitespace:iu,regexp:Xn,sepBy:qg,sepBy1:Hg,seq:vr,seqMap:Zn,string:Au,succeed:jn,whitespace:au};var ru=ie.createLanguage({script:e=>ie.seqMap(ie.optWhitespace,e.expression.sepBy(ie.optWhitespace),ie.optWhitespace,(A,a)=>a).node("Script"),expression:e=>ie.alt(e.comment,e.push,e.evaluation,e.utf8,e.binary,e.hex,e.bigint,e.identifier),comment:e=>ie.alt(e.singleLineComment,e.multiLineComment).node("Comment"),singleLineComment:()=>ie.seqMap(ie.string("//").desc("the start of a single-line comment ('//')"),ie.regexp(/[^\n]*/u),(e,A)=>A.trim()),multiLineComment:()=>ie.seqMap(ie.string("/*").desc("the start of a multi-line comment ('/*')"),ie.regexp(/[\s\S]*?\*\//u).desc("the end of this multi-line comment ('*/')"),(e,A)=>A.slice(0,-2).trim()),push:e=>ie.seqMap(ie.string("<").desc("the start of a push statement ('<')"),e.script,ie.string(">").desc("the end of this push statement ('>')"),(A,a)=>a).node("Push"),evaluation:e=>ie.seqMap(ie.string("$").desc("the start of an evaluation ('$')"),ie.string("(").desc("the opening parenthesis of this evaluation ('(')"),e.script,ie.string(")").desc("the closing parenthesis of this evaluation (')')"),(A,a,r)=>r).node("Evaluation"),identifier:()=>ie.regexp(/[a-zA-Z_][.a-zA-Z0-9_-]*/u).desc("a valid identifier").node("Identifier"),utf8:()=>ie.alt(ie.seqMap(ie.string('"').desc('a double quote (")'),ie.regexp(/[^"]*/u),ie.string('"').desc('a closing double quote (")'),(e,A)=>A),ie.seqMap(ie.string("'").desc("a single quote (')"),ie.regexp(/[^']*/u),ie.string("'").desc("a closing single quote (')"),(e,A)=>A)).node("UTF8Literal"),hex:()=>ie.seqMap(ie.string("0x").desc("a hex literal ('0x...')"),ie.regexp(/[0-9a-f]_*(?:_*[0-9a-f]_*[0-9a-f]_*)*[0-9a-f]/iu).desc("a valid hexadecimal string"),(e,A)=>A).node("HexLiteral"),binary:()=>ie.seqMap(ie.string("0b").desc("a binary literal ('0b...')"),ie.regexp(/[01]+(?:[01_]*[01]+)*/iu).desc("a string of binary digits"),(e,A)=>A).node("BinaryLiteral"),bigint:()=>ie.regexp(/-?[0-9]+(?:[0-9_]*[0-9]+)*/u).desc("an integer literal").node("BigIntLiteral")}),Lg=e=>ru.script.parse(za(e));var Dr=e=>({bytecode:Uint8Array.of(),range:e}),nu=e=>e.error!==void 0?e.error:e.controlStack.length!==0?v.nonEmptyControlStack:e.stack.length!==1?v.requiresCleanStack:!0,wr=(e,A,a)=>{let r=e.map(i=>{switch(i.type){case"bytecode":return{bytecode:i.value,range:i.range};case"push":{let t=wr(i.value,A,a);return{bytecode:Na(t.bytecode),...t.errors===void 0?void 0:{errors:t.errors},push:t,range:i.range}}case"evaluation":{if(typeof A>"u"||typeof a>"u")return{errors:[{error:"Both a VM and a createState method are required to reduce evaluations.",range:i.range}],...Dr(i.range)};let t=wr(i.value,A,a);if(t.errors!==void 0)return{...Dr(i.range),errors:t.errors,source:t,trace:[]};let o=A.debug(a(t.bytecode)),s=o[o.length-1],g=nu(s),l=s.stack[s.stack.length-1];return{...typeof g=="string"?{bytecode:Uint8Array.of(),errors:[{error:`Failed to reduce evaluation: ${g}`,range:i.range}]}:{bytecode:l},range:i.range,source:t,trace:o}}case"comment":return Dr(i.range);case"error":return{errors:[{error:`Tried to reduce a CashAssembly script with resolution errors: ${i.value}`,range:i.range}],...Dr(i.range)};default:throw new Error(`"${i.type}" is not a known segment type.`)}}),n=r.reduce((i,t)=>({bytecode:[...i.bytecode,t.bytecode],ranges:[...i.ranges,t.range],...i.errors!==void 0||t.errors!==void 0?{errors:[...i.errors??[],...t.errors??[]]}:void 0}),{bytecode:[],ranges:[]});return{...n.errors===void 0?void 0:{errors:n.errors},bytecode:ee(n.bytecode),range:Vn(n.ranges,e.length===0?void 0:e[0].range),script:r}};var Vg=e=>({endColumn:e.end.column,endLineNumber:e.end.line,startColumn:e.start.column,startLineNumber:e.start.line}),$n=e=>e.replace(/_/gu,""),eo=(e,A)=>{let a=e.value.map(r=>{let n=Vg(r);switch(r.name){case"Identifier":{let i=r.value,t=A(i);return t.status?{range:n,type:"bytecode",value:t.bytecode,...t.type===FA.opcode?{opcode:i}:t.type===FA.variable?{..."debug"in t?{debug:t.debug}:{},..."signature"in t?{signature:t.signature}:{},variable:i}:t.type===FA.script?{script:i,source:t.source}:{unknown:i}}:{..."debug"in t?{debug:t.debug}:{},..."recoverable"in t&&t.recoverable?{missingIdentifier:i,owningEntity:t.entityOwnership}:{},range:n,type:"error",value:t.error}}case"Push":return{range:n,type:"push",value:eo(r.value,A)};case"Evaluation":return{range:n,type:"evaluation",value:eo(r.value,A)};case"BigIntLiteral":return{literal:r.value,literalType:"BigIntLiteral",range:n,type:"bytecode",value:W(BigInt($n(r.value)))};case"BinaryLiteral":return{literal:r.value,literalType:"BinaryLiteral",range:n,type:"bytecode",value:Ga($n(r.value))};case"HexLiteral":return{literal:r.value,literalType:"HexLiteral",range:n,type:"bytecode",value:ze($n(r.value))};case"UTF8Literal":return{literal:r.value,literalType:"UTF8Literal",range:n,type:"bytecode",value:DA(r.value)};case"Comment":return{range:n,type:"comment",value:r.value};default:return{range:n,type:"error",value:`Unrecognized segment: ${r.name}`}}});return a.length===0?[{range:Vg(e),type:"comment",value:""}]:a},wa;(function(e){e.currentBlockTime="current_block_time",e.currentBlockHeight="current_block_height",e.signingSerialization="signing_serialization"})(wa||(wa={}));var Tr=({data:e,configuration:A,identifier:a,matchingOperations:r,operationExample:n="operation_identifier",operationId:i,variableId:t,variableType:o})=>{if(r===void 0)return{error:`The "${t}" variable type can not be resolved because the "${o}" operation has not been included in this compiler's configuration.`,status:"error"};if(typeof r=="function")return r(a,e,A);if(i===void 0)return{error:`This "${t}" variable could not be resolved because this compiler's "${o}" operations require an operation identifier, e.g. '${t}.${n}'.`,status:"error"};let s=r[i];return s===void 0?{error:`The identifier "${a}" could not be resolved because the "${t}.${i}" operation is not available to this compiler.`,status:"error"}:s(a,e,A)},ou=({data:e,configuration:A,identifier:a})=>{let[r,n]=a.split(".");switch(r){case wa.currentBlockHeight:return Tr({configuration:A,data:e,identifier:a,matchingOperations:A.operations?.currentBlockHeight,operationId:n,variableId:r,variableType:"currentBlockHeight"});case wa.currentBlockTime:return Tr({configuration:A,data:e,identifier:a,matchingOperations:A.operations?.currentBlockTime,operationId:n,variableId:r,variableType:"currentBlockTime"});case wa.signingSerialization:return Tr({configuration:A,data:e,identifier:a,matchingOperations:A.operations?.signingSerialization,operationExample:"version",operationId:n,variableId:r,variableType:"signingSerialization"});default:{let i=A.variables?.[r];return i===void 0?{status:"skip"}:Tr({configuration:A,data:e,identifier:a,operationId:n,variableId:r,...{AddressData:{matchingOperations:A.operations?.addressData,variableType:"addressData"},HdKey:{matchingOperations:A.operations?.hdKey,operationExample:"public_key",variableType:"hdKey"},Key:{matchingOperations:A.operations?.key,operationExample:"public_key",variableType:"key"},WalletData:{matchingOperations:A.operations?.walletData,variableType:"walletData"}}[i.type]})}}},su=e=>{let a=e.filter(o=>o!=="EOF");a.length!==e.length&&a.push("the end of the script");let r=a.slice(0,a.length-1),n=a[a.length-1];return`Encountered unexpected input while parsing script. Expected ${a.length>=3?r.join(", ").concat(`, or ${n}`):a.length===2?a.join(" or "):n}.`},mA=()=>({endColumn:0,endLineNumber:0,startColumn:0,startLineNumber:0}),gu=({configuration:e,data:A})=>[...A.bytecode===void 0?[]:Object.entries(A.bytecode).filter(([a])=>a.endsWith(".public_key")).reduce((a,[r,n])=>a.concat(e.secp256k1?.validatePublicKey(n)===!0?[]:[e.secp256k1===void 0?{error:`Could not validate compilation data: the public key provided for "${r}" could not be validated because the "secp256k1" property was not provided in the compiler configuration.`,range:mA()}:{error:`Invalid compilation data detected: the public key provided for "${r}" is not a valid Secp256k1 public key.`,range:mA()}]),[]),...A.keys?.privateKeys===void 0?[]:Object.entries(A.keys.privateKeys).reduce((a,[r,n])=>a.concat(aa(n)?[]:[{error:`Invalid compilation data detected: the private key provided for the "${r}" variable is not a valid Secp256k1 private key.`,range:mA()}]),[]),...A.hdKeys?.hdPrivateKeys===void 0?[]:Object.entries(A.hdKeys.hdPrivateKeys).reduce((a,[r,n])=>{let i=na(n);return a.concat(typeof i=="string"?[{error:`Invalid compilation data detected: the HD private key provided for the "${r}" entity is not a valid HD private key. ${i}`,range:mA()}]:[])},[]),...A.hdKeys?.hdPublicKeys===void 0?[]:Object.entries(A.hdKeys.hdPublicKeys).reduce((a,[r,n])=>{let i=va(n);return a.concat(typeof i=="string"?[{error:`Invalid compilation data detected: the HD public key provided for the "${r}" entity is not a valid HD public key. ${i}`,range:mA()}]:[])},[])],ZA=({data:e,configuration:A,scriptId:a})=>{let r=A.scripts[a];if(r===void 0)return{errorType:"parse",errors:[{error:`No script with an ID of "${a}" was provided in the compiler configuration.`,range:mA()}],success:!1};if(A.sourceScriptIds?.includes(a)===!0)return{errorType:"parse",errors:[{error:`A circular dependency was encountered: script "${a}" relies on itself to be generated. (Source scripts: ${A.sourceScriptIds.join(" \u2192 ")})`,range:mA()}],success:!1};let n=A.sourceScriptIds===void 0?[a]:[...A.sourceScriptIds,a],i=gu({configuration:A,data:e});return i.length!==0?{errorType:"parse",errors:i,success:!1}:cu({configuration:{...A,sourceScriptIds:n},data:e,script:r})},Ao=({data:e,configuration:A,identifier:a})=>{if(A.scripts[a]===void 0)return!1;let r=ZA({configuration:A,data:e,scriptId:a});return r.success?r:`Compilation error in resolved script "${a}": ${KA(r.errors)}`},Iu=({data:e,configuration:A})=>a=>{let r=A.opcodes?.[a];if(r!==void 0)return{bytecode:r,status:!0,type:FA.opcode};let n=ou({configuration:A,data:e,identifier:a});if(n.status!=="skip")return n.status==="error"?{..."debug"in n?{debug:n.debug}:{},error:n.error,...A.entityOwnership===void 0?{}:{entityOwnership:A.entityOwnership[a.split(".")[0]]},recoverable:"recoverable"in n,status:!1,type:oa.variable}:{..."debug"in n?{debug:n.debug}:{},bytecode:n.bytecode,..."signature"in n?{signature:n.signature}:{},status:!0,type:FA.variable};let i=Ao({configuration:A,data:e,identifier:a});return i!==!1?typeof i=="string"?{error:i,scriptId:a,status:!1,type:oa.script}:{bytecode:i.bytecode,source:i,status:!0,type:FA.script}:{error:`Unknown identifier "${a}".`,status:!1,type:oa.unknown}},cu=({data:e,configuration:A,script:a})=>{let r=Lg(a);if(!r.status)return{errorType:"parse",errors:[{error:su(r.expected),range:{endColumn:r.index.column,endLineNumber:r.index.line,startColumn:r.index.column,startLineNumber:r.index.line}}],success:!1};let n=Iu({configuration:A,data:e}),i=eo(r.value,n),t=zn(i);if(t.length!==0)return{errorType:"resolve",errors:t,parse:r.value,resolve:i,success:!1};let o=wr(i,A.vm,A.createAuthenticationProgram);return{...o.errors===void 0?{bytecode:o.bytecode,success:!0}:{errorType:"reduce",errors:o.errors,success:!1},parse:r.value,reduce:o,resolve:i}};var zg=(e,A,a)=>{if(A.compilationContext?.transaction.locktime!==void 0){if(a.unlockingScriptTimeLockTypes?.[e]==="height"&&A.compilationContext.transaction.locktime>=5e8)return{errorType:"parse",errors:[{error:`The script "${e}" requires a height-based locktime (less than 500,000,000), but this transaction uses a timestamp-based locktime ("${A.compilationContext.transaction.locktime}").`,range:mA()}],success:!1};if(a.unlockingScriptTimeLockTypes?.[e]==="timestamp"&&A.compilationContext.transaction.locktime<5e8)return{errorType:"parse",errors:[{error:`The script "${e}" requires a timestamp-based locktime (greater than or equal to 500,000,000), but this transaction uses a height-based locktime ("${A.compilationContext.transaction.locktime}").`,range:mA()}],success:!1}}if(A.compilationContext?.transaction.inputs[A.compilationContext.inputIndex]?.sequenceNumber!==void 0&&a.unlockingScriptTimeLockTypes?.[e]!==void 0&&A.compilationContext.transaction.inputs[A.compilationContext.inputIndex].sequenceNumber===4294967295)return{errorType:"parse",errors:[{error:`The script "${e}" requires a locktime, but this input's sequence number is set to disable transaction locktime (0xffffffff). This will cause the OP_CHECKLOCKTIMEVERIFY operation to error when the transaction is verified. To be valid, this input must use a sequence number that does not disable locktime.`,range:mA()}],success:!1};let i=ZA({configuration:a,data:A,scriptId:e});if(!i.success)return i;let t=a.unlockingScripts?.[e],o=t===void 0?void 0:a.lockingScriptTypes?.[t],s=o==="p2sh20"||o==="p2sh32",g=a.lockingScriptTypes?.[e];if(g==="p2sh20"||g==="p2sh32"){let I=ZA({configuration:{...a,scripts:{p2sh20Locking:"OP_HASH160 <$(<lockingBytecode> OP_HASH160)> OP_EQUAL",p2sh32Locking:"OP_HASH256 <$(<lockingBytecode> OP_HASH256)> OP_EQUAL"},variables:{lockingBytecode:{type:"AddressData"}}},data:{bytecode:{lockingBytecode:i.bytecode}},scriptId:g==="p2sh20"?"p2sh20Locking":"p2sh32Locking"});return I.success?{...i,bytecode:I.bytecode,transformed:g==="p2sh20"?"p2sh20-locking":"p2sh32-locking"}:I}if(s){let I=ZA({configuration:a,data:A,scriptId:t});if(!I.success)return I;let E=ZA({configuration:{...a,scripts:{p2shUnlocking:"unlockingBytecode <lockingBytecode>"},variables:{lockingBytecode:{type:"AddressData"},unlockingBytecode:{type:"AddressData"}}},data:{bytecode:{lockingBytecode:I.bytecode,unlockingBytecode:i.bytecode}},scriptId:"p2shUnlocking"});return{...i,bytecode:E.bytecode,transformed:o==="p2sh20"?"p2sh20-unlocking":"p2sh32-unlocking"}}return i};var Qe;(function(e){e[e.defaultScenarioAddressIndex=0]="defaultScenarioAddressIndex",e.defaultScenarioBytecode="",e[e.defaultScenarioCurrentBlockHeight=2]="defaultScenarioCurrentBlockHeight",e[e.defaultScenarioCurrentBlockTime=1231469665]="defaultScenarioCurrentBlockTime",e.defaultScenarioInputOutpointTransactionHash="0000000000000000000000000000000000000000000000000000000000000001",e.defaultScenarioOutputTokenCategory="0000000000000000000000000000000000000000000000000000000000000002",e[e.defaultScenarioInputSequenceNumber=0]="defaultScenarioInputSequenceNumber",e.defaultScenarioOutputLockingBytecode="6a076c696261757468",e[e.defaultScenarioOutputValueSatoshis=0]="defaultScenarioOutputValueSatoshis",e[e.defaultScenarioTransactionLocktime=0]="defaultScenarioTransactionLocktime",e[e.defaultScenarioTransactionVersion=2]="defaultScenarioTransactionVersion",e[e.hdKeyAddressOffset=0]="hdKeyAddressOffset",e.hdKeyHdPublicKeyDerivationPath="",e.hdKeyPrivateDerivationPath="i",e.scenarioBytecodeScriptPrefix="_scenario."})(Qe||(Qe={}));var XA=(e,A)=>(a,r,n)=>{for(let i of e){let t=i(a,r,n);if(t.status!=="skip")return t}return A(a,r,n)},ce=({canBeSkipped:e,dataProperties:A,configurationProperties:a,operation:r})=>(n,i,t)=>{for(let o of a)if(t[o]===void 0)return e?{status:"skip"}:{error:`Cannot resolve "${n}" - the "${o}" property was not provided in the compiler configuration.`,status:"error"};for(let o of A)if(i[o]===void 0)return e?{status:"skip"}:{error:`Cannot resolve "${n}" - the "${o}" property was not provided in the compilation data.`,status:"error"};return r(n,i,t)},$A=ce({canBeSkipped:!0,configurationProperties:[],dataProperties:["bytecode"],operation:(e,A)=>{let a=A.bytecode[e];return a!==void 0?{bytecode:a,status:"success"}:{status:"skip"}}}),to=({addressIndex:e,entityId:A,entityHdPrivateKey:a,configuration:r,hdKey:n,identifier:i})=>{let t=n.addressOffset??Qe.hdKeyAddressOffset,o=n.privateDerivationPath??Qe.hdKeyPrivateDerivationPath,s=e+t;if(!/^(?:m|i|[0-9]+)'?(?:\/(?:[0-9]+|i)'?)*$/u.test(o))return{error:`Could not generate "${i}" - the path "${o}" is not a valid "privateDerivationPath".`,status:"error"};let l=Ra(na(a,{crypto:r})),I=o.replace("i",s.toString()),u=(I.includes("m")?_g:Da)(l.node,I,{crypto:r,throwErrors:!1});return typeof u=="string"?{error:`Could not generate "${i}" - the path "${I}" could not be derived for entity "${A}": ${u}`,status:"error"}:{bytecode:u.privateKey,status:"success"}},io=(e,A)=>({error:`Identifier "${e}" refers to an HdKey, but the "entityOwnership" for "${A}" is not available in this compiler configuration.`,status:"error"}),ao=e=>({error:`Identifier "${e}" refers to an HdKey, but "hdKeys.addressIndex" was not provided in the compilation data.`,status:"error"}),ro=({configuration:e,hdKeys:A,identifier:a})=>{let{addressIndex:r,hdPrivateKeys:n}=A,[i]=a.split("."),t=e.entityOwnership[i];if(t===void 0)return io(a,i);if(r===void 0)return ao(a);let o=n===void 0?void 0:n[t];if(o===void 0)return{error:`Identifier "${a}" refers to an HdKey owned by "${t}", but an HD private key for this entity (or an existing signature) was not provided in the compilation data.`,recoverable:!0,status:"error"};let s=e.variables[i];return to({addressIndex:r,configuration:e,entityHdPrivateKey:o,entityId:t,hdKey:s,identifier:a})},no=({targetScriptId:e,data:A,configuration:a})=>{let r=a.scripts[e],n=Ao({configuration:a,data:A,identifier:e});return r===void 0||n===!1?!1:typeof n=="string"?{error:n,status:"error"}:n.bytecode},ga=({data:e,configuration:A,identifier:a,sourceScriptIds:r,unlockingScripts:n})=>{let i=r[r.length-1];if(i===void 0)return{error:`Identifier "${a}" requires a signing serialization, but "coveredBytecode" cannot be determined because the compiler configuration's "sourceScriptIds" is empty.`,status:"error"};let t=n[i];if(t===void 0)return{error:`Identifier "${a}" requires a signing serialization, but "coveredBytecode" cannot be determined because "${i}" is not present in the compiler configuration's "unlockingScripts".`,status:"error"};let o=no({configuration:A,data:e,targetScriptId:t});return o===!1?{error:`Identifier "${a}" requires a signing serialization that covers an unknown locking script, "${t}".`,status:"error"}:o};var lu=ce({canBeSkipped:!1,configurationProperties:[],dataProperties:["bytecode"],operation:(e,A)=>{let a=A.bytecode[e];return a!==void 0?{bytecode:a,status:"success"}:{error:`Identifier "${e}" refers to an AddressData, but "${e}" was not provided in the CompilationData "bytecode".`,recoverable:!0,status:"error"}}}),uu=ce({canBeSkipped:!1,configurationProperties:[],dataProperties:["bytecode"],operation:(e,A)=>{let a=A.bytecode[e];return a!==void 0?{bytecode:a,status:"success"}:{error:`Identifier "${e}" refers to a WalletData, but "${e}" was not provided in the CompilationData "bytecode".`,recoverable:!0,status:"error"}}}),hu=ce({canBeSkipped:!1,configurationProperties:[],dataProperties:["currentBlockTime"],operation:(e,A)=>({bytecode:de(A.currentBlockTime),status:"success"})}),du=ce({canBeSkipped:!1,configurationProperties:[],dataProperties:["currentBlockHeight"],operation:(e,A)=>({bytecode:W(BigInt(A.currentBlockHeight)),status:"success"})}),Eu=ce({canBeSkipped:!1,configurationProperties:[],dataProperties:["compilationContext"],operation:(e,A)=>{let{correspondingOutput:a}=tr(A.compilationContext);return a===void 0?{bytecode:Uint8Array.of(),status:"success"}:{bytecode:a,status:"success"}}}),Bu=ce({canBeSkipped:!1,configurationProperties:["sha256"],dataProperties:["compilationContext"],operation:(e,A,a)=>{let{correspondingOutput:r}=tr(A.compilationContext);return r===void 0?{bytecode:Uint8Array.of(),status:"success"}:{bytecode:a.sha256.hash(a.sha256.hash(r)),status:"success"}}}),jg=e=>ce({canBeSkipped:!1,configurationProperties:["sourceScriptIds","unlockingScripts"],dataProperties:["compilationContext"],operation:(A,a,r)=>{let{unlockingScripts:n,sourceScriptIds:i}=r,t=ga({configuration:r,data:a,identifier:A,sourceScriptIds:i,unlockingScripts:n});return"error"in t?t:{bytecode:e?IA(BigInt(t.length)):t,status:"success"}}}),pu=jg(!1),mu=jg(!0),Qu=ce({canBeSkipped:!1,configurationProperties:[],dataProperties:["compilationContext"],operation:(e,A)=>({bytecode:de(A.compilationContext.transaction.locktime),status:"success"})}),yu=ce({canBeSkipped:!1,configurationProperties:[],dataProperties:["compilationContext"],operation:(e,A)=>({bytecode:de(A.compilationContext.transaction.inputs[A.compilationContext.inputIndex].outpointIndex),status:"success"})}),fu=ce({canBeSkipped:!1,configurationProperties:[],dataProperties:["compilationContext"],operation:(e,A)=>({bytecode:A.compilationContext.transaction.inputs[A.compilationContext.inputIndex].outpointTransactionHash,status:"success"})}),Cu=ce({canBeSkipped:!1,configurationProperties:[],dataProperties:["compilationContext"],operation:(e,A)=>({bytecode:Qt(A.compilationContext.sourceOutputs[A.compilationContext.inputIndex].valueSatoshis),status:"success"})}),Pu=ce({canBeSkipped:!1,configurationProperties:[],dataProperties:["compilationContext"],operation:(e,A)=>({bytecode:de(A.compilationContext.transaction.inputs[A.compilationContext.inputIndex].sequenceNumber),status:"success"})}),Su=ce({canBeSkipped:!1,configurationProperties:[],dataProperties:["compilationContext"],operation:(e,A)=>({bytecode:Ca(A.compilationContext.transaction.inputs),status:"success"})}),bu=ce({canBeSkipped:!1,configurationProperties:["sha256"],dataProperties:["compilationContext"],operation:(e,A,a)=>({bytecode:a.sha256.hash(a.sha256.hash(Ca(A.compilationContext.transaction.inputs))),status:"success"})}),ku=ce({canBeSkipped:!1,configurationProperties:[],dataProperties:["compilationContext"],operation:(e,A)=>({bytecode:bt(A.compilationContext.transaction.outputs),status:"success"})}),Nu=ce({canBeSkipped:!1,configurationProperties:["sha256"],dataProperties:["compilationContext"],operation:(e,A,a)=>({bytecode:a.sha256.hash(a.sha256.hash(bt(A.compilationContext.transaction.outputs))),status:"success"})}),Uu=ce({canBeSkipped:!1,configurationProperties:[],dataProperties:["compilationContext"],operation:(e,A)=>({bytecode:Pa(A.compilationContext.transaction.inputs),status:"success"})}),_u=ce({canBeSkipped:!1,configurationProperties:["sha256"],dataProperties:["compilationContext"],operation:(e,A,a)=>({bytecode:a.sha256.hash(a.sha256.hash(Pa(A.compilationContext.transaction.inputs))),status:"success"})}),vu=ce({canBeSkipped:!1,configurationProperties:[],dataProperties:["compilationContext"],operation:(e,A)=>({bytecode:de(A.compilationContext.transaction.version),status:"success"})}),Du=XA([$A],ce({canBeSkipped:!1,configurationProperties:["secp256k1"],dataProperties:["keys"],operation:(e,A,a)=>{let{keys:r}=A,{secp256k1:n}=a,{privateKeys:i}=r,[t]=e.split(".");return i?.[t]!==void 0?{bytecode:n.derivePublicKeyCompressed(i[t]),status:"success"}:{error:`Identifier "${e}" refers to a public key, but no public or private keys for "${t}" were provided in the compilation data.`,recoverable:!0,status:"error"}}})),wu=XA([$A],ce({canBeSkipped:!1,configurationProperties:["entityOwnership","ripemd160","secp256k1","sha256","sha512","variables"],dataProperties:["hdKeys"],operation:(e,A,a)=>{let{hdKeys:r}=A,{hdPrivateKeys:n,addressIndex:i,hdPublicKeys:t}=r,[o]=e.split("."),s=a.entityOwnership[o];if(s===void 0)return io(e,o);if(i===void 0)return ao(e);let g=n===void 0?void 0:n[s],l=a.variables[o];if(g!==void 0){let p=to({addressIndex:i,configuration:a,entityHdPrivateKey:g,entityId:s,hdKey:l,identifier:e});return p.status==="error"?p:{bytecode:a.secp256k1.derivePublicKeyCompressed(p.bytecode),status:"success"}}let I=t===void 0?void 0:t[s];if(I===void 0)return{error:`Identifier "${e}" refers to an HdKey owned by "${s}", but an HD private key or HD public key for this entity was not provided in the compilation data.`,recoverable:!0,status:"error"};let E=l.addressOffset??Qe.hdKeyAddressOffset,u=l.privateDerivationPath??Qe.hdKeyPrivateDerivationPath,k=l.hdPublicKeyDerivationPath??Qe.hdKeyHdPublicKeyDerivationPath,U=l.publicDerivationPath??u.replace("m/","");if(k!==""&&!/^(?:m|[0-9]+)'?(?:\/(?:[0-9]+'?))*$/u.test(k))return{error:`Could not generate "${e}" - "hdPublicKeyDerivationPath" ("${k}") must be a fixed (no "i" characters), valid absolute derivation path.`,status:"error"};let c=k===""?U:`${k}/${U}`;if(u!==c)return{error:`Could not generate "${e}" - "privateDerivationPath" ("${u}") is expected to be the combination of "hdPublicKeyDerivationPath" and "publicDerivationPath": "${c}".`,status:"error"};let B=Ra(va(I,{crypto:a})),S=i+E,P=U.replace("i",S.toString()),h=k.split("/").length-1;if(k!==""&&B.node.depth!==h)return{error:`Could not generate "${e}" - the HD public key derivation path ("${k}") indicates an expected depth of ${h}, but the provided HD public key has a depth of ${B.node.depth}.`,status:"error"};let y=Da(B.node,P,{crypto:a,throwErrors:!1});return typeof y=="string"?{error:`Could not generate "${e}" - the path "${P}" could not be derived for entity "${s}": ${y}`,status:"error"}:{bytecode:y.publicKey,status:"success"}}})),Et={addressData:lu,currentBlockHeight:du,currentBlockTime:hu,hdKey:{public_key:wu},key:{public_key:Du},signingSerialization:{corresponding_output:Eu,corresponding_output_hash:Bu,covered_bytecode:pu,covered_bytecode_length:mu,locktime:Qu,outpoint_index:yu,outpoint_transaction_hash:fu,output_value:Cu,sequence_number:Pu,transaction_outpoints:Su,transaction_outpoints_hash:bu,transaction_outputs:ku,transaction_outputs_hash:Nu,transaction_sequence_numbers:Uu,transaction_sequence_numbers_hash:_u,version:vu},walletData:uu};var Wg=e=>{let{variables:A,entityOwnership:a}=e,r=A===void 0?[]:Object.entries(A).filter(u=>u[1].type==="Key").map(([u])=>u),n=a===void 0?[]:Object.keys(Object.values(a).reduce((u,k)=>({...u,[k]:!0}),{})),i=[...r,...n].sort((u,k)=>u.localeCompare(k,"en")).reduce((u,k,U)=>({...u,[k]:Ja(BigInt(U+1))}),{}),t=A===void 0?void 0:Object.entries(A).reduce((u,[k,U])=>U.type==="Key"?{...u,[k]:$(i[k])}:u,{}),o={data:{currentBlockHeight:Qe.defaultScenarioCurrentBlockHeight,currentBlockTime:Qe.defaultScenarioCurrentBlockTime,...t===void 0||Object.keys(t).length===0?{}:{keys:{privateKeys:t}}},sourceOutputs:[{lockingBytecode:["slot"]}],transaction:{inputs:[{unlockingBytecode:["slot"]}],locktime:Qe.defaultScenarioTransactionLocktime,outputs:[{lockingBytecode:Qe.defaultScenarioOutputLockingBytecode}],version:Qe.defaultScenarioTransactionVersion}};if(!(A===void 0?!1:Object.values(A).findIndex(u=>u.type==="HdKey")!==-1))return o;let{sha256:g,sha512:l}=e;if(g===void 0)return'An implementations of "sha256" is required to generate defaults for HD keys, but the "sha256" property is not included in this compiler configuration.';if(l===void 0)return'An implementations of "sha512" is required to generate defaults for HD keys, but the "sha512" property is not included in this compiler configuration.';let I={sha256:g,sha512:l},E=n.reduce((u,k)=>{let N=ra(i[k],{assumeValidity:!0,crypto:I}),{hdPrivateKey:c}=Ug({network:"mainnet",node:N},{crypto:I});return{...u,[k]:c}},{});return{...o,data:{...o.data,hdKeys:{addressIndex:Qe.defaultScenarioAddressIndex,hdPrivateKeys:E}}}},$g=(e,A)=>({...e,...A,...e.bytecode===void 0&&A.bytecode===void 0?{}:{bytecode:{...e.bytecode,...A.bytecode}},...e.hdKeys===void 0&&A.hdKeys===void 0?{}:{hdKeys:{...e.hdKeys,...A.hdKeys,...e.hdKeys?.hdPrivateKeys===void 0&&A.hdKeys?.hdPrivateKeys===void 0?{}:{hdPrivateKeys:{...e.hdKeys?.hdPrivateKeys,...A.hdKeys?.hdPrivateKeys}},...e.hdKeys?.hdPublicKeys===void 0&&A.hdKeys?.hdPublicKeys===void 0?{}:{hdPublicKeys:{...e.hdKeys?.hdPublicKeys,...A.hdKeys?.hdPublicKeys}}}},...e.keys===void 0&&A.keys===void 0?{}:{keys:{privateKeys:{...e.keys?.privateKeys,...A.keys?.privateKeys}}}}),eI=(e,A)=>({...e.data===void 0&&A.data===void 0?{}:{data:$g(e.data??{},A.data??{})},...e.transaction===void 0&&A.transaction===void 0?{}:{transaction:{...e.transaction,...A.transaction}},...e.sourceOutputs===void 0&&A.sourceOutputs===void 0?{}:{sourceOutputs:A.sourceOutputs??e.sourceOutputs}}),AI=({configuration:e,scenarioId:A,sourceScenarioIds:a=[]})=>{if(A===void 0)return Wg(e);if(a.includes(A))return`Cannot extend scenario "${A}": scenario "${A}" extends itself. Scenario inheritance path: ${a.join(" \u2192 ")}`;let r=e.scenarios?.[A];if(r===void 0)return`Cannot extend scenario "${A}": a scenario with the identifier ${A} is not included in this compiler configuration.`;let n=r.extends===void 0?Wg(e):AI({configuration:e,scenarioId:r.extends,sourceScenarioIds:[...a,A]});return typeof n=="string"?n:eI(n,r)},tI=e=>({...e.data.currentBlockHeight===void 0?{}:{currentBlockHeight:e.data.currentBlockHeight},...e.data.currentBlockTime===void 0?{}:{currentBlockTime:e.data.currentBlockTime},...e.data.hdKeys===void 0?{}:{hdKeys:{...e.data.hdKeys.addressIndex===void 0?{}:{addressIndex:e.data.hdKeys.addressIndex},...e.data.hdKeys.hdPrivateKeys!==void 0&&Object.keys(e.data.hdKeys.hdPrivateKeys).length>0?{hdPrivateKeys:e.data.hdKeys.hdPrivateKeys}:{},...e.data.hdKeys.hdPublicKeys===void 0?{}:{hdPublicKeys:e.data.hdKeys.hdPublicKeys}}},...e.data.keys?.privateKeys!==void 0&&Object.keys(e.data.keys.privateKeys).length>0?{keys:{privateKeys:Object.entries(e.data.keys.privateKeys).reduce((A,[a,r])=>({...A,[a]:ze(r)}),{})}}:{}}),iI=({compilationData:e,configuration:A,scenarioDataBytecodeScripts:a})=>{let r=g=>`${Qe.scenarioBytecodeScriptPrefix}${g}`,n=Object.entries(a).reduce((g,[l,I])=>({...g,[r(l)]:I}),{}),i={...A,scripts:{...A.scripts,...n}},t=Object.keys(a).map(g=>{let l=ZA({configuration:i,data:e,scriptId:r(g)});return l.success?{bytecode:l.bytecode,id:g}:{errors:l.errors,id:g}}),o=t.filter(g=>"errors"in g);if(o.length>0)return o.map(g=>`Compilation error while generating bytecode for "${g.id}": ${KA(g.errors)}`).join("; ");let s=t.reduce((g,l)=>({...g,[l.id]:l.bytecode}),{});return{...Object.keys(s).length>0?{bytecode:s}:{},...e}},Zg=(e=Qe.defaultScenarioOutputValueSatoshis)=>typeof e=="string"?yo(ze(e)):BigInt(e),oo=({bytecodeDefinition:e,compilationContext:A,configuration:a,defaultOverride:r,extendedScenario:n,generateBytecode:i,lockingOrUnlockingScriptIdUnderTest:t})=>{if(typeof e=="string")return ze(e);let o=e.script===void 0||Array.isArray(e.script)?t:e.script;if(o===void 0)return ze("");let s=e.overrides??r,g=$g(n.data,s),l=iI({compilationData:tI({data:g}),configuration:a,scenarioDataBytecodeScripts:g.bytecode??{}});return typeof l=="string"?{errors:[{error:`Could not compile scenario "data.bytecode": ${l}`}],success:!1}:i({data:{...l,compilationContext:A},debug:!0,scriptId:o})},Xg=e=>e.token===void 0?{}:{token:{amount:BigInt(e.token.amount??0),category:ze(e.token.category??Qe.defaultScenarioOutputTokenCategory),...e.token.nft===void 0?{}:{nft:{capability:e.token.nft.capability??"none",commitment:ze(e.token.nft.commitment??"")}}}},aI=({configuration:e,generateBytecode:A,scenarioId:a,unlockingScriptId:r,lockingScriptId:n},i)=>{let{scenarioDefinition:t,scenarioName:o}=a===void 0?{scenarioDefinition:{},scenarioName:"the default scenario"}:{scenarioDefinition:e.scenarios?.[a],scenarioName:`scenario "${a}"`};if(t===void 0)return`Cannot generate ${o}: a scenario definition with the identifier ${a} is not included in this compiler configuration.`;let s=AI({configuration:e,scenarioId:a});if(typeof s=="string")return`Cannot generate ${o}: ${s}`;let g=eI(s,t),l=tI(g),I=iI({compilationData:l,configuration:e,scenarioDataBytecodeScripts:g.data.bytecode??{}});if(typeof I=="string")return`Cannot generate ${o}. ${I}`;if(g.transaction.inputs.length!==g.sourceOutputs.length)return`Cannot generate ${o}: could not match source outputs with inputs - "sourceOutputs" must be the same length as "transaction.inputs".`;if(g.transaction.inputs.filter(D=>Array.isArray(D.unlockingBytecode)).length!==1)return`Cannot generate ${o}: the specific input under test in this scenario is ambiguous - "transaction.inputs" must include exactly one input that has "unlockingBytecode" set to ["slot"].`;let u=g.transaction.inputs.findIndex(D=>Array.isArray(D.unlockingBytecode));if(g.sourceOutputs.filter(D=>Array.isArray(D.lockingBytecode)).length!==1)return`Cannot generate ${o}: the source output unlocked by the input under test in this scenario is ambiguous - "sourceOutputs" must include exactly one output that has "lockingBytecode" set to ["slot"].`;if(!Array.isArray(g.sourceOutputs[u]?.lockingBytecode))return`Cannot generate ${o}: the source output unlocked by the input under test in this scenario is ambiguous - the ["slot"] in "transaction.inputs" and "sourceOutputs" must be at the same index.`;if(r!==void 0&&n!==void 0)return`Cannot generate ${o}: a scenario cannot be generated with both unlocking and locking script IDs defined. If an unlocking script is provided, the associated locking script ID must be read from the template.`;let U=n??(r===void 0?void 0:e.unlockingScripts?.[r]);if(r!==void 0&&U===void 0)return`Cannot generate ${o} using unlocking script "${r}": the locking script unlocked by "${r}" is not provided in this compiler configuration.`;let N=g.sourceOutputs.map((D,G)=>{let K=Array.isArray(D.lockingBytecode),V=K?U===void 0?Qe.defaultScenarioBytecode:{script:U}:D.lockingBytecode??{};return{compiled:{lockingBytecode:oo({bytecodeDefinition:V,configuration:e,defaultOverride:{},extendedScenario:g,generateBytecode:A,lockingOrUnlockingScriptIdUnderTest:U}),valueSatoshis:Zg(D.valueSatoshis),...Xg(D)},index:G,slot:K,type:"source output"}}),c=N.find(D=>D.slot)?.compiled.lockingBytecode,B=g.transaction.outputs.map((D,G)=>{let K={hdKeys:{addressIndex:1}};return{compiled:{lockingBytecode:oo({bytecodeDefinition:D.lockingBytecode??{},configuration:e,defaultOverride:K,extendedScenario:g,generateBytecode:A,lockingOrUnlockingScriptIdUnderTest:U}),valueSatoshis:Zg(D.valueSatoshis),...Xg(D)},index:G,type:"transaction output"}}),S=[...N,...B].reduce((D,G)=>"errors"in G.compiled.lockingBytecode?[...D,...G.compiled.lockingBytecode.errors.map(K=>`Failed compilation of ${G.type} at index ${G.index}: ${K.error}`)]:D,[]);if(S.length>0){let D=`Cannot generate ${o}: ${S.join(" ")}`;return i===!0?{lockingCompilation:c,scenario:D}:D}let P=N,h=B,y=D=>{let{lockingBytecode:G,valueSatoshis:K,token:V}=D.compiled;return{lockingBytecode:"bytecode"in G?G.bytecode:G,valueSatoshis:K,...V===void 0?{}:{token:V}}},p=P.map(y),C=h.map(y),b=g.transaction.inputs.map((D,G)=>({outpointIndex:D.outpointIndex??G,outpointTransactionHash:ze(D.outpointTransactionHash??Qe.defaultScenarioInputOutpointTransactionHash),sequenceNumber:D.sequenceNumber??Qe.defaultScenarioInputSequenceNumber,unlockingBytecode:void 0})),Y=g.transaction.inputs.map((D,G)=>{let K=Array.isArray(D.unlockingBytecode),V=Array.isArray(D.unlockingBytecode)?r===void 0?Qe.defaultScenarioBytecode:{script:r}:D.unlockingBytecode??{},L={};return{compiled:{outpointIndex:b[G].outpointIndex,outpointTransactionHash:b[G].outpointTransactionHash,sequenceNumber:b[G].sequenceNumber,unlockingBytecode:oo({bytecodeDefinition:V,compilationContext:{inputIndex:G,sourceOutputs:p,transaction:{inputs:b,locktime:g.transaction.locktime,outputs:C,version:g.transaction.version}},configuration:e,defaultOverride:L,extendedScenario:g,generateBytecode:A,lockingOrUnlockingScriptIdUnderTest:r})},index:G,slot:K}}),_=Y.find(D=>D.slot)?.compiled.unlockingBytecode,x=Y.reduce((D,G)=>"errors"in G.compiled.unlockingBytecode?[...D,...G.compiled.unlockingBytecode.errors.map(K=>`Failed compilation of input at index ${G.index}: ${K.error}`)]:D,[]);if(x.length>0){let D=`Cannot generate ${o}: ${x.join(" ")}`;return i===!0?{lockingCompilation:c,scenario:D,unlockingCompilation:_}:D}let F=Y.map(D=>{let{outpointIndex:G,outpointTransactionHash:K,sequenceNumber:V,unlockingBytecode:L}=D.compiled;return{outpointIndex:G,outpointTransactionHash:K,sequenceNumber:V,unlockingBytecode:"bytecode"in L?L.bytecode:L}}),O={data:I,program:{inputIndex:u,sourceOutputs:p,transaction:{inputs:F,locktime:g.transaction.locktime,outputs:C,version:g.transaction.version}}};return i===!0?{lockingCompilation:c,scenario:O,unlockingCompilation:_}:O};var Tu=e=>({data:A,debug:a,scriptId:r})=>{let n=zg(r,A,e);return a===!0?n:n.success?{bytecode:n.bytecode,success:!0}:{errorType:n.errorType,errors:n.errors,success:!1}},Yr=e=>{let A=Tu(e);return{configuration:e,generateBytecode:A,generateScenario:({lockingScriptId:a,unlockingScriptId:r,scenarioId:n,debug:i})=>aI({configuration:e,generateBytecode:A,lockingScriptId:a,scenarioId:n,unlockingScriptId:r},i)}},aP=Yr,Yu=32,so=e=>({inputIndex:0,sourceOutputs:[{lockingBytecode:e,valueSatoshis:0n}],transaction:{inputs:[{outpointIndex:0,outpointTransactionHash:new Uint8Array(Yu),sequenceNumber:0,unlockingBytecode:Uint8Array.of()}],locktime:0,outputs:[{lockingBytecode:Uint8Array.of(),valueSatoshis:0n}],version:0}}),rI=e=>Yr({createAuthenticationProgram:so,opcodes:zA(cs),operations:Et,ripemd160:Ee,secp256k1:Ae,sha256:q,sha512:je,...e}),rP=e=>{let A=rI({opcodes:{},operations:{},scripts:{script:e}}).generateBytecode({data:{},scriptId:"script"});return A.success?A.bytecode:`CashAssembly compilation error:${A.errors.reduce((a,{error:r,range:n})=>`${a} [${n.startLineNumber}, ${n.startColumn}]: ${r}`,"")}`},nI=(e,A)=>rI({opcodes:e,scripts:{asm:A}}).generateBytecode({data:{},scriptId:"asm"}),xu=e=>nI(zA(f),e),nP=e=>{let A=xu(e);return A.success?A.bytecode:`CashAssembly compilation ${A.errorType} error: ${A.errors.map(a=>a.error).join(" ")}`},oP=e=>nI(zA(kt),e),xr=e=>{let A=Object.entries(e.scripts).reduce((l,[I,E])=>"tests"in E?{...l,...Object.entries(E.tests).reduce((u,[k,U])=>{let N=E.pushed===!0,c=`${I}.${k}.check`,B=`${I}.${k}.lock`,S=`${I}.${k}.unlock`;return{...u,[c]:{script:U.check},[B]:{lockingType:"p2sh20",script:N?`<${I}> ${c}`:`${I} ${c}`},[S]:{script:U.setup??"",unlocks:B}}},{})}:l,{}),a={...e.scripts,...A},r=Object.entries(a).reduce((l,[I,E])=>({...l,[I]:E.script}),{}),n=Object.values(e.entities).reduce((l,I)=>({...l,...I.variables}),{}),i=Object.entries(e.entities).reduce((l,[I,E])=>({...l,...Object.keys(E.variables??{}).reduce((u,k)=>({...u,[k]:I}),{})}),{}),t=Object.entries(a).reduce((l,[I,E])=>"unlocks"in E&&E.unlocks!==void 0?{...l,[I]:E.unlocks}:l,{}),o=Object.entries(a).reduce((l,[I,E])=>"timeLockType"in E&&E.timeLockType!==void 0?{...l,[I]:E.timeLockType}:l,{}),s=Object.entries(a).reduce((l,[I,E])=>"lockingType"in E&&E.lockingType!==void 0?{...l,[I]:E.lockingType}:l,{}),g=e.scenarios===void 0?void 0:Object.entries(e.scenarios).reduce((l,[I,E])=>({...l,[I]:E}),{});return{entityOwnership:i,lockingScriptTypes:s,...g===void 0?{}:{scenarios:g},scripts:r,unlockingScriptTimeLockTypes:o,unlockingScripts:t,variables:n}};var Ze;(function(e){e.allOutputs="all_outputs",e.allOutputsAllUtxos="all_outputs_all_utxos",e.allOutputsSingleInput="all_outputs_single_input",e.allOutputsSingleInputInvalidAllUtxos="all_outputs_single_input_INVALID_all_utxos",e.correspondingOutput="corresponding_output",e.correspondingOutputAllUtxos="corresponding_output_all_utxos",e.correspondingOutputSingleInput="corresponding_output_single_input",e.correspondingOutputSingleInputInvalidAllUtxos="corresponding_output_single_input_INVALID_all_utxos",e.default="default",e.noOutputs="no_outputs",e.noOutputsAllUtxos="no_outputs_all_utxos",e.noOutputsSingleInput="no_outputs_single_input",e.noOutputsSingleInputInvalidAllUtxos="no_outputs_single_input_INVALID_all_utxos"})(Ze||(Ze={}));var gI=(e,A="")=>{switch(e){case`${A}${Ze.allOutputs}`:return Uint8Array.of(ve.allOutputs);case`${A}${Ze.allOutputsAllUtxos}`:case`${A}${Ze.default}`:return Uint8Array.of(ve.allOutputsAllUtxos);case`${A}${Ze.allOutputsSingleInput}`:return Uint8Array.of(ve.allOutputsSingleInput);case`${A}${Ze.allOutputsSingleInputInvalidAllUtxos}`:return Uint8Array.of(De.allOutputs|De.singleInput|De.utxos|De.forkId);case`${A}${Ze.correspondingOutput}`:return Uint8Array.of(ve.correspondingOutput);case`${A}${Ze.correspondingOutputAllUtxos}`:return Uint8Array.of(ve.correspondingOutputAllUtxos);case`${A}${Ze.correspondingOutputSingleInput}`:return Uint8Array.of(ve.correspondingOutputSingleInput);case`${A}${Ze.correspondingOutputSingleInputInvalidAllUtxos}`:return Uint8Array.of(De.correspondingOutput|De.singleInput|De.utxos|De.forkId);case`${A}${Ze.noOutputs}`:return Uint8Array.of(ve.noOutputs);case`${A}${Ze.noOutputsAllUtxos}`:return Uint8Array.of(ve.noOutputsAllUtxos);case`${A}${Ze.noOutputsSingleInput}`:return Uint8Array.of(ve.noOutputsSingleInput);case`${A}${Ze.noOutputsSingleInputInvalidAllUtxos}`:return Uint8Array.of(De.noOutputs|De.singleInput|De.utxos|De.forkId);default:return}},II=({coveredBytecode:e,identifier:A,compilationContext:a,operationName:r,privateKey:n,sha256:i,sign:t})=>{let[,,o,s]=A.split(".");if(s!==void 0)return{error:`Unknown component in "${A}" - the fragment "${s}" is not recognized.`,status:"error"};if(o===void 0)return{error:`Invalid signature identifier. Signatures must be of the form: "[variable_id].${r}.[signing_serialization_type]".`,status:"error"};let g=gI(o);if(g===void 0)return{error:`Unknown signing serialization algorithm, "${o}".`,status:"error"};let l=cA(a,{coveredBytecode:e,signingSerializationType:g},i),I=pe(l,i);return{bytecode:Uint8Array.from([...t(n,I),...g]),signature:{serialization:l},status:"success"}},cI=({operationName:e,secp256k1Method:A})=>XA([$A],ce({canBeSkipped:!1,configurationProperties:["entityOwnership","ripemd160","secp256k1","sha256","sha512","variables","sourceScriptIds","unlockingScripts"],dataProperties:["hdKeys","compilationContext"],operation:(a,r,n)=>{let{hdKeys:i,compilationContext:t}=r,{secp256k1:o,sha256:s,sourceScriptIds:g,unlockingScripts:l}=n,I=ro({configuration:n,hdKeys:i,identifier:a});if(I.status==="error")return I;let E=ga({configuration:n,data:r,identifier:a,sourceScriptIds:g,unlockingScripts:l});return"error"in E?E:II({compilationContext:t,coveredBytecode:E,identifier:a,operationName:e,privateKey:I.bytecode,sha256:s,sign:o[A]})}})),Ou=cI({operationName:"ecdsa_signature",secp256k1Method:"signMessageHashDER"}),Ru=cI({operationName:"schnorr_signature",secp256k1Method:"signMessageHashSchnorr"}),lI=({operationName:e,secp256k1Method:A})=>XA([$A],ce({canBeSkipped:!1,configurationProperties:["sha256","secp256k1","unlockingScripts","sourceScriptIds"],dataProperties:["keys","compilationContext"],operation:(a,r,n)=>{let{keys:i,compilationContext:t}=r,{secp256k1:o,sha256:s,unlockingScripts:g,sourceScriptIds:l}=n,{privateKeys:I}=i,[E]=a.split("."),u=I===void 0?void 0:I[E];if(u===void 0)return{error:`Identifier "${a}" refers to a Key, but a private key for "${E}" (or an existing signature) was not provided in the compilation data.`,recoverable:!0,status:"error"};let k=ga({configuration:n,data:r,identifier:a,sourceScriptIds:l,unlockingScripts:g});return"error"in k?k:II({compilationContext:t,coveredBytecode:k,identifier:a,operationName:e,privateKey:u,sha256:s,sign:o[A]})}})),Fu=lI({operationName:"ecdsa_signature",secp256k1Method:"signMessageHashDER"}),Ku=lI({operationName:"schnorr_signature",secp256k1Method:"signMessageHashSchnorr"}),uI=({data:e,configuration:A,identifier:a,operationName:r,privateKey:n,sha256:i,sign:t})=>{let[,,o,s]=a.split(".");if(s!==void 0)return{error:`Unknown component in "${a}" - the fragment "${s}" is not recognized.`,status:"error"};if(o===void 0)return{error:`Invalid data signature identifier. Data signatures must be of the form: "[variable_id].${r}.[target_script_id]".`,status:"error"};let g=no({configuration:A,data:e,targetScriptId:o});if(g===!1)return{error:`Data signature tried to sign an unknown target script, "${o}".`,status:"error"};if("error"in g)return g;let l=i.hash(g);return{bytecode:t(n,l),signature:{digest:l,message:g},status:"success"}},hI=({operationName:e,secp256k1Method:A})=>XA([$A],ce({canBeSkipped:!1,configurationProperties:["sha256","secp256k1"],dataProperties:["keys"],operation:(a,r,n)=>{let{keys:i}=r,{secp256k1:t,sha256:o}=n,{privateKeys:s}=i,[g]=a.split("."),l=s===void 0?void 0:s[g];return l===void 0?{error:`Identifier "${a}" refers to a Key, but a private key for "${g}" (or an existing signature) was not provided in the compilation data.`,recoverable:!0,status:"error"}:uI({configuration:n,data:r,identifier:a,operationName:e,privateKey:l,sha256:o,sign:t[A]})}})),Mu=hI({operationName:"ecdsa_data_signature",secp256k1Method:"signMessageHashDER"}),Gu=hI({operationName:"schnorr_data_signature",secp256k1Method:"signMessageHashSchnorr"}),dI=({operationName:e,secp256k1Method:A})=>XA([$A],ce({canBeSkipped:!1,configurationProperties:["entityOwnership","ripemd160","secp256k1","sha256","sha512","variables"],dataProperties:["hdKeys"],operation:(a,r,n)=>{let{hdKeys:i}=r,{secp256k1:t,sha256:o}=n,s=ro({configuration:n,hdKeys:i,identifier:a});return s.status==="error"?s:uI({configuration:n,data:r,identifier:a,operationName:e,privateKey:s.bytecode,sha256:o,sign:t[A]})}})),qu=dI({operationName:"ecdsa_data_signature",secp256k1Method:"signMessageHashDER"}),Hu=dI({operationName:"schnorr_data_signature",secp256k1Method:"signMessageHashSchnorr"}),Ju=ce({canBeSkipped:!1,configurationProperties:[],dataProperties:["compilationContext"],operation:(e,A)=>({bytecode:fa(A.compilationContext.sourceOutputs[A.compilationContext.inputIndex].token),status:"success"})}),oI=e=>({error:`The "signature" compiler operation was renamed to "ecdsa_signature". Consider fixing this error by changing "${e}" to "${e.replace("signature","schnorr_signature")}" (schnorr signatures reduce transaction sizes and enable multi-party signature aggregation).`,status:"error"}),sI=e=>({error:`The "data_signature" compiler operation was renamed to "ecdsa_data_signature". Consider fixing this error by changing "${e}" to "${e.replace("data_signature","schnorr_data_signature")}" (schnorr signatures reduce transaction sizes and enable multi-party signature aggregation).`,status:"error"}),sA=ce({canBeSkipped:!1,configurationProperties:["sha256","sourceScriptIds","unlockingScripts"],dataProperties:["compilationContext"],operation:(e,A,a)=>{let[,r,n]=e.split(".");if(r===void 0)return{error:'Invalid signing serialization operation. Include the desired component or algorithm, e.g. "signing_serialization.version".',status:"error"};if(n!==void 0)return{error:`Unknown component in "${e}" - the fragment "${n}" is not recognized.`,status:"error"};let i=gI(r,"full_");if(i===void 0)return{error:`Unknown signing serialization algorithm, "${r}".`,status:"error"};let{sha256:t,sourceScriptIds:o,unlockingScripts:s}=a,g=ga({configuration:a,data:A,identifier:e,sourceScriptIds:o,unlockingScripts:s});if("error"in g)return g;let{compilationContext:l}=A;return{bytecode:cA(l,{coveredBytecode:g,signingSerializationType:i},t),status:"success"}}}),Lu={...Et,hdKey:{data_signature:sI,ecdsa_data_signature:qu,ecdsa_signature:Ou,public_key:Et.hdKey.public_key,schnorr_data_signature:Hu,schnorr_signature:Ru,signature:oI},key:{data_signature:sI,ecdsa_data_signature:Mu,ecdsa_signature:Fu,public_key:Et.key.public_key,schnorr_data_signature:Gu,schnorr_signature:Ku,signature:oI},signingSerialization:{...Et.signingSerialization,full_all_outputs:sA,full_all_outputs_all_utxos:sA,full_all_outputs_single_input:sA,full_all_outputs_single_input_INVALID_all_utxos:sA,full_corresponding_output:sA,full_corresponding_output_all_utxos:sA,full_corresponding_output_single_input:sA,full_corresponding_output_single_input_INVALID_all_utxos:sA,full_default:sA,full_no_outputs:sA,full_no_outputs_all_utxos:sA,full_no_outputs_single_input:sA,full_no_outputs_single_input_INVALID_all_utxos:sA,token_prefix:Ju}},Or=e=>Yr({createAuthenticationProgram:so,opcodes:zA(m),operations:Lu,ripemd160:Ee,secp256k1:Ae,sha256:q,sha512:je,vm:e.vm??ws(),...e}),dP=Or,Ta=(e,A)=>Or({...A,...xr(e)});var go={$schema:"https://libauth.org/schemas/wallet-template-v0.schema.json",description:`A standard single-factor wallet template that uses Pay-to-Public-Key-Hash (P2PKH), the most common authentication scheme in use on the network.

This P2PKH template uses BCH Schnorr signatures, reducing the size of transactions.`,entities:{owner:{description:"The individual who can spend from this wallet.",name:"Owner",scripts:["lock","unlock"],variables:{key:{description:"The private key that controls this wallet.",name:"Key",type:"Key"}}}},name:"Single Signature (P2PKH)",scripts:{lock:{lockingType:"standard",name:"P2PKH Lock",script:`OP_DUP
OP_HASH160 <$(<key.public_key> OP_HASH160
)> OP_EQUALVERIFY
OP_CHECKSIG`},unlock:{name:"Unlock",script:`<key.schnorr_signature.all_outputs>
<key.public_key>`,unlocks:"lock"}},supported:["BCH_2020_05","BCH_2021_05","BCH_2022_05"],version:0},Io={$schema:"https://libauth.org/schemas/wallet-template-v0.schema.json",description:`A standard single-factor wallet template that uses Pay-to-Public-Key-Hash (P2PKH), the most common authentication scheme in use on the network.

This P2PKH template uses BCH Schnorr signatures, reducing the size of transactions. Because the template uses a Hierarchical Deterministic (HD) key, it also supports watch-only clients.`,entities:{owner:{description:"The individual who can spend from this wallet.",name:"Owner",scripts:["lock","unlock"],variables:{key:{description:"The private key that controls this wallet.",name:"Key",type:"HdKey"}}}},name:"Single Signature (P2PKH)",scripts:{lock:{lockingType:"standard",name:"P2PKH Lock",script:`OP_DUP
OP_HASH160 <$(<key.public_key> OP_HASH160
)> OP_EQUALVERIFY
OP_CHECKSIG`},unlock:{name:"Unlock",script:`<key.schnorr_signature.all_outputs>
<key.public_key>`,unlocks:"lock"}},supported:["BCH_2020_05","BCH_2021_05","BCH_2022_05"],version:0};var Ia;(function(e){e.hdPrivateKeyToP2pkhLockingBytecodeCompilation="P2PKH utility error: could not derive P2PKH locking bytecode from the provided HD private key.",e.hdPublicKeyToP2pkhLockingBytecodeCompilation="P2PKH utility error: could not derive P2PKH locking bytecode from the provided HD public key.",e.privateKeyToP2pkhLockingBytecodeCompilation="P2PKH utility error: could not derive P2PKH locking bytecode from the provided private key.",e.publicKeyToP2pkhLockingBytecodeCompilation="P2PKH utility error: could not derive P2PKH locking bytecode from the provided public key."})(Ia||(Ia={}));var Vu=({privateKey:e,throwErrors:A=!0})=>{let r=Ta(go).generateBytecode({data:{keys:{privateKeys:{key:e}}},scriptId:"lock"});return r.success?r.bytecode:R(Ia.privateKeyToP2pkhLockingBytecodeCompilation,KA(r.errors),A)},zu=({publicKey:e,throwErrors:A=!0})=>{let r=Ta(go).generateBytecode({data:{bytecode:{"key.public_key":e}},scriptId:"lock"});return r.success?r.bytecode:R(Ia.publicKeyToP2pkhLockingBytecodeCompilation,KA(r.errors),A)},ju=({addressIndex:e,hdPrivateKey:A,privateDerivationPath:a="i",throwErrors:r=!0})=>{let n=structuredClone(Io);n.entities.owner.variables.key.privateDerivationPath=a;let t=Ta(n).generateBytecode({data:{hdKeys:{addressIndex:e,hdPrivateKeys:{owner:A}}},scriptId:"lock"});return t.success?t.bytecode:R(Ia.hdPrivateKeyToP2pkhLockingBytecodeCompilation,KA(t.errors),r)},Wu=({addressIndex:e,hdPublicKey:A,hdPublicKeyDerivationPath:a="",throwErrors:r=!0,publicDerivationPath:n="i"})=>{let i=structuredClone(Io);i.entities.owner.variables.key.publicDerivationPath=n,i.entities.owner.variables.key.hdPublicKeyDerivationPath=a,i.entities.owner.variables.key.privateDerivationPath=a===""?n:`${a}/${n}`;let o=Ta(i).generateBytecode({data:{hdKeys:{addressIndex:e,hdPublicKeys:{owner:A}}},scriptId:"lock"});return o.success?o.bytecode:R(Ia.hdPublicKeyToP2pkhLockingBytecodeCompilation,KA(o.errors),r)},SP=({privateKey:e,prefix:A="bitcoincash",throwErrors:a=!0,tokenSupport:r=!1})=>{let n=Vu({privateKey:e,throwErrors:a});return typeof n=="string"?R(n,void 0,a):Qa({bytecode:n,prefix:A,tokenSupport:r})},bP=({publicKey:e,prefix:A="bitcoincash",throwErrors:a=!0,tokenSupport:r=!1})=>{let n=zu({publicKey:e,throwErrors:a});return typeof n=="string"?R(n,void 0,a):Qa({bytecode:n,prefix:A,tokenSupport:r})},kP=({addressIndex:e,hdPrivateKey:A,prefix:a="bitcoincash",privateDerivationPath:r="i",throwErrors:n=!0,tokenSupport:i=!1})=>{let t=ju({addressIndex:e,hdPrivateKey:A,privateDerivationPath:r,throwErrors:n});return typeof t=="string"?R(t,void 0,n):Qa({bytecode:t,prefix:a,tokenSupport:i})},NP=({addressIndex:e,hdPublicKey:A,hdPublicKeyDerivationPath:a="",prefix:r="bitcoincash",publicDerivationPath:n="i",throwErrors:i=!0,tokenSupport:t=!1})=>{let o=Wu({addressIndex:e,hdPublicKey:A,hdPublicKeyDerivationPath:a,publicDerivationPath:n,throwErrors:i});return typeof o=="string"?R(o,void 0,i):Qa({bytecode:o,prefix:r,tokenSupport:t})};var Rr=BI;var Zu={additionalProperties:!1,properties:{lockingType:{description:'Indicates if P2SH20 infrastructure should be used when producing bytecode related to this script. For more information on P2SH20, see BIP16.\n\nWhen compiling locking scripts of type `p2sh20`, the result will be placed in a P2SH20 "redeem script" format: `OP_HASH160 <$(<lockingBytecode> OP_HASH160)> OP_EQUAL`\n\nWhen compiling unlocking scripts that unlock locking scripts of type `p2sh20`, the result will be transformed into the P2SH20 unlocking format: `unlockingBytecode <lockingBytecode>` (where `lockingBytecode` is the compiled bytecode of the locking script, without the "redeem script" transformation.)\n\nThe presence of the `lockingType` property indicates that this script is a locking script. It must be present on any script referenced by the `unlocks` property of another script.',enum:["p2sh20","p2sh32","standard"],type:"string"},name:{description:"A single-line, human-readable name for this script (for use in user interfaces).",type:"string"},script:{description:"The script definition in CashAssembly.",type:"string"}},required:["lockingType","script"],type:"object"},EI={additionalProperties:!1,properties:{ageLock:{description:`TODO: not yet implemented

The minimum input age required for this unlocking script to become valid.

This value is provided as a CashAssembly script that must compile to the least significant 3 bytes of the minimum sequence number required for this unlocking script to be valid (the "type bit" and the 2-byte "value" \u2013 see BIP68 for details). This script has access to all other template scripts and variables, but cyclical references will produce an error at compile time.

In supporting wallets, this value can be computed at address creation time, and the remaining time for which any UTXO remains "age-locked" can be displayed in user interfaces (by parsing the "type bit" and "value" as described in BIP68).

Note, because the precise value used by \`OP_CHECKSEQUENCEVERIFY\` can be provided in the unlocking script, it is trivial to create an unlocking script for which a proper value for \`ageLock\` is not possible to determine until the spending transaction is prepared. These cases are intentionally out-of-scope for this property. Instead, \`ageLock\` should only be used for unlocking scripts where the expected value can be compiled at address creation time.`,type:"string"},estimate:{description:'The identifier of the scenario to use for this unlocking script when compiling an estimated transaction.\n\nUsing estimate scenarios, it\'s possible for wallet software to compute an "estimated transaction", an invalid transaction that is guaranteed to be the same byte length as the final transaction. This length can be used to calculate the required transaction fee and assign values to the transaction\'s change output(s). Because estimate scenarios provide "estimated" values for all variables, this estimation can be done by a single entity without input from other entities.\n\nIf not provided, the default scenario will be used for estimation. The default scenario only provides values for each `Key` and `HdKey` variable, so compilations requiring other variables will produce errors. See `WalletTemplateScenario.extends` for details.',type:"string"},fails:{description:`A list of the scenario identifiers that \u2013 when used to compile this unlocking script and the script it unlocks \u2013 result in bytecode that fails program verification.

These scenarios can be used to test this script in development and review.`,items:{type:"string"},type:"array"},invalid:{description:`A list of the scenario identifiers that \u2013 when used to compile this unlocking script and the script it unlocks \u2013 result in a compilation error.

These scenarios can be used to test this script in development and review.`,items:{type:"string"},type:"array"},name:{description:"A single-line, human-readable name for this script (for use in user interfaces).",type:"string"},passes:{description:`A list of the scenario identifiers that \u2013 when used to compile this unlocking script and the script it unlocks \u2013 result in bytecode that passes program verification.

These scenarios can be used to test this script in development and review.`,items:{type:"string"},type:"array"},script:{description:"The script definition in CashAssembly.",type:"string"},timeLockType:{description:"The expected type of time locks in this script.\n\nBecause `OP_CHECKLOCKTIMEVERIFY` reads from a transaction's `locktime` property, every input to a given transaction must share the same time lock type. This differs from `OP_CHECKSEQUENCEVERIFY` in that each input has its own `sequenceNumber`, so compatibility is not required.\n\nIf a transaction includes multiple inputs using scripts with `timeLockType` defined, and the types are not compatible, generation should fail.\n\nThe `timestamp` type indicates that the transaction's locktime is provided as a UNIX timestamp (the `locktime` value is greater than or equal to `500000000`).\n\nThe `height` type indicates that the transaction's locktime is provided as a block height (the `locktime` value is less than `500000000`).\n\nIf `timeLockType` is undefined, the script is assumed to have no reliance on absolute time locks.",enum:["height","timestamp"],type:"string"},unlocks:{description:"The identifier of the script that can be unlocked by this script.\n\nThe presence of the `unlocks` property indicates that this script is an unlocking script, and the script it unlocks must be a locking script.",type:"string"}},required:["script","unlocks"],type:"object"},Xu={description:"Allowable identifiers for authentication virtual machine versions. The `BCH` prefix identifies the Bitcoin Cash network, the `XEC` prefix identifies the eCash network, the `BSV` prefix identifies the Bitcoin SV network, and the `BTC` prefix identifies the Bitcoin Core network. VM versions are named according to the date they were deployed on the indicated network.\n\nFor each network prefix, a `_SPEC` VM version is reserved to indicate that the template requires a custom, not-yet-deployed VM version (e.g. one or more CHIPs). By convention, templates marked for `_SPEC` VMs should indicate their requirements in the template description. After deployment of the `_SPEC` VM, when template compatibility is verified, the template's `supported` array should be updated to indicate compatibility with the live VM version.",enum:["BCH_2020_05","BCH_2021_05","BCH_2022_05","BCH_2023_05","BCH_SPEC","BSV_2020_02","BSV_SPEC","BTC_2017_08","BTC_SPEC","XEC_2020_05","XEC_SPEC"],type:"string"};function Ya(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0,o=t,s=!1,g=t;if(t===t)if(e&&typeof e=="object"&&!Array.isArray(e)){let N;if(e.type===void 0&&(N="type")){let c={instancePath:A,schemaPath:"#/definitions/WalletTemplateAddressData/required",keyword:"required",params:{missingProperty:N},message:"must have required property '"+N+"'"};i===null?i=[c]:i.push(c),t++}else{let c=t;for(let B in e)if(!(B==="description"||B==="name"||B==="type")){let S={instancePath:A,schemaPath:"#/definitions/WalletTemplateAddressData/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:B},message:"must NOT have additional properties"};i===null?i=[S]:i.push(S),t++;break}if(c===t){if(e.description!==void 0){let B=t;if(typeof e.description!="string"){let S={instancePath:A+"/description",schemaPath:"#/definitions/WalletTemplateAddressData/properties/description/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[S]:i.push(S),t++}var I=B===t}else var I=!0;if(I){if(e.name!==void 0){let B=t;if(typeof e.name!="string"){let P={instancePath:A+"/name",schemaPath:"#/definitions/WalletTemplateAddressData/properties/name/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[P]:i.push(P),t++}var I=B===t}else var I=!0;if(I)if(e.type!==void 0){let B=e.type,S=t;if(typeof B!="string"){let h={instancePath:A+"/type",schemaPath:"#/definitions/WalletTemplateAddressData/properties/type/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[h]:i.push(h),t++}if(B!=="AddressData"){let h={instancePath:A+"/type",schemaPath:"#/definitions/WalletTemplateAddressData/properties/type/const",keyword:"const",params:{allowedValue:"AddressData"},message:"must be equal to constant"};i===null?i=[h]:i.push(h),t++}var I=S===t}else var I=!0}}}}else{let N={instancePath:A,schemaPath:"#/definitions/WalletTemplateAddressData/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[N]:i.push(N),t++}var E=g===t;if(s=s||E,!s){let N=t;if(t===t)if(e&&typeof e=="object"&&!Array.isArray(e)){let S;if(e.type===void 0&&(S="type")){let P={instancePath:A,schemaPath:"#/definitions/WalletTemplateHdKey/required",keyword:"required",params:{missingProperty:S},message:"must have required property '"+S+"'"};i===null?i=[P]:i.push(P),t++}else{let P=t;for(let h in e)if(!(h==="addressOffset"||h==="description"||h==="hdPublicKeyDerivationPath"||h==="name"||h==="neverSignTwice"||h==="privateDerivationPath"||h==="publicDerivationPath"||h==="type")){let y={instancePath:A,schemaPath:"#/definitions/WalletTemplateHdKey/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:h},message:"must NOT have additional properties"};i===null?i=[y]:i.push(y),t++;break}if(P===t){if(e.addressOffset!==void 0){let h=e.addressOffset,y=t;if(!(typeof h=="number"&&isFinite(h))){let p={instancePath:A+"/addressOffset",schemaPath:"#/definitions/WalletTemplateHdKey/properties/addressOffset/type",keyword:"type",params:{type:"number"},message:"must be number"};i===null?i=[p]:i.push(p),t++}var u=y===t}else var u=!0;if(u){if(e.description!==void 0){let h=t;if(typeof e.description!="string"){let p={instancePath:A+"/description",schemaPath:"#/definitions/WalletTemplateHdKey/properties/description/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[p]:i.push(p),t++}var u=h===t}else var u=!0;if(u){if(e.hdPublicKeyDerivationPath!==void 0){let h=t;if(typeof e.hdPublicKeyDerivationPath!="string"){let p={instancePath:A+"/hdPublicKeyDerivationPath",schemaPath:"#/definitions/WalletTemplateHdKey/properties/hdPublicKeyDerivationPath/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[p]:i.push(p),t++}var u=h===t}else var u=!0;if(u){if(e.name!==void 0){let h=t;if(typeof e.name!="string"){let p={instancePath:A+"/name",schemaPath:"#/definitions/WalletTemplateHdKey/properties/name/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[p]:i.push(p),t++}var u=h===t}else var u=!0;if(u){if(e.neverSignTwice!==void 0){let h=t;if(typeof e.neverSignTwice!="boolean"){let p={instancePath:A+"/neverSignTwice",schemaPath:"#/definitions/WalletTemplateHdKey/properties/neverSignTwice/type",keyword:"type",params:{type:"boolean"},message:"must be boolean"};i===null?i=[p]:i.push(p),t++}var u=h===t}else var u=!0;if(u){if(e.privateDerivationPath!==void 0){let h=t;if(typeof e.privateDerivationPath!="string"){let p={instancePath:A+"/privateDerivationPath",schemaPath:"#/definitions/WalletTemplateHdKey/properties/privateDerivationPath/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[p]:i.push(p),t++}var u=h===t}else var u=!0;if(u){if(e.publicDerivationPath!==void 0){let h=t;if(typeof e.publicDerivationPath!="string"){let p={instancePath:A+"/publicDerivationPath",schemaPath:"#/definitions/WalletTemplateHdKey/properties/publicDerivationPath/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[p]:i.push(p),t++}var u=h===t}else var u=!0;if(u)if(e.type!==void 0){let h=e.type,y=t;if(typeof h!="string"){let C={instancePath:A+"/type",schemaPath:"#/definitions/WalletTemplateHdKey/properties/type/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[C]:i.push(C),t++}if(h!=="HdKey"){let C={instancePath:A+"/type",schemaPath:"#/definitions/WalletTemplateHdKey/properties/type/const",keyword:"const",params:{allowedValue:"HdKey"},message:"must be equal to constant"};i===null?i=[C]:i.push(C),t++}var u=y===t}else var u=!0}}}}}}}}}else{let S={instancePath:A,schemaPath:"#/definitions/WalletTemplateHdKey/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[S]:i.push(S),t++}var E=N===t;if(s=s||E,!s){let S=t;if(t===t)if(e&&typeof e=="object"&&!Array.isArray(e)){let y;if(e.type===void 0&&(y="type")){let p={instancePath:A,schemaPath:"#/definitions/WalletTemplateKey/required",keyword:"required",params:{missingProperty:y},message:"must have required property '"+y+"'"};i===null?i=[p]:i.push(p),t++}else{let p=t;for(let C in e)if(!(C==="description"||C==="name"||C==="neverSignTwice"||C==="type")){let b={instancePath:A,schemaPath:"#/definitions/WalletTemplateKey/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:C},message:"must NOT have additional properties"};i===null?i=[b]:i.push(b),t++;break}if(p===t){if(e.description!==void 0){let C=t;if(typeof e.description!="string"){let b={instancePath:A+"/description",schemaPath:"#/definitions/WalletTemplateKey/properties/description/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[b]:i.push(b),t++}var k=C===t}else var k=!0;if(k){if(e.name!==void 0){let C=t;if(typeof e.name!="string"){let Y={instancePath:A+"/name",schemaPath:"#/definitions/WalletTemplateKey/properties/name/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[Y]:i.push(Y),t++}var k=C===t}else var k=!0;if(k){if(e.neverSignTwice!==void 0){let C=t;if(typeof e.neverSignTwice!="boolean"){let Y={instancePath:A+"/neverSignTwice",schemaPath:"#/definitions/WalletTemplateKey/properties/neverSignTwice/type",keyword:"type",params:{type:"boolean"},message:"must be boolean"};i===null?i=[Y]:i.push(Y),t++}var k=C===t}else var k=!0;if(k)if(e.type!==void 0){let C=e.type,b=t;if(typeof C!="string"){let _={instancePath:A+"/type",schemaPath:"#/definitions/WalletTemplateKey/properties/type/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[_]:i.push(_),t++}if(C!=="Key"){let _={instancePath:A+"/type",schemaPath:"#/definitions/WalletTemplateKey/properties/type/const",keyword:"const",params:{allowedValue:"Key"},message:"must be equal to constant"};i===null?i=[_]:i.push(_),t++}var k=b===t}else var k=!0}}}}}else{let y={instancePath:A,schemaPath:"#/definitions/WalletTemplateKey/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[y]:i.push(y),t++}var E=S===t;if(s=s||E,!s){let y=t;if(t===t)if(e&&typeof e=="object"&&!Array.isArray(e)){let b;if(e.type===void 0&&(b="type")){let Y={instancePath:A,schemaPath:"#/definitions/WalletTemplateWalletData/required",keyword:"required",params:{missingProperty:b},message:"must have required property '"+b+"'"};i===null?i=[Y]:i.push(Y),t++}else{let Y=t;for(let _ in e)if(!(_==="description"||_==="name"||_==="type")){let x={instancePath:A,schemaPath:"#/definitions/WalletTemplateWalletData/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:_},message:"must NOT have additional properties"};i===null?i=[x]:i.push(x),t++;break}if(Y===t){if(e.description!==void 0){let _=t;if(typeof e.description!="string"){let x={instancePath:A+"/description",schemaPath:"#/definitions/WalletTemplateWalletData/properties/description/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[x]:i.push(x),t++}var U=_===t}else var U=!0;if(U){if(e.name!==void 0){let _=t;if(typeof e.name!="string"){let H={instancePath:A+"/name",schemaPath:"#/definitions/WalletTemplateWalletData/properties/name/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[H]:i.push(H),t++}var U=_===t}else var U=!0;if(U)if(e.type!==void 0){let _=e.type,x=t;if(typeof _!="string"){let F={instancePath:A+"/type",schemaPath:"#/definitions/WalletTemplateWalletData/properties/type/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[F]:i.push(F),t++}if(_!=="WalletData"){let F={instancePath:A+"/type",schemaPath:"#/definitions/WalletTemplateWalletData/properties/type/const",keyword:"const",params:{allowedValue:"WalletData"},message:"must be equal to constant"};i===null?i=[F]:i.push(F),t++}var U=x===t}else var U=!0}}}}else{let b={instancePath:A,schemaPath:"#/definitions/WalletTemplateWalletData/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[b]:i.push(b),t++}var E=y===t;s=s||E}}}if(s)t=o,i!==null&&(o?i.length=o:i=null);else{let N={instancePath:A,schemaPath:"#/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};return i===null?i=[N]:i.push(N),t++,Ya.errors=i,!1}return Ya.errors=i,t===0}function QA(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e)){let l=t;for(let I in e)if(!(I==="description"||I==="name"||I==="scripts"||I==="variables")){return QA.errors=[{instancePath:A,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:I},message:"must NOT have additional properties"}],!1;break}if(l===t){if(e.description!==void 0){let I=t;if(typeof e.description!="string")return QA.errors=[{instancePath:A+"/description",schemaPath:"#/properties/description/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=I===t}else var o=!0;if(o){if(e.name!==void 0){let I=t;if(typeof e.name!="string")return QA.errors=[{instancePath:A+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=I===t}else var o=!0;if(o){if(e.scripts!==void 0){let I=e.scripts,E=t;if(t===E)if(Array.isArray(I)){var s=!0;let k=I.length;for(let U=0;U<k;U++){let N=t;if(typeof I[U]!="string")return QA.errors=[{instancePath:A+"/scripts/"+U,schemaPath:"#/properties/scripts/items/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var s=N===t;if(!s)break}}else return QA.errors=[{instancePath:A+"/scripts",schemaPath:"#/properties/scripts/type",keyword:"type",params:{type:"array"},message:"must be array"}],!1;var o=E===t}else var o=!0;if(o)if(e.variables!==void 0){let I=e.variables,E=t;if(t===E)if(I&&typeof I=="object"&&!Array.isArray(I))for(let k in I){let U=t;Ya(I[k],{instancePath:A+"/variables/"+k.replace(/~/g,"~0").replace(/\//g,"~1"),parentData:I,parentDataProperty:k,rootData:n})||(i=i===null?Ya.errors:i.concat(Ya.errors),t=i.length);var g=U===t;if(!g)break}else return QA.errors=[{instancePath:A+"/variables",schemaPath:"#/properties/variables/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=E===t}else var o=!0}}}}else return QA.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return QA.errors=i,t===0}var co={additionalProperties:!1,description:"An example output used to define a scenario for a wallet template.",properties:{lockingBytecode:{anyOf:[{$ref:"#/definitions/WalletTemplateScenarioBytecode"},{items:{const:"slot",type:"string"},maxItems:1,minItems:1,type:"array"}],description:'The locking bytecode used to encumber this output.\n\n`lockingBytecode` values may be provided as a hexadecimal-encoded string or as an object describing the required compilation. If undefined, defaults to  `{}`, which uses the default values for `script` and `overrides`, respectively.\n\nOnly source outputs may specify a `lockingBytecode` of `["slot"]`; this identifies the source output in which the locking script under test will be placed. (To be valid, every scenario\'s `sourceOutputs` property must have exactly one source output slot and one input slot at the same index.)'},token:{additionalProperties:!1,description:"The CashToken contents of this output. This property is only defined if the output contains one or more tokens. For details, see `CHIP-2022-02-CashTokens`.",properties:{amount:{description:'The number of fungible tokens (of `category`) held in this output.\n\nBecause `Number.MAX_SAFE_INTEGER` (`9007199254740991`) is less than the maximum token amount (`9223372036854775807`), this value may also be provided as a string, e.g. `"9223372036854775807"`.\n\nIf undefined, this defaults to: `0`.',type:["number","string"]},category:{description:"The 32-byte, hexadecimal-encoded token category ID to which the token(s) in this output belong in big-endian byte order. This is the byte order typically seen in block explorers and user interfaces (as opposed to little-endian byte order, which is used in standard P2P network messages).\n\nIf undefined, this defaults to the value: `0000000000000000000000000000000000000000000000000000000000000002`",type:"string"},nft:{additionalProperties:!1,description:"If present, the non-fungible token (NFT) held by this output. If the output does not include a non-fungible token, `undefined`.",properties:{capability:{description:"The capability of this non-fungible token, must be either `minting`, `mutable`, or `none`.\n\nIf undefined, this defaults to: `none`.",enum:["minting","mutable","none"],type:"string"},commitment:{description:'The hex-encoded commitment contents included in the non-fungible token held in this output.\n\nIf undefined, this defaults to: `""` (a zero-length commitment).',type:"string"}},type:"object"}},type:"object"},valueSatoshis:{description:'The value of the output in satoshis, the smallest unit of bitcoin.\n\nIn a valid transaction, this is a positive integer, from `0` to the maximum number of satoshis available to the transaction.\n\nThe maximum number of satoshis in existence is about 1/4 of `Number.MAX_SAFE_INTEGER` (`9007199254740991`), so typically, this value is defined using a `number`. However, this value may also be defined using a 16-character, hexadecimal-encoded `string`, to allow for the full range of the 64-bit unsigned, little-endian integer used to encode `valueSatoshis` in the encoded output format, e.g. `"ffffffffffffffff"`. This is useful for representing scenarios where intentionally excessive values are provided (to ensure an otherwise properly-signed transaction can never be included in the blockchain), e.g. transaction size estimations or off-chain Bitauth signatures.\n\nIf undefined, this defaults to: `0`.',type:["number","string"]}},type:"object"};function yA(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0,o=t,s=!1,g=t;if(typeof e!="string"){let P={instancePath:A,schemaPath:"#/anyOf/0/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[P]:i.push(P),t++}var l=g===t;if(s=s||l,!s){let P=t;if(t===P)if(e&&typeof e=="object"&&!Array.isArray(e)){let y=t;for(let p in e)if(!(p==="overrides"||p==="script")){let C={instancePath:A,schemaPath:"#/anyOf/1/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:p},message:"must NOT have additional properties"};i===null?i=[C]:i.push(C),t++;break}if(y===t){if(e.overrides!==void 0){let p=e.overrides,C=t;if(t===t)if(p&&typeof p=="object"&&!Array.isArray(p)){let Y=t;for(let _ in p)if(!(_==="bytecode"||_==="currentBlockHeight"||_==="currentBlockTime"||_==="hdKeys"||_==="keys")){let x={instancePath:A+"/overrides",schemaPath:"#/definitions/WalletTemplateScenarioData/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:_},message:"must NOT have additional properties"};i===null?i=[x]:i.push(x),t++;break}if(Y===t){if(p.bytecode!==void 0){let _=p.bytecode,x=t;if(t===x)if(_&&typeof _=="object"&&!Array.isArray(_))for(let H in _){let F=t;if(typeof _[H]!="string"){let O={instancePath:A+"/overrides/bytecode/"+H.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScenarioData/properties/bytecode/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[O]:i.push(O),t++}var I=F===t;if(!I)break}else{let H={instancePath:A+"/overrides/bytecode",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/bytecode/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[H]:i.push(H),t++}var E=x===t}else var E=!0;if(E){if(p.currentBlockHeight!==void 0){let _=p.currentBlockHeight,x=t;if(!(typeof _=="number"&&isFinite(_))){let F={instancePath:A+"/overrides/currentBlockHeight",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/currentBlockHeight/type",keyword:"type",params:{type:"number"},message:"must be number"};i===null?i=[F]:i.push(F),t++}var E=x===t}else var E=!0;if(E){if(p.currentBlockTime!==void 0){let _=p.currentBlockTime,x=t;if(!(typeof _=="number"&&isFinite(_))){let F={instancePath:A+"/overrides/currentBlockTime",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/currentBlockTime/type",keyword:"type",params:{type:"number"},message:"must be number"};i===null?i=[F]:i.push(F),t++}var E=x===t}else var E=!0;if(E){if(p.hdKeys!==void 0){let _=p.hdKeys,x=t;if(t===x)if(_&&typeof _=="object"&&!Array.isArray(_)){let F=t;for(let O in _)if(!(O==="addressIndex"||O==="hdPrivateKeys"||O==="hdPublicKeys")){let D={instancePath:A+"/overrides/hdKeys",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/hdKeys/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:O},message:"must NOT have additional properties"};i===null?i=[D]:i.push(D),t++;break}if(F===t){if(_.addressIndex!==void 0){let O=_.addressIndex,D=t;if(!(typeof O=="number"&&isFinite(O))){let G={instancePath:A+"/overrides/hdKeys/addressIndex",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/hdKeys/properties/addressIndex/type",keyword:"type",params:{type:"number"},message:"must be number"};i===null?i=[G]:i.push(G),t++}var u=D===t}else var u=!0;if(u){if(_.hdPrivateKeys!==void 0){let O=_.hdPrivateKeys,D=t;if(t===D)if(O&&typeof O=="object"&&!Array.isArray(O))for(let K in O){let V=t;if(typeof O[K]!="string"){let L={instancePath:A+"/overrides/hdKeys/hdPrivateKeys/"+K.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScenarioData/properties/hdKeys/properties/hdPrivateKeys/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[L]:i.push(L),t++}var k=V===t;if(!k)break}else{let K={instancePath:A+"/overrides/hdKeys/hdPrivateKeys",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/hdKeys/properties/hdPrivateKeys/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[K]:i.push(K),t++}var u=D===t}else var u=!0;if(u)if(_.hdPublicKeys!==void 0){let O=_.hdPublicKeys,D=t;if(t===D)if(O&&typeof O=="object"&&!Array.isArray(O))for(let K in O){let V=t;if(typeof O[K]!="string"){let L={instancePath:A+"/overrides/hdKeys/hdPublicKeys/"+K.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScenarioData/properties/hdKeys/properties/hdPublicKeys/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[L]:i.push(L),t++}var U=V===t;if(!U)break}else{let K={instancePath:A+"/overrides/hdKeys/hdPublicKeys",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/hdKeys/properties/hdPublicKeys/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[K]:i.push(K),t++}var u=D===t}else var u=!0}}}else{let F={instancePath:A+"/overrides/hdKeys",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/hdKeys/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[F]:i.push(F),t++}var E=x===t}else var E=!0;if(E)if(p.keys!==void 0){let _=p.keys,x=t;if(t===x)if(_&&typeof _=="object"&&!Array.isArray(_)){let F=t;for(let O in _)if(O!=="privateKeys"){let D={instancePath:A+"/overrides/keys",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/keys/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:O},message:"must NOT have additional properties"};i===null?i=[D]:i.push(D),t++;break}if(F===t&&_.privateKeys!==void 0){let O=_.privateKeys;if(t===t)if(O&&typeof O=="object"&&!Array.isArray(O))for(let G in O){let K=t;if(typeof O[G]!="string"){let V={instancePath:A+"/overrides/keys/privateKeys/"+G.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScenarioData/properties/keys/properties/privateKeys/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[V]:i.push(V),t++}var N=K===t;if(!N)break}else{let G={instancePath:A+"/overrides/keys/privateKeys",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/keys/properties/privateKeys/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[G]:i.push(G),t++}}}else{let F={instancePath:A+"/overrides/keys",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/keys/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[F]:i.push(F),t++}var E=x===t}else var E=!0}}}}}else{let Y={instancePath:A+"/overrides",schemaPath:"#/definitions/WalletTemplateScenarioData/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[Y]:i.push(Y),t++}var c=C===t}else var c=!0;if(c)if(e.script!==void 0){let p=e.script,C=t,b=t,Y=!1,_=t;if(typeof p!="string"){let H={instancePath:A+"/script",schemaPath:"#/anyOf/1/properties/script/anyOf/0/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[H]:i.push(H),t++}var B=_===t;if(Y=Y||B,!Y){let H=t;if(t===H)if(Array.isArray(p))if(p.length>1){let O={instancePath:A+"/script",schemaPath:"#/anyOf/1/properties/script/anyOf/1/maxItems",keyword:"maxItems",params:{limit:1},message:"must NOT have more than 1 items"};i===null?i=[O]:i.push(O),t++}else if(p.length<1){let O={instancePath:A+"/script",schemaPath:"#/anyOf/1/properties/script/anyOf/1/minItems",keyword:"minItems",params:{limit:1},message:"must NOT have fewer than 1 items"};i===null?i=[O]:i.push(O),t++}else{var S=!0;let O=p.length;for(let D=0;D<O;D++){let G=p[D],K=t;if(typeof G!="string"){let L={instancePath:A+"/script/"+D,schemaPath:"#/anyOf/1/properties/script/anyOf/1/items/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[L]:i.push(L),t++}if(G!=="copy"){let L={instancePath:A+"/script/"+D,schemaPath:"#/anyOf/1/properties/script/anyOf/1/items/const",keyword:"const",params:{allowedValue:"copy"},message:"must be equal to constant"};i===null?i=[L]:i.push(L),t++}var S=K===t;if(!S)break}}else{let O={instancePath:A+"/script",schemaPath:"#/anyOf/1/properties/script/anyOf/1/type",keyword:"type",params:{type:"array"},message:"must be array"};i===null?i=[O]:i.push(O),t++}var B=H===t;Y=Y||B}if(Y)t=b,i!==null&&(b?i.length=b:i=null);else{let H={instancePath:A+"/script",schemaPath:"#/anyOf/1/properties/script/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};i===null?i=[H]:i.push(H),t++}var c=C===t}else var c=!0}}else{let y={instancePath:A,schemaPath:"#/anyOf/1/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[y]:i.push(y),t++}var l=P===t;s=s||l}if(s)t=o,i!==null&&(o?i.length=o:i=null);else{let P={instancePath:A,schemaPath:"#/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};return i===null?i=[P]:i.push(P),t++,yA.errors=i,!1}return yA.errors=i,t===0}function He(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e)){let E=t;for(let u in e)if(!(u==="lockingBytecode"||u==="token"||u==="valueSatoshis")){return He.errors=[{instancePath:A,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:u},message:"must NOT have additional properties"}],!1;break}if(E===t){if(e.lockingBytecode!==void 0){let u=e.lockingBytecode,k=t,U=t,N=!1,c=t;yA(u,{instancePath:A+"/lockingBytecode",parentData:e,parentDataProperty:"lockingBytecode",rootData:n})||(i=i===null?yA.errors:i.concat(yA.errors),t=i.length);var o=c===t;if(N=N||o,!N){let B=t;if(t===B)if(Array.isArray(u))if(u.length>1){let P={instancePath:A+"/lockingBytecode",schemaPath:"#/properties/lockingBytecode/anyOf/1/maxItems",keyword:"maxItems",params:{limit:1},message:"must NOT have more than 1 items"};i===null?i=[P]:i.push(P),t++}else if(u.length<1){let P={instancePath:A+"/lockingBytecode",schemaPath:"#/properties/lockingBytecode/anyOf/1/minItems",keyword:"minItems",params:{limit:1},message:"must NOT have fewer than 1 items"};i===null?i=[P]:i.push(P),t++}else{var s=!0;let P=u.length;for(let h=0;h<P;h++){let y=u[h],p=t;if(typeof y!="string"){let b={instancePath:A+"/lockingBytecode/"+h,schemaPath:"#/properties/lockingBytecode/anyOf/1/items/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[b]:i.push(b),t++}if(y!=="slot"){let b={instancePath:A+"/lockingBytecode/"+h,schemaPath:"#/properties/lockingBytecode/anyOf/1/items/const",keyword:"const",params:{allowedValue:"slot"},message:"must be equal to constant"};i===null?i=[b]:i.push(b),t++}var s=p===t;if(!s)break}}else{let P={instancePath:A+"/lockingBytecode",schemaPath:"#/properties/lockingBytecode/anyOf/1/type",keyword:"type",params:{type:"array"},message:"must be array"};i===null?i=[P]:i.push(P),t++}var o=B===t;N=N||o}if(N)t=U,i!==null&&(U?i.length=U:i=null);else{let B={instancePath:A+"/lockingBytecode",schemaPath:"#/properties/lockingBytecode/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};return i===null?i=[B]:i.push(B),t++,He.errors=i,!1}var g=k===t}else var g=!0;if(g){if(e.token!==void 0){let u=e.token,k=t;if(t===k)if(u&&typeof u=="object"&&!Array.isArray(u)){let N=t;for(let c in u)if(!(c==="amount"||c==="category"||c==="nft")){return He.errors=[{instancePath:A+"/token",schemaPath:"#/properties/token/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:c},message:"must NOT have additional properties"}],!1;break}if(N===t){if(u.amount!==void 0){let c=u.amount,B=t;if(!(typeof c=="number"&&isFinite(c))&&typeof c!="string")return He.errors=[{instancePath:A+"/token/amount",schemaPath:"#/properties/token/properties/amount/type",keyword:"type",params:{type:co.properties.token.properties.amount.type},message:"must be number,string"}],!1;var l=B===t}else var l=!0;if(l){if(u.category!==void 0){let c=t;if(typeof u.category!="string")return He.errors=[{instancePath:A+"/token/category",schemaPath:"#/properties/token/properties/category/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var l=c===t}else var l=!0;if(l)if(u.nft!==void 0){let c=u.nft,B=t;if(t===B)if(c&&typeof c=="object"&&!Array.isArray(c)){let P=t;for(let h in c)if(!(h==="capability"||h==="commitment")){return He.errors=[{instancePath:A+"/token/nft",schemaPath:"#/properties/token/properties/nft/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:h},message:"must NOT have additional properties"}],!1;break}if(P===t){if(c.capability!==void 0){let h=c.capability,y=t;if(typeof h!="string")return He.errors=[{instancePath:A+"/token/nft/capability",schemaPath:"#/properties/token/properties/nft/properties/capability/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;if(!(h==="minting"||h==="mutable"||h==="none"))return He.errors=[{instancePath:A+"/token/nft/capability",schemaPath:"#/properties/token/properties/nft/properties/capability/enum",keyword:"enum",params:{allowedValues:co.properties.token.properties.nft.properties.capability.enum},message:"must be equal to one of the allowed values"}],!1;var I=y===t}else var I=!0;if(I)if(c.commitment!==void 0){let h=t;if(typeof c.commitment!="string")return He.errors=[{instancePath:A+"/token/nft/commitment",schemaPath:"#/properties/token/properties/nft/properties/commitment/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var I=h===t}else var I=!0}}else return He.errors=[{instancePath:A+"/token/nft",schemaPath:"#/properties/token/properties/nft/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var l=B===t}else var l=!0}}}else return He.errors=[{instancePath:A+"/token",schemaPath:"#/properties/token/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var g=k===t}else var g=!0;if(g)if(e.valueSatoshis!==void 0){let u=e.valueSatoshis,k=t;if(!(typeof u=="number"&&isFinite(u))&&typeof u!="string")return He.errors=[{instancePath:A+"/valueSatoshis",schemaPath:"#/properties/valueSatoshis/type",keyword:"type",params:{type:co.properties.valueSatoshis.type},message:"must be number,string"}],!1;var g=k===t}else var g=!0}}}else return He.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return He.errors=i,t===0}function UA(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e)){let l=t;for(let I in e)if(!(I==="outpointIndex"||I==="outpointTransactionHash"||I==="sequenceNumber"||I==="unlockingBytecode")){return UA.errors=[{instancePath:A,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:I},message:"must NOT have additional properties"}],!1;break}if(l===t){if(e.outpointIndex!==void 0){let I=e.outpointIndex,E=t;if(!(typeof I=="number"&&isFinite(I)))return UA.errors=[{instancePath:A+"/outpointIndex",schemaPath:"#/properties/outpointIndex/type",keyword:"type",params:{type:"number"},message:"must be number"}],!1;var o=E===t}else var o=!0;if(o){if(e.outpointTransactionHash!==void 0){let I=t;if(typeof e.outpointTransactionHash!="string")return UA.errors=[{instancePath:A+"/outpointTransactionHash",schemaPath:"#/properties/outpointTransactionHash/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=I===t}else var o=!0;if(o){if(e.sequenceNumber!==void 0){let I=e.sequenceNumber,E=t;if(!(typeof I=="number"&&isFinite(I)))return UA.errors=[{instancePath:A+"/sequenceNumber",schemaPath:"#/properties/sequenceNumber/type",keyword:"type",params:{type:"number"},message:"must be number"}],!1;var o=E===t}else var o=!0;if(o)if(e.unlockingBytecode!==void 0){let I=e.unlockingBytecode,E=t,u=t,k=!1,U=t;yA(I,{instancePath:A+"/unlockingBytecode",parentData:e,parentDataProperty:"unlockingBytecode",rootData:n})||(i=i===null?yA.errors:i.concat(yA.errors),t=i.length);var s=U===t;if(k=k||s,!k){let c=t;if(t===c)if(Array.isArray(I))if(I.length>1){let S={instancePath:A+"/unlockingBytecode",schemaPath:"#/properties/unlockingBytecode/anyOf/1/maxItems",keyword:"maxItems",params:{limit:1},message:"must NOT have more than 1 items"};i===null?i=[S]:i.push(S),t++}else if(I.length<1){let S={instancePath:A+"/unlockingBytecode",schemaPath:"#/properties/unlockingBytecode/anyOf/1/minItems",keyword:"minItems",params:{limit:1},message:"must NOT have fewer than 1 items"};i===null?i=[S]:i.push(S),t++}else{var g=!0;let S=I.length;for(let P=0;P<S;P++){let h=I[P],y=t;if(typeof h!="string"){let C={instancePath:A+"/unlockingBytecode/"+P,schemaPath:"#/properties/unlockingBytecode/anyOf/1/items/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[C]:i.push(C),t++}if(h!=="slot"){let C={instancePath:A+"/unlockingBytecode/"+P,schemaPath:"#/properties/unlockingBytecode/anyOf/1/items/const",keyword:"const",params:{allowedValue:"slot"},message:"must be equal to constant"};i===null?i=[C]:i.push(C),t++}var g=y===t;if(!g)break}}else{let S={instancePath:A+"/unlockingBytecode",schemaPath:"#/properties/unlockingBytecode/anyOf/1/type",keyword:"type",params:{type:"array"},message:"must be array"};i===null?i=[S]:i.push(S),t++}var s=c===t;k=k||s}if(k)t=u,i!==null&&(u?i.length=u:i=null);else{let c={instancePath:A+"/unlockingBytecode",schemaPath:"#/properties/unlockingBytecode/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};return i===null?i=[c]:i.push(c),t++,UA.errors=i,!1}var o=E===t}else var o=!0}}}}else return UA.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return UA.errors=i,t===0}var lo={additionalProperties:!1,description:"An example output used to define a scenario for a wallet template.",properties:{lockingBytecode:{$ref:"#/definitions/WalletTemplateScenarioBytecode",description:'The locking bytecode used to encumber this output.\n\n`lockingBytecode` values may be provided as a hexadecimal-encoded string or as an object describing the required compilation. If undefined, defaults to  `{}`, which uses the default values for `script` and `overrides`, respectively.\n\nOnly source outputs may specify a `lockingBytecode` of `["slot"]`; this identifies the source output in which the locking script under test will be placed. (To be valid, every scenario\'s `sourceOutputs` property must have exactly one source output slot and one input slot at the same index.)'},token:{additionalProperties:!1,description:"The CashToken contents of this output. This property is only defined if the output contains one or more tokens. For details, see `CHIP-2022-02-CashTokens`.",properties:{amount:{description:'The number of fungible tokens (of `category`) held in this output.\n\nBecause `Number.MAX_SAFE_INTEGER` (`9007199254740991`) is less than the maximum token amount (`9223372036854775807`), this value may also be provided as a string, e.g. `"9223372036854775807"`.\n\nIf undefined, this defaults to: `0`.',type:["number","string"]},category:{description:"The 32-byte, hexadecimal-encoded token category ID to which the token(s) in this output belong in big-endian byte order. This is the byte order typically seen in block explorers and user interfaces (as opposed to little-endian byte order, which is used in standard P2P network messages).\n\nIf undefined, this defaults to the value: `0000000000000000000000000000000000000000000000000000000000000002`",type:"string"},nft:{additionalProperties:!1,description:"If present, the non-fungible token (NFT) held by this output. If the output does not include a non-fungible token, `undefined`.",properties:{capability:{description:"The capability of this non-fungible token, must be either `minting`, `mutable`, or `none`.\n\nIf undefined, this defaults to: `none`.",enum:["minting","mutable","none"],type:"string"},commitment:{description:'The hex-encoded commitment contents included in the non-fungible token held in this output.\n\nIf undefined, this defaults to: `""` (a zero-length commitment).',type:"string"}},type:"object"}},type:"object"},valueSatoshis:{description:'The value of the output in satoshis, the smallest unit of bitcoin.\n\nIn a valid transaction, this is a positive integer, from `0` to the maximum number of satoshis available to the transaction.\n\nThe maximum number of satoshis in existence is about 1/4 of `Number.MAX_SAFE_INTEGER` (`9007199254740991`), so typically, this value is defined using a `number`. However, this value may also be defined using a 16-character, hexadecimal-encoded `string`, to allow for the full range of the 64-bit unsigned, little-endian integer used to encode `valueSatoshis` in the encoded output format, e.g. `"ffffffffffffffff"`. This is useful for representing scenarios where intentionally excessive values are provided (to ensure an otherwise properly-signed transaction can never be included in the blockchain), e.g. transaction size estimations or off-chain Bitauth signatures.\n\nIf undefined, this defaults to: `0`.',type:["number","string"]}},type:"object"};function Ve(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e)){let l=t;for(let I in e)if(!(I==="lockingBytecode"||I==="token"||I==="valueSatoshis")){return Ve.errors=[{instancePath:A,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:I},message:"must NOT have additional properties"}],!1;break}if(l===t){if(e.lockingBytecode!==void 0){let I=t;yA(e.lockingBytecode,{instancePath:A+"/lockingBytecode",parentData:e,parentDataProperty:"lockingBytecode",rootData:n})||(i=i===null?yA.errors:i.concat(yA.errors),t=i.length);var o=I===t}else var o=!0;if(o){if(e.token!==void 0){let I=e.token,E=t;if(t===E)if(I&&typeof I=="object"&&!Array.isArray(I)){let k=t;for(let U in I)if(!(U==="amount"||U==="category"||U==="nft")){return Ve.errors=[{instancePath:A+"/token",schemaPath:"#/properties/token/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:U},message:"must NOT have additional properties"}],!1;break}if(k===t){if(I.amount!==void 0){let U=I.amount,N=t;if(!(typeof U=="number"&&isFinite(U))&&typeof U!="string")return Ve.errors=[{instancePath:A+"/token/amount",schemaPath:"#/properties/token/properties/amount/type",keyword:"type",params:{type:lo.properties.token.properties.amount.type},message:"must be number,string"}],!1;var s=N===t}else var s=!0;if(s){if(I.category!==void 0){let U=t;if(typeof I.category!="string")return Ve.errors=[{instancePath:A+"/token/category",schemaPath:"#/properties/token/properties/category/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var s=U===t}else var s=!0;if(s)if(I.nft!==void 0){let U=I.nft,N=t;if(t===N)if(U&&typeof U=="object"&&!Array.isArray(U)){let B=t;for(let S in U)if(!(S==="capability"||S==="commitment")){return Ve.errors=[{instancePath:A+"/token/nft",schemaPath:"#/properties/token/properties/nft/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:S},message:"must NOT have additional properties"}],!1;break}if(B===t){if(U.capability!==void 0){let S=U.capability,P=t;if(typeof S!="string")return Ve.errors=[{instancePath:A+"/token/nft/capability",schemaPath:"#/properties/token/properties/nft/properties/capability/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;if(!(S==="minting"||S==="mutable"||S==="none"))return Ve.errors=[{instancePath:A+"/token/nft/capability",schemaPath:"#/properties/token/properties/nft/properties/capability/enum",keyword:"enum",params:{allowedValues:lo.properties.token.properties.nft.properties.capability.enum},message:"must be equal to one of the allowed values"}],!1;var g=P===t}else var g=!0;if(g)if(U.commitment!==void 0){let S=t;if(typeof U.commitment!="string")return Ve.errors=[{instancePath:A+"/token/nft/commitment",schemaPath:"#/properties/token/properties/nft/properties/commitment/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var g=S===t}else var g=!0}}else return Ve.errors=[{instancePath:A+"/token/nft",schemaPath:"#/properties/token/properties/nft/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var s=N===t}else var s=!0}}}else return Ve.errors=[{instancePath:A+"/token",schemaPath:"#/properties/token/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=E===t}else var o=!0;if(o)if(e.valueSatoshis!==void 0){let I=e.valueSatoshis,E=t;if(!(typeof I=="number"&&isFinite(I))&&typeof I!="string")return Ve.errors=[{instancePath:A+"/valueSatoshis",schemaPath:"#/properties/valueSatoshis/type",keyword:"type",params:{type:lo.properties.valueSatoshis.type},message:"must be number,string"}],!1;var o=E===t}else var o=!0}}}else return Ve.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return Ve.errors=i,t===0}function se(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e)){let B=t;for(let S in e)if(!(S==="data"||S==="description"||S==="extends"||S==="name"||S==="sourceOutputs"||S==="transaction")){return se.errors=[{instancePath:A,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:S},message:"must NOT have additional properties"}],!1;break}if(B===t){if(e.data!==void 0){let S=e.data,P=t;if(t===t)if(S&&typeof S=="object"&&!Array.isArray(S)){let y=t;for(let p in S)if(!(p==="bytecode"||p==="currentBlockHeight"||p==="currentBlockTime"||p==="hdKeys"||p==="keys")){return se.errors=[{instancePath:A+"/data",schemaPath:"#/definitions/WalletTemplateScenarioData/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:p},message:"must NOT have additional properties"}],!1;break}if(y===t){if(S.bytecode!==void 0){let p=S.bytecode,C=t;if(t===C)if(p&&typeof p=="object"&&!Array.isArray(p))for(let b in p){let Y=t;if(typeof p[b]!="string")return se.errors=[{instancePath:A+"/data/bytecode/"+b.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScenarioData/properties/bytecode/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=Y===t;if(!o)break}else return se.errors=[{instancePath:A+"/data/bytecode",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/bytecode/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var s=C===t}else var s=!0;if(s){if(S.currentBlockHeight!==void 0){let p=S.currentBlockHeight,C=t;if(!(typeof p=="number"&&isFinite(p)))return se.errors=[{instancePath:A+"/data/currentBlockHeight",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/currentBlockHeight/type",keyword:"type",params:{type:"number"},message:"must be number"}],!1;var s=C===t}else var s=!0;if(s){if(S.currentBlockTime!==void 0){let p=S.currentBlockTime,C=t;if(!(typeof p=="number"&&isFinite(p)))return se.errors=[{instancePath:A+"/data/currentBlockTime",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/currentBlockTime/type",keyword:"type",params:{type:"number"},message:"must be number"}],!1;var s=C===t}else var s=!0;if(s){if(S.hdKeys!==void 0){let p=S.hdKeys,C=t;if(t===C)if(p&&typeof p=="object"&&!Array.isArray(p)){let Y=t;for(let _ in p)if(!(_==="addressIndex"||_==="hdPrivateKeys"||_==="hdPublicKeys")){return se.errors=[{instancePath:A+"/data/hdKeys",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/hdKeys/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:_},message:"must NOT have additional properties"}],!1;break}if(Y===t){if(p.addressIndex!==void 0){let _=p.addressIndex,x=t;if(!(typeof _=="number"&&isFinite(_)))return se.errors=[{instancePath:A+"/data/hdKeys/addressIndex",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/hdKeys/properties/addressIndex/type",keyword:"type",params:{type:"number"},message:"must be number"}],!1;var g=x===t}else var g=!0;if(g){if(p.hdPrivateKeys!==void 0){let _=p.hdPrivateKeys,x=t;if(t===x)if(_&&typeof _=="object"&&!Array.isArray(_))for(let F in _){let O=t;if(typeof _[F]!="string")return se.errors=[{instancePath:A+"/data/hdKeys/hdPrivateKeys/"+F.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScenarioData/properties/hdKeys/properties/hdPrivateKeys/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var l=O===t;if(!l)break}else return se.errors=[{instancePath:A+"/data/hdKeys/hdPrivateKeys",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/hdKeys/properties/hdPrivateKeys/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var g=x===t}else var g=!0;if(g)if(p.hdPublicKeys!==void 0){let _=p.hdPublicKeys,x=t;if(t===x)if(_&&typeof _=="object"&&!Array.isArray(_))for(let F in _){let O=t;if(typeof _[F]!="string")return se.errors=[{instancePath:A+"/data/hdKeys/hdPublicKeys/"+F.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScenarioData/properties/hdKeys/properties/hdPublicKeys/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var I=O===t;if(!I)break}else return se.errors=[{instancePath:A+"/data/hdKeys/hdPublicKeys",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/hdKeys/properties/hdPublicKeys/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var g=x===t}else var g=!0}}}else return se.errors=[{instancePath:A+"/data/hdKeys",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/hdKeys/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var s=C===t}else var s=!0;if(s)if(S.keys!==void 0){let p=S.keys,C=t;if(t===C)if(p&&typeof p=="object"&&!Array.isArray(p)){let Y=t;for(let _ in p)if(_!=="privateKeys"){return se.errors=[{instancePath:A+"/data/keys",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/keys/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:_},message:"must NOT have additional properties"}],!1;break}if(Y===t&&p.privateKeys!==void 0){let _=p.privateKeys;if(t===t)if(_&&typeof _=="object"&&!Array.isArray(_))for(let H in _){let F=t;if(typeof _[H]!="string")return se.errors=[{instancePath:A+"/data/keys/privateKeys/"+H.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScenarioData/properties/keys/properties/privateKeys/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var E=F===t;if(!E)break}else return se.errors=[{instancePath:A+"/data/keys/privateKeys",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/keys/properties/privateKeys/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1}}else return se.errors=[{instancePath:A+"/data/keys",schemaPath:"#/definitions/WalletTemplateScenarioData/properties/keys/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var s=C===t}else var s=!0}}}}}else return se.errors=[{instancePath:A+"/data",schemaPath:"#/definitions/WalletTemplateScenarioData/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var u=P===t}else var u=!0;if(u){if(e.description!==void 0){let S=t;if(typeof e.description!="string")return se.errors=[{instancePath:A+"/description",schemaPath:"#/properties/description/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var u=S===t}else var u=!0;if(u){if(e.extends!==void 0){let S=t;if(typeof e.extends!="string")return se.errors=[{instancePath:A+"/extends",schemaPath:"#/properties/extends/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var u=S===t}else var u=!0;if(u){if(e.name!==void 0){let S=t;if(typeof e.name!="string")return se.errors=[{instancePath:A+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var u=S===t}else var u=!0;if(u){if(e.sourceOutputs!==void 0){let S=e.sourceOutputs,P=t;if(t===P)if(Array.isArray(S)){var k=!0;let y=S.length;for(let p=0;p<y;p++){let C=t;He(S[p],{instancePath:A+"/sourceOutputs/"+p,parentData:S,parentDataProperty:p,rootData:n})||(i=i===null?He.errors:i.concat(He.errors),t=i.length);var k=C===t;if(!k)break}}else return se.errors=[{instancePath:A+"/sourceOutputs",schemaPath:"#/properties/sourceOutputs/type",keyword:"type",params:{type:"array"},message:"must be array"}],!1;var u=P===t}else var u=!0;if(u)if(e.transaction!==void 0){let S=e.transaction,P=t;if(t===P)if(S&&typeof S=="object"&&!Array.isArray(S)){let y=t;for(let p in S)if(!(p==="inputs"||p==="locktime"||p==="outputs"||p==="version")){return se.errors=[{instancePath:A+"/transaction",schemaPath:"#/properties/transaction/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:p},message:"must NOT have additional properties"}],!1;break}if(y===t){if(S.inputs!==void 0){let p=S.inputs,C=t;if(t===C)if(Array.isArray(p)){var U=!0;let b=p.length;for(let Y=0;Y<b;Y++){let _=t;UA(p[Y],{instancePath:A+"/transaction/inputs/"+Y,parentData:p,parentDataProperty:Y,rootData:n})||(i=i===null?UA.errors:i.concat(UA.errors),t=i.length);var U=_===t;if(!U)break}}else return se.errors=[{instancePath:A+"/transaction/inputs",schemaPath:"#/properties/transaction/properties/inputs/type",keyword:"type",params:{type:"array"},message:"must be array"}],!1;var N=C===t}else var N=!0;if(N){if(S.locktime!==void 0){let p=S.locktime,C=t;if(!(typeof p=="number"&&isFinite(p)))return se.errors=[{instancePath:A+"/transaction/locktime",schemaPath:"#/properties/transaction/properties/locktime/type",keyword:"type",params:{type:"number"},message:"must be number"}],!1;var N=C===t}else var N=!0;if(N){if(S.outputs!==void 0){let p=S.outputs,C=t;if(t===C)if(Array.isArray(p)){var c=!0;let Y=p.length;for(let _=0;_<Y;_++){let x=t;Ve(p[_],{instancePath:A+"/transaction/outputs/"+_,parentData:p,parentDataProperty:_,rootData:n})||(i=i===null?Ve.errors:i.concat(Ve.errors),t=i.length);var c=x===t;if(!c)break}}else return se.errors=[{instancePath:A+"/transaction/outputs",schemaPath:"#/properties/transaction/properties/outputs/type",keyword:"type",params:{type:"array"},message:"must be array"}],!1;var N=C===t}else var N=!0;if(N)if(S.version!==void 0){let p=S.version,C=t;if(!(typeof p=="number"&&isFinite(p)))return se.errors=[{instancePath:A+"/transaction/version",schemaPath:"#/properties/transaction/properties/version/type",keyword:"type",params:{type:"number"},message:"must be number"}],!1;var N=C===t}else var N=!0}}}}else return se.errors=[{instancePath:A+"/transaction",schemaPath:"#/properties/transaction/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var u=P===t}else var u=!0}}}}}}else return se.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return se.errors=i,t===0}function ye(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e)){let u;if(e.script===void 0&&(u="script")||e.tests===void 0&&(u="tests"))return ye.errors=[{instancePath:A,schemaPath:"#/required",keyword:"required",params:{missingProperty:u},message:"must have required property '"+u+"'"}],!1;{let k=t;for(let U in e)if(!(U==="name"||U==="pushed"||U==="script"||U==="tests")){return ye.errors=[{instancePath:A,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:U},message:"must NOT have additional properties"}],!1;break}if(k===t){if(e.name!==void 0){let U=t;if(typeof e.name!="string")return ye.errors=[{instancePath:A+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=U===t}else var o=!0;if(o){if(e.pushed!==void 0){let U=t;if(typeof e.pushed!="boolean")return ye.errors=[{instancePath:A+"/pushed",schemaPath:"#/properties/pushed/type",keyword:"type",params:{type:"boolean"},message:"must be boolean"}],!1;var o=U===t}else var o=!0;if(o){if(e.script!==void 0){let U=t;if(typeof e.script!="string")return ye.errors=[{instancePath:A+"/script",schemaPath:"#/properties/script/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=U===t}else var o=!0;if(o)if(e.tests!==void 0){let U=e.tests,N=t;if(t===N)if(U&&typeof U=="object"&&!Array.isArray(U))for(let B in U){let S=U[B],P=t;if(t===t)if(S&&typeof S=="object"&&!Array.isArray(S)){let y;if(S.check===void 0&&(y="check"))return ye.errors=[{instancePath:A+"/tests/"+B.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScriptTest/required",keyword:"required",params:{missingProperty:y},message:"must have required property '"+y+"'"}],!1;{let p=t;for(let C in S)if(!(C==="check"||C==="fails"||C==="invalid"||C==="name"||C==="passes"||C==="setup")){return ye.errors=[{instancePath:A+"/tests/"+B.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScriptTest/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:C},message:"must NOT have additional properties"}],!1;break}if(p===t){if(S.check!==void 0){let C=t;if(typeof S.check!="string")return ye.errors=[{instancePath:A+"/tests/"+B.replace(/~/g,"~0").replace(/\//g,"~1")+"/check",schemaPath:"#/definitions/WalletTemplateScriptTest/properties/check/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var s=C===t}else var s=!0;if(s){if(S.fails!==void 0){let C=S.fails,b=t;if(t===b)if(Array.isArray(C)){var g=!0;let _=C.length;for(let x=0;x<_;x++){let H=t;if(typeof C[x]!="string")return ye.errors=[{instancePath:A+"/tests/"+B.replace(/~/g,"~0").replace(/\//g,"~1")+"/fails/"+x,schemaPath:"#/definitions/WalletTemplateScriptTest/properties/fails/items/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var g=H===t;if(!g)break}}else return ye.errors=[{instancePath:A+"/tests/"+B.replace(/~/g,"~0").replace(/\//g,"~1")+"/fails",schemaPath:"#/definitions/WalletTemplateScriptTest/properties/fails/type",keyword:"type",params:{type:"array"},message:"must be array"}],!1;var s=b===t}else var s=!0;if(s){if(S.invalid!==void 0){let C=S.invalid,b=t;if(t===b)if(Array.isArray(C)){var l=!0;let _=C.length;for(let x=0;x<_;x++){let H=t;if(typeof C[x]!="string")return ye.errors=[{instancePath:A+"/tests/"+B.replace(/~/g,"~0").replace(/\//g,"~1")+"/invalid/"+x,schemaPath:"#/definitions/WalletTemplateScriptTest/properties/invalid/items/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var l=H===t;if(!l)break}}else return ye.errors=[{instancePath:A+"/tests/"+B.replace(/~/g,"~0").replace(/\//g,"~1")+"/invalid",schemaPath:"#/definitions/WalletTemplateScriptTest/properties/invalid/type",keyword:"type",params:{type:"array"},message:"must be array"}],!1;var s=b===t}else var s=!0;if(s){if(S.name!==void 0){let C=t;if(typeof S.name!="string")return ye.errors=[{instancePath:A+"/tests/"+B.replace(/~/g,"~0").replace(/\//g,"~1")+"/name",schemaPath:"#/definitions/WalletTemplateScriptTest/properties/name/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var s=C===t}else var s=!0;if(s){if(S.passes!==void 0){let C=S.passes,b=t;if(t===b)if(Array.isArray(C)){var I=!0;let _=C.length;for(let x=0;x<_;x++){let H=t;if(typeof C[x]!="string")return ye.errors=[{instancePath:A+"/tests/"+B.replace(/~/g,"~0").replace(/\//g,"~1")+"/passes/"+x,schemaPath:"#/definitions/WalletTemplateScriptTest/properties/passes/items/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var I=H===t;if(!I)break}}else return ye.errors=[{instancePath:A+"/tests/"+B.replace(/~/g,"~0").replace(/\//g,"~1")+"/passes",schemaPath:"#/definitions/WalletTemplateScriptTest/properties/passes/type",keyword:"type",params:{type:"array"},message:"must be array"}],!1;var s=b===t}else var s=!0;if(s)if(S.setup!==void 0){let C=t;if(typeof S.setup!="string")return ye.errors=[{instancePath:A+"/tests/"+B.replace(/~/g,"~0").replace(/\//g,"~1")+"/setup",schemaPath:"#/definitions/WalletTemplateScriptTest/properties/setup/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var s=C===t}else var s=!0}}}}}}}else return ye.errors=[{instancePath:A+"/tests/"+B.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScriptTest/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var E=P===t;if(!E)break}else return ye.errors=[{instancePath:A+"/tests",schemaPath:"#/properties/tests/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=N===t}else var o=!0}}}}}else return ye.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return ye.errors=i,t===0}var $u=Object.prototype.hasOwnProperty;function Oe(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e)){let S;if(e.entities===void 0&&(S="entities")||e.scripts===void 0&&(S="scripts")||e.supported===void 0&&(S="supported"))return Oe.errors=[{instancePath:A,schemaPath:"#/required",keyword:"required",params:{missingProperty:S},message:"must have required property '"+S+"'"}],!1;{let P=t;for(let h in e)if(!(h==="$schema"||h==="description"||h==="entities"||h==="name"||h==="scenarios"||h==="scripts"||h==="supported"||h==="version")){return Oe.errors=[{instancePath:A,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:h},message:"must NOT have additional properties"}],!1;break}if(P===t){if(e.$schema!==void 0){let h=t;if(typeof e.$schema!="string")return Oe.errors=[{instancePath:A+"/$schema",schemaPath:"#/properties/%24schema/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=h===t}else var o=!0;if(o){if(e.description!==void 0){let h=t;if(typeof e.description!="string")return Oe.errors=[{instancePath:A+"/description",schemaPath:"#/properties/description/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=h===t}else var o=!0;if(o){if(e.entities!==void 0){let h=e.entities,y=t;if(t===y)if(h&&typeof h=="object"&&!Array.isArray(h))for(let C in h){let b=t;QA(h[C],{instancePath:A+"/entities/"+C.replace(/~/g,"~0").replace(/\//g,"~1"),parentData:h,parentDataProperty:C,rootData:n})||(i=i===null?QA.errors:i.concat(QA.errors),t=i.length);var s=b===t;if(!s)break}else return Oe.errors=[{instancePath:A+"/entities",schemaPath:"#/properties/entities/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=y===t}else var o=!0;if(o){if(e.name!==void 0){let h=t;if(typeof e.name!="string")return Oe.errors=[{instancePath:A+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=h===t}else var o=!0;if(o){if(e.scenarios!==void 0){let h=e.scenarios,y=t;if(t===y)if(h&&typeof h=="object"&&!Array.isArray(h))for(let C in h){let b=t;se(h[C],{instancePath:A+"/scenarios/"+C.replace(/~/g,"~0").replace(/\//g,"~1"),parentData:h,parentDataProperty:C,rootData:n})||(i=i===null?se.errors:i.concat(se.errors),t=i.length);var g=b===t;if(!g)break}else return Oe.errors=[{instancePath:A+"/scenarios",schemaPath:"#/properties/scenarios/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=y===t}else var o=!0;if(o){if(e.scripts!==void 0){let h=e.scripts,y=t;if(t===y)if(h&&typeof h=="object"&&!Array.isArray(h))for(let C in h){let b=h[C],Y=t,_=t,x=!1,H=t;if(t===t)if(b&&typeof b=="object"&&!Array.isArray(b)){let O;if(b.script===void 0&&(O="script")){let D={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScript/required",keyword:"required",params:{missingProperty:O},message:"must have required property '"+O+"'"};i===null?i=[D]:i.push(D),t++}else{let D=t;for(let G in b)if(!(G==="name"||G==="script")){let K={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScript/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:G},message:"must NOT have additional properties"};i===null?i=[K]:i.push(K),t++;break}if(D===t){if(b.name!==void 0){let G=t;if(typeof b.name!="string"){let K={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/name",schemaPath:"#/definitions/WalletTemplateScript/properties/name/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[K]:i.push(K),t++}var l=G===t}else var l=!0;if(l)if(b.script!==void 0){let G=t;if(typeof b.script!="string"){let V={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/script",schemaPath:"#/definitions/WalletTemplateScript/properties/script/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[V]:i.push(V),t++}var l=G===t}else var l=!0}}}else{let O={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScript/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[O]:i.push(O),t++}var I=H===t;if(x=x||I,!x){let O=t;if(t===t)if(b&&typeof b=="object"&&!Array.isArray(b)){let K;if(b.lockingType===void 0&&(K="lockingType")||b.script===void 0&&(K="script")){let V={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScriptLocking/required",keyword:"required",params:{missingProperty:K},message:"must have required property '"+K+"'"};i===null?i=[V]:i.push(V),t++}else{let V=t;for(let L in b)if(!(L==="lockingType"||L==="name"||L==="script")){let Pe={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScriptLocking/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:L},message:"must NOT have additional properties"};i===null?i=[Pe]:i.push(Pe),t++;break}if(V===t){if(b.lockingType!==void 0){let L=b.lockingType,Pe=t;if(typeof L!="string"){let Fe={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/lockingType",schemaPath:"#/definitions/WalletTemplateScriptLocking/properties/lockingType/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[Fe]:i.push(Fe),t++}if(!(L==="p2sh20"||L==="p2sh32"||L==="standard")){let Fe={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/lockingType",schemaPath:"#/definitions/WalletTemplateScriptLocking/properties/lockingType/enum",keyword:"enum",params:{allowedValues:Zu.properties.lockingType.enum},message:"must be equal to one of the allowed values"};i===null?i=[Fe]:i.push(Fe),t++}var E=Pe===t}else var E=!0;if(E){if(b.name!==void 0){let L=t;if(typeof b.name!="string"){let Fe={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/name",schemaPath:"#/definitions/WalletTemplateScriptLocking/properties/name/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[Fe]:i.push(Fe),t++}var E=L===t}else var E=!0;if(E)if(b.script!==void 0){let L=t;if(typeof b.script!="string"){let Fe={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/script",schemaPath:"#/definitions/WalletTemplateScriptLocking/properties/script/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[Fe]:i.push(Fe),t++}var E=L===t}else var E=!0}}}}else{let K={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScriptLocking/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[K]:i.push(K),t++}var I=O===t;if(x=x||I,!x){let K=t;ye(b,{instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1"),parentData:h,parentDataProperty:C,rootData:n})||(i=i===null?ye.errors:i.concat(ye.errors),t=i.length);var I=K===t;if(x=x||I,!x){let L=t;if(t===t)if(b&&typeof b=="object"&&!Array.isArray(b)){let Ne;if(b.script===void 0&&(Ne="script")||b.unlocks===void 0&&(Ne="unlocks")){let JA={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScriptUnlocking/required",keyword:"required",params:{missingProperty:Ne},message:"must have required property '"+Ne+"'"};i===null?i=[JA]:i.push(JA),t++}else{let JA=t;for(let ne in b)if(!$u.call(EI.properties,ne)){let Ke={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScriptUnlocking/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:ne},message:"must NOT have additional properties"};i===null?i=[Ke]:i.push(Ke),t++;break}if(JA===t){if(b.ageLock!==void 0){let ne=t;if(typeof b.ageLock!="string"){let Ke={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/ageLock",schemaPath:"#/definitions/WalletTemplateScriptUnlocking/properties/ageLock/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[Ke]:i.push(Ke),t++}var u=ne===t}else var u=!0;if(u){if(b.estimate!==void 0){let ne=t;if(typeof b.estimate!="string"){let eA={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/estimate",schemaPath:"#/definitions/WalletTemplateScriptUnlocking/properties/estimate/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[eA]:i.push(eA),t++}var u=ne===t}else var u=!0;if(u){if(b.fails!==void 0){let ne=b.fails,Ke=t;if(t===Ke)if(Array.isArray(ne)){var k=!0;let Se=ne.length;for(let Je=0;Je<Se;Je++){let LA=t;if(typeof ne[Je]!="string"){let J={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/fails/"+Je,schemaPath:"#/definitions/WalletTemplateScriptUnlocking/properties/fails/items/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[J]:i.push(J),t++}var k=LA===t;if(!k)break}}else{let Se={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/fails",schemaPath:"#/definitions/WalletTemplateScriptUnlocking/properties/fails/type",keyword:"type",params:{type:"array"},message:"must be array"};i===null?i=[Se]:i.push(Se),t++}var u=Ke===t}else var u=!0;if(u){if(b.invalid!==void 0){let ne=b.invalid,Ke=t;if(t===Ke)if(Array.isArray(ne)){var U=!0;let Se=ne.length;for(let Je=0;Je<Se;Je++){let LA=t;if(typeof ne[Je]!="string"){let J={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/invalid/"+Je,schemaPath:"#/definitions/WalletTemplateScriptUnlocking/properties/invalid/items/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[J]:i.push(J),t++}var U=LA===t;if(!U)break}}else{let Se={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/invalid",schemaPath:"#/definitions/WalletTemplateScriptUnlocking/properties/invalid/type",keyword:"type",params:{type:"array"},message:"must be array"};i===null?i=[Se]:i.push(Se),t++}var u=Ke===t}else var u=!0;if(u){if(b.name!==void 0){let ne=t;if(typeof b.name!="string"){let eA={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/name",schemaPath:"#/definitions/WalletTemplateScriptUnlocking/properties/name/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[eA]:i.push(eA),t++}var u=ne===t}else var u=!0;if(u){if(b.passes!==void 0){let ne=b.passes,Ke=t;if(t===Ke)if(Array.isArray(ne)){var N=!0;let Se=ne.length;for(let Je=0;Je<Se;Je++){let LA=t;if(typeof ne[Je]!="string"){let J={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/passes/"+Je,schemaPath:"#/definitions/WalletTemplateScriptUnlocking/properties/passes/items/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[J]:i.push(J),t++}var N=LA===t;if(!N)break}}else{let Se={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/passes",schemaPath:"#/definitions/WalletTemplateScriptUnlocking/properties/passes/type",keyword:"type",params:{type:"array"},message:"must be array"};i===null?i=[Se]:i.push(Se),t++}var u=Ke===t}else var u=!0;if(u){if(b.script!==void 0){let ne=t;if(typeof b.script!="string"){let eA={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/script",schemaPath:"#/definitions/WalletTemplateScriptUnlocking/properties/script/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[eA]:i.push(eA),t++}var u=ne===t}else var u=!0;if(u){if(b.timeLockType!==void 0){let ne=b.timeLockType,Ke=t;if(typeof ne!="string"){let Se={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/timeLockType",schemaPath:"#/definitions/WalletTemplateScriptUnlocking/properties/timeLockType/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[Se]:i.push(Se),t++}if(!(ne==="height"||ne==="timestamp")){let Se={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/timeLockType",schemaPath:"#/definitions/WalletTemplateScriptUnlocking/properties/timeLockType/enum",keyword:"enum",params:{allowedValues:EI.properties.timeLockType.enum},message:"must be equal to one of the allowed values"};i===null?i=[Se]:i.push(Se),t++}var u=Ke===t}else var u=!0;if(u)if(b.unlocks!==void 0){let ne=t;if(typeof b.unlocks!="string"){let eA={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/unlocks",schemaPath:"#/definitions/WalletTemplateScriptUnlocking/properties/unlocks/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[eA]:i.push(eA),t++}var u=ne===t}else var u=!0}}}}}}}}}}else{let Ne={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/WalletTemplateScriptUnlocking/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[Ne]:i.push(Ne),t++}var I=L===t;x=x||I}}}if(x)t=_,i!==null&&(_?i.length=_:i=null);else{let O={instancePath:A+"/scripts/"+C.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/properties/scripts/additionalProperties/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};return i===null?i=[O]:i.push(O),t++,Oe.errors=i,!1}var c=Y===t;if(!c)break}else return Oe.errors=[{instancePath:A+"/scripts",schemaPath:"#/properties/scripts/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=y===t}else var o=!0;if(o){if(e.supported!==void 0){let h=e.supported,y=t;if(t===y)if(Array.isArray(h)){var B=!0;let C=h.length;for(let b=0;b<C;b++){let Y=h[b],_=t;if(typeof Y!="string")return Oe.errors=[{instancePath:A+"/supported/"+b,schemaPath:"#/definitions/AuthenticationVirtualMachineIdentifier/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;if(!(Y==="BCH_2020_05"||Y==="BCH_2021_05"||Y==="BCH_2022_05"||Y==="BCH_2023_05"||Y==="BCH_SPEC"||Y==="BSV_2020_02"||Y==="BSV_SPEC"||Y==="BTC_2017_08"||Y==="BTC_SPEC"||Y==="XEC_2020_05"||Y==="XEC_SPEC"))return Oe.errors=[{instancePath:A+"/supported/"+b,schemaPath:"#/definitions/AuthenticationVirtualMachineIdentifier/enum",keyword:"enum",params:{allowedValues:Xu.enum},message:"must be equal to one of the allowed values"}],!1;var B=_===t;if(!B)break}}else return Oe.errors=[{instancePath:A+"/supported",schemaPath:"#/properties/supported/type",keyword:"type",params:{type:"array"},message:"must be array"}],!1;var o=y===t}else var o=!0;if(o)if(e.version!==void 0){let h=e.version,y=t;if(!(typeof h=="number"&&isFinite(h)))return Oe.errors=[{instancePath:A+"/version",schemaPath:"#/properties/version/type",keyword:"type",params:{type:"number"},message:"must be number"}],!1;if(h!==0)return Oe.errors=[{instancePath:A+"/version",schemaPath:"#/properties/version/const",keyword:"const",params:{allowedValue:0},message:"must be equal to constant"}],!1;var o=y===t}else var o=!0}}}}}}}}}else return Oe.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return Oe.errors=i,t===0}function BI(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;return Oe(e,{instancePath:A,parentData:a,parentDataProperty:r,rootData:n})||(i=i===null?Oe.errors:i.concat(Oe.errors),t=i.length),BI.errors=i,t===0}var eh=e=>e.map(A=>`${A.instancePath}: ${A.message}`).join(","),Fr=(e,A)=>{try{let a=typeof e=="string"?e:JSON.stringify(e),r=za(a),n=JSON.parse(r);return A(n)?n:eh(Rr.errors)}catch(a){return`Invalid JSON. ${String(a)}`}};var mI=yI;var Ah={additionalProperties:!1,description:"A Bitcoin Cash Metadata Registry is an authenticated JSON file containing metadata about tokens, identities, contract applications, and other on-chain artifacts. BCMRs conform to the Bitcoin Cash Metadata Registry JSON Schema, and they can be published and maintained by any entity or individual.",properties:{$schema:{description:"The schema used by this registry. Many JSON editors can automatically provide inline documentation and autocomplete support using the `$schema` property, so it is recommended that registries include it. E.g.: `https://cashtokens.org/bcmr-v2.schema.json`",type:"string"},chains:{additionalProperties:{$ref:"#/definitions/ChainHistory"},description:`A map of split IDs tracked by this registry to the  {@link  ChainHistory }  for that chain/network.

The split ID of a chain is the block header hash (A.K.A. block ID) of the first unique block after the most recent tracked split \u2013 a split after which both resulting chains are considered notable or tracked by the registry. (For chains with no such splits, this is the ID of the genesis block.)

Note, split ID is inherently a "relative" identifier. After a tracked split, both resulting chains will have a new split ID. However, if a wallet has not yet heard about a particular split, that wallet will continue to reference one of the resulting chains by its previous split ID, and the split-unaware wallet may create transactions that are valid on both chains (losing claimable value if the receivers of their transactions don't acknowledge transfers on both chains). When a registry trusted by the wallet notes the split in it's \`chains\` map, the wallet can represent the split in the user interface using the the latest  {@link  ChainSnapshot }  for each chain and splitting coins prior to spending (by introducing post-split coins in each transaction).

This map may exclude the following well-known split IDs (all clients supporting any of these chains should build-in  {@link  ChainHistory }  for those chains):

- \`0000000000000000029e471c41818d24b8b74c911071c4ef0b4a0509f9b5a8ce\`:   A.K.A. mainnet \u2013 the BCH side of the BCH/XEC split.
- \`00000000ae25e85d9e22cd6c8d72c2f5d4b0222289d801b7f633aeae3f8c6367\`:   A.K.A testnet4 \u2013 the test network on which CHIPs are activated   simultaneously with mainnet (May 15 at 12 UTC).
- \`00000000040ba9641ba98a37b2e5ceead38e4e2930ac8f145c8094f94c708727\`:   A.K.A. chipnet \u2013 the test network on which CHIPs are activated 6 months   before mainnet (November 15 at 12 UTC).

All other split IDs referenced by this registry should be included in this map.`,type:"object"},defaultChain:{description:'The split ID of the chain/network considered the "default" chain for this registry. Identities that do not specify a  {@link  IdentitySnapshot.splitId }  are assumed to be set to this split ID. For a description of split IDs, see  {@link  MetadataRegistry.chains } .\n\nIf not provided, the `defaultChain` is `0000000000000000029e471c41818d24b8b74c911071c4ef0b4a0509f9b5a8ce`, the BCH side of the BCH/XEC split (mainnet). Common values include:\n- `00000000ae25e85d9e22cd6c8d72c2f5d4b0222289d801b7f633aeae3f8c6367` (testnet4)\n- `00000000040ba9641ba98a37b2e5ceead38e4e2930ac8f145c8094f94c708727` (chipnet)',type:"string"},extensions:{$ref:"#/definitions/Extensions",description:"A mapping of `Registry` extension identifiers to extension definitions.  {@link  Extensions }  may be widely standardized or application-specific.\n\nStandardized extensions for `Registry`s include the `locale` extension. See https://github.com/bitjson/chip-bcmr#locales-extension for details."},identities:{additionalProperties:{$ref:"#/definitions/IdentityHistory"},description:`A mapping of authbases to the \`IdentityHistory\` for that identity.

An authbase is a 32-byte, hex-encoded transaction hash (A.K.A. TXID) for which the zeroth-descendant transaction chain (ZDTC) authenticates and publishes an identity's claimed metadata.

Identities may represent metadata registries, specific types of tokens, companies, organizations, individuals, or other on-chain entities.`,type:"object"},latestRevision:{description:"The timestamp of the latest revision made to this registry version. The timestamp must be provided in simplified extended ISO 8601 format, a 24-character string of format `YYYY-MM-DDTHH:mm:ss.sssZ` where timezone is zero UTC (denoted by `Z`). Note, this is the format returned by ECMAScript `Date.toISOString()`.",type:"string"},license:{description:"The license under which this registry is published. This may be specified as either a SPDX short identifier (https://spdx.org/licenses/) or by including the full text of the license.\n\nCommon values include:  - `CC0-1.0`: https://creativecommons.org/publicdomain/zero/1.0/  - `MIT`: https://opensource.org/licenses/MIT",type:"string"},registryIdentity:{anyOf:[{$ref:"#/definitions/OffChainRegistryIdentity"},{type:"string"}],description:"The identity information of this particular registry, provided as either an authbase (recommended) or an `IdentitySnapshot`.\n\nAn authbase is a 32-byte, hex-encoded transaction hash (A.K.A. TXID) for which the zeroth-descendant transaction chain (ZDTC) authenticates and publishes all registry updates. If an authbase is provided, the registry's identity information can be found in `identities[authbase]`, and clients should immediately attempt to verify the registry's identity on-chain. (See https://github.com/bitjson/chip-bcmr#chain-resolved-registries)\n\nIf an `IdentitySnapshot` is provided directly, this registry does not support on-chain resolution/authentication, and the contained `IdentitySnapshot` can only be authenticated via DNS/HTTPS."},tags:{additionalProperties:{$ref:"#/definitions/Tag"},description:"A map of registry-specific `Tag`s used by this registry to convey information about identities it tracks.\n\nTags allow registries to group identities into collections of related identities, marking characteristics or those identities. Tags are standardized within a registry and may represent either labels applied by that registry (e.g. `individual`, `organization`, `token`, `wallet`, `exchange`, `staking`, `utility-token`, `security-token`, `stablecoin`, `wrapped`, `collectable`, `deflationary`, `governance`, `decentralized-exchange`, `liquidity-provider`, `sidechain`, `sidechain-bridge`, etc.) or designations by external authorities (certification, membership, ownership, etc.) that are tracked by that registry.\n\nTags may be used by clients in search, discover, and filtering of identities, and they can also convey information like accreditation from investor protection organizations, public certifications by security or financial auditors, and other designations that signal legitimacy and value to users.",type:"object"},version:{additionalProperties:!1,description:"The version of this registry. Versioning adheres to Semantic Versioning (https://semver.org/).",properties:{major:{description:"The major version is incremented when an identity is removed.",type:"number"},minor:{description:"The minor version is incremented when an identity is added or a new identity snapshot is added.",type:"number"},patch:{description:"The patch version is incremented when an existing identity or identity snapshot is modified (e.g. to correct an error or add a missing piece of information) or when other registry properties (e.g. registry `name`, `description`, `uris`, etc.) are modified.\n\nGenerally, substantive changes to an existing identity should be made using a new identity snapshot in a minor version upgrade \u2013 this allows clients to provide a better user experience by noting the change in relevant user interfaces.\n\nFor example, patch upgrades might include spelling corrections in an existing snapshot or the addition of an `icon` containing a higher-resolution version of an existing `icon` image. On the other hand, a rebranding in which the icon is substantially changed may warrant a new identity snapshot to be added in a minor version upgrade.",type:"number"}},required:["major","minor","patch"],type:"object"}},required:["version","latestRevision","registryIdentity"],type:"object"};var QI=Object.prototype.hasOwnProperty;var th={additionalProperties:!1,description:"A snapshot of the metadata for a particular chain/network at a specific time. This allows for registries to provide similar metadata for each chain's native currency unit (name, description, symbol, icon, etc.) as can be provided for other registered tokens.",properties:{description:{description:"A string describing this identity for use in user interfaces.\n\nIn user interfaces with limited space, descriptions should be hidden beyond the first newline character or `140` characters until revealed by the user.\n\nE.g.:\n- `The common stock issued by ACME, Inc.`\n- `A metadata registry maintained by Company Name, the embedded registry for Wallet Name.`\n- `Software developer and lead maintainer of Wallet Name.`",type:"string"},extensions:{$ref:"#/definitions/Extensions",description:"A mapping of `IdentitySnapshot` extension identifiers to extension definitions.  {@link  Extensions }  may be widely standardized or application-specific.\n\nStandardized extensions for `IdentitySnapshot`s include the `authchain` extension. See https://github.com/bitjson/chip-bcmr#authchain-extension for details."},name:{description:"The name of this identity for use in interfaces.\n\nIn user interfaces with limited space, names should be hidden beyond the first newline character or `20` characters until revealed by the user.\n\nE.g. `ACME Class A Shares`, `ACME Registry`, `Satoshi Nakamoto`, etc.",type:"string"},splitId:{description:`The split ID of this identity's chain of record.

If undefined, defaults to  {@link  MetadataRegistry.defaultChain } .`,type:"string"},status:{description:"The status of this identity, must be `active`, `inactive`, or `burned`. If omitted, defaults to `active`.\n- Identities with an `active` status should be actively tracked by clients.\n- Identities with an `inactive` status may be considered for archival by clients and may be removed in future registry versions.\n- Identities with a `burned` status have been destroyed by setting the latest identity output to a data-carrier output (`OP_RETURN`), permanently terminating the authchain. Clients should archive burned identities and \u2013 if the burned identity represented a token type \u2013 consider burning any remaining tokens of that category to reclaim funds from those outputs.",enum:["active","burned","inactive"],type:"string"},tags:{description:"An array of `Tag` identifiers marking the `Tag`s associated with this identity. All specified tag identifiers must be defined in the registry's `tags` mapping.",items:{type:"string"},type:"array"},token:{additionalProperties:!1,description:"A data structure indicating how the chain's native currency units should be displayed in user interfaces.",properties:{decimals:{description:"An integer between `0` and `18` (inclusive) indicating the divisibility of the primary unit of this native currency.\n\nThis is the number of digits that can appear after the decimal separator in currency amounts. For a currency with a `symbol` of `SYMBOL` and a `decimals` of `2`, an amount of `12345` should be displayed as `123.45 SYMBOL`.\n\nIf omitted, defaults to `0`.",type:"number"},symbol:{description:"An abbreviation used to uniquely identity this native currency unit.\n\nSymbols must be comprised only of capital letters, numbers, and dashes (`-`). This can be validated with the regular expression: `/^[-A-Z0-9]+$/`.",type:"string"}},required:["symbol"],type:"object"},uris:{$ref:"#/definitions/URIs",description:"A mapping of identifiers to URIs associated with this identity. URI identifiers may be widely-standardized or registry-specific. Values must be valid URIs, including a protocol prefix (e.g. `https://` or `ipfs://`). Clients are only required to support `https` and `ipfs` URIs, but any scheme may be specified.\n\nThe following identifiers are recommended for all identities:\n- `icon`\n- `web`\n\nThe following optional identifiers are standardized:\n- `blog`\n- `chat`\n- `forum`\n- `icon-intro`\n- `image`\n- `migrate`\n- `registry`\n- `support`\n\nFor details on these standard identifiers, see: https://github.com/bitjson/chip-bcmr#uri-identifiers\n\nCustom URI identifiers allow for sharing social networking profiles, p2p connection information, and other application-specific URIs. Identifiers must be lowercase, alphanumeric strings, with no whitespace or special characters other than dashes (as a regular expression: `/^[-a-z0-9]+$/`).\n\nFor example, some common identifiers include: `discord`, `docker`, `facebook`, `git`, `github`, `gitter`, `instagram`, `linkedin`, `matrix`, `npm`, `reddit`, `slack`, `substack`, `telegram`, `twitter`, `wechat`, `youtube`."}},required:["name","token"],type:"object"};function fe(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e)){let N;if(e.name===void 0&&(N="name")||e.token===void 0&&(N="token"))return fe.errors=[{instancePath:A,schemaPath:"#/required",keyword:"required",params:{missingProperty:N},message:"must have required property '"+N+"'"}],!1;{let c=t;for(let B in e)if(!(B==="description"||B==="extensions"||B==="name"||B==="splitId"||B==="status"||B==="tags"||B==="token"||B==="uris")){return fe.errors=[{instancePath:A,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:B},message:"must NOT have additional properties"}],!1;break}if(c===t){if(e.description!==void 0){let B=t;if(typeof e.description!="string")return fe.errors=[{instancePath:A+"/description",schemaPath:"#/properties/description/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=B===t}else var o=!0;if(o){if(e.extensions!==void 0){let B=e.extensions,S=t;if(t===t)if(B&&typeof B=="object"&&!Array.isArray(B))for(let y in B){let p=B[y],C=t,b=t,Y=!1,_=t;if(typeof p!="string"){let x={instancePath:A+"/extensions/"+y.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/0/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[x]:i.push(x),t++}var s=_===t;if(Y=Y||s,!Y){let x=t;if(t===x)if(p&&typeof p=="object"&&!Array.isArray(p))for(let F in p){let O=t;if(typeof p[F]!="string"){let D={instancePath:A+"/extensions/"+y.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+F.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/1/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[D]:i.push(D),t++}var g=O===t;if(!g)break}else{let F={instancePath:A+"/extensions/"+y.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/1/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[F]:i.push(F),t++}var s=x===t;if(Y=Y||s,!Y){let F=t;if(t===F)if(p&&typeof p=="object"&&!Array.isArray(p))for(let D in p){let G=p[D],K=t;if(t===K)if(G&&typeof G=="object"&&!Array.isArray(G))for(let V in G){let L=t;if(typeof G[V]!="string"){let Pe={instancePath:A+"/extensions/"+y.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+D.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+V.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/additionalProperties/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[Pe]:i.push(Pe),t++}var l=L===t;if(!l)break}else{let V={instancePath:A+"/extensions/"+y.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+D.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/additionalProperties/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[V]:i.push(V),t++}var I=K===t;if(!I)break}else{let D={instancePath:A+"/extensions/"+y.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[D]:i.push(D),t++}var s=F===t;Y=Y||s}}if(Y)t=b,i!==null&&(b?i.length=b:i=null);else{let x={instancePath:A+"/extensions/"+y.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};return i===null?i=[x]:i.push(x),t++,fe.errors=i,!1}var E=C===t;if(!E)break}else return fe.errors=[{instancePath:A+"/extensions",schemaPath:"#/definitions/Extensions/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=S===t}else var o=!0;if(o){if(e.name!==void 0){let B=t;if(typeof e.name!="string")return fe.errors=[{instancePath:A+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=B===t}else var o=!0;if(o){if(e.splitId!==void 0){let B=t;if(typeof e.splitId!="string")return fe.errors=[{instancePath:A+"/splitId",schemaPath:"#/properties/splitId/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=B===t}else var o=!0;if(o){if(e.status!==void 0){let B=e.status,S=t;if(typeof B!="string")return fe.errors=[{instancePath:A+"/status",schemaPath:"#/properties/status/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;if(!(B==="active"||B==="burned"||B==="inactive"))return fe.errors=[{instancePath:A+"/status",schemaPath:"#/properties/status/enum",keyword:"enum",params:{allowedValues:th.properties.status.enum},message:"must be equal to one of the allowed values"}],!1;var o=S===t}else var o=!0;if(o){if(e.tags!==void 0){let B=e.tags,S=t;if(t===S)if(Array.isArray(B)){var u=!0;let h=B.length;for(let y=0;y<h;y++){let p=t;if(typeof B[y]!="string")return fe.errors=[{instancePath:A+"/tags/"+y,schemaPath:"#/properties/tags/items/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var u=p===t;if(!u)break}}else return fe.errors=[{instancePath:A+"/tags",schemaPath:"#/properties/tags/type",keyword:"type",params:{type:"array"},message:"must be array"}],!1;var o=S===t}else var o=!0;if(o){if(e.token!==void 0){let B=e.token,S=t;if(t===S)if(B&&typeof B=="object"&&!Array.isArray(B)){let h;if(B.symbol===void 0&&(h="symbol"))return fe.errors=[{instancePath:A+"/token",schemaPath:"#/properties/token/required",keyword:"required",params:{missingProperty:h},message:"must have required property '"+h+"'"}],!1;{let y=t;for(let p in B)if(!(p==="decimals"||p==="symbol")){return fe.errors=[{instancePath:A+"/token",schemaPath:"#/properties/token/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:p},message:"must NOT have additional properties"}],!1;break}if(y===t){if(B.decimals!==void 0){let p=B.decimals,C=t;if(!(typeof p=="number"&&isFinite(p)))return fe.errors=[{instancePath:A+"/token/decimals",schemaPath:"#/properties/token/properties/decimals/type",keyword:"type",params:{type:"number"},message:"must be number"}],!1;var k=C===t}else var k=!0;if(k)if(B.symbol!==void 0){let p=t;if(typeof B.symbol!="string")return fe.errors=[{instancePath:A+"/token/symbol",schemaPath:"#/properties/token/properties/symbol/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var k=p===t}else var k=!0}}}else return fe.errors=[{instancePath:A+"/token",schemaPath:"#/properties/token/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=S===t}else var o=!0;if(o)if(e.uris!==void 0){let B=e.uris,S=t;if(t===t)if(B&&typeof B=="object"&&!Array.isArray(B))for(let y in B){let p=t;if(typeof B[y]!="string")return fe.errors=[{instancePath:A+"/uris/"+y.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/URIs/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var U=p===t;if(!U)break}else return fe.errors=[{instancePath:A+"/uris",schemaPath:"#/definitions/URIs/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=S===t}else var o=!0}}}}}}}}}else return fe.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return fe.errors=i,t===0}function xa(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e))for(let s in e){let g=t;fe(e[s],{instancePath:A+"/"+s.replace(/~/g,"~0").replace(/\//g,"~1"),parentData:e,parentDataProperty:s,rootData:n})||(i=i===null?fe.errors:i.concat(fe.errors),t=i.length);var o=g===t;if(!o)break}else return xa.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return xa.errors=i,t===0}var pI={additionalProperties:!1,description:"A snapshot of the metadata for a particular identity at a specific time.",properties:{description:{description:"A string describing this identity for use in user interfaces.\n\nIn user interfaces with limited space, descriptions should be hidden beyond the first newline character or `140` characters until revealed by the user.\n\nE.g.:\n- `The common stock issued by ACME, Inc.`\n- `A metadata registry maintained by Company Name, the embedded registry for Wallet Name.`\n- `Software developer and lead maintainer of Wallet Name.`",type:"string"},extensions:{$ref:"#/definitions/Extensions",description:"A mapping of `IdentitySnapshot` extension identifiers to extension definitions.  {@link  Extensions }  may be widely standardized or application-specific.\n\nStandardized extensions for `IdentitySnapshot`s include the `authchain` extension. See https://github.com/bitjson/chip-bcmr#authchain-extension for details."},migrated:{description:"The timestamp at which this identity snapshot is fully in effect. This value should only be provided if the snapshot takes effect over a period of time (e.g. an in-circulation token identity is gradually migrating to a new category). In these cases, clients should gradually migrate to using the new information beginning after the identity snapshot's timestamp and the `migrated` time.\n\nThis timestamp must be provided in simplified extended ISO 8601 format, a 24-character string of format `YYYY-MM-DDTHH:mm:ss.sssZ` where timezone is zero UTC (denoted by `Z`). Note, this is the format returned by ECMAScript `Date.toISOString()`.",type:"string"},name:{description:"The name of this identity for use in interfaces.\n\nIn user interfaces with limited space, names should be hidden beyond the first newline character or `20` characters until revealed by the user.\n\nE.g. `ACME Class A Shares`, `ACME Registry`, `Satoshi Nakamoto`, etc.",type:"string"},splitId:{description:`The split ID of this identity's chain of record.

If undefined, defaults to  {@link  MetadataRegistry.defaultChain } .`,type:"string"},status:{description:"The status of this identity, must be `active`, `inactive`, or `burned`. If omitted, defaults to `active`.\n- Identities with an `active` status should be actively tracked by clients.\n- Identities with an `inactive` status may be considered for archival by clients and may be removed in future registry versions.\n- Identities with a `burned` status have been destroyed by setting the latest identity output to a data-carrier output (`OP_RETURN`), permanently terminating the authchain. Clients should archive burned identities and \u2013 if the burned identity represented a token type \u2013 consider burning any remaining tokens of that category to reclaim funds from those outputs.",enum:["active","burned","inactive"],type:"string"},tags:{description:"An array of `Tag` identifiers marking the `Tag`s associated with this identity. All specified tag identifiers must be defined in the registry's `tags` mapping.",items:{type:"string"},type:"array"},token:{$ref:"#/definitions/TokenCategory",description:"If this identity is a type of token, a data structure indicating how tokens should be understood and displayed in user interfaces. Omitted for non-token identities."},uris:{$ref:"#/definitions/URIs",description:"A mapping of identifiers to URIs associated with this identity. URI identifiers may be widely-standardized or registry-specific. Values must be valid URIs, including a protocol prefix (e.g. `https://` or `ipfs://`). Clients are only required to support `https` and `ipfs` URIs, but any scheme may be specified.\n\nThe following identifiers are recommended for all identities:\n- `icon`\n- `web`\n\nThe following optional identifiers are standardized:\n- `blog`\n- `chat`\n- `forum`\n- `icon-intro`\n- `image`\n- `migrate`\n- `registry`\n- `support`\n\nFor details on these standard identifiers, see: https://github.com/bitjson/chip-bcmr#uri-identifiers\n\nCustom URI identifiers allow for sharing social networking profiles, p2p connection information, and other application-specific URIs. Identifiers must be lowercase, alphanumeric strings, with no whitespace or special characters other than dashes (as a regular expression: `/^[-a-z0-9]+$/`).\n\nFor example, some common identifiers include: `discord`, `docker`, `facebook`, `git`, `github`, `gitter`, `instagram`, `linkedin`, `matrix`, `npm`, `reddit`, `slack`, `substack`, `telegram`, `twitter`, `wechat`, `youtube`."}},required:["name"],type:"object"};var ih={additionalProperties:{additionalProperties:!1,properties:{description:{description:"A string describing how this identity uses NFTs (for use in user interfaces). Descriptions longer than `160` characters may be elided in some interfaces.\n\nE.g.:\n- `The BCH value pledged at the time this receipt was issued.`\n- `The number of tokens sold in this order.`\n- `The seat number associated with this ticket.`",type:"string"},encoding:{anyOf:[{additionalProperties:!1,properties:{type:{enum:["binary","boolean","hex","https-url","ipfs-cid","utf8","locktime"],type:"string"}},required:["type"],type:"object"},{additionalProperties:!1,properties:{aggregate:{const:"add",description:"The `aggregate` property indicates that aggregating this field from multiple NFTs is desirable in user interfaces. For example, for a field named `BCH Pledged` where `aggregate` is `add`, the client can display a `Total BCH Pledged` in any user interface listing more than one NFT.\n\nIf specified, clients should aggregate the field from all NFTs, of all NFT types within the category, within a particular view (e.g. NFTs held by a single wallet, NFTs existing in a single transaction's outputs, etc.) using the specified operation.\n\nNote, while aggregation could be performed using any commutative operation \u2013 multiplication, bitwise AND, bitwise OR, bitwise XOR, etc. \u2013 only `add` is currently supported.",type:"string"},decimals:{description:"An integer between `0` and `18` (inclusive) indicating the divisibility of the primary unit of this token field.\n\nThis is the number of digits that can appear after the decimal separator in amounts. For a field with a `decimals` of `2`, a value of `123456` should be displayed as `1234.56`.\n\nIf omitted, defaults to `0`.",type:"number"},type:{const:"number",type:"string"},unit:{description:"The unit in which this field is denominated, taking the `decimals` value into account. If representing fungible token amount, this will often be the symbol of the represented token category.\n\nE.g. `BCH`, `sats`, `AcmeUSD`, etc.\n\nIf not provided, clients should not represent this field as having a unit beyond the field's `name`.",type:"string"}},required:["type"],type:"object"}],description:"The expected encoding of this field when read from the parsing altstack (see  {@link  ParsableNftCollection } ). All encoding definitions must have a `type`, and some encoding definitions allow for additional hinting about display strategies in clients.\n\nEncoding types may be set to `binary`, `boolean`, `hex`, `number`, or `utf8`:\n\n- `binary` types should be displayed as binary literals (e.g. `0b0101`)\n- `boolean` types should be displayed as `true` if exactly `0x01` or `false` if exactly `0x00`. If a boolean value does not match one of these values, clients should represent the NFT as unable to be parsed (e.g. simply display the full `commitment`).\n- `hex` types should be displayed as hex literals (e.g.`0xabcd`).\n- `https-url` types are percent encoded with the `https://` prefix omitted; they may be displayed as URIs or as activatable links.\n- `ipfs-cid` types are binary-encoded IPFS Content Identifiers; they may be displayed as URIs or as activatable links.\n- `locktime` types are `OP_TXLOCKTIME` results: integers from `0` to `4294967295` (inclusive) where values less than `500000000` are understood to be a block height (the current block number in the chain, beginning from block `0`), and values greater than or equal to `500000000` are understood to be a Median Time Past (BIP113) UNIX timestamp. (Note, sequence age is not currently supported.)\n- `number` types should be displayed according the their configured `decimals` and `unit` values.\n- `utf8` types should be displayed as utf8 strings."},extensions:{$ref:"#/definitions/Extensions",description:"A mapping of NFT field extension identifiers to extension definitions.  {@link  Extensions }  may be widely standardized or application-specific."},name:{description:"The name of this field for use in interfaces. Names longer than `20` characters may be elided in some interfaces.\n\nE.g.:\n- `BCH Pledged`\n- `Tokens Sold`\n- `Settlement Locktime`\n- `Seat Number`,\n- `IPFS Content Identifier`\n- `HTTPS URL`",type:"string"},uris:{$ref:"#/definitions/URIs",description:"A mapping of identifiers to URIs associated with this NFT field. URI identifiers may be widely-standardized or registry-specific. Values must be valid URIs, including a protocol prefix (e.g. `https://` or `ipfs://`). Clients are only required to support `https` and `ipfs` URIs, but any scheme may be specified."}},required:["encoding"],type:"object"},description:"A definition specifying a field that can be encoded in non-fungible tokens of a token category.",type:"object"};function Xe(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e))for(let c in e){let B=e[c],S=t;if(t===S)if(B&&typeof B=="object"&&!Array.isArray(B)){let P;if(B.encoding===void 0&&(P="encoding"))return Xe.errors=[{instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/additionalProperties/required",keyword:"required",params:{missingProperty:P},message:"must have required property '"+P+"'"}],!1;{let h=t;for(let y in B)if(!(y==="description"||y==="encoding"||y==="extensions"||y==="name"||y==="uris")){return Xe.errors=[{instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/additionalProperties/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:y},message:"must NOT have additional properties"}],!1;break}if(h===t){if(B.description!==void 0){let y=t;if(typeof B.description!="string")return Xe.errors=[{instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/description",schemaPath:"#/additionalProperties/properties/description/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=y===t}else var o=!0;if(o){if(B.encoding!==void 0){let y=B.encoding,p=t,C=t,b=!1,Y=t;if(t===Y)if(y&&typeof y=="object"&&!Array.isArray(y)){let x;if(y.type===void 0&&(x="type")){let H={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/encoding",schemaPath:"#/additionalProperties/properties/encoding/anyOf/0/required",keyword:"required",params:{missingProperty:x},message:"must have required property '"+x+"'"};i===null?i=[H]:i.push(H),t++}else{let H=t;for(let F in y)if(F!=="type"){let O={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/encoding",schemaPath:"#/additionalProperties/properties/encoding/anyOf/0/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:F},message:"must NOT have additional properties"};i===null?i=[O]:i.push(O),t++;break}if(H===t&&y.type!==void 0){let F=y.type;if(typeof F!="string"){let O={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/encoding/type",schemaPath:"#/additionalProperties/properties/encoding/anyOf/0/properties/type/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[O]:i.push(O),t++}if(!(F==="binary"||F==="boolean"||F==="hex"||F==="https-url"||F==="ipfs-cid"||F==="utf8"||F==="locktime")){let O={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/encoding/type",schemaPath:"#/additionalProperties/properties/encoding/anyOf/0/properties/type/enum",keyword:"enum",params:{allowedValues:ih.additionalProperties.properties.encoding.anyOf[0].properties.type.enum},message:"must be equal to one of the allowed values"};i===null?i=[O]:i.push(O),t++}}}}else{let x={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/encoding",schemaPath:"#/additionalProperties/properties/encoding/anyOf/0/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[x]:i.push(x),t++}var s=Y===t;if(b=b||s,!b){let x=t;if(t===x)if(y&&typeof y=="object"&&!Array.isArray(y)){let F;if(y.type===void 0&&(F="type")){let O={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/encoding",schemaPath:"#/additionalProperties/properties/encoding/anyOf/1/required",keyword:"required",params:{missingProperty:F},message:"must have required property '"+F+"'"};i===null?i=[O]:i.push(O),t++}else{let O=t;for(let D in y)if(!(D==="aggregate"||D==="decimals"||D==="type"||D==="unit")){let G={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/encoding",schemaPath:"#/additionalProperties/properties/encoding/anyOf/1/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:D},message:"must NOT have additional properties"};i===null?i=[G]:i.push(G),t++;break}if(O===t){if(y.aggregate!==void 0){let D=y.aggregate,G=t;if(typeof D!="string"){let K={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/encoding/aggregate",schemaPath:"#/additionalProperties/properties/encoding/anyOf/1/properties/aggregate/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[K]:i.push(K),t++}if(D!=="add"){let K={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/encoding/aggregate",schemaPath:"#/additionalProperties/properties/encoding/anyOf/1/properties/aggregate/const",keyword:"const",params:{allowedValue:"add"},message:"must be equal to constant"};i===null?i=[K]:i.push(K),t++}var g=G===t}else var g=!0;if(g){if(y.decimals!==void 0){let D=y.decimals,G=t;if(!(typeof D=="number"&&isFinite(D))){let V={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/encoding/decimals",schemaPath:"#/additionalProperties/properties/encoding/anyOf/1/properties/decimals/type",keyword:"type",params:{type:"number"},message:"must be number"};i===null?i=[V]:i.push(V),t++}var g=G===t}else var g=!0;if(g){if(y.type!==void 0){let D=y.type,G=t;if(typeof D!="string"){let V={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/encoding/type",schemaPath:"#/additionalProperties/properties/encoding/anyOf/1/properties/type/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[V]:i.push(V),t++}if(D!=="number"){let V={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/encoding/type",schemaPath:"#/additionalProperties/properties/encoding/anyOf/1/properties/type/const",keyword:"const",params:{allowedValue:"number"},message:"must be equal to constant"};i===null?i=[V]:i.push(V),t++}var g=G===t}else var g=!0;if(g)if(y.unit!==void 0){let D=t;if(typeof y.unit!="string"){let K={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/encoding/unit",schemaPath:"#/additionalProperties/properties/encoding/anyOf/1/properties/unit/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[K]:i.push(K),t++}var g=D===t}else var g=!0}}}}}else{let F={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/encoding",schemaPath:"#/additionalProperties/properties/encoding/anyOf/1/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[F]:i.push(F),t++}var s=x===t;b=b||s}if(b)t=C,i!==null&&(C?i.length=C:i=null);else{let x={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/encoding",schemaPath:"#/additionalProperties/properties/encoding/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};return i===null?i=[x]:i.push(x),t++,Xe.errors=i,!1}var o=p===t}else var o=!0;if(o){if(B.extensions!==void 0){let y=B.extensions,p=t;if(t===t)if(y&&typeof y=="object"&&!Array.isArray(y))for(let Y in y){let _=y[Y],x=t,H=t,F=!1,O=t;if(typeof _!="string"){let D={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/extensions/"+Y.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/0/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[D]:i.push(D),t++}var l=O===t;if(F=F||l,!F){let D=t;if(t===D)if(_&&typeof _=="object"&&!Array.isArray(_))for(let K in _){let V=t;if(typeof _[K]!="string"){let L={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/extensions/"+Y.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+K.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/1/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[L]:i.push(L),t++}var I=V===t;if(!I)break}else{let K={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/extensions/"+Y.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/1/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[K]:i.push(K),t++}var l=D===t;if(F=F||l,!F){let K=t;if(t===K)if(_&&typeof _=="object"&&!Array.isArray(_))for(let L in _){let Pe=_[L],Fe=t;if(t===Fe)if(Pe&&typeof Pe=="object"&&!Array.isArray(Pe))for(let Ne in Pe){let JA=t;if(typeof Pe[Ne]!="string"){let ne={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/extensions/"+Y.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+L.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+Ne.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/additionalProperties/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[ne]:i.push(ne),t++}var E=JA===t;if(!E)break}else{let Ne={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/extensions/"+Y.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+L.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/additionalProperties/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[Ne]:i.push(Ne),t++}var u=Fe===t;if(!u)break}else{let L={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/extensions/"+Y.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[L]:i.push(L),t++}var l=K===t;F=F||l}}if(F)t=H,i!==null&&(H?i.length=H:i=null);else{let D={instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/extensions/"+Y.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};return i===null?i=[D]:i.push(D),t++,Xe.errors=i,!1}var k=x===t;if(!k)break}else return Xe.errors=[{instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/extensions",schemaPath:"#/definitions/Extensions/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=p===t}else var o=!0;if(o){if(B.name!==void 0){let y=t;if(typeof B.name!="string")return Xe.errors=[{instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/name",schemaPath:"#/additionalProperties/properties/name/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=y===t}else var o=!0;if(o)if(B.uris!==void 0){let y=B.uris,p=t;if(t===t)if(y&&typeof y=="object"&&!Array.isArray(y))for(let Y in y){let _=t;if(typeof y[Y]!="string")return Xe.errors=[{instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/uris/"+Y.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/URIs/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var U=_===t;if(!U)break}else return Xe.errors=[{instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1")+"/uris",schemaPath:"#/definitions/URIs/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=p===t}else var o=!0}}}}}}else return Xe.errors=[{instancePath:A+"/"+c.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/additionalProperties/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var N=S===t;if(!N)break}else return Xe.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return Xe.errors=i,t===0}function Me(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e)){let U;if(e.name===void 0&&(U="name"))return Me.errors=[{instancePath:A,schemaPath:"#/required",keyword:"required",params:{missingProperty:U},message:"must have required property '"+U+"'"}],!1;{let N=t;for(let c in e)if(!(c==="description"||c==="extensions"||c==="fields"||c==="name"||c==="uris")){return Me.errors=[{instancePath:A,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:c},message:"must NOT have additional properties"}],!1;break}if(N===t){if(e.description!==void 0){let c=t;if(typeof e.description!="string")return Me.errors=[{instancePath:A+"/description",schemaPath:"#/properties/description/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=c===t}else var o=!0;if(o){if(e.extensions!==void 0){let c=e.extensions,B=t;if(t===t)if(c&&typeof c=="object"&&!Array.isArray(c))for(let h in c){let y=c[h],p=t,C=t,b=!1,Y=t;if(typeof y!="string"){let _={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/0/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[_]:i.push(_),t++}var s=Y===t;if(b=b||s,!b){let _=t;if(t===_)if(y&&typeof y=="object"&&!Array.isArray(y))for(let H in y){let F=t;if(typeof y[H]!="string"){let O={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+H.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/1/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[O]:i.push(O),t++}var g=F===t;if(!g)break}else{let H={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/1/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[H]:i.push(H),t++}var s=_===t;if(b=b||s,!b){let H=t;if(t===H)if(y&&typeof y=="object"&&!Array.isArray(y))for(let O in y){let D=y[O],G=t;if(t===G)if(D&&typeof D=="object"&&!Array.isArray(D))for(let K in D){let V=t;if(typeof D[K]!="string"){let L={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+O.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+K.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/additionalProperties/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[L]:i.push(L),t++}var l=V===t;if(!l)break}else{let K={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+O.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/additionalProperties/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[K]:i.push(K),t++}var I=G===t;if(!I)break}else{let O={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[O]:i.push(O),t++}var s=H===t;b=b||s}}if(b)t=C,i!==null&&(C?i.length=C:i=null);else{let _={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};return i===null?i=[_]:i.push(_),t++,Me.errors=i,!1}var E=p===t;if(!E)break}else return Me.errors=[{instancePath:A+"/extensions",schemaPath:"#/definitions/Extensions/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=B===t}else var o=!0;if(o){if(e.fields!==void 0){let c=e.fields,B=t;if(t===B)if(Array.isArray(c)){var u=!0;let P=c.length;for(let h=0;h<P;h++){let y=t;if(typeof c[h]!="string")return Me.errors=[{instancePath:A+"/fields/"+h,schemaPath:"#/properties/fields/items/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var u=y===t;if(!u)break}}else return Me.errors=[{instancePath:A+"/fields",schemaPath:"#/properties/fields/type",keyword:"type",params:{type:"array"},message:"must be array"}],!1;var o=B===t}else var o=!0;if(o){if(e.name!==void 0){let c=t;if(typeof e.name!="string")return Me.errors=[{instancePath:A+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=c===t}else var o=!0;if(o)if(e.uris!==void 0){let c=e.uris,B=t;if(t===t)if(c&&typeof c=="object"&&!Array.isArray(c))for(let h in c){let y=t;if(typeof c[h]!="string")return Me.errors=[{instancePath:A+"/uris/"+h.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/URIs/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var k=y===t;if(!k)break}else return Me.errors=[{instancePath:A+"/uris",schemaPath:"#/definitions/URIs/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=B===t}else var o=!0}}}}}}else return Me.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return Me.errors=i,t===0}function qA(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e)){let g;if(e.bytecode===void 0&&(g="bytecode")||e.types===void 0&&(g="types"))return qA.errors=[{instancePath:A,schemaPath:"#/required",keyword:"required",params:{missingProperty:g},message:"must have required property '"+g+"'"}],!1;{let l=t;for(let I in e)if(!(I==="bytecode"||I==="types")){return qA.errors=[{instancePath:A,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:I},message:"must NOT have additional properties"}],!1;break}if(l===t){if(e.bytecode!==void 0){let I=t;if(typeof e.bytecode!="string")return qA.errors=[{instancePath:A+"/bytecode",schemaPath:"#/properties/bytecode/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=I===t}else var o=!0;if(o)if(e.types!==void 0){let I=e.types,E=t;if(t===E)if(I&&typeof I=="object"&&!Array.isArray(I))for(let k in I){let U=t;Me(I[k],{instancePath:A+"/types/"+k.replace(/~/g,"~0").replace(/\//g,"~1"),parentData:I,parentDataProperty:k,rootData:n})||(i=i===null?Me.errors:i.concat(Me.errors),t=i.length);var s=U===t;if(!s)break}else return qA.errors=[{instancePath:A+"/types",schemaPath:"#/properties/types/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=E===t}else var o=!0}}}else return qA.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return qA.errors=i,t===0}function et(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e)){let s;if(e.types===void 0&&(s="types"))return et.errors=[{instancePath:A,schemaPath:"#/required",keyword:"required",params:{missingProperty:s},message:"must have required property '"+s+"'"}],!1;{let g=t;for(let l in e)if(l!=="types"){return et.errors=[{instancePath:A,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:l},message:"must NOT have additional properties"}],!1;break}if(g===t&&e.types!==void 0){let l=e.types;if(t===t)if(l&&typeof l=="object"&&!Array.isArray(l))for(let E in l){let u=t;Me(l[E],{instancePath:A+"/types/"+E.replace(/~/g,"~0").replace(/\//g,"~1"),parentData:l,parentDataProperty:E,rootData:n})||(i=i===null?Me.errors:i.concat(Me.errors),t=i.length);var o=u===t;if(!o)break}else return et.errors=[{instancePath:A+"/types",schemaPath:"#/properties/types/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1}}}else return et.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return et.errors=i,t===0}function HA(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e)){let g;if(e.parse===void 0&&(g="parse"))return HA.errors=[{instancePath:A,schemaPath:"#/required",keyword:"required",params:{missingProperty:g},message:"must have required property '"+g+"'"}],!1;{let l=t;for(let I in e)if(!(I==="description"||I==="fields"||I==="parse")){return HA.errors=[{instancePath:A,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:I},message:"must NOT have additional properties"}],!1;break}if(l===t){if(e.description!==void 0){let I=t;if(typeof e.description!="string")return HA.errors=[{instancePath:A+"/description",schemaPath:"#/properties/description/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=I===t}else var o=!0;if(o){if(e.fields!==void 0){let I=t;Xe(e.fields,{instancePath:A+"/fields",parentData:e,parentDataProperty:"fields",rootData:n})||(i=i===null?Xe.errors:i.concat(Xe.errors),t=i.length);var o=I===t}else var o=!0;if(o)if(e.parse!==void 0){let I=e.parse,E=t,u=t,k=!1,U=t;qA(I,{instancePath:A+"/parse",parentData:e,parentDataProperty:"parse",rootData:n})||(i=i===null?qA.errors:i.concat(qA.errors),t=i.length);var s=U===t;if(k=k||s,!k){let c=t;et(I,{instancePath:A+"/parse",parentData:e,parentDataProperty:"parse",rootData:n})||(i=i===null?et.errors:i.concat(et.errors),t=i.length);var s=c===t;k=k||s}if(k)t=u,i!==null&&(u?i.length=u:i=null);else{let c={instancePath:A+"/parse",schemaPath:"#/properties/parse/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};return i===null?i=[c]:i.push(c),t++,HA.errors=i,!1}var o=E===t}else var o=!0}}}}else return HA.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return HA.errors=i,t===0}function _A(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e)){let s;if(e.category===void 0&&(s="category")||e.symbol===void 0&&(s="symbol"))return _A.errors=[{instancePath:A,schemaPath:"#/required",keyword:"required",params:{missingProperty:s},message:"must have required property '"+s+"'"}],!1;{let g=t;for(let l in e)if(!(l==="category"||l==="decimals"||l==="nfts"||l==="symbol")){return _A.errors=[{instancePath:A,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:l},message:"must NOT have additional properties"}],!1;break}if(g===t){if(e.category!==void 0){let l=t;if(typeof e.category!="string")return _A.errors=[{instancePath:A+"/category",schemaPath:"#/properties/category/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=l===t}else var o=!0;if(o){if(e.decimals!==void 0){let l=e.decimals,I=t;if(!(typeof l=="number"&&isFinite(l)))return _A.errors=[{instancePath:A+"/decimals",schemaPath:"#/properties/decimals/type",keyword:"type",params:{type:"number"},message:"must be number"}],!1;var o=I===t}else var o=!0;if(o){if(e.nfts!==void 0){let l=t;HA(e.nfts,{instancePath:A+"/nfts",parentData:e,parentDataProperty:"nfts",rootData:n})||(i=i===null?HA.errors:i.concat(HA.errors),t=i.length);var o=l===t}else var o=!0;if(o)if(e.symbol!==void 0){let l=t;if(typeof e.symbol!="string")return _A.errors=[{instancePath:A+"/symbol",schemaPath:"#/properties/symbol/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=l===t}else var o=!0}}}}}else return _A.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return _A.errors=i,t===0}function Re(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e)){let U;if(e.name===void 0&&(U="name"))return Re.errors=[{instancePath:A,schemaPath:"#/required",keyword:"required",params:{missingProperty:U},message:"must have required property '"+U+"'"}],!1;{let N=t;for(let c in e)if(!QI.call(pI.properties,c)){return Re.errors=[{instancePath:A,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:c},message:"must NOT have additional properties"}],!1;break}if(N===t){if(e.description!==void 0){let c=t;if(typeof e.description!="string")return Re.errors=[{instancePath:A+"/description",schemaPath:"#/properties/description/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=c===t}else var o=!0;if(o){if(e.extensions!==void 0){let c=e.extensions,B=t;if(t===t)if(c&&typeof c=="object"&&!Array.isArray(c))for(let h in c){let y=c[h],p=t,C=t,b=!1,Y=t;if(typeof y!="string"){let _={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/0/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[_]:i.push(_),t++}var s=Y===t;if(b=b||s,!b){let _=t;if(t===_)if(y&&typeof y=="object"&&!Array.isArray(y))for(let H in y){let F=t;if(typeof y[H]!="string"){let O={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+H.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/1/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[O]:i.push(O),t++}var g=F===t;if(!g)break}else{let H={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/1/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[H]:i.push(H),t++}var s=_===t;if(b=b||s,!b){let H=t;if(t===H)if(y&&typeof y=="object"&&!Array.isArray(y))for(let O in y){let D=y[O],G=t;if(t===G)if(D&&typeof D=="object"&&!Array.isArray(D))for(let K in D){let V=t;if(typeof D[K]!="string"){let L={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+O.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+K.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/additionalProperties/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[L]:i.push(L),t++}var l=V===t;if(!l)break}else{let K={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+O.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/additionalProperties/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[K]:i.push(K),t++}var I=G===t;if(!I)break}else{let O={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[O]:i.push(O),t++}var s=H===t;b=b||s}}if(b)t=C,i!==null&&(C?i.length=C:i=null);else{let _={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};return i===null?i=[_]:i.push(_),t++,Re.errors=i,!1}var E=p===t;if(!E)break}else return Re.errors=[{instancePath:A+"/extensions",schemaPath:"#/definitions/Extensions/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=B===t}else var o=!0;if(o){if(e.migrated!==void 0){let c=t;if(typeof e.migrated!="string")return Re.errors=[{instancePath:A+"/migrated",schemaPath:"#/properties/migrated/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=c===t}else var o=!0;if(o){if(e.name!==void 0){let c=t;if(typeof e.name!="string")return Re.errors=[{instancePath:A+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=c===t}else var o=!0;if(o){if(e.splitId!==void 0){let c=t;if(typeof e.splitId!="string")return Re.errors=[{instancePath:A+"/splitId",schemaPath:"#/properties/splitId/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=c===t}else var o=!0;if(o){if(e.status!==void 0){let c=e.status,B=t;if(typeof c!="string")return Re.errors=[{instancePath:A+"/status",schemaPath:"#/properties/status/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;if(!(c==="active"||c==="burned"||c==="inactive"))return Re.errors=[{instancePath:A+"/status",schemaPath:"#/properties/status/enum",keyword:"enum",params:{allowedValues:pI.properties.status.enum},message:"must be equal to one of the allowed values"}],!1;var o=B===t}else var o=!0;if(o){if(e.tags!==void 0){let c=e.tags,B=t;if(t===B)if(Array.isArray(c)){var u=!0;let P=c.length;for(let h=0;h<P;h++){let y=t;if(typeof c[h]!="string")return Re.errors=[{instancePath:A+"/tags/"+h,schemaPath:"#/properties/tags/items/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var u=y===t;if(!u)break}}else return Re.errors=[{instancePath:A+"/tags",schemaPath:"#/properties/tags/type",keyword:"type",params:{type:"array"},message:"must be array"}],!1;var o=B===t}else var o=!0;if(o){if(e.token!==void 0){let c=t;_A(e.token,{instancePath:A+"/token",parentData:e,parentDataProperty:"token",rootData:n})||(i=i===null?_A.errors:i.concat(_A.errors),t=i.length);var o=c===t}else var o=!0;if(o)if(e.uris!==void 0){let c=e.uris,B=t;if(t===t)if(c&&typeof c=="object"&&!Array.isArray(c))for(let h in c){let y=t;if(typeof c[h]!="string")return Re.errors=[{instancePath:A+"/uris/"+h.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/URIs/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var k=y===t;if(!k)break}else return Re.errors=[{instancePath:A+"/uris",schemaPath:"#/definitions/URIs/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=B===t}else var o=!0}}}}}}}}}}else return Re.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return Re.errors=i,t===0}function Oa(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e))for(let s in e){let g=t;Re(e[s],{instancePath:A+"/"+s.replace(/~/g,"~0").replace(/\//g,"~1"),parentData:e,parentDataProperty:s,rootData:n})||(i=i===null?Re.errors:i.concat(Re.errors),t=i.length);var o=g===t;if(!o)break}else return Oa.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return Oa.errors=i,t===0}function $e(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e)){let U;if(e.name===void 0&&(U="name"))return $e.errors=[{instancePath:A,schemaPath:"#/required",keyword:"required",params:{missingProperty:U},message:"must have required property '"+U+"'"}],!1;{let N=t;for(let c in e)if(!(c==="description"||c==="extensions"||c==="name"||c==="tags"||c==="uris")){return $e.errors=[{instancePath:A,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:c},message:"must NOT have additional properties"}],!1;break}if(N===t){if(e.description!==void 0){let c=t;if(typeof e.description!="string")return $e.errors=[{instancePath:A+"/description",schemaPath:"#/properties/description/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=c===t}else var o=!0;if(o){if(e.extensions!==void 0){let c=e.extensions,B=t;if(t===t)if(c&&typeof c=="object"&&!Array.isArray(c))for(let h in c){let y=c[h],p=t,C=t,b=!1,Y=t;if(typeof y!="string"){let _={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/0/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[_]:i.push(_),t++}var s=Y===t;if(b=b||s,!b){let _=t;if(t===_)if(y&&typeof y=="object"&&!Array.isArray(y))for(let H in y){let F=t;if(typeof y[H]!="string"){let O={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+H.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/1/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[O]:i.push(O),t++}var g=F===t;if(!g)break}else{let H={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/1/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[H]:i.push(H),t++}var s=_===t;if(b=b||s,!b){let H=t;if(t===H)if(y&&typeof y=="object"&&!Array.isArray(y))for(let O in y){let D=y[O],G=t;if(t===G)if(D&&typeof D=="object"&&!Array.isArray(D))for(let K in D){let V=t;if(typeof D[K]!="string"){let L={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+O.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+K.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/additionalProperties/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[L]:i.push(L),t++}var l=V===t;if(!l)break}else{let K={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+O.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/additionalProperties/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[K]:i.push(K),t++}var I=G===t;if(!I)break}else{let O={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[O]:i.push(O),t++}var s=H===t;b=b||s}}if(b)t=C,i!==null&&(C?i.length=C:i=null);else{let _={instancePath:A+"/extensions/"+h.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};return i===null?i=[_]:i.push(_),t++,$e.errors=i,!1}var E=p===t;if(!E)break}else return $e.errors=[{instancePath:A+"/extensions",schemaPath:"#/definitions/Extensions/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=B===t}else var o=!0;if(o){if(e.name!==void 0){let c=t;if(typeof e.name!="string")return $e.errors=[{instancePath:A+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=c===t}else var o=!0;if(o){if(e.tags!==void 0){let c=e.tags,B=t;if(t===B)if(Array.isArray(c)){var u=!0;let P=c.length;for(let h=0;h<P;h++){let y=t;if(typeof c[h]!="string")return $e.errors=[{instancePath:A+"/tags/"+h,schemaPath:"#/properties/tags/items/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var u=y===t;if(!u)break}}else return $e.errors=[{instancePath:A+"/tags",schemaPath:"#/properties/tags/type",keyword:"type",params:{type:"array"},message:"must be array"}],!1;var o=B===t}else var o=!0;if(o)if(e.uris!==void 0){let c=e.uris,B=t;if(t===t)if(c&&typeof c=="object"&&!Array.isArray(c))for(let h in c){let y=t;if(typeof c[h]!="string")return $e.errors=[{instancePath:A+"/uris/"+h.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/URIs/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var k=y===t;if(!k)break}else return $e.errors=[{instancePath:A+"/uris",schemaPath:"#/definitions/URIs/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=B===t}else var o=!0}}}}}}else return $e.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return $e.errors=i,t===0}function gA(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e)){let k;if(e.name===void 0&&(k="name"))return gA.errors=[{instancePath:A,schemaPath:"#/required",keyword:"required",params:{missingProperty:k},message:"must have required property '"+k+"'"}],!1;{let U=t;for(let N in e)if(!(N==="description"||N==="extensions"||N==="name"||N==="uris")){return gA.errors=[{instancePath:A,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:N},message:"must NOT have additional properties"}],!1;break}if(U===t){if(e.description!==void 0){let N=t;if(typeof e.description!="string")return gA.errors=[{instancePath:A+"/description",schemaPath:"#/properties/description/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=N===t}else var o=!0;if(o){if(e.extensions!==void 0){let N=e.extensions,c=t;if(t===t)if(N&&typeof N=="object"&&!Array.isArray(N))for(let P in N){let h=N[P],y=t,p=t,C=!1,b=t;if(typeof h!="string"){let Y={instancePath:A+"/extensions/"+P.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/0/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[Y]:i.push(Y),t++}var s=b===t;if(C=C||s,!C){let Y=t;if(t===Y)if(h&&typeof h=="object"&&!Array.isArray(h))for(let x in h){let H=t;if(typeof h[x]!="string"){let F={instancePath:A+"/extensions/"+P.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+x.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/1/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[F]:i.push(F),t++}var g=H===t;if(!g)break}else{let x={instancePath:A+"/extensions/"+P.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/1/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[x]:i.push(x),t++}var s=Y===t;if(C=C||s,!C){let x=t;if(t===x)if(h&&typeof h=="object"&&!Array.isArray(h))for(let F in h){let O=h[F],D=t;if(t===D)if(O&&typeof O=="object"&&!Array.isArray(O))for(let G in O){let K=t;if(typeof O[G]!="string"){let V={instancePath:A+"/extensions/"+P.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+F.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+G.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/additionalProperties/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[V]:i.push(V),t++}var l=K===t;if(!l)break}else{let G={instancePath:A+"/extensions/"+P.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+F.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/additionalProperties/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[G]:i.push(G),t++}var I=D===t;if(!I)break}else{let F={instancePath:A+"/extensions/"+P.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[F]:i.push(F),t++}var s=x===t;C=C||s}}if(C)t=p,i!==null&&(p?i.length=p:i=null);else{let Y={instancePath:A+"/extensions/"+P.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};return i===null?i=[Y]:i.push(Y),t++,gA.errors=i,!1}var E=y===t;if(!E)break}else return gA.errors=[{instancePath:A+"/extensions",schemaPath:"#/definitions/Extensions/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=c===t}else var o=!0;if(o){if(e.name!==void 0){let N=t;if(typeof e.name!="string")return gA.errors=[{instancePath:A+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=N===t}else var o=!0;if(o)if(e.uris!==void 0){let N=e.uris,c=t;if(t===t)if(N&&typeof N=="object"&&!Array.isArray(N))for(let P in N){let h=t;if(typeof N[P]!="string")return gA.errors=[{instancePath:A+"/uris/"+P.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/URIs/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var u=h===t;if(!u)break}else return gA.errors=[{instancePath:A+"/uris",schemaPath:"#/definitions/URIs/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=c===t}else var o=!0}}}}}else return gA.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return gA.errors=i,t===0}function Ce(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;if(t===0)if(e&&typeof e=="object"&&!Array.isArray(e)){let B;if(e.version===void 0&&(B="version")||e.latestRevision===void 0&&(B="latestRevision")||e.registryIdentity===void 0&&(B="registryIdentity"))return Ce.errors=[{instancePath:A,schemaPath:"#/required",keyword:"required",params:{missingProperty:B},message:"must have required property '"+B+"'"}],!1;{let S=t;for(let P in e)if(!QI.call(Ah.properties,P)){return Ce.errors=[{instancePath:A,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:P},message:"must NOT have additional properties"}],!1;break}if(S===t){if(e.$schema!==void 0){let P=t;if(typeof e.$schema!="string")return Ce.errors=[{instancePath:A+"/$schema",schemaPath:"#/properties/%24schema/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=P===t}else var o=!0;if(o){if(e.chains!==void 0){let P=e.chains,h=t;if(t===h)if(P&&typeof P=="object"&&!Array.isArray(P))for(let p in P){let C=t;xa(P[p],{instancePath:A+"/chains/"+p.replace(/~/g,"~0").replace(/\//g,"~1"),parentData:P,parentDataProperty:p,rootData:n})||(i=i===null?xa.errors:i.concat(xa.errors),t=i.length);var s=C===t;if(!s)break}else return Ce.errors=[{instancePath:A+"/chains",schemaPath:"#/properties/chains/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=h===t}else var o=!0;if(o){if(e.defaultChain!==void 0){let P=t;if(typeof e.defaultChain!="string")return Ce.errors=[{instancePath:A+"/defaultChain",schemaPath:"#/properties/defaultChain/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=P===t}else var o=!0;if(o){if(e.extensions!==void 0){let P=e.extensions,h=t;if(t===t)if(P&&typeof P=="object"&&!Array.isArray(P))for(let C in P){let b=P[C],Y=t,_=t,x=!1,H=t;if(typeof b!="string"){let F={instancePath:A+"/extensions/"+C.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/0/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[F]:i.push(F),t++}var g=H===t;if(x=x||g,!x){let F=t;if(t===F)if(b&&typeof b=="object"&&!Array.isArray(b))for(let D in b){let G=t;if(typeof b[D]!="string"){let K={instancePath:A+"/extensions/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+D.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/1/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[K]:i.push(K),t++}var l=G===t;if(!l)break}else{let D={instancePath:A+"/extensions/"+C.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/1/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[D]:i.push(D),t++}var g=F===t;if(x=x||g,!x){let D=t;if(t===D)if(b&&typeof b=="object"&&!Array.isArray(b))for(let K in b){let V=b[K],L=t;if(t===L)if(V&&typeof V=="object"&&!Array.isArray(V))for(let Pe in V){let Fe=t;if(typeof V[Pe]!="string"){let Ne={instancePath:A+"/extensions/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+K.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+Pe.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/additionalProperties/additionalProperties/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[Ne]:i.push(Ne),t++}var I=Fe===t;if(!I)break}else{let Pe={instancePath:A+"/extensions/"+C.replace(/~/g,"~0").replace(/\//g,"~1")+"/"+K.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/additionalProperties/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[Pe]:i.push(Pe),t++}var E=L===t;if(!E)break}else{let K={instancePath:A+"/extensions/"+C.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf/2/type",keyword:"type",params:{type:"object"},message:"must be object"};i===null?i=[K]:i.push(K),t++}var g=D===t;x=x||g}}if(x)t=_,i!==null&&(_?i.length=_:i=null);else{let F={instancePath:A+"/extensions/"+C.replace(/~/g,"~0").replace(/\//g,"~1"),schemaPath:"#/definitions/Extensions/additionalProperties/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};return i===null?i=[F]:i.push(F),t++,Ce.errors=i,!1}var u=Y===t;if(!u)break}else return Ce.errors=[{instancePath:A+"/extensions",schemaPath:"#/definitions/Extensions/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=h===t}else var o=!0;if(o){if(e.identities!==void 0){let P=e.identities,h=t;if(t===h)if(P&&typeof P=="object"&&!Array.isArray(P))for(let p in P){let C=t;Oa(P[p],{instancePath:A+"/identities/"+p.replace(/~/g,"~0").replace(/\//g,"~1"),parentData:P,parentDataProperty:p,rootData:n})||(i=i===null?Oa.errors:i.concat(Oa.errors),t=i.length);var k=C===t;if(!k)break}else return Ce.errors=[{instancePath:A+"/identities",schemaPath:"#/properties/identities/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=h===t}else var o=!0;if(o){if(e.latestRevision!==void 0){let P=t;if(typeof e.latestRevision!="string")return Ce.errors=[{instancePath:A+"/latestRevision",schemaPath:"#/properties/latestRevision/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=P===t}else var o=!0;if(o){if(e.license!==void 0){let P=t;if(typeof e.license!="string")return Ce.errors=[{instancePath:A+"/license",schemaPath:"#/properties/license/type",keyword:"type",params:{type:"string"},message:"must be string"}],!1;var o=P===t}else var o=!0;if(o){if(e.registryIdentity!==void 0){let P=e.registryIdentity,h=t,y=t,p=!1,C=t;$e(P,{instancePath:A+"/registryIdentity",parentData:e,parentDataProperty:"registryIdentity",rootData:n})||(i=i===null?$e.errors:i.concat($e.errors),t=i.length);var U=C===t;if(p=p||U,!p){let Y=t;if(typeof P!="string"){let x={instancePath:A+"/registryIdentity",schemaPath:"#/properties/registryIdentity/anyOf/1/type",keyword:"type",params:{type:"string"},message:"must be string"};i===null?i=[x]:i.push(x),t++}var U=Y===t;p=p||U}if(p)t=y,i!==null&&(y?i.length=y:i=null);else{let Y={instancePath:A+"/registryIdentity",schemaPath:"#/properties/registryIdentity/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};return i===null?i=[Y]:i.push(Y),t++,Ce.errors=i,!1}var o=h===t}else var o=!0;if(o){if(e.tags!==void 0){let P=e.tags,h=t;if(t===h)if(P&&typeof P=="object"&&!Array.isArray(P))for(let p in P){let C=t;gA(P[p],{instancePath:A+"/tags/"+p.replace(/~/g,"~0").replace(/\//g,"~1"),parentData:P,parentDataProperty:p,rootData:n})||(i=i===null?gA.errors:i.concat(gA.errors),t=i.length);var N=C===t;if(!N)break}else return Ce.errors=[{instancePath:A+"/tags",schemaPath:"#/properties/tags/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=h===t}else var o=!0;if(o)if(e.version!==void 0){let P=e.version,h=t;if(t===h)if(P&&typeof P=="object"&&!Array.isArray(P)){let p;if(P.major===void 0&&(p="major")||P.minor===void 0&&(p="minor")||P.patch===void 0&&(p="patch"))return Ce.errors=[{instancePath:A+"/version",schemaPath:"#/properties/version/required",keyword:"required",params:{missingProperty:p},message:"must have required property '"+p+"'"}],!1;{let C=t;for(let b in P)if(!(b==="major"||b==="minor"||b==="patch")){return Ce.errors=[{instancePath:A+"/version",schemaPath:"#/properties/version/additionalProperties",keyword:"additionalProperties",params:{additionalProperty:b},message:"must NOT have additional properties"}],!1;break}if(C===t){if(P.major!==void 0){let b=P.major,Y=t;if(!(typeof b=="number"&&isFinite(b)))return Ce.errors=[{instancePath:A+"/version/major",schemaPath:"#/properties/version/properties/major/type",keyword:"type",params:{type:"number"},message:"must be number"}],!1;var c=Y===t}else var c=!0;if(c){if(P.minor!==void 0){let b=P.minor,Y=t;if(!(typeof b=="number"&&isFinite(b)))return Ce.errors=[{instancePath:A+"/version/minor",schemaPath:"#/properties/version/properties/minor/type",keyword:"type",params:{type:"number"},message:"must be number"}],!1;var c=Y===t}else var c=!0;if(c)if(P.patch!==void 0){let b=P.patch,Y=t;if(!(typeof b=="number"&&isFinite(b)))return Ce.errors=[{instancePath:A+"/version/patch",schemaPath:"#/properties/version/properties/patch/type",keyword:"type",params:{type:"number"},message:"must be number"}],!1;var c=Y===t}else var c=!0}}}}else return Ce.errors=[{instancePath:A+"/version",schemaPath:"#/properties/version/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;var o=h===t}else var o=!0}}}}}}}}}}}else return Ce.errors=[{instancePath:A,schemaPath:"#/type",keyword:"type",params:{type:"object"},message:"must be object"}],!1;return Ce.errors=i,t===0}function yI(e,{instancePath:A="",parentData:a,parentDataProperty:r,rootData:n=e}={}){let i=null,t=0;return Ce(e,{instancePath:A,parentData:a,parentDataProperty:r,rootData:n})||(i=i===null?Ce.errors:i.concat(Ce.errors),t=i.length),yI.errors=i,t===0}var WP=e=>{let A="Metadata Registry import failed:",a=Fr(e,mI);return typeof a=="string"?`${A}${a}`:a};var eS=e=>{let A="Wallet template import failed:",a=Fr(e,Rr);return typeof a=="string"?`${A}${a}`:a};var fI=({index:e,result:A,type:a})=>({errors:A.errors.map(r=>({...r,error:`Failed compilation of ${a} directive at index "${e}": ${r.error}`})),index:e,...A.errorType==="parse"?{}:{resolved:A.resolve},type:a}),ah=({outputTemplate:e,index:A})=>{if("script"in e.lockingBytecode){let a=e.lockingBytecode,r=a.data??{},n=a.compiler.generateBytecode({data:r,debug:!0,scriptId:a.script});return n.success?{lockingBytecode:n.bytecode,...e.token===void 0?{}:{token:e.token},valueSatoshis:e.valueSatoshis}:fI({index:A,result:n,type:"locking"})}return{lockingBytecode:e.lockingBytecode.slice(),...e.token===void 0?{}:{token:e.token},valueSatoshis:e.valueSatoshis}},rh=({inputTemplate:e,index:A,template:a,outputs:r})=>{if("script"in e.unlockingBytecode){let n=e.unlockingBytecode,i=[];i[A]={lockingBytecode:Uint8Array.of(),...e.unlockingBytecode.token===void 0?{}:{token:e.unlockingBytecode.token},valueSatoshis:e.unlockingBytecode.valueSatoshis};let t=n.compiler.generateBytecode({data:{...n.data,compilationContext:{inputIndex:A,sourceOutputs:i,transaction:{inputs:a.inputs,locktime:a.locktime,outputs:r,version:a.version}}},debug:!0,scriptId:n.script});return t.success?{outpointIndex:e.outpointIndex,outpointTransactionHash:e.outpointTransactionHash.slice(),sequenceNumber:e.sequenceNumber,unlockingBytecode:t.bytecode}:fI({index:A,result:t,type:"unlocking"})}return{outpointIndex:e.outpointIndex,outpointTransactionHash:e.outpointTransactionHash.slice(),sequenceNumber:e.sequenceNumber,unlockingBytecode:e.unlockingBytecode.slice()}},nS=e=>{let A=e.outputs.map((o,s)=>ah({index:s,outputTemplate:o})),a=A.filter(o=>"errors"in o);if(a.length>0)return{completions:A.map((s,g)=>"lockingBytecode"in s?{index:g,output:s,type:"output"}:s).filter(s=>"output"in s),errors:a,stage:"outputs",success:!1};let r=A,n=e.inputs.map((o,s)=>rh({index:s,inputTemplate:o,outputs:r,template:e})),i=n.filter(o=>"errors"in o);return i.length>0?{completions:n.map((s,g)=>"unlockingBytecode"in s?{index:g,input:s,type:"input"}:s).filter(s=>"input"in s),errors:i,stage:"inputs",success:!1}:{success:!0,transaction:{inputs:n,locktime:e.locktime,outputs:r,version:e.version}}},oS=e=>e.errors.reduce((A,a)=>a.resolved===void 0?A:{...A,...Kg(a.resolved)},{}),nh=e=>{let A=e.errors.reduce((a,r)=>[...a,...r.errors],[]);return Fg(A)?A.reduce((a,r)=>({...a,[r.missingIdentifier]:r.owningEntity}),{}):!1},sS=(e,A,a)=>{let r=nh(e);if(r===!1)return!1;let n=Object.entries(r).reduce((i,[t,o])=>{let s=a[o];if(s===void 0)return i;let g=s[t];return g===void 0?i:{...i,[t]:g}},{});return{...A,bytecode:{...n,...A.bytecode}}};var oh={lockingBytecode:{script:"lockP2pkh"},valueSatoshis:1e4},sh={unlockingBytecode:{script:"unlockP2pkh"}};var gh={lockingBytecode:{script:"vmbTestNullData"},valueSatoshis:0},Ih={lockingBytecode:["slot"],valueSatoshis:1e4},ch={unlockingBytecode:["slot"]};var CI={sourceOutputs:[oh,Ih],transaction:{inputs:[sh,ch],outputs:[gh]}};var QS=["nop2sh_nonstandard","p2sh20_standard","p2sh32_ignore"],lh=[["chip_cashtokens_invalid"],["chip_cashtokens_invalid","2022_p2sh32_nonstandard"],["default","chip_cashtokens"],["chip_cashtokens"],["chip_cashtokens","2022_p2sh32_nonstandard"],["chip_loops_invalid"],["chip_loops"],["invalid","2022_p2sh32_nonstandard","chip_cashtokens"],["invalid","2022_p2sh32_nonstandard","chip_cashtokens_invalid"],["invalid","2022_p2sh32_nonstandard","chip_cashtokens_nonstandard"],["invalid","chip_cashtokens_invalid"],["invalid","chip_cashtokens","nop2sh_invalid"],["invalid","chip_cashtokens"],["invalid","chip_cashtokens","chip_cashtokens_p2sh20_nonstandard","chip_cashtokens_p2sh32_nonstandard"],["invalid","chip_cashtokens","chip_cashtokens_p2sh32_nonstandard"],["invalid","chip_cashtokens","p2sh_ignore"],["invalid","chip_cashtokens_invalid","p2sh_ignore"],["invalid","nop2sh_nonstandard"],["invalid","nop2sh_nonstandard"],["invalid","p2sh_ignore"],["invalid","p2sh_nonstandard","chip_cashtokens_invalid"],["invalid","p2sh_nonstandard","chip_cashtokens"],["invalid","p2sh_standard"],["invalid","p2sh20_standard"],["invalid"],["nop2sh_invalid"],["nonstandard","chip_cashtokens_invalid"],["nonstandard","chip_cashtokens"],["nonstandard","chip_cashtokens","chip_cashtokens_p2sh20_nonstandard","chip_cashtokens_p2sh32_nonstandard"],["nonstandard","chip_cashtokens","chip_cashtokens_p2sh32_nonstandard"],["nonstandard","p2sh_ignore"],["nonstandard","p2sh_invalid"],["nonstandard"],["p2sh_ignore"],["p2sh_invalid"],[]],uh=e=>0;uh(lh);var hh={"":[{mode:"nonP2SH",sets:["2022_nonstandard"]},{mode:"P2SH20",sets:["2022_standard"]}],chip_cashtokens:[{mode:"nonP2SH",sets:["before_chip_cashtokens_invalid","chip_cashtokens_nonstandard"]},{mode:"P2SH20",sets:["before_chip_cashtokens_invalid","chip_cashtokens_standard"]},{mode:"P2SH32",sets:["before_chip_cashtokens_invalid","chip_cashtokens_standard"]}],"chip_cashtokens,2022_p2sh32_nonstandard":[{mode:"nonP2SH",sets:["before_chip_cashtokens_invalid","chip_cashtokens_nonstandard"]},{mode:"P2SH20",sets:["before_chip_cashtokens_invalid","chip_cashtokens_standard"]},{mode:"P2SH32",sets:["before_chip_cashtokens_nonstandard","chip_cashtokens_standard"]}],chip_cashtokens_invalid:[{mode:"nonP2SH",sets:["before_chip_cashtokens_invalid","chip_cashtokens_invalid"]},{mode:"P2SH20",sets:["before_chip_cashtokens_invalid","chip_cashtokens_invalid"]},{mode:"P2SH32",sets:["before_chip_cashtokens_invalid","chip_cashtokens_invalid"]}],"chip_cashtokens_invalid,2022_p2sh32_nonstandard":[{mode:"nonP2SH",sets:["before_chip_cashtokens_invalid","chip_cashtokens_invalid"]},{mode:"P2SH20",sets:["before_chip_cashtokens_invalid","chip_cashtokens_invalid"]},{mode:"P2SH32",sets:["before_chip_cashtokens_nonstandard","chip_cashtokens_invalid"]}],chip_loops:[{mode:"nonP2SH",sets:["chip_loops_nonstandard"]},{mode:"P2SH20",sets:["chip_loops_standard"]}],chip_loops_invalid:[{mode:"nonP2SH",sets:["chip_loops_invalid"]},{mode:"P2SH20",sets:["chip_loops_invalid"]}],"default,chip_cashtokens":[{mode:"nonP2SH",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_nonstandard"]},{mode:"P2SH20",sets:["2022_standard","before_chip_cashtokens_standard","chip_cashtokens_standard"]},{mode:"P2SH32",sets:["chip_cashtokens_standard"]}],invalid:[{mode:"nonP2SH",sets:["2022_invalid"]},{mode:"P2SH20",sets:["2022_invalid"]}],"invalid,2022_p2sh32_nonstandard,chip_cashtokens":[{mode:"nonP2SH",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_nonstandard"]},{mode:"P2SH20",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_standard"]},{mode:"P2SH32",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_standard"]}],"invalid,2022_p2sh32_nonstandard,chip_cashtokens_invalid":[{mode:"nonP2SH",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_invalid"]},{mode:"P2SH20",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_invalid"]},{mode:"P2SH32",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_invalid"]}],"invalid,2022_p2sh32_nonstandard,chip_cashtokens_nonstandard":[{mode:"nonP2SH",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_nonstandard"]},{mode:"P2SH20",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_nonstandard"]},{mode:"P2SH32",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_nonstandard"]}],"invalid,chip_cashtokens":[{mode:"nonP2SH",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_nonstandard"]},{mode:"P2SH20",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_standard"]},{mode:"P2SH32",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_standard"]}],"invalid,chip_cashtokens,chip_cashtokens_p2sh20_nonstandard,chip_cashtokens_p2sh32_nonstandard":[{mode:"nonP2SH",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_nonstandard"]},{mode:"P2SH20",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_nonstandard"]},{mode:"P2SH32",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_nonstandard"]}],"invalid,chip_cashtokens,chip_cashtokens_p2sh32_nonstandard":[{mode:"nonP2SH",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_nonstandard"]},{mode:"P2SH20",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_standard"]},{mode:"P2SH32",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_nonstandard"]}],"invalid,chip_cashtokens,nop2sh_invalid":[{mode:"nonP2SH",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_invalid"]},{mode:"P2SH20",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_standard"]},{mode:"P2SH32",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_standard"]}],"invalid,chip_cashtokens,p2sh_ignore":[{mode:"nonP2SH",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_nonstandard"]}],"invalid,chip_cashtokens_invalid":[{mode:"nonP2SH",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_invalid"]},{mode:"P2SH20",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_invalid"]},{mode:"P2SH32",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_invalid"]}],"invalid,chip_cashtokens_invalid,p2sh_ignore":[{mode:"nonP2SH",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_invalid"]}],"invalid,nop2sh_nonstandard":[{mode:"nonP2SH",sets:["2022_nonstandard"]},{mode:"P2SH20",sets:["2022_invalid"]}],"invalid,p2sh20_standard":[{mode:"nonP2SH",sets:["2022_invalid"]},{mode:"P2SH20",sets:["2022_standard"]}],"invalid,p2sh_ignore":[{mode:"nonP2SH",sets:["2022_invalid"]}],"invalid,p2sh_nonstandard,chip_cashtokens":[{mode:"nonP2SH",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_nonstandard"]},{mode:"P2SH20",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_standard"]},{mode:"P2SH32",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_standard"]}],"invalid,p2sh_nonstandard,chip_cashtokens_invalid":[{mode:"nonP2SH",sets:["2022_invalid","before_chip_cashtokens_invalid","chip_cashtokens_invalid"]},{mode:"P2SH20",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_invalid"]},{mode:"P2SH32",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_invalid"]}],"invalid,p2sh_standard":[{mode:"nonP2SH",sets:["2022_invalid"]},{mode:"P2SH20",sets:["2022_standard"]}],nonstandard:[{mode:"nonP2SH",sets:["2022_nonstandard"]},{mode:"P2SH20",sets:["2022_nonstandard"]}],"nonstandard,chip_cashtokens":[{mode:"nonP2SH",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_nonstandard"]},{mode:"P2SH20",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_standard"]},{mode:"P2SH32",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_standard"]}],"nonstandard,chip_cashtokens,chip_cashtokens_p2sh20_nonstandard,chip_cashtokens_p2sh32_nonstandard":[{mode:"nonP2SH",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_nonstandard"]},{mode:"P2SH20",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_nonstandard"]},{mode:"P2SH32",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_nonstandard"]}],"nonstandard,chip_cashtokens,chip_cashtokens_p2sh32_nonstandard":[{mode:"nonP2SH",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_nonstandard"]},{mode:"P2SH20",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_standard"]},{mode:"P2SH32",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_nonstandard"]}],"nonstandard,chip_cashtokens_invalid":[{mode:"nonP2SH",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_invalid"]},{mode:"P2SH20",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_invalid"]},{mode:"P2SH32",sets:["2022_nonstandard","before_chip_cashtokens_nonstandard","chip_cashtokens_invalid"]}],"nonstandard,p2sh_ignore":[{mode:"nonP2SH",sets:["2022_nonstandard"]}],"nonstandard,p2sh_invalid":[{mode:"nonP2SH",sets:["2022_nonstandard"]},{mode:"P2SH20",sets:["2022_invalid"]}],nop2sh_invalid:[{mode:"nonP2SH",sets:["2022_invalid"]},{mode:"P2SH20",sets:["2022_standard"]}],p2sh_ignore:[{mode:"nonP2SH",sets:["2022_nonstandard"]}],p2sh_invalid:[{mode:"nonP2SH",sets:["2022_nonstandard"]},{mode:"P2SH20",sets:["2022_invalid"]}]},dh=5,Eh=e=>hh[(e??[]).join(",")],Bh=(e,A="",a=dh)=>{let[r,n,i,t,o,s]=e,g="test",l=Eh(t),I={extends:"vmb_default",...o},E=xr({entities:{tester:{variables:{key1:{type:"HdKey"},key2:{privateDerivationPath:"m/2/i",type:"HdKey"},key3:{privateDerivationPath:"m/3/i",type:"HdKey"}}}},scenarios:{[g]:I,vmb_default:CI},scripts:{...s,lockEmptyP2sh20:{lockingType:"p2sh20",script:""},lockP2pkh:{lockingType:"standard",script:"OP_DUP OP_HASH160 <$(<key1.public_key> OP_HASH160)> OP_EQUALVERIFY OP_CHECKSIG"},lockP2sh20:{lockingType:"p2sh20",script:n},lockP2sh32:{lockingType:"p2sh32",script:n},lockStandard:{lockingType:"standard",script:n},unlockEmptyP2sh20:{script:"<1>",unlocks:"lockEmptyP2sh20"},unlockP2pkh:{script:"<key1.schnorr_signature.corresponding_output_single_input> <key1.public_key>",unlocks:"lockP2pkh"},unlockP2sh20:{script:r,unlocks:"lockP2sh20"},unlockP2sh32:{script:r,unlocks:"lockP2sh32"},unlockStandard:{script:r,unlocks:"lockStandard"},vmbTestNullData:{lockingType:"standard",script:'OP_RETURN <"vmb_test">'}},supported:["BCH_2022_05"],version:0}),u=Or(E);return l.map(U=>{let N=`${A}: ${i} (${U.mode})`,c=u.generateScenario({debug:!0,scenarioId:g,unlockingScriptId:{P2SH20:"unlockP2sh20",P2SH32:"unlockP2sh32",nonP2SH:"unlockStandard"}[U.mode]});if(typeof c=="string")throw new Error(`Error while generating "${N}" - ${c}`);if(typeof c.scenario=="string")throw new Error(`Error while generating "${N}" - ${c.scenario}`);let B=as(c.scenario.program.transaction),S=hn(c.scenario.program.sourceOutputs),h=[Ct(ot({bin:q.hash(ee([B,S])),resultWordLength:5,sourceWordLength:8})).slice(0,a),N,r,n,$(B),$(S),U.sets];return c.scenario.program.inputIndex===0?h:[...h,c.scenario.program.inputIndex]})},yS=e=>e[1].map(A=>Bh(A,e[0])),fS=e=>e.reduce((A,a)=>{let[r,n,i,t,o,s,g,l]=a,I=[r,n,i,t,o,s,...l===void 0?[]:[l]];return g.forEach(E=>{A[E]=[...A[E]??[],I]}),A},{});export{ym as AuthenticationErrorBCH,sg as AuthenticationErrorBCH2022,On as AuthenticationErrorBCH2023,kA as AuthenticationErrorBCHCHIPs,v as AuthenticationErrorCommon,nt as Base58AddressError,le as Base58AddressFormatVersion,Gr as BaseConversionError,Fa as BaseConverterCreationError,en as Bech32DecodingError,NA as Bip39Error,Ea as BitRegroupingError,wa as BuiltInVariables,rA as CashAddressDecodingError,Pt as CashAddressEncodingError,nn as CashAddressFormatCorrectionError,rn as CashAddressFormatEncodingError,Ba as CashAddressNetworkPrefix,Ue as CashAddressType,CA as CashAddressTypeBits,qo as CashAddressVersionByte,Za as CashAddressVersionByteDecodingError,AA as CashTokenDecodingError,pt as CompactUintError,er as CompactUintPrefixedBinError,Qe as CompilerDefaults,yt as CompressionFlag,re as ConsensusBCH,Be as ConsensusBCH2023,dt as ConsensusBCHCHIPs,ae as ConsensusCommon,WA as ConsensusXEC,ha as ContextFlag,br as EntropyGenerationError,oA as HdKeyDecodingError,pA as HdKeyEncodingError,hA as HdKeyVersion,Gn as HdNodeCrackingError,uA as HdNodeDerivationError,oa as IdentifierResolutionErrorType,FA as IdentifierResolutionType,_e as LockingBytecodeType,la as LocktimeError,SA as NonFungibleTokenCapability,mm as OpcodeDescriptions,sl as OpcodeDescriptionsBCH,og as OpcodeDescriptionsBCH2022,xn as OpcodeDescriptionsBCH2023,lg as OpcodeDescriptionsBCHCHIPs,fg as OpcodeDescriptionsBTC,ns as OpcodeDescriptionsXEC,cs as Opcodes,f as OpcodesBCH,Z as OpcodesBCH2022,Q as OpcodesBCH2023,m as OpcodesBCHCHIPs,kt as OpcodesBTC,ht as OpcodesXEC,Ia as P2pkhUtilityError,da as Pbkdf2Error,In as ReadBytesError,La as ReadItemCountError,cn as ReadUint32LEError,ln as ReadUint64LEError,Ge as Secp256k1Error,Ze as SigningSerializationAlgorithmIdentifier,De as SigningSerializationFlag,pn as SigningSerializationType,ve as SigningSerializationTypeBCH,Sa as SigningSerializationTypesBCH,ia as SigningSerializationTypesBCH2023,Mc as SigningSerializationTypesCommon,nA as TransactionDecodingError,Nt as VmNumberError,Yg as WalletImportFormatError,sn as addressContentsToLockingBytecode,Fg as allErrorsAreRecoverable,w as applyError,CQ as assembleBitcoinSatoshiScript,nI as assembleBytecode,xu as assembleBytecodeBCH,oP as assembleBytecodeBTC,Ra as assertSuccess,Hf as attemptBip39MnemonicErrorCorrection,DE as attemptCashAddressFormatErrorCorrection,XA as attemptCompilerOperations,Ut as authenticationInstructionIsMalformed,tA as authenticationInstructionsAreMalformed,ds as authenticationInstructionsArePushInstructions,KE as base58AddressToLockingBytecode,Ka as base58ToBin,dA as base64ToBin,An as bech32CharacterSet,tc as bech32CharacterSetIndex,bE as bech32PaddedToBin,Ja as bigIntToBinUint256BEClamped,mo as bigIntToBinUint64LE,_I as bigIntToBinUint64LEClamped,Hh as bigIntToBinUintBE,Vr as bigIntToBinUintLE,IA as bigIntToCompactUint,W as bigIntToVmNumber,Ga as binStringToBin,Ma as binToBase58,fh as binToBase64,kE as binToBech32Padded,zr as binToBigIntUint256BE,jr as binToBigIntUint64LE,vI as binToBigIntUintBE,Qo as binToBigIntUintLE,Jr as binToBinString,qa as binToFixedLength,$ as binToHex,Rh as binToNumberInt16LE,Fh as binToNumberInt32LE,qh as binToNumberUint16LE,Ha as binToNumberUint32LE,Gh as binToNumberUintLE,td as binToUtf8,yo as binToValueSatoshis,tt as binsAreEqual,dl as bip32HmacSha512Key,Nl as bip39WordListChineseSimplified,_l as bip39WordListChineseTraditional,Dl as bip39WordListCzech,kr as bip39WordListEnglish,Yl as bip39WordListFrench,Ol as bip39WordListItalian,Fl as bip39WordListJapanese,Ml as bip39WordListKorean,ql as bip39WordListPortuguese,Jl as bip39WordListSpanish,SI as bitcoinBase58Alphabet,ul as bitcoinSatoshiOpcodes,bn as bitwiseOperation,oe as booleanToVmNumber,Ic as cashAddressChecksumToUint5Array,nc as cashAddressLengthBitsToLength,Jo as cashAddressLengthToLengthBits,Xa as cashAddressPolynomialModulo,an as cashAddressPolynomialToCashAddress,RE as cashAddressToLockingBytecode,rc as cashAddressTypeBitsToType,ac as cashAddressTypeToTypeBits,nP as cashAssemblyToBin,rp as checkLimitsCommon,ir as cloneAuthenticationInstruction,kn as cloneAuthenticationProgramCommon,np as cloneAuthenticationProgramState,ka as cloneAuthenticationProgramStateBCH,gg as cloneAuthenticationProgramStateBCHCHIPs,il as cloneAuthenticationProgramStateCommon,BA as cloneStack,rs as cloneTransactionCommon,wc as cloneTransactionInputsCommon,En as cloneTransactionOutputsCommon,qe as combineOperations,DI as compactUintPrefixToLength,Jh as compactUintToBigInt,rP as compileCashAssembly,rh as compileInputTemplate,ah as compileOutputTemplate,Xg as compileScenarioOutputTokenData,zg as compileScript,cu as compileScriptContents,ZA as compileScriptRaw,oo as compileWalletTemplateScenarioBytecode,Zg as compileWalletTemplateScenarioValueSatoshis,aP as compilerConfigurationToCompiler,Yr as compilerConfigurationToCompilerBCH,lu as compilerOperationAddressData,$A as compilerOperationAttemptBytecodeResolution,du as compilerOperationCurrentBlockHeight,hu as compilerOperationCurrentBlockTime,sI as compilerOperationDataSignatureRenamed,qu as compilerOperationHdKeyEcdsaDataSignatureBCH,Ou as compilerOperationHdKeyEcdsaSignatureBCH,wu as compilerOperationHdKeyPublicKeyCommon,Hu as compilerOperationHdKeySchnorrDataSignatureBCH,Ru as compilerOperationHdKeySchnorrSignatureBCH,ao as compilerOperationHelperAddressIndex,no as compilerOperationHelperCompileScript,uI as compilerOperationHelperComputeDataSignatureBCH,II as compilerOperationHelperComputeSignatureBCH,ro as compilerOperationHelperDeriveHdKeyPrivate,to as compilerOperationHelperDeriveHdPrivateNode,ga as compilerOperationHelperGenerateCoveredBytecode,dI as compilerOperationHelperHdKeyDataSignatureBCH,cI as compilerOperationHelperHdKeySignatureBCH,hI as compilerOperationHelperKeyDataSignatureBCH,lI as compilerOperationHelperKeySignatureBCH,io as compilerOperationHelperUnknownEntity,Mu as compilerOperationKeyEcdsaDataSignatureBCH,Fu as compilerOperationKeyEcdsaSignatureBCH,Du as compilerOperationKeyPublicKeyCommon,Gu as compilerOperationKeySchnorrDataSignatureBCH,Ku as compilerOperationKeySchnorrSignatureBCH,ce as compilerOperationRequires,oI as compilerOperationSignatureRenamed,Eu as compilerOperationSigningSerializationCorrespondingOutput,Bu as compilerOperationSigningSerializationCorrespondingOutputHash,pu as compilerOperationSigningSerializationCoveredBytecode,mu as compilerOperationSigningSerializationCoveredBytecodeLength,sA as compilerOperationSigningSerializationFullBCH,Qu as compilerOperationSigningSerializationLocktime,yu as compilerOperationSigningSerializationOutpointIndex,fu as compilerOperationSigningSerializationOutpointTransactionHash,Cu as compilerOperationSigningSerializationOutputValue,Pu as compilerOperationSigningSerializationSequenceNumber,Ju as compilerOperationSigningSerializationTokenPrefix,Su as compilerOperationSigningSerializationTransactionOutpoints,bu as compilerOperationSigningSerializationTransactionOutpointsHash,ku as compilerOperationSigningSerializationTransactionOutputs,Nu as compilerOperationSigningSerializationTransactionOutputsHash,Uu as compilerOperationSigningSerializationTransactionSequenceNumbers,_u as compilerOperationSigningSerializationTransactionSequenceNumbersHash,vu as compilerOperationSigningSerializationVersion,uu as compilerOperationWalletData,Lu as compilerOperationsBCH,Et as compilerOperationsCommon,d as conditionallyEvaluate,T as conditionallyEvaluateChipLoops,jl as containsRange,of as crackHdPrivateNodeFromHdPublicNodeAndChildPrivateNode,so as createAuthenticationProgramEvaluationCommon,Cr as createAuthenticationProgramStateBCHCHIPs,jA as createAuthenticationProgramStateCommon,Fm as createAuthenticationVirtualMachine,PI as createBaseConverter,op as createCompilationContextCommonTesting,dP as createCompiler,Or as createCompilerBCH,rI as createCompilerCommon,Tu as createCompilerGenerateBytecodeFunction,mA as createEmptyRange,Iu as createIdentifierResolver,xm as createInstructionSetBCH,fr as createInstructionSetBCH2022,Rn as createInstructionSetBCH2023,yg as createInstructionSetBCHCHIPs,ng as createInstructionSetXEC,xQ as createTestAuthenticationProgramBCH,RA as createVirtualMachine,ws as createVirtualMachineBCH,KQ as createVirtualMachineBCH2022,ll as createVirtualMachineBCH2023,Ny as createVirtualMachineBCHCHIPs,pQ as createVirtualMachineXEC,xI as dateToLocktime,$h as dateToLocktimeBin,we as decodeAuthenticationInstructions,Ko as decodeBase58Address,$r as decodeBase58AddressFormat,ja as decodeBech32,Kf as decodeBip39Mnemonic,Ll as decodeBip39MnemonicNonStandard,YA as decodeBitcoinSignature,Vo as decodeCashAddress,Lo as decodeCashAddressFormat,vE as decodeCashAddressFormatWithoutPrefix,hc as decodeCashAddressNonStandard,sc as decodeCashAddressVersionByte,bg as decodeHdKey,Bl as decodeHdKeyUnchecked,na as decodeHdPrivateKey,va as decodeHdPublicKey,ed as decodeLocktime,jf as decodePrivateKeyWif,aB as decodeTransaction,_c as decodeTransactionBCH,is as decodeTransactionCommon,AB as decodeTransactionOutputs,rB as decodeTransactionUnsafe,Dc as decodeTransactionUnsafeBCH,vc as decodeTransactionUnsafeCommon,wg as deriveBip39ChecksumBits,_g as deriveHdPath,Da as deriveHdPathRelative,fl as deriveHdPrivateNodeChild,Gf as deriveHdPrivateNodeFromBip39Mnemonic,ra as deriveHdPrivateNodeFromSeed,Cg as deriveHdPrivateNodeIdentifier,nf as deriveHdPublicKey,yl as deriveHdPublicNode,Cl as deriveHdPublicNodeChild,Pg as deriveHdPublicNodeIdentifier,Vl as deriveSeedFromBip39Mnemonic,su as describeExpectedInput,Te as disabledOperation,Vc as disassembleAuthenticationInstruction,Lc as disassembleAuthenticationInstructionMalformed,zc as disassembleAuthenticationInstructionMaybeMalformed,Cn as disassembleAuthenticationInstructionsMaybeMalformed,UB as disassembleBytecode,_B as disassembleBytecodeBCH,vB as disassembleBytecodeBTC,ps as encodeAuthenticationInstruction,rr as encodeAuthenticationInstructionMalformed,Wc as encodeAuthenticationInstructionMaybeMalformed,iA as encodeAuthenticationInstructions,DB as encodeAuthenticationInstructionsMaybeMalformed,PE as encodeBase58Address,ft as encodeBase58AddressFormat,Ct as encodeBech32,Mf as encodeBip39Mnemonic,Tg as encodeBip39MnemonicNonStandard,pa as encodeCashAddress,cc as encodeCashAddressFormat,uc as encodeCashAddressNonStandard,oc as encodeCashAddressVersionByte,Na as encodeDataPush,kg as encodeHdKeyPayloadMetadata,Ng as encodeHdKeyPayloadWithChecksum,Ug as encodeHdPrivateKey,pl as encodeHdPrivateKeyPayload,Ql as encodeHdPublicKey,ml as encodeHdPublicKeyPayload,pc as encodeLockingBytecodeP2pk,dc as encodeLockingBytecodeP2pkh,Ec as encodeLockingBytecodeP2sh20,Bc as encodeLockingBytecodeP2sh32,zf as encodePrivateKeyWif,Kc as encodeSigningSerializationBCH,fa as encodeTokenPrefix,as as encodeTransaction,gt as encodeTransactionBCH,dn as encodeTransactionCommon,mc as encodeTransactionInput,Pa as encodeTransactionInputSequenceNumbersForSigning,yc as encodeTransactionInputs,Ca as encodeTransactionOutpoints,St as encodeTransactionOutput,hn as encodeTransactionOutputs,bt as encodeTransactionOutputsForSigning,jE as excessiveSatoshis,iI as extendCompilationDataWithScenarioBytecode,eI as extendScenarioDefinition,$g as extendScenarioDefinitionData,tI as extendedScenarioDefinitionToCompilationData,Ln as extractBytecodeResolutions,xg as extractEvaluationSamples,rC as extractEvaluationSamplesRecursive,gl as extractGenesisCategories,nh as extractMissingVariables,tn as extractNonBech32Characters,Kg as extractResolvedVariableBytecodeMap,oS as extractResolvedVariables,Il as extractSourceOutputTokenData,cl as extractTransactionOutputTokenData,nC as extractUnexecutedRanges,ee as flattenBinArray,R as formatError,qf as generateBip39Mnemonic,zl as generateBip39MnemonicNonStandard,zA as generateBytecodeMap,Wg as generateDefaultScenarioDefinition,hf as generateDeterministicEntropy,AI as generateExtendedScenario,uf as generateHdPrivateNode,lf as generatePrivateKey,Hn as generateRandomBytes,Pl as generateRandomBytesUnchecked,vg as generateRandomSeed,aI as generateScenarioBCH,cA as generateSigningSerializationBCH,tr as generateSigningSerializationComponentsBCH,nS as generateTransaction,Pn as getDustThreshold,$c as getDustThresholdForLength,JI as getEmbeddedRipemd160Binary,qI as getEmbeddedSecp256k1Binary,VI as getEmbeddedSha1Binary,jI as getEmbeddedSha256Binary,ZI as getEmbeddedSha512Binary,Xc as getMinimumFee,zn as getResolutionErrors,tE as hash160,pe as hash256,Pr as hashDigestIterations,Fc as hashOutputs,xc as hashPrevouts,Rc as hashSequence,nB as hashTransaction,Bn as hashTransactionP2pOrder,Tc as hashTransactionUiOrder,Oc as hashUtxos,El as hdKeyVersionIsPrivateKey,Sg as hdKeyVersionIsPublicKey,af as hdPrivateKeyToIdentifier,kP as hdPrivateKeyToP2pkhCashAddress,ju as hdPrivateKeyToP2pkhLockingBytecode,rf as hdPublicKeyToIdentifier,NP as hdPublicKeyToP2pkhCashAddress,Wu as hdPublicKeyToP2pkhLockingBytecode,ze as hexToBin,Ro as hmacSha256,rt as hmacSha512,WP as importMetadataRegistry,eS as importWalletTemplate,Ua as incrementHashDigestIterations,Tt as incrementOperationCount,Oo as instantiateHmacFunction,Fo as instantiatePbkdf2Function,vo as instantiateRipemd160,HI as instantiateRipemd160Bytes,VA as instantiateRustWasm,wo as instantiateSecp256k1,Md as instantiateSecp256k1Bytes,ko as instantiateSecp256k1Wasm,Zr as instantiateSecp256k1WasmBytes,To as instantiateSha1,LI as instantiateSha1Bytes,Yo as instantiateSha256,zI as instantiateSha256Bytes,xo as instantiateSha512,WI as instantiateSha512Bytes,Lh as int32SignedToUnsigned,fo as int32UnsignedToSigned,wA as isArbitraryDataOutput,yh as isBase64,Wa as isBech32CharacterSet,Nh as isBinString,ms as isDustOutput,Ph as isHex,EB as isLegacySigningSerialization,wn as isMinimalDataPush,gn as isPayToPublicKey,jo as isPayToPublicKeyCompressed,$a as isPayToPublicKeyHash,zo as isPayToPublicKeyUncompressed,PA as isPayToScriptHash20,ma as isPayToScriptHash32,bA as isPushOnly,wB as isPushOnlyAccurate,Zc as isPushOperation,tl as isSimpleMultisig,Qs as isStandardMultisig,vt as isStandardOutputBytecode,Sn as isStandardOutputBytecode2023,Dg as isValidBip39EntropyLength,Jn as isValidBip39WordList,lc as isValidCashAddressPayloadLength,Al as isValidCompressedPublicKeyEncoding,lA as isValidPublicKeyEncoding,vn as isValidSignatureEncodingBCHRaw,TA as isValidSignatureEncodingBCHTransaction,Nn as isValidSignatureEncodingDER,el as isValidUncompressedPublicKeyEncoding,nr as isVmNumberError,Dt as isWitnessProgram,id as length,Wo as lockingBytecodeToAddressContents,FE as lockingBytecodeToBase58Address,Qa as lockingBytecodeToCashAddress,Xh as locktimeToDate,za as lossyNormalize,Yt as mapOverOperations,on as maskCashAddressPrefix,YI as maximumLocktimeDate,Co as maximumLocktimeTimestamp,Vn as mergeRanges,bl as minimumEventsPerEntropyBits,TI as minimumLocktimeDate,Wr as minimumLocktimeTimestamp,Pc as nftCapabilityLabelToNumber,Cc as nftCapabilityNumberToLabel,xh as numberToBinInt16LE,Oh as numberToBinInt32LE,Mh as numberToBinInt32TwosCompliment,Kh as numberToBinUint16BE,mt as numberToBinUint16LE,Th as numberToBinUint16LEClamped,vA as numberToBinUint32BE,de as numberToBinUint32LE,Yh as numberToBinUint32LEClamped,po as numberToBinUintLE,Gt as op0NotEqual,Ot as op1Add,Rt as op1Sub,Fi as op2Drop,Ki as op2Dup,Gi as op2Over,qi as op2Rot,Hi as op2Swap,Mi as op3Dup,Kt as opAbs,fi as opActiveBytecode,qt as opAdd,ni as opAnd,mg as opBegin,Qi as opBin2Num,Jt as opBoolAnd,Lt as opBoolOr,Bi as opCat,ut as opCheckDataSig,hl as opCheckDataSigChipLimits,di as opCheckDataSigVerify,gy as opCheckDataSigVerifyChipLimits,xA as opCheckLockTimeVerify,_n as opCheckMultiSig,Yn as opCheckMultiSigBCH2023,Mn as opCheckMultiSigChipLimits,Ss as opCheckMultiSigVerify,Ns as opCheckMultiSigVerifyBCH2023,cg as opCheckMultiSigVerifyChipLimits,OA as opCheckSequenceVerify,Un as opCheckSig,Tn as opCheckSigBCH2023,Kn as opCheckSigChipLimits,Ps as opCheckSigVerify,ks as opCheckSigVerifyBCH2023,Ig as opCheckSigVerifyChipLimits,hi as opCodeSeparator,Li as opDepth,ii as opDiv,Vi as opDrop,zi as opDup,lr as opElse,pg as opElseChipLoops,cr as opEndIf,Bg as opEndIfChipLoops,lt as opEqual,ri as opEqualVerify,Ri as opFromAltStack,Zt as opGreaterThan,Xt as opGreaterThanOrEqual,li as opHash160,oy as opHash160ChipLimits,ui as opHash256,sy as opHash256ChipLimits,gr as opIf,dg as opIfChipLoops,Ji as opIfDup,Di as opInputBytecode,yi as opInputIndex,wi as opInputSequenceNumber,jt as opLessThan,Wt as opLessThanOrEqual,ei as opMax,$t as opMin,ai as opMod,ti as opMul,Ft as opNegate,ji as opNip,Ie as opNop,ue as opNopDisallowed,Mt as opNot,Ir as opNotIf,Eg as opNotIfChipLoops,mi as opNum2Bin,ct as opNumEqual,Vt as opNumEqualVerify,zt as opNumNotEqual,oi as opOr,vi as opOutpointIndex,_i as opOutpointTxHash,xi as opOutputBytecode,yr as opOutputTokenAmount,mr as opOutputTokenCategory,Qr as opOutputTokenCommitment,Yi as opOutputValue,Wi as opOver,Zi as opPick,xt as opReturn,Ei as opReverseBytes,gi as opRipemd160,ay as opRipemd160ChipLimits,Xi as opRoll,$i as opRot,Ii as opSha1,ry as opSha1ChipLimits,ci as opSha256,ny as opSha256ChipLimits,ta as opSize,pi as opSplit,Ht as opSub,ea as opSwap,Oi as opToAltStack,Aa as opTuck,Pi as opTxInputCount,bi as opTxLocktime,Si as opTxOutputCount,Ci as opTxVersion,Qg as opUntil,Ui as opUtxoBytecode,pr as opUtxoTokenAmount,Er as opUtxoTokenCategory,Br as opUtxoTokenCommitment,Ni as opUtxoValue,me as opVerify,Ai as opWithin,si as opXor,Es as opcodeToPushLength,Dn as padMinimallyEncodedVmNumber,Lg as parseScript,gE as pbkdf2HmacSha256,Xr as pbkdf2HmacSha512,SP as privateKeyToP2pkhCashAddress,Vu as privateKeyToP2pkhLockingBytecode,bP as publicKeyToP2pkhCashAddress,zu as publicKeyToP2pkhLockingBytecode,hs as pushNumberOpcodeToNumber,z as pushNumberOperation,hr as pushOperation,hg as pushOperationChipLoops,_a as pushToControlStackChipLoops,M as pushToStack,EA as pushToStackChecked,ba as pushToStackVmNumber,Le as pushToStackVmNumberChecked,Ds as pushTokenAmount,vs as pushTokenCommitment,_s as pushTokenExtendedCategory,qr as range,Hc as readAuthenticationInstruction,Zo as readBytes,wI as readCompactUint,it as readCompactUintMinimal,ya as readCompactUintPrefixedBin,Va as readItemCount,qc as readLittleEndianNumber,bc as readLockingBytecodeWithPrefix,at as readMultiple,Xo as readRemainingBytes,$o as readTokenAmount,Sc as readTokenPrefix,tB as readTransaction,ts as readTransactionCommon,Qc as readTransactionInput,es as readTransactionInputs,iB as readTransactionNonTokenAware,kc as readTransactionOutput,Nc as readTransactionOutputNonTokenAware,As as readTransactionOutputs,Uc as readTransactionOutputsNonTokenAware,st as readUint32LE,un as readUint64LE,wr as reduceScript,ot as regroupBits,Ye as reservedOperation,Ao as resolveScriptIdentifier,eo as resolveScriptSegment,ou as resolveVariableIdentifier,Ee as ripemd160,Po as ripemd160Base64Bytes,sS as safelyExtendCompilationData,Ae as secp256k1,KI as segment,fA as sha1,No as sha1Base64Bytes,q as sha256,Uo as sha256Base64Bytes,je as sha512,_o as sha512Base64Bytes,Sl as shannonEntropyPerEvent,Lr as sortObjectKeys,ca as splitEvery,We as stackItemIsTruthy,Bo as stringify,sC as stringifyDebugTraceSummary,KA as stringifyErrors,vh as stringifyTestVector,oC as summarizeDebugTrace,Rg as summarizeStack,hh as supportedTestSetOverridesBCH,Sh as swapEndianness,xe as undefinedOperation,ug as undefinedOperationChipLoops,Mr as unknownValue,or as useFourStackItems,bs as useLocktime,te as useOneStackItem,X as useOneVmNumber,ys as useSixStackItems,It as useThreeStackItems,sr as useThreeVmNumbers,ur as useTransactionInput,Ti as useTransactionOutput,ki as useTransactionUtxo,be as useTwoStackItems,ge as useTwoVmNumbers,DA as utf8ToBin,gu as validateCompilationData,aa as validateSecp256k1PrivateKey,Qt as valueSatoshisToBin,nu as verifyCashAssemblyEvaluationState,Us as verifyTransactionTokens,_t as vmNumberToBigInt,QS as vmbTestDefinitionDefaultBehaviorBCH,Bh as vmbTestDefinitionToVmbTests,yS as vmbTestGroupToVmbTests,fS as vmbTestPartitionMasterTestList,Io as walletTemplateP2pkh,go as walletTemplateP2pkhNonHd,Ta as walletTemplateToCompilerBCH,xr as walletTemplateToCompilerConfiguration};
//# sourceMappingURL=libauth.mjs.map